/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 257);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(267);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var _module=__webpack_require__(264);var _module2=_interopRequireDefault(_module);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}module.exports=_module2.default;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.mapPropsToStyleNames=exports.SwipeRow=exports.Root=exports.Segment=exports.DefaultTabBar=exports.TabContainer=exports.TabHeading=exports.ActionSheet=exports.ScrollableTab=exports.Toast=exports.View=exports.TabContent=exports.Text=exports.Grid=exports.Row=exports.Col=exports.Textarea=exports.Label=exports.Subtitle=exports.Item=exports.DeckSwiper=exports.Separator=exports.ListItem=exports.List=exports.Picker=exports.FooterTab=exports.Tabs=exports.Tab=exports.Footer=exports.Content=exports.Container=exports.Switch=exports.Spinner=exports.H3=exports.H2=exports.H1=exports.CardItem=exports.Card=exports.Thumbnail=exports.Radio=exports.CheckBox=exports.Badge=exports.Body=exports.Right=exports.Left=exports.Fab=exports.Title=exports.Input=exports.InputGroup=exports.Form=exports.Header=exports.Icon=exports.IconNB=exports.Button=exports.Drawer=exports.connectStyle=exports.StyleProvider=exports.variables=exports.getTheme=undefined;var _nativeBaseShoutemTheme=__webpack_require__(5);
var _lodash=__webpack_require__(12);
var _reactNativeEasyGrid=__webpack_require__(44);

var _init=__webpack_require__(408);var _init2=_interopRequireDefault(_init);
var _components=__webpack_require__(182);var _components2=_interopRequireDefault(_components);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);
var _Drawer=__webpack_require__(457);var _Drawer2=_interopRequireDefault(_Drawer);
var _SwipeRow=__webpack_require__(185);
var _Text=__webpack_require__(29);
var _View=__webpack_require__(107);
var _Button=__webpack_require__(58);
var _TabHeading=__webpack_require__(462);
var _TabContainer=__webpack_require__(463);
var _IconNB=__webpack_require__(74);
var _Icon=__webpack_require__(81);
var _Header=__webpack_require__(212);
var _InputGroup=__webpack_require__(587);
var _Input=__webpack_require__(213);
var _Title=__webpack_require__(214);
var _Fab=__webpack_require__(589);
var _Left=__webpack_require__(70);
var _Right=__webpack_require__(71);
var _Body=__webpack_require__(72);
var _Badge=__webpack_require__(590);
var _Checkbox=__webpack_require__(591);
var _Radio=__webpack_require__(215);
var _Thumbnail=__webpack_require__(592);
var _Card=__webpack_require__(593);
var _CardItem=__webpack_require__(594);
var _H=__webpack_require__(595);
var _H2=__webpack_require__(596);
var _H3=__webpack_require__(597);
var _Spinner=__webpack_require__(598);
var _Switch=__webpack_require__(599);
var _Container=__webpack_require__(216);
var _Root=__webpack_require__(601);
var _Content=__webpack_require__(217);
var _Footer=__webpack_require__(607);
var _FooterTab=__webpack_require__(608);
var _Form=__webpack_require__(609);
var _ToastContainer=__webpack_require__(125);
var _Actionsheet=__webpack_require__(126);
var _Picker=__webpack_require__(610);
var _List=__webpack_require__(127);
var _ListItem=__webpack_require__(73);
var _Separator=__webpack_require__(611);
var _DeckSwiper=__webpack_require__(612);
var _Item=__webpack_require__(613);
var _Segment=__webpack_require__(614);
var _Label=__webpack_require__(219);
var _Textarea=__webpack_require__(615);
var _Tab=__webpack_require__(616);
var _Tabs=__webpack_require__(617);var _Tabs2=_interopRequireDefault(_Tabs);
var _DefaultTabBar=__webpack_require__(220);
var _ScrollableTabBar=__webpack_require__(222);
var _Subtitle=__webpack_require__(620);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

(0,_init2.default)();exports.


getTheme=_components2.default;exports.
variables=_platform2.default;exports.
StyleProvider=_nativeBaseShoutemTheme.StyleProvider;exports.
connectStyle=_nativeBaseShoutemTheme.connectStyle;exports.
Drawer=_Drawer2.default;exports.
Button=_Button.Button;exports.
IconNB=_IconNB.IconNB;exports.
Icon=_Icon.Icon;exports.
Header=_Header.Header;exports.
Form=_Form.Form;exports.
InputGroup=_InputGroup.InputGroup;exports.
Input=_Input.Input;exports.
Title=_Title.Title;exports.
Fab=_Fab.Fab;exports.
Left=_Left.Left;exports.
Right=_Right.Right;exports.
Body=_Body.Body;exports.
Badge=_Badge.Badge;exports.
CheckBox=_Checkbox.CheckBox;exports.
Radio=_Radio.Radio;exports.
Thumbnail=_Thumbnail.Thumbnail;exports.
Card=_Card.Card;exports.
CardItem=_CardItem.CardItem;exports.
H1=_H.H1;exports.
H2=_H2.H2;exports.
H3=_H3.H3;exports.
Spinner=_Spinner.Spinner;exports.
Switch=_Switch.Switch;exports.
Container=_Container.Container;exports.
Content=_Content.Content;exports.
Footer=_Footer.Footer;exports.
Tab=_Tab.Tab;exports.
Tabs=_Tabs2.default;exports.
FooterTab=_FooterTab.FooterTab;exports.
Picker=_Picker.PickerNB;exports.
List=_List.List;exports.
ListItem=_ListItem.ListItem;exports.
Separator=_Separator.Separator;exports.
DeckSwiper=_DeckSwiper.DeckSwiper;exports.
Item=_Item.Item;exports.
Subtitle=_Subtitle.Subtitle;exports.
Label=_Label.Label;exports.
Textarea=_Textarea.Textarea;exports.
Col=_reactNativeEasyGrid.Col;exports.
Row=_reactNativeEasyGrid.Row;exports.
Grid=_reactNativeEasyGrid.Grid;exports.
Text=_Text.Text;exports.
TabContent=_Content.Content;exports.
View=_View.ViewNB;exports.
Toast=_ToastContainer.ToastContainer;exports.
ScrollableTab=_ScrollableTabBar.ScrollableTab;exports.
ActionSheet=_Actionsheet.ActionSheetContainer;exports.
TabHeading=_TabHeading.TabHeading;exports.
TabContainer=_TabContainer.TabContainer;exports.
DefaultTabBar=_DefaultTabBar.DefaultTabBar;exports.
Segment=_Segment.Segment;exports.
Root=_Root.Root;exports.
SwipeRow=_SwipeRow.SwipeRow;


var mapPropsToStyleNames=function mapPropsToStyleNames(styleNames,props){return(0,_lodash.keys)(props);};exports.

mapPropsToStyleNames=mapPropsToStyleNames;
//# sourceMappingURL=index.js.map

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(336)();
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _color=__webpack_require__(410);var _color2=_interopRequireDefault(_color);

var _reactNative=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var deviceHeight=_reactNative.Dimensions.get("window").height;
var deviceWidth=_reactNative.Dimensions.get("window").width;
var platform=_reactNative.Platform.OS;
var platformStyle=undefined;
var isIphoneX=platform==="ios"&&deviceHeight===812&&deviceWidth===375;exports.default=

{
platformStyle:platformStyle,
platform:platform,

androidRipple:true,
androidRippleColor:"rgba(256, 256, 256, 0.3)",
androidRippleColorDark:"rgba(0, 0, 0, 0.15)",


badgeBg:"#ED1727",
badgeColor:"#fff",

badgePadding:platform==="ios"?3:0,


btnFontFamily:platform==="ios"?"System":"Roboto_medium",
btnDisabledBg:"#b5b5b5",
btnDisabledClr:"#f1f1f1",


CheckboxRadius:platform==="ios"?13:0,
CheckboxBorderWidth:platform==="ios"?1:2,
CheckboxPaddingLeft:platform==="ios"?4:2,
CheckboxPaddingBottom:platform==="ios"?0:5,
CheckboxIconSize:platform==="ios"?21:14,
CheckboxIconMarginTop:platform==="ios"?undefined:1,
CheckboxFontSize:platform==="ios"?23/0.9:18,
DefaultFontSize:17,
checkboxBgColor:"#039BE5",
checkboxSize:20,
checkboxTickColor:"#fff",


segmentBackgroundColor:platform==="ios"?"#F8F8F8":"#3F51B5",
segmentActiveBackgroundColor:platform==="ios"?"#007aff":"#fff",
segmentTextColor:platform==="ios"?"#007aff":"#fff",
segmentActiveTextColor:platform==="ios"?"#fff":"#3F51B5",
segmentBorderColor:platform==="ios"?"#007aff":"#fff",
segmentBorderColorMain:platform==="ios"?"#a7a6ab":"#3F51B5",


get defaultTextColor(){
return this.textColor;
},

get btnPrimaryBg(){
return this.brandPrimary;
},
get btnPrimaryColor(){
return this.inverseTextColor;
},
get btnInfoBg(){
return this.brandInfo;
},
get btnInfoColor(){
return this.inverseTextColor;
},
get btnSuccessBg(){
return this.brandSuccess;
},
get btnSuccessColor(){
return this.inverseTextColor;
},
get btnDangerBg(){
return this.brandDanger;
},
get btnDangerColor(){
return this.inverseTextColor;
},
get btnWarningBg(){
return this.brandWarning;
},
get btnWarningColor(){
return this.inverseTextColor;
},
get btnTextSize(){
return platform==="ios"?this.fontSizeBase*1.1:this.fontSizeBase-1;
},
get btnTextSizeLarge(){
return this.fontSizeBase*1.5;
},
get btnTextSizeSmall(){
return this.fontSizeBase*0.8;
},
get borderRadiusLarge(){
return this.fontSizeBase*3.8;
},

buttonPadding:6,

get iconSizeLarge(){
return this.iconFontSize*1.5;
},
get iconSizeSmall(){
return this.iconFontSize*0.6;
},


cardDefaultBg:"#fff",


brandPrimary:platform==="ios"?"#007aff":"#3F51B5",
brandInfo:"#62B1F6",
brandSuccess:"#5cb85c",
brandDanger:"#d9534f",
brandWarning:"#f0ad4e",
brandSidebar:"#252932",
brandDark:"#000",
brandLight:"#f4f4f4",


fontFamily:platform==="ios"?"System":"Roboto",
fontSizeBase:15,

get fontSizeH1(){
return this.fontSizeBase*1.8;
},
get fontSizeH2(){
return this.fontSizeBase*1.6;
},
get fontSizeH3(){
return this.fontSizeBase*1.4;
},


footerHeight:isIphoneX?89:55,
footerDefaultBg:platform==="ios"?"#F8F8F8":"#4179F7",
footerPaddingBottom:isIphoneX?34:0,


tabBarTextColor:platform==="ios"?"#6b6b6b":"#b3c7f9",
tabBarTextSize:platform==="ios"?14:11,
activeTab:platform==="ios"?"#007aff":"#fff",
sTabBarActiveTextColor:"#007aff",
tabBarActiveTextColor:platform==="ios"?"#007aff":"#fff",
tabActiveBgColor:platform==="ios"?"#cde1f9":"#3F51B5",


tabDefaultBg:platform==="ios"?"#F8F8F8":"#3F51B5",
topTabBarTextColor:platform==="ios"?"#6b6b6b":"#b3c7f9",
topTabBarActiveTextColor:platform==="ios"?"#007aff":"#fff",
topTabActiveBgColor:platform==="ios"?"#cde1f9":undefined,
topTabBarBorderColor:platform==="ios"?"#a7a6ab":"#fff",
topTabBarActiveBorderColor:platform==="ios"?"#007aff":"#fff",


toolbarBtnColor:platform==="ios"?"#007aff":"#fff",
toolbarDefaultBg:platform==="ios"?"#F8F8F8":"#3F51B5",
toolbarHeight:platform==="ios"?isIphoneX?88:64:56,
toolbarIconSize:platform==="ios"?20:22,
toolbarSearchIconSize:platform==="ios"?20:23,
toolbarInputColor:platform==="ios"?"#CECDD2":"#fff",
searchBarHeight:platform==="ios"?30:40,
toolbarInverseBg:"#222",
toolbarTextColor:platform==="ios"?"#000":"#fff",
toolbarDefaultBorder:platform==="ios"?"#a7a6ab":"#3F51B5",
iosStatusbar:platform==="ios"?"dark-content":"light-content",
get statusBarColor(){
return(0,_color2.default)(this.toolbarDefaultBg).
darken(0.2).
hex();
},


iconFamily:"Ionicons",
iconFontSize:platform==="ios"?30:28,
iconMargin:7,
iconHeaderSize:platform==="ios"?33:24,


inputFontSize:17,
inputBorderColor:"#D9D5DC",
inputSuccessBorderColor:"#2b8339",
inputErrorBorderColor:"#ed2f2f",

get inputColor(){
return this.textColor;
},
get inputColorPlaceholder(){
return"#575757";
},

inputGroupMarginBottom:10,
inputHeightBase:50,
inputPaddingLeft:5,

get inputPaddingLeftIcon(){
return this.inputPaddingLeft*8;
},


btnLineHeight:19,
lineHeightH1:32,
lineHeightH2:27,
lineHeightH3:22,
iconLineHeight:platform==="ios"?37:30,
lineHeight:platform==="ios"?20:24,


listBg:"#fff",
listBorderColor:"#c9c9c9",
listDividerBg:"#f4f4f4",
listItemHeight:45,
listBtnUnderlayColor:"#DDD",


cardBorderColor:"#ccc",


listItemPadding:platform==="ios"?10:12,

listNoteColor:"#808080",
listNoteSize:13,


defaultProgressColor:"#E4202D",
inverseProgressColor:"#1A191B",


radioBtnSize:platform==="ios"?25:23,
radioSelectedColorAndroid:"#3F51B5",


radioBtnLineHeight:platform==="ios"?29:24,

radioColor:"#7e7e7e",

get radioSelectedColor(){
return(0,_color2.default)(this.radioColor).
darken(0.2).
hex();
},


defaultSpinnerColor:"#45D56E",
inverseSpinnerColor:"#1A191B",


tabBgColor:"#F8F8F8",
tabFontSize:15,
tabTextColor:"#222222",


textColor:"#000",
inverseTextColor:"#fff",
noteFontSize:14,


titleFontfamily:platform==="ios"?"System":"Roboto_medium",
titleFontSize:platform==="ios"?17:19,
subTitleFontSize:platform==="ios"?12:14,
subtitleColor:platform==="ios"?"#8e8e93":"#FFF",


titleFontColor:platform==="ios"?"#000":"#FFF",


borderRadiusBase:platform==="ios"?5:2,
borderWidth:1/_reactNative.PixelRatio.getPixelSizeForLayoutSize(1),
contentPadding:10,

get darkenHeader(){
return(0,_color2.default)(this.tabBgColor).
darken(0.03).
hex();
},

dropdownBg:"#000",
dropdownLinkColor:"#414142",
inputLineHeight:24,
jumbotronBg:"#C9C9CE",
jumbotronPadding:30,
deviceWidth:deviceWidth,
deviceHeight:deviceHeight,
isIphoneX:isIphoneX,


inputGroupRoundedBorderRadius:30};
//# sourceMappingURL=platform.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.createSharedStyle=exports.createVariations=exports.ThemeShape=exports.Theme=exports.StyleProvider=exports.INCLUDE=exports.connectStyle=undefined;var _connectStyle=__webpack_require__(398);var _connectStyle2=_interopRequireDefault(_connectStyle);var _resolveIncludes=__webpack_require__(178);var _StyleProvider=__webpack_require__(405);var _StyleProvider2=_interopRequireDefault(_StyleProvider);var _Theme=__webpack_require__(105);var _Theme2=_interopRequireDefault(_Theme);var _addons=__webpack_require__(406);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.connectStyle=_connectStyle2.default;exports.INCLUDE=_resolveIncludes.INCLUDE;exports.StyleProvider=_StyleProvider2.default;exports.Theme=_Theme2.default;exports.ThemeShape=_Theme.ThemeShape;exports.createVariations=_addons.createVariations;exports.createSharedStyle=_addons.createSharedStyle;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _lodash=__webpack_require__(12);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var mapPropsToStyleNames=function mapPropsToStyleNames(styleNames,props){
var keys=_lodash2.default.keys(props);
var values=_lodash2.default.values(props);

_lodash2.default.forEach(keys,function(key,index){
if(values[index]){
styleNames.push(key);
}
});

return styleNames;
};exports.default=

mapPropsToStyleNames;
//# sourceMappingURL=mapPropsToStyleNames.js.map

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.ViewPropTypes=undefined;var _viewPropTypes=__webpack_require__(461);var _viewPropTypes2=_interopRequireDefault(_viewPropTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.

ViewPropTypes=_viewPropTypes2.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _flattenStyle=__webpack_require__(147);var _flattenStyle2=_interopRequireDefault(_flattenStyle);var _modality=__webpack_require__(279);var _modality2=_interopRequireDefault(_modality);var _registry=__webpack_require__(89);var _registry2=_interopRequireDefault(_registry);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}(0,_modality2.default)();if(false){var _require=require('fbjs/lib/ExecutionEnvironment'),canUseDOM=_require.canUseDOM;if(canUseDOM&&window.__REACT_DEVTOOLS_GLOBAL_HOOK__){window.__REACT_DEVTOOLS_GLOBAL_HOOK__.resolveRNStyle=_flattenStyle2.default;}}var absoluteFillObject={position:'absolute',left:0,right:0,top:0,bottom:0};var absoluteFill=_registry2.default.register(absoluteFillObject);var StyleSheet={absoluteFill:absoluteFill,absoluteFillObject:absoluteFillObject,create:function create(styles){var result={};Object.keys(styles).forEach(function(key){if(false){var StyleSheetValidation=require('./StyleSheetValidation').default;StyleSheetValidation.validateStyle(key,styles);}result[key]=_registry2.default.register(styles[key]);});return result;},flatten:_flattenStyle2.default,getStyleSheets:function getStyleSheets(){return _registry2.default.getStyleSheets();},hairlineWidth:1};exports.default=StyleSheet;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _applyLayout=__webpack_require__(93);var _applyLayout2=_interopRequireDefault(_applyLayout);var _applyNativeMethods=__webpack_require__(18);var _applyNativeMethods2=_interopRequireDefault(_applyNativeMethods);var _propTypes=__webpack_require__(3);var _createElement=__webpack_require__(41);var _createElement2=_interopRequireDefault(_createElement);var _invariant=__webpack_require__(8);var _invariant2=_interopRequireDefault(_invariant);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _ViewPropTypes=__webpack_require__(15);var _ViewPropTypes2=_interopRequireDefault(_ViewPropTypes);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var calculateHitSlopStyle=function calculateHitSlopStyle(hitSlop){var hitStyle={};for(var prop in hitSlop){if(hitSlop.hasOwnProperty(prop)){var value=hitSlop[prop];hitStyle[prop]=value>0?-1*value:0;}}return hitStyle;};var View=function(_Component){_inherits(View,_Component);function View(){_classCallCheck(this,View);return _possibleConstructorReturn(this,(View.__proto__||Object.getPrototypeOf(View)).apply(this,arguments));}_createClass(View,[{key:'render',value:function render(){var _props=this.props,hitSlop=_props.hitSlop,style=_props.style,collapsable=_props.collapsable,onAccessibilityTap=_props.onAccessibilityTap,onLayout=_props.onLayout,onMagicTap=_props.onMagicTap,removeClippedSubviews=_props.removeClippedSubviews,otherProps=_objectWithoutProperties(_props,['hitSlop','style','collapsable','onAccessibilityTap','onLayout','onMagicTap','removeClippedSubviews']);if(false){_react2.default.Children.toArray(this.props.children).forEach(function(item){(0,_invariant2.default)(typeof item!=='string','Unexpected text node: '+item+'. A text node cannot be a child of a <View>.');});}var isInAParentText=this.context.isInAParentText;otherProps.style=[styles.initial,isInAParentText&&styles.inline,style];if(hitSlop){var hitSlopStyle=calculateHitSlopStyle(hitSlop);var hitSlopChild=(0,_createElement2.default)('span',{style:[styles.hitSlop,hitSlopStyle]});otherProps.children=_react2.default.Children.toArray(otherProps.children);otherProps.children.unshift(hitSlopChild);}return(0,_createElement2.default)('div',otherProps);}}]);return View;}(_react.Component);View.displayName='View';View.contextTypes={isInAParentText:_propTypes.bool};View.propTypes= false?_ViewPropTypes2.default:{};var styles=_StyleSheet2.default.create({initial:{alignItems:'stretch',borderWidth:0,borderStyle:'solid',boxSizing:'border-box',display:'flex',flexDirection:'column',margin:0,padding:0,position:'relative',zIndex:0,minHeight:0,minWidth:0},inline:{display:'inline-flex'},hitSlop:_extends({},_StyleSheet2.default.absoluteFillObject,{zIndex:-1})});exports.default=(0,_applyLayout2.default)((0,_applyNativeMethods2.default)(View));

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * lodash 4.11.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash -d -o ./foo/lodash.js`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.11.2';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
      BIND_KEY_FLAG = 2,
      CURRY_BOUND_FLAG = 4,
      CURRY_FLAG = 8,
      CURRY_RIGHT_FLAG = 16,
      PARTIAL_FLAG = 32,
      PARTIAL_RIGHT_FLAG = 64,
      ARY_FLAG = 128,
      REARG_FLAG = 256,
      FLIP_FLAG = 512;

  /** Used to compose bitmasks for comparison styles. */
  var UNORDERED_COMPARE_FLAG = 1,
      PARTIAL_COMPARE_FLAG = 2;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 150,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
      reUnescapedHtml = /[&<>"'`]/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match non-compound words composed of alphanumeric characters. */
  var reBasicWord = /[a-zA-Z0-9]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0x/i;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
      rsComboSymbolsRange = '\\u20d0-\\u20f0',
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
      rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reComplexWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
    rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
    rsUpper + '+' + rsOptUpperContr,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasComplexWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'Reflect', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError',
    'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#96;': '`'
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `exports`. */
  var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
    ? exports
    : undefined;

  /** Detect free variable `module`. */
  var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
    ? module
    : undefined;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = (freeModule && freeModule.exports === freeExports)
    ? freeExports
    : undefined;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);

  /** Detect free variable `self`. */
  var freeSelf = checkGlobal(objectTypes[typeof self] && self);

  /** Detect free variable `window`. */
  var freeWindow = checkGlobal(objectTypes[typeof window] && window);

  /** Detect `this` as the global object. */
  var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal ||
    ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
      freeSelf || thisGlobal || Function('return this')();

  /*--------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    // Don't return `Map#set` because it doesn't return the map instance in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    var length = args.length;
    switch (length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * Creates a new array concatenating `array` with `other`.
   *
   * @private
   * @param {Array} array The first array to concatenate.
   * @param {Array} other The second array to concatenate.
   * @returns {Array} Returns the new concatenated array.
   */
  function arrayConcat(array, other) {
    var index = -1,
        length = array.length,
        othIndex = -1,
        othLength = other.length,
        result = Array(length + othLength);

    while (++index < length) {
      result[index] = array[index];
    }
    while (++othIndex < othLength) {
      result[index++] = other[othIndex];
    }
    return result;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    return !!array.length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * The base implementation of methods like `_.find` and `_.findKey`, without
   * support for iteratee shorthands, which iterates over `collection` using
   * `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @param {boolean} [retKey] Specify returning the key of the found element
   *  instead of the element itself.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFind(collection, predicate, eachFunc, retKey) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = retKey ? key : value;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array ? array.length : 0;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the new array of key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing wrapper metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Checks if `value` is a global object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {null|Object} Returns `value` if it's a global object, else `null`.
   */
  function checkGlobal(value) {
    return (value && value.Object === Object) ? value : null;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        result++;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is a host object in IE < 9.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
   */
  function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') {
      try {
        result = !!(value + '');
      } catch (e) {}
    }
    return result;
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to an array.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the converted array.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the converted array.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    if (!(string && reHasComplexSymbol.test(string))) {
      return string.length;
    }
    var result = reComplexSymbol.lastIndex = 0;
    while (reComplexSymbol.test(string)) {
      result++;
    }
    return result;
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return string.match(reComplexSymbol);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Use `context` to mock `Date#getTime` use in `_.now`.
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    context = context ? _.defaults({}, context, _.pick(root, contextProps)) : root;

    /** Built-in constructor references. */
    var Date = context.Date,
        Error = context.Error,
        Math = context.Math,
        RegExp = context.RegExp,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = context.Array.prototype,
        objectProto = context.Object.prototype,
        stringProto = context.String.prototype;

    /** Used to resolve the decompiled source of functions. */
    var funcToString = context.Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objectToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Reflect = context.Reflect,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        clearTimeout = context.clearTimeout,
        enumerate = Reflect ? Reflect.enumerate : undefined,
        getOwnPropertySymbols = Object.getOwnPropertySymbols,
        iteratorSymbol = typeof (iteratorSymbol = Symbol && Symbol.iterator) == 'symbol' ? iteratorSymbol : undefined,
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        setTimeout = context.setTimeout,
        splice = arrayProto.splice;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetPrototype = Object.getPrototypeOf,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = Object.keys,
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReplace = stringProto.replace,
        nativeReverse = arrayProto.reverse,
        nativeSplit = stringProto.split;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
    var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array of at least `200` elements
     * and any iteratees accept only one argument. The heuristic for whether a
     * section qualifies for shortcut fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `deburr`, `divide`, `each`,
     * `eachRight`, `endsWith`, `eq`, `escape`, `escapeRegExp`, `every`, `find`,
     * `findIndex`, `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `first`,
     * `floor`, `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`,
     * `forOwnRight`, `get`, `gt`, `gte`, `has`, `hasIn`, `head`, `identity`,
     * `includes`, `indexOf`, `inRange`, `invoke`, `isArguments`, `isArray`,
     * `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`, `isBoolean`, `isBuffer`,
     * `isDate`, `isElement`, `isEmpty`, `isEqual`, `isEqualWith`, `isError`,
     * `isFinite`, `isFunction`, `isInteger`, `isLength`, `isMap`, `isMatch`,
     * `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`, `isNumber`,
     * `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`, `isSafeInteger`,
     * `isSet`, `isString`, `isUndefined`, `isTypedArray`, `isWeakMap`, `isWeakSet`,
     * `join`, `kebabCase`, `last`, `lastIndexOf`, `lowerCase`, `lowerFirst`,
     * `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`, `min`, `minBy`, `multiply`,
     * `noConflict`, `noop`, `now`, `nth`, `pad`, `padEnd`, `padStart`, `parseInt`,
     * `pop`, `random`, `reduce`, `reduceRight`, `repeat`, `result`, `round`,
     * `runInContext`, `sample`, `shift`, `size`, `snakeCase`, `some`, `sortedIndex`,
     * `sortedIndexBy`, `sortedLastIndex`, `sortedLastIndexBy`, `startCase`,
     * `startsWith`, `subtract`, `sum`, `sumBy`, `template`, `times`, `toInteger`,
     * `toJSON`, `toLength`, `toLower`, `toNumber`, `toSafeInteger`, `toString`,
     * `toUpper`, `trim`, `trimEnd`, `trimStart`, `truncate`, `unescape`,
     * `uniqueId`, `upperCase`, `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE ||
          (arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @returns {Object} Returns the new hash object.
     */
    function Hash() {}

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(hash, key) {
      return hashHas(hash, key) && delete hash[key];
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @param {Object} hash The hash to query.
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(hash, key) {
      if (nativeCreate) {
        var result = hash[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(hash, key) ? hash[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @param {Object} hash The hash to query.
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(hash, key) {
      return nativeCreate ? hash[key] !== undefined : hasOwnProperty.call(hash, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     */
    function hashSet(hash, key, value) {
      hash[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
    }

    // Avoid inheriting from `Object.prototype` when possible.
    Hash.prototype = nativeCreate ? nativeCreate(null) : objectProto;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function MapCache(values) {
      var index = -1,
          length = values ? values.length : 0;

      this.clear();
      while (++index < length) {
        var entry = values[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapClear() {
      this.__data__ = {
        'hash': new Hash,
        'map': Map ? new Map : [],
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapDelete(key) {
      var data = this.__data__;
      if (isKeyable(key)) {
        return hashDelete(typeof key == 'string' ? data.string : data.hash, key);
      }
      return Map ? data.map['delete'](key) : assocDelete(data.map, key);
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapGet(key) {
      var data = this.__data__;
      if (isKeyable(key)) {
        return hashGet(typeof key == 'string' ? data.string : data.hash, key);
      }
      return Map ? data.map.get(key) : assocGet(data.map, key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      var data = this.__data__;
      if (isKeyable(key)) {
        return hashHas(typeof key == 'string' ? data.string : data.hash, key);
      }
      return Map ? data.map.has(key) : assocHas(data.map, key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapSet(key, value) {
      var data = this.__data__;
      if (isKeyable(key)) {
        hashSet(typeof key == 'string' ? data.string : data.hash, key, value);
      } else if (Map) {
        data.map.set(key, value);
      } else {
        assocSet(data.map, key, value);
      }
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapClear;
    MapCache.prototype['delete'] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates a set cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values ? values.length : 0;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.push(values[index]);
      }
    }

    /**
     * Checks if `value` is in `cache`.
     *
     * @private
     * @param {Object} cache The set cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function cacheHas(cache, value) {
      var map = cache.__data__;
      if (isKeyable(value)) {
        var data = map.__data__,
            hash = typeof value == 'string' ? data.string : data.hash;

        return hash[value] === HASH_UNDEFINED;
      }
      return map.has(value);
    }

    /**
     * Adds `value` to the set cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var map = this.__data__;
      if (isKeyable(value)) {
        var data = map.__data__,
            hash = typeof value == 'string' ? data.string : data.hash;

        hash[value] = HASH_UNDEFINED;
      }
      else {
        map.set(value, HASH_UNDEFINED);
      }
    }

    // Add methods to `SetCache`.
    SetCache.prototype.push = cachePush;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function Stack(values) {
      var index = -1,
          length = values ? values.length : 0;

      this.clear();
      while (++index < length) {
        var entry = values[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = { 'array': [], 'map': null };
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          array = data.array;

      return array ? assocDelete(array, key) : data.map['delete'](key);
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      var data = this.__data__,
          array = data.array;

      return array ? assocGet(array, key) : data.map.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      var data = this.__data__,
          array = data.array;

      return array ? assocHas(array, key) : data.map.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__,
          array = data.array;

      if (array) {
        if (array.length < (LARGE_ARRAY_SIZE - 1)) {
          assocSet(array, key, value);
        } else {
          data.array = null;
          data.map = new MapCache(array);
        }
      }
      var map = data.map;
      if (map) {
        map.set(key, value);
      }
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Removes `key` and its value from the associative array.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function assocDelete(array, key) {
      var index = assocIndexOf(array, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = array.length - 1;
      if (index == lastIndex) {
        array.pop();
      } else {
        splice.call(array, index, 1);
      }
      return true;
    }

    /**
     * Gets the associative array value for `key`.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function assocGet(array, key) {
      var index = assocIndexOf(array, key);
      return index < 0 ? undefined : array[index][1];
    }

    /**
     * Checks if an associative array value for `key` exists.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function assocHas(array, key) {
      return assocIndexOf(array, key) > -1;
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to search.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Sets the associative array `key` to `value`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     */
    function assocSet(array, key, value) {
      var index = assocIndexOf(array, key);
      if (index < 0) {
        array.push([key, value]);
      } else {
        array[index][1] = value;
      }
    }

    /*------------------------------------------------------------------------*/

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function assignInDefaults(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (typeof key == 'number' && value === undefined && !(key in object))) {
        object[key] = value;
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        object[key] = value;
      }
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          isNil = object == null,
          length = paths.length,
          result = Array(length);

      while (++index < length) {
        result[index] = isNil ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments to numbers.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {boolean} [isFull] Specify a clone including symbols.
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          if (isHostObject(value)) {
            return object ? value : {};
          }
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (!isArr) {
        var props = isFull ? getAllKeys(value) : keys(value);
      }
      // Recursively populate clone (susceptible to call stack limits).
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new function.
     */
    function baseConforms(source) {
      var props = keys(source),
          length = props.length;

      return function(object) {
        if (object == null) {
          return !length;
        }
        var index = length;
        while (index--) {
          var key = props[index],
              predicate = source[key],
              value = object[key];

          if ((value === undefined &&
              !(key in Object(object))) || !predicate(value)) {
            return false;
          }
        }
        return true;
      };
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    function baseCreate(proto) {
      return isObject(proto) ? objectCreate(proto) : {};
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an array
     * of `func` arguments.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments to provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = isKey(path, object) ? [path] : castPath(path);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object)
        ? result
        : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments to numbers.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
      // that are composed entirely of index properties, return `false` for
      // `hasOwnProperty` checks of them.
      return hasOwnProperty.call(object, key) ||
        (typeof object == 'object' && key in object && getPrototype(object) === null);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments to numbers.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      if (!isKey(path, object)) {
        path = castPath(path);
        object = parent(object, path);
        path = last(path);
      }
      var func = object == null ? object : object[toKey(path)];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {boolean} [bitmask] The bitmask of comparison flags.
     *  The bitmask may be composed of the following flags:
     *     1 - Unordered comparison
     *     2 - Partial comparison
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, bitmask, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
     *  for more details.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
      }
      if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
      }
      var objIsObj = objTag == objectTag && !isHostObject(object),
          othIsObj = othTag == objectTag && !isHostObject(other),
          isSameTag = objTag == othTag;

      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
          : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
      }
      if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't skip the constructor
     * property of prototypes or treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      return nativeKeys(Object(object));
    }

    /**
     * The base implementation of `_.keysIn` which doesn't skip the constructor
     * property of prototypes or treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      object = object == null ? object : Object(object);

      var result = [];
      for (var key in object) {
        result.push(key);
      }
      return result;
    }

    // Fallback for IE < 9 with es6-shim.
    if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
      baseKeysIn = function(object) {
        return iteratorToArray(enumerate(object));
      };
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments to numbers.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      if (!(isArray(source) || isTypedArray(source))) {
        var props = keysIn(source);
      }
      arrayEach(props || source, function(srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      });
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
          srcValue = source[key],
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        newValue = srcValue;
        if (isArray(srcValue) || isTypedArray(srcValue)) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else {
            isCommon = false;
            newValue = baseClone(srcValue, true);
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            isCommon = false;
            newValue = baseClone(srcValue, true);
          }
          else {
            newValue = objValue;
          }
        }
        else {
          isCommon = false;
        }
      }
      stack.set(srcValue, newValue);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
      }
      stack['delete'](srcValue);
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce `n` to an integer.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property identifiers to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, props) {
      object = Object(object);
      return arrayReduce(props, function(result, key) {
        if (key in object) {
          result[key] = object[key];
        }
        return result;
      }, {});
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, predicate) {
      var index = -1,
          props = getAllKeysIn(object),
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (predicate(value, key)) {
          result[key] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : object[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          }
          else if (!isKey(index, array)) {
            var path = castPath(index),
                object = parent(array, path);

            if (object != null) {
              delete object[toKey(last(path))];
            }
          }
          else {
            delete array[toKey(index)];
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments to numbers.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the new array of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      path = isKey(path, object) ? [path] : castPath(path);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]);
        if (isObject(nested)) {
          var newValue = value;
          if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) {
              newValue = objValue == null
                ? (isIndex(path[index + 1]) ? [] : {})
                : objValue;
            }
          }
          assignValue(nested, key, newValue);
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = isKey(path, object) ? [path] : castPath(path);
      object = parent(object, path);

      var key = toKey(last(path));
      return !(object != null && baseHas(object, key)) || delete object[key];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var index = -1,
          length = arrays.length;

      while (++index < length) {
        var result = result
          ? arrayPush(
              baseDifference(result, arrays[index], iteratee, comparator),
              baseDifference(arrays[index], result, iteratee, comparator)
            )
          : arrays[index];
      }
      return (result && result.length) ? baseUniq(result, iteratee, comparator) : [];
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value) {
      return isArray(value) ? value : stringToPath(value);
    }

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var result = new buffer.constructor(buffer.length);
      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : source[key];

        assignValue(object, key, newValue);
      }
      return object;
    }

    /**
     * Copies own symbol properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return rest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = typeof customizer == 'function'
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
     *  for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBaseWrapper(func, bitmask, thisArg) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = reHasComplexSymbol.test(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
     *  for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurryWrapper(func, bitmask, arity) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getPlaceholder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurryWrapper(
            func, bitmask, createHybridWrapper, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return rest(function(funcs) {
        funcs = baseFlatten(funcs, 1);

        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 &&
              isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
     *  for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
          isFlip = bitmask & FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtorWrapper(func);

      function wrapper() {
        var length = arguments.length,
            index = length,
            args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getPlaceholder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurryWrapper(
            func, bitmask, createHybridWrapper, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return 0;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new invoker function.
     */
    function createOver(arrayFunc) {
      return rest(function(iteratees) {
        iteratees = (iteratees.length == 1 && isArray(iteratees[0]))
          ? arrayMap(iteratees[0], baseUnary(getIteratee()))
          : arrayMap(baseFlatten(iteratees, 1, isFlattenableIteratee), baseUnary(getIteratee()));

        return rest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return reHasComplexSymbol.test(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
     *  for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toNumber(start);
        start = start === start ? start : 0;
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toNumber(end) || 0;
        }
        step = step === undefined ? (start < end ? 1 : -1) : (toNumber(step) || 0);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
     *  for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurryWrapper(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

      if (!(bitmask & CURRY_BOUND_FLAG)) {
        bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return result;
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = toInteger(precision);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask of wrapper flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] == null
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
        bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == BIND_FLAG) {
        var result = createBaseWrapper(func, bitmask, thisArg);
      } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
        result = createCurryWrapper(func, bitmask, arity);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
        result = createPartialWrapper(func, bitmask, thisArg, partials);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} customizer The function to customize comparisons.
     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
     *  for more details.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
      var index = -1,
          isPartial = bitmask & PARTIAL_COMPARE_FLAG,
          isUnordered = bitmask & UNORDERED_COMPARE_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked) {
        return stacked == other;
      }
      var result = true;
      stack.set(array, other);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isUnordered) {
          if (!arraySome(other, function(othValue) {
                return arrValue === othValue ||
                  equalFunc(arrValue, othValue, customizer, bitmask, stack);
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, customizer, bitmask, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} customizer The function to customize comparisons.
     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
     *  for more details.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and
          // booleans to `1` or `0` treating invalid dates coerced to `NaN` as
          // not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object) ? other != +other : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/6.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= UNORDERED_COMPARE_FLAG;
          stack.set(object, other);

          // Recursively compare objects (susceptible to call stack limits).
          return equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} customizer The function to customize comparisons.
     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
     *  for more details.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
          objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : baseHas(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      return result;
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a
     * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
     * Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = toPairs(object),
          length = result.length;

      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object[key];
      return isNative(value) ? value : undefined;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getPlaceholder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the `[[Prototype]]` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {null|Object} Returns the `[[Prototype]]`.
     */
    function getPrototype(value) {
      return nativeGetPrototype(Object(value));
    }

    /**
     * Creates an array of the own enumerable symbol properties of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    function getSymbols(object) {
      // Coerce `object` to an object to avoid non-object errors in V8.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=3443 for more details.
      return getOwnPropertySymbols(Object(object));
    }

    // Fallback for IE < 11.
    if (!getOwnPropertySymbols) {
      getSymbols = function() {
        return [];
      };
    }

    /**
     * Creates an array of the own and inherited enumerable symbol properties
     * of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !getOwnPropertySymbols ? getSymbols : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function getTag(value) {
      return objectToString.call(value);
    }

    // Fallback for data views, maps, sets, and weak maps in IE 11,
    // for data views in Edge, and promises in Node.js.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = objectToString.call(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : undefined;

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = isKey(path, object) ? [path] : castPath(path);

      var result,
          index = -1,
          length = path.length;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result) {
        return result;
      }
      var length = object ? object.length : 0;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isString(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Creates an array of index keys for `object` values of arrays,
     * `arguments` objects, and strings, otherwise `null` is returned.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array|null} Returns index keys, else `null`.
     */
    function indexKeys(object) {
      var length = object ? object.length : undefined;
      if (isLength(length) &&
          (isArray(object) || isString(object) || isArguments(object))) {
        return baseTimes(length, String);
      }
      return null;
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArrayLikeObject(value) && (isArray(value) || isArguments(value));
    }

    /**
     * Checks if `value` is a flattenable array and not a `_.matchesProperty`
     * iteratee shorthand.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenableIteratee(value) {
      return isArray(value) && !(value.length == 2 && !isFunction(value[0]));
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length &&
        (typeof value == 'number' || reIsUint.test(value)) &&
        (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);

      var isCombo =
        ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
        ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function mergeDefaults(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        baseMerge(objValue, srcValue, undefined, mergeDefaults, stack.set(srcValue, objValue));
      }
      return objValue;
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;

      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoize(function(string) {
      var result = [];
      toString(string).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to process.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array ? array.length : 0;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array ? array.length : 0,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length,
          array = castArray(arguments[0]);

      if (length < 2) {
        return length ? copyArray(array) : [];
      }
      var args = Array(length - 1);
      while (length--) {
        args[length - 1] = arguments[length];
      }
      return arrayConcat(array, baseFlatten(args, 1));
    }

    /**
     * Creates an array of unique `array` values not included in the other given
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. The order of result values is determined by the
     * order they occur in the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([3, 2, 1], [4, 2]);
     * // => [3, 1]
     */
    var difference = rest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. Result values are chosen from the first array.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([3.1, 2.2, 1.3], [4.4, 2.5], Math.floor);
     * // => [3.1, 1.3]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = rest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. Result values
     * are chosen from the first array. The comparator is invoked with two arguments:
     * (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = rest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to search.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate) {
      return (array && array.length)
        ? baseFindIndex(array, getIteratee(predicate, 3))
        : -1;
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to search.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate) {
      return (array && array.length)
        ? baseFindIndex(array, getIteratee(predicate, 3), true)
        : -1;
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs ? pairs.length : 0,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      fromIndex = toInteger(fromIndex);
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return baseIndexOf(array, value, fromIndex);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. The order of result values is determined by the
     * order they occur in the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [4, 2], [1, 2]);
     * // => [2]
     */
    var intersection = rest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. Result values are chosen from the first array.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [4.3, 2.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = rest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. Result values are chosen
     * from the first array. The comparator is invoked with two arguments:
     * (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = rest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (comparator === last(mapped)) {
        comparator = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array ? nativeJoin.call(array, separator) : '';
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = (
          index < 0
            ? nativeMax(length + index, 0)
            : nativeMin(index, length - 1)
        ) + 1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Gets the nth element of `array`. If `n` is negative, the nth element
     * from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    var pull = rest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pullAll(array, [2, 3]);
     * console.log(array);
     * // => [1, 1]
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = rest(function(array, indexes) {
      indexes = baseFlatten(indexes, 1);

      var length = array ? array.length : 0,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array ? nativeReverse.call(array) : array;
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 5], 4);
     * // => 0
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var dict = { 'thirty': 30, 'forty': 40, 'fifty': 50 };
     *
     * _.sortedIndexBy(['thirty', 'fifty'], 'forty', _.propertyOf(dict));
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy([{ 'x': 4 }, { 'x': 5 }], { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([1, 1, 2, 2], 2);
     * // => 2
     */
    function sortedIndexOf(array, value) {
      var length = array ? array.length : 0;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5], 4);
     * // => 1
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy([{ 'x': 4 }, { 'x': 5 }], { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([1, 1, 2, 2], 2);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array ? array.length : 0;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2, 1], [4, 2], [1, 2]);
     * // => [2, 1, 4]
     */
    var union = rest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1, 1.2], [4.3, 2.4], Math.floor);
     * // => [2.1, 1.2, 4.3]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = rest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = rest(function(arrays) {
      var comparator = last(arrays);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each
     * element is kept.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length)
        ? baseUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length)
        ? baseUniq(array, getIteratee(iteratee))
        : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The comparator is invoked with
     * two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 },  { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      return (array && array.length)
        ? baseUniq(array, undefined, comparator)
        : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = rest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [4, 2]);
     * // => [1, 4]
     */
    var xor = rest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [4.3, 2.4], Math.floor);
     * // => [1.2, 4.3]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = rest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The comparator is invoked with
     * two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = rest(function(arrays) {
      var comparator = last(arrays);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = rest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = rest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths of elements to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     *
     * _(['a', 'b', 'c']).at(0, 2).value();
     * // => ['a', 'c']
     */
    var wrapperAt = rest(function(paths) {
      paths = baseFlatten(paths, 1);
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to search.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    function find(collection, predicate) {
      predicate = getIteratee(predicate, 3);
      if (isArray(collection)) {
        var index = baseFindIndex(collection, predicate);
        return index > -1 ? collection[index] : undefined;
      }
      return baseFind(collection, predicate, baseEach);
    }

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to search.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    function findLast(collection, predicate) {
      predicate = getIteratee(predicate, 3);
      if (isArray(collection)) {
        var index = baseFindIndex(collection, predicate, true);
        return index > -1 ? collection[index] : undefined;
      }
      return baseFind(collection, predicate, baseEachRight);
    }

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _([1, 2]).forEach(function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      return (typeof iteratee == 'function' && isArray(collection))
        ? arrayEach(collection, iteratee)
        : baseEach(collection, getIteratee(iteratee));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      return (typeof iteratee == 'function' && isArray(collection))
        ? arrayEachRight(collection, iteratee)
        : baseEachRight(collection, getIteratee(iteratee));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function, it's
     * invoked for and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = rest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
        result[++index] = func ? apply(func, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      result[key] = value;
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getIteratee(predicate, 3);
      return func(collection, function(value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var array = isArrayLike(collection) ? collection : values(collection),
          length = array.length;

      return length > 0 ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      var index = -1,
          result = toArray(collection),
          length = result.length,
          lastIndex = length - 1;

      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = baseClamp(toInteger(n), 0, length);
      }
      while (++index < n) {
        var rand = baseRandom(index, lastIndex),
            value = result[rand];

        result[rand] = result[index];
        result[index] = value;
      }
      result.length = n;
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      return sampleSize(collection, MAX_ARRAY_LENGTH);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        var result = collection.length;
        return (result && isString(collection)) ? stringSize(collection) : result;
      }
      if (isObjectLike(collection)) {
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
      }
      return keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
     *  [iteratees=[_.identity]] The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, function(o) { return o.user; });
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     *
     * _.sortBy(users, 'user', function(o) {
     *   return Math.floor(o.age / 10);
     * });
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    var sortBy = rest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      iteratees = (iteratees.length == 1 && isArray(iteratees[0]))
        ? iteratees[0]
        : baseFlatten(iteratees, 1, isFlattenableIteratee);

      return baseOrderBy(collection, iteratees, []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @type {Function}
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred function to be invoked.
     */
    var now = Date.now;

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = rest(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getPlaceholder(bind));
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = rest(function(object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getPlaceholder(bindKey));
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrapper(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrapper(func, CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide an options object to indicate whether `func` should be invoked on
     * the leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent calls
     * to the debounced function return the result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime = 0,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (!lastCallTime || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        clearTimeout(timerId);
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastCallTime = lastInvokeTime = 0;
        lastArgs = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one or more milliseconds.
     */
    var defer = rest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = rest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrapper(func, FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with arguments transformed by
     * corresponding `transforms`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
     *  [transforms[_.identity]] The functions to transform.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = rest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1, isFlattenableIteratee), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return rest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = rest(function(func, partials) {
      var holders = replaceHolders(partials, getPlaceholder(partial));
      return createWrapper(func, PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = rest(function(func, partials) {
      var holders = replaceHolders(partials, getPlaceholder(partialRight));
      return createWrapper(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = rest(function(func, indexes) {
      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes, 1));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, array);
          case 1: return func.call(this, args[0], array);
          case 2: return func.call(this, args[0], args[1], array);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = array;
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/6.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
      return rest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide an options object to indicate whether
     * `func` should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return partial(wrapper, value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, false, true);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      return baseClone(value, false, true, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, true, true);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      return baseClone(value, true, true, customizer);
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
      return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
        (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @type {Function}
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified,
     *  else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified,
     *  else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    function isArrayBuffer(value) {
      return isObjectLike(value) && objectToString.call(value) == arrayBufferTag;
    }

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value)) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified,
     *  else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && objectToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = !Buffer ? constant(false) : function(value) {
      return value instanceof Buffer;
    };

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified,
     *  else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objectToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element,
     *  else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (isArrayLike(value) &&
          (isArray(value) || isString(value) || isFunction(value.splice) ||
            isArguments(value) || isBuffer(value))) {
        return !value.length;
      }
      if (isObjectLike(value)) {
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return !(nonEnumShadows && keys(value).length);
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are **not** supported.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent,
     *  else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent,
     *  else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object,
     *  else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      return (objectToString.call(value) == errorTag) ||
        (typeof value.message == 'string' && typeof value.name == 'string');
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number,
     *  else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MAX_VALUE);
     * // => true
     *
     * _.isFinite(3.14);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified,
     *  else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 8 which returns 'object' for typed array and weak map constructors,
      // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
      var tag = isObject(value) ? objectToString.call(value) : '';
      return tag == funcTag || tag == genTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length,
     *  else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return !!value && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified,
     *  else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    function isMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values. This method is
     * equivalent to a `_.matches` function when `source` is partially applied.
     *
     * **Note:** This method supports comparing the same values as `_.isEqual`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (!isObject(value)) {
        return false;
      }
      var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified,
     *  else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && objectToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object,
     *  else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) ||
          objectToString.call(value) != objectTag || isHostObject(value)) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return (typeof Ctor == 'function' &&
        Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified,
     *  else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObject(value) && objectToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer,
     *  else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified,
     *  else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    function isSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified,
     *  else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified,
     *  else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && objectToString.call(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified,
     *  else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified,
     *  else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified,
     *  else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && objectToString.call(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (iteratorSymbol && value[iteratorSymbol]) {
        return iteratorToArray(value[iteratorSymbol]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This function is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3');
     * // => 3
     */
    function toInteger(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      var remainder = value % 1;
      return value === value ? (remainder ? value - remainder : value) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3);
     * // => 3
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3');
     * // => 3
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = isFunction(value.valueOf) ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3');
     * // => 3
     */
    function toSafeInteger(value) {
      return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.c = 3;
     * }
     *
     * function Bar() {
     *   this.e = 5;
     * }
     *
     * Foo.prototype.d = 4;
     * Bar.prototype.f = 6;
     *
     * _.assign({ 'a': 1 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3, 'e': 5 }
     */
    var assign = createAssigner(function(object, source) {
      if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * function Bar() {
     *   this.d = 4;
     * }
     *
     * Foo.prototype.c = 3;
     * Bar.prototype.e = 5;
     *
     * _.assignIn({ 'a': 1 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4, 'e': 5 }
     */
    var assignIn = createAssigner(function(object, source) {
      if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keysIn(source), object);
        return;
      }
      for (var key in source) {
        assignValue(object, key, source[key]);
      }
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     *
     * _.at(['a', 'b', 'c'], 0, 2);
     * // => ['a', 'c']
     */
    var at = rest(function(object, paths) {
      return baseAt(object, baseFlatten(paths, 1));
    });

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = rest(function(args) {
      args.push(undefined, assignInDefaults);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */
    var defaultsDeep = rest(function(args) {
      args.push(undefined, mergeDefaults);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to search.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFind(object, getIteratee(predicate, 3), baseForOwn, true);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to search.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFind(object, getIteratee(predicate, 3), baseForOwnRight, true);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = rest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      var isProto = isPrototype(object);
      if (!(isProto || isArrayLike(object))) {
        return baseKeys(object);
      }
      var indexes = indexKeys(object),
          skipIndexes = !!indexes,
          result = indexes || [],
          length = result.length;

      for (var key in object) {
        if (baseHas(object, key) &&
            !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
            !(isProto && key == 'constructor')) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      var index = -1,
          isProto = isPrototype(object),
          props = baseKeysIn(object),
          propsLength = props.length,
          indexes = indexKeys(object),
          skipIndexes = !!indexes,
          result = indexes || [],
          length = result.length;

      while (++index < propsLength) {
        var key = props[index];
        if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        result[iteratee(value, key, object)] = value;
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        result[key] = iteratee(value, key, object);
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively.Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with seven arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable string keyed properties of `object` that are
     * not omitted.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [props] The property identifiers to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = rest(function(object, props) {
      if (object == null) {
        return {};
      }
      props = arrayMap(baseFlatten(props, 1), toKey);
      return basePick(object, baseDifference(getAllKeysIn(object), props));
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      predicate = getIteratee(predicate);
      return basePickBy(object, function(value, key) {
        return !predicate(value, key);
      });
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [props] The property identifiers to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = rest(function(object, props) {
      return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Array|Function|Object|string} [predicate=_.identity]
     *  The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      return object == null ? {} : basePickBy(object, getIteratee(predicate));
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = isKey(path, object) ? [path] : castPath(path);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        object = undefined;
        length = 1;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    function toPairs(object) {
      return baseToPairs(object, keys(object));
    }

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 1]] (iteration order is not guaranteed)
     */
    function toPairsIn(object) {
      return baseToPairs(object, keysIn(object));
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. The iteratee is invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getIteratee(iteratee, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object ? baseValues(object, keys(object)) : [];
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toNumber(start) || 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toNumber(end) || 0;
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toNumber(lower) || 0;
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toNumber(upper) || 0;
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in IE < 9, they can break out of
     * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the
     * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      // Chrome fails to trim leading <BOM> whitespace characters.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=3109 for more details.
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      string = toString(string).replace(reTrim, '');
      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : nativeReplace.call(string, args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the new array of string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (separator == '' && reHasComplexSymbol.test(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return nativeSplit.call(string, separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = baseClamp(toInteger(position), 0, string.length);
      return string.lastIndexOf(baseToString(target), position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, assignInDefaults);

      var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (reHasComplexSymbol.test(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        pattern = reHasComplexWord.test(string) ? reComplexWord : reBasicWord;
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = rest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, 'onClick');
     * jQuery(element).on('click', view.onClick);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = rest(function(object, methodNames) {
      arrayEach(baseFlatten(methodNames, 1), function(key) {
        key = toKey(key);
        object[key] = bind(object[key], object);
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.constant(true),                _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs ? pairs.length : 0,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return rest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.filter(users, _.conforms({ 'age': _.partial(_.gt, _, 38) }));
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, true));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument given to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, true));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`. The created function is equivalent to
     * `_.isMatch` with a `source` partially applied.
     *
     * **Note:** This method supports comparing the same values as `_.isEqual`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** This method supports comparing the same values as `_.isEqual`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, true));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = rest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = rest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that returns its nth argument. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return rest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
     *  [iteratees=[_.identity]] The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over(Math.max, Math.min);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
     *  [predicates=[_.identity]] The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery(Boolean, isFinite);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
     *  [predicates=[_.identity]] The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome(Boolean, isFinite);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(true));
     * // => [true, true, true, true]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     *
     * var path = ['a', 'b', 'c'],
     *     newPath = _.toPath(path);
     *
     * console.log(newPath);
     * // => ['a', 'b', 'c']
     *
     * console.log(path === newPath);
     * // => false
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(value));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    });

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    });

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    });

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    });

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Array|Function|Object|string} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.deburr = deburr;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = rest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      predicate = getIteratee(predicate, 3);
      return this.filter(function(value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    if (iteratorSymbol) {
      lodash.prototype[iteratorSymbol] = wrapperToIterator;
    }
    return lodash;
  }

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Expose Lodash on the free variable `window` or `self` when available so it's
  // globally accessible, even when bundled with Browserify, Webpack, etc. This
  // also prevents errors in cases where Lodash is loaded by a script tag in the
  // presence of an AMD loader. See http://requirejs.org/docs/errors.html#mismatch
  // for more details. Use `_.noConflict` to remove Lodash from the global object.
  (freeWindow || freeSelf || {})._ = _;

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (true) {
    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module), __webpack_require__(10)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var



Animated=function(){function Animated(){_classCallCheck(this,Animated);}_createClass(Animated,[{key:'__attach',value:function __attach()
{}},{key:'__detach',value:function __detach()
{}},{key:'__getValue',value:function __getValue()
{}},{key:'__getAnimatedValue',value:function __getAnimatedValue()
{return this.__getValue();}},{key:'__addChild',value:function __addChild(
child){}},{key:'__removeChild',value:function __removeChild(
child){}},{key:'__getChildren',value:function __getChildren()
{return[];}}]);return Animated;}();


module.exports=Animated;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var isWebColor=function isWebColor(color){return color==='currentcolor'||color==='inherit'||color.indexOf('var(')===0;};var colorPropType=function colorPropType(isRequired,props,propName,componentName,location,propFullName){var normalizeColor=__webpack_require__(62);var color=props[propName];if(color===undefined||color===null){if(isRequired){return new Error('Required '+location+' `'+(propFullName||propName)+'` was not specified in `'+componentName+'`.');}return;}if(typeof color==='number'){return;}if(typeof color==='string'&&isWebColor(color)){return;}if(normalizeColor(color)===null){return new Error('Invalid '+location+' `'+(propFullName||propName)+'` supplied to `'+componentName+'`: '+color+'\n'+'Valid color formats are\n  - \'#f0f\' (#rgb)\n  - \'#f0fc\' (#rgba)\n  - \'#ff00ff\' (#rrggbb)\n  - \'#ff00ff00\' (#rrggbbaa)\n  - \'rgb(255, 255, 255)\'\n  - \'rgba(255, 255, 255, 1.0)\'\n  - \'hsl(360, 100%, 100%)\'\n  - \'hsla(360, 100%, 100%, 1.0)\'\n  - \'transparent\'\n  - \'red\'\n  - 0xff00ff00 (0xrrggbbaa)\n');}};var ColorPropType=void 0;if(false){ColorPropType=colorPropType.bind(null,false);ColorPropType.isRequired=colorPropType.bind(null,true);}else{ColorPropType=function ColorPropType(){};}exports.default=ColorPropType;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _BaseComponentPropTypes=__webpack_require__(95);var _BaseComponentPropTypes2=_interopRequireDefault(_BaseComponentPropTypes);var _EdgeInsetsPropType=__webpack_require__(96);var _EdgeInsetsPropType2=_interopRequireDefault(_EdgeInsetsPropType);var _StyleSheetPropType=__webpack_require__(56);var _StyleSheetPropType2=_interopRequireDefault(_StyleSheetPropType);var _ViewStylePropTypes=__webpack_require__(97);var _ViewStylePropTypes2=_interopRequireDefault(_ViewStylePropTypes);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ViewPropTypes=_extends({},_BaseComponentPropTypes2.default,{children:_propTypes.any,collapsable:_propTypes.bool,hitSlop:_EdgeInsetsPropType2.default,onClick:_propTypes.func,onClickCapture:_propTypes.func,onLayout:_propTypes.func,onMoveShouldSetResponder:_propTypes.func,onMoveShouldSetResponderCapture:_propTypes.func,onResponderGrant:_propTypes.func,onResponderMove:_propTypes.func,onResponderReject:_propTypes.func,onResponderRelease:_propTypes.func,onResponderTerminate:_propTypes.func,onResponderTerminationRequest:_propTypes.func,onStartShouldSetResponder:_propTypes.func,onStartShouldSetResponderCapture:_propTypes.func,onTouchCancel:_propTypes.func,onTouchCancelCapture:_propTypes.func,onTouchEnd:_propTypes.func,onTouchEndCapture:_propTypes.func,onTouchMove:_propTypes.func,onTouchMoveCapture:_propTypes.func,onTouchStart:_propTypes.func,onTouchStartCapture:_propTypes.func,pointerEvents:(0,_propTypes.oneOf)(['auto','box-none','box-only','none']),style:(0,_StyleSheetPropType2.default)(_ViewStylePropTypes2.default)});exports.default=ViewPropTypes;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.4';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
          srcValue = source[key],
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length &&
        (typeof value == 'number' || reIsUint.test(value)) &&
        (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(args) {
      args.push(undefined, customDefaultsAssignIn);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(57)(module)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _NativeMethodsMixin=__webpack_require__(325);var _NativeMethodsMixin2=_interopRequireDefault(_NativeMethodsMixin);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var applyNativeMethods=function applyNativeMethods(Component){Object.keys(_NativeMethodsMixin2.default).forEach(function(method){if(!Component.prototype[method]){Component.prototype[method]=_NativeMethodsMixin2.default[method];}});return Component;};exports.default=applyNativeMethods;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(186);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FFF"},buttonContainer:{flexDirection:"row",flexWrap:"wrap",flex:1,justifyContent:"center",marginTop:10},mb15:{marginBottom:20},mt15:{marginTop:15},mb20:{marginBottom:20},iconButton:{color:"#007aff"},margin:{flex:1,alignItems:"center",justifyContent:"center",borderColor:"#FFF"},mf:{flexGrow:1,alignSelf:"center",alignItems:"center"}});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var Animated=__webpack_require__(13);var

AnimatedWithChildren=function(_Animated){_inherits(AnimatedWithChildren,_Animated);


function AnimatedWithChildren(){_classCallCheck(this,AnimatedWithChildren);var _this=_possibleConstructorReturn(this,(AnimatedWithChildren.__proto__||Object.getPrototypeOf(AnimatedWithChildren)).call(this));

_this._children=[];return _this;
}_createClass(AnimatedWithChildren,[{key:'__addChild',value:function __addChild(

child){
if(this._children.length===0){
this.__attach();
}
this._children.push(child);
}},{key:'__removeChild',value:function __removeChild(

child){
var index=this._children.indexOf(child);
if(index===-1){
console.warn('Trying to remove a child that doesn\'t exist');
return;
}
this._children.splice(index,1);
if(this._children.length===0){
this.__detach();
}
}},{key:'__getChildren',value:function __getChildren()

{
return this._children;
}}]);return AnimatedWithChildren;}(Animated);


module.exports=AnimatedWithChildren;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use_strict";
var _lodash=__webpack_require__(12);var _lodash2=_interopRequireDefault(_lodash);
var _ReactNativePropRegistry=__webpack_require__(180);var _ReactNativePropRegistry2=_interopRequireDefault(_ReactNativePropRegistry);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}


module.exports=function(incomingProps,defaultProps){

var computedProps={};

incomingProps=_lodash2.default.clone(incomingProps);
delete incomingProps.children;

var incomingPropsStyle=incomingProps.style;
delete incomingProps.style;


if(incomingProps){
_lodash2.default.assign(computedProps,defaultProps,incomingProps);
}else{
computedProps=defaultProps;
}

if(incomingPropsStyle){
var computedPropsStyle={};
computedProps.style={};
if(Array.isArray(incomingPropsStyle)){
_lodash2.default.forEach(incomingPropsStyle,function(style){
if(typeof style==="number"){
_lodash2.default.merge(computedPropsStyle,_ReactNativePropRegistry2.default.getByID(style));
}else{
_lodash2.default.merge(computedPropsStyle,style);
}
});
}else if(typeof incomingPropsStyle==="number"){
computedPropsStyle=_ReactNativePropRegistry2.default.getByID(incomingPropsStyle);
}else{
computedPropsStyle=incomingPropsStyle;
}

_lodash2.default.merge(computedProps.style,defaultProps.style,computedPropsStyle);
}

return computedProps;
};
//# sourceMappingURL=computeProps.js.map

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=createIconSet;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);var _reactNative=__webpack_require__(75);var _iconButton=__webpack_require__(464);var _iconButton2=_interopRequireDefault(_iconButton);var _tabBarItemIos=__webpack_require__(558);var _tabBarItemIos2=_interopRequireDefault(_tabBarItemIos);var _toolbarAndroid=__webpack_require__(568);var _toolbarAndroid2=_interopRequireDefault(_toolbarAndroid);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NativeIconAPI=_reactNative.NativeModules.RNVectorIconsManager||_reactNative.NativeModules.RNVectorIconsModule;var DEFAULT_ICON_SIZE=12;var DEFAULT_ICON_COLOR='black';function createIconSet(glyphMap,fontFamily,fontFile){var fontReference=fontFamily;if(_reactNative.Platform.OS==='android'&&fontFile){fontReference=fontFile.replace(/\.(otf|ttf)$/,'');}if(_reactNative.Platform.OS==='windows'&&fontFile){fontReference='Assets/'+fontFile+'#'+fontFamily;}var IconNamePropType=_propTypes2.default.oneOf(Object.keys(glyphMap));var Icon=function(_Component){_inherits(Icon,_Component);function Icon(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Icon);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Icon.__proto__||Object.getPrototypeOf(Icon)).call.apply(_ref,[this].concat(args))),_this),_this.root=null,_this.handleRef=function(ref){_this.root=ref;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Icon,[{key:'setNativeProps',value:function setNativeProps(nativeProps){if(this.root){this.root.setNativeProps(nativeProps);}}},{key:'render',value:function render(){var _props=this.props,name=_props.name,size=_props.size,color=_props.color,style=_props.style,props=_objectWithoutProperties(_props,['name','size','color','style']);var glyph=name?glyphMap[name]||'?':'';if(typeof glyph==='number'){glyph=String.fromCharCode(glyph);}var styleDefaults={fontSize:size,color:color};var styleOverrides={fontFamily:fontReference,fontWeight:'normal',fontStyle:'normal'};props.style=[styleDefaults,style,styleOverrides];props.ref=this.handleRef;return _react2.default.createElement(_reactNative.Text,props,glyph,this.props.children);}}]);return Icon;}(_react.Component);Icon.propTypes={name:IconNamePropType,size:_propTypes2.default.number,color:_propTypes2.default.string,children:_propTypes2.default.node,style:_propTypes2.default.any};Icon.defaultProps={size:DEFAULT_ICON_SIZE,allowFontScaling:false};var imageSourceCache={};function ensureNativeModuleAvailable(){if(!NativeIconAPI){if(_reactNative.Platform.OS==='android'){throw new Error('RNVectorIconsModule not available, did you properly integrate the module? Try running `react-native link react-native-vector-icons` and recompiling.');}throw new Error('RNVectorIconsManager not available, did you add the library to your project and link with libRNVectorIcons.a? Try running `react-native link react-native-vector-icons` and recompiling.');}}function getImageSource(name){var size=arguments.length>1&&arguments[1]!==undefined?arguments[1]:DEFAULT_ICON_SIZE;var color=arguments.length>2&&arguments[2]!==undefined?arguments[2]:DEFAULT_ICON_COLOR;ensureNativeModuleAvailable();var glyph=glyphMap[name]||'?';if(typeof glyph==='number'){glyph=String.fromCharCode(glyph);}var processedColor=(0,_reactNative.processColor)(color);var cacheKey=glyph+':'+size+':'+processedColor;var scale=_reactNative.PixelRatio.get();return new Promise(function(resolve,reject){var cached=imageSourceCache[cacheKey];if(typeof cached!=='undefined'){if(!cached||cached instanceof Error){reject(cached);}else{resolve({uri:cached,scale:scale});}}else{NativeIconAPI.getImageForFont(fontReference,glyph,size,processedColor,function(err,image){var error=typeof err==='string'?new Error(err):err;imageSourceCache[cacheKey]=image||error||false;if(!error&&image){resolve({uri:image,scale:scale});}else{reject(error);}});}});}function loadFont(){var file=arguments.length>0&&arguments[0]!==undefined?arguments[0]:fontFile;if(_reactNative.Platform.OS==='ios'){ensureNativeModuleAvailable();if(!file){return Promise.reject(new Error('Unable to load font, because no file was specified. '));}return NativeIconAPI.loadFontWithFileName.apply(NativeIconAPI,_toConsumableArray(file.split('.')));}return Promise.resolve();}Icon.Button=(0,_iconButton2.default)(Icon);Icon.TabBarItem=(0,_tabBarItemIos2.default)(IconNamePropType,getImageSource);Icon.TabBarItemIOS=Icon.TabBarItem;Icon.ToolbarAndroid=(0,_toolbarAndroid2.default)(IconNamePropType,getImageSource);Icon.getImageSource=getImageSource;Icon.loadFont=loadFont;return Icon;}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *//**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */var validateFormat=function validateFormat(format){};if(false){validateFormat=function validateFormat(format){if(format===undefined){throw new Error('invariant requires an error message argument');}};}function invariant(condition,format,a,b,c,d,e,f){validateFormat(format);if(!condition){var error;if(format===undefined){error=new Error('Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.');}else{var args=[a,b,c,d,e,f];var argIndex=0;error=new Error(format.replace(/%s/g,function(){return args[argIndex++];}));error.name='Invariant Violation';}error.framesToPop=1;// we don't care about invariant's own frame
throw error;}}module.exports=invariant;

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FFF"},mb10:{marginBottom:10}});

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(341);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Text=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Text.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _lodash=__webpack_require__(12);var _lodash2=_interopRequireDefault(_lodash);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Text=function(_Component){_inherits(Text,_Component);function Text(){_classCallCheck(this,Text);return _possibleConstructorReturn(this,(Text.__proto__||Object.getPrototypeOf(Text)).apply(this,arguments));}_createClass(Text,[{key:"render",value:function render()
{var _this2=this;var _props=



this.props,uppercase=_props.uppercase,children=_props.children;

var text=void 0;
if(uppercase){
text=_react2.default.Children.map(children,function(child){
if(_lodash2.default.isString(child)){
return _lodash2.default.toUpper(child);
}else{
return child;
}
});
}else{
text=children;
}

return(
_react2.default.createElement(_reactNative.Text,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:30}}),
text));


}}]);return Text;}(_react.Component);


Text.propTypes=_extends({},
_reactNative.Text.propTypes,{
uppercase:_propTypes2.default.bool,
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


Text.defaultProps={
uppercase:false};


var StyledText=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Text",{},_mapPropsToStyleNames2.default)(Text);exports.

Text=StyledText;
//# sourceMappingURL=Text.js.map

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FFF"},mb:{marginBottom:15}});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FFF"},text:{alignSelf:"center",marginBottom:7},mb:{marginBottom:15}});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FBFAFA"}});

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(266);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {









var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var AnimatedWithChildren=__webpack_require__(22);
var InteractionManager=__webpack_require__(157);
var AnimatedInterpolation=__webpack_require__(63);
var Interpolation=__webpack_require__(54);
var Animation=__webpack_require__(55);
var guid=__webpack_require__(91);
var Set=global.Set||__webpack_require__(309);




























function _flush(rootNode){
var animatedStyles=new Set();
function findAnimatedStyles(node){
if(typeof node.update==='function'){
animatedStyles.add(node);
}else{
node.__getChildren().forEach(findAnimatedStyles);
}
}
findAnimatedStyles(rootNode);
animatedStyles.forEach(function(animatedStyle){return animatedStyle.update();});
}var







AnimatedValue=function(_AnimatedWithChildren){_inherits(AnimatedValue,_AnimatedWithChildren);






function AnimatedValue(value){_classCallCheck(this,AnimatedValue);var _this=_possibleConstructorReturn(this,(AnimatedValue.__proto__||Object.getPrototypeOf(AnimatedValue)).call(this));

_this._value=value;
_this._offset=0;
_this._animation=null;
_this._listeners={};return _this;
}_createClass(AnimatedValue,[{key:'__detach',value:function __detach()

{
this.stopAnimation();
}},{key:'__getValue',value:function __getValue()

{
return this._value+this._offset;
}},{key:'setValue',value:function setValue(





value){
if(this._animation){
this._animation.stop();
this._animation=null;
}
this._updateValue(value);
}},{key:'setOffset',value:function setOffset(






offset){
this._offset=offset;
}},{key:'flattenOffset',value:function flattenOffset()





{
this._value+=this._offset;
this._offset=0;
}},{key:'addListener',value:function addListener(






callback){
var id=guid();
this._listeners[id]=callback;
return id;
}},{key:'removeListener',value:function removeListener(

id){
delete this._listeners[id];
}},{key:'removeAllListeners',value:function removeAllListeners()

{
this._listeners={};
}},{key:'stopAnimation',value:function stopAnimation(






callback){
this.stopTracking();
this._animation&&this._animation.stop();
this._animation=null;
callback&&callback(this.__getValue());
}},{key:'interpolate',value:function interpolate(





config){
return new AnimatedInterpolation(this,Interpolation.create(config));
}},{key:'animate',value:function animate(





animation,callback){var _this2=this;
var handle=null;
if(animation.__isInteraction){
handle=InteractionManager.current.createInteractionHandle();
}
var previousAnimation=this._animation;
this._animation&&this._animation.stop();
this._animation=animation;
animation.start(
this._value,
function(value){
_this2._updateValue(value);
},
function(result){
_this2._animation=null;
if(handle!==null){
InteractionManager.current.clearInteractionHandle(handle);
}
callback&&callback(result);
},
previousAnimation);

}},{key:'stopTracking',value:function stopTracking()




{
this._tracking&&this._tracking.__detach();
this._tracking=null;
}},{key:'track',value:function track(




tracking){
this.stopTracking();
this._tracking=tracking;
}},{key:'_updateValue',value:function _updateValue(

value){
this._value=value;
_flush(this);
for(var key in this._listeners){
this._listeners[key]({value:this.__getValue()});
}
}}]);return AnimatedValue;}(AnimatedWithChildren);


module.exports=AnimatedValue;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='src/components/UnimplementedView/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _View=__webpack_require__(11);var _View2=_interopRequireDefault(_View);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UnimplementedView=function(_Component){_inherits(UnimplementedView,_Component);function UnimplementedView(){_classCallCheck(this,UnimplementedView);return _possibleConstructorReturn(this,(UnimplementedView.__proto__||Object.getPrototypeOf(UnimplementedView)).apply(this,arguments));}_createClass(UnimplementedView,[{key:'setNativeProps',value:function setNativeProps(){}},{key:'render',value:function render(){return _react2.default.createElement(_View2.default,{style:[unimplementedViewStyles,this.props.style],__source:{fileName:_jsxFileName,lineNumber:28}},this.props.children);}}]);return UnimplementedView;}(_react.Component);var unimplementedViewStyles= false?{alignSelf:'flex-start',borderColor:'red',borderWidth:1}:{};exports.default=UnimplementedView;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(45),
    getRawTag = __webpack_require__(466),
    objectToString = __webpack_require__(467);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(480),
    getValue = __webpack_require__(483);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var BACK='Navigation/BACK';var INIT='Navigation/INIT';var NAVIGATE='Navigation/NAVIGATE';var RESET='Navigation/RESET';var SET_PARAMS='Navigation/SET_PARAMS';var URI='Navigation/URI';var createAction=function createAction(type){return function(){var payload=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _extends({type:type},payload);};};var back=createAction(BACK);var init=createAction(INIT);var navigate=createAction(NAVIGATE);var reset=createAction(RESET);var setParams=createAction(SET_PARAMS);var uri=createAction(URI);var deprecatedActionMap={Back:BACK,Init:INIT,Navigate:NAVIGATE,Reset:RESET,SetParams:SET_PARAMS,Uri:URI};var mapDeprecatedActionAndWarn=function mapDeprecatedActionAndWarn(action){var mappedType=deprecatedActionMap[action.type];if(!mappedType){return action;}console.warn(['The action type \''+action.type+'\' has been renamed to \''+mappedType+'\'.','\''+action.type+'\' will continue to work while in beta but will be removed','in the first major release. Moving forward, you should use the','action constants and action creators exported by this library in',"the 'actions' object.",'See https://github.com/react-community/react-navigation/pull/120 for','more details.'].join(' '));return _extends({},action,{type:deprecatedActionMap[action.type]});};exports.default={// Action constants
BACK:BACK,INIT:INIT,NAVIGATE:NAVIGATE,RESET:RESET,SET_PARAMS:SET_PARAMS,URI:URI,// Action creators
back:back,init:init,navigate:navigate,reset:reset,setParams:setParams,uri:uri,// TODO: Remove once old actions are deprecated
mapDeprecatedActionAndWarn:mapDeprecatedActionAndWarn};

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FFF"}});

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});__webpack_require__(265);var _AccessibilityUtil=__webpack_require__(87);var _AccessibilityUtil2=_interopRequireDefault(_AccessibilityUtil);var _createDOMProps=__webpack_require__(146);var _createDOMProps2=_interopRequireDefault(_createDOMProps);var _normalizeNativeEvent=__webpack_require__(144);var _normalizeNativeEvent2=_interopRequireDefault(_normalizeNativeEvent);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var eventHandlerNames={onClick:true,onClickCapture:true,onMoveShouldSetResponder:true,onMoveShouldSetResponderCapture:true,onResponderGrant:true,onResponderMove:true,onResponderReject:true,onResponderRelease:true,onResponderTerminate:true,onResponderTerminationRequest:true,onStartShouldSetResponder:true,onStartShouldSetResponderCapture:true,onTouchCancel:true,onTouchCancelCapture:true,onTouchEnd:true,onTouchEndCapture:true,onTouchMove:true,onTouchMoveCapture:true,onTouchStart:true,onTouchStartCapture:true};var adjustProps=function adjustProps(domProps){var isButtonRole=domProps.role==='button';var isDisabled=_AccessibilityUtil2.default.isDisabled(domProps);Object.keys(domProps).forEach(function(propName){var prop=domProps[propName];var isEventHandler=typeof prop==='function'&&eventHandlerNames[propName];if(isEventHandler){if(isButtonRole&&isDisabled){domProps[propName]=undefined;}else{domProps[propName]=function(e){e.nativeEvent=(0,_normalizeNativeEvent2.default)(e.nativeEvent);return prop(e);};}}});if(isButtonRole&&!isDisabled){var onClick=domProps.onClick;domProps.onKeyPress=function(e){if(!e.isDefaultPrevented()&&(e.which===13||e.which===32)){e.preventDefault();if(onClick){onClick(e);}}};}};var createElement=function createElement(component,props){for(var _len=arguments.length,children=Array(_len>2?_len-2:0),_key=2;_key<_len;_key++){children[_key-2]=arguments[_key];}var accessibilityComponent=_AccessibilityUtil2.default.propsToAccessibilityComponent(props);var Component=accessibilityComponent||component;var domProps=(0,_createDOMProps2.default)(Component,props);adjustProps(domProps);return _react2.default.createElement.apply(_react2.default,[Component,domProps].concat(children));};exports.default=createElement;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _reactDom=__webpack_require__(33);exports.default=_reactDom.findDOMNode;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[typeof Symbol==='function'?typeof Symbol==='function'?Symbol.iterator:'@@iterator':'@@iterator'](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if((typeof Symbol==='function'?typeof Symbol==='function'?Symbol.iterator:'@@iterator':'@@iterator')in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _requestAnimationFrame=__webpack_require__(163);var _requestAnimationFrame2=_interopRequireDefault(_requestAnimationFrame);var _setImmediate=__webpack_require__(327);var _setImmediate2=_interopRequireDefault(_setImmediate);var _setValueForStyles=__webpack_require__(330);var _setValueForStyles2=_interopRequireDefault(_setValueForStyles);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getRect=function getRect(node){var height=node.offsetHeight;var width=node.offsetWidth;var left=0;var top=0;while(node&&node.nodeType===1){left+=node.offsetLeft;top+=node.offsetTop;node=node.offsetParent;}return{height:height,left:left,top:top,width:width};};var hasRequestedAnimationFrame=false;var measureLayoutQueue=[];var processLayoutQueue=function processLayoutQueue(){measureLayoutQueue.splice(0,250).forEach(function(item){var _item=_slicedToArray(item,3),node=_item[0],relativeToNativeNode=_item[1],callback=_item[2];var relativeNode=relativeToNativeNode||node&&node.parentNode;if(node&&relativeNode){var relativeRect=getRect(relativeNode);var _getRect=getRect(node),height=_getRect.height,left=_getRect.left,top=_getRect.top,width=_getRect.width;var x=left-relativeRect.left;var y=top-relativeRect.top;callback(x,y,width,height,left,top);}});if(measureLayoutQueue.length>0){(0,_setImmediate2.default)(processLayoutQueue);}};var _measureLayout=function _measureLayout(node,relativeToNativeNode,callback){if(!hasRequestedAnimationFrame){(0,_requestAnimationFrame2.default)(function(){hasRequestedAnimationFrame=false;processLayoutQueue();});}hasRequestedAnimationFrame=true;measureLayoutQueue.push([node,relativeToNativeNode,callback]);};var UIManager={blur:function blur(node){try{node.blur();}catch(err){}},focus:function focus(node){try{node.focus();}catch(err){}},measure:function measure(node,callback){_measureLayout(node,null,callback);},measureInWindow:function measureInWindow(node,callback){(0,_requestAnimationFrame2.default)(function(){if(node){var _getRect2=getRect(node),height=_getRect2.height,left=_getRect2.left,top=_getRect2.top,width=_getRect2.width;callback(left,top,width,height);}});},measureLayout:function measureLayout(node,relativeToNativeNode,onFail,onSuccess){_measureLayout(node,relativeToNativeNode,onSuccess);},updateView:function updateView(node,props,component){for(var prop in props){if(!Object.prototype.hasOwnProperty.call(props,prop)){continue;}var value=props[prop];switch(prop){case'style':{(0,_setValueForStyles2.default)(node,value,component._reactInternalInstance);break;}case'class':case'className':{node.setAttribute('class',value);break;}case'text':case'value':node.value=value;break;default:node.setAttribute(prop,value);}}}};exports.default=UIManager;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _Row=__webpack_require__(179);var _Row2=_interopRequireDefault(_Row);var _Grid=__webpack_require__(407);var _Grid2=_interopRequireDefault(_Grid);var _Col=__webpack_require__(181);var _Col2=_interopRequireDefault(_Col);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}module.exports={Row:_Row2.default,Col:_Col2.default,Grid:_Grid2.default};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(19);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 46 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(20),
    isKey = __webpack_require__(531),
    stringToPath = __webpack_require__(532),
    toString = __webpack_require__(535);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};/**
                                                                                                                                                                                                                                                                   * 
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * Helpers for navigation.
                                                                                                                                                                                                                                                                   */exports.default=function(navigation){return _extends({},navigation,{goBack:function goBack(key){return navigation.dispatch(_NavigationActions2.default.back({key:key===undefined?navigation.state.key:key}));},navigate:function navigate(routeName,params,action){return navigation.dispatch(_NavigationActions2.default.navigate({routeName:routeName,params:params,action:action}));},/**
     * For updating current route params. For example the nav bar title and
     * buttons are based on the route params.
     * This means `setParams` can be used to update nav bar for example.
     */setParams:function setParams(params){return navigation.dispatch(_NavigationActions2.default.setParams({params:params,key:navigation.state.key}));}});};var _NavigationActions=__webpack_require__(39);var _NavigationActions2=_interopRequireDefault(_NavigationActions);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FFF"},text:{alignSelf:"center",marginBottom:7},mb:{marginBottom:15}});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FFF"}});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";











var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}

var normalizeColor=__webpack_require__(62);

var invariant=__webpack_require__(53);












var linear=function linear(t){return t;};var





Interpolation=function(){function Interpolation(){_classCallCheck(this,Interpolation);}_createClass(Interpolation,null,[{key:'create',value:function create(
config){

if(config.outputRange&&typeof config.outputRange[0]==='string'){
return createInterpolationFromStringOutputRange(config);
}

var outputRange=config.outputRange;
checkInfiniteRange('outputRange',outputRange);

var inputRange=config.inputRange;
checkInfiniteRange('inputRange',inputRange);
checkValidInputRange(inputRange);

invariant(
inputRange.length===outputRange.length,
'inputRange ('+inputRange.length+') and outputRange ('+
outputRange.length+') must have the same length');


var easing=config.easing||linear;

var extrapolateLeft='extend';
if(config.extrapolateLeft!==undefined){
extrapolateLeft=config.extrapolateLeft;
}else if(config.extrapolate!==undefined){
extrapolateLeft=config.extrapolate;
}

var extrapolateRight='extend';
if(config.extrapolateRight!==undefined){
extrapolateRight=config.extrapolateRight;
}else if(config.extrapolate!==undefined){
extrapolateRight=config.extrapolate;
}

return function(input){
invariant(
typeof input==='number',
'Cannot interpolation an input which is not a number');


var range=findRange(input,inputRange);
return interpolate(
input,
inputRange[range],
inputRange[range+1],
outputRange[range],
outputRange[range+1],
easing,
extrapolateLeft,
extrapolateRight);

};
}}]);return Interpolation;}();


function interpolate(
input,
inputMin,
inputMax,
outputMin,
outputMax,
easing,
extrapolateLeft,
extrapolateRight)
{
var result=input;


if(result<inputMin){
if(extrapolateLeft==='identity'){
return result;
}else if(extrapolateLeft==='clamp'){
result=inputMin;
}else if(extrapolateLeft==='extend'){

}
}

if(result>inputMax){
if(extrapolateRight==='identity'){
return result;
}else if(extrapolateRight==='clamp'){
result=inputMax;
}else if(extrapolateRight==='extend'){

}
}

if(outputMin===outputMax){
return outputMin;
}

if(inputMin===inputMax){
if(input<=inputMin){
return outputMin;
}
return outputMax;
}


if(inputMin===-Infinity){
result=-result;
}else if(inputMax===Infinity){
result=result-inputMin;
}else{
result=(result-inputMin)/(inputMax-inputMin);
}


result=easing(result);


if(outputMin===-Infinity){
result=-result;
}else if(outputMax===Infinity){
result=result+outputMin;
}else{
result=result*(outputMax-outputMin)+outputMin;
}

return result;
}

function colorToRgba(input){
var int32Color=normalizeColor(input);
if(int32Color===null){
return input;
}

int32Color=int32Color||0;

var r=(int32Color&0xff000000)>>>24;
var g=(int32Color&0x00ff0000)>>>16;
var b=(int32Color&0x0000ff00)>>>8;
var a=(int32Color&0x000000ff)/255;

return'rgba('+r+', '+g+', '+b+', '+a+')';
}

var stringShapeRegex=/[0-9\.-]+/g;









function createInterpolationFromStringOutputRange(
config)
{
var outputRange=config.outputRange;
invariant(outputRange.length>=2,'Bad output range');
outputRange=outputRange.map(colorToRgba);
checkPattern(outputRange);












var outputRanges=outputRange[0].match(stringShapeRegex).map(function(){return[];});
outputRange.forEach(function(value){



value.match(stringShapeRegex).forEach(function(number,i){
outputRanges[i].push(+number);
});
});




var interpolations=outputRange[0].match(stringShapeRegex).map(function(value,i){
return Interpolation.create(_extends({},
config,{
outputRange:outputRanges[i]}));

});



var shouldRound=/^rgb/.test(outputRange[0]);

return function(input){
var i=0;



return outputRange[0].replace(stringShapeRegex,function(){
var val=interpolations[i++](input);
return String(shouldRound&&i<4?Math.round(val):val);
});
};
}

function checkPattern(arr){
var pattern=arr[0].replace(stringShapeRegex,'');
for(var i=1;i<arr.length;++i){
invariant(
pattern===arr[i].replace(stringShapeRegex,''),
'invalid pattern '+arr[0]+' and '+arr[i]);

}
}

function findRange(input,inputRange){
for(var i=1;i<inputRange.length-1;++i){
if(inputRange[i]>=input){
break;
}
}
return i-1;
}

function checkValidInputRange(arr){
invariant(arr.length>=2,'inputRange must have at least 2 elements');
for(var i=1;i<arr.length;++i){
invariant(
arr[i]>=arr[i-1],






'inputRange must be monotonically increasing '+arr);

}
}

function checkInfiniteRange(name,arr){
invariant(arr.length>=2,name+' must have at least 2 elements');
invariant(
arr.length!==2||arr[0]!==-Infinity||arr[1]!==Infinity,






name+'cannot be ]-infinity;+infinity[ '+arr);

}

module.exports=Interpolation;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var










Animation=function(){function Animation(){_classCallCheck(this,Animation);}_createClass(Animation,[{key:'start',value:function start(




fromValue,
onUpdate,
onEnd,
previousAnimation)
{}},{key:'stop',value:function stop()
{}},{key:'__debouncedOnEnd',value:function __debouncedOnEnd(

result){
var onEnd=this.__onEnd;
this.__onEnd=null;
onEnd&&onEnd(result);
}}]);return Animation;}();


module.exports=Animation;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});function StyleSheetPropType(shape){var createStrictShapeTypeChecker=__webpack_require__(92).default;var StyleSheet=__webpack_require__(9).default;var shapePropType=createStrictShapeTypeChecker(shape);return function(props,propName,componentName,location){var newProps=props;if(props[propName]){newProps={};var flatStyle=StyleSheet.flatten(props[propName]);var nextStyle=Object.keys(flatStyle).reduce(function(acc,curr){if(curr.indexOf('--')!==0){acc[curr]=flatStyle[curr];}return acc;},{});newProps[propName]=nextStyle;}for(var _len=arguments.length,rest=Array(_len>4?_len-4:0),_key=4;_key<_len;_key++){rest[_key-4]=arguments[_key];}return shapePropType.apply(undefined,[newProps,propName,componentName,location].concat(rest));};}exports.default=StyleSheetPropType;

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Button=undefined;var _jsxFileName="src/basic/Button.js";var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);
var _Text=__webpack_require__(29);
var _computeProps=__webpack_require__(23);var _computeProps2=_interopRequireDefault(_computeProps);

var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Button=function(_Component){_inherits(Button,_Component);function Button(){_classCallCheck(this,Button);return _possibleConstructorReturn(this,(Button.__proto__||Object.getPrototypeOf(Button)).apply(this,arguments));}_createClass(Button,[{key:"getInitialStyle",value:function getInitialStyle()





{
return{
borderedBtn:{
borderWidth:this.props.bordered?1:undefined,
borderRadius:this.props.rounded&&this.props.bordered?_platform2.default.borderRadiusLarge:2}};


}},{key:"prepareRootProps",value:function prepareRootProps()



{
var defaultProps={
style:this.getInitialStyle().borderedBtn};


return(0,_computeProps2.default)(this.props,defaultProps);
}},{key:"render",value:function render()
{var _this2=this;
var variables=this.context.theme?this.context.theme["@@shoutem.theme/themeStyle"].variables:_platform2.default;
var children=
_reactNative.Platform.OS==="ios"?
this.props.children:
_react2.default.Children.map(
this.props.children,
function(child){return(
child&&child.type===_Text.Text?
_react2.default.cloneElement(child,_extends({uppercase:true},child.props)):
child);});

if(_reactNative.Platform.OS==="ios"||variables.androidRipple===false||_reactNative.Platform["Version"]<=21){
return(
_react2.default.createElement(_reactNative.TouchableOpacity,_extends({},
this.prepareRootProps(),{
ref:function ref(c){return _this2._root=c;},
activeOpacity:this.props.activeOpacity>0?this.props.activeOpacity:0.5,__source:{fileName:_jsxFileName,lineNumber:49}}),

children));


}else{
return(
_react2.default.createElement(_reactNative.TouchableNativeFeedback,_extends({
ref:function ref(c){return _this2._root=c;},
onPress:this.props.onPress,
background:
this.props.androidRippleColor?
_reactNative.TouchableNativeFeedback.Ripple(this.props.androidRippleColor):
_reactNative.TouchableNativeFeedback.Ripple(variables.androidRippleColor)},

this.prepareRootProps(),{__source:{fileName:_jsxFileName,lineNumber:59}}),

_react2.default.createElement(_reactNative.View,_extends({},this.prepareRootProps(),{__source:{fileName:_jsxFileName,lineNumber:69}}),
children)));



}
}}]);return Button;}(_react.Component);Button.contextTypes={theme:_propTypes2.default.object};


Button.propTypes=_extends({},
_reactNative.TouchableOpacity.propTypes,{
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array]),
block:_propTypes2.default.bool,
primary:_propTypes2.default.bool,
transparent:_propTypes2.default.bool,
success:_propTypes2.default.bool,
danger:_propTypes2.default.bool,
warning:_propTypes2.default.bool,
info:_propTypes2.default.bool,
bordered:_propTypes2.default.bool,
disabled:_propTypes2.default.bool,
rounded:_propTypes2.default.bool,
large:_propTypes2.default.bool,
small:_propTypes2.default.bool,
active:_propTypes2.default.bool});


var StyledButton=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Button",{},_mapPropsToStyleNames2.default)(Button);exports.
Button=StyledButton;
//# sourceMappingURL=Button.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(112),
    baseAssignValue = __webpack_require__(191);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationRoutePropType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavigationStatePropType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SceneRendererPropType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
var NavigationRoutePropType=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({title:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,key:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired});var NavigationStatePropType=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({routes:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(NavigationRoutePropType).isRequired,index:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired});var SceneRendererPropType={layout:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({measured:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,height:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,width:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired}).isRequired,navigationState:NavigationStatePropType.isRequired,position:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_react_native__["Animated"].Value).isRequired,jumpToIndex:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,getLastPosition:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,subscribe:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired};

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FFF"},text:{alignSelf:"center",marginBottom:7},mb:{marginBottom:15}});

/***/ }),
/* 62 */
/***/ (function(module, exports) {

/*
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

function normalizeColor(color) {
  var match;

  if (typeof color === 'number') {
    if (color >>> 0 === color && color >= 0 && color <= 0xffffffff) {
      return color;
    }
    return null;
  }

  // Ordered based on occurrences on Facebook codebase
  if ((match = matchers.hex6.exec(color))) {
    return parseInt(match[1] + 'ff', 16) >>> 0;
  }

  if (names.hasOwnProperty(color)) {
    return names[color];
  }

  if ((match = matchers.rgb.exec(color))) {
    return (
        parse255(match[1]) << 24 | // r
        parse255(match[2]) << 16 | // g
        parse255(match[3]) << 8 | // b
        0x000000ff // a
      ) >>> 0;
  }

  if ((match = matchers.rgba.exec(color))) {
    return (
        parse255(match[1]) << 24 | // r
        parse255(match[2]) << 16 | // g
        parse255(match[3]) << 8 | // b
        parse1(match[4]) // a
      ) >>> 0;
  }

  if ((match = matchers.hex3.exec(color))) {
    return parseInt(
        match[1] + match[1] + // r
        match[2] + match[2] + // g
        match[3] + match[3] + // b
        'ff', // a
        16
      ) >>> 0;
  }

  // https://drafts.csswg.org/css-color-4/#hex-notation
  if ((match = matchers.hex8.exec(color))) {
    return parseInt(match[1], 16) >>> 0;
  }

  if ((match = matchers.hex4.exec(color))) {
    return parseInt(
        match[1] + match[1] + // r
        match[2] + match[2] + // g
        match[3] + match[3] + // b
        match[4] + match[4], // a
        16
      ) >>> 0;
  }

  if ((match = matchers.hsl.exec(color))) {
    return (
        hslToRgb(
          parse360(match[1]), // h
          parsePercentage(match[2]), // s
          parsePercentage(match[3]) // l
        ) |
        0x000000ff // a
      ) >>> 0;
  }

  if ((match = matchers.hsla.exec(color))) {
    return (
        hslToRgb(
          parse360(match[1]), // h
          parsePercentage(match[2]), // s
          parsePercentage(match[3]) // l
        ) |
        parse1(match[4]) // a
      ) >>> 0;
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) {
    t += 1;
  }
  if (t > 1) {
    t -= 1;
  }
  if (t < 1 / 6) {
    return p + (q - p) * 6 * t;
  }
  if (t < 1 / 2) {
    return q;
  }
  if (t < 2 / 3) {
    return p + (q - p) * (2 / 3 - t) * 6;
  }
  return p;
}

function hslToRgb(h, s, l) {
  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  var p = 2 * l - q;
  var r = hue2rgb(p, q, h + 1 / 3);
  var g = hue2rgb(p, q, h);
  var b = hue2rgb(p, q, h - 1 / 3);

  return (
    Math.round(r * 255) << 24 |
    Math.round(g * 255) << 16 |
    Math.round(b * 255) << 8
  );
}

// var INTEGER = '[-+]?\\d+';
var NUMBER = '[-+]?\\d*\\.?\\d+';
var PERCENTAGE = NUMBER + '%';

function toArray(arrayLike) {
  return Array.prototype.slice.call(arrayLike, 0);
}

function call() {
  return '\\(\\s*(' + toArray(arguments).join(')\\s*,\\s*(') + ')\\s*\\)';
}

var matchers = {
  rgb: new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER)),
  rgba: new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER)),
  hsl: new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE)),
  hsla: new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER)),
  hex3: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex4: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#([0-9a-fA-F]{6})$/,
  hex8: /^#([0-9a-fA-F]{8})$/,
};

function parse255(str) {
  var int = parseInt(str, 10);
  if (int < 0) {
    return 0;
  }
  if (int > 255) {
    return 255;
  }
  return int;
}

function parse360(str) {
  var int = parseFloat(str);
  return (((int % 360) + 360) % 360) / 360;
}

function parse1(str) {
  var num = parseFloat(str);
  if (num < 0) {
    return 0;
  }
  if (num > 1) {
    return 255;
  }
  return Math.round(num * 255);
}

function parsePercentage(str) {
  // parseFloat conveniently ignores the final %
  var int = parseFloat(str, 10);
  if (int < 0) {
    return 0;
  }
  if (int > 100) {
    return 1;
  }
  return int / 100;
}

var names = {
  transparent: 0x00000000,

  // http://www.w3.org/TR/css3-color/#svg-color
  aliceblue: 0xf0f8ffff,
  antiquewhite: 0xfaebd7ff,
  aqua: 0x00ffffff,
  aquamarine: 0x7fffd4ff,
  azure: 0xf0ffffff,
  beige: 0xf5f5dcff,
  bisque: 0xffe4c4ff,
  black: 0x000000ff,
  blanchedalmond: 0xffebcdff,
  blue: 0x0000ffff,
  blueviolet: 0x8a2be2ff,
  brown: 0xa52a2aff,
  burlywood: 0xdeb887ff,
  burntsienna: 0xea7e5dff,
  cadetblue: 0x5f9ea0ff,
  chartreuse: 0x7fff00ff,
  chocolate: 0xd2691eff,
  coral: 0xff7f50ff,
  cornflowerblue: 0x6495edff,
  cornsilk: 0xfff8dcff,
  crimson: 0xdc143cff,
  cyan: 0x00ffffff,
  darkblue: 0x00008bff,
  darkcyan: 0x008b8bff,
  darkgoldenrod: 0xb8860bff,
  darkgray: 0xa9a9a9ff,
  darkgreen: 0x006400ff,
  darkgrey: 0xa9a9a9ff,
  darkkhaki: 0xbdb76bff,
  darkmagenta: 0x8b008bff,
  darkolivegreen: 0x556b2fff,
  darkorange: 0xff8c00ff,
  darkorchid: 0x9932ccff,
  darkred: 0x8b0000ff,
  darksalmon: 0xe9967aff,
  darkseagreen: 0x8fbc8fff,
  darkslateblue: 0x483d8bff,
  darkslategray: 0x2f4f4fff,
  darkslategrey: 0x2f4f4fff,
  darkturquoise: 0x00ced1ff,
  darkviolet: 0x9400d3ff,
  deeppink: 0xff1493ff,
  deepskyblue: 0x00bfffff,
  dimgray: 0x696969ff,
  dimgrey: 0x696969ff,
  dodgerblue: 0x1e90ffff,
  firebrick: 0xb22222ff,
  floralwhite: 0xfffaf0ff,
  forestgreen: 0x228b22ff,
  fuchsia: 0xff00ffff,
  gainsboro: 0xdcdcdcff,
  ghostwhite: 0xf8f8ffff,
  gold: 0xffd700ff,
  goldenrod: 0xdaa520ff,
  gray: 0x808080ff,
  green: 0x008000ff,
  greenyellow: 0xadff2fff,
  grey: 0x808080ff,
  honeydew: 0xf0fff0ff,
  hotpink: 0xff69b4ff,
  indianred: 0xcd5c5cff,
  indigo: 0x4b0082ff,
  ivory: 0xfffff0ff,
  khaki: 0xf0e68cff,
  lavender: 0xe6e6faff,
  lavenderblush: 0xfff0f5ff,
  lawngreen: 0x7cfc00ff,
  lemonchiffon: 0xfffacdff,
  lightblue: 0xadd8e6ff,
  lightcoral: 0xf08080ff,
  lightcyan: 0xe0ffffff,
  lightgoldenrodyellow: 0xfafad2ff,
  lightgray: 0xd3d3d3ff,
  lightgreen: 0x90ee90ff,
  lightgrey: 0xd3d3d3ff,
  lightpink: 0xffb6c1ff,
  lightsalmon: 0xffa07aff,
  lightseagreen: 0x20b2aaff,
  lightskyblue: 0x87cefaff,
  lightslategray: 0x778899ff,
  lightslategrey: 0x778899ff,
  lightsteelblue: 0xb0c4deff,
  lightyellow: 0xffffe0ff,
  lime: 0x00ff00ff,
  limegreen: 0x32cd32ff,
  linen: 0xfaf0e6ff,
  magenta: 0xff00ffff,
  maroon: 0x800000ff,
  mediumaquamarine: 0x66cdaaff,
  mediumblue: 0x0000cdff,
  mediumorchid: 0xba55d3ff,
  mediumpurple: 0x9370dbff,
  mediumseagreen: 0x3cb371ff,
  mediumslateblue: 0x7b68eeff,
  mediumspringgreen: 0x00fa9aff,
  mediumturquoise: 0x48d1ccff,
  mediumvioletred: 0xc71585ff,
  midnightblue: 0x191970ff,
  mintcream: 0xf5fffaff,
  mistyrose: 0xffe4e1ff,
  moccasin: 0xffe4b5ff,
  navajowhite: 0xffdeadff,
  navy: 0x000080ff,
  oldlace: 0xfdf5e6ff,
  olive: 0x808000ff,
  olivedrab: 0x6b8e23ff,
  orange: 0xffa500ff,
  orangered: 0xff4500ff,
  orchid: 0xda70d6ff,
  palegoldenrod: 0xeee8aaff,
  palegreen: 0x98fb98ff,
  paleturquoise: 0xafeeeeff,
  palevioletred: 0xdb7093ff,
  papayawhip: 0xffefd5ff,
  peachpuff: 0xffdab9ff,
  peru: 0xcd853fff,
  pink: 0xffc0cbff,
  plum: 0xdda0ddff,
  powderblue: 0xb0e0e6ff,
  purple: 0x800080ff,
  rebeccapurple: 0x663399ff,
  red: 0xff0000ff,
  rosybrown: 0xbc8f8fff,
  royalblue: 0x4169e1ff,
  saddlebrown: 0x8b4513ff,
  salmon: 0xfa8072ff,
  sandybrown: 0xf4a460ff,
  seagreen: 0x2e8b57ff,
  seashell: 0xfff5eeff,
  sienna: 0xa0522dff,
  silver: 0xc0c0c0ff,
  skyblue: 0x87ceebff,
  slateblue: 0x6a5acdff,
  slategray: 0x708090ff,
  slategrey: 0x708090ff,
  snow: 0xfffafaff,
  springgreen: 0x00ff7fff,
  steelblue: 0x4682b4ff,
  tan: 0xd2b48cff,
  teal: 0x008080ff,
  thistle: 0xd8bfd8ff,
  tomato: 0xff6347ff,
  turquoise: 0x40e0d0ff,
  violet: 0xee82eeff,
  wheat: 0xf5deb3ff,
  white: 0xffffffff,
  whitesmoke: 0xf5f5f5ff,
  yellow: 0xffff00ff,
  yellowgreen: 0x9acd32ff,
};

function rgba(colorInt) {
  var r = Math.round(((colorInt & 0xff000000) >>> 24));
  var g = Math.round(((colorInt & 0x00ff0000) >>> 16));
  var b = Math.round(((colorInt & 0x0000ff00) >>> 8));
  var a = ((colorInt & 0x000000ff) >>> 0) / 255;
  return {
    r: r,
    g: g,
    b: b,
    a: a,
  };
};

normalizeColor.rgba = rgba;

module.exports = normalizeColor;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var Animated=__webpack_require__(13);
var AnimatedWithChildren=__webpack_require__(22);
var invariant=__webpack_require__(53);
var Interpolation=__webpack_require__(54);
var guid=__webpack_require__(91);var



AnimatedInterpolation=function(_AnimatedWithChildren){_inherits(AnimatedInterpolation,_AnimatedWithChildren);





function AnimatedInterpolation(parent,interpolation){_classCallCheck(this,AnimatedInterpolation);var _this=_possibleConstructorReturn(this,(AnimatedInterpolation.__proto__||Object.getPrototypeOf(AnimatedInterpolation)).call(this));

_this._parent=parent;
_this._interpolation=interpolation;
_this._listeners={};return _this;
}_createClass(AnimatedInterpolation,[{key:'__getValue',value:function __getValue()

{
var parentValue=this._parent.__getValue();
invariant(
typeof parentValue==='number',
'Cannot interpolate an input which is not a number.');

return this._interpolation(parentValue);
}},{key:'addListener',value:function addListener(

callback){var _this2=this;
if(!this._parentListener){
this._parentListener=this._parent.addListener(function(){
for(var key in _this2._listeners){
_this2._listeners[key]({value:_this2.__getValue()});
}
});
}
var id=guid();
this._listeners[id]=callback;
return id;
}},{key:'removeListener',value:function removeListener(

id){
delete this._listeners[id];
}},{key:'interpolate',value:function interpolate(

config){
return new AnimatedInterpolation(this,Interpolation.create(config));
}},{key:'__attach',value:function __attach()

{
this._parent.__addChild(this);
}},{key:'__detach',value:function __detach()

{
this._parent.__removeChild(this);
this._parentListener=this._parent.removeListener(this._parentListener);
}}]);return AnimatedInterpolation;}(AnimatedWithChildren);


module.exports=AnimatedInterpolation;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {











var RequestAnimationFrame={
current:function current(cb){return global.requestAnimationFrame(cb);},
inject:function inject(injected){
RequestAnimationFrame.current=injected;
}};


module.exports=RequestAnimationFrame;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {











var CancelAnimationFrame={
current:function current(id){return global.cancelAnimationFrame(id);},
inject:function inject(injected){
CancelAnimationFrame.current=injected;
}};


module.exports=CancelAnimationFrame;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='src/components/ScrollView/index.js';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createReactClass=__webpack_require__(28);var _createReactClass2=_interopRequireDefault(_createReactClass);var _dismissKeyboard=__webpack_require__(169);var _dismissKeyboard2=_interopRequireDefault(_dismissKeyboard);var _findNodeHandle=__webpack_require__(42);var _findNodeHandle2=_interopRequireDefault(_findNodeHandle);var _invariant=__webpack_require__(8);var _invariant2=_interopRequireDefault(_invariant);var _ScrollResponder=__webpack_require__(342);var _ScrollResponder2=_interopRequireDefault(_ScrollResponder);var _ScrollViewBase=__webpack_require__(343);var _ScrollViewBase2=_interopRequireDefault(_ScrollViewBase);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _StyleSheetPropType=__webpack_require__(56);var _StyleSheetPropType2=_interopRequireDefault(_StyleSheetPropType);var _View=__webpack_require__(11);var _View2=_interopRequireDefault(_View);var _ViewPropTypes=__webpack_require__(15);var _ViewPropTypes2=_interopRequireDefault(_ViewPropTypes);var _ViewStylePropTypes=__webpack_require__(97);var _ViewStylePropTypes2=_interopRequireDefault(_ViewStylePropTypes);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var emptyObject={};var ScrollView=(0,_createReactClass2.default)({propTypes:_extends({},_ViewPropTypes2.default,{contentContainerStyle:(0,_StyleSheetPropType2.default)(_ViewStylePropTypes2.default),horizontal:_propTypes.bool,keyboardDismissMode:(0,_propTypes.oneOf)(['none','interactive','on-drag']),onContentSizeChange:_propTypes.func,onScroll:_propTypes.func,pagingEnabled:_propTypes.bool,refreshControl:_propTypes.element,scrollEnabled:_propTypes.bool,scrollEventThrottle:_propTypes.number,style:(0,_StyleSheetPropType2.default)(_ViewStylePropTypes2.default)}),mixins:[_ScrollResponder2.default.Mixin],getInitialState:function getInitialState(){return this.scrollResponderMixinGetInitialState();},setNativeProps:function setNativeProps(props){this._scrollViewRef.setNativeProps(props);},getScrollResponder:function getScrollResponder(){return this;},getScrollableNode:function getScrollableNode(){return(0,_findNodeHandle2.default)(this._scrollViewRef);},getInnerViewNode:function getInnerViewNode(){return(0,_findNodeHandle2.default)(this._innerViewRef);},scrollTo:function scrollTo(y,x,animated){if(typeof y==='number'){console.warn('`scrollTo(y, x, animated)` is deprecated. Use `scrollTo({x: 5, y: 5, animated: true})` instead.');}else{var _ref=y||emptyObject;x=_ref.x;y=_ref.y;animated=_ref.animated;}this.getScrollResponder().scrollResponderScrollTo({x:x||0,y:y||0,animated:animated!==false});},scrollToEnd:function scrollToEnd(options){var animated=(options&&options.animated)!==false;var horizontal=this.props.horizontal;var scrollResponder=this.getScrollResponder();var scrollResponderNode=scrollResponder.scrollResponderGetScrollableNode();var x=horizontal?scrollResponderNode.scrollWidth:0;var y=horizontal?0:scrollResponderNode.scrollHeight;scrollResponder.scrollResponderScrollTo({x:x,y:y,animated:animated});},scrollWithoutAnimationTo:function scrollWithoutAnimationTo(){var y=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var x=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;console.warn('`scrollWithoutAnimationTo` is deprecated. Use `scrollTo` instead');this.scrollTo({x:x,y:y,animated:false});},render:function render(){var _props=this.props,contentContainerStyle=_props.contentContainerStyle,horizontal=_props.horizontal,onContentSizeChange=_props.onContentSizeChange,refreshControl=_props.refreshControl,keyboardDismissMode=_props.keyboardDismissMode,onScroll=_props.onScroll,pagingEnabled=_props.pagingEnabled,stickyHeaderIndices=_props.stickyHeaderIndices,other=_objectWithoutProperties(_props,['contentContainerStyle','horizontal','onContentSizeChange','refreshControl','keyboardDismissMode','onScroll','pagingEnabled','stickyHeaderIndices']);if(false){var style=_StyleSheet2.default.flatten(this.props.style);var childLayoutProps=['alignItems','justifyContent'].filter(function(prop){return style&&style[prop]!==undefined;});(0,_invariant2.default)(childLayoutProps.length===0,'ScrollView child layout ('+JSON.stringify(childLayoutProps)+') '+'must be applied through the contentContainerStyle prop.');}var contentSizeChangeProps={};if(onContentSizeChange){contentSizeChangeProps={onLayout:this._handleContentOnLayout};}var contentContainer=_react2.default.createElement(_View2.default,_extends({},contentSizeChangeProps,{children:this.props.children,collapsable:false,ref:this._setInnerViewRef,style:[horizontal&&styles.contentContainerHorizontal,contentContainerStyle],__source:{fileName:_jsxFileName,lineNumber:165}}));var props=_extends({},other,{style:[styles.base,horizontal&&styles.baseHorizontal,this.props.style],onTouchStart:this.scrollResponderHandleTouchStart,onTouchMove:this.scrollResponderHandleTouchMove,onTouchEnd:this.scrollResponderHandleTouchEnd,onScrollBeginDrag:this.scrollResponderHandleScrollBeginDrag,onScrollEndDrag:this.scrollResponderHandleScrollEndDrag,onMomentumScrollBegin:this.scrollResponderHandleMomentumScrollBegin,onMomentumScrollEnd:this.scrollResponderHandleMomentumScrollEnd,onStartShouldSetResponder:this.scrollResponderHandleStartShouldSetResponder,onStartShouldSetResponderCapture:this.scrollResponderHandleStartShouldSetResponderCapture,onScrollShouldSetResponder:this.scrollResponderHandleScrollShouldSetResponder,onScroll:this._handleScroll,onResponderGrant:this.scrollResponderHandleResponderGrant,onResponderTerminationRequest:this.scrollResponderHandleTerminationRequest,onResponderTerminate:this.scrollResponderHandleTerminate,onResponderRelease:this.scrollResponderHandleResponderRelease,onResponderReject:this.scrollResponderHandleResponderReject});var ScrollViewClass=_ScrollViewBase2.default;(0,_invariant2.default)(ScrollViewClass!==undefined,'ScrollViewClass must not be undefined');if(refreshControl){return _react2.default.cloneElement(refreshControl,{style:props.style},_react2.default.createElement(ScrollViewClass,_extends({},props,{ref:this._setScrollViewRef,style:styles.base,__source:{fileName:_jsxFileName,lineNumber:203}}),contentContainer));}return _react2.default.createElement(ScrollViewClass,_extends({},props,{ref:this._setScrollViewRef,style:props.style,__source:{fileName:_jsxFileName,lineNumber:210}}),contentContainer);},_handleContentOnLayout:function _handleContentOnLayout(e){var _e$nativeEvent$layout=e.nativeEvent.layout,width=_e$nativeEvent$layout.width,height=_e$nativeEvent$layout.height;this.props.onContentSizeChange(width,height);},_handleScroll:function _handleScroll(e){if(false){if(this.props.onScroll&&!this.props.scrollEventThrottle){console.log('You specified `onScroll` on a <ScrollView> but not '+'`scrollEventThrottle`. You will only receive one event. '+'Using `16` you get all the events but be aware that it may '+"cause frame drops, use a bigger number if you don't need as "+'much precision.');}}if(this.props.keyboardDismissMode==='on-drag'){(0,_dismissKeyboard2.default)();}this.scrollResponderHandleScroll(e);},_setInnerViewRef:function _setInnerViewRef(component){this._innerViewRef=component;},_setScrollViewRef:function _setScrollViewRef(component){this._scrollViewRef=component;}});var styles=_StyleSheet2.default.create({base:{flex:1,overflowX:'hidden',overflowY:'auto',WebkitOverflowScrolling:'touch',transform:[{translateZ:0}]},baseHorizontal:{flexDirection:'row',overflowX:'auto',overflowY:'hidden'},contentContainerHorizontal:{flexDirection:'row'}});exports.default=ScrollView;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _ExecutionEnvironment=__webpack_require__(16);var _debounce=__webpack_require__(94);var _debounce2=_interopRequireDefault(_debounce);var _invariant=__webpack_require__(8);var _invariant2=_interopRequireDefault(_invariant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var win=_ExecutionEnvironment.canUseDOM?window:{devicePixelRatio:undefined,innerHeight:undefined,innerWidth:undefined,screen:{height:undefined,width:undefined}};var dimensions={};var listeners={};var Dimensions=function(){function Dimensions(){_classCallCheck(this,Dimensions);}_createClass(Dimensions,null,[{key:'get',value:function get(dimension){(0,_invariant2.default)(dimensions[dimension],'No dimension set for key '+dimension);return dimensions[dimension];}},{key:'set',value:function set(initialDimensions){if(initialDimensions){if(_ExecutionEnvironment.canUseDOM){(0,_invariant2.default)(false,'Dimensions cannot be set in the browser');}else{dimensions.screen=initialDimensions.screen;dimensions.window=initialDimensions.window;}}}},{key:'_update',value:function _update(){dimensions.window={fontScale:1,height:win.innerHeight,scale:win.devicePixelRatio||1,width:win.innerWidth};dimensions.screen={fontScale:1,height:win.screen.height,scale:win.devicePixelRatio||1,width:win.screen.width};if(Array.isArray(listeners['change'])){listeners['change'].forEach(function(handler){return handler(dimensions);});}}},{key:'addEventListener',value:function addEventListener(type,handler){listeners[type]=listeners[type]||[];listeners[type].push(handler);}},{key:'removeEventListener',value:function removeEventListener(type,handler){if(Array.isArray(listeners[type])){listeners[type]=listeners[type].filter(function(_handler){return _handler!==handler;});}}}]);return Dimensions;}();exports.default=Dimensions;Dimensions._update();if(_ExecutionEnvironment.canUseDOM){window.addEventListener('resize',(0,_debounce2.default)(Dimensions._update,16),false);}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(27);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='src/components/Touchable/Touchable.js';var _AccessibilityUtil=__webpack_require__(87);var _AccessibilityUtil2=_interopRequireDefault(_AccessibilityUtil);var _BoundingDimensions=__webpack_require__(364);var _BoundingDimensions2=_interopRequireDefault(_BoundingDimensions);var _findNodeHandle=__webpack_require__(42);var _findNodeHandle2=_interopRequireDefault(_findNodeHandle);var _normalizeCssColor=__webpack_require__(62);var _normalizeCssColor2=_interopRequireDefault(_normalizeCssColor);var _Position=__webpack_require__(365);var _Position2=_interopRequireDefault(_Position);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _TouchEventUtils=__webpack_require__(366);var _TouchEventUtils2=_interopRequireDefault(_TouchEventUtils);var _UIManager=__webpack_require__(43);var _UIManager2=_interopRequireDefault(_UIManager);var _View=__webpack_require__(11);var _View2=_interopRequireDefault(_View);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var States={NOT_RESPONDER:'NOT_RESPONDER',RESPONDER_INACTIVE_PRESS_IN:'RESPONDER_INACTIVE_PRESS_IN',RESPONDER_INACTIVE_PRESS_OUT:'RESPONDER_INACTIVE_PRESS_OUT',RESPONDER_ACTIVE_PRESS_IN:'RESPONDER_ACTIVE_PRESS_IN',RESPONDER_ACTIVE_PRESS_OUT:'RESPONDER_ACTIVE_PRESS_OUT',RESPONDER_ACTIVE_LONG_PRESS_IN:'RESPONDER_ACTIVE_LONG_PRESS_IN',RESPONDER_ACTIVE_LONG_PRESS_OUT:'RESPONDER_ACTIVE_LONG_PRESS_OUT',ERROR:'ERROR'};var IsActive={RESPONDER_ACTIVE_PRESS_OUT:true,RESPONDER_ACTIVE_PRESS_IN:true};var IsPressingIn={RESPONDER_INACTIVE_PRESS_IN:true,RESPONDER_ACTIVE_PRESS_IN:true,RESPONDER_ACTIVE_LONG_PRESS_IN:true};var IsLongPressingIn={RESPONDER_ACTIVE_LONG_PRESS_IN:true};var Signals={DELAY:'DELAY',RESPONDER_GRANT:'RESPONDER_GRANT',RESPONDER_RELEASE:'RESPONDER_RELEASE',RESPONDER_TERMINATED:'RESPONDER_TERMINATED',ENTER_PRESS_RECT:'ENTER_PRESS_RECT',LEAVE_PRESS_RECT:'LEAVE_PRESS_RECT',LONG_PRESS_DETECTED:'LONG_PRESS_DETECTED'};var Transitions={NOT_RESPONDER:{DELAY:States.ERROR,RESPONDER_GRANT:States.RESPONDER_INACTIVE_PRESS_IN,RESPONDER_RELEASE:States.ERROR,RESPONDER_TERMINATED:States.ERROR,ENTER_PRESS_RECT:States.ERROR,LEAVE_PRESS_RECT:States.ERROR,LONG_PRESS_DETECTED:States.ERROR},RESPONDER_INACTIVE_PRESS_IN:{DELAY:States.RESPONDER_ACTIVE_PRESS_IN,RESPONDER_GRANT:States.ERROR,RESPONDER_RELEASE:States.NOT_RESPONDER,RESPONDER_TERMINATED:States.NOT_RESPONDER,ENTER_PRESS_RECT:States.RESPONDER_INACTIVE_PRESS_IN,LEAVE_PRESS_RECT:States.RESPONDER_INACTIVE_PRESS_OUT,LONG_PRESS_DETECTED:States.ERROR},RESPONDER_INACTIVE_PRESS_OUT:{DELAY:States.RESPONDER_ACTIVE_PRESS_OUT,RESPONDER_GRANT:States.ERROR,RESPONDER_RELEASE:States.NOT_RESPONDER,RESPONDER_TERMINATED:States.NOT_RESPONDER,ENTER_PRESS_RECT:States.RESPONDER_INACTIVE_PRESS_IN,LEAVE_PRESS_RECT:States.RESPONDER_INACTIVE_PRESS_OUT,LONG_PRESS_DETECTED:States.ERROR},RESPONDER_ACTIVE_PRESS_IN:{DELAY:States.ERROR,RESPONDER_GRANT:States.ERROR,RESPONDER_RELEASE:States.NOT_RESPONDER,RESPONDER_TERMINATED:States.NOT_RESPONDER,ENTER_PRESS_RECT:States.RESPONDER_ACTIVE_PRESS_IN,LEAVE_PRESS_RECT:States.RESPONDER_ACTIVE_PRESS_OUT,LONG_PRESS_DETECTED:States.RESPONDER_ACTIVE_LONG_PRESS_IN},RESPONDER_ACTIVE_PRESS_OUT:{DELAY:States.ERROR,RESPONDER_GRANT:States.ERROR,RESPONDER_RELEASE:States.NOT_RESPONDER,RESPONDER_TERMINATED:States.NOT_RESPONDER,ENTER_PRESS_RECT:States.RESPONDER_ACTIVE_PRESS_IN,LEAVE_PRESS_RECT:States.RESPONDER_ACTIVE_PRESS_OUT,LONG_PRESS_DETECTED:States.ERROR},RESPONDER_ACTIVE_LONG_PRESS_IN:{DELAY:States.ERROR,RESPONDER_GRANT:States.ERROR,RESPONDER_RELEASE:States.NOT_RESPONDER,RESPONDER_TERMINATED:States.NOT_RESPONDER,ENTER_PRESS_RECT:States.RESPONDER_ACTIVE_LONG_PRESS_IN,LEAVE_PRESS_RECT:States.RESPONDER_ACTIVE_LONG_PRESS_OUT,LONG_PRESS_DETECTED:States.RESPONDER_ACTIVE_LONG_PRESS_IN},RESPONDER_ACTIVE_LONG_PRESS_OUT:{DELAY:States.ERROR,RESPONDER_GRANT:States.ERROR,RESPONDER_RELEASE:States.NOT_RESPONDER,RESPONDER_TERMINATED:States.NOT_RESPONDER,ENTER_PRESS_RECT:States.RESPONDER_ACTIVE_LONG_PRESS_IN,LEAVE_PRESS_RECT:States.RESPONDER_ACTIVE_LONG_PRESS_OUT,LONG_PRESS_DETECTED:States.ERROR},error:{DELAY:States.NOT_RESPONDER,RESPONDER_GRANT:States.RESPONDER_INACTIVE_PRESS_IN,RESPONDER_RELEASE:States.NOT_RESPONDER,RESPONDER_TERMINATED:States.NOT_RESPONDER,ENTER_PRESS_RECT:States.NOT_RESPONDER,LEAVE_PRESS_RECT:States.NOT_RESPONDER,LONG_PRESS_DETECTED:States.NOT_RESPONDER}};var HIGHLIGHT_DELAY_MS=130;var PRESS_EXPAND_PX=20;var LONG_PRESS_THRESHOLD=500;var LONG_PRESS_DELAY_MS=LONG_PRESS_THRESHOLD-HIGHLIGHT_DELAY_MS;var LONG_PRESS_ALLOWED_MOVEMENT=10;var TouchableMixin={componentDidMount:function componentDidMount(){var _this=this;this._touchableNode=(0,_findNodeHandle2.default)(this);this._touchableBlurListener=function(e){if(_this._isTouchableKeyboardActive){if(_this.state.touchable.touchState&&_this.state.touchable.touchState!==States.NOT_RESPONDER){_this.touchableHandleResponderTerminate({nativeEvent:e});}_this._isTouchableKeyboardActive=false;}};this._touchableNode.addEventListener('blur',this._touchableBlurListener);},componentWillUnmount:function componentWillUnmount(){this._touchableNode.removeEventListener('blur',this._touchableBlurListener);this.touchableDelayTimeout&&clearTimeout(this.touchableDelayTimeout);this.longPressDelayTimeout&&clearTimeout(this.longPressDelayTimeout);this.pressOutDelayTimeout&&clearTimeout(this.pressOutDelayTimeout);},touchableGetInitialState:function touchableGetInitialState(){return{touchable:{touchState:undefined,responderID:null}};},touchableHandleResponderTerminationRequest:function touchableHandleResponderTerminationRequest(){return!this.props.rejectResponderTermination;},touchableHandleStartShouldSetResponder:function touchableHandleStartShouldSetResponder(){return!this.props.disabled;},touchableLongPressCancelsPress:function touchableLongPressCancelsPress(){return true;},touchableHandleResponderGrant:function touchableHandleResponderGrant(e){var dispatchID=e.currentTarget;e.persist();this.pressOutDelayTimeout&&clearTimeout(this.pressOutDelayTimeout);this.pressOutDelayTimeout=null;this.state.touchable.touchState=States.NOT_RESPONDER;this.state.touchable.responderID=dispatchID;this._receiveSignal(Signals.RESPONDER_GRANT,e);var delayMS=this.touchableGetHighlightDelayMS!==undefined?Math.max(this.touchableGetHighlightDelayMS(),0):HIGHLIGHT_DELAY_MS;delayMS=isNaN(delayMS)?HIGHLIGHT_DELAY_MS:delayMS;if(delayMS!==0){this.touchableDelayTimeout=setTimeout(this._handleDelay.bind(this,e),delayMS);}else{this.state.touchable.positionOnActivate=null;this._handleDelay(e);}var longDelayMS=this.touchableGetLongPressDelayMS!==undefined?Math.max(this.touchableGetLongPressDelayMS(),10):LONG_PRESS_DELAY_MS;longDelayMS=isNaN(longDelayMS)?LONG_PRESS_DELAY_MS:longDelayMS;this.longPressDelayTimeout=setTimeout(this._handleLongDelay.bind(this,e),longDelayMS+delayMS);},touchableHandleResponderRelease:function touchableHandleResponderRelease(e){this._receiveSignal(Signals.RESPONDER_RELEASE,e);if(e.cancelable&&!e.isDefaultPrevented()){e.preventDefault();}},touchableHandleResponderTerminate:function touchableHandleResponderTerminate(e){this._receiveSignal(Signals.RESPONDER_TERMINATED,e);},touchableHandleResponderMove:function touchableHandleResponderMove(e){if(this.state.touchable.touchState===States.RESPONDER_INACTIVE_PRESS_IN){return;}if(!this.state.touchable.positionOnActivate){return;}var positionOnActivate=this.state.touchable.positionOnActivate;var dimensionsOnActivate=this.state.touchable.dimensionsOnActivate;var pressRectOffset=this.touchableGetPressRectOffset?this.touchableGetPressRectOffset():{left:PRESS_EXPAND_PX,right:PRESS_EXPAND_PX,top:PRESS_EXPAND_PX,bottom:PRESS_EXPAND_PX};var pressExpandLeft=pressRectOffset.left;var pressExpandTop=pressRectOffset.top;var pressExpandRight=pressRectOffset.right;var pressExpandBottom=pressRectOffset.bottom;var hitSlop=this.touchableGetHitSlop?this.touchableGetHitSlop():null;if(hitSlop){pressExpandLeft+=hitSlop.left;pressExpandTop+=hitSlop.top;pressExpandRight+=hitSlop.right;pressExpandBottom+=hitSlop.bottom;}var touch=_TouchEventUtils2.default.extractSingleTouch(e.nativeEvent);var pageX=touch&&touch.pageX;var pageY=touch&&touch.pageY;if(this.pressInLocation){var movedDistance=this._getDistanceBetweenPoints(pageX,pageY,this.pressInLocation.pageX,this.pressInLocation.pageY);if(movedDistance>LONG_PRESS_ALLOWED_MOVEMENT){this._cancelLongPressDelayTimeout();}}var isTouchWithinActive=pageX>positionOnActivate.left-pressExpandLeft&&pageY>positionOnActivate.top-pressExpandTop&&pageX<positionOnActivate.left+dimensionsOnActivate.width+pressExpandRight&&pageY<positionOnActivate.top+dimensionsOnActivate.height+pressExpandBottom;if(isTouchWithinActive){this._receiveSignal(Signals.ENTER_PRESS_RECT,e);var curState=this.state.touchable.touchState;if(curState===States.RESPONDER_INACTIVE_PRESS_IN){this._cancelLongPressDelayTimeout();}}else{this._cancelLongPressDelayTimeout();this._receiveSignal(Signals.LEAVE_PRESS_RECT,e);}},_remeasureMetricsOnActivation:function _remeasureMetricsOnActivation(){var tag=this.state.touchable.responderID;if(tag==null){return;}_UIManager2.default.measure(tag,this._handleQueryLayout);},_handleQueryLayout:function _handleQueryLayout(x,y,width,height,globalX,globalY){if(!x&&!y&&!width&&!height&&!globalX&&!globalY){return;}this.state.touchable.positionOnActivate&&_Position2.default.release(this.state.touchable.positionOnActivate);this.state.touchable.dimensionsOnActivate&&_BoundingDimensions2.default.release(this.state.touchable.dimensionsOnActivate);this.state.touchable.positionOnActivate=_Position2.default.getPooled(globalX,globalY);this.state.touchable.dimensionsOnActivate=_BoundingDimensions2.default.getPooled(width,height);},_handleDelay:function _handleDelay(e){this.touchableDelayTimeout=null;this._receiveSignal(Signals.DELAY,e);},_handleLongDelay:function _handleLongDelay(e){this.longPressDelayTimeout=null;var curState=this.state.touchable.touchState;if(curState!==States.RESPONDER_ACTIVE_PRESS_IN&&curState!==States.RESPONDER_ACTIVE_LONG_PRESS_IN){console.error('Attempted to transition from state `'+curState+'` to `'+States.RESPONDER_ACTIVE_LONG_PRESS_IN+'`, which is not supported. This is '+'most likely due to `Touchable.longPressDelayTimeout` not being cancelled.');}else{this._receiveSignal(Signals.LONG_PRESS_DETECTED,e);}},_receiveSignal:function _receiveSignal(signal,e){var responderID=this.state.touchable.responderID;var curState=this.state.touchable.touchState;var nextState=Transitions[curState]&&Transitions[curState][signal];if(!responderID&&signal===Signals.RESPONDER_RELEASE){return;}if(!nextState){throw new Error('Unrecognized signal `'+signal+'` or state `'+curState+'` for Touchable responder `'+responderID+'`');}if(nextState===States.ERROR){throw new Error('Touchable cannot transition from `'+curState+'` to `'+signal+'` for responder `'+responderID+'`');}if(curState!==nextState){this._performSideEffectsForTransition(curState,nextState,signal,e);this.state.touchable.touchState=nextState;}},_cancelLongPressDelayTimeout:function _cancelLongPressDelayTimeout(){this.longPressDelayTimeout&&clearTimeout(this.longPressDelayTimeout);this.longPressDelayTimeout=null;},_isHighlight:function _isHighlight(state){return state===States.RESPONDER_ACTIVE_PRESS_IN||state===States.RESPONDER_ACTIVE_LONG_PRESS_IN;},_savePressInLocation:function _savePressInLocation(e){var touch=_TouchEventUtils2.default.extractSingleTouch(e.nativeEvent);var pageX=touch&&touch.pageX;var pageY=touch&&touch.pageY;var locationX=touch&&touch.locationX;var locationY=touch&&touch.locationY;this.pressInLocation={pageX:pageX,pageY:pageY,locationX:locationX,locationY:locationY};},_getDistanceBetweenPoints:function _getDistanceBetweenPoints(aX,aY,bX,bY){var deltaX=aX-bX;var deltaY=aY-bY;return Math.sqrt(deltaX*deltaX+deltaY*deltaY);},_performSideEffectsForTransition:function _performSideEffectsForTransition(curState,nextState,signal,e){var curIsHighlight=this._isHighlight(curState);var newIsHighlight=this._isHighlight(nextState);var isFinalSignal=signal===Signals.RESPONDER_TERMINATED||signal===Signals.RESPONDER_RELEASE;if(isFinalSignal){this._cancelLongPressDelayTimeout();}if(!IsActive[curState]&&IsActive[nextState]){this._remeasureMetricsOnActivation();}if(IsPressingIn[curState]&&signal===Signals.LONG_PRESS_DETECTED){this.touchableHandleLongPress&&this.touchableHandleLongPress(e);}if(newIsHighlight&&!curIsHighlight){this._startHighlight(e);}else if(!newIsHighlight&&curIsHighlight){this._endHighlight(e);}if(IsPressingIn[curState]&&signal===Signals.RESPONDER_RELEASE){var hasLongPressHandler=!!this.props.onLongPress;var pressIsLongButStillCallOnPress=IsLongPressingIn[curState]&&(!hasLongPressHandler||!this.touchableLongPressCancelsPress());var shouldInvokePress=!IsLongPressingIn[curState]||pressIsLongButStillCallOnPress;if(shouldInvokePress&&this.touchableHandlePress){if(!newIsHighlight&&!curIsHighlight){this._startHighlight(e);this._endHighlight(e);}this.touchableHandlePress(e);}}this.touchableDelayTimeout&&clearTimeout(this.touchableDelayTimeout);this.touchableDelayTimeout=null;},_startHighlight:function _startHighlight(e){this._savePressInLocation(e);this.touchableHandleActivePressIn&&this.touchableHandleActivePressIn(e);},_endHighlight:function _endHighlight(e){var _this2=this;if(this.touchableHandleActivePressOut){if(this.touchableGetPressOutDelayMS&&this.touchableGetPressOutDelayMS()){this.pressOutDelayTimeout=setTimeout(function(){_this2.touchableHandleActivePressOut(e);},this.touchableGetPressOutDelayMS());}else{this.touchableHandleActivePressOut(e);}}},touchableHandleKeyEvent:function touchableHandleKeyEvent(e){var ENTER=13;var SPACE=32;var type=e.type,which=e.which;if(which===ENTER||which===SPACE){if(type==='keydown'){if(!this._isTouchableKeyboardActive){if(!this.state.touchable.touchState||this.state.touchable.touchState===States.NOT_RESPONDER){this.touchableHandleResponderGrant(e);this._isTouchableKeyboardActive=true;}}}else if(type==='keyup'){if(this._isTouchableKeyboardActive){if(this.state.touchable.touchState&&this.state.touchable.touchState!==States.NOT_RESPONDER){this.touchableHandleResponderRelease(e);this._isTouchableKeyboardActive=false;}}}e.stopPropagation();if(!(which===ENTER&&_AccessibilityUtil2.default.propsToAriaRole(this.props)==='link')){e.preventDefault();}}}};var Touchable={Mixin:TouchableMixin,TOUCH_TARGET_DEBUG:false,renderDebugView:function renderDebugView(_ref){var color=_ref.color,hitSlop=_ref.hitSlop;if(false){if(!Touchable.TOUCH_TARGET_DEBUG){return null;}var debugHitSlopStyle={};hitSlop=hitSlop||{top:0,bottom:0,left:0,right:0};for(var key in hitSlop){debugHitSlopStyle[key]=-hitSlop[key];}var hexColor='#'+('00000000'+(0,_normalizeCssColor2.default)(color).toString(16)).substr(-8);return _react2.default.createElement(_View2.default,{pointerEvents:'none',style:_extends({position:'absolute',borderColor:hexColor.slice(0,-2)+'55',borderWidth:1,borderStyle:'dashed',backgroundColor:hexColor.slice(0,-2)+'0F'},debugHitSlopStyle),__source:{fileName:_jsxFileName,lineNumber:850}});}}};exports.default=Touchable;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Left=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Left.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Left=function(_Component){_inherits(Left,_Component);function Left(){_classCallCheck(this,Left);return _possibleConstructorReturn(this,(Left.__proto__||Object.getPrototypeOf(Left)).apply(this,arguments));}_createClass(Left,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:11}}));
}}]);return Left;}(_react.Component);


Left.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledLeft=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Left",{},_mapPropsToStyleNames2.default)(Left);exports.

Left=StyledLeft;
//# sourceMappingURL=Left.js.map

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Right=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Right.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Right=function(_Component){_inherits(Right,_Component);function Right(){_classCallCheck(this,Right);return _possibleConstructorReturn(this,(Right.__proto__||Object.getPrototypeOf(Right)).apply(this,arguments));}_createClass(Right,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:11}}));
}}]);return Right;}(_react.Component);


Right.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledRight=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Right",{},_mapPropsToStyleNames2.default)(Right);exports.

Right=StyledRight;
//# sourceMappingURL=Right.js.map

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Body=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Body.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Body=function(_Component){_inherits(Body,_Component);function Body(){_classCallCheck(this,Body);return _possibleConstructorReturn(this,(Body.__proto__||Object.getPrototypeOf(Body)).apply(this,arguments));}_createClass(Body,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:11}}));
}}]);return Body;}(_react.Component);


Body.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledBody=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Body",{},_mapPropsToStyleNames2.default)(Body);exports.

Body=StyledBody;
//# sourceMappingURL=Body.js.map

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.ListItem=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/ListItem.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

ListItem=function(_Component){_inherits(ListItem,_Component);function ListItem(){_classCallCheck(this,ListItem);return _possibleConstructorReturn(this,(ListItem.__proto__||Object.getPrototypeOf(ListItem)).apply(this,arguments));}_createClass(ListItem,[{key:"render",value:function render()



{var _this2=this;
var variables=this.context.theme?this.context.theme["@@shoutem.theme/themeStyle"].variables:_platform2.default;

if(
_reactNative.Platform.OS==="ios"||
variables.androidRipple===false||
!this.props.onPress&&!this.props.onLongPress||
_reactNative.Platform.Version<=21)
{
return(
_react2.default.createElement(_reactNative.TouchableHighlight,{
onPress:this.props.onPress,
onLongPress:this.props.onLongPress,
ref:function ref(c){return _this2._root=c;},
underlayColor:variables.listBtnUnderlayColor,__source:{fileName:_jsxFileName,lineNumber:23}},

_react2.default.createElement(_reactNative.View,_extends({},this.props,{__source:{fileName:_jsxFileName,lineNumber:29}}),
this.props.children)));



}else{
return(
_react2.default.createElement(_reactNative.TouchableNativeFeedback,{
ref:function ref(c){return _this2._root=c;},
onPress:this.props.onPress,
onLongPress:this.props.onLongPress,
background:
this.props.androidRippleColor?
_reactNative.TouchableNativeFeedback.Ripple(this.props.androidRippleColor):
_reactNative.TouchableNativeFeedback.Ripple(variables.androidRippleColorDark),__source:{fileName:_jsxFileName,lineNumber:36}},


_react2.default.createElement(_reactNative.View,{style:{marginLeft:-17,paddingLeft:17},__source:{fileName:_jsxFileName,lineNumber:46}},
_react2.default.createElement(_reactNative.View,_extends({},this.props,{__source:{fileName:_jsxFileName,lineNumber:47}}),
this.props.children))));




}
}}]);return ListItem;}(_react.Component);ListItem.contextTypes={theme:_propTypes2.default.object};


ListItem.propTypes=_extends({},
_reactNative.TouchableHighlight.propTypes,{
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array]),
itemDivider:_propTypes2.default.bool,
button:_propTypes2.default.bool});


var StyledListItem=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.ListItem",{},_mapPropsToStyleNames2.default)(ListItem);exports.

ListItem=StyledListItem;
//# sourceMappingURL=ListItem.js.map

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.IconNB=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/IconNB.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);

var _nativeBaseShoutemTheme=__webpack_require__(5);

var _Ionicons=__webpack_require__(108);var _Ionicons2=_interopRequireDefault(_Ionicons);
var _Entypo=__webpack_require__(570);var _Entypo2=_interopRequireDefault(_Entypo);
var _FontAwesome=__webpack_require__(572);var _FontAwesome2=_interopRequireDefault(_FontAwesome);
var _Foundation=__webpack_require__(574);var _Foundation2=_interopRequireDefault(_Foundation);
var _MaterialIcons=__webpack_require__(576);var _MaterialIcons2=_interopRequireDefault(_MaterialIcons);
var _MaterialCommunityIcons=__webpack_require__(578);var _MaterialCommunityIcons2=_interopRequireDefault(_MaterialCommunityIcons);
var _Octicons=__webpack_require__(580);var _Octicons2=_interopRequireDefault(_Octicons);
var _Zocial=__webpack_require__(582);var _Zocial2=_interopRequireDefault(_Zocial);
var _SimpleLineIcons=__webpack_require__(584);var _SimpleLineIcons2=_interopRequireDefault(_SimpleLineIcons);

var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

IconNB=function(_Component){_inherits(IconNB,_Component);function IconNB(){_classCallCheck(this,IconNB);return _possibleConstructorReturn(this,(IconNB.__proto__||Object.getPrototypeOf(IconNB)).apply(this,arguments));}_createClass(IconNB,[{key:"componentWillMount",value:function componentWillMount()




{
if(this.context.theme){
switch(this.context.theme["@@shoutem.theme/themeStyle"].variables.iconFamily){
case"Ionicons":
this.Icon=_Ionicons2.default;
break;
case"Entypo":
this.Icon=_Entypo2.default;
break;
case"FontAwesome":
this.Icon=_FontAwesome2.default;
break;
case"Foundation":
this.Icon=_Foundation2.default;
break;
case"MaterialIcons":
this.Icon=_MaterialIcons2.default;
break;
case"MaterialCommunityIcons":
this.Icon=_MaterialCommunityIcons2.default;
break;
case"Octicons":
this.Icon=_Octicons2.default;
break;
case"Zocial":
this.Icon=_Zocial2.default;
break;
case"SimpleLineIcons":
this.Icon=_SimpleLineIcons2.default;
break;
default:
this.Icon=_Ionicons2.default;}

}else{
this.Icon=_Ionicons2.default;
}
}},{key:"render",value:function render()

{var _this2=this;
return _react2.default.createElement(this.Icon,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:62}}));
}}]);return IconNB;}(_react.Component);IconNB.contextTypes={theme:_propTypes2.default.object};


IconNB.propTypes={
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])};


var StyledIconNB=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.IconNB",{},_mapPropsToStyleNames2.default)(IconNB);exports.

IconNB=StyledIconNB;
//# sourceMappingURL=IconNB.js.map

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _reactNative=__webpack_require__(1);Object.keys(_reactNative).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _reactNative[key];}});});

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(470),
    listCacheDelete = __webpack_require__(471),
    listCacheGet = __webpack_require__(472),
    listCacheHas = __webpack_require__(473),
    listCacheSet = __webpack_require__(474);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(109);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(38);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(492);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(123);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Icon=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Icon/index.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);

var _reactNative=__webpack_require__(1);
var _nativeBaseShoutemTheme=__webpack_require__(5);

var _IconNB=__webpack_require__(74);
var _NBIcons=__webpack_require__(586);var _NBIcons2=_interopRequireDefault(_NBIcons);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);
var _lodash=__webpack_require__(12);var _lodash2=_interopRequireDefault(_lodash);

var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Icon=function(_Component){_inherits(Icon,_Component);function Icon(){_classCallCheck(this,Icon);return _possibleConstructorReturn(this,(Icon.__proto__||Object.getPrototypeOf(Icon)).apply(this,arguments));}_createClass(Icon,[{key:"getName",value:function getName()




{
var variables=this.context.theme?this.context.theme["@@shoutem.theme/themeStyle"].variables:_platform2.default;
var platformStyle=variables.platformStyle;
var platform=variables.platform;

if(variables.iconFamily==="Ionicons"){
if(typeof _NBIcons2.default[this.props.name]!=="object"){
return this.props.name;
}else if(typeof _NBIcons2.default[this.props.name]==="object"){
var name=void 0;
if(platform==="ios"&&platformStyle!=="material"){
name=this.props.active?_NBIcons2.default[this.props.name].ios.active:_NBIcons2.default[this.props.name].ios.default;
}else{
name=this.props.active?_NBIcons2.default[this.props.name].android.active:_NBIcons2.default[this.props.name].android.default;
}
return name;
}
}else{
return this.props.name;
}
}},{key:"getIconName",value:function getIconName()

{
if(_reactNative.Platform.OS==="ios"){
if(this.props.ios){
return this.props.ios;
}else{
return this.props.active?_NBIcons2.default[this.props.name].ios.active:_NBIcons2.default[this.props.name].ios.default;
}
}else if(this.props.android){
return this.props.android;
}else{
return this.props.active?_NBIcons2.default[this.props.name].android.active:_NBIcons2.default[this.props.name].android.default;
}
}},{key:"render",value:function render()

{var _this2=this;
if(this.props.ios&&this.props.android){
return(
_react2.default.createElement(_IconNB.IconNB,_extends({
ref:function ref(c){return _this2._root=c;}},
this.props,{
name:_reactNative.Platform.OS==="ios"?this.props.ios:this.props.android,__source:{fileName:_jsxFileName,lineNumber:58}})));


}else if(this.props.name&&(this.props.android||this.props.ios)){
return _react2.default.createElement(_IconNB.IconNB,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{name:this.getIconName(),__source:{fileName:_jsxFileName,lineNumber:65}}));
}else{
return _react2.default.createElement(_IconNB.IconNB,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{name:this.getName(),__source:{fileName:_jsxFileName,lineNumber:67}}));
}
}}]);return Icon;}(_react.Component);Icon.contextTypes={theme:_propTypes2.default.object};


Icon.propTypes=_extends({},
_IconNB.IconNB.propTypes,{
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array]),
name:_propTypes2.default.string,
ios:_propTypes2.default.string,
android:_propTypes2.default.string,
active:_propTypes2.default.bool});


var StyledIcon=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Icon",{},_mapPropsToStyleNames2.default)(Icon);exports.

Icon=StyledIcon;
//# sourceMappingURL=index.js.map

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_native_iphone_x_helper__ = __webpack_require__(603);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _KAM_DEFAULT_TAB_BAR_HEIGHT=Object(__WEBPACK_IMPORTED_MODULE_3_react_native_iphone_x_helper__["a" /* isIphoneX */])()?83:49;var _KAM_KEYBOARD_OPENING_TIME=250;var _KAM_EXTRA_HEIGHT=75;function listenToKeyboardEvents(ScrollableComponent){var _class,_temp,_initialiseProps;return _temp=_class=function(_React$Component){_inherits(_class,_React$Component);function _class(props){_classCallCheck(this,_class);var _this=_possibleConstructorReturn(this,(_class.__proto__||Object.getPrototypeOf(_class)).call(this,props));_initialiseProps.call(_this);_this.keyboardWillShowEvent=undefined;_this.keyboardWillHideEvent=undefined;_this.position={x:0,y:0};_this.defaultResetScrollToCoords=null;var keyboardSpace=props.viewIsInsideTabBar?_KAM_DEFAULT_TAB_BAR_HEIGHT:0;_this.state={keyboardSpace:keyboardSpace};return _this;}_createClass(_class,[{key:'componentDidMount',value:function componentDidMount(){this.mountedComponent=true;// Keyboard events
if(__WEBPACK_IMPORTED_MODULE_2_react_native__["Platform"].OS==='ios'){this.keyboardWillShowEvent=__WEBPACK_IMPORTED_MODULE_2_react_native__["Keyboard"].addListener('keyboardWillShow',this._updateKeyboardSpace);this.keyboardWillHideEvent=__WEBPACK_IMPORTED_MODULE_2_react_native__["Keyboard"].addListener('keyboardWillHide',this._resetKeyboardSpace);}else if(__WEBPACK_IMPORTED_MODULE_2_react_native__["Platform"].OS==='android'&&this.props.enableOnAndroid){this.keyboardWillShowEvent=__WEBPACK_IMPORTED_MODULE_2_react_native__["Keyboard"].addListener('keyboardDidShow',this._updateKeyboardSpace);this.keyboardWillHideEvent=__WEBPACK_IMPORTED_MODULE_2_react_native__["Keyboard"].addListener('keyboardDidHide',this._resetKeyboardSpace);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var keyboardSpace=nextProps.viewIsInsideTabBar?_KAM_DEFAULT_TAB_BAR_HEIGHT:0;if(this.state.keyboardSpace!==keyboardSpace){this.setState({keyboardSpace:keyboardSpace});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.mountedComponent=false;this.keyboardWillShowEvent&&this.keyboardWillShowEvent.remove();this.keyboardWillHideEvent&&this.keyboardWillHideEvent.remove();}/**
     * @param keyboardOpeningTime: takes a different keyboardOpeningTime in consideration.
     * @param extraHeight: takes an extra height in consideration.
     */// Keyboard actions
},{key:'render',value:function render(){var _props=this.props,enableOnAndroid=_props.enableOnAndroid,contentContainerStyle=_props.contentContainerStyle;var newContentContainerStyle=void 0;if(__WEBPACK_IMPORTED_MODULE_2_react_native__["Platform"].OS==='android'&&enableOnAndroid){newContentContainerStyle=[].concat(contentContainerStyle).concat({paddingBottom:((contentContainerStyle||{}).paddingBottom||0)+this.state.keyboardSpace});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollableComponent,Object.assign({ref:this._handleRef,keyboardDismissMode:'interactive',contentInset:{bottom:this.state.keyboardSpace},automaticallyAdjustContentInsets:false,showsVerticalScrollIndicator:true,scrollEventThrottle:1},this.props,{contentContainerStyle:newContentContainerStyle||contentContainerStyle,keyboardSpace:this.state.keyboardSpace,getScrollResponder:this.getScrollResponder,scrollToPosition:this.scrollToPosition,scrollToEnd:this.scrollToEnd,scrollForExtraHeightOnAndroid:this.scrollForExtraHeightOnAndroid,scrollToFocusedInput:this.scrollToFocusedInput,resetKeyboardSpace:this._resetKeyboardSpace,handleOnScroll:this._handleOnScroll,onScroll:this._onScroll}));}}]);return _class;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.propTypes={viewIsInsideTabBar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,resetScrollToCoords:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({x:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,y:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired}),enableResetScrollToCoords:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,enableAutoAutomaticScroll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,extraHeight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,extraScrollHeight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,keyboardOpeningTime:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,onScroll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,contentContainerStyle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,enableOnAndroid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,innerRef:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func},_class.defaultProps={enableAutoAutomaticScroll:true,extraHeight:_KAM_EXTRA_HEIGHT,extraScrollHeight:0,enableResetScrollToCoords:true,keyboardOpeningTime:_KAM_KEYBOARD_OPENING_TIME,viewIsInsideTabBar:false},_initialiseProps=function _initialiseProps(){var _this2=this;this.getScrollResponder=function(){return _this2._rnkasv_keyboardView&&_this2._rnkasv_keyboardView.getScrollResponder();};this.scrollToPosition=function(x,y){var animated=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var responder=_this2.getScrollResponder();responder&&responder.scrollResponderScrollTo({x:x,y:y,animated:animated});};this.scrollToEnd=function(){var animated=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var responder=_this2.getScrollResponder();responder&&responder.scrollResponderScrollToEnd({animated:animated});};this.scrollForExtraHeightOnAndroid=function(extraHeight){_this2.scrollToPosition(0,_this2.position.y+extraHeight,true);};this.scrollToFocusedInput=function(reactNode,extraHeight,keyboardOpeningTime){if(extraHeight===undefined){extraHeight=_this2.props.extraHeight||0;}if(keyboardOpeningTime===undefined){keyboardOpeningTime=_this2.props.keyboardOpeningTime||0;}setTimeout(function(){if(!_this2.mountedComponent){return;}var responder=_this2.getScrollResponder();responder&&responder.scrollResponderScrollNativeHandleToKeyboard(reactNode,extraHeight,true);},keyboardOpeningTime);};this._updateKeyboardSpace=function(frames){var keyboardSpace=frames.endCoordinates.height+_this2.props.extraScrollHeight;if(_this2.props.viewIsInsideTabBar){keyboardSpace-=_KAM_DEFAULT_TAB_BAR_HEIGHT;}_this2.setState({keyboardSpace:keyboardSpace});// Automatically scroll to focused TextInput
if(_this2.props.enableAutoAutomaticScroll){var currentlyFocusedField=__WEBPACK_IMPORTED_MODULE_2_react_native__["TextInput"].State.currentlyFocusedField();var responder=_this2.getScrollResponder();if(!currentlyFocusedField||!responder){return;}__WEBPACK_IMPORTED_MODULE_2_react_native__["UIManager"].viewIsDescendantOf(currentlyFocusedField,responder.getInnerViewNode(),function(isAncestor){if(isAncestor){// Check if the TextInput will be hidden by the keyboard
__WEBPACK_IMPORTED_MODULE_2_react_native__["UIManager"].measureInWindow(currentlyFocusedField,function(x,y,width,height){var textInputBottomPosition=y+height;var keyboardPosition=frames.endCoordinates.screenY;var totalExtraHeight=_this2.props.extraScrollHeight+_this2.props.extraHeight;if(__WEBPACK_IMPORTED_MODULE_2_react_native__["Platform"].OS==='ios'){if(textInputBottomPosition>keyboardPosition-totalExtraHeight){_this2._scrollToFocusedInputWithNodeHandle(currentlyFocusedField);}}else{// On android, the system would scroll the text input just
// above the keyboard so we just neet to scroll the extra
// height part
if(textInputBottomPosition>keyboardPosition){// Since the system already scrolled the whole view up
// we should reduce that amount
keyboardSpace=keyboardSpace-(textInputBottomPosition-keyboardPosition);_this2.setState({keyboardSpace:keyboardSpace});_this2.scrollForExtraHeightOnAndroid(totalExtraHeight);}else if(textInputBottomPosition>keyboardPosition-totalExtraHeight){_this2.scrollForExtraHeightOnAndroid(totalExtraHeight-(keyboardPosition-textInputBottomPosition));}}});}});}if(!_this2.resetCoords){if(!_this2.defaultResetScrollToCoords){_this2.defaultResetScrollToCoords=_this2.position;}}};this._resetKeyboardSpace=function(){var keyboardSpace=_this2.props.viewIsInsideTabBar?_KAM_DEFAULT_TAB_BAR_HEIGHT+_this2.props.extraScrollHeight||0:_this2.props.extraScrollHeight||0;_this2.setState({keyboardSpace:keyboardSpace});// Reset scroll position after keyboard dismissal
if(_this2.props.enableResetScrollToCoords===false){_this2.defaultResetScrollToCoords=null;return;}else if(_this2.resetCoords){_this2.scrollToPosition(_this2.resetCoords.x,_this2.resetCoords.y,true);}else{if(_this2.defaultResetScrollToCoords){_this2.scrollToPosition(_this2.defaultResetScrollToCoords.x,_this2.defaultResetScrollToCoords.y,true);_this2.defaultResetScrollToCoords=null;}else{_this2.scrollToPosition(0,0,true);}}};this._scrollToFocusedInputWithNodeHandle=function(nodeID,extraHeight,keyboardOpeningTime){if(extraHeight===undefined){extraHeight=_this2.props.extraHeight;}var reactNode=__WEBPACK_IMPORTED_MODULE_2_react_native___default.a.findNodeHandle(nodeID);_this2.scrollToFocusedInput(reactNode,extraHeight+_this2.props.extraScrollHeight,keyboardOpeningTime!==undefined?keyboardOpeningTime:_this2.props.keyboardOpeningTime||0);};this._handleOnScroll=function(e){_this2.position=e.nativeEvent.contentOffset;};this._handleRef=function(ref){_this2._rnkasv_keyboardView=ref;if(_this2.props.innerRef){_this2.props.innerRef(_this2._rnkasv_keyboardView);}};this._onScroll=function(e){_this2._handleOnScroll(e);_this2.props.onScroll&&_this2.props.onScroll(e);};},_temp;}/* harmony default export */ __webpack_exports__["a"] = (listenToKeyboardEvents);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=createNavigationContainer;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _PlatformHelpers=__webpack_require__(177);var _NavigationActions=__webpack_require__(39);var _NavigationActions2=_interopRequireDefault(_NavigationActions);var _addNavigationHelpers=__webpack_require__(48);var _addNavigationHelpers2=_interopRequireDefault(_addNavigationHelpers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Create an HOC that injects the navigation and manages the navigation state
 * in case it's not passed from above.
 * This allows to use e.g. the StackNavigator and TabNavigator as root-level
 * components.
 */function createNavigationContainer(Component){var NavigationContainer=function(_React$Component){_inherits(NavigationContainer,_React$Component);function NavigationContainer(props){_classCallCheck(this,NavigationContainer);var _this=_possibleConstructorReturn(this,(NavigationContainer.__proto__||Object.getPrototypeOf(NavigationContainer)).call(this,props));_this.subs=null;_this._handleOpenURL=function(_ref){var url=_ref.url;var parsedUrl=_this._urlToPathAndParams(url);if(parsedUrl){var path=parsedUrl.path,params=parsedUrl.params;var action=Component.router.getActionForPathAndParams(path,params);if(action){_this.dispatch(action);}}};_this.dispatch=function(action){var state=_this.state;if(!_this._isStateful()){return false;}var nav=Component.router.getStateForAction(action,state.nav);if(nav&&nav!==state.nav){_this.setState({nav:nav},function(){return _this._onNavigationStateChange(state.nav,nav,action);});return true;}return false;};_this._validateProps(props);_this.state={nav:_this._isStateful()?Component.router.getStateForAction(_NavigationActions2.default.init()):null};return _this;}_createClass(NavigationContainer,[{key:'_isStateful',value:function _isStateful(){return!this.props.navigation;}},{key:'_validateProps',value:function _validateProps(props){if(this._isStateful()){return;}var navigation=props.navigation,screenProps=props.screenProps,containerProps=_objectWithoutProperties(props,['navigation','screenProps']);var keys=Object.keys(containerProps);if(keys.length!==0){throw new Error('This navigator has both navigation and container props, so it is '+('unclear if it should own its own state. Remove props: "'+keys.join(', ')+'" ')+'if the navigator should get its state from the navigation prop. If the '+'navigator should maintain its own state, do not pass a navigation prop.');}}},{key:'_urlToPathAndParams',value:function _urlToPathAndParams(url){var params={};var delimiter=this.props.uriPrefix||'://';var path=url.split(delimiter)[1];if(typeof path==='undefined'){path=url;}return{path:path,params:params};}},{key:'_onNavigationStateChange',value:function _onNavigationStateChange(prevNav,nav,action){if(typeof this.props.onNavigationStateChange==='undefined'&&this._isStateful()&&!!Object({"NODE_ENV":"production","PUBLIC_URL":"."}).REACT_NAV_LOGGING){/* eslint-disable no-console */if(console.group){console.group('Navigation Dispatch: ');console.log('Action: ',action);console.log('New State: ',nav);console.log('Last State: ',prevNav);console.groupEnd();}else{console.log('Navigation Dispatch: ',{action:action,newState:nav,lastState:prevNav});}/* eslint-enable no-console */return;}if(typeof this.props.onNavigationStateChange==='function'){this.props.onNavigationStateChange(prevNav,nav,action);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this._validateProps(nextProps);}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(!this._isStateful()){return;}this.subs=_PlatformHelpers.BackHandler.addEventListener('hardwareBackPress',function(){return _this2.dispatch(_NavigationActions2.default.back());});_PlatformHelpers.Linking.addEventListener('url',this._handleOpenURL);_PlatformHelpers.Linking.getInitialURL().then(function(url){return url&&_this2._handleOpenURL({url:url});});}},{key:'componentWillUnmount',value:function componentWillUnmount(){_PlatformHelpers.Linking.removeEventListener('url',this._handleOpenURL);this.subs&&this.subs.remove();}},{key:'render',value:function render(){var navigation=this.props.navigation;if(this._isStateful()){if(!this._navigation||this._navigation.state!==this.state.nav){this._navigation=(0,_addNavigationHelpers2.default)({dispatch:this.dispatch,state:this.state.nav});}navigation=this._navigation;}return _react2.default.createElement(Component,_extends({},this.props,{navigation:navigation}));}}]);return NavigationContainer;}(_react2.default.Component);NavigationContainer.router=Component.router;return NavigationContainer;}

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=createNavigator;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Creates a navigator based on a router and a view that renders the screens.
 */function createNavigator(router,routeConfigs,navigatorConfig,navigatorType){return function(NavigationView){var Navigator=function(_React$Component){_inherits(Navigator,_React$Component);function Navigator(){_classCallCheck(this,Navigator);return _possibleConstructorReturn(this,(Navigator.__proto__||Object.getPrototypeOf(Navigator)).apply(this,arguments));}_createClass(Navigator,[{key:'render',value:function render(){return _react2.default.createElement(NavigationView,_extends({},this.props,{router:router}));}}]);return Navigator;}(_react2.default.Component);Navigator.router=router;Navigator.routeConfigs=routeConfigs;Navigator.navigatorConfig=navigatorConfig;Navigator.navigatorType=navigatorType;return Navigator;};}

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet,Platform=React.Platform;/* harmony default export */ __webpack_exports__["a"] = ({container:{flex:1,width:null,height:null,backgroundColor:"#FFF"},iconContainer:{flexDirection:"row",flexWrap:"wrap",justifyContent:"space-around",paddingLeft:15},iconText:{fontSize:12},icon:{width:45,height:45,justifyContent:"center"},col:{alignItems:"center",paddingHorizontal:3},row:{paddingBottom:20}});

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _isDisabled=__webpack_require__(145);var _isDisabled2=_interopRequireDefault(_isDisabled);var _propsToAccessibilityComponent=__webpack_require__(277);var _propsToAccessibilityComponent2=_interopRequireDefault(_propsToAccessibilityComponent);var _propsToAriaRole=__webpack_require__(88);var _propsToAriaRole2=_interopRequireDefault(_propsToAriaRole);var _propsToTabIndex=__webpack_require__(278);var _propsToTabIndex2=_interopRequireDefault(_propsToTabIndex);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var AccessibilityUtil={isDisabled:_isDisabled2.default,propsToAccessibilityComponent:_propsToAccessibilityComponent2.default,propsToAriaRole:_propsToAriaRole2.default,propsToTabIndex:_propsToTabIndex2.default};exports.default=AccessibilityUtil;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var accessibilityComponentTypeToRole={button:'button',none:'presentation'};var accessibilityTraitsToRole={adjustable:'slider',button:'button',header:'heading',image:'img',link:'link',none:'presentation',search:'search',summary:'region'};var propsToAriaRole=function propsToAriaRole(_ref){var accessibilityComponentType=_ref.accessibilityComponentType,accessibilityRole=_ref.accessibilityRole,accessibilityTraits=_ref.accessibilityTraits;if(accessibilityRole){return accessibilityRole;}if(accessibilityTraits){var trait=Array.isArray(accessibilityTraits)?accessibilityTraits[0]:accessibilityTraits;return accessibilityTraitsToRole[trait];}if(accessibilityComponentType){return accessibilityComponentTypeToRole[accessibilityComponentType];}};exports.default=propsToAriaRole;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _StyleRegistry=__webpack_require__(280);var _StyleRegistry2=_interopRequireDefault(_StyleRegistry);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var registry=new _StyleRegistry2.default();exports.default=registry;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _ExecutionEnvironment=__webpack_require__(16);var _ExecutionEnvironment2=_interopRequireDefault(_ExecutionEnvironment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var isPreferredLanguageRTL=false;var isRTLAllowed=true;var isRTLForced=false;var isRTL=function isRTL(){if(isRTLForced){return true;}return isRTLAllowed&&isPreferredLanguageRTL;};var onChange=function onChange(){if(_ExecutionEnvironment2.default.canUseDOM){if(document.documentElement&&document.documentElement.setAttribute){document.documentElement.setAttribute('dir',isRTL()?'rtl':'ltr');}}};var I18nManager={allowRTL:function allowRTL(bool){isRTLAllowed=bool;onChange();},forceRTL:function forceRTL(bool){isRTLForced=bool;onChange();},setPreferredLanguageRTL:function setPreferredLanguageRTL(bool){isPreferredLanguageRTL=bool;onChange();},get isRTL(){return isRTL();}};exports.default=I18nManager;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";












var _uniqueId=0;

module.exports=function uniqueId(){
return String(_uniqueId++);
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _invariant=__webpack_require__(8);var _invariant2=_interopRequireDefault(_invariant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function createStrictShapeTypeChecker(shapeTypes){function checkType(isRequired,props,propName,componentName,location){if(!props[propName]){if(isRequired){(0,_invariant2.default)(false,'Required object `'+propName+'` was not specified in `'+componentName+'`.');}return;}var propValue=props[propName];var propType=typeof propValue;var locationName=location||'(unknown)';if(propType!=='object'){(0,_invariant2.default)(false,'Invalid '+locationName+' `'+propName+'` of type `'+propType+'` '+('supplied to `'+componentName+'`, expected `object`.'));}var allKeys=_extends({},props[propName],shapeTypes);for(var _len=arguments.length,rest=Array(_len>5?_len-5:0),_key=5;_key<_len;_key++){rest[_key-5]=arguments[_key];}for(var _key2 in allKeys){var checker=shapeTypes[_key2];if(!checker){(0,_invariant2.default)(false,'Invalid props.'+propName+' key `'+_key2+'` supplied to `'+componentName+'`.'+'\nBad object: '+JSON.stringify(props[propName],null,'  ')+'\nValid keys: '+JSON.stringify(Object.keys(shapeTypes),null,'  '));}var error=checker.apply(undefined,[propValue,_key2,componentName,location].concat(rest));if(error){(0,_invariant2.default)(false,error.message+'\nBad object: '+JSON.stringify(props[propName],null,'  '));}}}function chainedCheckType(props,propName,componentName,location){for(var _len2=arguments.length,rest=Array(_len2>4?_len2-4:0),_key3=4;_key3<_len2;_key3++){rest[_key3-4]=arguments[_key3];}return checkType.apply(undefined,[false,props,propName,componentName,location].concat(rest));}chainedCheckType.isRequired=checkType.bind(null,true);return chainedCheckType;}exports.default=createStrictShapeTypeChecker;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _ExecutionEnvironment=__webpack_require__(16);var _debounce=__webpack_require__(94);var _debounce2=_interopRequireDefault(_debounce);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var emptyObject={};var registry={};var id=1;var guid=function guid(){return'r-'+id++;};if(_ExecutionEnvironment.canUseDOM){var triggerAll=function triggerAll(){Object.keys(registry).forEach(function(key){var instance=registry[key];instance._handleLayout();});};window.addEventListener('resize',(0,_debounce2.default)(triggerAll,16),false);}var safeOverride=function safeOverride(original,next){if(original){return function prototypeOverride(){original.call(this);next.call(this);};}return next;};var applyLayout=function applyLayout(Component){var componentDidMount=Component.prototype.componentDidMount;var componentDidUpdate=Component.prototype.componentDidUpdate;var componentWillUnmount=Component.prototype.componentWillUnmount;Component.prototype.componentDidMount=safeOverride(componentDidMount,function componentDidMount(){this._layoutState=emptyObject;this._isMounted=true;this._onLayoutId=guid();registry[this._onLayoutId]=this;this._handleLayout();});Component.prototype.componentDidUpdate=safeOverride(componentDidUpdate,function componentDidUpdate(){this._handleLayout();});Component.prototype.componentWillUnmount=safeOverride(componentWillUnmount,function componentWillUnmount(){this._isMounted=false;delete registry[this._onLayoutId];});Component.prototype._handleLayout=function(){var _this=this;var layout=this._layoutState;var onLayout=this.props.onLayout;if(onLayout){this.measure(function(x,y,width,height){if(!_this._isMounted)return;if(layout.x!==x||layout.y!==y||layout.width!==width||layout.height!==height){_this._layoutState={x:x,y:y,width:width,height:height};var nativeEvent={layout:_this._layoutState};onLayout({nativeEvent:nativeEvent,timeStamp:Date.now()});}});}};return Component;};exports.default=applyLayout;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */

module.exports = function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _propTypes=__webpack_require__(3);var BaseComponentPropTypes={accessibilityLabel:_propTypes.string,accessibilityLiveRegion:(0,_propTypes.oneOf)(['assertive','none','polite']),accessibilityRole:_propTypes.string,accessible:_propTypes.bool,importantForAccessibility:(0,_propTypes.oneOf)(['auto','no','no-hide-descendants','yes']),style:(0,_propTypes.oneOfType)([_propTypes.array,_propTypes.number,_propTypes.object]),testID:_propTypes.string,accessibilityComponentType:_propTypes.string,accessibilityTraits:(0,_propTypes.oneOfType)([_propTypes.array,_propTypes.string])};exports.default=BaseComponentPropTypes;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createStrictShapeTypeChecker=__webpack_require__(92);var _createStrictShapeTypeChecker2=_interopRequireDefault(_createStrictShapeTypeChecker);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var EdgeInsetsPropType=(0,_createStrictShapeTypeChecker2.default)({top:_propTypes.number,left:_propTypes.number,bottom:_propTypes.number,right:_propTypes.number});exports.default=EdgeInsetsPropType;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _AnimationPropTypes=__webpack_require__(340);var _AnimationPropTypes2=_interopRequireDefault(_AnimationPropTypes);var _BorderPropTypes=__webpack_require__(165);var _BorderPropTypes2=_interopRequireDefault(_BorderPropTypes);var _ColorPropType=__webpack_require__(14);var _ColorPropType2=_interopRequireDefault(_ColorPropType);var _LayoutPropTypes=__webpack_require__(166);var _LayoutPropTypes2=_interopRequireDefault(_LayoutPropTypes);var _ShadowPropTypes=__webpack_require__(167);var _ShadowPropTypes2=_interopRequireDefault(_ShadowPropTypes);var _TransformPropTypes=__webpack_require__(168);var _TransformPropTypes2=_interopRequireDefault(_TransformPropTypes);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ViewStylePropTypes=_extends({},_AnimationPropTypes2.default,_BorderPropTypes2.default,_LayoutPropTypes2.default,_ShadowPropTypes2.default,_TransformPropTypes2.default,{backgroundColor:_ColorPropType2.default,opacity:_propTypes.number,elevation:_propTypes.number,backgroundAttachment:_propTypes.string,backgroundBlendMode:_propTypes.string,backgroundClip:_propTypes.string,backgroundImage:_propTypes.string,backgroundOrigin:(0,_propTypes.oneOf)(['border-box','content-box','padding-box']),backgroundPosition:_propTypes.string,backgroundRepeat:_propTypes.string,backgroundSize:_propTypes.string,boxShadow:_propTypes.string,clip:_propTypes.string,cursor:_propTypes.string,filter:_propTypes.string,outline:_propTypes.string,outlineColor:_ColorPropType2.default,perspective:(0,_propTypes.oneOfType)([_propTypes.number,_propTypes.string]),perspectiveOrigin:_propTypes.string,touchAction:_propTypes.string,transitionDelay:_propTypes.string,transitionDuration:_propTypes.string,transitionProperty:_propTypes.string,transitionTimingFunction:_propTypes.string,userSelect:_propTypes.string,willChange:_propTypes.string,WebkitMaskImage:_propTypes.string,WebkitOverflowScrolling:(0,_propTypes.oneOf)(['auto','touch'])});exports.default=ViewStylePropTypes;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _UIManager=__webpack_require__(43);var _UIManager2=_interopRequireDefault(_UIManager);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TextInputState={_currentlyFocusedNode:null,currentlyFocusedField:function currentlyFocusedField(){if(document.activeElement!==this._currentlyFocusedNode){this._currentlyFocusedNode=null;}return this._currentlyFocusedNode;},focusTextInput:function focusTextInput(textFieldNode){if(document.activeElement!==textFieldNode&&textFieldNode!==null){this._currentlyFocusedNode=textFieldNode;_UIManager2.default.focus(textFieldNode);}},blurTextInput:function blurTextInput(textFieldNode){if(document.activeElement===textFieldNode&&textFieldNode!==null){this._currentlyFocusedNode=null;_UIManager2.default.blur(textFieldNode);}}};exports.default=TextInputState;

/***/ }),
/* 99 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var Platform={OS:'web',select:function select(obj){return'web'in obj?obj.web:obj.default;}};exports.default=Platform;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _applyLayout=__webpack_require__(93);var _applyLayout2=_interopRequireDefault(_applyLayout);var _applyNativeMethods=__webpack_require__(18);var _applyNativeMethods2=_interopRequireDefault(_applyNativeMethods);var _propTypes=__webpack_require__(3);var _react=__webpack_require__(0);var _createElement=__webpack_require__(41);var _createElement2=_interopRequireDefault(_createElement);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _TextPropTypes=__webpack_require__(170);var _TextPropTypes2=_interopRequireDefault(_TextPropTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Text=function(_Component){_inherits(Text,_Component);function Text(){_classCallCheck(this,Text);return _possibleConstructorReturn(this,(Text.__proto__||Object.getPrototypeOf(Text)).apply(this,arguments));}_createClass(Text,[{key:'getChildContext',value:function getChildContext(){return{isInAParentText:true};}},{key:'render',value:function render(){var _props=this.props,dir=_props.dir,numberOfLines=_props.numberOfLines,onPress=_props.onPress,selectable=_props.selectable,style=_props.style,adjustsFontSizeToFit=_props.adjustsFontSizeToFit,allowFontScaling=_props.allowFontScaling,ellipsizeMode=_props.ellipsizeMode,lineBreakMode=_props.lineBreakMode,minimumFontScale=_props.minimumFontScale,onLayout=_props.onLayout,suppressHighlighting=_props.suppressHighlighting,otherProps=_objectWithoutProperties(_props,['dir','numberOfLines','onPress','selectable','style','adjustsFontSizeToFit','allowFontScaling','ellipsizeMode','lineBreakMode','minimumFontScale','onLayout','suppressHighlighting']);var isInAParentText=this.context.isInAParentText;if(onPress){otherProps.accessible=true;otherProps.onClick=onPress;otherProps.onKeyDown=this._createEnterHandler(onPress);}otherProps.dir=dir!==undefined?dir:'auto';otherProps.style=[styles.initial,this.context.isInAParentText===true&&styles.isInAParentText,style,selectable===false&&styles.notSelectable,numberOfLines===1&&styles.singleLineStyle,onPress&&styles.pressable];var component=isInAParentText?'span':'div';return(0,_createElement2.default)(component,otherProps);}},{key:'_createEnterHandler',value:function _createEnterHandler(fn){return function(e){if(e.keyCode===13){fn&&fn(e);}};}}]);return Text;}(_react.Component);Text.displayName='Text';Text.childContextTypes={isInAParentText:_propTypes.bool};Text.contextTypes={isInAParentText:_propTypes.bool};Text.propTypes= false?_TextPropTypes2.default:{};var styles=_StyleSheet2.default.create({initial:{borderWidth:0,boxSizing:'border-box',color:'inherit',display:'inline',font:'inherit',fontFamily:'System',fontSize:14,margin:0,padding:0,textDecorationLine:'none',whiteSpace:'pre-wrap',wordWrap:'break-word'},isInAParentText:{fontFamily:'inherit',fontSize:'inherit',whiteSpace:'inherit'},notSelectable:{userSelect:'none'},pressable:{cursor:'pointer'},singleLineStyle:{maxWidth:'100%',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}});exports.default=(0,_applyLayout2.default)((0,_applyNativeMethods2.default)(Text));

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _invariant=__webpack_require__(8);var _invariant2=_interopRequireDefault(_invariant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ensurePositiveDelayProps=function ensurePositiveDelayProps(props){(0,_invariant2.default)(!(props.delayPressIn<0||props.delayPressOut<0||props.delayLongPress<0),'Touchable components cannot have negative delay properties');};exports.default=ensurePositiveDelayProps;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _BaseComponentPropTypes=__webpack_require__(95);var _BaseComponentPropTypes2=_interopRequireDefault(_BaseComponentPropTypes);var _createReactClass=__webpack_require__(28);var _createReactClass2=_interopRequireDefault(_createReactClass);var _EdgeInsetsPropType=__webpack_require__(96);var _EdgeInsetsPropType2=_interopRequireDefault(_EdgeInsetsPropType);var _ensurePositiveDelayProps=__webpack_require__(101);var _ensurePositiveDelayProps2=_interopRequireDefault(_ensurePositiveDelayProps);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _reactTimerMixin=__webpack_require__(103);var _reactTimerMixin2=_interopRequireDefault(_reactTimerMixin);var _Touchable=__webpack_require__(69);var _Touchable2=_interopRequireDefault(_Touchable);var _warning=__webpack_require__(68);var _warning2=_interopRequireDefault(_warning);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var PRESS_RETENTION_OFFSET={top:20,left:20,right:20,bottom:30};var TouchableWithoutFeedback=(0,_createReactClass2.default)({displayName:'TouchableWithoutFeedback',mixins:[_reactTimerMixin2.default,_Touchable2.default.Mixin],propTypes:{accessibilityComponentType:_BaseComponentPropTypes2.default.accessibilityComponentType,accessibilityLabel:_propTypes.string,accessibilityRole:_BaseComponentPropTypes2.default.accessibilityRole,accessibilityTraits:_BaseComponentPropTypes2.default.accessibilityTraits,accessible:_propTypes.bool,delayLongPress:_propTypes.number,delayPressIn:_propTypes.number,delayPressOut:_propTypes.number,disabled:_propTypes.bool,hitSlop:_EdgeInsetsPropType2.default,onLayout:_propTypes.func,onLongPress:_propTypes.func,onPress:_propTypes.func,onPressIn:_propTypes.func,onPressOut:_propTypes.func,pressRetentionOffset:_EdgeInsetsPropType2.default,testID:_propTypes.string},getInitialState:function getInitialState(){return this.touchableGetInitialState();},componentDidMount:function componentDidMount(){(0,_ensurePositiveDelayProps2.default)(this.props);},componentWillReceiveProps:function componentWillReceiveProps(nextProps){(0,_ensurePositiveDelayProps2.default)(nextProps);},touchableHandlePress:function touchableHandlePress(e){this.props.onPress&&this.props.onPress(e);},touchableHandleActivePressIn:function touchableHandleActivePressIn(e){this.props.onPressIn&&this.props.onPressIn(e);},touchableHandleActivePressOut:function touchableHandleActivePressOut(e){this.props.onPressOut&&this.props.onPressOut(e);},touchableHandleLongPress:function touchableHandleLongPress(e){this.props.onLongPress&&this.props.onLongPress(e);},touchableGetPressRectOffset:function touchableGetPressRectOffset(){return this.props.pressRetentionOffset||PRESS_RETENTION_OFFSET;},touchableGetHitSlop:function touchableGetHitSlop(){return this.props.hitSlop;},touchableGetHighlightDelayMS:function touchableGetHighlightDelayMS(){return this.props.delayPressIn||0;},touchableGetLongPressDelayMS:function touchableGetLongPressDelayMS(){return this.props.delayLongPress===0?0:this.props.delayLongPress||500;},touchableGetPressOutDelayMS:function touchableGetPressOutDelayMS(){return this.props.delayPressOut||0;},render:function render(){var _props=this.props,delayLongPress=_props.delayLongPress,delayPressIn=_props.delayPressIn,delayPressOut=_props.delayPressOut,onLongPress=_props.onLongPress,onPress=_props.onPress,onPressIn=_props.onPressIn,onPressOut=_props.onPressOut,pressRetentionOffset=_props.pressRetentionOffset,other=_objectWithoutProperties(_props,['delayLongPress','delayPressIn','delayPressOut','onLongPress','onPress','onPressIn','onPressOut','pressRetentionOffset']);var child=_react2.default.Children.only(this.props.children);var children=child.props.children;(0,_warning2.default)(!child.type||child.type.displayName!=='Text','TouchableWithoutFeedback does not work well with Text children. Wrap children in a View instead. See '+(child._owner&&child._owner.getName&&child._owner.getName()||'<unknown>'));if(false){children=_react2.default.Children.toArray(children);children.push(_Touchable2.default.renderDebugView({color:'red',hitSlop:this.props.hitSlop}));}var style=_Touchable2.default.TOUCH_TARGET_DEBUG&&child.type&&child.type.displayName==='Text'?[!this.props.disabled&&styles.actionable,child.props.style,{color:'red'}]:[!this.props.disabled&&styles.actionable,child.props.style];return _react2.default.cloneElement(child,_extends({},other,{accessible:this.props.accessible!==false,children:children,onKeyDown:this.touchableHandleKeyEvent,onKeyUp:this.touchableHandleKeyEvent,onResponderGrant:this.touchableHandleResponderGrant,onResponderMove:this.touchableHandleResponderMove,onResponderRelease:this.touchableHandleResponderRelease,onResponderTerminate:this.touchableHandleResponderTerminate,onResponderTerminationRequest:this.touchableHandleResponderTerminationRequest,onStartShouldSetResponder:this.touchableHandleStartShouldSetResponder,style:style}));}});var styles=_StyleSheet2.default.create({actionable:{cursor:'pointer',touchAction:'manipulate'}});exports.default=TouchableWithoutFeedback;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*
 *  Copyright (c) 2015-present, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var GLOBAL = typeof window === 'undefined' ? global : window;

var setter = function(_setter, _clearer, array) {
  return function(callback, delta) {
    var id = _setter(function() {
      _clearer.call(this, id);
      callback.apply(this, arguments);
    }.bind(this), delta);

    if (!this[array]) {
      this[array] = [id];
    } else {
      this[array].push(id);
    }
    return id;
  };
};

var clearer = function(_clearer, array) {
  return function(id) {
    if (this[array]) {
      var index = this[array].indexOf(id);
      if (index !== -1) {
        this[array].splice(index, 1);
      }
    }
    _clearer(id);
  };
};

var _timeouts = 'TimerMixin_timeouts';
var _clearTimeout = clearer(GLOBAL.clearTimeout, _timeouts);
var _setTimeout = setter(GLOBAL.setTimeout, _clearTimeout, _timeouts);

var _intervals = 'TimerMixin_intervals';
var _clearInterval = clearer(GLOBAL.clearInterval, _intervals);
var _setInterval = setter(GLOBAL.setInterval, function() {/* noop */}, _intervals);

var _immediates = 'TimerMixin_immediates';
var _clearImmediate = clearer(GLOBAL.clearImmediate, _immediates);
var _setImmediate = setter(GLOBAL.setImmediate, _clearImmediate, _immediates);

var _rafs = 'TimerMixin_rafs';
var _cancelAnimationFrame = clearer(GLOBAL.cancelAnimationFrame, _rafs);
var _requestAnimationFrame = setter(GLOBAL.requestAnimationFrame, _cancelAnimationFrame, _rafs);

var TimerMixin = {
  componentWillUnmount: function() {
    this[_timeouts] && this[_timeouts].forEach(function(id) {
      GLOBAL.clearTimeout(id);
    });
    this[_timeouts] = null;
    this[_intervals] && this[_intervals].forEach(function(id) {
      GLOBAL.clearInterval(id);
    });
    this[_intervals] = null;
    this[_immediates] && this[_immediates].forEach(function(id) {
      GLOBAL.clearImmediate(id);
    });
    this[_immediates] = null;
    this[_rafs] && this[_rafs].forEach(function(id) {
      GLOBAL.cancelAnimationFrame(id);
    });
    this[_rafs] = null;
  },

  setTimeout: _setTimeout,
  clearTimeout: _clearTimeout,

  setInterval: _setInterval,
  clearInterval: _clearInterval,

  setImmediate: _setImmediate,
  clearImmediate: _clearImmediate,

  requestAnimationFrame: _requestAnimationFrame,
  cancelAnimationFrame: _cancelAnimationFrame,
};

module.exports = TimerMixin;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.default=normalizeStyle;var _lodash=__webpack_require__(17);var _lodash2=_interopRequireDefault(_lodash);var _StyleNormalizer=__webpack_require__(400);var _StyleNormalizer2=_interopRequireDefault(_StyleNormalizer);var _reactNative=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var styleNormalizer=new _StyleNormalizer2.default();function normalizeStyle(style){return _lodash2.default.reduce(style,function(normalizedStyle,val,prop){if(_lodash2.default.isPlainObject(val)){normalizedStyle[prop]=normalizeStyle(val);}else if(styleNormalizer.canNormalize(prop)){normalizedStyle=_extends({},normalizedStyle,styleNormalizer.normalize(prop,val));}else{normalizedStyle[prop]=val;}return normalizedStyle;},{});}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.ThemeShape=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _propTypes=__webpack_require__(3);var _resolveIncludes=__webpack_require__(178);var _resolveIncludes2=_interopRequireDefault(_resolveIncludes);var _mergeComponentAndThemeStyles=__webpack_require__(402);var _mergeComponentAndThemeStyles2=_interopRequireDefault(_mergeComponentAndThemeStyles);var _normalizeStyle=__webpack_require__(104);var _normalizeStyle2=_interopRequireDefault(_normalizeStyle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var THEME_STYLE="@@shoutem.theme/themeStyle";var THEME_STYLE_CACHE="@@shoutem.theme/themeCachedStyle";var defaultTheme=void 0;var resolveStyle=function resolveStyle(style,baseStyle){return(0,_normalizeStyle2.default)((0,_resolveIncludes2.default)(style,baseStyle));};var Theme=function(){function Theme(themeStyle){_classCallCheck(this,Theme);this[THEME_STYLE]=resolveStyle(themeStyle);this[THEME_STYLE_CACHE]={};}_createClass(Theme,[{key:"createComponentStyle",value:function createComponentStyle(componentName,defaultStyle){if(this[THEME_STYLE_CACHE][componentName]){return this[THEME_STYLE_CACHE][componentName];}var componentIncludedStyle=resolveStyle(defaultStyle,this[THEME_STYLE]);this[THEME_STYLE_CACHE][componentName]=(0,_mergeComponentAndThemeStyles2.default)(componentIncludedStyle,this[THEME_STYLE][componentName],this[THEME_STYLE]);return this[THEME_STYLE_CACHE][componentName];}}],[{key:"setDefaultThemeStyle",value:function setDefaultThemeStyle(style){defaultTheme=new Theme(style);}},{key:"getDefaultTheme",value:function getDefaultTheme(){if(!defaultTheme){defaultTheme=new Theme({});}return defaultTheme;}}]);return Theme;}();exports.default=Theme;var ThemeShape=exports.ThemeShape=_propTypes.PropTypes.shape({createComponentStyle:_propTypes.PropTypes.func.isRequired});

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var _ReactNativePropRegistry=__webpack_require__(180);var _ReactNativePropRegistry2=_interopRequireDefault(_ReactNativePropRegistry);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var React=__webpack_require__(0);var _=__webpack_require__(17);module.exports=function(incomingProps,defaultProps){var computedProps={};incomingProps=_.clone(incomingProps);delete incomingProps.children;var incomingPropsStyle=incomingProps.style;delete incomingProps.style;if(incomingProps)_.merge(computedProps,defaultProps,incomingProps);else computedProps=defaultProps;if(incomingPropsStyle){var computedPropsStyle={};computedProps.style={};if(Array.isArray(incomingPropsStyle)){_.forEach(incomingPropsStyle,function(style){if(typeof style=="number"){_.merge(computedPropsStyle,_ReactNativePropRegistry2.default.getByID(style));}else{_.merge(computedPropsStyle,style);}});}else{if(typeof incomingPropsStyle=="number"){computedPropsStyle=_ReactNativePropRegistry2.default.getByID(incomingPropsStyle);}else{computedPropsStyle=incomingPropsStyle;}}_.merge(computedProps.style,defaultProps.style,computedPropsStyle);}return computedProps;};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.ViewNB=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/View.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

ViewNB=function(_Component){_inherits(ViewNB,_Component);function ViewNB(){_classCallCheck(this,ViewNB);return _possibleConstructorReturn(this,(ViewNB.__proto__||Object.getPrototypeOf(ViewNB)).apply(this,arguments));}_createClass(ViewNB,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:10}}));
}}]);return ViewNB;}(_react.Component);


ViewNB.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledViewNB=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.ViewNB",{},_mapPropsToStyleNames2.default)(ViewNB);exports.
ViewNB=StyledViewNB;
//# sourceMappingURL=View.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(24);var _createIconSet2=_interopRequireDefault(_createIconSet);var _Ionicons=__webpack_require__(569);var _Ionicons2=_interopRequireDefault(_Ionicons);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_Ionicons2.default,'Ionicons','Ionicons.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 109 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(38),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(484),
    mapCacheDelete = __webpack_require__(491),
    mapCacheGet = __webpack_require__(493),
    mapCacheHas = __webpack_require__(494),
    mapCacheSet = __webpack_require__(495);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(191),
    eq = __webpack_require__(109);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(193),
    baseKeys = __webpack_require__(504),
    isArrayLike = __webpack_require__(196);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(499),
    isObjectLike = __webpack_require__(37);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(19),
    stubFalse = __webpack_require__(500);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),
/* 116 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 117 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 118 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(512),
    stubArray = __webpack_require__(198);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(195);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(204);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(552),
    flatRest = __webpack_require__(209);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.ToastContainer=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/ToastContainer.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _Text=__webpack_require__(29);
var _Button=__webpack_require__(58);
var _View=__webpack_require__(107);
var _Toast=__webpack_require__(600);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var


ToastContainer=function(_Component){_inherits(ToastContainer,_Component);
function ToastContainer(props){_classCallCheck(this,ToastContainer);var _this=_possibleConstructorReturn(this,(ToastContainer.__proto__||Object.getPrototypeOf(ToastContainer)).call(this,
props));
_this.state={
modalVisible:false,
fadeAnim:new _reactNative.Animated.Value(0)};return _this;

}_createClass(ToastContainer,[{key:"getToastStyle",value:function getToastStyle()




{
return{
position:"absolute",
opacity:this.state.fadeAnim,
width:"100%",
elevation:9,
paddingHorizontal:_reactNative.Platform.OS==="ios"?20:0,
top:this.state.position==="top"?this.getTop():undefined,
bottom:this.state.position==="bottom"?this.getTop():undefined};

}},{key:"getTop",value:function getTop()
{
if(_reactNative.Platform.OS==="ios"){
return 30;
}else{
return 0;
}
}},{key:"showToast",value:function showToast(_ref)
{var _this2=this;var config=_ref.config;
this.setState({
modalVisible:true,
text:config.text,
buttonText:config.buttonText,
type:config.type,
position:config.position?config.position:"bottom",
supportedOrientations:config.supportedOrientations,
style:config.style,
buttonTextStyle:config.buttonTextStyle,
buttonStyle:config.buttonStyle,
textStyle:config.textStyle,
onClose:config.onClose});

if(config.duration>0){
setTimeout(function(){
_reactNative.Animated.timing(_this2.state.fadeAnim,{
toValue:0,
duration:200}).
start();
setTimeout(function(){
_this2.setState({
modalVisible:false});

},500);
},config.duration);
}
_reactNative.Animated.timing(this.state.fadeAnim,{
toValue:1,
duration:200}).
start();
}},{key:"closeToast",value:function closeToast()
{var _this3=this;var
onClose=this.state.onClose;

if(onClose&&typeof onClose==="function"){
onClose();
}

_reactNative.Animated.timing(this.state.fadeAnim,{
toValue:0,
duration:200}).
start();
setTimeout(function(){
_this3.setState({
modalVisible:false});

},500);
}},{key:"render",value:function render()
{var _this4=this;
if(this.state.modalVisible){
return(
_react2.default.createElement(_reactNative.Animated.View,{style:this.getToastStyle(),__source:{fileName:_jsxFileName,lineNumber:95}},
_react2.default.createElement(_Toast.Toast,{
style:this.state.style,
danger:this.state.type=="danger"?true:false,
success:this.state.type=="success"?true:false,
warning:this.state.type=="warning"?true:false,__source:{fileName:_jsxFileName,lineNumber:96}},

_react2.default.createElement(_Text.Text,{style:this.state.textStyle,__source:{fileName:_jsxFileName,lineNumber:102}},
this.state.text),

this.state.buttonText&&
_react2.default.createElement(_Button.Button,{style:this.state.buttonStyle,onPress:function onPress(){return _this4.closeToast();},__source:{fileName:_jsxFileName,lineNumber:106}},
_react2.default.createElement(_Text.Text,{style:this.state.buttonTextStyle,__source:{fileName:_jsxFileName,lineNumber:107}},
this.state.buttonText)))));





}else return null;
}}],[{key:"show",value:function show(_ref2){var config=_objectWithoutProperties(_ref2,[]);this.toastInstance._root.showToast({config:config});}}]);return ToastContainer;}(_react.Component);


ToastContainer.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledToastContainer=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.ToastContainer",{},_mapPropsToStyleNames2.default)(ToastContainer);exports.

ToastContainer=StyledToastContainer;
//# sourceMappingURL=ToastContainer.js.map

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.ActionSheetContainer=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Actionsheet.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _Text=__webpack_require__(29);
var _Button=__webpack_require__(58);
var _View=__webpack_require__(107);
var _Icon=__webpack_require__(81);
var _Left=__webpack_require__(70);
var _Right=__webpack_require__(71);
var _Body=__webpack_require__(72);
var _List=__webpack_require__(127);
var _ListItem=__webpack_require__(73);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);
var _Utils=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

ActionSheetContainer=function(_Component){_inherits(ActionSheetContainer,_Component);
function ActionSheetContainer(props){_classCallCheck(this,ActionSheetContainer);var _this=_possibleConstructorReturn(this,(ActionSheetContainer.__proto__||Object.getPrototypeOf(ActionSheetContainer)).call(this,
props));
_this.state={
modalVisible:false,
items:[]};return _this;

}_createClass(ActionSheetContainer,[{key:"showActionSheet",value:function showActionSheet(




config,callback){
if(_reactNative.Platform.OS==="ios"){
if(typeof config.options[0]=="object"){
var options=config.options;
var filtered=options.map(function(item){
return item.text;
});
config.options=filtered;
_reactNative.ActionSheetIOS.showActionSheetWithOptions(config,callback);
}else{
_reactNative.ActionSheetIOS.showActionSheetWithOptions(config,callback);
}
}else{
this.setState({
items:config.options,
title:config.title,
message:config.message,
destructiveButtonIndex:config.destructiveButtonIndex,
cancelButtonIndex:config.cancelButtonIndex,
modalVisible:true,
callback:callback});

}
}},{key:"componentDidMount",value:function componentDidMount()
{
if(!this.props.autoHide&&this.props.duration){
console.warn("It's not recommended to set autoHide false with duration");
}
}},{key:"render",value:function render()
{var _this2=this;
return(
_react2.default.createElement(_reactNative.Modal,{
animationType:"fade",
transparent:true,
visible:this.state.modalVisible,
onRequestClose:function onRequestClose(){
_this2.state.callback(-1);
_this2.setState({modalVisible:false});
},__source:{fileName:_jsxFileName,lineNumber:60}},

_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:1,
onPress:function onPress(){
_this2.state.callback(-1);
_this2.setState({modalVisible:false});
},
style:{
backgroundColor:"rgba(0,0,0,0.4)",
flex:1,
justifyContent:"flex-end"},__source:{fileName:_jsxFileName,lineNumber:69}},


_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:1,
style:{
backgroundColor:"#fff",
height:this.state.length*80,
padding:15,
elevation:4},__source:{fileName:_jsxFileName,lineNumber:81}},


_react2.default.createElement(_Text.Text,{style:{color:"#757575"},__source:{fileName:_jsxFileName,lineNumber:90}},
this.state.title),

_react2.default.createElement(_List.List,{
style:{marginHorizontal:-15,marginTop:15},
dataArray:this.state.items,
renderRow:function renderRow(data,i,id){
return typeof _this2.state.items[0]==="string"?
_react2.default.createElement(_ListItem.ListItem,{
onPress:function onPress(){
_this2.state.callback(id);
_this2.setState({modalVisible:false});
},
style:{borderColor:"transparent"},__source:{fileName:_jsxFileName,lineNumber:98}},

_react2.default.createElement(_Text.Text,{__source:{fileName:_jsxFileName,lineNumber:105}},
data)):


_react2.default.createElement(_ListItem.ListItem,{
onPress:function onPress(){
_this2.state.callback(id);
_this2.setState({modalVisible:false});
},
style:{borderColor:"transparent"},
icon:true,__source:{fileName:_jsxFileName,lineNumber:109}},

_react2.default.createElement(_Left.Left,{__source:{fileName:_jsxFileName,lineNumber:117}},
_react2.default.createElement(_Icon.Icon,{
name:data.icon,
style:{
color:data.iconColor?data.iconColor:undefined},__source:{fileName:_jsxFileName,lineNumber:118}})),



_react2.default.createElement(_Body.Body,{style:{borderColor:"transparent"},__source:{fileName:_jsxFileName,lineNumber:125}},
_react2.default.createElement(_Text.Text,{__source:{fileName:_jsxFileName,lineNumber:126}},
data.text)),


_react2.default.createElement(_Right.Right,{__source:{fileName:_jsxFileName,lineNumber:130}}));

},__source:{fileName:_jsxFileName,lineNumber:93}})))));





}}],[{key:"show",value:function show(config,callback){this.actionsheetInstance._root.showActionSheet(config,callback);}}]);return ActionSheetContainer;}(_react.Component);


ActionSheetContainer.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledActionSheetContainer=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.ActionSheetContainer",{},_mapPropsToStyleNames2.default)(
ActionSheetContainer);exports.


ActionSheetContainer=StyledActionSheetContainer;
//# sourceMappingURL=Actionsheet.js.map

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.List=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='src/basic/List.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(1);
var _nativeBaseShoutemTheme=__webpack_require__(5);

var _SwipeRow=__webpack_require__(185);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

List=function(_Component){_inherits(List,_Component);













function List(props){_classCallCheck(this,List);var _this=_possibleConstructorReturn(this,(List.__proto__||Object.getPrototypeOf(List)).call(this,
props));
_this._rows={};
_this.openCellId=null;
if(props.dataArray&&props.renderRow){
var rowHasChanged=props.rowHasChanged||function(r1,r2){return r1!==r2;};
var ds=new _reactNative.ListView.DataSource({rowHasChanged:rowHasChanged});
_this.state={
dataSource:ds.cloneWithRows(props.dataArray)};

}else{
_this.state={};
}return _this;
}_createClass(List,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(
nextProps){
if(this.state.dataSource){
this.setState({
dataSource:this.state.dataSource.cloneWithRows(nextProps.dataArray)});

}
}},{key:'renderChildren',value:function renderChildren()
{
var childrenArray=_react2.default.Children.map(this.props.children,function(child){return child;});

return childrenArray;
}},{key:'setScrollEnabled',value:function setScrollEnabled(
enable){
this._listView.setNativeProps({scrollEnabled:enable});
}},{key:'safeCloseOpenRow',value:function safeCloseOpenRow()

{

if(this._rows[this.openCellId]._root){
this._rows[this.openCellId]._root.closeRow();
}
}},{key:'rowSwipeGestureBegan',value:function rowSwipeGestureBegan(

id){
if(this.props.closeOnRowBeginSwipe&&this.openCellId&&this.openCellId!==id){
this.safeCloseOpenRow();
}
}},{key:'onRowOpen',value:function onRowOpen(

secId,rowId,rowMap){
var cellIdentifier=''+secId+rowId;
if(this.openCellId&&this.openCellId!==cellIdentifier){
this.safeCloseOpenRow();
}
this.openCellId=cellIdentifier;
this.props.onRowOpen&&this.props.onRowOpen(secId,rowId,rowMap);
}},{key:'onRowPress',value:function onRowPress(

id){
if(this.openCellId){
if(this.props.closeOnRowPress){
this.safeCloseOpenRow();
this.openCellId=null;
}
}
}},{key:'closeRow',value:function closeRow(
id){
if(this.openCellId){
if(this.props.closeOnRowPress){
this.safeCloseOpenRow();
this.openCellId=null;
}
}
}},{key:'onScroll',value:function onScroll(

e){
if(this.openCellId){
if(this.props.closeOnScroll){
this.safeCloseOpenRow();
this.openCellId=null;
}
}
this.props.onScroll&&this.props.onScroll(e);
}},{key:'setRefs',value:function setRefs(

ref){
this._listView=ref;
this.props.listViewRef&&this.props.listViewRef(ref);
}},{key:'renderRow',value:function renderRow(

rowData,secId,rowId,rowMap){var _this2=this;
var previewRowId=
this.props.dataSource&&this.props.dataSource.getRowIDForFlatIndex(this.props.previewRowIndex||0);
return(
_react2.default.createElement(_SwipeRow.SwipeRow,{
list:true,
ref:function ref(row){return _this2._rows[''+secId+rowId]=row;},
swipeGestureBegan:function swipeGestureBegan(_){return _this2.rowSwipeGestureBegan(''+secId+rowId);},
onRowOpen:function onRowOpen(_){return _this2.onRowOpen(secId,rowId,_this2._rows);},
onRowDidOpen:function onRowDidOpen(_){return _this2.props.onRowDidOpen&&_this2.props.onRowDidOpen(secId,rowId,_this2._rows);},
onRowClose:function onRowClose(_){return _this2.props.onRowClose&&_this2.props.onRowClose(secId,rowId,_this2._rows);},
onRowDidClose:function onRowDidClose(_){return _this2.props.onRowDidClose&&_this2.props.onRowDidClose(secId,rowId,_this2._rows);},
onRowPress:function onRowPress(_){return _this2.onRowPress(''+secId+rowId);},
closeRow:function closeRow(_){return _this2.closeRow(''+secId+rowId);},
setScrollEnabled:function setScrollEnabled(enable){return _this2.setScrollEnabled(enable);},
leftOpenValue:this.props.leftOpenValue,
rightOpenValue:this.props.rightOpenValue,
closeOnRowPress:this.props.closeOnRowPress,
disableLeftSwipe:this.props.disableLeftSwipe,
disableRightSwipe:this.props.disableRightSwipe,
stopLeftSwipe:this.props.stopLeftSwipe,
stopRightSwipe:this.props.stopRightSwipe,
recalculateHiddenLayout:this.props.recalculateHiddenLayout,
style:this.props.swipeRowStyle,
preview:(this.props.previewFirstRow||this.props.previewRowIndex)&&rowId===previewRowId,
previewDuration:this.props.previewDuration,
previewOpenValue:this.props.previewOpenValue,
tension:this.props.tension,
friction:this.props.friction,
directionalDistanceChangeThreshold:this.props.directionalDistanceChangeThreshold,
swipeToOpenPercent:this.props.swipeToOpenPercent,
left:this.props.renderLeftHiddenRow(rowData,secId,rowId,this._rows),
right:this.props.renderRightHiddenRow(rowData,secId,rowId,this._rows),
body:this.props.renderRow(rowData,secId,rowId,this._rows),__source:{fileName:_jsxFileName,lineNumber:110}}));


}},{key:'render',value:function render()
{var _this3=this;
if(this.props.renderLeftHiddenRow||this.props.renderRightHiddenRow){
return(
_react2.default.createElement(_reactNative.ListView,_extends({},
this.props,{
ref:function ref(_ref){
_this3.setRefs(_ref);
_this3._root=_ref;
},
onScroll:function onScroll(e){return _this3.onScroll(e);},
renderRow:function renderRow(rowData,secId,rowId){return _this3.renderRow(rowData,secId,rowId,_this3._rows);},__source:{fileName:_jsxFileName,lineNumber:146}})));


}else if(this.state.dataSource){
return(
_react2.default.createElement(_reactNative.ListView,_extends({},
this.props,{
ref:function ref(_ref2){return _this3._root=_ref2;},
enableEmptySections:true,
dataSource:this.state.dataSource,
renderRow:this.props.renderRow,__source:{fileName:_jsxFileName,lineNumber:158}})));


}
return(
_react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this3._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:168}}),
this.renderChildren()));


}}]);return List;}(_react.Component);List.defaultProps={leftOpenValue:0,rightOpenValue:0,closeOnRowBeginSwipe:false,closeOnScroll:true,closeOnRowPress:true,disableLeftSwipe:false,disableRightSwipe:false,recalculateHiddenLayout:false,previewFirstRow:false,directionalDistanceChangeThreshold:2,swipeToOpenPercent:50};

var StyledList=(0,_nativeBaseShoutemTheme.connectStyle)('NativeBase.List',{},_mapPropsToStyleNames2.default)(List);exports.

List=StyledList;
//# sourceMappingURL=List.js.map

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SceneView=function(_PureComponent){_inherits(SceneView,_PureComponent);function SceneView(){_classCallCheck(this,SceneView);return _possibleConstructorReturn(this,(SceneView.__proto__||Object.getPrototypeOf(SceneView)).apply(this,arguments));}_createClass(SceneView,[{key:'getChildContext',value:function getChildContext(){return{navigation:this.props.navigation};}},{key:'render',value:function render(){var _props=this.props,screenProps=_props.screenProps,navigation=_props.navigation,Component=_props.component;return _react2.default.createElement(Component,{screenProps:screenProps,navigation:navigation});}}]);return SceneView;}(_react.PureComponent);SceneView.childContextTypes={navigation:_propTypes2.default.object.isRequired};exports.default=SceneView;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=getScreenForRouteName;var _invariant=__webpack_require__(25);var _invariant2=_interopRequireDefault(_invariant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Simple helper that gets a single screen (React component or navigator)
 * out of the navigator config.
 */function getScreenForRouteName(// eslint-disable-line consistent-return
routeConfigs,routeName){var routeConfig=routeConfigs[routeName];if(!routeConfig){throw new Error('There is no route defined for key '+routeName+'.\n'+('Must be one of: '+Object.keys(routeConfigs).map(function(a){return'\''+a+'\'';}).join(',')));}if(routeConfig.screen){return routeConfig.screen;}if(typeof routeConfig.getScreen==='function'){var screen=routeConfig.getScreen();(0,_invariant2.default)(typeof screen==='function','The getScreen defined for route \''+routeName+' didn\'t return a valid '+'screen or navigator.\n\n'+'Please pass it like this:\n'+(routeName+': {\n  getScreen: () => require(\'./MyScreen\').default\n}'));return screen;}throw new Error('Route '+routeName+' must define a screen or a getScreen.');}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var STACK='react-navigation/STACK';var TABS='react-navigation/TABS';var DRAWER='react-navigation/DRAWER';exports.default={STACK:STACK,TABS:TABS,DRAWER:DRAWER};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _invariant=__webpack_require__(25);var _invariant2=_interopRequireDefault(_invariant);var _getScreenForRouteName=__webpack_require__(129);var _getScreenForRouteName2=_interopRequireDefault(_getScreenForRouteName);var _createConfigGetter=__webpack_require__(238);var _createConfigGetter2=_interopRequireDefault(_createConfigGetter);var _NavigationActions=__webpack_require__(39);var _NavigationActions2=_interopRequireDefault(_NavigationActions);var _validateRouteConfigMap=__webpack_require__(239);var _validateRouteConfigMap2=_interopRequireDefault(_validateRouteConfigMap);var _getScreenConfigDeprecated=__webpack_require__(240);var _getScreenConfigDeprecated2=_interopRequireDefault(_getScreenConfigDeprecated);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default=function(routeConfigs){var config=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};// Fail fast on invalid route definitions
(0,_validateRouteConfigMap2.default)(routeConfigs);var order=config.order||Object.keys(routeConfigs);var paths=config.paths||{};var initialRouteName=config.initialRouteName||order[0];var initialRouteIndex=order.indexOf(initialRouteName);var backBehavior=config.backBehavior||'initialRoute';var shouldBackNavigateToInitialRoute=backBehavior==='initialRoute';var tabRouters={};order.forEach(function(routeName){var routeConfig=routeConfigs[routeName];paths[routeName]=typeof routeConfig.path==='string'?routeConfig.path:routeName;tabRouters[routeName]=null;if(routeConfig.screen&&routeConfig.screen.router){tabRouters[routeName]=routeConfig.screen.router;}});if(initialRouteIndex===-1){throw new Error('Invalid initialRouteName \''+initialRouteName+'\' for TabRouter. '+('Should be one of '+order.map(function(n){return'"'+n+'"';}).join(', ')));}return{getStateForAction:function getStateForAction(action,inputState){// eslint-disable-next-line no-param-reassign
action=_NavigationActions2.default.mapDeprecatedActionAndWarn(action);// Establish a default state
var state=inputState;if(!state){var _routes=order.map(function(routeName){var tabRouter=tabRouters[routeName];if(tabRouter){var childAction=action.action||_NavigationActions2.default.init(_extends({},action.params?{params:action.params}:{}));return _extends({},tabRouter.getStateForAction(childAction),{key:routeName,routeName:routeName});}return{key:routeName,routeName:routeName};});state={routes:_routes,index:initialRouteIndex};// console.log(`${order.join('-')}: Initial state`, {state});
}if(action.type===_NavigationActions2.default.INIT){// Merge any params from the action into all the child routes
var _action=action,params=_action.params;if(params){state.routes=state.routes.map(function(route){return _extends({},route,{params:_extends({},route.params,params)});});}}// Let the current tab handle it
var activeTabLastState=state.routes[state.index];var activeTabRouter=tabRouters[order[state.index]];if(activeTabRouter){var activeTabState=activeTabRouter.getStateForAction(action.action||action,activeTabLastState);if(!activeTabState&&inputState){return null;}if(activeTabState&&activeTabState!==activeTabLastState){var _routes2=[].concat(_toConsumableArray(state.routes));_routes2[state.index]=activeTabState;return _extends({},state,{routes:_routes2});}}// Handle tab changing. Do this after letting the current tab try to
// handle the action, to allow inner tabs to change first
var activeTabIndex=state.index;var isBackEligible=action.key==null||action.key===activeTabLastState.key;if(action.type===_NavigationActions2.default.BACK&&isBackEligible&&shouldBackNavigateToInitialRoute){activeTabIndex=initialRouteIndex;}var didNavigate=false;if(action.type===_NavigationActions2.default.NAVIGATE){var navigateAction=action;didNavigate=!!order.find(function(tabId,i){if(tabId===navigateAction.routeName){activeTabIndex=i;return true;}return false;});if(didNavigate){var childState=state.routes[activeTabIndex];var newChildState=void 0;var tabRouter=tabRouters[action.routeName];if(action.action){newChildState=tabRouter?tabRouter.getStateForAction(action.action,childState):null;}else if(!tabRouter&&action.params){newChildState=_extends({},childState,{params:_extends({},childState.params||{},action.params)});}if(newChildState&&newChildState!==childState){var _routes3=[].concat(_toConsumableArray(state.routes));_routes3[activeTabIndex]=newChildState;return _extends({},state,{routes:_routes3,index:activeTabIndex});}}}if(action.type===_NavigationActions2.default.SET_PARAMS){var lastRoute=state.routes.find(/* $FlowFixMe */function(route){return route.key===action.key;});if(lastRoute){var _params=_extends({},lastRoute.params,action.params);var _routes4=[].concat(_toConsumableArray(state.routes));_routes4[state.routes.indexOf(lastRoute)]=_extends({},lastRoute,{params:_params});return _extends({},state,{routes:_routes4});}}if(activeTabIndex!==state.index){return _extends({},state,{index:activeTabIndex});}else if(didNavigate&&!inputState){return state;}else if(didNavigate){return null;}// Let other tabs handle it and switch to the first tab that returns a new state
var index=state.index;/* $FlowFixMe */var routes=state.routes;order.find(function(tabId,i){var tabRouter=tabRouters[tabId];if(i===index){return false;}var tabState=routes[i];if(tabRouter){// console.log(`${order.join('-')}: Processing child router:`, {action, tabState});
tabState=tabRouter.getStateForAction(action,tabState);}if(!tabState){index=i;return true;}if(tabState!==routes[i]){routes=[].concat(_toConsumableArray(routes));routes[i]=tabState;index=i;return true;}return false;});// console.log(`${order.join('-')}: Processed other tabs:`, {lastIndex: state.index, index});
if(index!==state.index||routes!==state.routes){return _extends({},state,{index:index,routes:routes});}return state;},getComponentForState:function getComponentForState(state){var routeName=order[state.index];(0,_invariant2.default)(routeName,'There is no route defined for index '+state.index+'. Check that\n        that you passed in a navigation state with a valid tab/screen index.');var childRouter=tabRouters[routeName];if(childRouter){return childRouter.getComponentForState(state.routes[state.index]);}return(0,_getScreenForRouteName2.default)(routeConfigs,routeName);},getComponentForRouteName:function getComponentForRouteName(routeName){return(0,_getScreenForRouteName2.default)(routeConfigs,routeName);},getPathAndParamsForState:function getPathAndParamsForState(state){var route=state.routes[state.index];var routeName=order[state.index];var subPath=paths[routeName];var screen=(0,_getScreenForRouteName2.default)(routeConfigs,routeName);var path=subPath;var params=route.params;if(screen&&screen.router){// If it has a router it's a navigator.
// If it doesn't have router it's an ordinary React component.
var child=screen.router.getPathAndParamsForState(route);path=subPath?subPath+'/'+child.path:child.path;params=child.params?_extends({},params,child.params):params;}return{path:path,params:params};},/**
     * Gets an optional action, based on a relative path and query params.
     *
     * This will return null if there is no action matched
     */getActionForPathAndParams:function getActionForPathAndParams(path,params){return order.map(function(tabId){var parts=path.split('/');var pathToTest=paths[tabId];if(parts[0]===pathToTest){var tabRouter=tabRouters[tabId];var action=_NavigationActions2.default.navigate({routeName:tabId});if(tabRouter&&tabRouter.getActionForPathAndParams){action.action=tabRouter.getActionForPathAndParams(parts.slice(1).join('/'),params);}else if(params){action.params=params;}return action;}return null;}).find(function(action){return!!action;})||order.map(function(tabId){var tabRouter=tabRouters[tabId];return tabRouter&&tabRouter.getActionForPathAndParams(path,params);}).find(function(action){return!!action;})||null;},getScreenOptions:(0,_createConfigGetter2.default)(routeConfigs,config.navigationOptions),getScreenConfig:_getScreenConfigDeprecated2.default};};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=withCachedChildNavigation;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _addNavigationHelpers=__webpack_require__(48);var _addNavigationHelpers2=_interopRequireDefault(_addNavigationHelpers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * HOC which caches the child navigation items.
 */function withCachedChildNavigation(Comp){var _class,_temp2;return _temp2=_class=function(_PureComponent){_inherits(_class,_PureComponent);function _class(){var _ref;var _temp,_this,_ret;_classCallCheck(this,_class);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=_class.__proto__||Object.getPrototypeOf(_class)).call.apply(_ref,[this].concat(args))),_this),_this._updateNavigationProps=function(navigation){// Update props for each child route
if(!_this._childNavigationProps){_this._childNavigationProps={};}navigation.state.routes.forEach(function(route){var childNavigation=_this._childNavigationProps[route.key];if(childNavigation&&childNavigation.state===route){return;}_this._childNavigationProps[route.key]=(0,_addNavigationHelpers2.default)(_extends({},navigation,{state:route}));});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(_class,[{key:'componentWillMount',value:function componentWillMount(){this._updateNavigationProps(this.props.navigation);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this._updateNavigationProps(nextProps.navigation);}},{key:'render',value:function render(){return _react2.default.createElement(Comp,_extends({},this.props,{childNavigationProps:this._childNavigationProps}));}}]);return _class;}(_react.PureComponent),_class.displayName='withCachedChildNavigation('+(Comp.displayName||Comp.name)+')',_temp2;}

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FBFAFA"}});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FFF"}});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FFF"},text:{alignSelf:"center",marginBottom:7},mb:{marginBottom:15}});

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/swiper-1.e101d414.png";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/swiper-2.6a3d6c1f.png";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/drawer-cover.a21012ec.png";

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#fff"}});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabOne; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(50);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TabOne=function(_Component){_inherits(TabOne,_Component);function TabOne(){_classCallCheck(this,TabOne);return _possibleConstructorReturn(this,(TabOne.__proto__||Object.getPrototypeOf(TabOne)).apply(this,arguments));}_createClass(TabOne,[{key:'render',// eslint-disable-line
value:function render(){// eslint-disable-line
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Card"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,'NativeBase is open source and free.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,'Platform specific codebase for components.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,'Any native third-party libraries can be included.')))));}}]);return TabOne;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabTwo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(50);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TabTwo=function(_Component){_inherits(TabTwo,_Component);function TabTwo(){_classCallCheck(this,TabTwo);return _possibleConstructorReturn(this,(TabTwo.__proto__||Object.getPrototypeOf(TabTwo)).apply(this,arguments));}_createClass(TabTwo,[{key:'render',// eslint-disable-line
value:function render(){// eslint-disable-line
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true,style:{marginTop:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Card"],{style:{flex:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,'NativeBase builds a layer on top of React Native that provides you with basic set of components for mobile application development. This helps you to build world-class application experiences on native platforms.')))));}}]);return TabTwo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabThree; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(50);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TabThree=function(_Component){_inherits(TabThree,_Component);function TabThree(){_classCallCheck(this,TabThree);return _possibleConstructorReturn(this,(TabThree.__proto__||Object.getPrototypeOf(TabThree)).apply(this,arguments));}_createClass(TabThree,[{key:"render",// eslint-disable-line
value:function render(){// eslint-disable-line
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true,style:{marginTop:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Card"],{style:{flex:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"NativeBase is a free and open source framework that enables developers to build high-quality mobile apps using React Native apps with a fusion of ES6.")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Card"],{style:{flex:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"NativeBase gives you the potential of building applications that run on both platforms using a single codebase.")))));}}]);return TabThree;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(260);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 144 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var emptyArray=[];var emptyFunction=function emptyFunction(){};var normalizeTouches=function normalizeTouches(touches){if(!touches){return emptyArray;}return Array.prototype.slice.call(touches).map(function(touch){var identifier=touch.identifier>20?touch.identifier%20:touch.identifier;var locationX=void 0,locationY=void 0;var node=touch.target;if(node){var isElement=node.nodeType===1;if(isElement&&typeof node.getBoundingClientRect==='function'){var rect=node.getBoundingClientRect();locationX=touch.pageX-rect.left;locationY=touch.pageY-rect.top;}}return{_normalized:true,clientX:touch.clientX,clientY:touch.clientY,force:touch.force,locationX:locationX,locationY:locationY,identifier:identifier,pageX:touch.pageX,pageY:touch.pageY,radiusX:touch.radiusX,radiusY:touch.radiusY,rotationAngle:touch.rotationAngle,screenX:touch.screenX,screenY:touch.screenY,target:touch.target,timestamp:Date.now()};});};function normalizeTouchEvent(nativeEvent){var changedTouches=normalizeTouches(nativeEvent.changedTouches);var touches=normalizeTouches(nativeEvent.touches);var preventDefault=typeof nativeEvent.preventDefault==='function'?nativeEvent.preventDefault.bind(nativeEvent):emptyFunction;var stopImmediatePropagation=typeof nativeEvent.stopImmediatePropagation==='function'?nativeEvent.stopImmediatePropagation.bind(nativeEvent):emptyFunction;var stopPropagation=typeof nativeEvent.stopPropagation==='function'?nativeEvent.stopPropagation.bind(nativeEvent):emptyFunction;var event={_normalized:true,changedTouches:changedTouches,identifier:undefined,locationX:undefined,locationY:undefined,pageX:nativeEvent.pageX,pageY:nativeEvent.pageY,preventDefault:preventDefault,stopImmediatePropagation:stopImmediatePropagation,stopPropagation:stopPropagation,target:nativeEvent.target,timestamp:Date.now(),touches:touches};if(changedTouches[0]){event.identifier=changedTouches[0].identifier;event.pageX=changedTouches[0].pageX;event.pageY=changedTouches[0].pageY;event.locationX=changedTouches[0].locationX;event.locationY=changedTouches[0].locationY;}return event;}function normalizeMouseEvent(nativeEvent){var touches=[{_normalized:true,clientX:nativeEvent.clientX,clientY:nativeEvent.clientY,force:nativeEvent.force,locationX:nativeEvent.clientX,locationY:nativeEvent.clientY,identifier:0,pageX:nativeEvent.pageX,pageY:nativeEvent.pageY,screenX:nativeEvent.screenX,screenY:nativeEvent.screenY,target:nativeEvent.target,timestamp:Date.now()}];var preventDefault=typeof nativeEvent.preventDefault==='function'?nativeEvent.preventDefault.bind(nativeEvent):emptyFunction;var stopImmediatePropagation=typeof nativeEvent.stopImmediatePropagation==='function'?nativeEvent.stopImmediatePropagation.bind(nativeEvent):emptyFunction;var stopPropagation=typeof nativeEvent.stopPropagation==='function'?nativeEvent.stopPropagation.bind(nativeEvent):emptyFunction;return{_normalized:true,changedTouches:touches,identifier:touches[0].identifier,locationX:nativeEvent.offsetX,locationY:nativeEvent.offsetY,pageX:nativeEvent.pageX,pageY:nativeEvent.pageY,preventDefault:preventDefault,stopImmediatePropagation:stopImmediatePropagation,stopPropagation:stopPropagation,target:nativeEvent.target,timestamp:touches[0].timestamp,touches:nativeEvent.type==='mouseup'?emptyArray:touches};}function normalizeNativeEvent(nativeEvent){if(!nativeEvent||nativeEvent._normalized){return nativeEvent;}var eventType=nativeEvent.type||'';var mouse=eventType.indexOf('mouse')>=0;if(mouse){return normalizeMouseEvent(nativeEvent);}else{return normalizeTouchEvent(nativeEvent);}}exports.default=normalizeNativeEvent;

/***/ }),
/* 145 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var isDisabled=function isDisabled(props){return props.disabled||props['aria-disabled'];};exports.default=isDisabled;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _AccessibilityUtil=__webpack_require__(87);var _AccessibilityUtil2=_interopRequireDefault(_AccessibilityUtil);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _registry=__webpack_require__(89);var _registry2=_interopRequireDefault(_registry);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var emptyObject={};var resetStyles=_StyleSheet2.default.create({ariaButton:{cursor:'pointer'},button:{appearance:'none',backgroundColor:'transparent',color:'inherit',font:'inherit',textAlign:'inherit'},heading:{font:'inherit'},link:{backgroundColor:'transparent',color:'inherit',textDecorationLine:'none'},list:{listStyle:'none'}});var pointerEventsStyles=_StyleSheet2.default.create({auto:{pointerEvents:'auto'},'box-none':{pointerEvents:'box-none'},'box-only':{pointerEvents:'box-only'},none:{pointerEvents:'none'}});var defaultStyleResolver=function defaultStyleResolver(style){return _registry2.default.resolve(style);};var createDOMProps=function createDOMProps(component,props,styleResolver){if(!styleResolver){styleResolver=defaultStyleResolver;}if(!props){props=emptyObject;}var _props=props,accessibilityLabel=_props.accessibilityLabel,accessibilityLiveRegion=_props.accessibilityLiveRegion,importantForAccessibility=_props.importantForAccessibility,pointerEvents=_props.pointerEvents,providedStyle=_props.style,testID=_props.testID,accessible=_props.accessible,accessibilityComponentType=_props.accessibilityComponentType,accessibilityRole=_props.accessibilityRole,accessibilityTraits=_props.accessibilityTraits,domProps=_objectWithoutProperties(_props,['accessibilityLabel','accessibilityLiveRegion','importantForAccessibility','pointerEvents','style','testID','accessible','accessibilityComponentType','accessibilityRole','accessibilityTraits']);var isDisabled=_AccessibilityUtil2.default.isDisabled(props);var role=_AccessibilityUtil2.default.propsToAriaRole(props);var tabIndex=_AccessibilityUtil2.default.propsToTabIndex(props);var reactNativeStyle=[component==='a'&&resetStyles.link,component==='button'&&resetStyles.button,role==='heading'&&resetStyles.heading,component==='ul'&&resetStyles.list,role==='button'&&!isDisabled&&resetStyles.ariaButton,providedStyle,pointerEvents&&pointerEventsStyles[pointerEvents]];var _styleResolver=styleResolver(reactNativeStyle),className=_styleResolver.className,style=_styleResolver.style;if(isDisabled){domProps['aria-disabled']=true;}if(importantForAccessibility==='no-hide-descendants'){domProps['aria-hidden']=true;}if(accessibilityLabel&&accessibilityLabel.constructor===String){domProps['aria-label']=accessibilityLabel;}if(accessibilityLiveRegion&&accessibilityLiveRegion.constructor===String){domProps['aria-live']=accessibilityLiveRegion==='none'?'off':accessibilityLiveRegion;}if(className&&className.constructor===String){domProps.className=domProps.className?domProps.className+' '+className:className;}if(component==='a'&&domProps.target==='_blank'){domProps.rel=(domProps.rel||'')+' noopener noreferrer';}if(role&&role.constructor===String&&role!=='label'){domProps.role=role;}if(style){domProps.style=style;}if(tabIndex){domProps.tabIndex=tabIndex;}if(testID&&testID.constructor===String){domProps['data-testid']=testID;}return domProps;};exports.default=createDOMProps;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _ReactNativePropRegistry=__webpack_require__(148);var _ReactNativePropRegistry2=_interopRequireDefault(_ReactNativePropRegistry);var _invariant=__webpack_require__(8);var _invariant2=_interopRequireDefault(_invariant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function getStyle(style){if(typeof style==='number'){return _ReactNativePropRegistry2.default.getByID(style);}return style;}function flattenStyle(style){if(style==null||typeof style==='boolean'){return undefined;}if(false){(0,_invariant2.default)(style!==true,'style may be false but not true');}if(!Array.isArray(style)){return getStyle(style);}var result={};for(var i=0,styleLength=style.length;i<styleLength;++i){var computedStyle=flattenStyle(style[i]);if(computedStyle){for(var key in computedStyle){var value=computedStyle[key];result[key]=value;}}}return result;}exports.default=flattenStyle;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var emptyObject={};var objects={};var prefix='r';var uniqueID=1;var createKey=function createKey(id){return prefix+'-'+id;};var ReactNativePropRegistry=function(){function ReactNativePropRegistry(){_classCallCheck(this,ReactNativePropRegistry);}_createClass(ReactNativePropRegistry,null,[{key:'register',value:function register(object){var id=uniqueID++;if(false){Object.freeze(object);}var key=createKey(id);objects[key]=object;return id;}},{key:'getByID',value:function getByID(id){if(!id){return emptyObject;}var key=createKey(id);var object=objects[key];if(!object){console.warn('Invalid style with id `'+id+'`. Skipping ...');return emptyObject;}return object;}}]);return ReactNativePropRegistry;}();exports.default=ReactNativePropRegistry;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _unitlessNumbers=__webpack_require__(150);var _unitlessNumbers2=_interopRequireDefault(_unitlessNumbers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var normalizeValue=function normalizeValue(property,value){if(!_unitlessNumbers2.default[property]&&typeof value==='number'){value=value+'px';}return value;};exports.default=normalizeValue;

/***/ }),
/* 150 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var unitlessNumbers={animationIterationCount:true,borderImageOutset:true,borderImageSlice:true,borderImageWidth:true,boxFlex:true,boxFlexGroup:true,boxOrdinalGroup:true,columnCount:true,flex:true,flexGrow:true,flexOrder:true,flexPositive:true,flexShrink:true,flexNegative:true,fontWeight:true,gridRow:true,gridColumn:true,lineClamp:true,opacity:true,order:true,orphans:true,tabSize:true,widows:true,zIndex:true,zoom:true,fillOpacity:true,floodOpacity:true,stopOpacity:true,strokeDasharray:true,strokeDashoffset:true,strokeMiterlimit:true,strokeOpacity:true,strokeWidth:true,scale:true,scaleX:true,scaleY:true,scaleZ:true,shadowOpacity:true};var prefixes=['ms','Moz','O','Webkit'];var prefixKey=function prefixKey(prefix,key){return prefix+key.charAt(0).toUpperCase()+key.substring(1);};Object.keys(unitlessNumbers).forEach(function(prop){prefixes.forEach(function(prefix){unitlessNumbers[prefixKey(prefix,prop)]=unitlessNumbers[prop];});});exports.default=unitlessNumbers;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _normalizeCssColor=__webpack_require__(62);var _normalizeCssColor2=_interopRequireDefault(_normalizeCssColor);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var processColor=function processColor(color){var opacity=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;if(color===undefined||color===null||opacity===1&&typeof color==='string'&&color.charAt(0)!=='#'){return color;}var int32Color=(0,_normalizeCssColor2.default)(color);if(int32Color===null){return undefined;}var rgba=_normalizeCssColor2.default.rgba(int32Color);rgba.a=rgba.a.toFixed(1);var r=rgba.r,g=rgba.g,b=rgba.b,a=rgba.a;return'rgba('+r+','+g+','+b+','+a*opacity+')';};exports.default=processColor;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _I18nManager=__webpack_require__(90);var _I18nManager2=_interopRequireDefault(_I18nManager);var _multiplyStyleLengthValue=__webpack_require__(153);var _multiplyStyleLengthValue2=_interopRequireDefault(_multiplyStyleLengthValue);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var emptyObject={};var PROPERTIES_TO_SWAP={borderTopLeftRadius:'borderTopRightRadius',borderTopRightRadius:'borderTopLeftRadius',borderBottomLeftRadius:'borderBottomRightRadius',borderBottomRightRadius:'borderBottomLeftRadius',borderLeftColor:'borderRightColor',borderLeftStyle:'borderRightStyle',borderLeftWidth:'borderRightWidth',borderRightColor:'borderLeftColor',borderRightWidth:'borderLeftWidth',borderRightStyle:'borderLeftStyle',left:'right',marginLeft:'marginRight',marginRight:'marginLeft',paddingLeft:'paddingRight',paddingRight:'paddingLeft',right:'left'};var PROPERTIES_SWAP_LEFT_RIGHT={clear:true,float:true,textAlign:true};var additiveInverse=function additiveInverse(value){return(0,_multiplyStyleLengthValue2.default)(value,-1);};var flipProperty=function flipProperty(prop){return PROPERTIES_TO_SWAP.hasOwnProperty(prop)?PROPERTIES_TO_SWAP[prop]:prop;};var swapLeftRight=function swapLeftRight(value){return value==='left'?'right':value==='right'?'left':value;};var i18nStyle=function i18nStyle(originalStyle){if(!_I18nManager2.default.isRTL){return originalStyle;}var style=originalStyle||emptyObject;var nextStyle={};for(var prop in style){if(!Object.prototype.hasOwnProperty.call(style,prop)){continue;}var value=style[prop];if(PROPERTIES_TO_SWAP[prop]){var newProp=flipProperty(prop);nextStyle[newProp]=value;}else if(PROPERTIES_SWAP_LEFT_RIGHT[prop]){nextStyle[prop]=swapLeftRight(value);}else if(prop==='textShadowOffset'){nextStyle[prop]=value;nextStyle[prop].width=additiveInverse(value.width);}else{nextStyle[prop]=style[prop];}}return nextStyle;};exports.default=i18nStyle;

/***/ }),
/* 153 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var CSS_UNIT_RE=/^[+-]?\d*(?:\.\d+)?(?:[Ee][+-]?\d+)?(%|\w*)/;var getUnit=function getUnit(str){return str.match(CSS_UNIT_RE)[1];};var isNumeric=function isNumeric(n){return!isNaN(parseFloat(n))&&isFinite(n);};var multiplyStyleLengthValue=function multiplyStyleLengthValue(value,multiple){if(typeof value==='string'){var number=parseFloat(value)*multiple;var unit=getUnit(value);return''+number+unit;}else if(isNumeric(value)){return value*multiple;}};exports.default=multiplyStyleLengthValue;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.prefixInlineStyles=undefined;var _createPrefixer=__webpack_require__(283);var _createPrefixer2=_interopRequireDefault(_createPrefixer);var _static=__webpack_require__(288);var _static2=_interopRequireDefault(_static);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var prefixAll=(0,_createPrefixer2.default)(_static2.default);exports.default=prefixAll;var prefixInlineStyles=exports.prefixInlineStyles=function prefixInlineStyles(style){var prefixedStyles=prefixAll(style);Object.keys(prefixedStyles).forEach(function(prop){var value=prefixedStyles[prop];if(Array.isArray(value)){prefixedStyles[prop]=value[value.length-1];}});return prefixedStyles;};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";












var InteractionManager={
current:{
createInteractionHandle:function createInteractionHandle(){},
clearInteractionHandle:function clearInteractionHandle(){}},

inject:function inject(manager){
InteractionManager.current=manager;
}};


module.exports=InteractionManager;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}

var _bezier=__webpack_require__(318);var






Easing=function(){function Easing(){_classCallCheck(this,Easing);}_createClass(Easing,null,[{key:'step0',value:function step0(
n){
return n>0?1:0;
}},{key:'step1',value:function step1(

n){
return n>=1?1:0;
}},{key:'linear',value:function linear(

t){
return t;
}},{key:'ease',value:function ease(

t){
return _ease(t);
}},{key:'quad',value:function quad(

t){
return t*t;
}},{key:'cubic',value:function cubic(

t){
return t*t*t;
}},{key:'poly',value:function poly(

n){
return function(t){return Math.pow(t,n);};
}},{key:'sin',value:function sin(

t){
return 1-Math.cos(t*Math.PI/2);
}},{key:'circle',value:function circle(

t){
return 1-Math.sqrt(1-t*t);
}},{key:'exp',value:function exp(

t){
return Math.pow(2,10*(t-1));
}},{key:'elastic',value:function elastic()











{var bounciness=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;
var p=bounciness*Math.PI;
return function(t){return 1-Math.pow(Math.cos(t*Math.PI/2),3)*Math.cos(t*p);};
}},{key:'back',value:function back(

s){
if(s===undefined){
s=1.70158;
}
return function(t){return t*t*((s+1)*t-s);};
}},{key:'bounce',value:function bounce(

t){
if(t<1/2.75){
return 7.5625*t*t;
}

if(t<2/2.75){
t-=1.5/2.75;
return 7.5625*t*t+0.75;
}

if(t<2.5/2.75){
t-=2.25/2.75;
return 7.5625*t*t+0.9375;
}

t-=2.625/2.75;
return 7.5625*t*t+0.984375;
}},{key:'bezier',value:function bezier(


x1,
y1,
x2,
y2)
{
return _bezier(x1,y1,x2,y2);
}},{key:'in',value:function _in(


easing)
{
return easing;
}},{key:'out',value:function out(





easing)
{
return function(t){return 1-easing(1-t);};
}},{key:'inOut',value:function inOut(





easing)
{
return function(t){
if(t<0.5){
return easing(t*2)/2;
}
return 1-easing((1-t)*2)/2;
};
}}]);return Easing;}();


var _ease=Easing.bezier(0.42,0,1,1);



module.exports=Easing;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var Animated=__webpack_require__(13);
var AnimatedStyle=__webpack_require__(323);var

AnimatedProps=function(_Animated){_inherits(AnimatedProps,_Animated);



function AnimatedProps(
props,
callback)
{_classCallCheck(this,AnimatedProps);var _this=_possibleConstructorReturn(this,(AnimatedProps.__proto__||Object.getPrototypeOf(AnimatedProps)).call(this));

if(props.style){
props=_extends({},
props,{
style:new AnimatedStyle(props.style)});

}
_this._props=props;
_this._callback=callback;
_this.__attach();return _this;
}_createClass(AnimatedProps,[{key:'__getValue',value:function __getValue()

{
var props={};
for(var key in this._props){
var value=this._props[key];
if(value instanceof Animated){
props[key]=value.__getValue();
}else{
props[key]=value;
}
}
return props;
}},{key:'__getAnimatedValue',value:function __getAnimatedValue()

{
var props={};
for(var key in this._props){
var value=this._props[key];
if(value instanceof Animated){
props[key]=value.__getAnimatedValue();
}
}
return props;
}},{key:'__attach',value:function __attach()

{
for(var key in this._props){
var value=this._props[key];
if(value instanceof Animated){
value.__addChild(this);
}
}
}},{key:'__detach',value:function __detach()

{
for(var key in this._props){
var value=this._props[key];
if(value instanceof Animated){
value.__removeChild(this);
}
}
}},{key:'update',value:function update()

{
this._callback();
}}]);return AnimatedProps;}(Animated);


module.exports=AnimatedProps;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";












var FlattenStyle={
current:function current(style){return style;},
inject:function inject(flatten){
FlattenStyle.current=flatten;
}};


module.exports=FlattenStyle;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";












var ApplyAnimatedValues={
current:function ApplyAnimatedValues(instance,props){
if(instance.setNativeProps){
instance.setNativeProps(props);
}else{
return false;
}
},
inject:function inject(apply){
ApplyAnimatedValues.current=apply;
}};


module.exports=ApplyAnimatedValues;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='src/components/Image/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _applyNativeMethods=__webpack_require__(18);var _applyNativeMethods2=_interopRequireDefault(_applyNativeMethods);var _createElement=__webpack_require__(41);var _createElement2=_interopRequireDefault(_createElement);var _AssetRegistry=__webpack_require__(333);var _ImageLoader=__webpack_require__(334);var _ImageLoader2=_interopRequireDefault(_ImageLoader);var _ImageResizeMode=__webpack_require__(164);var _ImageResizeMode2=_interopRequireDefault(_ImageResizeMode);var _ImageStylePropTypes=__webpack_require__(335);var _ImageStylePropTypes2=_interopRequireDefault(_ImageStylePropTypes);var _ImageUriCache=__webpack_require__(338);var _ImageUriCache2=_interopRequireDefault(_ImageUriCache);var _requestIdleCallback=__webpack_require__(339);var _requestIdleCallback2=_interopRequireDefault(_requestIdleCallback);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _StyleSheetPropType=__webpack_require__(56);var _StyleSheetPropType2=_interopRequireDefault(_StyleSheetPropType);var _View=__webpack_require__(11);var _View2=_interopRequireDefault(_View);var _ViewPropTypes=__webpack_require__(15);var _ViewPropTypes2=_interopRequireDefault(_ViewPropTypes);var _propTypes=__webpack_require__(3);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toArray(arr){return Array.isArray(arr)?arr:Array.from(arr);}var emptyObject={};var STATUS_ERRORED='ERRORED';var STATUS_LOADED='LOADED';var STATUS_LOADING='LOADING';var STATUS_PENDING='PENDING';var STATUS_IDLE='IDLE';var ImageSourcePropType=(0,_propTypes.oneOfType)([_propTypes.number,(0,_propTypes.shape)({height:_propTypes.number,uri:_propTypes.string.isRequired,width:_propTypes.number}),_propTypes.string]);var getImageState=function getImageState(uri,shouldDisplaySource){return shouldDisplaySource?STATUS_LOADED:uri?STATUS_PENDING:STATUS_IDLE;};var resolveAssetDimensions=function resolveAssetDimensions(source){if(typeof source==='number'){var _getAssetByID=(0,_AssetRegistry.getAssetByID)(source),height=_getAssetByID.height,width=_getAssetByID.width;return{height:height,width:width};}else if(typeof source==='object'){var _height=source.height,_width=source.width;return{height:_height,width:_width};}};var svgDataUriPattern=/^data:image\/svg\+xml;/;var resolveAssetSource=function resolveAssetSource(source){var uri=void 0;if(typeof source==='number'){var asset=(0,_AssetRegistry.getAssetByID)(source);var scale=asset.scales[0];var scaleSuffix=scale!==1?'@'+scale+'x':'';uri=asset?asset.httpServerLocation+'/'+asset.name+scaleSuffix+'.'+asset.type:'';}else if(source&&source.uri){uri=source.uri;}else{uri=source||'';}if(svgDataUriPattern.test(uri)){var parts=uri.split('<svg');var _parts=_toArray(parts),prefix=_parts[0],svgFragment=_parts.slice(1);var svg=encodeURIComponent('<svg'+svgFragment.join('<svg'));return''+prefix+svg;}return uri;};var Image=function(_Component){_inherits(Image,_Component);_createClass(Image,null,[{key:'getSize',value:function getSize(uri,success,failure){_ImageLoader2.default.getSize(uri,success,failure);}},{key:'prefetch',value:function prefetch(uri){return _ImageLoader2.default.prefetch(uri);}}]);function Image(props,context){_classCallCheck(this,Image);var _this=_possibleConstructorReturn(this,(Image.__proto__||Object.getPrototypeOf(Image)).call(this,props,context));_initialiseProps.call(_this);var uri=resolveAssetSource(props.source);var shouldDisplaySource=_ImageUriCache2.default.has(uri);_this.state={shouldDisplaySource:shouldDisplaySource};_this._imageState=getImageState(uri,shouldDisplaySource);shouldDisplaySource&&_ImageUriCache2.default.add(uri);return _this;}_createClass(Image,[{key:'componentDidMount',value:function componentDidMount(){this._isMounted=true;if(this._imageState===STATUS_PENDING){this._createImageLoader();}}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this._imageState===STATUS_PENDING){this._createImageLoader();}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var uri=resolveAssetSource(this.props.source);var nextUri=resolveAssetSource(nextProps.source);if(uri!==nextUri){_ImageUriCache2.default.remove(uri);var isPreviouslyLoaded=_ImageUriCache2.default.has(nextUri);isPreviouslyLoaded&&_ImageUriCache2.default.add(uri);this._updateImageState(getImageState(uri,isPreviouslyLoaded));}}},{key:'componentWillUnmount',value:function componentWillUnmount(){_ImageUriCache2.default.remove(resolveAssetSource(this.props.source));this._destroyImageLoader();this._isMounted=false;}},{key:'render',value:function render(){var shouldDisplaySource=this.state.shouldDisplaySource;var _props=this.props,accessibilityLabel=_props.accessibilityLabel,accessible=_props.accessible,children=_props.children,defaultSource=_props.defaultSource,draggable=_props.draggable,onLayout=_props.onLayout,source=_props.source,testID=_props.testID,onError=_props.onError,onLoad=_props.onLoad,onLoadEnd=_props.onLoadEnd,onLoadStart=_props.onLoadStart,resizeMode=_props.resizeMode,other=_objectWithoutProperties(_props,['accessibilityLabel','accessible','children','defaultSource','draggable','onLayout','source','testID','onError','onLoad','onLoadEnd','onLoadStart','resizeMode']);var displayImage=resolveAssetSource(shouldDisplaySource?source:defaultSource);var imageSizeStyle=resolveAssetDimensions(shouldDisplaySource?source:defaultSource);var backgroundImage=displayImage?'url("'+displayImage+'")':null;var originalStyle=_StyleSheet2.default.flatten(this.props.style);var finalResizeMode=resizeMode||originalStyle.resizeMode||_ImageResizeMode2.default.cover;var style=_StyleSheet2.default.flatten([styles.initial,imageSizeStyle,originalStyle,resizeModeStyles[finalResizeMode],this.context.isInAParentText&&styles.inline,backgroundImage&&{backgroundImage:backgroundImage}]);delete style.overlayColor;delete style.resizeMode;delete style.tintColor;var hiddenImage=displayImage?(0,_createElement2.default)('img',{alt:accessibilityLabel||'',draggable:draggable,src:displayImage,style:styles.img}):null;return _react2.default.createElement(_View2.default,_extends({},other,{accessibilityLabel:accessibilityLabel,accessible:accessible,onLayout:onLayout,style:style,testID:testID,__source:{fileName:_jsxFileName,lineNumber:220}}),hiddenImage,children);}},{key:'_createImageLoader',value:function _createImageLoader(){var _this2=this;this._destroyImageLoader();this._loadRequest=(0,_requestIdleCallback2.default)(function(){var uri=resolveAssetSource(_this2.props.source);_this2._imageRequestId=_ImageLoader2.default.load(uri,_this2._onLoad,_this2._onError);_this2._onLoadStart();});}},{key:'_destroyImageLoader',value:function _destroyImageLoader(){if(this._loadRequest){(0,_requestIdleCallback.cancelIdleCallback)(this._loadRequest);this._loadRequest=null;}if(this._imageRequestId){_ImageLoader2.default.abort(this._imageRequestId);this._imageRequestId=null;}}},{key:'_onLoadEnd',value:function _onLoadEnd(){var onLoadEnd=this.props.onLoadEnd;if(onLoadEnd){onLoadEnd();}}},{key:'_onLoadStart',value:function _onLoadStart(){var onLoadStart=this.props.onLoadStart;this._updateImageState(STATUS_LOADING);if(onLoadStart){onLoadStart();}}},{key:'_updateImageState',value:function _updateImageState(status){this._imageState=status;var shouldDisplaySource=this._imageState===STATUS_LOADED||this._imageState===STATUS_LOADING;if(shouldDisplaySource!==this.state.shouldDisplaySource){if(this._isMounted){this.setState(function(){return{shouldDisplaySource:shouldDisplaySource};});}}}}]);return Image;}(_react.Component);Image.displayName='Image';Image.contextTypes={isInAParentText:_propTypes.bool};Image.defaultProps={style:emptyObject};Image.resizeMode=_ImageResizeMode2.default;var _initialiseProps=function _initialiseProps(){var _this3=this;this._imageRequestId=null;this._imageState=null;this._isMounted=false;this._loadRequest=null;this._onError=function(){var _props2=_this3.props,onError=_props2.onError,source=_props2.source;_this3._updateImageState(STATUS_ERRORED);if(onError){onError({nativeEvent:{error:'Failed to load resource '+resolveAssetSource(source)+' (404)'}});}_this3._onLoadEnd();};this._onLoad=function(e){var _props3=_this3.props,onLoad=_props3.onLoad,source=_props3.source;var event={nativeEvent:e};_ImageUriCache2.default.add(resolveAssetSource(source));_this3._updateImageState(STATUS_LOADED);if(onLoad){onLoad(event);}_this3._onLoadEnd();};};Image.propTypes= false?_extends({},_ViewPropTypes2.default,{children:_propTypes.any,defaultSource:ImageSourcePropType,draggable:_propTypes.bool,onError:_propTypes.func,onLayout:_propTypes.func,onLoad:_propTypes.func,onLoadEnd:_propTypes.func,onLoadStart:_propTypes.func,resizeMode:(0,_propTypes.oneOf)(Object.keys(_ImageResizeMode2.default)),source:ImageSourcePropType,style:(0,_StyleSheetPropType2.default)(_ImageStylePropTypes2.default)}):{};var styles=_StyleSheet2.default.create({initial:{backgroundColor:'transparent',backgroundPosition:'center',backgroundRepeat:'no-repeat',backgroundSize:'cover',zIndex:0},inline:{display:'inline-flex'},img:_extends({},_StyleSheet2.default.absoluteFillObject,{height:'100%',opacity:0,width:'100%',zIndex:-1})});var resizeModeStyles=_StyleSheet2.default.create({center:{backgroundSize:'auto',backgroundPosition:'center'},contain:{backgroundSize:'contain'},cover:{backgroundSize:'cover'},none:{backgroundSize:'auto'},repeat:{backgroundSize:'auto',backgroundRepeat:'repeat'},stretch:{backgroundSize:'100% 100%'}});exports.default=(0,_applyNativeMethods2.default)(Image);

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var emptyFunction = __webpack_require__(27);
var nativeRequestAnimationFrame = __webpack_require__(326);

var lastTime = 0;

var requestAnimationFrame = nativeRequestAnimationFrame || function (callback) {
  var currTime = Date.now();
  var timeDelay = Math.max(0, 16 - (currTime - lastTime));
  lastTime = currTime + timeDelay;
  return global.setTimeout(function () {
    callback(Date.now());
  }, timeDelay);
};

// Works around a rare bug in Safari 6 where the first request is never invoked.
requestAnimationFrame(emptyFunction);

module.exports = requestAnimationFrame;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 164 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var ImageResizeMode={center:'center',contain:'contain',cover:'cover',none:'none',repeat:'repeat',stretch:'stretch'};exports.default=ImageResizeMode;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _ColorPropType=__webpack_require__(14);var _ColorPropType2=_interopRequireDefault(_ColorPropType);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var numberOrString=(0,_propTypes.oneOfType)([_propTypes.number,_propTypes.string]);var BorderStylePropType=(0,_propTypes.oneOf)(['solid','dotted','dashed']);var BorderPropTypes={borderColor:_ColorPropType2.default,borderTopColor:_ColorPropType2.default,borderRightColor:_ColorPropType2.default,borderBottomColor:_ColorPropType2.default,borderLeftColor:_ColorPropType2.default,borderRadius:numberOrString,borderTopLeftRadius:numberOrString,borderTopRightRadius:numberOrString,borderBottomLeftRadius:numberOrString,borderBottomRightRadius:numberOrString,borderStyle:BorderStylePropType,borderTopStyle:BorderStylePropType,borderRightStyle:BorderStylePropType,borderBottomStyle:BorderStylePropType,borderLeftStyle:BorderStylePropType};exports.default=BorderPropTypes;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _propTypes=__webpack_require__(3);var OverflowPropType=(0,_propTypes.oneOf)(['auto','hidden','scroll','visible']);var hiddenOrVisible=(0,_propTypes.oneOf)(['hidden','visible']);var numberOrString=(0,_propTypes.oneOfType)([_propTypes.number,_propTypes.string]);var LayoutPropTypes={alignContent:(0,_propTypes.oneOf)(['center','flex-end','flex-start','space-around','space-between','stretch']),alignItems:(0,_propTypes.oneOf)(['baseline','center','flex-end','flex-start','stretch']),alignSelf:(0,_propTypes.oneOf)(['auto','baseline','center','flex-end','flex-start','stretch']),backfaceVisibility:hiddenOrVisible,borderWidth:numberOrString,borderBottomWidth:numberOrString,borderLeftWidth:numberOrString,borderRightWidth:numberOrString,borderTopWidth:numberOrString,bottom:numberOrString,boxSizing:_propTypes.string,direction:(0,_propTypes.oneOf)(['inherit','ltr','rtl']),display:_propTypes.string,flex:_propTypes.number,flexBasis:numberOrString,flexDirection:(0,_propTypes.oneOf)(['column','column-reverse','row','row-reverse']),flexGrow:_propTypes.number,flexShrink:_propTypes.number,flexWrap:(0,_propTypes.oneOf)(['nowrap','wrap','wrap-reverse']),height:numberOrString,justifyContent:(0,_propTypes.oneOf)(['center','flex-end','flex-start','space-around','space-between']),left:numberOrString,margin:numberOrString,marginBottom:numberOrString,marginHorizontal:numberOrString,marginLeft:numberOrString,marginRight:numberOrString,marginTop:numberOrString,marginVertical:numberOrString,maxHeight:numberOrString,maxWidth:numberOrString,minHeight:numberOrString,minWidth:numberOrString,order:_propTypes.number,overflow:OverflowPropType,overflowX:OverflowPropType,overflowY:OverflowPropType,padding:numberOrString,paddingBottom:numberOrString,paddingHorizontal:numberOrString,paddingLeft:numberOrString,paddingRight:numberOrString,paddingTop:numberOrString,paddingVertical:numberOrString,position:(0,_propTypes.oneOf)(['absolute','fixed','relative','static','sticky']),right:numberOrString,top:numberOrString,visibility:hiddenOrVisible,width:numberOrString,zIndex:_propTypes.number,aspectRatio:_propTypes.number,gridAutoColumns:_propTypes.string,gridAutoFlow:_propTypes.string,gridAutoRows:_propTypes.string,gridColumnEnd:_propTypes.string,gridColumnGap:_propTypes.string,gridColumnStart:_propTypes.string,gridRowEnd:_propTypes.string,gridRowGap:_propTypes.string,gridRowStart:_propTypes.string,gridTemplateColumns:_propTypes.string,gridTemplateRows:_propTypes.string,gridTemplateAreas:_propTypes.string};exports.default=LayoutPropTypes;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _ColorPropType=__webpack_require__(14);var _ColorPropType2=_interopRequireDefault(_ColorPropType);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var numberOrString=(0,_propTypes.oneOfType)([_propTypes.number,_propTypes.string]);var ShadowPropTypes={shadowColor:_ColorPropType2.default,shadowOffset:(0,_propTypes.shape)({width:numberOrString,height:numberOrString}),shadowOpacity:_propTypes.number,shadowRadius:numberOrString,shadowSpread:numberOrString};exports.default=ShadowPropTypes;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _propTypes=__webpack_require__(3);var numberOrString=(0,_propTypes.oneOfType)([_propTypes.number,_propTypes.string]);var TransformPropTypes={transform:(0,_propTypes.arrayOf)((0,_propTypes.oneOfType)([(0,_propTypes.shape)({perspective:numberOrString}),(0,_propTypes.shape)({rotate:_propTypes.string}),(0,_propTypes.shape)({rotateX:_propTypes.string}),(0,_propTypes.shape)({rotateY:_propTypes.string}),(0,_propTypes.shape)({rotateZ:_propTypes.string}),(0,_propTypes.shape)({scale:_propTypes.number}),(0,_propTypes.shape)({scaleX:_propTypes.number}),(0,_propTypes.shape)({scaleY:_propTypes.number}),(0,_propTypes.shape)({skewX:_propTypes.string}),(0,_propTypes.shape)({skewY:_propTypes.string}),(0,_propTypes.shape)({translateX:numberOrString}),(0,_propTypes.shape)({translateY:numberOrString}),(0,_propTypes.shape)({translateZ:numberOrString}),(0,_propTypes.shape)({translate3d:_propTypes.string})])),transformOrigin:_propTypes.string};exports.default=TransformPropTypes;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _TextInputState=__webpack_require__(98);var _TextInputState2=_interopRequireDefault(_TextInputState);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var dismissKeyboard=function dismissKeyboard(){_TextInputState2.default.blurTextInput(_TextInputState2.default.currentlyFocusedField());};exports.default=dismissKeyboard;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _BaseComponentPropTypes=__webpack_require__(95);var _BaseComponentPropTypes2=_interopRequireDefault(_BaseComponentPropTypes);var _StyleSheetPropType=__webpack_require__(56);var _StyleSheetPropType2=_interopRequireDefault(_StyleSheetPropType);var _TextStylePropTypes=__webpack_require__(171);var _TextStylePropTypes2=_interopRequireDefault(_TextStylePropTypes);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TextPropTypes=_extends({},_BaseComponentPropTypes2.default,{accessibilityRole:(0,_propTypes.oneOf)(['button','heading','label','link','listitem']),children:_propTypes.any,numberOfLines:_propTypes.number,onLayout:_propTypes.func,onPress:_propTypes.func,selectable:_propTypes.bool,style:(0,_StyleSheetPropType2.default)(_TextStylePropTypes2.default)});exports.default=TextPropTypes;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _ColorPropType=__webpack_require__(14);var _ColorPropType2=_interopRequireDefault(_ColorPropType);var _ViewStylePropTypes=__webpack_require__(97);var _ViewStylePropTypes2=_interopRequireDefault(_ViewStylePropTypes);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var numberOrString=(0,_propTypes.oneOfType)([_propTypes.number,_propTypes.string]);var ShadowOffsetPropType=(0,_propTypes.shape)({width:_propTypes.number,height:_propTypes.number});var TextAlignPropType=(0,_propTypes.oneOf)(['center','inherit','justify','justify-all','left','right']);var WritingDirectionPropType=(0,_propTypes.oneOf)(['auto','ltr','rtl']);var TextStylePropTypes=_extends({},_ViewStylePropTypes2.default,{color:_ColorPropType2.default,fontFamily:_propTypes.string,fontFeatureSettings:_propTypes.string,fontSize:numberOrString,fontStyle:_propTypes.string,fontWeight:_propTypes.string,letterSpacing:numberOrString,lineHeight:numberOrString,textAlign:TextAlignPropType,textAlignVertical:_propTypes.string,textDecorationColor:_ColorPropType2.default,textDecorationLine:_propTypes.string,textDecorationStyle:_propTypes.string,textShadowColor:_ColorPropType2.default,textShadowOffset:ShadowOffsetPropType,textShadowRadius:_propTypes.number,writingDirection:WritingDirectionPropType,textIndent:numberOrString,textOverflow:_propTypes.string,textRendering:(0,_propTypes.oneOf)(['auto','geometricPrecision','optimizeLegibility','optimizeSpeed']),textTransform:(0,_propTypes.oneOf)(['capitalize','lowercase','none','uppercase']),unicodeBidi:(0,_propTypes.oneOf)(['normal','bidi-override','embed','isolate','isolate-override','plaintext']),whiteSpace:_propTypes.string,wordWrap:_propTypes.string,MozOsxFontSmoothing:_propTypes.string,WebkitFontSmoothing:_propTypes.string});exports.default=TextStylePropTypes;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (arr, predicate, ctx) {
	if (typeof Array.prototype.findIndex === 'function') {
		return arr.findIndex(predicate, ctx);
	}

	if (typeof predicate !== 'function') {
		throw new TypeError('predicate must be a function');
	}

	var list = Object(arr);
	var len = list.length;

	if (len === 0) {
		return -1;
	}

	for (var i = 0; i < len; i++) {
		if (predicate.call(ctx, list[i], i, list)) {
			return i;
		}
	}

	return -1;
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='src/components/Touchable/TouchableOpacity.js';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _applyNativeMethods=__webpack_require__(18);var _applyNativeMethods2=_interopRequireDefault(_applyNativeMethods);var _createReactClass=__webpack_require__(28);var _createReactClass2=_interopRequireDefault(_createReactClass);var _ensurePositiveDelayProps=__webpack_require__(101);var _ensurePositiveDelayProps2=_interopRequireDefault(_ensurePositiveDelayProps);var _propTypes=__webpack_require__(3);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _Touchable=__webpack_require__(69);var _Touchable2=_interopRequireDefault(_Touchable);var _TouchableWithoutFeedback=__webpack_require__(102);var _TouchableWithoutFeedback2=_interopRequireDefault(_TouchableWithoutFeedback);var _View=__webpack_require__(11);var _View2=_interopRequireDefault(_View);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var flattenStyle=_StyleSheet2.default.flatten;var PRESS_RETENTION_OFFSET={top:20,left:20,right:20,bottom:30};var TouchableOpacity=(0,_createReactClass2.default)({displayName:'TouchableOpacity',mixins:[_Touchable2.default.Mixin],propTypes:_extends({},_TouchableWithoutFeedback2.default.propTypes,{activeOpacity:_propTypes.number,focusedOpacity:_propTypes.number}),getDefaultProps:function getDefaultProps(){return{activeOpacity:0.2,focusedOpacity:0.7};},getInitialState:function getInitialState(){return this.touchableGetInitialState();},componentDidMount:function componentDidMount(){(0,_ensurePositiveDelayProps2.default)(this.props);},componentWillReceiveProps:function componentWillReceiveProps(nextProps){(0,_ensurePositiveDelayProps2.default)(nextProps);},setOpacityTo:function setOpacityTo(value,duration){this.setNativeProps({style:{opacity:value,transitionDuration:duration?duration/1000+'s':'0s'}});},touchableHandleActivePressIn:function touchableHandleActivePressIn(e){if(e.dispatchConfig.registrationName==='onResponderGrant'){this._opacityActive(0);}else{this._opacityActive(150);}this.props.onPressIn&&this.props.onPressIn(e);},touchableHandleActivePressOut:function touchableHandleActivePressOut(e){this._opacityInactive(250);this.props.onPressOut&&this.props.onPressOut(e);},touchableHandlePress:function touchableHandlePress(e){this.props.onPress&&this.props.onPress(e);},touchableHandleLongPress:function touchableHandleLongPress(e){this.props.onLongPress&&this.props.onLongPress(e);},touchableGetPressRectOffset:function touchableGetPressRectOffset(){return this.props.pressRetentionOffset||PRESS_RETENTION_OFFSET;},touchableGetHitSlop:function touchableGetHitSlop(){return this.props.hitSlop;},touchableGetHighlightDelayMS:function touchableGetHighlightDelayMS(){return this.props.delayPressIn||0;},touchableGetLongPressDelayMS:function touchableGetLongPressDelayMS(){return this.props.delayLongPress===0?0:this.props.delayLongPress||500;},touchableGetPressOutDelayMS:function touchableGetPressOutDelayMS(){return this.props.delayPressOut;},_opacityActive:function _opacityActive(duration){this.setOpacityTo(this.props.activeOpacity,duration);},_opacityInactive:function _opacityInactive(duration){this.setOpacityTo(this._getChildStyleOpacityWithDefault(),duration);},_opacityFocused:function _opacityFocused(){this.setOpacityTo(this.props.focusedOpacity);},_getChildStyleOpacityWithDefault:function _getChildStyleOpacityWithDefault(){var childStyle=flattenStyle(this.props.style)||{};return childStyle.opacity===undefined?1:childStyle.opacity;},render:function render(){var _props=this.props,activeOpacity=_props.activeOpacity,focusedOpacity=_props.focusedOpacity,delayLongPress=_props.delayLongPress,delayPressIn=_props.delayPressIn,delayPressOut=_props.delayPressOut,onLongPress=_props.onLongPress,onPress=_props.onPress,onPressIn=_props.onPressIn,onPressOut=_props.onPressOut,pressRetentionOffset=_props.pressRetentionOffset,other=_objectWithoutProperties(_props,['activeOpacity','focusedOpacity','delayLongPress','delayPressIn','delayPressOut','onLongPress','onPress','onPressIn','onPressOut','pressRetentionOffset']);return _react2.default.createElement(_View2.default,_extends({},other,{accessible:this.props.accessible!==false,onKeyDown:this.touchableHandleKeyEvent,onKeyUp:this.touchableHandleKeyEvent,onResponderGrant:this.touchableHandleResponderGrant,onResponderMove:this.touchableHandleResponderMove,onResponderRelease:this.touchableHandleResponderRelease,onResponderTerminate:this.touchableHandleResponderTerminate,onResponderTerminationRequest:this.touchableHandleResponderTerminationRequest,onStartShouldSetResponder:this.touchableHandleStartShouldSetResponder,style:[styles.root,!this.props.disabled&&styles.actionable,this.props.style],__source:{fileName:_jsxFileName,lineNumber:179}}),this.props.children,_Touchable2.default.renderDebugView({color:'blue',hitSlop:this.props.hitSlop}));}});var styles=_StyleSheet2.default.create({root:{transitionProperty:'opacity',transitionDuration:'0.15s',userSelect:'none'},actionable:{cursor:'pointer',touchAction:'manipulate'}});exports.default=(0,_applyNativeMethods2.default)(TouchableOpacity);

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _invariant=__webpack_require__(8);var _invariant2=_interopRequireDefault(_invariant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var twoArgumentPooler=function twoArgumentPooler(a1,a2){var Klass=this;if(Klass.instancePool.length){var instance=Klass.instancePool.pop();Klass.call(instance,a1,a2);return instance;}else{return new Klass(a1,a2);}};var standardReleaser=function standardReleaser(instance){var Klass=this;instance.destructor();if(Klass.instancePool.length<Klass.poolSize){Klass.instancePool.push(instance);}};var DEFAULT_POOL_SIZE=10;var DEFAULT_POOLER=twoArgumentPooler;var addPoolingTo=function addPoolingTo(CopyConstructor,pooler){var NewKlass=CopyConstructor;NewKlass.instancePool=[];NewKlass.getPooled=pooler||DEFAULT_POOLER;if(!NewKlass.poolSize){NewKlass.poolSize=DEFAULT_POOL_SIZE;}NewKlass.release=standardReleaser;return NewKlass;};var PooledClass={addPoolingTo:addPoolingTo,twoArgumentPooler:twoArgumentPooler};exports.default=PooledClass;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _invariant=__webpack_require__(8);var _invariant2=_interopRequireDefault(_invariant);var _isEmpty=__webpack_require__(176);var _isEmpty2=_interopRequireDefault(_isEmpty);var _warning=__webpack_require__(68);var _warning2=_interopRequireDefault(_warning);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function defaultGetRowData(dataBlob,sectionID,rowID){return dataBlob[sectionID][rowID];}function defaultGetSectionHeaderData(dataBlob,sectionID){return dataBlob[sectionID];}var ListViewDataSource=function(){function ListViewDataSource(params){_classCallCheck(this,ListViewDataSource);(0,_invariant2.default)(params&&typeof params.rowHasChanged==='function','Must provide a rowHasChanged function.');this._rowHasChanged=params.rowHasChanged;this._getRowData=params.getRowData||defaultGetRowData;this._sectionHeaderHasChanged=params.sectionHeaderHasChanged;this._getSectionHeaderData=params.getSectionHeaderData||defaultGetSectionHeaderData;this._dataBlob=null;this._dirtyRows=[];this._dirtySections=[];this._cachedRowCount=0;this.rowIdentities=[];this.sectionIdentities=[];}_createClass(ListViewDataSource,[{key:'cloneWithRows',value:function cloneWithRows(dataBlob,rowIdentities){var rowIds=rowIdentities?[rowIdentities]:null;if(!this._sectionHeaderHasChanged){this._sectionHeaderHasChanged=function(){return false;};}return this.cloneWithRowsAndSections({s1:dataBlob},['s1'],rowIds);}},{key:'cloneWithRowsAndSections',value:function cloneWithRowsAndSections(dataBlob,sectionIdentities,rowIdentities){(0,_invariant2.default)(typeof this._sectionHeaderHasChanged==='function','Must provide a sectionHeaderHasChanged function with section data.');var newSource=new ListViewDataSource({getRowData:this._getRowData,getSectionHeaderData:this._getSectionHeaderData,rowHasChanged:this._rowHasChanged,sectionHeaderHasChanged:this._sectionHeaderHasChanged});newSource._dataBlob=dataBlob;if(sectionIdentities){newSource.sectionIdentities=sectionIdentities;}else{newSource.sectionIdentities=Object.keys(dataBlob);}if(rowIdentities){newSource.rowIdentities=rowIdentities;}else{newSource.rowIdentities=[];newSource.sectionIdentities.forEach(function(sectionID){newSource.rowIdentities.push(Object.keys(dataBlob[sectionID]));});}newSource._cachedRowCount=countRows(newSource.rowIdentities);newSource._calculateDirtyArrays(this._dataBlob,this.sectionIdentities,this.rowIdentities);return newSource;}},{key:'getRowCount',value:function getRowCount(){return this._cachedRowCount;}},{key:'getRowAndSectionCount',value:function getRowAndSectionCount(){return this._cachedRowCount+this.sectionIdentities.length;}},{key:'rowShouldUpdate',value:function rowShouldUpdate(sectionIndex,rowIndex){var needsUpdate=this._dirtyRows[sectionIndex][rowIndex];(0,_warning2.default)(needsUpdate!==undefined,'missing dirtyBit for section, row: '+sectionIndex+', '+rowIndex);return needsUpdate;}},{key:'getRowData',value:function getRowData(sectionIndex,rowIndex){var sectionID=this.sectionIdentities[sectionIndex];var rowID=this.rowIdentities[sectionIndex][rowIndex];(0,_warning2.default)(sectionID!==undefined&&rowID!==undefined,'rendering invalid section, row: '+sectionIndex+', '+rowIndex);return this._getRowData(this._dataBlob,sectionID,rowID);}},{key:'getRowIDForFlatIndex',value:function getRowIDForFlatIndex(index){var accessIndex=index;for(var ii=0;ii<this.sectionIdentities.length;ii++){if(accessIndex>=this.rowIdentities[ii].length){accessIndex-=this.rowIdentities[ii].length;}else{return this.rowIdentities[ii][accessIndex];}}return null;}},{key:'getSectionIDForFlatIndex',value:function getSectionIDForFlatIndex(index){var accessIndex=index;for(var ii=0;ii<this.sectionIdentities.length;ii++){if(accessIndex>=this.rowIdentities[ii].length){accessIndex-=this.rowIdentities[ii].length;}else{return this.sectionIdentities[ii];}}return null;}},{key:'getSectionLengths',value:function getSectionLengths(){var results=[];for(var ii=0;ii<this.sectionIdentities.length;ii++){results.push(this.rowIdentities[ii].length);}return results;}},{key:'sectionHeaderShouldUpdate',value:function sectionHeaderShouldUpdate(sectionIndex){var needsUpdate=this._dirtySections[sectionIndex];(0,_warning2.default)(needsUpdate!==undefined,'missing dirtyBit for section: '+sectionIndex);return needsUpdate;}},{key:'getSectionHeaderData',value:function getSectionHeaderData(sectionIndex){if(!this._getSectionHeaderData){return null;}var sectionID=this.sectionIdentities[sectionIndex];(0,_warning2.default)(sectionID!==undefined,'renderSection called on invalid section: '+sectionIndex);return this._getSectionHeaderData(this._dataBlob,sectionID);}},{key:'_calculateDirtyArrays',value:function _calculateDirtyArrays(prevDataBlob,prevSectionIDs,prevRowIDs){var prevSectionsHash=keyedDictionaryFromArray(prevSectionIDs);var prevRowsHash={};for(var ii=0;ii<prevRowIDs.length;ii++){var sectionID=prevSectionIDs[ii];(0,_warning2.default)(!prevRowsHash[sectionID],'SectionID appears more than once: '+sectionID);prevRowsHash[sectionID]=keyedDictionaryFromArray(prevRowIDs[ii]);}this._dirtySections=[];this._dirtyRows=[];var dirty;for(var sIndex=0;sIndex<this.sectionIdentities.length;sIndex++){var sectionID=this.sectionIdentities[sIndex];dirty=!prevSectionsHash[sectionID];var sectionHeaderHasChanged=this._sectionHeaderHasChanged;if(!dirty&&sectionHeaderHasChanged){dirty=sectionHeaderHasChanged(this._getSectionHeaderData(prevDataBlob,sectionID),this._getSectionHeaderData(this._dataBlob,sectionID));}this._dirtySections.push(!!dirty);this._dirtyRows[sIndex]=[];for(var rIndex=0;rIndex<this.rowIdentities[sIndex].length;rIndex++){var rowID=this.rowIdentities[sIndex][rIndex];dirty=!prevSectionsHash[sectionID]||!prevRowsHash[sectionID][rowID]||this._rowHasChanged(this._getRowData(prevDataBlob,sectionID,rowID),this._getRowData(this._dataBlob,sectionID,rowID));this._dirtyRows[sIndex].push(!!dirty);}}}}]);return ListViewDataSource;}();function countRows(allRowIDs){var totalRows=0;for(var sectionIdx=0;sectionIdx<allRowIDs.length;sectionIdx++){var rowIDs=allRowIDs[sectionIdx];totalRows+=rowIDs.length;}return totalRows;}function keyedDictionaryFromArray(arr){if((0,_isEmpty2.default)(arr)){return{};}var result={};for(var ii=0;ii<arr.length;ii++){var key=arr[ii];(0,_warning2.default)(!result[key],'Value appears more than once in array: '+key);result[key]=true;}return result;}exports.default=ListViewDataSource;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* eslint-disable fb-www/typeof-undefined */
/* eslint-disable no-unused-vars */

var invariant = __webpack_require__(8);

/**
 * Checks if a value is empty.
 */
function isEmpty(value) {
  if (Array.isArray(value)) {
    return value.length === 0;
  } else if (typeof value === 'object') {
    if (value) {
      !(!isIterable(value) || value.size === undefined) ?  false ? invariant(false, 'isEmpty() does not support iterable collections.') : invariant(false) : void 0;
      for (var _ in value) {
        return false;
      }
    }
    return true;
  } else {
    return !value;
  }
}

function isIterable(value) {
  if (typeof Symbol === 'undefined') {
    return false;
  }
  return value[Symbol.iterator];
}

module.exports = isEmpty;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var Linking=exports.Linking={addEventListener:function addEventListener(){},removeEventListener:function removeEventListener(){},getInitialURL:function getInitialURL(){return Promise.reject('Unsupported platform');}};var BackHandler=exports.BackHandler={addEventListener:function addEventListener(){}};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.INCLUDE=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.default=resolveIncludes;var _lodash=__webpack_require__(17);var _=_interopRequireWildcard(_lodash);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var INCLUDE=exports.INCLUDE='@@shoutem.theme/include';function includeSymbolMergeHandler(objVal,srcVal){var newObjVal=objVal;var include=void 0;if(srcVal&&srcVal[INCLUDE]){include=newObjVal&&newObjVal[INCLUDE]?[].concat(_toConsumableArray(newObjVal[INCLUDE]),_toConsumableArray(srcVal[INCLUDE])):srcVal[INCLUDE];}if(_.isUndefined(newObjVal)&&_.isPlainObject(srcVal)){var newObj=_.mergeWith({},srcVal,function(o,s){return s;});if(include){newObj[INCLUDE]=include;}return newObj;}if(_.isPlainObject(newObjVal)&&include){newObjVal[INCLUDE]=include;}}function resolveIncludes(target){var base=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};function getStyle(styleName){var defaultStyle={};var style=defaultStyle;var baseStyle=base[styleName];if(baseStyle){if(baseStyle[INCLUDE]){throw Error('Base style cannot have includes, unexpected include in '+styleName+'.');}style=_extends({},baseStyle);}var targetStyle=target[styleName];if(targetStyle){style=_extends({},style,targetStyle);}if(style===defaultStyle){console.warn('Including unexisting style: '+styleName);}return style;}function includeNodeStyles(styleNode,processingStyleNames){if(!_.isPlainObject(styleNode)){return styleNode;}var styleNamesToInclude=styleNode[INCLUDE];var stylesToInclude={};if(styleNamesToInclude){if(!_.isArray(styleNamesToInclude)){throw Error('Include should be array');}for(var _iterator=styleNamesToInclude,_isArray=Array.isArray(_iterator),_i=0,_iterator=_isArray?_iterator:_iterator[typeof Symbol==='function'?Symbol.iterator:'@@iterator']();;){var _ref;if(_isArray){if(_i>=_iterator.length)break;_ref=_iterator[_i++];}else{_i=_iterator.next();if(_i.done)break;_ref=_i.value;}var styleName=_ref;if(processingStyleNames.has(styleName)){throw Error('Circular style include, including '+styleName);}processingStyleNames.add(styleName);stylesToInclude=_.mergeWith({},stylesToInclude,includeNodeStyles(getStyle(styleName),processingStyleNames),includeSymbolMergeHandler);processingStyleNames.delete(styleName);}}var resultingStyle=_.mergeWith({},stylesToInclude,styleNode,includeSymbolMergeHandler);delete resultingStyle[INCLUDE];for(var _iterator2=_.keys(resultingStyle),_isArray2=Array.isArray(_iterator2),_i2=0,_iterator2=_isArray2?_iterator2:_iterator2[typeof Symbol==='function'?Symbol.iterator:'@@iterator']();;){var _ref2;if(_isArray2){if(_i2>=_iterator2.length)break;_ref2=_iterator2[_i2++];}else{_i2=_iterator2.next();if(_i2.done)break;_ref2=_i2.value;}var _styleName=_ref2;resultingStyle[_styleName]=includeNodeStyles(resultingStyle[_styleName],processingStyleNames);}return resultingStyle;}var processingStyleNames=new Set();return includeNodeStyles(target,processingStyleNames);}

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);var _computeProps=__webpack_require__(106);var _computeProps2=_interopRequireDefault(_computeProps);var _lodash=__webpack_require__(17);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RowNB=function(_Component){_inherits(RowNB,_Component);function RowNB(){_classCallCheck(this,RowNB);return _possibleConstructorReturn(this,(RowNB.__proto__||Object.getPrototypeOf(RowNB)).apply(this,arguments));}_createClass(RowNB,[{key:'prepareRootProps',value:function prepareRootProps(){var type={flexDirection:'row',flex:this.props.size?this.props.size:this.props.style&&this.props.style.height?0:1};var defaultProps={style:type};return(0,_computeProps2.default)(this.props,defaultProps);}},{key:'setNativeProps',value:function setNativeProps(nativeProps){this._root.setNativeProps(nativeProps);}},{key:'render',value:function render(){var _this2=this;if(this.props.onPress){return _react2.default.createElement(_reactNative.TouchableOpacity,{onPress:this.props.onPress},_react2.default.createElement(_reactNative.View,_extends({ref:function ref(component){return _this2._root=component;}},this.props,this.prepareRootProps()),this.props.children));}else{return _react2.default.createElement(_reactNative.View,_extends({ref:function ref(component){return _this2._root=component;}},this.props,this.prepareRootProps()),this.props.children);}}}]);return RowNB;}(_react.Component);exports.default=RowNB;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var emptyObject={};var objects={};var prefix='r';var uniqueID=1;var createKey=function createKey(id){return prefix+'-'+id;};var ReactNativePropRegistry=function(){function ReactNativePropRegistry(){_classCallCheck(this,ReactNativePropRegistry);}_createClass(ReactNativePropRegistry,null,[{key:'register',value:function register(object){var id=uniqueID++;if(false){Object.freeze(object);}var key=createKey(id);objects[key]=object;return id;}},{key:'getByID',value:function getByID(id){if(!id){return emptyObject;}var key=createKey(id);var object=objects[key];if(!object){console.warn('Invalid style with id `'+id+'`. Skipping ...');return emptyObject;}return object;}}]);return ReactNativePropRegistry;}();exports.default=ReactNativePropRegistry;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);var _computeProps=__webpack_require__(106);var _computeProps2=_interopRequireDefault(_computeProps);var _lodash=__webpack_require__(17);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ColumnNB=function(_Component){_inherits(ColumnNB,_Component);function ColumnNB(){_classCallCheck(this,ColumnNB);return _possibleConstructorReturn(this,(ColumnNB.__proto__||Object.getPrototypeOf(ColumnNB)).apply(this,arguments));}_createClass(ColumnNB,[{key:'prepareRootProps',value:function prepareRootProps(){var type={flexDirection:'column',flex:this.props.size?this.props.size:this.props.style&&this.props.style.width?0:1};var defaultProps={style:type};return(0,_computeProps2.default)(this.props,defaultProps);}},{key:'setNativeProps',value:function setNativeProps(nativeProps){this._root.setNativeProps(nativeProps);}},{key:'render',value:function render(){var _this2=this;if(this.props.onPress){return _react2.default.createElement(_reactNative.TouchableOpacity,{onPress:this.props.onPress},_react2.default.createElement(_reactNative.View,_extends({ref:function ref(component){return _this2._root=component;}},this.props,this.prepareRootProps()),this.props.children));}else{return _react2.default.createElement(_reactNative.View,_extends({ref:function ref(component){return _this2._root=component;}},this.props,this.prepareRootProps()),this.props.children);}}}]);return ColumnNB;}(_react.Component);exports.default=ColumnNB;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _lodash=__webpack_require__(12);var _lodash2=_interopRequireDefault(_lodash);
var _Body=__webpack_require__(409);var _Body2=_interopRequireDefault(_Body);
var _Left=__webpack_require__(416);var _Left2=_interopRequireDefault(_Left);
var _Right=__webpack_require__(417);var _Right2=_interopRequireDefault(_Right);
var _Header=__webpack_require__(418);var _Header2=_interopRequireDefault(_Header);
var _Switch=__webpack_require__(419);var _Switch2=_interopRequireDefault(_Switch);
var _Thumbnail=__webpack_require__(420);var _Thumbnail2=_interopRequireDefault(_Thumbnail);
var _Container=__webpack_require__(421);var _Container2=_interopRequireDefault(_Container);
var _Content=__webpack_require__(422);var _Content2=_interopRequireDefault(_Content);
var _Button=__webpack_require__(423);var _Button2=_interopRequireDefault(_Button);
var _Title=__webpack_require__(424);var _Title2=_interopRequireDefault(_Title);
var _Subtitle=__webpack_require__(425);var _Subtitle2=_interopRequireDefault(_Subtitle);
var _InputGroup=__webpack_require__(426);var _InputGroup2=_interopRequireDefault(_InputGroup);
var _Badge=__webpack_require__(427);var _Badge2=_interopRequireDefault(_Badge);
var _CheckBox=__webpack_require__(428);var _CheckBox2=_interopRequireDefault(_CheckBox);
var _Card=__webpack_require__(429);var _Card2=_interopRequireDefault(_Card);
var _Radio=__webpack_require__(430);var _Radio2=_interopRequireDefault(_Radio);
var _H=__webpack_require__(431);var _H2=_interopRequireDefault(_H);
var _H3=__webpack_require__(432);var _H4=_interopRequireDefault(_H3);
var _H5=__webpack_require__(433);var _H6=_interopRequireDefault(_H5);
var _Footer=__webpack_require__(434);var _Footer2=_interopRequireDefault(_Footer);
var _FooterTab=__webpack_require__(435);var _FooterTab2=_interopRequireDefault(_FooterTab);
var _Fab=__webpack_require__(436);var _Fab2=_interopRequireDefault(_Fab);
var _Item=__webpack_require__(437);var _Item2=_interopRequireDefault(_Item);
var _Label=__webpack_require__(438);var _Label2=_interopRequireDefault(_Label);
var _Textarea=__webpack_require__(439);var _Textarea2=_interopRequireDefault(_Textarea);
var _Text=__webpack_require__(440);var _Text2=_interopRequireDefault(_Text);
var _Toast=__webpack_require__(441);var _Toast2=_interopRequireDefault(_Toast);
var _Tab=__webpack_require__(442);var _Tab2=_interopRequireDefault(_Tab);
var _TabBar=__webpack_require__(443);var _TabBar2=_interopRequireDefault(_TabBar);
var _TabContainer=__webpack_require__(444);var _TabContainer2=_interopRequireDefault(_TabContainer);
var _View=__webpack_require__(445);var _View2=_interopRequireDefault(_View);
var _TabHeading=__webpack_require__(446);var _TabHeading2=_interopRequireDefault(_TabHeading);
var _Icon=__webpack_require__(447);var _Icon2=_interopRequireDefault(_Icon);
var _Input=__webpack_require__(448);var _Input2=_interopRequireDefault(_Input);
var _SwipeRow=__webpack_require__(449);var _SwipeRow2=_interopRequireDefault(_SwipeRow);
var _Segment=__webpack_require__(450);var _Segment2=_interopRequireDefault(_Segment);
var _Spinner=__webpack_require__(451);var _Spinner2=_interopRequireDefault(_Spinner);
var _CardItem=__webpack_require__(452);var _CardItem2=_interopRequireDefault(_CardItem);
var _ListItem=__webpack_require__(453);var _ListItem2=_interopRequireDefault(_ListItem);
var _Form=__webpack_require__(455);var _Form2=_interopRequireDefault(_Form);
var _Separator=__webpack_require__(456);var _Separator2=_interopRequireDefault(_Separator);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var theme={
variables:variables,
"NativeBase.Left":_extends({},
(0,_Left2.default)(variables)),

"NativeBase.Right":_extends({},
(0,_Right2.default)(variables)),

"NativeBase.Body":_extends({},
(0,_Body2.default)(variables)),


"NativeBase.Header":_extends({},
(0,_Header2.default)(variables)),


"NativeBase.Button":_extends({},
(0,_Button2.default)(variables)),


"NativeBase.Title":_extends({},
(0,_Title2.default)(variables)),

"NativeBase.Subtitle":_extends({},
(0,_Subtitle2.default)(variables)),


"NativeBase.InputGroup":_extends({},
(0,_InputGroup2.default)(variables)),


"NativeBase.Input":_extends({},
(0,_Input2.default)(variables)),


"NativeBase.Badge":_extends({},
(0,_Badge2.default)(variables)),


"NativeBase.CheckBox":_extends({},
(0,_CheckBox2.default)(variables)),


"NativeBase.Radio":_extends({},
(0,_Radio2.default)(variables)),


"NativeBase.Card":_extends({},
(0,_Card2.default)()),


"NativeBase.CardItem":_extends({},
(0,_CardItem2.default)(variables)),


"NativeBase.Toast":_extends({},
(0,_Toast2.default)(variables)),


"NativeBase.H1":_extends({},
(0,_H6.default)(variables)),

"NativeBase.H2":_extends({},
(0,_H4.default)(variables)),

"NativeBase.H3":_extends({},
(0,_H2.default)(variables)),

"NativeBase.Form":_extends({},
(0,_Form2.default)(variables)),


"NativeBase.Container":_extends({},
(0,_Container2.default)(variables)),

"NativeBase.Content":_extends({},
(0,_Content2.default)(variables)),


"NativeBase.Footer":_extends({},
(0,_Footer2.default)(variables)),


"NativeBase.Tabs":{
flex:1},


"NativeBase.FooterTab":_extends({},
(0,_FooterTab2.default)(variables)),


"NativeBase.ListItem":_extends({},
(0,_ListItem2.default)(variables)),


"NativeBase.ListItem1":_extends({},
(0,_ListItem2.default)(variables)),


"NativeBase.Icon":_extends({},
(0,_Icon2.default)(variables)),

"NativeBase.IconNB":_extends({},
(0,_Icon2.default)(variables)),

"NativeBase.Text":_extends({},
(0,_Text2.default)(variables)),

"NativeBase.Spinner":_extends({},
(0,_Spinner2.default)(variables)),


"NativeBase.Fab":_extends({},
(0,_Fab2.default)(variables)),


"NativeBase.Item":_extends({},
(0,_Item2.default)(variables)),


"NativeBase.Label":_extends({},
(0,_Label2.default)(variables)),


"NativeBase.Textarea":_extends({},
(0,_Textarea2.default)(variables)),


"NativeBase.PickerNB":{
"NativeBase.Button":{
"NativeBase.Text":{}}},



"NativeBase.Tab":_extends({},
(0,_Tab2.default)(variables)),


"NativeBase.Segment":_extends({},
(0,_Segment2.default)(variables)),


"NativeBase.TabBar":_extends({},
(0,_TabBar2.default)(variables)),

"NativeBase.ViewNB":_extends({},
(0,_View2.default)(variables)),

"NativeBase.TabHeading":_extends({},
(0,_TabHeading2.default)(variables)),

"NativeBase.TabContainer":_extends({},
(0,_TabContainer2.default)(variables)),

"NativeBase.Switch":_extends({},
(0,_Switch2.default)(variables)),

"NativeBase.Separator":_extends({},
(0,_Separator2.default)(variables)),

"NativeBase.SwipeRow":_extends({},
(0,_SwipeRow2.default)(variables)),

"NativeBase.Thumbnail":_extends({},
(0,_Thumbnail2.default)(variables))};



var cssifyTheme=function cssifyTheme(grandparent,parent,parentKey){
_lodash2.default.forEach(parent,function(style,styleName){


if(
styleName.indexOf(".")===0&&
parentKey&&
parentKey.indexOf(".")===0)
{
if(grandparent){
if(!grandparent[styleName]){
grandparent[styleName]={};
}else{
grandparent[styleName][parentKey]=style;
}
}
}
if(style&&typeof style==="object"){
cssifyTheme(parent,style,styleName);
}
});
};

cssifyTheme(null,theme,null);

return theme;
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var cssKeywords = __webpack_require__(183);

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in cssKeywords) {
	if (cssKeywords.hasOwnProperty(key)) {
		reverseKeywords[cssKeywords[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var v;

	if (max === 0) {
		s = 0;
	} else {
		s = (delta / max * 1000) / 10;
	}

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	v = ((max / 255) * 1000) / 10;

	return [h, s, v];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in cssKeywords) {
		if (cssKeywords.hasOwnProperty(keyword)) {
			var value = cssKeywords[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return cssKeywords[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.SwipeRow=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/SwipeRow.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _Text=__webpack_require__(29);
var _Left=__webpack_require__(70);
var _Right=__webpack_require__(71);
var _Body=__webpack_require__(72);
var _ListItem=__webpack_require__(73);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var PREVIEW_OPEN_DELAY=700;
var PREVIEW_CLOSE_DELAY=300;var

SwipeRow=function(_Component){_inherits(SwipeRow,_Component);












function SwipeRow(props){_classCallCheck(this,SwipeRow);var _this=_possibleConstructorReturn(this,(SwipeRow.__proto__||Object.getPrototypeOf(SwipeRow)).call(this,
props));
_this.horizontalSwipeGestureBegan=false;
_this.swipeInitialX=null;
_this.parentScrollEnabled=true;
_this.ranPreview=false;
_this.state={
dimensionsSet:false,
hiddenHeight:0,
hiddenWidth:0};

_this._translateX=new _reactNative.Animated.Value(0);return _this;
}_createClass(SwipeRow,[{key:"componentWillMount",value:function componentWillMount()

{var _this2=this;
this._panResponder=_reactNative.PanResponder.create({
onMoveShouldSetPanResponder:function onMoveShouldSetPanResponder(e,gs){return _this2.handleOnMoveShouldSetPanResponder(e,gs);},
onPanResponderMove:function onPanResponderMove(e,gs){return _this2.handlePanResponderMove(e,gs);},
onPanResponderRelease:function onPanResponderRelease(e,gs){return _this2.handlePanResponderEnd(e,gs);},
onPanResponderTerminate:function onPanResponderTerminate(e,gs){return _this2.handlePanResponderEnd(e,gs);},
onShouldBlockNativeResponder:function onShouldBlockNativeResponder(_){return false;}});

}},{key:"getPreviewAnimation",value:function getPreviewAnimation(

toValue,delay){
return _reactNative.Animated.timing(this._translateX,{duration:this.props.previewDuration,toValue:toValue,delay:delay});
}},{key:"onContentLayout",value:function onContentLayout(

e){var _this3=this;
this.setState({
dimensionsSet:!this.props.recalculateHiddenLayout,
hiddenHeight:e.nativeEvent.layout.height,
hiddenWidth:e.nativeEvent.layout.width});


if(this.props.preview&&!this.ranPreview){
this.ranPreview=true;
var previewOpenValue=this.props.previewOpenValue||this.props.rightOpenValue*0.5;
this.getPreviewAnimation(previewOpenValue,PREVIEW_OPEN_DELAY).start(function(_){
_this3.getPreviewAnimation(0,PREVIEW_CLOSE_DELAY).start();
});
}
}},{key:"handleOnMoveShouldSetPanResponder",value:function handleOnMoveShouldSetPanResponder(

e,gs){var
dx=gs.dx;
return Math.abs(dx)>this.props.directionalDistanceChangeThreshold;
}},{key:"handlePanResponderMove",value:function handlePanResponderMove(

e,gestureState){var
dx=gestureState.dx,dy=gestureState.dy;
var absDx=Math.abs(dx);
var absDy=Math.abs(dy);



if(
absDx>this.props.directionalDistanceChangeThreshold||
absDy>this.props.directionalDistanceChangeThreshold)
{

if(absDy>absDx&&!this.horizontalSwipeGestureBegan){

return;
}


if(this.parentScrollEnabled){

this.parentScrollEnabled=false;
this.props.setScrollEnabled&&this.props.setScrollEnabled(false);
}

if(this.swipeInitialX===null){

this.swipeInitialX=this._translateX._value;
}
if(!this.horizontalSwipeGestureBegan){
this.horizontalSwipeGestureBegan=true;
this.props.swipeGestureBegan&&this.props.swipeGestureBegan();
}

var newDX=this.swipeInitialX+dx;
if(this.props.disableLeftSwipe&&newDX<0){
newDX=0;
}
if(this.props.disableRightSwipe&&newDX>0){
newDX=0;
}

if(this.props.stopLeftSwipe&&newDX>this.props.stopLeftSwipe){
newDX=this.props.stopLeftSwipe;
}
if(this.props.stopRightSwipe&&newDX<this.props.stopRightSwipe){
newDX=this.props.stopRightSwipe;
}

this._translateX.setValue(newDX);
}
}},{key:"handlePanResponderEnd",value:function handlePanResponderEnd(

e,gestureState){

if(!this.parentScrollEnabled){
this.parentScrollEnabled=true;
this.props.setScrollEnabled&&this.props.setScrollEnabled(true);
}


var toValue=0;
if(this._translateX._value>=0){

if(this._translateX._value>this.props.leftOpenValue*(this.props.swipeToOpenPercent/100)){

toValue=this.props.leftOpenValue;
}
}else{

if(this._translateX._value<this.props.rightOpenValue*(this.props.swipeToOpenPercent/100)){

toValue=this.props.rightOpenValue;
}
}

this.manuallySwipeRow(toValue);
}},{key:"closeRow",value:function closeRow()




{
this.manuallySwipeRow(0);
}},{key:"manuallySwipeRow",value:function manuallySwipeRow(

toValue){var _this4=this;
_reactNative.Animated.spring(this._translateX,{
toValue:toValue,
friction:this.props.friction,
tension:this.props.tension}).
start(function(_){
if(toValue===0){
_this4.props.onRowDidClose&&_this4.props.onRowDidClose();
}else{
_this4.props.onRowDidOpen&&_this4.props.onRowDidOpen();
}
});

if(toValue===0){
this.props.onRowClose&&this.props.onRowClose();
}else{
this.props.onRowOpen&&this.props.onRowOpen(toValue);
}


this.swipeInitialX=null;
this.horizontalSwipeGestureBegan=false;
}},{key:"renderMainContent",value:function renderMainContent()

{var _this5=this;


if(this.state.dimensionsSet){
return(
_react2.default.createElement(_reactNative.Animated.View,_extends({},
this._panResponder.panHandlers,{
style:{
transform:[{translateX:this._translateX}],
zIndex:2},__source:{fileName:_jsxFileName,lineNumber:191}}),


!this.props.list?
_react2.default.createElement(_ListItem.ListItem,{list:true,__source:{fileName:_jsxFileName,lineNumber:199}},
this.props.body):

_react2.default.createElement(_reactNative.View,{style:{backgroundColor:'#FFF'},__source:{fileName:_jsxFileName,lineNumber:202}},
this.props.body)));



}else{
return(
_react2.default.createElement(_reactNative.Animated.View,_extends({},
this._panResponder.panHandlers,{
onLayout:function onLayout(e){return _this5.onContentLayout(e);},
style:{
transform:[{translateX:this._translateX}],
zIndex:2},__source:{fileName:_jsxFileName,lineNumber:209}}),


!this.props.list?
_react2.default.createElement(_ListItem.ListItem,{list:true,__source:{fileName:_jsxFileName,lineNumber:218}},
this.props.body):

_react2.default.createElement(_reactNative.View,{style:{backgroundColor:'#FFF'},__source:{fileName:_jsxFileName,lineNumber:221}},
this.props.body)));



}
}},{key:"render",value:function render()

{
return(
_react2.default.createElement(_reactNative.View,{style:this.props.style?this.props.style:undefined,__source:{fileName:_jsxFileName,lineNumber:231}},
_react2.default.createElement(_reactNative.View,{
style:[
styles.hidden,
{
height:this.state.hiddenHeight,
flex:1,
flexDirection:"row",
justifyContent:"space-between"}],__source:{fileName:_jsxFileName,lineNumber:232}},



_react2.default.createElement(_Left.Left,{style:{width:this.props.leftOpenValue,zIndex:1},__source:{fileName:_jsxFileName,lineNumber:243}},
this.props.left),

_react2.default.createElement(_Body.Body,{style:{flex:0},__source:{fileName:_jsxFileName,lineNumber:246}}),
_react2.default.createElement(_Right.Right,{style:{width:-this.props.rightOpenValue,zIndex:1},__source:{fileName:_jsxFileName,lineNumber:247}},
this.props.right)),


this.renderMainContent()));


}}]);return SwipeRow;}(_react.Component);SwipeRow.defaultProps={leftOpenValue:0,rightOpenValue:0,closeOnRowPress:true,disableLeftSwipe:false,disableRightSwipe:false,recalculateHiddenLayout:false,preview:false,previewDuration:300,directionalDistanceChangeThreshold:2,swipeToOpenPercent:50};


var styles={
container:{},



hidden:{
bottom:0,
left:0,
overflow:"hidden",
position:"absolute",
right:0,
top:0}};



var StyledSwipeRow=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.SwipeRow",{},_mapPropsToStyleNames2.default)(SwipeRow);exports.
SwipeRow=StyledSwipeRow;
//# sourceMappingURL=SwipeRow.js.map

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 187 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(76),
    stackClear = __webpack_require__(475),
    stackDelete = __webpack_require__(476),
    stackGet = __webpack_require__(477),
    stackHas = __webpack_require__(478),
    stackSet = __webpack_require__(479);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isObject = __webpack_require__(46);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(192);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(38);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(498),
    isArguments = __webpack_require__(114),
    isArray = __webpack_require__(20),
    isBuffer = __webpack_require__(115),
    isIndex = __webpack_require__(116),
    isTypedArray = __webpack_require__(194);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(501),
    baseUnary = __webpack_require__(502),
    nodeUtil = __webpack_require__(503);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(189),
    isLength = __webpack_require__(117);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(193),
    baseKeysIn = __webpack_require__(507),
    isArrayLike = __webpack_require__(196);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 198 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(120),
    getPrototype = __webpack_require__(121),
    getSymbols = __webpack_require__(119),
    stubArray = __webpack_require__(198);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(201),
    getSymbols = __webpack_require__(119),
    keys = __webpack_require__(113);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(120),
    isArray = __webpack_require__(20);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(201),
    getSymbolsIn = __webpack_require__(199),
    keysIn = __webpack_require__(197);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(514),
    Map = __webpack_require__(110),
    Promise = __webpack_require__(515),
    Set = __webpack_require__(516),
    WeakMap = __webpack_require__(517),
    baseGetTag = __webpack_require__(36),
    toSource = __webpack_require__(190);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(19);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 205 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 206 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 207 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(47),
    toKey = __webpack_require__(80);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(542),
    overRest = __webpack_require__(545),
    setToString = __webpack_require__(547);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(559);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(561),
    arraySome = __webpack_require__(564),
    cacheHas = __webpack_require__(565);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Header=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Header.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);
var _lodash=__webpack_require__(12);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Header=function(_Component){_inherits(Header,_Component);function Header(){_classCallCheck(this,Header);return _possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).apply(this,arguments));}_createClass(Header,[{key:"render",value:function render()




{var _this2=this;
var variables=this.context.theme?this.context.theme["@@shoutem.theme/themeStyle"].variables:_platform2.default;
var platformStyle=variables.platformStyle;

return(
_react2.default.createElement(_reactNative.View,{__source:{fileName:_jsxFileName,lineNumber:20}},
_react2.default.createElement(_reactNative.StatusBar,{
backgroundColor:
this.props.androidStatusBarColor?this.props.androidStatusBarColor:variables.statusBarColor,

barStyle:
this.props.iosBarStyle?
this.props.iosBarStyle:
platformStyle==="material"?"light-content":variables.iosStatusbar,__source:{fileName:_jsxFileName,lineNumber:21}}),


_react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:31}}))));


}}]);return Header;}(_react.Component);Header.contextTypes={theme:_propTypes2.default.object};


Header.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array]),
searchBar:_propTypes2.default.bool,
rounded:_propTypes2.default.bool});


var StyledHeader=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Header",{},_mapPropsToStyleNames2.default)(Header);exports.
Header=StyledHeader;
//# sourceMappingURL=Header.js.map

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Input=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Input.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);
var _NativeBaseComponent2=__webpack_require__(588);var _NativeBaseComponent3=_interopRequireDefault(_NativeBaseComponent2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Input=function(_NativeBaseComponent){_inherits(Input,_NativeBaseComponent);function Input(){_classCallCheck(this,Input);return _possibleConstructorReturn(this,(Input.__proto__||Object.getPrototypeOf(Input)).apply(this,arguments));}_createClass(Input,[{key:"render",value:function render()
{var _this2=this;
return(
_react2.default.createElement(_reactNative.TextInput,_extends({
ref:function ref(c){
_this2._textInput=c;
_this2._root=c;
},
editable:this.props.disabled?false:true},
this.props,{
placeholderTextColor:
this.props.placeholderTextColor?this.props.placeholderTextColor:_platform2.default.inputColorPlaceholder,

underlineColorAndroid:"rgba(0,0,0,0)",__source:{fileName:_jsxFileName,lineNumber:12}})));


}}]);return Input;}(_NativeBaseComponent3.default);


Input.propTypes=_extends({},
_reactNative.TextInput.propTypes,{
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledInput=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Input",{},_mapPropsToStyleNames2.default)(Input);exports.

Input=StyledInput;
//# sourceMappingURL=Input.js.map

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Title=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Title.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Title=function(_Component){_inherits(Title,_Component);function Title(){_classCallCheck(this,Title);return _possibleConstructorReturn(this,(Title.__proto__||Object.getPrototypeOf(Title)).apply(this,arguments));}_createClass(Title,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.Text,_extends({ref:function ref(c){return _this2._root=c;},numberOfLines:1},this.props,{__source:{fileName:_jsxFileName,lineNumber:9}}));
}}]);return Title;}(_react.Component);


Title.propTypes=_extends({},
_reactNative.Text.propTypes,{
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledTitle=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Title",{},_mapPropsToStyleNames2.default)(Title);exports.
Title=StyledTitle;
//# sourceMappingURL=Title.js.map

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Radio=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Radio.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _Ionicons=__webpack_require__(108);var _Ionicons2=_interopRequireDefault(_Ionicons);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);
var _computeProps=__webpack_require__(23);var _computeProps2=_interopRequireDefault(_computeProps);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Radio=function(_Component){_inherits(Radio,_Component);function Radio(){_classCallCheck(this,Radio);return _possibleConstructorReturn(this,(Radio.__proto__||Object.getPrototypeOf(Radio)).apply(this,arguments));}_createClass(Radio,[{key:"prepareRootProps",value:function prepareRootProps()



{
var defaultProps={
standardStyle:false};


return(0,_computeProps2.default)(this.props,defaultProps);
}},{key:"render",value:function render()

{var _this2=this;
var variables=this.context.theme?this.context.theme["@@shoutem.theme/themeStyle"].variables:_platform2.default;
var platformStyle=variables.platformStyle;
var platform=variables.platform;

return(
_react2.default.createElement(_reactNative.TouchableOpacity,_extends({ref:function ref(c){return _this2._root=c;}},this.prepareRootProps(),{__source:{fileName:_jsxFileName,lineNumber:28}}),
_reactNative.Platform.OS==="ios"&&!this.props.standardStyle?
this.props.selected&&
_react2.default.createElement(_Ionicons2.default,{
style:{
color:variables.brandPrimary,
lineHeight:25,
height:20,
fontSize:variables.radioBtnSize},

name:"ios-checkmark",__source:{fileName:_jsxFileName,lineNumber:31}}):

_react2.default.createElement(_Ionicons2.default,{
style:{
color:
_reactNative.Platform.OS==="ios"?
this.props.selected?variables.brandPrimary:undefined:
this.props.selected?variables.radioSelectedColorAndroid:undefined,
lineHeight:variables.radioBtnLineHeight,
fontSize:variables.radioBtnSize},

name:
_reactNative.Platform.OS==="ios"?
this.props.selected?"ios-radio-button-on":"ios-radio-button-off":
this.props.selected?"md-radio-button-on":"md-radio-button-off",__source:{fileName:_jsxFileName,lineNumber:40}})));




}}]);return Radio;}(_react.Component);Radio.contextTypes={theme:_propTypes2.default.object};


Radio.propTypes=_extends({},
_reactNative.TouchableOpacity.propTypes,{
selected:_propTypes2.default.bool,
standardStyle:_propTypes2.default.bool});


var StyledRadio=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Radio",{},_mapPropsToStyleNames2.default)(Radio);exports.

Radio=StyledRadio;
//# sourceMappingURL=Radio.js.map

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Container=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Container.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);
var _ToastContainer=__webpack_require__(125);
var _Actionsheet=__webpack_require__(126);
var _Text=__webpack_require__(29);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Container=function(_Component){_inherits(Container,_Component);function Container(){_classCallCheck(this,Container);return _possibleConstructorReturn(this,(Container.__proto__||Object.getPrototypeOf(Container)).apply(this,arguments));}_createClass(Container,[{key:"render",value:function render()
{var _this2=this;
return(
_react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:15}}),
this.props.children));


}}]);return Container;}(_react.Component);


Container.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledContainer=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Container",{},_mapPropsToStyleNames2.default)(Container);exports.

Container=StyledContainer;
//# sourceMappingURL=Container.js.map

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Content=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Content.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNativeKeyboardAwareScrollView=__webpack_require__(602);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Content=function(_Component){_inherits(Content,_Component);function Content(){_classCallCheck(this,Content);return _possibleConstructorReturn(this,(Content.__proto__||Object.getPrototypeOf(Content)).apply(this,arguments));}_createClass(Content,[{key:"render",value:function render()
{var _this2=this;
return(
_react2.default.createElement(_reactNativeKeyboardAwareScrollView.KeyboardAwareScrollView,_extends({
automaticallyAdjustContentInsets:false,
resetScrollToCoords:this.props.disableKBDismissScroll?null:{x:0,y:0},
ref:function ref(c){
_this2._scrollview=c;
_this2._root=c;
}},
this.props,{__source:{fileName:_jsxFileName,lineNumber:10}}),

this.props.children));


}}]);return Content;}(_react.Component);


Content.propTypes={
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array]),
padder:_propTypes2.default.bool,
disableKBDismissScroll:_propTypes2.default.bool,
enableResetScrollToCoords:_propTypes2.default.bool};


var StyledContent=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Content",{},_mapPropsToStyleNames2.default)(Content);exports.

Content=StyledContent;
//# sourceMappingURL=Content.js.map

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports = clamp

function clamp(value, min, max) {
  return min < max
    ? (value < min ? min : value > max ? max : value)
    : (value < max ? max : value > min ? min : value)
}


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Label=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Label.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Label=function(_Component){_inherits(Label,_Component);function Label(){_classCallCheck(this,Label);return _possibleConstructorReturn(this,(Label.__proto__||Object.getPrototypeOf(Label)).apply(this,arguments));}_createClass(Label,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.Text,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:10}}));
}}]);return Label;}(_react.Component);


Label.propTypes=_extends({},
_reactNative.Text.propTypes,{
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledLabel=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Label",{},_mapPropsToStyleNames2.default)(Label);exports.

Label=StyledLabel;
//# sourceMappingURL=Label.js.map

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.DefaultTabBar=undefined;var _jsxFileName="src/basic/Tabs/DefaultTabBar.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _createReactClass=__webpack_require__(28);var _createReactClass2=_interopRequireDefault(_createReactClass);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);
var _index=__webpack_require__(2);
var _lodash=__webpack_require__(12);var _lodash2=_interopRequireDefault(_lodash);


var _Utils=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ReactNative=__webpack_require__(1);var StyleSheet=ReactNative.StyleSheet,View=ReactNative.View,Animated=ReactNative.Animated,Platform=ReactNative.Platform;
var Button=__webpack_require__(221);

var DefaultTabBar=(0,_createReactClass2.default)({displayName:"DefaultTabBar",
propTypes:{
goToPage:_propTypes2.default.func,
activeTab:_propTypes2.default.number,
tabs:_propTypes2.default.array,
backgroundColor:_propTypes2.default.string,
activeTextColor:_propTypes2.default.string,
inactiveTextColor:_propTypes2.default.string,
tabStyle:_Utils.ViewPropTypes.style,
renderTab:_propTypes2.default.func,
underlineStyle:_Utils.ViewPropTypes.style,
tabContainerStyle:_Utils.ViewPropTypes.style},

contextTypes:{
theme:_propTypes2.default.object},


getDefaultProps:function getDefaultProps(){
return{
activeTextColor:_platform2.default.topTabBarActiveTextColor,
inactiveTextColor:_platform2.default.topTabBarTextColor,
backgroundColor:null};

},

renderTabOption:function renderTabOption(name,page){},

renderTab:function renderTab(
name,
page,
isTabActive,
onPressHandler,
tabStyle,
activeTabStyle,
textStyle,
activeTextStyle,
tabHeaderStyle)
{
var headerContent=typeof name!=="string"?name.props.children:undefined;var _props=
this.props,activeTextColor=_props.activeTextColor,inactiveTextColor=_props.inactiveTextColor;
var textColor=isTabActive?activeTextColor:inactiveTextColor;
var fontWeight=isTabActive?"bold":"normal";
if(typeof name==="string"){
return(
_react2.default.createElement(Button,{style:{flex:1},key:name,onPress:function onPress(){return onPressHandler(page);},__source:{fileName:_jsxFileName,lineNumber:59}},
_react2.default.createElement(_index.TabHeading,{style:isTabActive?activeTabStyle:tabStyle,active:isTabActive,__source:{fileName:_jsxFileName,lineNumber:60}},
_react2.default.createElement(_index.Text,{style:isTabActive?activeTextStyle:textStyle,__source:{fileName:_jsxFileName,lineNumber:61}},name))));



}else{
return(
_react2.default.createElement(Button,{style:{flex:1},key:_lodash2.default.random(1.2,5.2),onPress:function onPress(){return onPressHandler(page);},__source:{fileName:_jsxFileName,lineNumber:67}},
_react2.default.createElement(_index.TabHeading,{style:tabHeaderStyle,active:isTabActive,__source:{fileName:_jsxFileName,lineNumber:68}},
headerContent)));



}
},

render:function render(){var _this=this;
var variables=this.context.theme?
this.context.theme["@@shoutem.theme/themeStyle"].variables:_platform2.default;

var platformStyle=variables.platformStyle;
var containerWidth=this.props.containerWidth;
var numberOfTabs=this.props.tabs.length;
var tabUnderlineStyle={
position:"absolute",
width:containerWidth/numberOfTabs,
height:4,
backgroundColor:variables.topTabBarActiveBorderColor,
bottom:0};


var left=this.props.scrollValue.interpolate({
inputRange:[0,1],
outputRange:[0,containerWidth/numberOfTabs]});

return(
_react2.default.createElement(_index.TabContainer,{style:this.props.tabContainerStyle?this.props.tabContainerStyle:{},__source:{fileName:_jsxFileName,lineNumber:96}},
this.props.tabs.map(function(name,page){
var isTabActive=_this.props.activeTab===page;
var renderTab=_this.props.renderTab||_this.renderTab;
return renderTab(
name,
page,
isTabActive,
_this.props.goToPage,
_this.props.tabStyle[page],
_this.props.activeTabStyle[page],
_this.props.textStyle[page],
_this.props.activeTextStyle[page],
_this.props.tabHeaderStyle[page]);

}),
_react2.default.createElement(Animated.View,{style:[tabUnderlineStyle,{left:left},this.props.underlineStyle],__source:{fileName:_jsxFileName,lineNumber:112}})));


}});



var StyledTab=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.DefaultTabBar",{},_mapPropsToStyleNames2.default)(DefaultTabBar);exports.
DefaultTabBar=StyledTab;
//# sourceMappingURL=DefaultTabBar.js.map

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Tabs/Button.ios.js";var React=__webpack_require__(0);
var ReactNative=__webpack_require__(1);var
TouchableOpacity=ReactNative.TouchableOpacity,View=ReactNative.View;

var Button=function Button(props){
return(
React.createElement(TouchableOpacity,_extends({activeOpacity:0.6},props,{__source:{fileName:_jsxFileName,lineNumber:7}}),
props.children));


};

module.exports=Button;
//# sourceMappingURL=Button.ios.js.map

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.ScrollableTab=undefined;var _jsxFileName="src/basic/Tabs/ScrollableTabBar.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _createReactClass=__webpack_require__(28);var _createReactClass2=_interopRequireDefault(_createReactClass);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);
var _index=__webpack_require__(2);
var _lodash=__webpack_require__(12);var _lodash2=_interopRequireDefault(_lodash);

var _Utils=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ReactNative=__webpack_require__(1);var View=ReactNative.View,Animated=ReactNative.Animated,StyleSheet=ReactNative.StyleSheet,ScrollView=ReactNative.ScrollView,Platform=ReactNative.Platform,Dimensions=ReactNative.Dimensions;
var Button=__webpack_require__(221);

var WINDOW_WIDTH=Dimensions.get("window").width;

var ScrollableTabBar=(0,_createReactClass2.default)({displayName:"ScrollableTabBar",
propTypes:{
goToPage:_propTypes2.default.func,
activeTab:_propTypes2.default.number,
tabs:_propTypes2.default.array,
backgroundColor:_propTypes2.default.string,
activeTextColor:_propTypes2.default.string,
inactiveTextColor:_propTypes2.default.string,
scrollOffset:_propTypes2.default.number,
style:_Utils.ViewPropTypes.style,
tabStyle:_Utils.ViewPropTypes.style,
tabsContainerStyle:_Utils.ViewPropTypes.style,
renderTab:_propTypes2.default.func,
underlineStyle:_Utils.ViewPropTypes.style,
onScroll:_propTypes2.default.func},

contextTypes:{
theme:_propTypes2.default.object},


getDefaultProps:function getDefaultProps(){
return{
scrollOffset:52,
activeTextColor:"navy",
inactiveTextColor:"black",
backgroundColor:null,
style:{},
tabStyle:{},
tabsContainerStyle:{},
underlineStyle:{}};

},

getInitialState:function getInitialState(){
this._tabsMeasurements=[];
return{
_leftTabUnderline:new Animated.Value(0),
_widthTabUnderline:new Animated.Value(0),
_containerWidth:null};

},

componentDidMount:function componentDidMount(){
this.props.scrollValue.addListener(this.updateView);
},

updateView:function updateView(offset){
var position=Math.floor(offset.value);
var pageOffset=offset.value%1;
var tabCount=this.props.tabs.length;
var lastTabPosition=tabCount-1;

if(tabCount===0||offset.value<0||offset.value>lastTabPosition){
return;
}

if(this.necessarilyMeasurementsCompleted(position,position===lastTabPosition)){
this.updateTabPanel(position,pageOffset);
this.updateTabUnderline(position,pageOffset,tabCount);
}
},

necessarilyMeasurementsCompleted:function necessarilyMeasurementsCompleted(position,isLastTab){
return(
this._tabsMeasurements[position]&&(
isLastTab||this._tabsMeasurements[position+1])&&
this._tabContainerMeasurements&&
this._containerMeasurements);

},

updateTabPanel:function updateTabPanel(position,pageOffset){
var containerWidth=this._containerMeasurements.width;
var tabWidth=this._tabsMeasurements[position].width;
var nextTabMeasurements=this._tabsMeasurements[position+1];
var nextTabWidth=nextTabMeasurements&&nextTabMeasurements.width||0;
var tabOffset=this._tabsMeasurements[position].left;
var absolutePageOffset=pageOffset*tabWidth;
var newScrollX=tabOffset+absolutePageOffset;


newScrollX-=(containerWidth-(1-pageOffset)*tabWidth-pageOffset*nextTabWidth)/2;
newScrollX=newScrollX>=0?newScrollX:0;

if(Platform.OS==="android"){
this._scrollView.scrollTo({x:newScrollX,y:0,animated:false});
}else{
var rightBoundScroll=this._tabContainerMeasurements.width-this._containerMeasurements.width;
newScrollX=newScrollX>rightBoundScroll?rightBoundScroll:newScrollX;
this._scrollView.scrollTo({x:newScrollX,y:0,animated:false});
}
},

updateTabUnderline:function updateTabUnderline(position,pageOffset,tabCount){
var lineLeft=this._tabsMeasurements[position].left;
var lineRight=this._tabsMeasurements[position].right;

if(position<tabCount-1){
var nextTabLeft=this._tabsMeasurements[position+1].left;
var nextTabRight=this._tabsMeasurements[position+1].right;

var newLineLeft=pageOffset*nextTabLeft+(1-pageOffset)*lineLeft;
var newLineRight=pageOffset*nextTabRight+(1-pageOffset)*lineRight;

this.state._leftTabUnderline.setValue(newLineLeft);
this.state._widthTabUnderline.setValue(newLineRight-newLineLeft);
}else{
this.state._leftTabUnderline.setValue(lineLeft);
this.state._widthTabUnderline.setValue(lineRight-lineLeft);
}
},

renderTab:function renderTab(
name,
page,
isTabActive,
onPressHandler,
onLayoutHandler,
tabStyle,
activeTabStyle,
textStyle,
activeTextStyle,
tabHeaderStyle)
{
var headerContent=typeof name!=="string"?name.props.children:undefined;var _props=
this.props,activeTextColor=_props.activeTextColor,inactiveTextColor=_props.inactiveTextColor;
var textColor=isTabActive?activeTextColor:inactiveTextColor;
var fontWeight=isTabActive?"bold":"normal";

if(typeof name==="string"){
return(
_react2.default.createElement(Button,{key:name+"_"+page,onPress:function onPress(){return onPressHandler(page);},onLayout:onLayoutHandler,__source:{fileName:_jsxFileName,lineNumber:147}},
_react2.default.createElement(_index.TabHeading,{scrollable:true,style:isTabActive?activeTabStyle:tabStyle,active:isTabActive,__source:{fileName:_jsxFileName,lineNumber:148}},
_react2.default.createElement(_index.Text,{style:isTabActive?activeTextStyle:textStyle,__source:{fileName:_jsxFileName,lineNumber:149}},
name))));




}else{
return(
_react2.default.createElement(Button,{key:_lodash2.default.random(1.2,5.2),onPress:function onPress(){return onPressHandler(page);},onLayout:onLayoutHandler,__source:{fileName:_jsxFileName,lineNumber:157}},
_react2.default.createElement(_index.TabHeading,{scrollable:true,style:tabHeaderStyle,active:isTabActive,__source:{fileName:_jsxFileName,lineNumber:158}},
headerContent)));



}
},

measureTab:function measureTab(page,event){var _event$nativeEvent$la=
event.nativeEvent.layout,x=_event$nativeEvent$la.x,width=_event$nativeEvent$la.width,height=_event$nativeEvent$la.height;
this._tabsMeasurements[page]={left:x,right:x+width,width:width,height:height};
this.updateView({value:this.props.scrollValue._value});
},

render:function render(){var _this=this;
var variables=this.context.theme?this.context.theme["@@shoutem.theme/themeStyle"].variables:_platform2.default;
var tabUnderlineStyle={
position:"absolute",
height:4,
backgroundColor:variables.topTabBarActiveBorderColor,
bottom:0};


var dynamicTabUnderline={
left:this.state._leftTabUnderline,
width:this.state._widthTabUnderline};


return(
_react2.default.createElement(View,{
style:[styles.container,{backgroundColor:this.props.backgroundColor},this.props.style],
onLayout:this.onContainerLayout,__source:{fileName:_jsxFileName,lineNumber:187}},

_react2.default.createElement(ScrollView,{
automaticallyAdjustContentInsets:false,
ref:function ref(scrollView){
_this._scrollView=scrollView;
},
horizontal:true,
showsHorizontalScrollIndicator:false,
showsVerticalScrollIndicator:false,
directionalLockEnabled:true,
onScroll:this.props.onScroll,
bounces:false,
scrollsToTop:false,__source:{fileName:_jsxFileName,lineNumber:191}},

_react2.default.createElement(View,{
style:[styles.tabs,{width:this.state._containerWidth},this.props.tabsContainerStyle],
ref:"tabContainer",
onLayout:this.onTabContainerLayout,__source:{fileName:_jsxFileName,lineNumber:204}},

this.props.tabs.map(function(name,page){
var isTabActive=_this.props.activeTab===page;
var renderTab=_this.props.renderTab||_this.renderTab;
return renderTab(
name,
page,
isTabActive,
_this.props.goToPage,
_this.measureTab.bind(_this,page),
_this.props.tabStyle[page],
_this.props.activeTabStyle[page],
_this.props.textStyle[page],
_this.props.activeTextStyle[page],
_this.props.tabHeaderStyle[page]);

}),
_react2.default.createElement(Animated.View,{style:[tabUnderlineStyle,dynamicTabUnderline,this.props.underlineStyle],__source:{fileName:_jsxFileName,lineNumber:225}})))));




},

componentWillReceiveProps:function componentWillReceiveProps(nextProps){

if(!_lodash2.default.isEqual(this.props.tabs,nextProps.tabs)&&this.state._containerWidth){
this.setState({_containerWidth:null});
}
},

onTabContainerLayout:function onTabContainerLayout(e){
this._tabContainerMeasurements=e.nativeEvent.layout;
var width=this._tabContainerMeasurements.width;
if(width<WINDOW_WIDTH){
width=WINDOW_WIDTH;
}
this.setState({_containerWidth:width});
this.updateView({value:this.props.scrollValue._value});
},

onContainerLayout:function onContainerLayout(e){
this._containerMeasurements=e.nativeEvent.layout;
this.updateView({value:this.props.scrollValue._value});
}});



var StyledTab=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.ScrollableTab",{},_mapPropsToStyleNames2.default)(ScrollableTabBar);exports.
ScrollableTab=StyledTab;
var styles=StyleSheet.create({
tab:{
height:49,
alignItems:"center",
justifyContent:"center",
paddingLeft:20,
paddingRight:20},

container:{
height:50,
borderWidth:1,
borderTopWidth:0,
borderLeftWidth:0,
borderRightWidth:0,
borderColor:"#ccc"},

tabs:{
flexDirection:"row",
justifyContent:"space-around"}});
//# sourceMappingURL=ScrollableTabBar.js.map

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint global-require: 0 */module.exports={// Core
get createNavigationContainer(){return __webpack_require__(83).default;},get StateUtils(){return __webpack_require__(224).default;},get addNavigationHelpers(){return __webpack_require__(48).default;},get NavigationActions(){return __webpack_require__(39).default;},// Navigators
get createNavigator(){return __webpack_require__(84).default;},get StackNavigator(){return __webpack_require__(621).default;},get TabNavigator(){return __webpack_require__(631).default;},get DrawerNavigator(){return __webpack_require__(636).default;},// Routers
get StackRouter(){return __webpack_require__(237).default;},get TabRouter(){return __webpack_require__(131).default;},// Views
get Transitioner(){return __webpack_require__(236).default;},get CardStackTransitioner(){return __webpack_require__(225).default;},get CardStack(){return __webpack_require__(226).default;},get Card(){return __webpack_require__(227).default;},// Header
get Header(){return __webpack_require__(228).default;},get HeaderTitle(){return __webpack_require__(229).default;},get HeaderBackButton(){return __webpack_require__(230).default;},// DrawerView
get DrawerView(){return __webpack_require__(249).default;},get DrawerItems(){return __webpack_require__(250).default;},// TabView
get TabView(){return __webpack_require__(241).default;},get TabBarTop(){return __webpack_require__(246).default;},get TabBarBottom(){return __webpack_require__(248).default;},// HOCs
get withNavigation(){return __webpack_require__(642).default;}};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _invariant=__webpack_require__(25);var _invariant2=_interopRequireDefault(_invariant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Utilities to perform atomic operation with navigate state and routes.
 *
 * ```javascript
 * const state1 = {key: 'screen 1'};
 * const state2 = NavigationStateUtils.push(state1, {key: 'screen 2'});
 * ```
 */var StateUtils={/**
   * Gets a route by key. If the route isn't found, returns `null`.
   */get:function get(state,key){return state.routes.find(function(route){return route.key===key;})||null;},/**
   * Returns the first index at which a given route's key can be found in the
   * routes of the navigation state, or -1 if it is not present.
   */indexOf:function indexOf(state,key){return state.routes.map(function(route){return route.key;}).indexOf(key);},/**
   * Returns `true` at which a given route's key can be found in the
   * routes of the navigation state.
   */has:function has(state,key){return!!state.routes.some(function(route){return route.key===key;});},/**
   * Pushes a new route into the navigation state.
   * Note that this moves the index to the positon to where the last route in the
   * stack is at.
   */push:function push(state,route){(0,_invariant2.default)(StateUtils.indexOf(state,route.key)===-1,'should not push route with duplicated key %s',route.key);var routes=state.routes.slice();routes.push(route);return _extends({},state,{index:routes.length-1,routes:routes});},/**
   * Pops out a route from the navigation state.
   * Note that this moves the index to the positon to where the last route in the
   * stack is at.
   */pop:function pop(state){if(state.index<=0){// [Note]: Over-popping does not throw error. Instead, it will be no-op.
return state;}var routes=state.routes.slice(0,-1);return _extends({},state,{index:routes.length-1,routes:routes});},/**
   * Sets the focused route of the navigation state by index.
   */jumpToIndex:function jumpToIndex(state,index){if(index===state.index){return state;}(0,_invariant2.default)(!!state.routes[index],'invalid index %s to jump to',index);return _extends({},state,{index:index});},/**
   * Sets the focused route of the navigation state by key.
   */jumpTo:function jumpTo(state,key){var index=StateUtils.indexOf(state,key);return StateUtils.jumpToIndex(state,index);},/**
   * Sets the focused route to the previous route.
   */back:function back(state){var index=state.index-1;var route=state.routes[index];return route?StateUtils.jumpToIndex(state,index):state;},/**
   * Sets the focused route to the next route.
   */forward:function forward(state){var index=state.index+1;var route=state.routes[index];return route?StateUtils.jumpToIndex(state,index):state;},/**
   * Replace a route by a key.
   * Note that this moves the index to the positon to where the new route in the
   * stack is at.
   */replaceAt:function replaceAt(state,key,route){var index=StateUtils.indexOf(state,key);return StateUtils.replaceAtIndex(state,index,route);},/**
   * Replace a route by a index.
   * Note that this moves the index to the positon to where the new route in the
   * stack is at.
   */replaceAtIndex:function replaceAtIndex(state,index,route){(0,_invariant2.default)(!!state.routes[index],'invalid index %s for replacing route %s',index,route.key);if(state.routes[index]===route){return state;}var routes=state.routes.slice();routes[index]=route;return _extends({},state,{index:index,routes:routes});},/**
   * Resets all routes.
   * Note that this moves the index to the positon to where the last route in the
   * stack is at if the param `index` isn't provided.
   */reset:function reset(state,routes,index){(0,_invariant2.default)(routes.length&&Array.isArray(routes),'invalid routes to replace');var nextIndex=index===undefined?routes.length-1:index;if(state.routes.length===routes.length&&state.index===nextIndex){var compare=function compare(route,ii){return routes[ii]===route;};if(state.routes.every(compare)){return state;}}(0,_invariant2.default)(!!routes[nextIndex],'invalid index %s to reset',nextIndex);return _extends({},state,{index:nextIndex,routes:routes});}};exports.default=StateUtils;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);var _CardStack=__webpack_require__(226);var _CardStack2=_interopRequireDefault(_CardStack);var _CardStackStyleInterpolator=__webpack_require__(235);var _CardStackStyleInterpolator2=_interopRequireDefault(_CardStackStyleInterpolator);var _Transitioner=__webpack_require__(236);var _Transitioner2=_interopRequireDefault(_Transitioner);var _TransitionConfigs=__webpack_require__(234);var _TransitionConfigs2=_interopRequireDefault(_TransitionConfigs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NativeAnimatedModule=_reactNative.NativeModules&&_reactNative.NativeModules.NativeAnimatedModule;var CardStackTransitioner=function(_Component){_inherits(CardStackTransitioner,_Component);function CardStackTransitioner(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CardStackTransitioner);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CardStackTransitioner.__proto__||Object.getPrototypeOf(CardStackTransitioner)).call.apply(_ref,[this].concat(args))),_this),_this._configureTransition=function(// props for the new screen
transitionProps,prevTransitionProps){var isModal=_this.props.mode==='modal';// Copy the object so we can assign useNativeDriver below
// (avoid Flow error, transitionSpec is of type NavigationTransitionSpec).
var transitionSpec=_extends({},_TransitionConfigs2.default.getTransitionConfig(_this.props.transitionConfig,transitionProps,prevTransitionProps,isModal).transitionSpec);if(!!NativeAnimatedModule&&// Native animation support also depends on the transforms used:
_CardStackStyleInterpolator2.default.canUseNativeDriver()){// Internal undocumented prop
transitionSpec.useNativeDriver=true;}return transitionSpec;},_this._render=function(props){var _this$props=_this.props,screenProps=_this$props.screenProps,headerMode=_this$props.headerMode,mode=_this$props.mode,router=_this$props.router,cardStyle=_this$props.cardStyle,transitionConfig=_this$props.transitionConfig,style=_this$props.style;return _react2.default.createElement(_CardStack2.default,_extends({screenProps:screenProps,headerMode:headerMode,mode:mode,router:router,cardStyle:cardStyle,transitionConfig:transitionConfig,style:style},props));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CardStackTransitioner,[{key:'render',value:function render(){return _react2.default.createElement(_Transitioner2.default,{configureTransition:this._configureTransition,navigation:this.props.navigation,render:this._render,style:this.props.style,onTransitionStart:this.props.onTransitionStart,onTransitionEnd:this.props.onTransitionEnd});}}]);return CardStackTransitioner;}(_react.Component);CardStackTransitioner.defaultProps={mode:'card'};exports.default=CardStackTransitioner;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _clamp=__webpack_require__(218);var _clamp2=_interopRequireDefault(_clamp);var _reactNative=__webpack_require__(1);var _Card=__webpack_require__(227);var _Card2=_interopRequireDefault(_Card);var _Header=__webpack_require__(228);var _Header2=_interopRequireDefault(_Header);var _NavigationActions=__webpack_require__(39);var _NavigationActions2=_interopRequireDefault(_NavigationActions);var _addNavigationHelpers=__webpack_require__(48);var _addNavigationHelpers2=_interopRequireDefault(_addNavigationHelpers);var _SceneView=__webpack_require__(128);var _SceneView2=_interopRequireDefault(_SceneView);var _TransitionConfigs=__webpack_require__(234);var _TransitionConfigs2=_interopRequireDefault(_TransitionConfigs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var emptyFunction=function emptyFunction(){};/**
 * The max duration of the card animation in milliseconds after released gesture.
 * The actual duration should be always less then that because the rest distance 
 * is always less then the full distance of the layout.
 */var ANIMATION_DURATION=500;/**
 * The gesture distance threshold to trigger the back behavior. For instance,
 * `1/2` means that moving greater than 1/2 of the width of the screen will
 * trigger a back action
 */var POSITION_THRESHOLD=1/2;/**
 * The threshold (in pixels) to start the gesture action.
 */var RESPOND_THRESHOLD=20;/**
 * The distance of touch start from the edge of the screen where the gesture will be recognized
 */var GESTURE_RESPONSE_DISTANCE_HORIZONTAL=25;var GESTURE_RESPONSE_DISTANCE_VERTICAL=135;var animatedSubscribeValue=function animatedSubscribeValue(animatedValue){if(!animatedValue.__isNative){return;}if(Object.keys(animatedValue._listeners).length===0){animatedValue.addListener(emptyFunction);}};var CardStack=function(_Component){_inherits(CardStack,_Component);function CardStack(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CardStack);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CardStack.__proto__||Object.getPrototypeOf(CardStack)).call.apply(_ref,[this].concat(args))),_this),_this._gestureStartValue=0,_this._isResponding=false,_this._immediateIndex=null,_this._screenDetails={},_this._getScreenDetails=function(scene){var _this$props=_this.props,screenProps=_this$props.screenProps,navigation=_this$props.navigation,router=_this$props.router;var screenDetails=_this._screenDetails[scene.key];if(!screenDetails||screenDetails.state!==scene.route){var screenNavigation=(0,_addNavigationHelpers2.default)(_extends({},navigation,{state:scene.route}));screenDetails={state:scene.route,navigation:screenNavigation,options:router.getScreenOptions(screenNavigation,screenProps)};_this._screenDetails[scene.key]=screenDetails;}return screenDetails;},_this._getTransitionConfig=function(){var isModal=_this.props.mode==='modal';/* $FlowFixMe */return _TransitionConfigs2.default.getTransitionConfig(_this.props.transitionConfig,{},{},isModal);},_this._renderCard=function(scene){var _this$_getTransitionC=_this._getTransitionConfig(),screenInterpolator=_this$_getTransitionC.screenInterpolator;var style=screenInterpolator&&screenInterpolator(_extends({},_this.props,{scene:scene}));var SceneComponent=_this.props.router.getComponentForRouteName(scene.route.routeName);return _react2.default.createElement(_Card2.default,_extends({},_this.props,{key:'card_'+scene.key,style:[style,_this.props.cardStyle],scene:scene}),_this._renderInnerScene(SceneComponent,scene));},_temp),_possibleConstructorReturn(_this,_ret);}/**
   * Used to identify the starting point of the position when the gesture starts, such that it can
   * be updated according to its relative position. This means that a card can effectively be
   * "caught"- If a gesture starts while a card is animating, the card does not jump into a
   * corresponding location for the touch.
   */// tracks if a touch is currently happening
/**
   * immediateIndex is used to represent the expected index that we will be on after a
   * transition. To achieve a smooth animation when swiping back, the action to go back
   * doesn't actually fire until the transition completes. The immediateIndex is used during
   * the transition so that gestures can be handled correctly. This is a work-around for
   * cases when the user quickly swipes back several times.
   */_createClass(CardStack,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){var _this2=this;if(props.screenProps!==this.props.screenProps){this._screenDetails={};}props.scenes.forEach(function(newScene){if(_this2._screenDetails[newScene.key]&&_this2._screenDetails[newScene.key].state!==newScene.route){_this2._screenDetails[newScene.key]=null;}});}},{key:'_renderHeader',value:function _renderHeader(scene,headerMode){var header=this._getScreenDetails(scene).options.header;if(typeof header!=='undefined'&&typeof header!=='function'){return header;}var renderHeader=header||function(props){return _react2.default.createElement(_Header2.default,props);};// We need to explicitly exclude `mode` since Flow doesn't see
// mode: headerMode override below and reports prop mismatch
var _props=this.props,mode=_props.mode,passProps=_objectWithoutProperties(_props,['mode']);return renderHeader(_extends({},passProps,{scene:scene,mode:headerMode,getScreenDetails:this._getScreenDetails}));}// eslint-disable-next-line class-methods-use-this
},{key:'_animatedSubscribe',value:function _animatedSubscribe(props){// Hack to make this work with native driven animations. We add a single listener
// so the JS value of the following animated values gets updated. We rely on
// some Animated private APIs and not doing so would require using a bunch of
// value listeners but we'd have to remove them to not leak and I'm not sure
// when we'd do that with the current structure we have. `stopAnimation` callback
// is also broken with native animated values that have no listeners so if we
// want to remove this we have to fix this too.
animatedSubscribeValue(props.layout.width);animatedSubscribeValue(props.layout.height);animatedSubscribeValue(props.position);}},{key:'_reset',value:function _reset(resetToIndex,duration){_reactNative.Animated.timing(this.props.position,{toValue:resetToIndex,duration:duration,easing:_reactNative.Easing.linear(),useNativeDriver:this.props.position.__isNative}).start();}},{key:'_goBack',value:function _goBack(backFromIndex,duration){var _this3=this;var _props2=this.props,navigation=_props2.navigation,position=_props2.position,scenes=_props2.scenes;var toValue=Math.max(backFromIndex-1,0);// set temporary index for gesture handler to respect until the action is
// dispatched at the end of the transition.
this._immediateIndex=toValue;_reactNative.Animated.timing(position,{toValue:toValue,duration:duration,easing:_reactNative.Easing.linear(),useNativeDriver:position.__isNative}).start(function(){_this3._immediateIndex=null;var backFromScene=scenes.find(function(s){return s.index===toValue+1;});if(!_this3._isResponding&&backFromScene){navigation.dispatch(_NavigationActions2.default.back({key:backFromScene.route.key}));}});}},{key:'render',value:function render(){var _this4=this;var floatingHeader=null;var headerMode=this._getHeaderMode();if(headerMode==='float'){floatingHeader=this._renderHeader(this.props.scene,headerMode);}var _props3=this.props,navigation=_props3.navigation,position=_props3.position,layout=_props3.layout,scene=_props3.scene,scenes=_props3.scenes,mode=_props3.mode;var index=navigation.state.index;var isVertical=mode==='modal';var responder=_reactNative.PanResponder.create({onPanResponderTerminate:function onPanResponderTerminate(){_this4._isResponding=false;_this4._reset(index,0);},onPanResponderGrant:function onPanResponderGrant(){position.stopAnimation(function(value){_this4._isResponding=true;_this4._gestureStartValue=value;});},onMoveShouldSetPanResponder:function onMoveShouldSetPanResponder(event,gesture){if(index!==scene.index){return false;}var immediateIndex=_this4._immediateIndex==null?index:_this4._immediateIndex;var currentDragDistance=gesture[isVertical?'dy':'dx'];var currentDragPosition=event.nativeEvent[isVertical?'pageY':'pageX'];var axisLength=isVertical?layout.height.__getValue():layout.width.__getValue();var axisHasBeenMeasured=!!axisLength;// Measure the distance from the touch to the edge of the screen
var screenEdgeDistance=currentDragPosition-currentDragDistance;// Compare to the gesture distance relavant to card or modal
var _getScreenDetails$opt=_this4._getScreenDetails(scene).options.gestureResponseDistance,userGestureResponseDistance=_getScreenDetails$opt===undefined?{}:_getScreenDetails$opt;var gestureResponseDistance=isVertical?userGestureResponseDistance.vertical||GESTURE_RESPONSE_DISTANCE_VERTICAL:userGestureResponseDistance.horizontal||GESTURE_RESPONSE_DISTANCE_HORIZONTAL;// GESTURE_RESPONSE_DISTANCE is about 25 or 30. Or 135 for modals
if(screenEdgeDistance>gestureResponseDistance){// Reject touches that started in the middle of the screen
return false;}var hasDraggedEnough=Math.abs(currentDragDistance)>RESPOND_THRESHOLD;var isOnFirstCard=immediateIndex===0;var shouldSetResponder=hasDraggedEnough&&axisHasBeenMeasured&&!isOnFirstCard;return shouldSetResponder;},onPanResponderMove:function onPanResponderMove(event,gesture){// Handle the moving touches for our granted responder
var startValue=_this4._gestureStartValue;var axis=isVertical?'dy':'dx';var axisDistance=isVertical?layout.height.__getValue():layout.width.__getValue();var currentValue=_reactNative.I18nManager.isRTL&&axis==='dx'?startValue+gesture[axis]/axisDistance:startValue-gesture[axis]/axisDistance;var value=(0,_clamp2.default)(index-1,currentValue,index);position.setValue(value);},onPanResponderTerminationRequest:function onPanResponderTerminationRequest(){return(// Returning false will prevent other views from becoming responder while
// the navigation view is the responder (mid-gesture)
false);},onPanResponderRelease:function onPanResponderRelease(event,gesture){if(!_this4._isResponding){return;}_this4._isResponding=false;var immediateIndex=_this4._immediateIndex==null?index:_this4._immediateIndex;// Calculate animate duration according to gesture speed and moved distance
var axisDistance=isVertical?layout.height.__getValue():layout.width.__getValue();var movedDistance=gesture[isVertical?'dy':'dx'];var gestureVelocity=gesture[isVertical?'vy':'vx'];var defaultVelocity=axisDistance/ANIMATION_DURATION;var velocity=Math.max(Math.abs(gestureVelocity),defaultVelocity);var resetDuration=movedDistance/velocity;var goBackDuration=(axisDistance-movedDistance)/velocity;// To asyncronously get the current animated value, we need to run stopAnimation:
position.stopAnimation(function(value){// If the speed of the gesture release is significant, use that as the indication
// of intent
if(gestureVelocity<-0.5){_this4._reset(immediateIndex,resetDuration);return;}if(gestureVelocity>0.5){_this4._goBack(immediateIndex,goBackDuration);return;}// Then filter based on the distance the screen was moved. Over a third of the way swiped,
// and the back will happen.
if(value<=index-POSITION_THRESHOLD){_this4._goBack(immediateIndex,goBackDuration);}else{_this4._reset(immediateIndex,resetDuration);}});}});var _getScreenDetails=this._getScreenDetails(scene),options=_getScreenDetails.options;var gesturesEnabled=typeof options.gesturesEnabled==='boolean'?options.gesturesEnabled:_reactNative.Platform.OS==='ios';var handlers=gesturesEnabled?responder.panHandlers:{};var containerStyle=[styles.container,this._getTransitionConfig().containerStyle];return _react2.default.createElement(_reactNative.View,_extends({},handlers,{style:containerStyle}),_react2.default.createElement(_reactNative.View,{style:styles.scenes},scenes.map(function(s){return _this4._renderCard(s);})),floatingHeader);}},{key:'_getHeaderMode',value:function _getHeaderMode(){if(this.props.headerMode){return this.props.headerMode;}if(_reactNative.Platform.OS==='android'||this.props.mode==='modal'){return'screen';}return'float';}},{key:'_renderInnerScene',value:function _renderInnerScene(SceneComponent,scene){var _getScreenDetails2=this._getScreenDetails(scene),navigation=_getScreenDetails2.navigation;var screenProps=this.props.screenProps;var headerMode=this._getHeaderMode();if(headerMode==='screen'){return _react2.default.createElement(_reactNative.View,{style:styles.container},_react2.default.createElement(_reactNative.View,{style:{flex:1}},_react2.default.createElement(_SceneView2.default,{screenProps:screenProps,navigation:navigation,component:SceneComponent})),this._renderHeader(scene,headerMode));}return _react2.default.createElement(_SceneView2.default,{screenProps:this.props.screenProps,navigation:navigation,component:SceneComponent});}}]);return CardStack;}(_react.Component);var styles=_reactNative.StyleSheet.create({container:{flex:1,// Header is physically rendered after scenes so that Header won't be
// covered by the shadows of the scenes.
// That said, we'd have use `flexDirection: 'column-reverse'` to move
// Header above the scenes.
flexDirection:'column-reverse'},scenes:{flex:1}});exports.default=CardStack;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);var _PointerEventsContainer=__webpack_require__(622);var _PointerEventsContainer2=_interopRequireDefault(_PointerEventsContainer);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Component that renders the scene as card for the <NavigationCardStack />.
 */var Card=function(_React$Component){_inherits(Card,_React$Component);function Card(){_classCallCheck(this,Card);return _possibleConstructorReturn(this,(Card.__proto__||Object.getPrototypeOf(Card)).apply(this,arguments));}_createClass(Card,[{key:'render',value:function render(){var _props=this.props,children=_props.children,pointerEvents=_props.pointerEvents,style=_props.style;return _react2.default.createElement(_reactNative.Animated.View,{pointerEvents:pointerEvents,ref:this.props.onComponentRef,style:[styles.main,style]},children);}}]);return Card;}(_react2.default.Component);var styles=_reactNative.StyleSheet.create({main:{backgroundColor:'#E9E9EF',bottom:0,left:0,position:'absolute',right:0,shadowColor:'black',shadowOffset:{width:0,height:0},shadowOpacity:0.2,shadowRadius:5,top:0}});Card=(0,_PointerEventsContainer2.default)(Card);exports.default=Card;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'no babel-plugin-flow-react-proptypes';var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);var _HeaderTitle=__webpack_require__(229);var _HeaderTitle2=_interopRequireDefault(_HeaderTitle);var _HeaderBackButton=__webpack_require__(230);var _HeaderBackButton2=_interopRequireDefault(_HeaderBackButton);var _HeaderStyleInterpolator=__webpack_require__(625);var _HeaderStyleInterpolator2=_interopRequireDefault(_HeaderStyleInterpolator);var _withOrientation=__webpack_require__(232);var _withOrientation2=_interopRequireDefault(_withOrientation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==='undefined'?'undefined':_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==='undefined'?'undefined':_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var APPBAR_HEIGHT=_reactNative.Platform.OS==='ios'?44:56;var STATUSBAR_HEIGHT=_reactNative.Platform.OS==='ios'?20:0;var TITLE_OFFSET=_reactNative.Platform.OS==='ios'?70:56;var Header=function(_React$PureComponent){_inherits(Header,_React$PureComponent);function Header(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Header);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Header.__proto__||Object.getPrototypeOf(Header)).call.apply(_ref,[this].concat(args))),_this),_this.state={widths:{}},_this._navigateBack=function(){_this.props.navigation.goBack(null);},_this._renderTitleComponent=function(props){var details=_this.props.getScreenDetails(props.scene);var headerTitle=details.options.headerTitle;if(headerTitle&&typeof headerTitle!=='string'){return headerTitle;}var titleString=_this._getHeaderTitleString(props.scene);var titleStyle=details.options.headerTitleStyle;var color=details.options.headerTintColor;var allowFontScaling=details.options.headerTitleAllowFontScaling;// On iOS, width of left/right components depends on the calculated
// size of the title.
var onLayoutIOS=_reactNative.Platform.OS==='ios'?function(e){_this.setState({widths:_extends({},_this.state.widths,_defineProperty({},props.scene.key,e.nativeEvent.layout.width))});}:undefined;return _react2.default.createElement(_HeaderTitle2.default,{onLayout:onLayoutIOS,allowFontScaling:allowFontScaling==null?true:allowFontScaling,style:[color?{color:color}:null,titleStyle]},titleString);},_this._renderLeftComponent=function(props){var options=_this.props.getScreenDetails(props.scene).options;if(typeof options.headerLeft!=='undefined'){return options.headerLeft;}if(props.scene.index===0){return null;}var backButtonTitle=_this._getBackButtonTitleString(props.scene);var truncatedBackButtonTitle=_this._getTruncatedBackButtonTitle(props.scene);var width=_this.state.widths[props.scene.key]?(_this.props.layout.initWidth-_this.state.widths[props.scene.key])/2:undefined;return _react2.default.createElement(_HeaderBackButton2.default,{onPress:_this._navigateBack,pressColorAndroid:options.headerPressColorAndroid,tintColor:options.headerTintColor,title:backButtonTitle,truncatedTitle:truncatedBackButtonTitle,titleStyle:options.headerBackTitleStyle,width:width});},_this._renderRightComponent=function(props){var details=_this.props.getScreenDetails(props.scene);var headerRight=details.options.headerRight;return headerRight||null;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Header,[{key:'_getHeaderTitleString',value:function _getHeaderTitleString(scene){var sceneOptions=this.props.getScreenDetails(scene).options;if(typeof sceneOptions.headerTitle==='string'){return sceneOptions.headerTitle;}return sceneOptions.title;}},{key:'_getLastScene',value:function _getLastScene(scene){return this.props.scenes.find(function(s){return s.index===scene.index-1;});}},{key:'_getBackButtonTitleString',value:function _getBackButtonTitleString(scene){var lastScene=this._getLastScene(scene);if(!lastScene){return null;}var headerBackTitle=this.props.getScreenDetails(lastScene).options.headerBackTitle;if(headerBackTitle||headerBackTitle===null){return headerBackTitle;}return this._getHeaderTitleString(lastScene);}},{key:'_getTruncatedBackButtonTitle',value:function _getTruncatedBackButtonTitle(scene){var lastScene=this._getLastScene(scene);if(!lastScene){return null;}return this.props.getScreenDetails(lastScene).options.headerTruncatedBackTitle;}},{key:'_renderLeft',value:function _renderLeft(props){return this._renderSubView(props,'left',this._renderLeftComponent,_HeaderStyleInterpolator2.default.forLeft);}},{key:'_renderTitle',value:function _renderTitle(props,options){var style={};if(_reactNative.Platform.OS==='android'){if(!options.hasLeftComponent){style.left=0;}if(!options.hasRightComponent){style.right=0;}}return this._renderSubView(_extends({},props,{style:style}),'title',this._renderTitleComponent,_HeaderStyleInterpolator2.default.forCenter);}},{key:'_renderRight',value:function _renderRight(props){return this._renderSubView(props,'right',this._renderRightComponent,_HeaderStyleInterpolator2.default.forRight);}},{key:'_renderSubView',value:function _renderSubView(props,name,renderer,styleInterpolator){var scene=props.scene;var index=scene.index,isStale=scene.isStale,key=scene.key;var offset=this.props.navigation.state.index-index;if(Math.abs(offset)>2){// Scene is far away from the active scene. Hides it to avoid unnecessary
// rendering.
return null;}var subView=renderer(props);if(subView==null){return null;}var pointerEvents=offset!==0||isStale?'none':'box-none';return _react2.default.createElement(_reactNative.Animated.View,{pointerEvents:pointerEvents,key:name+'_'+key,style:[styles.item,styles[name],props.style,styleInterpolator(_extends({},this.props,props))]},subView);}},{key:'_renderHeader',value:function _renderHeader(props){var left=this._renderLeft(props);var right=this._renderRight(props);var title=this._renderTitle(props,{hasLeftComponent:!!left,hasRightComponent:!!right});return _react2.default.createElement(_reactNative.View,{style:[_reactNative.StyleSheet.absoluteFill,styles.header],key:'scene_'+props.scene.key},title,left,right);}},{key:'render',value:function render(){var _this2=this;var appBar=void 0;if(this.props.mode==='float'){var scenesProps=this.props.scenes.map(function(scene){return{position:_this2.props.position,progress:_this2.props.progress,scene:scene};});appBar=scenesProps.map(this._renderHeader,this);}else{appBar=this._renderHeader({position:new _reactNative.Animated.Value(this.props.scene.index),progress:new _reactNative.Animated.Value(0),scene:this.props.scene});}// eslint-disable-next-line no-unused-vars
var _props=this.props,scenes=_props.scenes,scene=_props.scene,position=_props.position,screenProps=_props.screenProps,progress=_props.progress,style=_props.style,isLandscape=_props.isLandscape,rest=_objectWithoutProperties(_props,['scenes','scene','position','screenProps','progress','style','isLandscape']);var _props$getScreenDetai=this.props.getScreenDetails(scene),options=_props$getScreenDetai.options;var headerStyle=options.headerStyle;var landscapeAwareStatusBarHeight=isLandscape?0:STATUSBAR_HEIGHT;var containerStyles=[styles.container,{paddingTop:landscapeAwareStatusBarHeight,height:APPBAR_HEIGHT+landscapeAwareStatusBarHeight},headerStyle,style];return _react2.default.createElement(_reactNative.Animated.View,_extends({},rest,{style:containerStyles}),_react2.default.createElement(_reactNative.View,{style:styles.appBar},appBar));}}]);return Header;}(_react2.default.PureComponent);Header.HEIGHT=APPBAR_HEIGHT+STATUSBAR_HEIGHT;var platformContainerStyles=void 0;if(_reactNative.Platform.OS==='ios'){platformContainerStyles={borderBottomWidth:_reactNative.StyleSheet.hairlineWidth,borderBottomColor:'rgba(0, 0, 0, .3)'};}else{platformContainerStyles={shadowColor:'black',shadowOpacity:0.1,shadowRadius:_reactNative.StyleSheet.hairlineWidth,shadowOffset:{height:_reactNative.StyleSheet.hairlineWidth},elevation:4};}var styles=_reactNative.StyleSheet.create({container:_extends({backgroundColor:_reactNative.Platform.OS==='ios'?'#F7F7F7':'#FFF'},platformContainerStyles),appBar:{flex:1},header:{flexDirection:'row'},item:{justifyContent:'center',alignItems:'center',backgroundColor:'transparent'},title:{bottom:0,left:TITLE_OFFSET,right:TITLE_OFFSET,top:0,position:'absolute',alignItems:_reactNative.Platform.OS==='ios'?'center':'flex-start'},left:{left:0,bottom:0,top:0,position:'absolute'},right:{right:0,bottom:0,top:0,position:'absolute'}});exports.default=(0,_withOrientation2.default)(Header);

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var AnimatedText=_reactNative.Animated.Text;var HeaderTitle=function HeaderTitle(_ref){var style=_ref.style,rest=_objectWithoutProperties(_ref,['style']);return _react2.default.createElement(AnimatedText,_extends({numberOfLines:1},rest,{style:[styles.title,style],accessibilityTraits:'header'}));};var styles=_reactNative.StyleSheet.create({title:{fontSize:_reactNative.Platform.OS==='ios'?17:20,fontWeight:_reactNative.Platform.OS==='ios'?'600':'500',color:'rgba(0, 0, 0, .9)',textAlign:_reactNative.Platform.OS==='ios'?'center':'left',marginHorizontal:16}});exports.default=HeaderTitle;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);var _TouchableItem=__webpack_require__(231);var _TouchableItem2=_interopRequireDefault(_TouchableItem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeaderBackButton=function(_React$PureComponent){_inherits(HeaderBackButton,_React$PureComponent);function HeaderBackButton(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HeaderBackButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HeaderBackButton.__proto__||Object.getPrototypeOf(HeaderBackButton)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_this._onTextLayout=function(e){if(_this.state.initialTextWidth){return;}_this.setState({initialTextWidth:e.nativeEvent.layout.x+e.nativeEvent.layout.width});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HeaderBackButton,[{key:'render',value:function render(){var _props=this.props,onPress=_props.onPress,pressColorAndroid=_props.pressColorAndroid,width=_props.width,title=_props.title,titleStyle=_props.titleStyle,tintColor=_props.tintColor,truncatedTitle=_props.truncatedTitle;var renderTruncated=this.state.initialTextWidth&&width?this.state.initialTextWidth>width:false;var backButtonTitle=renderTruncated?truncatedTitle:title;// eslint-disable-next-line global-require
var asset=__webpack_require__(624);return _react2.default.createElement(_TouchableItem2.default,{accessibilityComponentType:'button',accessibilityLabel:backButtonTitle,accessibilityTraits:'button',testID:'header-back',delayPressIn:0,onPress:onPress,pressColor:pressColorAndroid,style:styles.container,borderless:true},_react2.default.createElement(_reactNative.View,{style:styles.container},_react2.default.createElement(_reactNative.Image,{style:[styles.icon,!!title&&styles.iconWithTitle,!!tintColor&&{tintColor:tintColor}],source:asset}),_reactNative.Platform.OS==='ios'&&title&&_react2.default.createElement(_reactNative.Text,{onLayout:this._onTextLayout,style:[styles.title,!!tintColor&&{color:tintColor},titleStyle],numberOfLines:1},backButtonTitle)));}}]);return HeaderBackButton;}(_react2.default.PureComponent);HeaderBackButton.defaultProps={pressColorAndroid:'rgba(0, 0, 0, .32)',tintColor:_reactNative.Platform.select({ios:'#037aff'}),truncatedTitle:'Back'};var styles=_reactNative.StyleSheet.create({container:{alignItems:'center',flexDirection:'row',backgroundColor:'transparent'},title:{fontSize:17,paddingRight:10},icon:_reactNative.Platform.OS==='ios'?{height:21,width:13,marginLeft:10,marginRight:22,marginVertical:12,resizeMode:'contain',transform:[{scaleX:_reactNative.I18nManager.isRTL?-1:1}]}:{height:24,width:24,margin:16,resizeMode:'contain',transform:[{scaleX:_reactNative.I18nManager.isRTL?-1:1}]},iconWithTitle:_reactNative.Platform.OS==='ios'?{marginRight:5}:{}});exports.default=HeaderBackButton;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * TouchableItem renders a touchable that looks native on both iOS and Android.
 *
 * It provides an abstraction on top of TouchableNativeFeedback and
 * TouchableOpacity.
 *
 * On iOS you can pass the props of TouchableOpacity, on Android pass the props
 * of TouchableNativeFeedback.
 */var ANDROID_VERSION_LOLLIPOP=21;var TouchableItem=function(_Component){_inherits(TouchableItem,_Component);function TouchableItem(){_classCallCheck(this,TouchableItem);return _possibleConstructorReturn(this,(TouchableItem.__proto__||Object.getPrototypeOf(TouchableItem)).apply(this,arguments));}_createClass(TouchableItem,[{key:'render',value:function render(){/*
       * TouchableNativeFeedback.Ripple causes a crash on old Android versions,
       * therefore only enable it on Android Lollipop and above.
       *
       * All touchables on Android should have the ripple effect according to
       * platform design guidelines.
       * We need to pass the background prop to specify a borderless ripple effect.
       */if(_reactNative.Platform.OS==='android'&&_reactNative.Platform.Version>=ANDROID_VERSION_LOLLIPOP){var _props=this.props,_style=_props.style,rest=_objectWithoutProperties(_props,['style']);// eslint-disable-line no-unused-vars
return _react2.default.createElement(_reactNative.TouchableNativeFeedback,_extends({},rest,{style:null,background:_reactNative.TouchableNativeFeedback.Ripple(this.props.pressColor||'',this.props.borderless||false)}),_react2.default.createElement(_reactNative.View,{style:this.props.style},_react.Children.only(this.props.children)));}return _react2.default.createElement(_reactNative.TouchableOpacity,this.props,this.props.children);}}]);return TouchableItem;}(_react.Component);TouchableItem.defaultProps={borderless:false,pressColor:'rgba(0, 0, 0, .32)'};exports.default=TouchableItem;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});exports.isOrientationLandscape=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=function(WrappedComponent){var withOrientation=function(_React$Component){_inherits(withOrientation,_React$Component);function withOrientation(){_classCallCheck(this,withOrientation);var _this=_possibleConstructorReturn(this,(withOrientation.__proto__||Object.getPrototypeOf(withOrientation)).call(this));_initialiseProps.call(_this);var isLandscape=isOrientationLandscape(_reactNative.Dimensions.get('window'));_this.state={isLandscape:isLandscape};return _this;}_createClass(withOrientation,[{key:'componentDidMount',value:function componentDidMount(){_reactNative.Dimensions.addEventListener('change',this.handleOrientationChange);}},{key:'componentWillUnmount',value:function componentWillUnmount(){_reactNative.Dimensions.removeEventListener('change',this.handleOrientationChange);}},{key:'render',value:function render(){return _react2.default.createElement(WrappedComponent,_extends({},this.props,this.state));}}]);return withOrientation;}(_react2.default.Component);var _initialiseProps=function _initialiseProps(){var _this2=this;this.handleOrientationChange=function(_ref2){var window=_ref2.window;var isLandscape=isOrientationLandscape(window);_this2.setState({isLandscape:isLandscape});};};return(0,_hoistNonReactStatics2.default)(withOrientation,WrappedComponent);};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);var _hoistNonReactStatics=__webpack_require__(233);var _hoistNonReactStatics2=_interopRequireDefault(_hoistNonReactStatics);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var isOrientationLandscape=exports.isOrientationLandscape=function isOrientationLandscape(_ref){var width=_ref.width,height=_ref.height;return width>height;};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _reactNative=__webpack_require__(1);var _CardStackStyleInterpolator=__webpack_require__(235);var _CardStackStyleInterpolator2=_interopRequireDefault(_CardStackStyleInterpolator);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IOSTransitionSpec={duration:500,easing:_reactNative.Easing.bezier(0.2833,0.99,0.31833,0.99),timing:_reactNative.Animated.timing};// Standard iOS navigation transition
var SlideFromRightIOS={transitionSpec:IOSTransitionSpec,screenInterpolator:_CardStackStyleInterpolator2.default.forHorizontal,containerStyle:{backgroundColor:'#000'}};// Standard iOS navigation transition for modals
var ModalSlideFromBottomIOS={transitionSpec:IOSTransitionSpec,screenInterpolator:_CardStackStyleInterpolator2.default.forVertical,containerStyle:{backgroundColor:'#000'}};// Standard Android navigation transition when opening an Activity
var FadeInFromBottomAndroid={// See http://androidxref.com/7.1.1_r6/xref/frameworks/base/core/res/res/anim/activity_open_enter.xml
transitionSpec:{duration:350,easing:_reactNative.Easing.out(_reactNative.Easing.poly(5)),// decelerate
timing:_reactNative.Animated.timing},screenInterpolator:_CardStackStyleInterpolator2.default.forFadeFromBottomAndroid};// Standard Android navigation transition when closing an Activity
var FadeOutToBottomAndroid={// See http://androidxref.com/7.1.1_r6/xref/frameworks/base/core/res/res/anim/activity_close_exit.xml
transitionSpec:{duration:230,easing:_reactNative.Easing.in(_reactNative.Easing.poly(4)),// accelerate
timing:_reactNative.Animated.timing},screenInterpolator:_CardStackStyleInterpolator2.default.forFadeFromBottomAndroid};function defaultTransitionConfig(// props for the new screen
transitionProps,// props for the old screen
prevTransitionProps,// whether we're animating in/out a modal screen
isModal){if(_reactNative.Platform.OS==='android'){// Use the default Android animation no matter if the screen is a modal.
// Android doesn't have full-screen modals like iOS does, it has dialogs.
if(prevTransitionProps&&transitionProps.index<prevTransitionProps.index){// Navigating back to the previous screen
return FadeOutToBottomAndroid;}return FadeInFromBottomAndroid;}// iOS and other platforms
if(isModal){return ModalSlideFromBottomIOS;}return SlideFromRightIOS;}function getTransitionConfig(transitionConfigurer,// props for the new screen
transitionProps,// props for the old screen
prevTransitionProps,isModal){var defaultConfig=defaultTransitionConfig(transitionProps,prevTransitionProps,isModal);if(transitionConfigurer){return _extends({},defaultConfig,transitionConfigurer());}return defaultConfig;}exports.default={defaultTransitionConfig:defaultTransitionConfig,getTransitionConfig:getTransitionConfig};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _reactNative=__webpack_require__(1);/**
 * Utility that builds the style for the card in the cards stack.
 *
 *     +------------+
 *   +-+            |
 * +-+ |            |
 * | | |            |
 * | | |  Focused   |
 * | | |   Card     |
 * | | |            |
 * +-+ |            |
 *   +-+            |
 *     +------------+
 *//**
 * Render the initial style when the initial layout isn't measured yet.
 */function forInitial(props){var navigation=props.navigation,scene=props.scene;var focused=navigation.state.index===scene.index;var opacity=focused?1:0;// If not focused, move the scene far away.
var translate=focused?0:1000000;return{opacity:opacity,transform:[{translateX:translate},{translateY:translate}]};}/**
 * Standard iOS-style slide in from the right.
 */function forHorizontal(props){var layout=props.layout,position=props.position,scene=props.scene;if(!layout.isMeasured){return forInitial(props);}var index=scene.index;var inputRange=[index-1,index,index+1];var width=layout.initWidth;var outputRange=_reactNative.I18nManager.isRTL?[-width,0,width*0.3]:[width,0,width*-0.3];// Add [index - 1, index - 0.99] to the interpolated opacity for screen transition.
// This makes the screen's shadow to disappear smoothly.
var opacity=position.interpolate({inputRange:[index-1,index-0.99,index,index+0.99,index+1],outputRange:[0,1,1,0.85,0]});var translateY=0;var translateX=position.interpolate({inputRange:inputRange,outputRange:outputRange});return{opacity:opacity,transform:[{translateX:translateX},{translateY:translateY}]};}/**
 * Standard iOS-style slide in from the bottom (used for modals).
 */function forVertical(props){var layout=props.layout,position=props.position,scene=props.scene;if(!layout.isMeasured){return forInitial(props);}var index=scene.index;var height=layout.initHeight;var opacity=position.interpolate({inputRange:[index-1,index-0.99,index,index+0.99,index+1],outputRange:[0,1,1,0.85,0]});var translateX=0;var translateY=position.interpolate({inputRange:[index-1,index,index+1],outputRange:[height,0,0]});return{opacity:opacity,transform:[{translateX:translateX},{translateY:translateY}]};}/**
 * Standard Android-style fade in from the bottom.
 */function forFadeFromBottomAndroid(props){var layout=props.layout,position=props.position,scene=props.scene;if(!layout.isMeasured){return forInitial(props);}var index=scene.index;var inputRange=[index-1,index,index+0.99,index+1];var opacity=position.interpolate({inputRange:inputRange,outputRange:[0,1,1,0]});var translateX=0;var translateY=position.interpolate({inputRange:inputRange,outputRange:[50,0,0,0]});return{opacity:opacity,transform:[{translateX:translateX},{translateY:translateY}]};}function canUseNativeDriver(){// The native driver can be enabled for this interpolator animating
// opacity, translateX, and translateY is supported by the native animation
// driver on iOS and Android.
return true;}exports.default={forHorizontal:forHorizontal,forVertical:forVertical,forFadeFromBottomAndroid:forFadeFromBottomAndroid,canUseNativeDriver:canUseNativeDriver};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);var _invariant=__webpack_require__(25);var _invariant2=_interopRequireDefault(_invariant);var _ScenesReducer=__webpack_require__(626);var _ScenesReducer2=_interopRequireDefault(_ScenesReducer);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Used for all animations unless overriden
var DefaultTransitionSpec={duration:250,easing:_reactNative.Easing.inOut(_reactNative.Easing.ease),timing:_reactNative.Animated.timing};var Transitioner=function(_React$Component){_inherits(Transitioner,_React$Component);function Transitioner(props,context){_classCallCheck(this,Transitioner);// The initial layout isn't measured. Measured layout will be only available
// when the component is mounted.
var _this=_possibleConstructorReturn(this,(Transitioner.__proto__||Object.getPrototypeOf(Transitioner)).call(this,props,context));var layout={height:new _reactNative.Animated.Value(0),initHeight:0,initWidth:0,isMeasured:false,width:new _reactNative.Animated.Value(0)};_this.state={layout:layout,position:new _reactNative.Animated.Value(_this.props.navigation.state.index),progress:new _reactNative.Animated.Value(1),scenes:(0,_ScenesReducer2.default)([],_this.props.navigation.state)};_this._prevTransitionProps=null;_this._transitionProps=buildTransitionProps(props,_this.state);_this._isMounted=false;_this._isTransitionRunning=false;_this._queuedTransition=null;return _this;}_createClass(Transitioner,[{key:'componentWillMount',value:function componentWillMount(){this._onLayout=this._onLayout.bind(this);this._onTransitionEnd=this._onTransitionEnd.bind(this);}},{key:'componentDidMount',value:function componentDidMount(){this._isMounted=true;}},{key:'componentWillUnmount',value:function componentWillUnmount(){this._isMounted=false;}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var nextScenes=(0,_ScenesReducer2.default)(this.state.scenes,nextProps.navigation.state,this.props.navigation.state);if(nextScenes===this.state.scenes){return;}var indexHasChanged=nextProps.navigation.state.index!==this.props.navigation.state.index;if(this._isTransitionRunning){this._queuedTransition={nextProps:nextProps,nextScenes:nextScenes,indexHasChanged:indexHasChanged};return;}this._startTransition(nextProps,nextScenes,indexHasChanged);}},{key:'_startTransition',value:function _startTransition(nextProps,nextScenes,indexHasChanged){var _this2=this;var nextState=_extends({},this.state,{scenes:nextScenes});var position=nextState.position,progress=nextState.progress;progress.setValue(0);this._prevTransitionProps=this._transitionProps;this._transitionProps=buildTransitionProps(nextProps,nextState);// get the transition spec.
var transitionUserSpec=nextProps.configureTransition?nextProps.configureTransition(this._transitionProps,this._prevTransitionProps):null;var transitionSpec=_extends({},DefaultTransitionSpec,transitionUserSpec);var timing=transitionSpec.timing;delete transitionSpec.timing;var toValue=nextProps.navigation.state.index;var positionHasChanged=position.__getValue()!==toValue;// if swiped back, indexHasChanged == true && positionHasChanged == false
var animations=indexHasChanged&&positionHasChanged?[timing(progress,_extends({},transitionSpec,{toValue:1})),timing(position,_extends({},transitionSpec,{toValue:nextProps.navigation.state.index}))]:[];// update scenes and play the transition
this._isTransitionRunning=true;this.setState(nextState,function(){nextProps.onTransitionStart&&nextProps.onTransitionStart(_this2._transitionProps,_this2._prevTransitionProps);_reactNative.Animated.parallel(animations).start(_this2._onTransitionEnd);});}},{key:'render',value:function render(){return _react2.default.createElement(_reactNative.View,{onLayout:this._onLayout,style:[styles.main,this.props.style]},this.props.render(this._transitionProps,this._prevTransitionProps));}},{key:'_onLayout',value:function _onLayout(event){var _event$nativeEvent$la=event.nativeEvent.layout,height=_event$nativeEvent$la.height,width=_event$nativeEvent$la.width;if(this.state.layout.initWidth===width&&this.state.layout.initHeight===height){return;}var layout=_extends({},this.state.layout,{initHeight:height,initWidth:width,isMeasured:true});layout.height.setValue(height);layout.width.setValue(width);var nextState=_extends({},this.state,{layout:layout});this._transitionProps=buildTransitionProps(this.props,nextState);this.setState(nextState);}},{key:'_onTransitionEnd',value:function _onTransitionEnd(){var _this3=this;if(!this._isMounted){return;}var prevTransitionProps=this._prevTransitionProps;this._prevTransitionProps=null;var nextState=_extends({},this.state,{scenes:this.state.scenes.filter(isSceneNotStale)});this._transitionProps=buildTransitionProps(this.props,nextState);this.setState(nextState,function(){_this3.props.onTransitionEnd&&_this3.props.onTransitionEnd(_this3._transitionProps,prevTransitionProps);if(_this3._queuedTransition){_this3._startTransition(_this3._queuedTransition.nextProps,_this3._queuedTransition.nextScenes,_this3._queuedTransition.indexHasChanged);_this3._queuedTransition=null;}else{_this3._isTransitionRunning=false;}});}}]);return Transitioner;}(_react2.default.Component);function buildTransitionProps(props,state){var navigation=props.navigation;var layout=state.layout,position=state.position,progress=state.progress,scenes=state.scenes;var scene=scenes.find(isSceneActive);(0,_invariant2.default)(scene,'Could not find active scene');return{layout:layout,navigation:navigation,position:position,progress:progress,scenes:scenes,scene:scene,index:scene.index};}function isSceneNotStale(scene){return!scene.isStale;}function isSceneActive(scene){return scene.isActive;}var styles=_reactNative.StyleSheet.create({main:{flex:1}});exports.default=Transitioner;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _pathToRegexp=__webpack_require__(628);var _pathToRegexp2=_interopRequireDefault(_pathToRegexp);var _NavigationActions=__webpack_require__(39);var _NavigationActions2=_interopRequireDefault(_NavigationActions);var _createConfigGetter=__webpack_require__(238);var _createConfigGetter2=_interopRequireDefault(_createConfigGetter);var _getScreenForRouteName=__webpack_require__(129);var _getScreenForRouteName2=_interopRequireDefault(_getScreenForRouteName);var _StateUtils=__webpack_require__(224);var _StateUtils2=_interopRequireDefault(_StateUtils);var _validateRouteConfigMap=__webpack_require__(239);var _validateRouteConfigMap2=_interopRequireDefault(_validateRouteConfigMap);var _getScreenConfigDeprecated=__webpack_require__(240);var _getScreenConfigDeprecated2=_interopRequireDefault(_getScreenConfigDeprecated);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var uniqueBaseId='id-'+Date.now();var uuidCount=0;function _getUuid(){return uniqueBaseId+'-'+uuidCount++;}exports.default=function(routeConfigs){var stackConfig=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};// Fail fast on invalid route definitions
(0,_validateRouteConfigMap2.default)(routeConfigs);var childRouters={};var routeNames=Object.keys(routeConfigs);// Loop through routes and find child routers
routeNames.forEach(function(routeName){var screen=(0,_getScreenForRouteName2.default)(routeConfigs,routeName);if(screen&&screen.router){// If it has a router it's a navigator.
childRouters[routeName]=screen.router;}else{// If it doesn't have router it's an ordinary React component.
childRouters[routeName]=null;}});var initialRouteParams=stackConfig.initialRouteParams;var initialRouteName=stackConfig.initialRouteName||routeNames[0];var initialChildRouter=childRouters[initialRouteName];var paths=stackConfig.paths||{};// Build paths for each route
routeNames.forEach(function(routeName){var pathPattern=paths[routeName]||routeConfigs[routeName].path;var matchExact=!!pathPattern&&!childRouters[routeName];if(typeof pathPattern!=='string'){pathPattern=routeName;}var keys=[];var re=(0,_pathToRegexp2.default)(pathPattern,keys);if(!matchExact){var wildcardRe=(0,_pathToRegexp2.default)(pathPattern+'/*',keys);re=new RegExp('(?:'+re.source+')|(?:'+wildcardRe.source+')');}/* $FlowFixMe */paths[routeName]={re:re,keys:keys,toPath:_pathToRegexp2.default.compile(pathPattern)};});return{getComponentForState:function getComponentForState(state){var activeChildRoute=state.routes[state.index];var routeName=activeChildRoute.routeName;if(childRouters[routeName]){return childRouters[routeName].getComponentForState(activeChildRoute);}return(0,_getScreenForRouteName2.default)(routeConfigs,routeName);},getComponentForRouteName:function getComponentForRouteName(routeName){return(0,_getScreenForRouteName2.default)(routeConfigs,routeName);},getStateForAction:function getStateForAction(passedAction,state){var action=_NavigationActions2.default.mapDeprecatedActionAndWarn(passedAction);// Set up the initial state if needed
if(!state){var route={};if(action.type===_NavigationActions2.default.NAVIGATE&&childRouters[action.routeName]!==undefined){return{index:0,routes:[_extends({},action,{type:undefined,key:'Init-'+_getUuid()})]};}if(initialChildRouter){route=initialChildRouter.getStateForAction(_NavigationActions2.default.navigate({routeName:initialRouteName,params:initialRouteParams}));}var params=(route.params||action.params||initialRouteParams)&&_extends({},route.params||{},action.params||{},initialRouteParams||{});route=_extends({},route,{routeName:initialRouteName,key:'Init-'+_getUuid()},params?{params:params}:{});// eslint-disable-next-line no-param-reassign
state={index:0,routes:[route]};}// Check if a child scene wants to handle the action as long as it is not a reset to the root stack
if(action.type!==_NavigationActions2.default.RESET||action.key!==null){var keyIndex=action.key?_StateUtils2.default.indexOf(state,action.key):-1;var childIndex=keyIndex>=0?keyIndex:state.index;var childRoute=state.routes[childIndex];var childRouter=childRouters[childRoute.routeName];if(childRouter){var _route=childRouter.getStateForAction(action,childRoute);if(_route===null){return state;}if(_route&&_route!==childRoute){return _StateUtils2.default.replaceAt(state,childRoute.key,_route);}}}// Handle explicit push navigation action
if(action.type===_NavigationActions2.default.NAVIGATE&&childRouters[action.routeName]!==undefined){var _childRouter=childRouters[action.routeName];var _route2=void 0;if(_childRouter){var childAction=action.action||_NavigationActions2.default.init({params:action.params});_route2=_extends({params:action.params},_childRouter.getStateForAction(childAction),{key:_getUuid(),routeName:action.routeName});}else{_route2={params:action.params,key:_getUuid(),routeName:action.routeName};}return _StateUtils2.default.push(state,_route2);}// Handle navigation to other child routers that are not yet pushed
if(action.type===_NavigationActions2.default.NAVIGATE){var childRouterNames=Object.keys(childRouters);for(var i=0;i<childRouterNames.length;i++){var childRouterName=childRouterNames[i];var _childRouter2=childRouters[childRouterName];if(_childRouter2){// For each child router, start with a blank state
var initChildRoute=_childRouter2.getStateForAction(_NavigationActions2.default.init());// Then check to see if the router handles our navigate action
var navigatedChildRoute=_childRouter2.getStateForAction(action,initChildRoute);var routeToPush=null;if(navigatedChildRoute===null){// Push the route if the router has 'handled' the action and returned null
routeToPush=initChildRoute;}else if(navigatedChildRoute!==initChildRoute){// Push the route if the state has changed in response to this navigation
routeToPush=navigatedChildRoute;}if(routeToPush){return _StateUtils2.default.push(state,_extends({},routeToPush,{key:_getUuid(),routeName:childRouterName}));}}}}if(action.type===_NavigationActions2.default.SET_PARAMS){var lastRoute=state.routes.find(/* $FlowFixMe */function(route){return route.key===action.key;});if(lastRoute){var _params=_extends({},lastRoute.params,action.params);var routes=[].concat(_toConsumableArray(state.routes));routes[state.routes.indexOf(lastRoute)]=_extends({},lastRoute,{params:_params});return _extends({},state,{routes:routes});}}if(action.type===_NavigationActions2.default.RESET){var resetAction=action;return _extends({},state,{routes:resetAction.actions.map(function(childAction){var router=childRouters[childAction.routeName];if(router){return _extends({},childAction,router.getStateForAction(childAction),{routeName:childAction.routeName,key:_getUuid()});}var route=_extends({},childAction,{key:_getUuid()});delete route.type;return route;}),index:action.index});}if(action.type===_NavigationActions2.default.BACK){var backRouteIndex=null;if(action.key){var backRoute=state.routes.find(/* $FlowFixMe */function(route){return route.key===action.key;});/* $FlowFixMe */backRouteIndex=state.routes.indexOf(backRoute);}if(backRouteIndex==null){return _StateUtils2.default.pop(state);}if(backRouteIndex>0){return _extends({},state,{routes:state.routes.slice(0,backRouteIndex),index:backRouteIndex-1});}}return state;},getPathAndParamsForState:function getPathAndParamsForState(state){var route=state.routes[state.index];var routeName=route.routeName;var screen=(0,_getScreenForRouteName2.default)(routeConfigs,routeName);/* $FlowFixMe */var subPath=paths[routeName].toPath(route.params);var path=subPath;var params=route.params;if(screen&&screen.router){// If it has a router it's a navigator.
// If it doesn't have router it's an ordinary React component.
var child=screen.router.getPathAndParamsForState(route);path=subPath?subPath+'/'+child.path:child.path;params=child.params?_extends({},params,child.params):params;}return{path:path,params:params};},getActionForPathAndParams:function getActionForPathAndParams(pathToResolve){// If the path is empty (null or empty string)
// just return the initial route action
if(!pathToResolve){return _NavigationActions2.default.navigate({routeName:initialRouteName});}var _pathToResolve$split=pathToResolve.split('?'),_pathToResolve$split2=_slicedToArray(_pathToResolve$split,2),pathNameToResolve=_pathToResolve$split2[0],queryString=_pathToResolve$split2[1];// Attempt to match `pathNameToResolve` with a route in this router's
// routeConfigs
var matchedRouteName=void 0;var pathMatch=void 0;var pathMatchKeys=void 0;// eslint-disable-next-line no-restricted-syntax
var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.entries(paths)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _step$value=_slicedToArray(_step.value,2),routeName=_step$value[0],path=_step$value[1];/* $FlowFixMe */var re=path.re,keys=path.keys;pathMatch=re.exec(pathNameToResolve);if(pathMatch&&pathMatch.length){pathMatchKeys=keys;matchedRouteName=routeName;break;}}// We didn't match -- return null
}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(!matchedRouteName){return null;}// Determine nested actions:
// If our matched route for this router is a child router,
// get the action for the path AFTER the matched path for this
// router
var nestedAction=void 0;var nestedQueryString=queryString?'?'+queryString:'';if(childRouters[matchedRouteName]){nestedAction=childRouters[matchedRouteName].getActionForPathAndParams(/* $FlowFixMe */pathMatch.slice(pathMatchKeys.length).join('/')+nestedQueryString);}// reduce the items of the query string. any query params may
// be overridden by path params
var queryParams=(queryString||'').split('&').reduce(function(result,item){if(item!==''){var nextResult=result||{};var _item$split=item.split('='),_item$split2=_slicedToArray(_item$split,2),key=_item$split2[0],value=_item$split2[1];nextResult[key]=value;return nextResult;}return result;},null);// reduce the matched pieces of the path into the params
// of the route. `params` is null if there are no params.
/* $FlowFixMe */var params=pathMatch.slice(1).reduce(function(result,matchResult,i){var key=pathMatchKeys[i];if(key.asterisk||!key){return result;}var nextResult=result||{};var paramName=key.name;nextResult[paramName]=matchResult;return nextResult;},queryParams);return _NavigationActions2.default.navigate(_extends({routeName:matchedRouteName},params?{params:params}:{},nestedAction?{action:nestedAction}:{}));},getScreenOptions:(0,_createConfigGetter2.default)(routeConfigs,stackConfig.navigationOptions),getScreenConfig:_getScreenConfigDeprecated2.default};};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof2=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==="undefined"?"undefined":_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==="undefined"?"undefined":_typeof2(obj);};var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _invariant=__webpack_require__(25);var _invariant2=_interopRequireDefault(_invariant);var _getScreenForRouteName=__webpack_require__(129);var _getScreenForRouteName2=_interopRequireDefault(_getScreenForRouteName);var _addNavigationHelpers=__webpack_require__(48);var _addNavigationHelpers2=_interopRequireDefault(_addNavigationHelpers);var _validateScreenOptions=__webpack_require__(630);var _validateScreenOptions2=_interopRequireDefault(_validateScreenOptions);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function applyConfig(configurer,navigationOptions,configProps){if(typeof configurer==='function'){return _extends({},navigationOptions,configurer(_extends({},configProps,{navigationOptions:navigationOptions})));}if((typeof configurer==='undefined'?'undefined':_typeof(configurer))==='object'){return _extends({},navigationOptions,configurer);}return navigationOptions;}exports.default=function(routeConfigs,navigatorScreenConfig){return function(navigation,screenProps){var state=navigation.state,dispatch=navigation.dispatch;var route=state;// $FlowFixMe
var _ref=route,routes=_ref.routes,index=_ref.index;(0,_invariant2.default)(route.routeName&&typeof route.routeName==='string','Cannot get config because the route does not have a routeName.');var Component=(0,_getScreenForRouteName2.default)(routeConfigs,route.routeName);var outputConfig={};if(Component.router){if(!route||!routes||index==null){throw new Error('Expect nav state to have routes and index, '+JSON.stringify(route));}var childRoute=routes[index];var childNavigation=(0,_addNavigationHelpers2.default)({state:childRoute,dispatch:dispatch});outputConfig=Component.router.getScreenOptions(childNavigation,screenProps);}var routeConfig=routeConfigs[route.routeName];var routeScreenConfig=routeConfig.navigationOptions;var componentScreenConfig=Component.navigationOptions;var configOptions={navigation:navigation,screenProps:screenProps||{}};outputConfig=applyConfig(navigatorScreenConfig,outputConfig,configOptions);outputConfig=applyConfig(componentScreenConfig,outputConfig,configOptions);outputConfig=applyConfig(routeScreenConfig,outputConfig,configOptions);(0,_validateScreenOptions2.default)(outputConfig,route);return outputConfig;};};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _invariant=__webpack_require__(25);var _invariant2=_interopRequireDefault(_invariant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Make sure the config passed e.g. to StackRouter, TabRouter has
 * the correct format, and throw a clear error if it doesn't.
 */function validateRouteConfigMap(routeConfigs){var routeNames=Object.keys(routeConfigs);(0,_invariant2.default)(routeNames.length>0,'Please specify at least one route when configuring a navigator.');routeNames.forEach(function(routeName){var routeConfig=routeConfigs[routeName];if(!routeConfig.screen&&!routeConfig.getScreen){throw new Error('Route \''+routeName+'\' should declare a screen. '+'For example:\n\n'+"import MyScreen from './MyScreen';\n"+'...\n'+(routeName+': {\n')+'  screen: MyScreen,\n'+'}');}else if(routeConfig.screen&&routeConfig.getScreen){throw new Error('Route \''+routeName+'\' should declare a screen or '+'a getScreen, not both.');}if(routeConfig.screen&&typeof routeConfig.screen!=='function'){throw new Error('The component for route \''+routeName+'\' must be a '+'React component. For example:\n\n'+"import MyScreen from './MyScreen';\n"+'...\n'+(routeName+': {\n')+'  screen: MyScreen,\n'+'}\n\n'+'You can also use a navigator:\n\n'+"import MyNavigator from './MyNavigator';\n"+'...\n'+(routeName+': {\n')+'  screen: MyNavigator,\n'+'}');}});}exports.default=validateRouteConfigMap;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _invariant=__webpack_require__(25);var _invariant2=_interopRequireDefault(_invariant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=function(){return(0,_invariant2.default)(false,'`getScreenConfig` has been replaced with `getScreenOptions`');};

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);var _reactNativeTabView=__webpack_require__(242);var _SceneView=__webpack_require__(128);var _SceneView2=_interopRequireDefault(_SceneView);var _withCachedChildNavigation=__webpack_require__(132);var _withCachedChildNavigation2=_interopRequireDefault(_withCachedChildNavigation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TabView=function(_PureComponent){_inherits(TabView,_PureComponent);function TabView(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TabView);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TabView.__proto__||Object.getPrototypeOf(TabView)).call.apply(_ref,[this].concat(args))),_this),_this._handlePageChanged=function(index){var navigation=_this.props.navigation;navigation.navigate(navigation.state.routes[index].routeName);},_this._renderScene=function(_ref2){var route=_ref2.route;var screenProps=_this.props.screenProps;var childNavigation=_this.props.childNavigationProps[route.key];var TabComponent=_this.props.router.getComponentForRouteName(route.routeName);return _react2.default.createElement(_reactNative.View,{style:styles.page},_react2.default.createElement(_SceneView2.default,{screenProps:screenProps,component:TabComponent,navigation:childNavigation}));},_this._getLabel=function(_ref3){var route=_ref3.route,tintColor=_ref3.tintColor,focused=_ref3.focused;var options=_this.props.router.getScreenOptions(_this.props.childNavigationProps[route.key],_this.props.screenProps||{});if(options.tabBarLabel){return typeof options.tabBarLabel==='function'?options.tabBarLabel({tintColor:tintColor,focused:focused}):options.tabBarLabel;}if(typeof options.title==='string'){return options.title;}return route.routeName;},_this._getOnPress=function(_ref4){var route=_ref4.route;var options=_this.props.router.getScreenOptions(_this.props.childNavigationProps[route.key],_this.props.screenProps||{});return options.tabBarOnPress;},_this._getTestIDProps=function(_ref5){var route=_ref5.route;var options=_this.props.router.getScreenOptions(_this.props.childNavigationProps[route.key],_this.props.screenProps||{});return options.tabBarTestIDProps;},_this._renderIcon=function(_ref6){var focused=_ref6.focused,route=_ref6.route,tintColor=_ref6.tintColor;var options=_this.props.router.getScreenOptions(_this.props.childNavigationProps[route.key],_this.props.screenProps||{});if(options.tabBarIcon){return typeof options.tabBarIcon==='function'?options.tabBarIcon({tintColor:tintColor,focused:focused}):options.tabBarIcon;}return null;},_this._renderTabBar=function(props){var _this$props=_this.props,tabBarOptions=_this$props.tabBarOptions,TabBarComponent=_this$props.tabBarComponent,animationEnabled=_this$props.animationEnabled;if(typeof TabBarComponent==='undefined'){return null;}return _react2.default.createElement(TabBarComponent,_extends({},props,tabBarOptions,{screenProps:_this.props.screenProps,navigation:_this.props.navigation,getLabel:_this._getLabel,getTestIDProps:_this._getTestIDProps,getOnPress:_this._getOnPress,renderIcon:_this._renderIcon,animationEnabled:animationEnabled}));},_this._renderPager=function(props){return _react2.default.createElement(_reactNativeTabView.TabViewPagerPan,props);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TabView,[{key:'render',value:function render(){var _props=this.props,router=_props.router,tabBarComponent=_props.tabBarComponent,tabBarPosition=_props.tabBarPosition,animationEnabled=_props.animationEnabled,swipeEnabled=_props.swipeEnabled,lazy=_props.lazy,screenProps=_props.screenProps;var renderHeader=void 0;var renderFooter=void 0;var renderPager=void 0;var state=this.props.navigation.state;var options=router.getScreenOptions(this.props.childNavigationProps[state.routes[state.index].key],screenProps||{});var tabBarVisible=options.tabBarVisible==null?true:options.tabBarVisible;if(tabBarComponent!==undefined&&tabBarVisible){if(tabBarPosition==='bottom'){renderFooter=this._renderTabBar;}else{renderHeader=this._renderTabBar;}}if(animationEnabled===false&&swipeEnabled===false){renderPager=this._renderPager;}var props={lazy:lazy,animationEnabled:animationEnabled,swipeEnabled:swipeEnabled,renderPager:renderPager,renderHeader:renderHeader,renderFooter:renderFooter,renderScene:this._renderScene,onIndexChange:this._handlePageChanged,navigationState:this.props.navigation.state,screenProps:this.props.screenProps,style:styles.container};return _react2.default.createElement(_reactNativeTabView.TabViewAnimated,props);}}]);return TabView;}(_react.PureComponent);exports.default=(0,_withCachedChildNavigation2.default)(TabView);var styles=_reactNative.StyleSheet.create({container:{flex:1},page:{flex:1,overflow:'hidden'}});

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable import/no-commonjs */module.exports={get TabViewAnimated(){return __webpack_require__(632).default;},get TabViewPagerPan(){return __webpack_require__(245).default;},get TabViewPagerScroll(){return __webpack_require__(244).default;},get TabViewPagerAndroid(){return __webpack_require__(243).default;},get TabBar(){return __webpack_require__(633).default;},get SceneMap(){return __webpack_require__(635).default;}};

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TabViewPagerAndroid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TabViewPropTypes__ = __webpack_require__(60);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TabViewPagerAndroid=(_temp=_class=function(_PureComponent){_inherits(TabViewPagerAndroid,_PureComponent);function TabViewPagerAndroid(props){_classCallCheck(this,TabViewPagerAndroid);var _this=_possibleConstructorReturn(this,(TabViewPagerAndroid.__proto__||Object.getPrototypeOf(TabViewPagerAndroid)).call(this,props));_this._isRequestingAnimationFrame=false;_this._isIdle=true;_this._currentIndex=0;_this._getPageIndex=function(index){return __WEBPACK_IMPORTED_MODULE_2_react_native__["I18nManager"].isRTL?_this.props.navigationState.routes.length-(index+1):index;};_this._setPage=function(index){if(_this._viewPager){_this._animationFrameCallback=null;var page=_this._getPageIndex(index);if(_this.props.animationEnabled!==false){_this._viewPager.setPage(page);}else{_this._viewPager.setPageWithoutAnimation(page);}}};_this._handlePageChange=function(index){if(_this._isIdle&&_this._currentIndex!==index){_this._setPage(index);_this._currentIndex=index;}};_this._handlePageScroll=function(e){_this.props.position.setValue(_this._getPageIndex(e.nativeEvent.position)+e.nativeEvent.offset*(__WEBPACK_IMPORTED_MODULE_2_react_native__["I18nManager"].isRTL?-1:1));};_this._handlePageScrollStateChanged=function(e){_this._isIdle=e==='idle';_this.props.jumpToIndex(_this._currentIndex);};_this._handlePageSelected=function(e){var index=_this._getPageIndex(e.nativeEvent.position);_this._currentIndex=index;};_this._setRef=function(el){return _this._viewPager=el;};_this._currentIndex=_this.props.navigationState.index;return _this;}_createClass(TabViewPagerAndroid,[{key:'componentDidMount',value:function componentDidMount(){this._resetListener=this.props.subscribe('reset',this._handlePageChange);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;if(this.props.layout!==nextProps.layout||__WEBPACK_IMPORTED_MODULE_0_react__["Children"].count(this.props.children)!==__WEBPACK_IMPORTED_MODULE_0_react__["Children"].count(nextProps.children)){this._animationFrameCallback=function(){if(_this2._viewPager){var navigationState=nextProps.navigationState;var page=__WEBPACK_IMPORTED_MODULE_2_react_native__["I18nManager"].isRTL?navigationState.routes.length-(navigationState.index+1):navigationState.index;_this2._viewPager.setPageWithoutAnimation(page);}};if(!this._isRequestingAnimationFrame){this._isRequestingAnimationFrame=true;global.requestAnimationFrame(function(){_this2._isRequestingAnimationFrame=false;if(_this2._animationFrameCallback){_this2._animationFrameCallback();}});}}}},{key:'componentDidUpdate',value:function componentDidUpdate(){this._handlePageChange(this.props.navigationState.index);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this._resetListener.remove();}},{key:'render',value:function render(){var _props=this.props,children=_props.children,navigationState=_props.navigationState,swipeEnabled=_props.swipeEnabled;var content=__WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children,function(child,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["View"],{key:navigationState.routes[i].key,testID:navigationState.routes[i].testID,style:styles.page},child);});if(__WEBPACK_IMPORTED_MODULE_2_react_native__["I18nManager"].isRTL){content.reverse();}var initialPage=this._getPageIndex(navigationState.index);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["ViewPagerAndroid"],{key:navigationState.routes.length,keyboardDismissMode:'on-drag',initialPage:initialPage,scrollEnabled:swipeEnabled!==false,onPageScroll:this._handlePageScroll,onPageScrollStateChanged:this._handlePageScrollStateChanged,onPageSelected:this._handlePageSelected,style:styles.container,ref:this._setRef},content);}}]);return TabViewPagerAndroid;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]),_class.propTypes=_extends({},__WEBPACK_IMPORTED_MODULE_3__TabViewPropTypes__["b" /* SceneRendererPropType */],{animationEnabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,swipeEnabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node}),_temp);var styles=__WEBPACK_IMPORTED_MODULE_2_react_native__["StyleSheet"].create({container:{flexGrow:1},page:{overflow:'hidden'}});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TabViewPagerScroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TabViewPropTypes__ = __webpack_require__(60);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TabViewPagerScroll=(_temp=_class=function(_PureComponent){_inherits(TabViewPagerScroll,_PureComponent);function TabViewPagerScroll(props){_classCallCheck(this,TabViewPagerScroll);var _this=_possibleConstructorReturn(this,(TabViewPagerScroll.__proto__||Object.getPrototypeOf(TabViewPagerScroll)).call(this,props));_this._nextOffset=0;_this._isIdle=true;_this._scrollTo=function(x){var animated=arguments.length>1&&arguments[1]!==undefined?arguments[1]:_this.props.animationEnabled!==false;_this._nextOffset=x;if(_this._isIdle&&_this._scrollView){_this._scrollView.scrollTo({x:x,animated:animated});}};_this._handleMomentumScrollEnd=function(e){var nextIndex=Math.round(e.nativeEvent.contentOffset.x/_this.props.layout.width);_this._isIdle=true;_this.props.jumpToIndex(nextIndex);};_this._handleScroll=function(e){_this._isIdle=Math.abs(e.nativeEvent.contentOffset.x-_this._nextOffset)<0.1;_this.props.position.setValue(e.nativeEvent.contentOffset.x/_this.props.layout.width);};_this._setRef=function(el){return _this._scrollView=el;};_this.state={initialOffset:{x:_this.props.navigationState.index*_this.props.layout.width,y:0}};return _this;}_createClass(TabViewPagerScroll,[{key:'componentDidMount',value:function componentDidMount(){this._scrollTo(this.props.navigationState.index*this.props.layout.width,false);this._resetListener=this.props.subscribe('reset',this._scrollTo);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this2=this;var amount=this.props.navigationState.index*this.props.layout.width;if(prevProps.navigationState!==this.props.navigationState||prevProps.layout!==this.props.layout){if(__WEBPACK_IMPORTED_MODULE_2_react_native__["Platform"].OS==='android'||prevProps.navigationState!==this.props.navigationState){global.requestAnimationFrame(function(){return _this2._scrollTo(amount);});}else{this._scrollTo(amount,false);}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this._resetListener.remove();}},{key:'render',value:function render(){var _props=this.props,children=_props.children,layout=_props.layout,navigationState=_props.navigationState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["ScrollView"],{horizontal:true,pagingEnabled:true,directionalLockEnabled:true,keyboardDismissMode:'on-drag',keyboardShouldPersistTaps:'always',scrollEnabled:this.props.swipeEnabled,automaticallyAdjustContentInsets:false,bounces:false,alwaysBounceHorizontal:false,scrollsToTop:false,showsHorizontalScrollIndicator:false,scrollEventThrottle:16,onScroll:this._handleScroll,onMomentumScrollEnd:this._handleMomentumScrollEnd,contentOffset:this.state.initialOffset,style:styles.container,contentContainerStyle:layout.width?null:styles.container,ref:this._setRef},__WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children,function(child,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["View"],{key:navigationState.routes[i].key,testID:navigationState.routes[i].testID,style:layout.width?{width:layout.width,overflow:'hidden'}:i===navigationState.index?styles.page:null},i===navigationState.index||layout.width?child:null);}));}}]);return TabViewPagerScroll;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]),_class.propTypes=_extends({},__WEBPACK_IMPORTED_MODULE_3__TabViewPropTypes__["b" /* SceneRendererPropType */],{animationEnabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,swipeEnabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node}),_temp);var styles=__WEBPACK_IMPORTED_MODULE_2_react_native__["StyleSheet"].create({container:{flexGrow:1},page:{flex:1,overflow:'hidden'}});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TabViewPagerPan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TabViewPropTypes__ = __webpack_require__(60);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DEAD_ZONE=12;var DefaultTransitionSpec={timing:__WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].spring,tension:300,friction:35};var TabViewPagerPan=(_temp2=_class=function(_PureComponent){_inherits(TabViewPagerPan,_PureComponent);function TabViewPagerPan(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TabViewPagerPan);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TabViewPagerPan.__proto__||Object.getPrototypeOf(TabViewPagerPan)).call.apply(_ref,[this].concat(args))),_this),_this._pendingIndex=null,_this._lastValue=null,_this._isMoving=null,_this._startDirection=0,_this._isIndexInRange=function(index){var routes=_this.props.navigationState.routes;return index>=0&&index<=routes.length-1;},_this._isMovingHorizontally=function(evt,gestureState){return Math.abs(gestureState.dx)>Math.abs(gestureState.dy*3)&&Math.abs(gestureState.vx)>Math.abs(gestureState.vy*3);},_this._isReverseDirection=function(gestureState){if(_this._startDirection>0){return gestureState.vx<0;}else{return gestureState.vx>0;}},_this._getNextIndex=function(evt,gestureState){var currentIndex=typeof _this._pendingIndex==='number'?_this._pendingIndex:_this.props.navigationState.index;var swipeVelocityThreshold=_this.props.swipeVelocityThreshold;if(__WEBPACK_IMPORTED_MODULE_2_react_native__["Platform"].OS==='android'){// on Android, velocity is way lower due to timestamp being in nanosecond
// normalize it to have the same velocity on both iOS and Android
swipeVelocityThreshold/=1000000;}if(Math.abs(gestureState.dx)>_this.props.swipeDistanceThreshold||Math.abs(gestureState.vx)>swipeVelocityThreshold){var nextIndex=currentIndex-gestureState.dx/Math.abs(gestureState.dx)*(__WEBPACK_IMPORTED_MODULE_2_react_native__["I18nManager"].isRTL?-1:1);if(_this._isIndexInRange(nextIndex)){return nextIndex;}}return currentIndex;},_this._canMoveScreen=function(evt,gestureState){if(_this.props.swipeEnabled===false){return false;}var _this$props$navigatio=_this.props.navigationState,routes=_this$props$navigatio.routes,index=_this$props$navigatio.index;var canMove=_this._isMovingHorizontally(evt,gestureState)&&(gestureState.dx>=DEAD_ZONE&&index>=0||gestureState.dx<=-DEAD_ZONE&&index<=routes.length-1);if(canMove){_this._startDirection=gestureState.dx;}return canMove;},_this._startGesture=function(evt,gestureState){if(typeof _this.props.onSwipeStart==='function'){_this.props.onSwipeStart(evt,gestureState);}_this._lastValue=_this.props.getLastPosition();_this.props.position.stopAnimation();},_this._respondToGesture=function(evt,gestureState){var width=_this.props.layout.width;var currentPosition=typeof _this._lastValue==='number'?_this._lastValue:_this.props.navigationState.index;var nextPosition=currentPosition-gestureState.dx/width*(__WEBPACK_IMPORTED_MODULE_2_react_native__["I18nManager"].isRTL?-1:1);if(_this._isMoving===null){_this._isMoving=_this._isMovingHorizontally(evt,gestureState);}if(_this._isMoving&&_this._isIndexInRange(nextPosition)){_this.props.position.setValue(nextPosition);}},_this._finishGesture=function(evt,gestureState){if(typeof _this.props.onSwipeEnd==='function'){_this.props.onSwipeEnd(evt,gestureState);}var currentIndex=_this.props.navigationState.index;var currentValue=_this.props.getLastPosition();if(currentValue!==currentIndex){if(_this._isMoving&&!_this._isReverseDirection(gestureState)){var nextIndex=_this._getNextIndex(evt,gestureState);_this._transitionTo(nextIndex);}else{_this._transitionTo(currentIndex);}}_this._lastValue=null;_this._isMoving=null;},_this._transitionTo=function(toValue){var lastPosition=_this.props.getLastPosition();var currentTransitionProps={progress:lastPosition};var nextTransitionProps={progress:toValue};_this._pendingIndex=toValue;if(_this.props.animationEnabled!==false){var transitionSpec=_this.props.configureTransition(currentTransitionProps,nextTransitionProps);var timing=transitionSpec.timing,transitionConfig=_objectWithoutProperties(transitionSpec,['timing']);timing(_this.props.position,_extends({},transitionConfig,{toValue:toValue})).start(function(_ref2){var finished=_ref2.finished;if(finished){_this.props.jumpToIndex(toValue);_this._pendingIndex=null;}});}else{_this.props.position.setValue(toValue);_this.props.jumpToIndex(toValue);_this._pendingIndex=null;}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TabViewPagerPan,[{key:'componentWillMount',value:function componentWillMount(){this._panResponder=__WEBPACK_IMPORTED_MODULE_2_react_native__["PanResponder"].create({onMoveShouldSetPanResponder:this._canMoveScreen,onMoveShouldSetPanResponderCapture:this._canMoveScreen,onPanResponderGrant:this._startGesture,onPanResponderMove:this._respondToGesture,onPanResponderTerminate:this._finishGesture,onPanResponderRelease:this._finishGesture,onPanResponderTerminationRequest:function onPanResponderTerminationRequest(){return true;}});}},{key:'componentDidMount',value:function componentDidMount(){this._resetListener=this.props.subscribe('reset',this._transitionTo);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.navigationState.index!==this.props.navigationState.index){this._transitionTo(this.props.navigationState.index);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this._resetListener.remove();}},{key:'render',value:function render(){var _props=this.props,layout=_props.layout,position=_props.position,navigationState=_props.navigationState,children=_props.children;var width=layout.width;var routes=navigationState.routes;// Prepend '-1', so there are always at least 2 items in inputRange
var inputRange=[-1].concat(_toConsumableArray(routes.map(function(x,i){return i;})));var outputRange=inputRange.map(function(i){return width*i*(__WEBPACK_IMPORTED_MODULE_2_react_native__["I18nManager"].isRTL?1:-1);});var translateX=position.interpolate({inputRange:inputRange,outputRange:outputRange});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].View,Object.assign({style:[styles.sheet,width?{width:routes.length*width,transform:[{translateX:translateX}]}:null]},this._panResponder.panHandlers),__WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children,function(child,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["View"],{key:navigationState.routes[i].key,testID:navigationState.routes[i].testID,style:width?{width:width}:i===navigationState.index?__WEBPACK_IMPORTED_MODULE_2_react_native__["StyleSheet"].absoluteFill:null},i===navigationState.index||width?child:null);}));}}]);return TabViewPagerPan;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]),_class.propTypes=_extends({},__WEBPACK_IMPORTED_MODULE_3__TabViewPropTypes__["b" /* SceneRendererPropType */],{configureTransition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,animationEnabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,swipeEnabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,swipeDistanceThreshold:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,swipeVelocityThreshold:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,onSwipeStart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onSwipeEnd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node}),_class.defaultProps={configureTransition:function configureTransition(){return DefaultTransitionSpec;},initialLayout:{height:0,width:0},swipeDistanceThreshold:120,swipeVelocityThreshold:0.25},_temp2);var styles=__WEBPACK_IMPORTED_MODULE_2_react_native__["StyleSheet"].create({sheet:{flex:1,flexDirection:'row',alignItems:'stretch'}});

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);var _reactNativeTabView=__webpack_require__(242);var _TabBarIcon=__webpack_require__(247);var _TabBarIcon2=_interopRequireDefault(_TabBarIcon);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TabBarTop=function(_PureComponent){_inherits(TabBarTop,_PureComponent);function TabBarTop(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TabBarTop);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TabBarTop.__proto__||Object.getPrototypeOf(TabBarTop)).call.apply(_ref,[this].concat(args))),_this),_this._renderLabel=function(scene){var _this$props=_this.props,position=_this$props.position,navigation=_this$props.navigation,activeTintColor=_this$props.activeTintColor,inactiveTintColor=_this$props.inactiveTintColor,showLabel=_this$props.showLabel,upperCaseLabel=_this$props.upperCaseLabel,labelStyle=_this$props.labelStyle,allowFontScaling=_this$props.allowFontScaling;if(showLabel===false){return null;}var index=scene.index;var routes=navigation.state.routes;// Prepend '-1', so there are always at least 2 items in inputRange
var inputRange=[-1].concat(_toConsumableArray(routes.map(function(x,i){return i;})));var outputRange=inputRange.map(function(inputIndex){return inputIndex===index?activeTintColor:inactiveTintColor;});var color=position.interpolate({inputRange:inputRange,outputRange:outputRange});var tintColor=scene.focused?activeTintColor:inactiveTintColor;var label=_this.props.getLabel(_extends({},scene,{tintColor:tintColor}));if(typeof label==='string'){return _react2.default.createElement(_reactNative.Animated.Text,{style:[styles.label,{color:color},labelStyle],allowFontScaling:allowFontScaling},upperCaseLabel?label.toUpperCase():label);}if(typeof label==='function'){return label(_extends({},scene,{tintColor:tintColor}));}return label;},_this._renderIcon=function(scene){var _this$props2=_this.props,position=_this$props2.position,navigation=_this$props2.navigation,activeTintColor=_this$props2.activeTintColor,inactiveTintColor=_this$props2.inactiveTintColor,renderIcon=_this$props2.renderIcon,showIcon=_this$props2.showIcon,iconStyle=_this$props2.iconStyle;if(showIcon===false){return null;}return _react2.default.createElement(_TabBarIcon2.default,{position:position,navigation:navigation,activeTintColor:activeTintColor,inactiveTintColor:inactiveTintColor,renderIcon:renderIcon,scene:scene,style:[styles.icon,iconStyle]});},_this._handleOnPress=function(scene){var _this$props3=_this.props,getOnPress=_this$props3.getOnPress,jumpToIndex=_this$props3.jumpToIndex;var onPress=getOnPress(scene);if(onPress){onPress(scene,jumpToIndex);}else{jumpToIndex(scene.index);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TabBarTop,[{key:'render',value:function render(){// TODO: Define full proptypes
var props=this.props;return _react2.default.createElement(_reactNativeTabView.TabBar,_extends({},props,{onTabPress:this._handleOnPress,jumpToIndex:function jumpToIndex(){},renderIcon:this._renderIcon,renderLabel:this._renderLabel}));}}]);return TabBarTop;}(_react.PureComponent);TabBarTop.defaultProps={activeTintColor:'#fff',inactiveTintColor:'#fff',showIcon:false,showLabel:true,upperCaseLabel:true,allowFontScaling:true};exports.default=TabBarTop;var styles=_reactNative.StyleSheet.create({icon:{height:24,width:24},label:{textAlign:'center',fontSize:13,margin:8,backgroundColor:'transparent'}});

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TabBarIcon=function(_PureComponent){_inherits(TabBarIcon,_PureComponent);function TabBarIcon(){_classCallCheck(this,TabBarIcon);return _possibleConstructorReturn(this,(TabBarIcon.__proto__||Object.getPrototypeOf(TabBarIcon)).apply(this,arguments));}_createClass(TabBarIcon,[{key:'render',value:function render(){var _props=this.props,position=_props.position,scene=_props.scene,navigation=_props.navigation,activeTintColor=_props.activeTintColor,inactiveTintColor=_props.inactiveTintColor,style=_props.style;var route=scene.route,index=scene.index;var routes=navigation.state.routes;// Prepend '-1', so there are always at least 2 items in inputRange
var inputRange=[-1].concat(_toConsumableArray(routes.map(function(x,i){return i;})));var activeOpacity=position.interpolate({inputRange:inputRange,outputRange:inputRange.map(function(i){return i===index?1:0;})});var inactiveOpacity=position.interpolate({inputRange:inputRange,outputRange:inputRange.map(function(i){return i===index?0:1;})});// We render the icon twice at the same position on top of each other:
// active and inactive one, so we can fade between them.
return _react2.default.createElement(_reactNative.View,{style:style},_react2.default.createElement(_reactNative.Animated.View,{style:[styles.icon,{opacity:activeOpacity}]},this.props.renderIcon({route:route,index:index,focused:true,tintColor:activeTintColor})),_react2.default.createElement(_reactNative.Animated.View,{style:[styles.icon,{opacity:inactiveOpacity}]},this.props.renderIcon({route:route,index:index,focused:false,tintColor:inactiveTintColor})));}}]);return TabBarIcon;}(_react.PureComponent);exports.default=TabBarIcon;var styles=_reactNative.StyleSheet.create({icon:{// We render the icon twice at the same position on top of each other:
// active and inactive one, so we can fade between them:
// Cover the whole iconContainer:
position:'absolute',top:0,left:0,right:0,bottom:0,alignItems:'center',justifyContent:'center'}});

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);var _TabBarIcon=__webpack_require__(247);var _TabBarIcon2=_interopRequireDefault(_TabBarIcon);var _withOrientation=__webpack_require__(232);var _withOrientation2=_interopRequireDefault(_withOrientation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var majorVersion=parseInt(_reactNative.Platform.Version,10);var isIos=_reactNative.Platform.OS==='ios';var useHorizontalTabs=majorVersion>=11&&isIos;var TabBarBottom=function(_PureComponent){_inherits(TabBarBottom,_PureComponent);function TabBarBottom(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TabBarBottom);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TabBarBottom.__proto__||Object.getPrototypeOf(TabBarBottom)).call.apply(_ref,[this].concat(args))),_this),_this._renderLabel=function(scene){var _this$props=_this.props,position=_this$props.position,navigation=_this$props.navigation,activeTintColor=_this$props.activeTintColor,inactiveTintColor=_this$props.inactiveTintColor,labelStyle=_this$props.labelStyle,showLabel=_this$props.showLabel,showIcon=_this$props.showIcon,isLandscape=_this$props.isLandscape,allowFontScaling=_this$props.allowFontScaling;if(showLabel===false){return null;}var index=scene.index;var routes=navigation.state.routes;// Prepend '-1', so there are always at least 2 items in inputRange
var inputRange=[-1].concat(_toConsumableArray(routes.map(function(x,i){return i;})));var outputRange=inputRange.map(function(inputIndex){return inputIndex===index?activeTintColor:inactiveTintColor;});var color=position.interpolate({inputRange:inputRange,outputRange:outputRange});var tintColor=scene.focused?activeTintColor:inactiveTintColor;var label=_this.props.getLabel(_extends({},scene,{tintColor:tintColor}));var marginLeft=0;if(isLandscape&&showIcon&&useHorizontalTabs){marginLeft=LABEL_LEFT_MARGIN;}var marginTop=0;if(!isLandscape&&showIcon&&useHorizontalTabs){marginTop=LABEL_TOP_MARGIN;}if(typeof label==='string'){return _react2.default.createElement(_reactNative.Animated.Text,{style:[styles.label,{color:color,marginLeft:marginLeft,marginTop:marginTop},labelStyle],allowFontScaling:allowFontScaling},label);}if(typeof label==='function'){return label(_extends({},scene,{tintColor:tintColor}));}return label;},_this._renderIcon=function(scene){var _this$props2=_this.props,position=_this$props2.position,navigation=_this$props2.navigation,activeTintColor=_this$props2.activeTintColor,inactiveTintColor=_this$props2.inactiveTintColor,renderIcon=_this$props2.renderIcon,showIcon=_this$props2.showIcon,showLabel=_this$props2.showLabel;if(showIcon===false){return null;}return _react2.default.createElement(_TabBarIcon2.default,{position:position,navigation:navigation,activeTintColor:activeTintColor,inactiveTintColor:inactiveTintColor,renderIcon:renderIcon,scene:scene,style:showLabel&&useHorizontalTabs?{}:styles.icon});},_this._renderTestIDProps=function(scene){var testIDProps=_this.props.getTestIDProps&&_this.props.getTestIDProps(scene);return testIDProps;},_temp),_possibleConstructorReturn(_this,_ret);}// See https://developer.apple.com/library/content/documentation/UserExperience/Conceptual/UIKitUICatalog/UITabBar.html
_createClass(TabBarBottom,[{key:'render',value:function render(){var _this2=this;var _props=this.props,position=_props.position,navigation=_props.navigation,jumpToIndex=_props.jumpToIndex,getOnPress=_props.getOnPress,getTestIDProps=_props.getTestIDProps,activeBackgroundColor=_props.activeBackgroundColor,inactiveBackgroundColor=_props.inactiveBackgroundColor,style=_props.style,tabStyle=_props.tabStyle,isLandscape=_props.isLandscape;var routes=navigation.state.routes;// Prepend '-1', so there are always at least 2 items in inputRange
var inputRange=[-1].concat(_toConsumableArray(routes.map(function(x,i){return i;})));return _react2.default.createElement(_reactNative.Animated.View,{style:[styles.tabBar,style]},routes.map(function(route,index){var focused=index===navigation.state.index;var scene={route:route,index:index,focused:focused};var _onPress=getOnPress(scene);var outputRange=inputRange.map(function(inputIndex){return inputIndex===index?activeBackgroundColor:inactiveBackgroundColor;});var backgroundColor=position.interpolate({inputRange:inputRange,outputRange:outputRange});var justifyContent=_this2.props.showIcon?'flex-end':'center';var extraProps=_this2._renderTestIDProps(scene)||{};var testID=extraProps.testID,accessibilityLabel=extraProps.accessibilityLabel;return _react2.default.createElement(_reactNative.TouchableWithoutFeedback,{key:route.key,testID:testID,accessibilityLabel:accessibilityLabel,onPress:function onPress(){return _onPress?_onPress(scene,jumpToIndex):jumpToIndex(index);}},_react2.default.createElement(_reactNative.Animated.View,{style:[styles.tab,isLandscape&&useHorizontalTabs&&styles.tabLandscape,!isLandscape&&useHorizontalTabs&&styles.tabPortrait,{backgroundColor:backgroundColor},tabStyle]},_this2._renderIcon(scene),_this2._renderLabel(scene)));}));}}]);return TabBarBottom;}(_react.PureComponent);TabBarBottom.defaultProps={activeTintColor:'#3478f6',// Default active tint color in iOS 10
activeBackgroundColor:'transparent',inactiveTintColor:'#929292',// Default inactive tint color in iOS 10
inactiveBackgroundColor:'transparent',showLabel:true,showIcon:true,allowFontScaling:true};var LABEL_LEFT_MARGIN=20;var LABEL_TOP_MARGIN=15;var styles=_reactNative.StyleSheet.create({tabBar:{height:49,// Default tab bar height in iOS 10+
flexDirection:'row',borderTopWidth:_reactNative.StyleSheet.hairlineWidth,borderTopColor:'rgba(0, 0, 0, .3)',backgroundColor:'#F7F7F7'// Default background color in iOS 10+
},tab:{flex:1,alignItems:isIos?'center':'stretch',justifyContent:'flex-end'},tabPortrait:{justifyContent:'flex-end',flexDirection:'column'},tabLandscape:{justifyContent:'center',flexDirection:'row'},icon:{flexGrow:1},label:{textAlign:'center',fontSize:10,marginBottom:1.5,backgroundColor:'transparent'}});exports.default=(0,_withOrientation2.default)(TabBarBottom);

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNativeDrawerLayoutPolyfill=__webpack_require__(638);var _reactNativeDrawerLayoutPolyfill2=_interopRequireDefault(_reactNativeDrawerLayoutPolyfill);var _addNavigationHelpers=__webpack_require__(48);var _addNavigationHelpers2=_interopRequireDefault(_addNavigationHelpers);var _DrawerSidebar=__webpack_require__(641);var _DrawerSidebar2=_interopRequireDefault(_DrawerSidebar);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Component that renders the drawer.
 */var DrawerView=function(_PureComponent){_inherits(DrawerView,_PureComponent);function DrawerView(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DrawerView);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DrawerView.__proto__||Object.getPrototypeOf(DrawerView)).call.apply(_ref,[this].concat(args))),_this),_this._handleDrawerOpen=function(){var navigation=_this.props.navigation;var _navigation$state=navigation.state,routes=_navigation$state.routes,index=_navigation$state.index;if(routes[index].routeName!=='DrawerOpen'){_this.props.navigation.navigate('DrawerOpen');}},_this._handleDrawerClose=function(){var navigation=_this.props.navigation;var _navigation$state2=navigation.state,routes=_navigation$state2.routes,index=_navigation$state2.index;if(routes[index].routeName!=='DrawerClose'){_this.props.navigation.navigate('DrawerClose');}},_this._updateScreenNavigation=function(navigation){var navigationState=navigation.state.routes.find(function(route){return route.routeName==='DrawerClose';});if(_this._screenNavigationProp&&_this._screenNavigationProp.state===navigationState){return;}_this._screenNavigationProp=(0,_addNavigationHelpers2.default)(_extends({},navigation,{state:navigationState}));},_this._getNavigationState=function(navigation){var navigationState=navigation.state.routes.find(function(route){return route.routeName==='DrawerClose';});return navigationState;},_this._renderNavigationView=function(){return _react2.default.createElement(_DrawerSidebar2.default,{screenProps:_this.props.screenProps,navigation:_this._screenNavigationProp,router:_this.props.router,contentComponent:_this.props.contentComponent,contentOptions:_this.props.contentOptions,style:_this.props.style});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DrawerView,[{key:'componentWillMount',value:function componentWillMount(){this._updateScreenNavigation(this.props.navigation);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.navigation.state.index!==nextProps.navigation.state.index){var _nextProps$navigation=nextProps.navigation.state,routes=_nextProps$navigation.routes,_index=_nextProps$navigation.index;if(routes[_index].routeName==='DrawerOpen'){this._drawer.openDrawer();}else if(routes[_index].routeName==='DrawerToggle'){if(this._drawer.state.drawerShown){this.props.navigation.navigate('DrawerClose');}else{this.props.navigation.navigate('DrawerOpen');}}else{this._drawer.closeDrawer();}}this._updateScreenNavigation(nextProps.navigation);}},{key:'render',value:function render(){var _this2=this;var DrawerScreen=this.props.router.getComponentForRouteName('DrawerClose');var screenNavigation=(0,_addNavigationHelpers2.default)({state:this._screenNavigationProp.state,dispatch:this._screenNavigationProp.dispatch});var config=this.props.router.getScreenOptions(screenNavigation,this.props.screenProps);return _react2.default.createElement(_reactNativeDrawerLayoutPolyfill2.default,{ref:function ref(c){_this2._drawer=c;},drawerLockMode:this.props.screenProps&&this.props.screenProps.drawerLockMode||config&&config.drawerLockMode,drawerBackgroundColor:this.props.drawerBackgroundColor,drawerWidth:this.props.drawerWidth,onDrawerOpen:this._handleDrawerOpen,onDrawerClose:this._handleDrawerClose,useNativeAnimations:this.props.useNativeAnimations,renderNavigationView:this._renderNavigationView,drawerPosition:this.props.drawerPosition==='right'?_reactNativeDrawerLayoutPolyfill2.default.positions.Right:_reactNativeDrawerLayoutPolyfill2.default.positions.Left},_react2.default.createElement(DrawerScreen,{screenProps:this.props.screenProps,navigation:this._screenNavigationProp}));}}]);return DrawerView;}(_react.PureComponent);exports.default=DrawerView;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);var _TouchableItem=__webpack_require__(231);var _TouchableItem2=_interopRequireDefault(_TouchableItem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Component that renders the navigation list in the drawer.
 */var DrawerNavigatorItems=function DrawerNavigatorItems(_ref){var _ref$navigation=_ref.navigation,state=_ref$navigation.state,navigate=_ref$navigation.navigate,items=_ref.items,activeItemKey=_ref.activeItemKey,activeTintColor=_ref.activeTintColor,activeBackgroundColor=_ref.activeBackgroundColor,inactiveTintColor=_ref.inactiveTintColor,inactiveBackgroundColor=_ref.inactiveBackgroundColor,getLabel=_ref.getLabel,renderIcon=_ref.renderIcon,onItemPress=_ref.onItemPress,style=_ref.style,labelStyle=_ref.labelStyle;return _react2.default.createElement(_reactNative.View,{style:[styles.container,style]},items.map(function(route,index){var focused=activeItemKey===route.key;var color=focused?activeTintColor:inactiveTintColor;var backgroundColor=focused?activeBackgroundColor:inactiveBackgroundColor;var scene={route:route,index:index,focused:focused,tintColor:color};var icon=renderIcon(scene);var label=getLabel(scene);return _react2.default.createElement(_TouchableItem2.default,{key:route.key,onPress:function onPress(){onItemPress({route:route,focused:focused});},delayPressIn:0},_react2.default.createElement(_reactNative.View,{style:[styles.item,{backgroundColor:backgroundColor}]},icon?_react2.default.createElement(_reactNative.View,{style:[styles.icon,focused?null:styles.inactiveIcon]},icon):null,typeof label==='string'?_react2.default.createElement(_reactNative.Text,{style:[styles.label,{color:color},labelStyle]},label):label));}));};/* Material design specs - https://material.io/guidelines/patterns/navigation-drawer.html#navigation-drawer-specs */DrawerNavigatorItems.defaultProps={activeTintColor:'#2196f3',activeBackgroundColor:'rgba(0, 0, 0, .04)',inactiveTintColor:'rgba(0, 0, 0, .87)',inactiveBackgroundColor:'transparent'};var styles=_reactNative.StyleSheet.create({container:{marginTop:_reactNative.Platform.OS==='ios'?20:0,paddingVertical:4},item:{flexDirection:'row',alignItems:'center'},icon:{marginHorizontal:16,width:24,alignItems:'center'},inactiveIcon:{/*
     * Icons have 0.54 opacity according to guidelines
     * 100/87 * 54 ~= 62
     */opacity:0.62},label:{margin:16,fontWeight:'bold'}});exports.default=DrawerNavigatorItems;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-kitchen-sink.bab8cef9.png";

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datas=[{route:"Header1",text:"Only Title"},{route:"Header2",text:"Icon Buttons"},{route:"Header3",text:"Text Buttons"},{route:"Header4",text:"Icon Button and Text Button"},{route:"Header5",text:"Icon and Text Buttons"},{route:"Header6",text:"Multiple Icon Buttons"},{route:"Header7",text:"Title and Subtitle"},{route:"Header8",text:"Custom Background Color"}];var HeaderNB=function(_Component){_inherits(HeaderNB,_Component);function HeaderNB(){_classCallCheck(this,HeaderNB);return _possibleConstructorReturn(this,(HeaderNB.__proto__||Object.getPrototypeOf(HeaderNB)).apply(this,arguments));}_createClass(HeaderNB,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Headers")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.props.navigation.navigate(data.route);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,data.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward"})));}})));}}]);return HeaderNB;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HeaderNB);

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/splashscreen.d8225b92.png";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.9b000b33.png";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/swiper-3.badbd51a.png";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/swiper-4.4a902ca3.png";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(258);
module.exports = __webpack_require__(263);


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(259).enable();
  window.Promise = __webpack_require__(261);
}

// fetch() polyfill for making API calls.
__webpack_require__(262);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(51);


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(143);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(143);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 262 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_native_web__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_native_web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_native_web__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native_web_dist_apis_Platform__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native_web_dist_apis_Platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native_web_dist_apis_Platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native_web_dist_apis_Dimensions__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native_web_dist_apis_Dimensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_native_web_dist_apis_Dimensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_navigation_lib_PlatformHelpers__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_navigation_lib_PlatformHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_navigation_lib_PlatformHelpers__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}__WEBPACK_IMPORTED_MODULE_0_react_native_web___default.a.DeviceInfo={};var dimensions={window:{width:325,height:576}};var listeners={};Object.assign(__WEBPACK_IMPORTED_MODULE_2_react_native_web_dist_apis_Dimensions___default.a,{get:function get(dimension){return dimensions[dimension];},set:function set(newDimensions){Object.assign(dimensions,newDimensions);},emit:function emit(type){for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}if(Array.isArray(listeners[type])){listeners[type].forEach(function(handler){return handler.apply(undefined,_toConsumableArray(args));});}},addEventListener:function addEventListener(type,handler){listeners[type]=listeners[type]||[];listeners[type].push(handler);},removeEventListener:function removeEventListener(type,handler){if(Array.isArray(listeners[type])){listeners[type]=listeners[type].filter(function(_handler){return _handler!==handler;});}},// TODO: update dimensions when orientation or size changed
_update:function _update(){}});__WEBPACK_IMPORTED_MODULE_3_react_navigation_lib_PlatformHelpers__["Linking"].getInitialURL=function(){return new Promise(function(resolve){resolve('');});};__WEBPACK_IMPORTED_MODULE_1_react_native_web_dist_apis_Platform___default.a.OS='ios';var oldError=console.error.bind(console);console.error=function(arg){if(typeof arg==='string'&&(arg.startsWith('Warning: React does not recognize the')||arg.startsWith('Warning: Unknown event handler property')||arg.startsWith('Warning: Received `true` for non-boolean attribute `accessible`')||arg.startsWith('Warning: Stateless function components cannot')||arg.startsWith('Warning: Failed prop type: Invalid props.style key `pointerEvents` supplied to `View`.')||arg.match(/Warning: Received `.*` for non-.* attribute `.*`\. If this is expected, cast the value to a .*\./))){return;}for(var _len2=arguments.length,args=Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){args[_key2-1]=arguments[_key2];}oldError.apply(undefined,[arg].concat(args));};__webpack_require__(387);

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.ViewPropTypes=exports.TextPropTypes=exports.PointPropType=exports.EdgeInsetsPropType=exports.ColorPropType=exports.VirtualizedList=exports.View=exports.TouchableWithoutFeedback=exports.TouchableOpacity=exports.TouchableNativeFeedback=exports.TouchableHighlight=exports.Touchable=exports.TextInput=exports.Text=exports.Switch=exports.StatusBar=exports.Slider=exports.SectionList=exports.ScrollView=exports.RefreshControl=exports.ProgressBar=exports.Picker=exports.Modal=exports.ListView=exports.KeyboardAvoidingView=exports.Image=exports.FlatList=exports.Button=exports.ActivityIndicator=exports.Vibration=exports.UIManager=exports.StyleSheet=exports.Platform=exports.PixelRatio=exports.PanResponder=exports.NetInfo=exports.Linking=exports.Keyboard=exports.InteractionManager=exports.I18nManager=exports.Easing=exports.Dimensions=exports.Clipboard=exports.BackHandler=exports.AsyncStorage=exports.AppState=exports.AppRegistry=exports.Animated=exports.processColor=exports.NativeModules=exports.createElement=exports.unmountComponentAtNode=exports.render=exports.hydrate=exports.findNodeHandle=undefined;var _createElement=__webpack_require__(41);var _createElement2=_interopRequireDefault(_createElement);var _findNodeHandle=__webpack_require__(42);var _findNodeHandle2=_interopRequireDefault(_findNodeHandle);var _NativeModules=__webpack_require__(306);var _NativeModules2=_interopRequireDefault(_NativeModules);var _processColor=__webpack_require__(151);var _processColor2=_interopRequireDefault(_processColor);var _reactDom=__webpack_require__(33);var _Animated=__webpack_require__(307);var _Animated2=_interopRequireDefault(_Animated);var _AppRegistry=__webpack_require__(344);var _AppRegistry2=_interopRequireDefault(_AppRegistry);var _AppState=__webpack_require__(347);var _AppState2=_interopRequireDefault(_AppState);var _AsyncStorage=__webpack_require__(348);var _AsyncStorage2=_interopRequireDefault(_AsyncStorage);var _BackHandler=__webpack_require__(351);var _BackHandler2=_interopRequireDefault(_BackHandler);var _Clipboard=__webpack_require__(352);var _Clipboard2=_interopRequireDefault(_Clipboard);var _Dimensions=__webpack_require__(67);var _Dimensions2=_interopRequireDefault(_Dimensions);var _Easing=__webpack_require__(353);var _Easing2=_interopRequireDefault(_Easing);var _I18nManager=__webpack_require__(90);var _I18nManager2=_interopRequireDefault(_I18nManager);var _Keyboard=__webpack_require__(354);var _Keyboard2=_interopRequireDefault(_Keyboard);var _InteractionManager=__webpack_require__(355);var _InteractionManager2=_interopRequireDefault(_InteractionManager);var _Linking=__webpack_require__(356);var _Linking2=_interopRequireDefault(_Linking);var _NetInfo=__webpack_require__(357);var _NetInfo2=_interopRequireDefault(_NetInfo);var _PanResponder=__webpack_require__(358);var _PanResponder2=_interopRequireDefault(_PanResponder);var _PixelRatio=__webpack_require__(360);var _PixelRatio2=_interopRequireDefault(_PixelRatio);var _Platform=__webpack_require__(99);var _Platform2=_interopRequireDefault(_Platform);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _UIManager=__webpack_require__(43);var _UIManager2=_interopRequireDefault(_UIManager);var _Vibration=__webpack_require__(361);var _Vibration2=_interopRequireDefault(_Vibration);var _ActivityIndicator=__webpack_require__(362);var _ActivityIndicator2=_interopRequireDefault(_ActivityIndicator);var _Button=__webpack_require__(363);var _Button2=_interopRequireDefault(_Button);var _FlatList=__webpack_require__(367);var _FlatList2=_interopRequireDefault(_FlatList);var _Image=__webpack_require__(162);var _Image2=_interopRequireDefault(_Image);var _KeyboardAvoidingView=__webpack_require__(368);var _KeyboardAvoidingView2=_interopRequireDefault(_KeyboardAvoidingView);var _ListView=__webpack_require__(369);var _ListView2=_interopRequireDefault(_ListView);var _Modal=__webpack_require__(372);var _Modal2=_interopRequireDefault(_Modal);var _Picker=__webpack_require__(373);var _Picker2=_interopRequireDefault(_Picker);var _ProgressBar=__webpack_require__(374);var _ProgressBar2=_interopRequireDefault(_ProgressBar);var _RefreshControl=__webpack_require__(375);var _RefreshControl2=_interopRequireDefault(_RefreshControl);var _ScrollView=__webpack_require__(66);var _ScrollView2=_interopRequireDefault(_ScrollView);var _SectionList=__webpack_require__(376);var _SectionList2=_interopRequireDefault(_SectionList);var _Slider=__webpack_require__(377);var _Slider2=_interopRequireDefault(_Slider);var _StatusBar=__webpack_require__(378);var _StatusBar2=_interopRequireDefault(_StatusBar);var _Switch=__webpack_require__(379);var _Switch2=_interopRequireDefault(_Switch);var _Text=__webpack_require__(100);var _Text2=_interopRequireDefault(_Text);var _TextInput=__webpack_require__(380);var _TextInput2=_interopRequireDefault(_TextInput);var _Touchable=__webpack_require__(69);var _Touchable2=_interopRequireDefault(_Touchable);var _TouchableHighlight=__webpack_require__(382);var _TouchableHighlight2=_interopRequireDefault(_TouchableHighlight);var _TouchableNativeFeedback=__webpack_require__(384);var _TouchableNativeFeedback2=_interopRequireDefault(_TouchableNativeFeedback);var _TouchableOpacity=__webpack_require__(173);var _TouchableOpacity2=_interopRequireDefault(_TouchableOpacity);var _TouchableWithoutFeedback=__webpack_require__(102);var _TouchableWithoutFeedback2=_interopRequireDefault(_TouchableWithoutFeedback);var _View=__webpack_require__(11);var _View2=_interopRequireDefault(_View);var _VirtualizedList=__webpack_require__(385);var _VirtualizedList2=_interopRequireDefault(_VirtualizedList);var _ColorPropType=__webpack_require__(14);var _ColorPropType2=_interopRequireDefault(_ColorPropType);var _EdgeInsetsPropType=__webpack_require__(96);var _EdgeInsetsPropType2=_interopRequireDefault(_EdgeInsetsPropType);var _PointPropType=__webpack_require__(386);var _PointPropType2=_interopRequireDefault(_PointPropType);var _TextPropTypes=__webpack_require__(170);var _TextPropTypes2=_interopRequireDefault(_TextPropTypes);var _ViewPropTypes=__webpack_require__(15);var _ViewPropTypes2=_interopRequireDefault(_ViewPropTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.findNodeHandle=_findNodeHandle2.default;exports.hydrate=_reactDom.hydrate;exports.render=_reactDom.render;exports.unmountComponentAtNode=_reactDom.unmountComponentAtNode;exports.createElement=_createElement2.default;exports.NativeModules=_NativeModules2.default;exports.processColor=_processColor2.default;exports.Animated=_Animated2.default;exports.AppRegistry=_AppRegistry2.default;exports.AppState=_AppState2.default;exports.AsyncStorage=_AsyncStorage2.default;exports.BackHandler=_BackHandler2.default;exports.Clipboard=_Clipboard2.default;exports.Dimensions=_Dimensions2.default;exports.Easing=_Easing2.default;exports.I18nManager=_I18nManager2.default;exports.InteractionManager=_InteractionManager2.default;exports.Keyboard=_Keyboard2.default;exports.Linking=_Linking2.default;exports.NetInfo=_NetInfo2.default;exports.PanResponder=_PanResponder2.default;exports.PixelRatio=_PixelRatio2.default;exports.Platform=_Platform2.default;exports.StyleSheet=_StyleSheet2.default;exports.UIManager=_UIManager2.default;exports.Vibration=_Vibration2.default;exports.ActivityIndicator=_ActivityIndicator2.default;exports.Button=_Button2.default;exports.FlatList=_FlatList2.default;exports.Image=_Image2.default;exports.KeyboardAvoidingView=_KeyboardAvoidingView2.default;exports.ListView=_ListView2.default;exports.Modal=_Modal2.default;exports.Picker=_Picker2.default;exports.ProgressBar=_ProgressBar2.default;exports.RefreshControl=_RefreshControl2.default;exports.ScrollView=_ScrollView2.default;exports.SectionList=_SectionList2.default;exports.Slider=_Slider2.default;exports.StatusBar=_StatusBar2.default;exports.Switch=_Switch2.default;exports.Text=_Text2.default;exports.TextInput=_TextInput2.default;exports.Touchable=_Touchable2.default;exports.TouchableHighlight=_TouchableHighlight2.default;exports.TouchableNativeFeedback=_TouchableNativeFeedback2.default;exports.TouchableOpacity=_TouchableOpacity2.default;exports.TouchableWithoutFeedback=_TouchableWithoutFeedback2.default;exports.View=_View2.default;exports.VirtualizedList=_VirtualizedList2.default;exports.ColorPropType=_ColorPropType2.default;exports.EdgeInsetsPropType=_EdgeInsetsPropType2.default;exports.PointPropType=_PointPropType2.default;exports.TextPropTypes=_TextPropTypes2.default;exports.ViewPropTypes=_ViewPropTypes2.default;var ReactNative={findNodeHandle:_findNodeHandle2.default,hydrate:_reactDom.hydrate,render:_reactDom.render,unmountComponentAtNode:_reactDom.unmountComponentAtNode,createElement:_createElement2.default,NativeModules:_NativeModules2.default,processColor:_processColor2.default,Animated:_Animated2.default,AppRegistry:_AppRegistry2.default,AppState:_AppState2.default,AsyncStorage:_AsyncStorage2.default,BackHandler:_BackHandler2.default,Clipboard:_Clipboard2.default,Dimensions:_Dimensions2.default,Easing:_Easing2.default,I18nManager:_I18nManager2.default,InteractionManager:_InteractionManager2.default,Keyboard:_Keyboard2.default,Linking:_Linking2.default,NetInfo:_NetInfo2.default,PanResponder:_PanResponder2.default,PixelRatio:_PixelRatio2.default,Platform:_Platform2.default,StyleSheet:_StyleSheet2.default,UIManager:_UIManager2.default,Vibration:_Vibration2.default,ActivityIndicator:_ActivityIndicator2.default,Button:_Button2.default,FlatList:_FlatList2.default,Image:_Image2.default,KeyboardAvoidingView:_KeyboardAvoidingView2.default,ListView:_ListView2.default,Modal:_Modal2.default,Picker:_Picker2.default,ProgressBar:_ProgressBar2.default,RefreshControl:_RefreshControl2.default,ScrollView:_ScrollView2.default,SectionList:_SectionList2.default,Slider:_Slider2.default,StatusBar:_StatusBar2.default,Switch:_Switch2.default,Text:_Text2.default,TextInput:_TextInput2.default,Touchable:_Touchable2.default,TouchableHighlight:_TouchableHighlight2.default,TouchableNativeFeedback:_TouchableNativeFeedback2.default,TouchableOpacity:_TouchableOpacity2.default,TouchableWithoutFeedback:_TouchableWithoutFeedback2.default,View:_View2.default,VirtualizedList:_VirtualizedList2.default,ColorPropType:_ColorPropType2.default,EdgeInsetsPropType:_EdgeInsetsPropType2.default,PointPropType:_PointPropType2.default,TextPropTypes:_TextPropTypes2.default,ViewPropTypes:_ViewPropTypes2.default};exports.default=ReactNative;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var _normalizeNativeEvent=__webpack_require__(144);var _normalizeNativeEvent2=_interopRequireDefault(_normalizeNativeEvent);var _reactDom=__webpack_require__(33);var _reactDom2=_interopRequireDefault(_reactDom);var _unstableNativeDependencies=__webpack_require__(275);var _unstableNativeDependencies2=_interopRequireDefault(_unstableNativeDependencies);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var EventPluginHub=_reactDom2.default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.EventPluginHub;var ResponderEventPlugin=_unstableNativeDependencies2.default.ResponderEventPlugin,ResponderTouchHistoryStore=_unstableNativeDependencies2.default.ResponderTouchHistoryStore;var topMouseDown='topMouseDown';var topMouseMove='topMouseMove';var topMouseUp='topMouseUp';var topScroll='topScroll';var topSelectionChange='topSelectionChange';var topTouchCancel='topTouchCancel';var topTouchEnd='topTouchEnd';var topTouchMove='topTouchMove';var topTouchStart='topTouchStart';var endDependencies=[topTouchCancel,topTouchEnd,topMouseUp];var moveDependencies=[topTouchMove,topMouseMove];var startDependencies=[topTouchStart,topMouseDown];ResponderEventPlugin.eventTypes.responderMove.dependencies=moveDependencies;ResponderEventPlugin.eventTypes.responderEnd.dependencies=endDependencies;ResponderEventPlugin.eventTypes.responderStart.dependencies=startDependencies;ResponderEventPlugin.eventTypes.responderRelease.dependencies=endDependencies;ResponderEventPlugin.eventTypes.responderTerminationRequest.dependencies=[];ResponderEventPlugin.eventTypes.responderGrant.dependencies=[];ResponderEventPlugin.eventTypes.responderReject.dependencies=[];ResponderEventPlugin.eventTypes.responderTerminate.dependencies=[];ResponderEventPlugin.eventTypes.moveShouldSetResponder.dependencies=moveDependencies;ResponderEventPlugin.eventTypes.selectionChangeShouldSetResponder.dependencies=[topSelectionChange];ResponderEventPlugin.eventTypes.scrollShouldSetResponder.dependencies=[topScroll];ResponderEventPlugin.eventTypes.startShouldSetResponder.dependencies=startDependencies;var originalRecordTouchTrack=ResponderTouchHistoryStore.recordTouchTrack;ResponderTouchHistoryStore.recordTouchTrack=function(topLevelType,nativeEvent){if(topLevelType===topMouseMove&&!ResponderTouchHistoryStore.touchHistory.touchBank.length){return;}var normalizedEvent=(0,_normalizeNativeEvent2.default)(nativeEvent);originalRecordTouchTrack.call(ResponderTouchHistoryStore,topLevelType,normalizedEvent);};EventPluginHub.injection.injectEventPluginsByName({ResponderEventPlugin:ResponderEventPlugin});

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 React v16.0.0
 react-dom.production.min.js

 Copyright (c) 2013-present, Facebook, Inc.

 This source code is licensed under the MIT license found in the
 LICENSE file in the root directory of this source tree.
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0);__webpack_require__(8);var l=__webpack_require__(16),n=__webpack_require__(51),ba=__webpack_require__(268),ca=__webpack_require__(27),da=__webpack_require__(86),ea=__webpack_require__(269),fa=__webpack_require__(270),ha=__webpack_require__(273),ia=__webpack_require__(274);
function w(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:w("227");
function ja(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var ka={Namespaces:{html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"},getIntrinsicNamespace:ja,getChildNamespace:function(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ja(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}},la=null,oa={};
function pa(){if(la)for(var a in oa){var b=oa[a],c=la.indexOf(a);-1<c?void 0:w("96",a);if(!qa.plugins[c]){b.extractEvents?void 0:w("97",a);qa.plugins[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;qa.eventNameDispatchConfigs.hasOwnProperty(h)?w("99",h):void 0;qa.eventNameDispatchConfigs[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ra(k[e],g,h);e=!0}else f.registrationName?(ra(f.registrationName,g,h),e=!0):e=!1;e?void 0:w("98",d,a)}}}}
function ra(a,b,c){qa.registrationNameModules[a]?w("100",a):void 0;qa.registrationNameModules[a]=b;qa.registrationNameDependencies[a]=b.eventTypes[c].dependencies}
var qa={plugins:[],eventNameDispatchConfigs:{},registrationNameModules:{},registrationNameDependencies:{},possibleRegistrationNames:null,injectEventPluginOrder:function(a){la?w("101"):void 0;la=Array.prototype.slice.call(a);pa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];oa.hasOwnProperty(c)&&oa[c]===d||(oa[c]?w("102",c):void 0,oa[c]=d,b=!0)}b&&pa()}},sa=qa,ta={children:!0,dangerouslySetInnerHTML:!0,autoFocus:!0,defaultValue:!0,defaultChecked:!0,
innerHTML:!0,suppressContentEditableWarning:!0,style:!0};function ua(a,b){return(a&b)===b}
var wa={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=wa,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){xa.properties.hasOwnProperty(f)?w("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:ua(h,b.MUST_USE_PROPERTY),
hasBooleanValue:ua(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:ua(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:ua(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:ua(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:ua(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:w("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);xa.properties[f]=
g}}},xa={ID_ATTRIBUTE_NAME:"data-reactid",ROOT_ATTRIBUTE_NAME:"data-reactroot",ATTRIBUTE_NAME_START_CHAR:":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",ATTRIBUTE_NAME_CHAR:":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",
properties:{},shouldSetAttribute:function(a,b){if(xa.isReservedProp(a)||!("o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return xa.shouldAttributeAcceptBooleanValue(a);case "undefined":case "number":case "string":case "object":return!0;default:return!1}},getPropertyInfo:function(a){return xa.properties.hasOwnProperty(a)?xa.properties[a]:null},shouldAttributeAcceptBooleanValue:function(a){if(xa.isReservedProp(a))return!0;var b=xa.getPropertyInfo(a);
if(b)return b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue;a=a.toLowerCase().slice(0,5);return"data-"===a||"aria-"===a},isReservedProp:function(a){return ta.hasOwnProperty(a)},injection:wa},A=xa,E={IndeterminateComponent:0,FunctionalComponent:1,ClassComponent:2,HostRoot:3,HostPortal:4,HostComponent:5,HostText:6,CoroutineComponent:7,CoroutineHandlerPhase:8,YieldComponent:9,Fragment:10},F={ELEMENT_NODE:1,TEXT_NODE:3,COMMENT_NODE:8,DOCUMENT_NODE:9,DOCUMENT_FRAGMENT_NODE:11},
ya=E.HostComponent,za=E.HostText,Aa=F.ELEMENT_NODE,Ba=F.COMMENT_NODE,Ea=A.ID_ATTRIBUTE_NAME,Fa={hasCachedChildNodes:1},Ga=Math.random().toString(36).slice(2),Ha="__reactInternalInstance$"+Ga,Ia="__reactEventHandlers$"+Ga;function La(a){for(var b;b=a._renderedComponent;)a=b;return a}function Ma(a,b){a=La(a);a._hostNode=b;b[Ha]=a}
function Na(a,b){if(!(a._flags&Fa.hasCachedChildNodes)){var c=a._renderedChildren;b=b.firstChild;var d;a:for(d in c)if(c.hasOwnProperty(d)){var e=c[d],f=La(e)._domID;if(0!==f){for(;null!==b;b=b.nextSibling){var g=b,h=f;if(g.nodeType===Aa&&g.getAttribute(Ea)===""+h||g.nodeType===Ba&&g.nodeValue===" react-text: "+h+" "||g.nodeType===Ba&&g.nodeValue===" react-empty: "+h+" "){Ma(e,b);continue a}}w("32",f)}}a._flags|=Fa.hasCachedChildNodes}}
function Oa(a){if(a[Ha])return a[Ha];for(var b=[];!a[Ha];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=a[Ha];if(c.tag===ya||c.tag===za)return c;for(;a&&(c=a[Ha]);a=b.pop()){var d=c;b.length&&Na(c,a)}return d}
var G={getClosestInstanceFromNode:Oa,getInstanceFromNode:function(a){var b=a[Ha];if(b)return b.tag===ya||b.tag===za?b:b._hostNode===a?b:null;b=Oa(a);return null!=b&&b._hostNode===a?b:null},getNodeFromInstance:function(a){if(a.tag===ya||a.tag===za)return a.stateNode;void 0===a._hostNode?w("33"):void 0;if(a._hostNode)return a._hostNode;for(var b=[];!a._hostNode;)b.push(a),a._hostParent?void 0:w("34"),a=a._hostParent;for(;b.length;a=b.pop())Na(a,a._hostNode);return a._hostNode},precacheChildNodes:Na,
precacheNode:Ma,uncacheNode:function(a){var b=a._hostNode;b&&(delete b[Ha],a._hostNode=null)},precacheFiberNode:function(a,b){b[Ha]=a},getFiberCurrentPropsFromNode:function(a){return a[Ia]||null},updateFiberProps:function(a,b){a[Ia]=b}},Pa={remove:function(a){a._reactInternalFiber=void 0},get:function(a){return a._reactInternalFiber},has:function(a){return void 0!==a._reactInternalFiber},set:function(a,b){a._reactInternalFiber=b}},Qa={ReactCurrentOwner:aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner};
function Ra(a){if("function"===typeof a.getName)return a.getName();if("number"===typeof a.tag){a=a.type;if("string"===typeof a)return a;if("function"===typeof a)return a.displayName||a.name}return null}var J={NoEffect:0,PerformedWork:1,Placement:2,Update:4,PlacementAndUpdate:6,Deletion:8,ContentReset:16,Callback:32,Err:64,Ref:128},Sa=E.HostComponent,Ta=E.HostRoot,Ua=E.HostPortal,Va=E.HostText,Wa=J.NoEffect,Xa=J.Placement;
function Za(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if((b.effectTag&Xa)!==Wa)return 1;for(;b["return"];)if(b=b["return"],(b.effectTag&Xa)!==Wa)return 1}return b.tag===Ta?2:3}function $a(a){2!==Za(a)?w("188"):void 0}
function ab(a){var b=a.alternate;if(!b)return b=Za(a),3===b?w("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return $a(e),a;if(g===d)return $a(e),b;g=g.sibling}w("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:w("189")}}c.alternate!==d?w("190"):void 0}c.tag!==Ta?w("188"):void 0;return c.stateNode.current===c?a:b}
var bb={isFiberMounted:function(a){return 2===Za(a)},isMounted:function(a){return(a=Pa.get(a))?2===Za(a):!1},findCurrentFiberUsingSlowPath:ab,findCurrentHostFiber:function(a){a=ab(a);if(!a)return null;for(var b=a;;){if(b.tag===Sa||b.tag===Va)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null},findCurrentHostFiberWithNoPortals:function(a){a=ab(a);
if(!a)return null;for(var b=a;;){if(b.tag===Sa||b.tag===Va)return b;if(b.child&&b.tag!==Ua)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}},K={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?w("197"):void 0;cb=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,
b,c,d,e,f,g,h,k){cb.apply(K,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){K.invokeGuardedCallback.apply(this,arguments);if(K.hasCaughtError()){var p=K.clearCaughtError();K._hasRethrowError||(K._hasRethrowError=!0,K._rethrowError=p)}},rethrowCaughtError:function(){return db.apply(K,arguments)},hasCaughtError:function(){return K._hasCaughtError},clearCaughtError:function(){if(K._hasCaughtError){var a=K._caughtError;K._caughtError=null;K._hasCaughtError=!1;return a}w("198")}};
function cb(a,b,c,d,e,f,g,h,k){K._hasCaughtError=!1;K._caughtError=null;var p=Array.prototype.slice.call(arguments,3);try{b.apply(c,p)}catch(x){K._caughtError=x,K._hasCaughtError=!0}}function db(){if(K._hasRethrowError){var a=K._rethrowError;K._rethrowError=null;K._hasRethrowError=!1;throw a;}}var eb=K,fb;function gb(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=hb.getNodeFromInstance(d);eb.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
var hb={isEndish:function(a){return"topMouseUp"===a||"topTouchEnd"===a||"topTouchCancel"===a},isMoveish:function(a){return"topMouseMove"===a||"topTouchMove"===a},isStartish:function(a){return"topMouseDown"===a||"topTouchStart"===a},executeDirectDispatch:function(a){var b=a._dispatchListeners,c=a._dispatchInstances;Array.isArray(b)?w("103"):void 0;a.currentTarget=b?hb.getNodeFromInstance(c):null;b=b?b(a):null;a.currentTarget=null;a._dispatchListeners=null;a._dispatchInstances=null;return b},executeDispatchesInOrder:function(a,
b){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)gb(a,b,c[e],d[e]);else c&&gb(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null},executeDispatchesInOrderStopAtTrue:function(a){a:{var b=a._dispatchListeners;var c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++){if(b[d](a,c[d])){b=c[d];break a}}else if(b&&b(a,c)){b=c;break a}b=null}a._dispatchInstances=null;a._dispatchListeners=
null;return b},hasDispatches:function(a){return!!a._dispatchListeners},getFiberCurrentPropsFromNode:function(a){return fb.getFiberCurrentPropsFromNode(a)},getInstanceFromNode:function(a){return fb.getInstanceFromNode(a)},getNodeFromInstance:function(a){return fb.getNodeFromInstance(a)},injection:{injectComponentTree:function(a){fb=a}}},ib=hb,jb=null,kb=null,lb=null;
function mb(a){if(a=ib.getInstanceFromNode(a))if("number"===typeof a.tag){jb&&"function"===typeof jb.restoreControlledState?void 0:w("194");var b=ib.getFiberCurrentPropsFromNode(a.stateNode);jb.restoreControlledState(a.stateNode,a.type,b)}else"function"!==typeof a.restoreControlledState?w("195"):void 0,a.restoreControlledState()}
var nb={injection:{injectFiberControlledHostComponent:function(a){jb=a}},enqueueStateRestore:function(a){kb?lb?lb.push(a):lb=[a]:kb=a},restoreStateIfNeeded:function(){if(kb){var a=kb,b=lb;lb=kb=null;mb(a);if(b)for(a=0;a<b.length;a++)mb(b[a])}}};function ob(a,b,c,d,e,f){return a(b,c,d,e,f)}function pb(a,b){return a(b)}function qb(a,b){return pb(a,b)}
var rb=!1,sb={batchedUpdates:function(a,b){if(rb)return ob(qb,a,b);rb=!0;try{return ob(qb,a,b)}finally{rb=!1,nb.restoreStateIfNeeded()}},injection:{injectStackBatchedUpdates:function(a){ob=a},injectFiberBatchedUpdates:function(a){pb=a}}},tb=F.TEXT_NODE;function ub(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return a.nodeType===tb?a.parentNode:a}var vb=E.HostRoot,wb=[];
function xb(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c=b;if("number"===typeof c.tag){for(;c["return"];)c=c["return"];c=c.tag!==vb?null:c.stateNode.containerInfo}else{for(;c._hostParent;)c=c._hostParent;c=G.getNodeFromInstance(c).parentNode}if(!c)break;a.ancestors.push(b);b=G.getClosestInstanceFromNode(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],yb._handleTopLevel(a.topLevelType,b,a.nativeEvent,ub(a.nativeEvent))}
var yb={_enabled:!0,_handleTopLevel:null,setHandleTopLevel:function(a){yb._handleTopLevel=a},setEnabled:function(a){yb._enabled=!!a},isEnabled:function(){return yb._enabled},trapBubbledEvent:function(a,b,c){return c?ba.listen(c,b,yb.dispatchEvent.bind(null,a)):null},trapCapturedEvent:function(a,b,c){return c?ba.capture(c,b,yb.dispatchEvent.bind(null,a)):null},dispatchEvent:function(a,b){if(yb._enabled){var c=ub(b);c=G.getClosestInstanceFromNode(c);null===c||"number"!==typeof c.tag||bb.isFiberMounted(c)||
(c=null);if(wb.length){var d=wb.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{sb.batchedUpdates(xb,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>wb.length&&wb.push(a)}}}},L=yb;function Cb(a,b){null==b?w("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function Db(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Eb=null;function Fb(a,b){a&&(ib.executeDispatchesInOrder(a,b),a.isPersistent()||a.constructor.release(a))}function Gb(a){return Fb(a,!0)}function Hb(a){return Fb(a,!1)}
function Ib(a,b,c){switch(a){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":return!(!c.disabled||"button"!==b&&"input"!==b&&"select"!==b&&"textarea"!==b);default:return!1}}
var Jb={injection:{injectEventPluginOrder:sa.injectEventPluginOrder,injectEventPluginsByName:sa.injectEventPluginsByName},getListener:function(a,b){if("number"===typeof a.tag){var c=a.stateNode;if(!c)return null;var d=ib.getFiberCurrentPropsFromNode(c);if(!d)return null;c=d[b];if(Ib(b,a.type,d))return null}else{d=a._currentElement;if("string"===typeof d||"number"===typeof d||!a._rootNodeID)return null;a=d.props;c=a[b];if(Ib(b,d.type,a))return null}c&&"function"!==typeof c?w("231",b,typeof c):void 0;
return c},extractEvents:function(a,b,c,d){for(var e,f=sa.plugins,g=0;g<f.length;g++){var h=f[g];h&&(h=h.extractEvents(a,b,c,d))&&(e=Cb(e,h))}return e},enqueueEvents:function(a){a&&(Eb=Cb(Eb,a))},processEventQueue:function(a){var b=Eb;Eb=null;a?Db(b,Gb):Db(b,Hb);Eb?w("95"):void 0;eb.rethrowCaughtError()}},Kb;l.canUseDOM&&(Kb=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function Lb(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&Kb&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function Mb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var Nb={animationend:Mb("Animation","AnimationEnd"),animationiteration:Mb("Animation","AnimationIteration"),animationstart:Mb("Animation","AnimationStart"),transitionend:Mb("Transition","TransitionEnd")},Ob={},Pb={};l.canUseDOM&&(Pb=document.createElement("div").style,"AnimationEvent"in window||(delete Nb.animationend.animation,delete Nb.animationiteration.animation,delete Nb.animationstart.animation),"TransitionEvent"in window||delete Nb.transitionend.transition);
function Qb(a){if(Ob[a])return Ob[a];if(!Nb[a])return a;var b=Nb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Pb)return Ob[a]=b[c];return""}
var Rb={topAbort:"abort",topAnimationEnd:Qb("animationend")||"animationend",topAnimationIteration:Qb("animationiteration")||"animationiteration",topAnimationStart:Qb("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Qb("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Sb={},Tb=0,Ub="_reactListenersID"+(""+Math.random()).slice(2);function Vb(a){Object.prototype.hasOwnProperty.call(a,Ub)||(a[Ub]=Tb++,Sb[a[Ub]]={});return Sb[a[Ub]]}
var M=n({},{handleTopLevel:function(a,b,c,d){a=Jb.extractEvents(a,b,c,d);Jb.enqueueEvents(a);Jb.processEventQueue(!1)}},{setEnabled:function(a){L&&L.setEnabled(a)},isEnabled:function(){return!(!L||!L.isEnabled())},listenTo:function(a,b){var c=Vb(b);a=sa.registrationNameDependencies[a];for(var d=0;d<a.length;d++){var e=a[d];c.hasOwnProperty(e)&&c[e]||("topWheel"===e?Lb("wheel")?L.trapBubbledEvent("topWheel","wheel",b):Lb("mousewheel")?L.trapBubbledEvent("topWheel","mousewheel",b):L.trapBubbledEvent("topWheel",
"DOMMouseScroll",b):"topScroll"===e?L.trapCapturedEvent("topScroll","scroll",b):"topFocus"===e||"topBlur"===e?(L.trapCapturedEvent("topFocus","focus",b),L.trapCapturedEvent("topBlur","blur",b),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(Lb("cancel",!0)&&L.trapCapturedEvent("topCancel","cancel",b),c.topCancel=!0):"topClose"===e?(Lb("close",!0)&&L.trapCapturedEvent("topClose","close",b),c.topClose=!0):Rb.hasOwnProperty(e)&&L.trapBubbledEvent(e,Rb[e],b),c[e]=!0)}},isListeningToAllDependencies:function(a,
b){b=Vb(b);a=sa.registrationNameDependencies[a];for(var c=0;c<a.length;c++){var d=a[c];if(!b.hasOwnProperty(d)||!b[d])return!1}return!0},trapBubbledEvent:function(a,b,c){return L.trapBubbledEvent(a,b,c)},trapCapturedEvent:function(a,b,c){return L.trapCapturedEvent(a,b,c)}}),Wb={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,
flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Xb=["Webkit","ms","Moz","O"];
Object.keys(Wb).forEach(function(a){Xb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Wb[b]=Wb[a]})});
var Yb={isUnitlessNumber:Wb,shorthandPropertyExpansions:{background:{backgroundAttachment:!0,backgroundColor:!0,backgroundImage:!0,backgroundPositionX:!0,backgroundPositionY:!0,backgroundRepeat:!0},backgroundPosition:{backgroundPositionX:!0,backgroundPositionY:!0},border:{borderWidth:!0,borderStyle:!0,borderColor:!0},borderBottom:{borderBottomWidth:!0,borderBottomStyle:!0,borderBottomColor:!0},borderLeft:{borderLeftWidth:!0,borderLeftStyle:!0,borderLeftColor:!0},borderRight:{borderRightWidth:!0,borderRightStyle:!0,
borderRightColor:!0},borderTop:{borderTopWidth:!0,borderTopStyle:!0,borderTopColor:!0},font:{fontStyle:!0,fontVariant:!0,fontWeight:!0,fontSize:!0,lineHeight:!0,fontFamily:!0},outline:{outlineWidth:!0,outlineStyle:!0,outlineColor:!0}}},Zb=Yb.isUnitlessNumber,$b=!1;if(l.canUseDOM){var ac=document.createElement("div").style;try{ac.font=""}catch(a){$b=!0}}
var bc={createDangerousStringForStyles:function(){},setValueForStyles:function(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Zb.hasOwnProperty(e)&&Zb[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");if(d)a.setProperty(c,e);else if(e)a[c]=e;else if(d=$b&&Yb.shorthandPropertyExpansions[c])for(var g in d)a[g]="";else a[c]=""}}},cc=new RegExp("^["+A.ATTRIBUTE_NAME_START_CHAR+
"]["+A.ATTRIBUTE_NAME_CHAR+"]*$"),dc={},ec={};function fc(a){if(ec.hasOwnProperty(a))return!0;if(dc.hasOwnProperty(a))return!1;if(cc.test(a))return ec[a]=!0;dc[a]=!0;return!1}
var gc={setAttributeForID:function(a,b){a.setAttribute(A.ID_ATTRIBUTE_NAME,b)},setAttributeForRoot:function(a){a.setAttribute(A.ROOT_ATTRIBUTE_NAME,"")},getValueForProperty:function(){},getValueForAttribute:function(){},setValueForProperty:function(a,b,c){var d=A.getPropertyInfo(b);if(d&&A.shouldSetAttribute(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?gc.deleteValueForProperty(a,
b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else gc.setValueForAttribute(a,b,A.shouldSetAttribute(b,c)?c:null)},setValueForAttribute:function(a,b,c){fc(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))},deleteValueForAttribute:function(a,b){a.removeAttribute(b)},deleteValueForProperty:function(a,b){var c=A.getPropertyInfo(b);
c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}},hc=gc,ic=Qa.ReactDebugCurrentFrame;function jc(){return null}
var kc={current:null,phase:null,resetCurrentFiber:function(){ic.getCurrentStack=null;kc.current=null;kc.phase=null},setCurrentFiber:function(a,b){ic.getCurrentStack=jc;kc.current=a;kc.phase=b},getCurrentFiberOwnerName:function(){return null},getCurrentFiberStackAddendum:jc},lc=kc,mc={getHostProps:function(a,b){var c=b.value,d=b.checked;return n({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?
d:a._wrapperState.initialChecked})},initWrapperState:function(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}},updateWrapper:function(a,b){var c=b.checked;null!=c&&hc.setValueForProperty(a,"checked",c||!1);c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=
c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)},postMountWrapper:function(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==
b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)},restoreControlledState:function(a,b){mc.updateWrapper(a,b);var c=b.name;if("radio"===b.type&&null!=c){for(b=a;b.parentNode;)b=b.parentNode;c=b.querySelectorAll("input[name\x3d"+JSON.stringify(""+c)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=G.getFiberCurrentPropsFromNode(d);e?void 0:w("90");mc.updateWrapper(d,e)}}}}},qc=mc;
function rc(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}var sc={validateProps:function(){},postMountWrapper:function(a,b){null!=b.value&&a.setAttribute("value",b.value)},getHostProps:function(a,b){a=n({children:void 0},b);if(b=rc(b.children))a.children=b;return a}};
function tc(a,b,c){a=a.options;if(b){b={};for(var d=0;d<c.length;d++)b["$"+c[d]]=!0;for(c=0;c<a.length;c++)d=b.hasOwnProperty("$"+a[c].value),a[c].selected!==d&&(a[c].selected=d)}else{c=""+c;b=null;for(d=0;d<a.length;d++){if(a[d].value===c){a[d].selected=!0;return}null!==b||a[d].disabled||(b=a[d])}null!==b&&(b.selected=!0)}}
var uc={getHostProps:function(a,b){return n({},b,{value:void 0})},initWrapperState:function(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}},postMountWrapper:function(a,b){a.multiple=!!b.multiple;var c=b.value;null!=c?tc(a,!!b.multiple,c):null!=b.defaultValue&&tc(a,!!b.multiple,b.defaultValue)},postUpdateWrapper:function(a,b){a._wrapperState.initialValue=void 0;var c=a._wrapperState.wasMultiple;a._wrapperState.wasMultiple=!!b.multiple;var d=b.value;
null!=d?tc(a,!!b.multiple,d):c!==!!b.multiple&&(null!=b.defaultValue?tc(a,!!b.multiple,b.defaultValue):tc(a,!!b.multiple,b.multiple?[]:""))},restoreControlledState:function(a,b){var c=b.value;null!=c&&tc(a,!!b.multiple,c)}},vc={getHostProps:function(a,b){null!=b.dangerouslySetInnerHTML?w("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})},initWrapperState:function(a,b){var c=b.value,d=c;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?
w("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:w("93"),b=b[0]),c=""+b),null==c&&(c=""),d=c);a._wrapperState={initialValue:""+d}},updateWrapper:function(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)},postMountWrapper:function(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)},restoreControlledState:function(a,b){vc.updateWrapper(a,b)}},wc=vc,xc=n({menuitem:!0},{area:!0,
base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});function yc(a,b){b&&(xc[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?w("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?w("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:w("61")),null!=b.style&&"object"!==typeof b.style?w("62",""):void 0)}
function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
var Bc={_getTrackerFromNode:function(a){return a._valueTracker},track:function(a){a._valueTracker||(a._valueTracker=Ac(a))},updateValueIfChanged:function(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1},stopTracking:function(a){(a=a._valueTracker)&&a.stopTracking()}};
function Cc(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
var Dc=ka.Namespaces,Ec,Fc=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Dc.svg||"innerHTML"in a)a.innerHTML=b;else for(Ec=Ec||document.createElement("div"),Ec.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e",b=Ec.firstChild;b.firstChild;)a.appendChild(b.firstChild)}),Gc=/["'&<>]/,Hc=F.TEXT_NODE;
function Ic(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&c.nodeType===Hc){c.nodeValue=b;return}}a.textContent=b}
l.canUseDOM&&("textContent"in document.documentElement||(Ic=function(a,b){if(a.nodeType===Hc)a.nodeValue=b;else{if("boolean"===typeof b||"number"===typeof b)b=""+b;else{b=""+b;var c=Gc.exec(b);if(c){var d="",e,f=0;for(e=c.index;e<b.length;e++){switch(b.charCodeAt(e)){case 34:c="\x26quot;";break;case 38:c="\x26amp;";break;case 39:c="\x26#x27;";break;case 60:c="\x26lt;";break;case 62:c="\x26gt;";break;default:continue}f!==e&&(d+=b.substring(f,e));f=e+1;d+=c}b=f!==e?d+b.substring(f,e):d}}Fc(a,b)}}));
var Jc=Ic,Kc=lc.getCurrentFiberOwnerName,Lc=F.DOCUMENT_NODE,Mc=F.DOCUMENT_FRAGMENT_NODE,Nc=M.listenTo,Oc=sa.registrationNameModules,Pc=ka.Namespaces.html,Qc=ka.getIntrinsicNamespace;function Rc(a,b){Nc(b,a.nodeType===Lc||a.nodeType===Mc?a:a.ownerDocument)}
var Sc={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"},N={createElement:function(a,b,c,d){c=c.nodeType===Lc?c:c.ownerDocument;d===Pc&&(d=Qc(a));d===Pc?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a},createTextNode:function(a,b){return(b.nodeType===Lc?b:b.ownerDocument).createTextNode(a)},setInitialProperties:function(a,b,c,d){var e=Cc(b,c);switch(b){case "iframe":case "object":M.trapBubbledEvent("topLoad",
"load",a);var f=c;break;case "video":case "audio":for(f in Sc)Sc.hasOwnProperty(f)&&M.trapBubbledEvent(f,Sc[f],a);f=c;break;case "source":M.trapBubbledEvent("topError","error",a);f=c;break;case "img":case "image":M.trapBubbledEvent("topError","error",a);M.trapBubbledEvent("topLoad","load",a);f=c;break;case "form":M.trapBubbledEvent("topReset","reset",a);M.trapBubbledEvent("topSubmit","submit",a);f=c;break;case "details":M.trapBubbledEvent("topToggle","toggle",a);f=c;break;case "input":qc.initWrapperState(a,
c);f=qc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;case "option":sc.validateProps(a,c);f=sc.getHostProps(a,c);break;case "select":uc.initWrapperState(a,c);f=uc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;case "textarea":wc.initWrapperState(a,c);f=wc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;default:f=c}yc(b,f,Kc);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===
h?bc.setValueForStyles(a,k):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Fc(a,k)):"children"===h?"string"===typeof k?Jc(a,k):"number"===typeof k&&Jc(a,""+k):"suppressContentEditableWarning"!==h&&(Oc.hasOwnProperty(h)?null!=k&&Rc(d,h):e?hc.setValueForAttribute(a,h,k):null!=k&&hc.setValueForProperty(a,h,k))}switch(b){case "input":Bc.track(a);qc.postMountWrapper(a,c);break;case "textarea":Bc.track(a);wc.postMountWrapper(a,c);break;case "option":sc.postMountWrapper(a,c);break;case "select":uc.postMountWrapper(a,
c);break;default:"function"===typeof f.onClick&&(a.onclick=ca)}},diffProperties:function(a,b,c,d,e){var f=null;switch(b){case "input":c=qc.getHostProps(a,c);d=qc.getHostProps(a,d);f=[];break;case "option":c=sc.getHostProps(a,c);d=sc.getHostProps(a,d);f=[];break;case "select":c=uc.getHostProps(a,c);d=uc.getHostProps(a,d);f=[];break;case "textarea":c=wc.getHostProps(a,c);d=wc.getHostProps(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=ca)}yc(b,d,Kc);
var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]="");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&(Oc.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&
b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&(Oc.hasOwnProperty(g)?(null!=k&&Rc(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f},updateProperties:function(a,b,c,d,e){Cc(c,d);d=Cc(c,e);for(var f=0;f<b.length;f+=
2){var g=b[f],h=b[f+1];"style"===g?bc.setValueForStyles(a,h):"dangerouslySetInnerHTML"===g?Fc(a,h):"children"===g?Jc(a,h):d?null!=h?hc.setValueForAttribute(a,g,h):hc.deleteValueForAttribute(a,g):null!=h?hc.setValueForProperty(a,g,h):hc.deleteValueForProperty(a,g)}switch(c){case "input":qc.updateWrapper(a,e);Bc.updateValueIfChanged(a);break;case "textarea":wc.updateWrapper(a,e);break;case "select":uc.postUpdateWrapper(a,e)}},diffHydratedProperties:function(a,b,c,d,e){switch(b){case "iframe":case "object":M.trapBubbledEvent("topLoad",
"load",a);break;case "video":case "audio":for(var f in Sc)Sc.hasOwnProperty(f)&&M.trapBubbledEvent(f,Sc[f],a);break;case "source":M.trapBubbledEvent("topError","error",a);break;case "img":case "image":M.trapBubbledEvent("topError","error",a);M.trapBubbledEvent("topLoad","load",a);break;case "form":M.trapBubbledEvent("topReset","reset",a);M.trapBubbledEvent("topSubmit","submit",a);break;case "details":M.trapBubbledEvent("topToggle","toggle",a);break;case "input":qc.initWrapperState(a,c);M.trapBubbledEvent("topInvalid",
"invalid",a);Rc(e,"onChange");break;case "option":sc.validateProps(a,c);break;case "select":uc.initWrapperState(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(e,"onChange");break;case "textarea":wc.initWrapperState(a,c),M.trapBubbledEvent("topInvalid","invalid",a),Rc(e,"onChange")}yc(b,c,Kc);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Oc.hasOwnProperty(g)&&
null!=f&&Rc(e,g));switch(b){case "input":Bc.track(a);qc.postMountWrapper(a,c);break;case "textarea":Bc.track(a);wc.postMountWrapper(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=ca)}return d},diffHydratedText:function(a,b){return a.nodeValue!==b},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,
b,c){switch(b){case "input":qc.restoreControlledState(a,c);break;case "textarea":wc.restoreControlledState(a,c);break;case "select":uc.restoreControlledState(a,c)}}},Tc=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback){var Uc=null,Vc=null,Wc=!1,Xc=!1,Yc=0,Zc=33,$c=33,ad={timeRemaining:"object"===typeof performance&&"function"===typeof performance.now?function(){return Yc-performance.now()}:function(){return Yc-Date.now()}},bd="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){a.source===window&&a.data===bd&&(Wc=!1,a=Vc,Vc=null,null!==a&&a(ad))},!1);var cd=function(a){Xc=!1;var b=a-Yc+$c;b<$c&&Zc<$c?(8>
b&&(b=8),$c=b<Zc?Zc:b):Zc=b;Yc=a+$c;Wc||(Wc=!0,window.postMessage(bd,"*"));b=Uc;Uc=null;null!==b&&b(a)};Tc=function(a){Vc=a;Xc||(Xc=!0,requestAnimationFrame(cd));return 0}}else Tc=requestIdleCallback;else Tc=function(a){setTimeout(function(){a({timeRemaining:function(){return Infinity}})});return 0};
var dd={rIC:Tc},ed={enableAsyncSubtreeAPI:!0},Q={NoWork:0,SynchronousPriority:1,TaskPriority:2,HighPriority:3,LowPriority:4,OffscreenPriority:5},fd=J.Callback,gd=Q.NoWork,hd=Q.SynchronousPriority,id=Q.TaskPriority,jd=E.ClassComponent,kd=E.HostRoot,md=void 0,nd=void 0;function od(a,b){return a!==id&&a!==hd||b!==id&&b!==hd?a===gd&&b!==gd?-255:a!==gd&&b===gd?255:a-b:0}function pd(){return{first:null,last:null,hasForceUpdate:!1,callbackList:null}}
function qd(a,b,c,d){null!==c?c.next=b:(b.next=a.first,a.first=b);null!==d?b.next=d:a.last=b}function rd(a,b){b=b.priorityLevel;var c=null;if(null!==a.last&&0>=od(a.last.priorityLevel,b))c=a.last;else for(a=a.first;null!==a&&0>=od(a.priorityLevel,b);)c=a,a=a.next;return c}
function sd(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=pd());null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=pd())):a=null;md=d;nd=a!==d?a:null;var e=md;c=nd;var f=rd(e,b),g=null!==f?f.next:e.first;if(null===c)return qd(e,b,f,g),null;d=rd(c,b);a=null!==d?d.next:c.first;qd(e,b,f,g);if(g===a&&null!==g||f===d&&null!==f)return null===d&&(c.first=b),null===a&&(c.last=null),null;b={priorityLevel:b.priorityLevel,partialState:b.partialState,callback:b.callback,isReplace:b.isReplace,
isForced:b.isForced,isTopLevelUnmount:b.isTopLevelUnmount,next:null};qd(c,b,d,a);return b}function td(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
var ud={addUpdate:function(a,b,c,d){sd(a,{priorityLevel:d,partialState:b,callback:c,isReplace:!1,isForced:!1,isTopLevelUnmount:!1,next:null})},addReplaceUpdate:function(a,b,c,d){sd(a,{priorityLevel:d,partialState:b,callback:c,isReplace:!0,isForced:!1,isTopLevelUnmount:!1,next:null})},addForceUpdate:function(a,b,c){sd(a,{priorityLevel:c,partialState:null,callback:b,isReplace:!1,isForced:!0,isTopLevelUnmount:!1,next:null})},getUpdatePriority:function(a){var b=a.updateQueue;return null===b||a.tag!==
jd&&a.tag!==kd?gd:null!==b.first?b.first.priorityLevel:gd},addTopLevelUpdate:function(a,b,c,d){var e=null===b.element;b={priorityLevel:d,partialState:b,callback:c,isReplace:!1,isForced:!1,isTopLevelUnmount:e,next:null};a=sd(a,b);e&&(e=md,c=nd,null!==e&&null!==b.next&&(b.next=null,e.last=b),null!==c&&null!==a&&null!==a.next&&(a.next=null,c.last=b))},beginUpdateQueue:function(a,b,c,d,e,f,g){null!==a&&a.updateQueue===c&&(c=b.updateQueue={first:c.first,last:c.last,callbackList:null,hasForceUpdate:!1});
a=c.callbackList;for(var h=c.hasForceUpdate,k=!0,p=c.first;null!==p&&0>=od(p.priorityLevel,g);){c.first=p.next;null===c.first&&(c.last=null);var x;if(p.isReplace)e=td(p,d,e,f),k=!0;else if(x=td(p,d,e,f))e=k?n({},e,x):n(e,x),k=!1;p.isForced&&(h=!0);null===p.callback||p.isTopLevelUnmount&&null!==p.next||(a=null!==a?a:[],a.push(p.callback),b.effectTag|=fd);p=p.next}c.callbackList=a;c.hasForceUpdate=h;null!==c.first||null!==a||h||(b.updateQueue=null);return e},commitCallbacks:function(a,b,c){a=b.callbackList;
if(null!==a)for(b.callbackList=null,b=0;b<a.length;b++){var d=a[b];"function"!==typeof d?w("191",d):void 0;d.call(c)}}},vd=[],wd=-1,xd={createCursor:function(a){return{current:a}},isEmpty:function(){return-1===wd},pop:function(a){0>wd||(a.current=vd[wd],vd[wd]=null,wd--)},push:function(a,b){wd++;vd[wd]=a.current;a.current=b},reset:function(){for(;-1<wd;)vd[wd]=null,wd--}},yd=bb.isFiberMounted,zd=E.ClassComponent,Ad=E.HostRoot,Bd=xd.createCursor,Cd=xd.pop,Dd=xd.push,Ed=Bd(da),Fd=Bd(!1),Ld=da;
function Md(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function Nd(a){return a.tag===zd&&null!=a.type.childContextTypes}function Od(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:w("108",Ra(a)||"Unknown",e);return n({},b,c)}
var R={getUnmaskedContext:function(a){return Nd(a)?Ld:Ed.current},cacheContext:Md,getMaskedContext:function(a,b){var c=a.type.contextTypes;if(!c)return da;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&Md(a,b,e);return e},hasContextChanged:function(){return Fd.current},isContextConsumer:function(a){return a.tag===zd&&null!=a.type.contextTypes},isContextProvider:Nd,popContextProvider:function(a){Nd(a)&&
(Cd(Fd,a),Cd(Ed,a))},popTopLevelContextObject:function(a){Cd(Fd,a);Cd(Ed,a)},pushTopLevelContextObject:function(a,b,c){null!=Ed.cursor?w("168"):void 0;Dd(Ed,b,a);Dd(Fd,c,a)},processChildContext:Od,pushContextProvider:function(a){if(!Nd(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||da;Ld=Ed.current;Dd(Ed,b,a);Dd(Fd,Fd.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:w("169");if(b){var d=Od(a,Ld,!0);c.__reactInternalMemoizedMergedChildContext=
d;Cd(Fd,a);Cd(Ed,a);Dd(Ed,d,a)}else Cd(Fd,a);Dd(Fd,b,a)},resetContext:function(){Ld=da;Ed.current=da;Fd.current=!1},findCurrentUnmaskedContext:function(a){for(yd(a)&&a.tag===zd?void 0:w("170");a.tag!==Ad;){if(Nd(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:w("171")}return a.stateNode.context}},Pd={NoContext:0,AsyncUpdates:1},Qd=E.IndeterminateComponent,Rd=E.ClassComponent,Sd=E.HostRoot,Td=E.HostComponent,Ud=E.HostText,Vd=E.HostPortal,Wd=E.CoroutineComponent,
Xd=E.YieldComponent,Yd=E.Fragment,Zd=Q.NoWork,$d=Pd.NoContext,ae=J.NoEffect;function be(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=ae;this.lastEffect=this.firstEffect=this.nextEffect=null;this.pendingWorkPriority=Zd;this.alternate=null}
function ce(a,b,c){var d=void 0;"function"===typeof a?(d=a.prototype&&a.prototype.isReactComponent?new be(Rd,b,c):new be(Qd,b,c),d.type=a):"string"===typeof a?(d=new be(Td,b,c),d.type=a):"object"===typeof a&&null!==a&&"number"===typeof a.tag?d=a:w("130",null==a?a:typeof a,"");return d}
var de={createWorkInProgress:function(a,b){var c=a.alternate;null===c?(c=new be(a.tag,a.key,a.internalContextTag),c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.effectTag=ae,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.pendingWorkPriority=b;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c},createHostRootFiber:function(){return new be(Sd,null,$d)},
createFiberFromElement:function(a,b,c){b=ce(a.type,a.key,b,null);b.pendingProps=a.props;b.pendingWorkPriority=c;return b},createFiberFromFragment:function(a,b,c){b=new be(Yd,null,b);b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromText:function(a,b,c){b=new be(Ud,null,b);b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromElementType:ce,createFiberFromHostInstanceForDeletion:function(){var a=new be(Td,null,$d);a.type="DELETED";return a},createFiberFromCoroutine:function(a,
b,c){b=new be(Wd,a.key,b);b.type=a.handler;b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromYield:function(a,b){return new be(Xd,null,b)},createFiberFromPortal:function(a,b,c){b=new be(Vd,a.key,b);b.pendingProps=a.children||[];b.pendingWorkPriority=c;b.stateNode={containerInfo:a.containerInfo,implementation:a.implementation};return b},largerPriority:function(a,b){return a!==Zd&&(b===Zd||b>a)?a:b}},ee=de.createHostRootFiber,fe=E.IndeterminateComponent,ge=E.FunctionalComponent,he=E.ClassComponent,
ie=E.HostComponent,je,ke;"function"===typeof Symbol&&Symbol["for"]?(je=Symbol["for"]("react.coroutine"),ke=Symbol["for"]("react.yield")):(je=60104,ke=60105);
var le={createCoroutine:function(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:je,key:null==d?null:""+d,children:a,handler:b,props:c}},createYield:function(a){return{$$typeof:ke,value:a}},isCoroutine:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===je},isYield:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===ke},REACT_YIELD_TYPE:ke,REACT_COROUTINE_TYPE:je},me="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.portal")||
60106,ne={createPortal:function(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:me,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}},isPortal:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===me},REACT_PORTAL_TYPE:me},oe=le.REACT_COROUTINE_TYPE,pe=le.REACT_YIELD_TYPE,qe=ne.REACT_PORTAL_TYPE,re=de.createWorkInProgress,se=de.createFiberFromElement,te=de.createFiberFromFragment,ue=de.createFiberFromText,ve=de.createFiberFromCoroutine,
we=de.createFiberFromYield,xe=de.createFiberFromPortal,ye=Array.isArray,ze=E.FunctionalComponent,Ae=E.ClassComponent,Be=E.HostText,Ce=E.HostPortal,De=E.CoroutineComponent,Ee=E.YieldComponent,Fe=E.Fragment,Ge=J.NoEffect,He=J.Placement,Ie=J.Deletion,Je="function"===typeof Symbol&&Symbol.iterator,Ke="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103;
function Le(a){if(null===a||"undefined"===typeof a)return null;a=Je&&a[Je]||a["@@iterator"];return"function"===typeof a?a:null}
function Me(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&("number"===typeof b.tag?(b.tag!==Ae?w("110"):void 0,d=b.stateNode):d=b.getPublicInstance());d?void 0:w("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===da?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?w("148"):void 0;b._owner?void 0:w("149",c)}return c}
function Ne(a,b){"textarea"!==a.type&&w("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Oe(a,b){function c(c,d){if(b){if(!a){if(null===d.alternate)return;d=d.alternate}var m=c.lastEffect;null!==m?(m.nextEffect=d,c.lastEffect=d):c.firstEffect=c.lastEffect=d;d.nextEffect=null;d.effectTag=Ie}}function d(a,d){if(!b)return null;for(;null!==d;)c(a,d),d=d.sibling;return null}function e(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function f(b,c){if(a)return b=re(b,c),b.index=0,b.sibling=null,b;b.pendingWorkPriority=c;b.effectTag=Ge;
b.index=0;b.sibling=null;return b}function g(a,c,d){a.index=d;if(!b)return c;d=a.alternate;if(null!==d)return d=d.index,d<c?(a.effectTag=He,c):d;a.effectTag=He;return c}function h(a){b&&null===a.alternate&&(a.effectTag=He);return a}function k(a,b,c,d){if(null===b||b.tag!==Be)return c=ue(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function p(a,b,c,d){if(null===b||b.type!==c.type)return d=se(c,a.internalContextTag,d),d.ref=Me(b,c),d["return"]=a,d;d=f(b,
d);d.ref=Me(b,c);d.pendingProps=c.props;d["return"]=a;return d}function x(a,b,c,d){if(null===b||b.tag!==De)return c=ve(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function S(a,b,c,d){if(null===b||b.tag!==Ee)return b=we(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=f(b,d);b.type=c.value;b["return"]=a;return b}function D(a,b,c,d){if(null===b||b.tag!==Ce||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return c=
xe(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c.children||[];b["return"]=a;return b}function y(a,b,c,d){if(null===b||b.tag!==Fe)return c=te(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function B(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ue(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ke:return c=se(b,a.internalContextTag,c),c.ref=Me(null,b),c["return"]=
a,c;case oe:return b=ve(b,a.internalContextTag,c),b["return"]=a,b;case pe:return c=we(b,a.internalContextTag,c),c.type=b.value,c["return"]=a,c;case qe:return b=xe(b,a.internalContextTag,c),b["return"]=a,b}if(ye(b)||Le(b))return b=te(b,a.internalContextTag,c),b["return"]=a,b;Ne(a,b)}return null}function H(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:k(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ke:return c.key===e?p(a,
b,c,d):null;case oe:return c.key===e?x(a,b,c,d):null;case pe:return null===e?S(a,b,c,d):null;case qe:return c.key===e?D(a,b,c,d):null}if(ye(c)||Le(c))return null!==e?null:y(a,b,c,d);Ne(a,c)}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,k(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ke:return a=a.get(null===d.key?c:d.key)||null,p(b,a,d,e);case oe:return a=a.get(null===d.key?c:d.key)||null,x(b,a,d,e);case pe:return a=a.get(c)||
null,S(b,a,d,e);case qe:return a=a.get(null===d.key?c:d.key)||null,D(b,a,d,e)}if(ye(d)||Le(d))return a=a.get(c)||null,y(b,a,d,e);Ne(b,d)}return null}function Ca(a,f,h,k){for(var m=null,t=null,q=f,r=f=0,p=null;null!==q&&r<h.length;r++){q.index>r?(p=q,q=null):p=q.sibling;var v=H(a,q,h[r],k);if(null===v){null===q&&(q=p);break}b&&q&&null===v.alternate&&c(a,q);f=g(v,f,r);null===t?m=v:t.sibling=v;t=v;q=p}if(r===h.length)return d(a,q),m;if(null===q){for(;r<h.length;r++)if(q=B(a,h[r],k))f=g(q,f,r),null===
t?m=q:t.sibling=q,t=q;return m}for(q=e(a,q);r<h.length;r++)if(p=C(q,a,r,h[r],k)){if(b&&null!==p.alternate)q["delete"](null===p.key?r:p.key);f=g(p,f,r);null===t?m=p:t.sibling=p;t=p}b&&q.forEach(function(b){return c(a,b)});return m}function r(a,f,h,r){var m=Le(h);"function"!==typeof m?w("150"):void 0;h=m.call(h);null==h?w("151"):void 0;for(var t=m=null,q=f,k=f=0,p=null,v=h.next();null!==q&&!v.done;k++,v=h.next()){q.index>k?(p=q,q=null):p=q.sibling;var V=H(a,q,v.value,r);if(null===V){q||(q=p);break}b&&
q&&null===V.alternate&&c(a,q);f=g(V,f,k);null===t?m=V:t.sibling=V;t=V;q=p}if(v.done)return d(a,q),m;if(null===q){for(;!v.done;k++,v=h.next())v=B(a,v.value,r),null!==v&&(f=g(v,f,k),null===t?m=v:t.sibling=v,t=v);return m}for(q=e(a,q);!v.done;k++,v=h.next())if(v=C(q,a,k,v.value,r),null!==v){if(b&&null!==v.alternate)q["delete"](null===v.key?k:v.key);f=g(v,f,k);null===t?m=v:t.sibling=v;t=v}b&&q.forEach(function(b){return c(a,b)});return m}return function(a,b,e,g){var m="object"===typeof e&&null!==e;if(m)switch(e.$$typeof){case Ke:a:{var C=
e.key;for(m=b;null!==m;){if(m.key===C)if(m.type===e.type){d(a,m.sibling);b=f(m,g);b.ref=Me(m,e);b.pendingProps=e.props;b["return"]=a;a=b;break a}else{d(a,m);break}else c(a,m);m=m.sibling}g=se(e,a.internalContextTag,g);g.ref=Me(b,e);g["return"]=a;a=g}return h(a);case oe:a:{for(m=e.key;null!==b;){if(b.key===m)if(b.tag===De){d(a,b.sibling);b=f(b,g);b.pendingProps=e;b["return"]=a;a=b;break a}else{d(a,b);break}else c(a,b);b=b.sibling}e=ve(e,a.internalContextTag,g);e["return"]=a;a=e}return h(a);case pe:a:{if(null!==
b)if(b.tag===Ee){d(a,b.sibling);b=f(b,g);b.type=e.value;b["return"]=a;a=b;break a}else d(a,b);b=we(e,a.internalContextTag,g);b.type=e.value;b["return"]=a;a=b}return h(a);case qe:a:{for(m=e.key;null!==b;){if(b.key===m)if(b.tag===Ce&&b.stateNode.containerInfo===e.containerInfo&&b.stateNode.implementation===e.implementation){d(a,b.sibling);b=f(b,g);b.pendingProps=e.children||[];b["return"]=a;a=b;break a}else{d(a,b);break}else c(a,b);b=b.sibling}e=xe(e,a.internalContextTag,g);e["return"]=a;a=e}return h(a)}if("string"===
typeof e||"number"===typeof e)return e=""+e,null!==b&&b.tag===Be?(d(a,b.sibling),b=f(b,g),b.pendingProps=e,b["return"]=a,a=b):(d(a,b),e=ue(e,a.internalContextTag,g),e["return"]=a,a=e),h(a);if(ye(e))return Ca(a,b,e,g);if(Le(e))return r(a,b,e,g);m&&Ne(a,e);if("undefined"===typeof e)switch(a.tag){case Ae:case ze:e=a.type,w("152",e.displayName||e.name||"Component")}return d(a,b)}}
var Pe=Oe(!0,!0),Qe=Oe(!1,!0),Re=Oe(!1,!1),Se={reconcileChildFibers:Pe,reconcileChildFibersInPlace:Qe,mountChildFibersInPlace:Re,cloneChildFibers:function(a,b){null!==a&&b.child!==a.child?w("153"):void 0;if(null!==b.child){a=b.child;var c=re(a,a.pendingWorkPriority);c.pendingProps=a.pendingProps;b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=re(a,a.pendingWorkPriority),c.pendingProps=a.pendingProps,c["return"]=b;c.sibling=null}}},Te=J.Update,Ue=Pd.AsyncUpdates,Ve=R.cacheContext,
We=R.getMaskedContext,Xe=R.getUnmaskedContext,Ye=R.isContextConsumer,Ze=ud.addUpdate,$e=ud.addReplaceUpdate,af=ud.addForceUpdate,bf=ud.beginUpdateQueue,cf=R.hasContextChanged,df=bb.isMounted;
function ef(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;Pa.set(b,a)}var f={isMounted:df,enqueueSetState:function(c,d,e){c=Pa.get(c);var f=b(c,!1);Ze(c,d,void 0===e?null:e,f);a(c,f)},enqueueReplaceState:function(c,d,e){c=Pa.get(c);var f=b(c,!1);$e(c,d,void 0===e?null:e,f);a(c,f)},enqueueForceUpdate:function(c,d){c=Pa.get(c);var e=b(c,!1);af(c,void 0===d?null:d,e);a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=Xe(a),f=Ye(a),g=f?We(a,d):da;b=new c(b,g);
e(a,b);f&&Ve(a,d,g);return b},mountClassInstance:function(a,b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:w("158");var h=Xe(a);d.props=g;d.state=e;d.refs=da;d.context=We(a,h);ed.enableAsyncSubtreeAPI&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=Ue);"function"===typeof d.componentWillMount&&(h=d.state,d.componentWillMount(),h!==d.state&&f.enqueueReplaceState(d,d.state,null),h=a.updateQueue,null!==
h&&(d.state=bf(c,a,h,d,e,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=Te)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?w("159"):void 0);var D=g.context,y=Xe(b);y=We(b,y);"function"!==typeof g.componentWillReceiveProps||h===k&&D===y||(D=g.state,g.componentWillReceiveProps(k,y),g.state!==D&&f.enqueueReplaceState(g,g.state,null));D=b.memoizedState;e=null!==b.updateQueue?bf(a,
b,b.updateQueue,g,D,k,e):D;if(!(h!==k||D!==e||cf()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&D===a.memoizedState||(b.effectTag|=Te),!1;var B=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)B=!0;else{var H=b.stateNode,C=b.type;B="function"===typeof H.shouldComponentUpdate?H.shouldComponentUpdate(B,e,y):C.prototype&&C.prototype.isPureReactComponent?!ea(h,B)||!ea(D,e):!0}B?("function"===typeof g.componentWillUpdate&&
g.componentWillUpdate(k,e,y),"function"===typeof g.componentDidUpdate&&(b.effectTag|=Te)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&D===a.memoizedState||(b.effectTag|=Te),c(b,k),d(b,e));g.props=k;g.state=e;g.context=y;return B}}}
var ff=Se.mountChildFibersInPlace,gf=Se.reconcileChildFibers,hf=Se.reconcileChildFibersInPlace,jf=Se.cloneChildFibers,kf=ud.beginUpdateQueue,lf=R.getMaskedContext,mf=R.getUnmaskedContext,nf=R.hasContextChanged,of=R.pushContextProvider,pf=R.pushTopLevelContextObject,qf=R.invalidateContextProvider,rf=E.IndeterminateComponent,sf=E.FunctionalComponent,tf=E.ClassComponent,uf=E.HostRoot,wf=E.HostComponent,xf=E.HostText,yf=E.HostPortal,zf=E.CoroutineComponent,Af=E.CoroutineHandlerPhase,Bf=E.YieldComponent,
Cf=E.Fragment,Df=Q.NoWork,Ef=Q.OffscreenPriority,Ff=J.PerformedWork,Gf=J.Placement,Hf=J.ContentReset,If=J.Err,Jf=J.Ref,Kf=Qa.ReactCurrentOwner;
function Lf(a,b,c,d,e){function f(a,b,c){g(a,b,c,b.pendingWorkPriority)}function g(a,b,c,d){b.child=null===a?ff(b,b.child,c,d):a.child===b.child?gf(b,b.child,c,d):hf(b,b.child,c,d)}function h(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=Jf)}function k(a,b,c,d){h(a,b);if(!c)return d&&qf(b,!1),x(a,b);c=b.stateNode;Kf.current=b;var e=c.render();b.effectTag|=Ff;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&qf(b,!0);return b.child}function p(a){var b=a.stateNode;b.pendingContext?
pf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&pf(a,b.context,!1);C(a,b.containerInfo)}function x(a,b){jf(a,b);return b.child}function S(a,b){switch(b.tag){case uf:p(b);break;case tf:of(b);break;case yf:C(b,b.stateNode.containerInfo)}return null}var D=a.shouldSetTextContent,y=a.useSyncScheduling,B=a.shouldDeprioritizeSubtree,H=b.pushHostContext,C=b.pushHostContainer,Ca=c.enterHydrationState,r=c.resetHydrationState,m=c.tryToClaimNextHydratableInstance;a=ef(d,e,function(a,b){a.memoizedProps=
b},function(a,b){a.memoizedState=b});var t=a.adoptClassInstance,v=a.constructClassInstance,V=a.mountClassInstance,ld=a.updateClassInstance;return{beginWork:function(a,b,c){if(b.pendingWorkPriority===Df||b.pendingWorkPriority>c)return S(a,b);switch(b.tag){case rf:null!==a?w("155"):void 0;var d=b.type,e=b.pendingProps,g=mf(b);g=lf(b,g);d=d(e,g);b.effectTag|=Ff;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=tf,e=of(b),t(b,d),V(b,c),b=k(a,b,!0,e)):(b.tag=sf,f(a,b,d),b.memoizedProps=
e,b=b.child);return b;case sf:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(nf())null===c&&(c=d);else if(null===c||d===c){b=x(a,b);break a}d=mf(b);d=lf(b,d);e=e(c,d);b.effectTag|=Ff;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case tf:return e=of(b),d=void 0,null===a?b.stateNode?w("153"):(v(b,b.pendingProps),V(b,c),d=!0):d=ld(a,b,c),k(a,b,d,e);case uf:return p(b),d=b.updateQueue,null!==d?(e=b.memoizedState,d=kf(a,b,d,null,e,null,c),e===d?(r(),b=x(a,b)):(e=d.element,null!==a&&null!==a.child||
!Ca(b)?(r(),f(a,b,e)):(b.effectTag|=Gf,b.child=ff(b,b.child,e,c)),b.memoizedState=d,b=b.child)):(r(),b=x(a,b)),b;case wf:H(b);null===a&&m(b);e=b.type;var q=b.memoizedProps;d=b.pendingProps;null===d&&(d=q,null===d?w("154"):void 0);g=null!==a?a.memoizedProps:null;nf()||null!==d&&q!==d?(q=d.children,D(e,d)?q=null:g&&D(e,g)&&(b.effectTag|=Hf),h(a,b),c!==Ef&&!y&&B(e,d)?(b.pendingWorkPriority=Ef,b=null):(f(a,b,q),b.memoizedProps=d,b=b.child)):b=x(a,b);return b;case xf:return null===a&&m(b),a=b.pendingProps,
null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case Af:b.tag=zf;case zf:c=b.pendingProps;if(nf())null===c&&(c=a&&a.memoizedProps,null===c?w("154"):void 0);else if(null===c||b.memoizedProps===c)c=b.memoizedProps;e=c.children;d=b.pendingWorkPriority;b.stateNode=null===a?ff(b,b.stateNode,e,d):a.child===b.child?gf(b,b.stateNode,e,d):hf(b,b.stateNode,e,d);b.memoizedProps=c;return b.stateNode;case Bf:return null;case yf:a:{C(b,b.stateNode.containerInfo);c=b.pendingWorkPriority;e=b.pendingProps;if(nf())null===
e&&(e=a&&a.memoizedProps,null==e?w("154"):void 0);else if(null===e||b.memoizedProps===e){b=x(a,b);break a}null===a?b.child=hf(b,b.child,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case Cf:a:{c=b.pendingProps;if(nf())null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=x(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:w("156")}},beginFailedWork:function(a,b,c){switch(b.tag){case tf:of(b);break;case uf:p(b);break;default:w("157")}b.effectTag|=If;null===a?
b.child=null:b.child!==a.child&&(b.child=a.child);if(b.pendingWorkPriority===Df||b.pendingWorkPriority>c)return S(a,b);b.firstEffect=null;b.lastEffect=null;g(a,b,null,c);b.tag===tf&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
var Mf=Se.reconcileChildFibers,Nf=R.popContextProvider,Of=R.popTopLevelContextObject,Pf=E.IndeterminateComponent,Qf=E.FunctionalComponent,Rf=E.ClassComponent,Sf=E.HostRoot,Tf=E.HostComponent,Uf=E.HostText,Vf=E.HostPortal,Wf=E.CoroutineComponent,Xf=E.CoroutineHandlerPhase,Yf=E.YieldComponent,Zf=E.Fragment,ag=J.Placement,bg=J.Ref,cg=J.Update,dg=Q.OffscreenPriority;
function eg(a,b,c){var d=a.createInstance,e=a.createTextInstance,f=a.appendInitialChild,g=a.finalizeInitialChildren,h=a.prepareUpdate,k=b.getRootHostContainer,p=b.popHostContext,x=b.getHostContext,S=b.popHostContainer,D=c.prepareToHydrateHostInstance,y=c.prepareToHydrateHostTextInstance,B=c.popHydrationState;return{completeWork:function(a,b,c){var r=b.pendingProps;if(null===r)r=b.memoizedProps;else if(b.pendingWorkPriority!==dg||c===dg)b.pendingProps=null;switch(b.tag){case Qf:return null;case Rf:return Nf(b),
null;case Sf:S(b);Of(b);r=b.stateNode;r.pendingContext&&(r.context=r.pendingContext,r.pendingContext=null);if(null===a||null===a.child)B(b),b.effectTag&=~ag;return null;case Tf:p(b);c=k();var m=b.type;if(null!==a&&null!=b.stateNode){var t=a.memoizedProps,C=b.stateNode,V=x();r=h(C,m,t,r,c,V);if(b.updateQueue=r)b.effectTag|=cg;a.ref!==b.ref&&(b.effectTag|=bg)}else{if(!r)return null===b.stateNode?w("166"):void 0,null;a=x();if(B(b))D(b,c,a)&&(b.effectTag|=cg);else{a=d(m,r,c,a,b);a:for(t=b.child;null!==
t;){if(t.tag===Tf||t.tag===Uf)f(a,t.stateNode);else if(t.tag!==Vf&&null!==t.child){t=t.child;continue}if(t===b)break a;for(;null===t.sibling;){if(null===t["return"]||t["return"]===b)break a;t=t["return"]}t=t.sibling}g(a,m,r,c)&&(b.effectTag|=cg);b.stateNode=a}null!==b.ref&&(b.effectTag|=bg)}return null;case Uf:if(a&&null!=b.stateNode)a.memoizedProps!==r&&(b.effectTag|=cg);else{if("string"!==typeof r)return null===b.stateNode?w("166"):void 0,null;a=k();c=x();B(b)?y(b)&&(b.effectTag|=cg):b.stateNode=
e(r,a,c,b)}return null;case Wf:(r=b.memoizedProps)?void 0:w("165");b.tag=Xf;c=[];a:for((m=b.stateNode)&&(m["return"]=b);null!==m;){if(m.tag===Tf||m.tag===Uf||m.tag===Vf)w("164");else if(m.tag===Yf)c.push(m.type);else if(null!==m.child){m.child["return"]=m;m=m.child;continue}for(;null===m.sibling;){if(null===m["return"]||m["return"]===b)break a;m=m["return"]}m.sibling["return"]=m["return"];m=m.sibling}m=r.handler;r=m(r.props,c);b.child=Mf(b,null!==a?a.child:null,r,b.pendingWorkPriority);return b.child;
case Xf:return b.tag=Wf,null;case Yf:return null;case Zf:return null;case Vf:return b.effectTag|=cg,S(b),null;case Pf:w("167");default:w("156")}}}}var fg=null,gg=null;function hg(a){return function(b){try{return a(b)}catch(c){}}}
var ig={injectInternals:function(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!b.supportsFiber)return!0;try{var c=b.inject(a);fg=hg(function(a){return b.onCommitFiberRoot(c,a)});gg=hg(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0},onCommitRoot:function(a){"function"===typeof fg&&fg(a)},onCommitUnmount:function(a){"function"===typeof gg&&gg(a)}},jg=E.ClassComponent,kg=E.HostRoot,lg=E.HostComponent,mg=E.HostText,ng=
E.HostPortal,og=E.CoroutineComponent,pg=ud.commitCallbacks,qg=ig.onCommitUnmount,rg=J.Placement,sg=J.Update,tg=J.Callback,ug=J.ContentReset;
function vg(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(t){b(a,t)}}function d(a){return a.tag===lg||a.tag===kg||a.tag===ng}function e(a){for(var b=a;;)if(g(b),null!==b.child&&b.tag!==ng)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}function f(a){for(var b=a,c=!1,d=void 0,f=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?w("160"):void 0;switch(c.tag){case lg:d=
c.stateNode;f=!1;break a;case kg:d=c.stateNode.containerInfo;f=!0;break a;case ng:d=c.stateNode.containerInfo;f=!0;break a}c=c["return"]}c=!0}if(b.tag===lg||b.tag===mg)e(b),f?C(d,b.stateNode):H(d,b.stateNode);else if(b.tag===ng?d=b.stateNode.containerInfo:g(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];b.tag===ng&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}function g(a){"function"===
typeof qg&&qg(a);switch(a.tag){case jg:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(t){b(a,t)}break;case lg:c(a);break;case og:e(a.stateNode);break;case ng:f(a)}}var h=a.commitMount,k=a.commitUpdate,p=a.resetTextContent,x=a.commitTextUpdate,S=a.appendChild,D=a.appendChildToContainer,y=a.insertBefore,B=a.insertInContainerBefore,H=a.removeChild,C=a.removeChildFromContainer,Ca=a.getPublicInstance;
return{commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(d(b)){var c=b;break a}b=b["return"]}w("160");c=void 0}var e=b=void 0;switch(c.tag){case lg:b=c.stateNode;e=!1;break;case kg:b=c.stateNode.containerInfo;e=!0;break;case ng:b=c.stateNode.containerInfo;e=!0;break;default:w("161")}c.effectTag&ug&&(p(b),c.effectTag&=~ug);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||d(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;c.tag!==
lg&&c.tag!==mg;){if(c.effectTag&rg)continue b;if(null===c.child||c.tag===ng)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&rg)){c=c.stateNode;break a}}for(var f=a;;){if(f.tag===lg||f.tag===mg)c?e?B(b,f.stateNode,c):y(b,f.stateNode,c):e?D(b,f.stateNode):S(b,f.stateNode);else if(f.tag!==ng&&null!==f.child){f.child["return"]=f;f=f.child;continue}if(f===a)break;for(;null===f.sibling;){if(null===f["return"]||f["return"]===a)return;f=f["return"]}f.sibling["return"]=f["return"];f=f.sibling}},
commitDeletion:function(a){f(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case jg:break;case lg:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&k(c,f,e,a,d,b)}break;case mg:null===b.stateNode?w("162"):void 0;c=b.memoizedProps;x(b.stateNode,null!==a?a.memoizedProps:c,c);break;case kg:break;case ng:break;default:w("163")}},
commitLifeCycles:function(a,b){switch(b.tag){case jg:var c=b.stateNode;if(b.effectTag&sg)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b.effectTag&tg&&null!==b.updateQueue&&pg(b,b.updateQueue,c);break;case kg:a=b.updateQueue;null!==a&&pg(b,a,b.child&&b.child.stateNode);break;case lg:c=b.stateNode;null===a&&b.effectTag&sg&&h(c,b.type,b.memoizedProps,
b);break;case mg:break;case ng:break;default:w("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case lg:b(Ca(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var wg=xd.createCursor,xg=xd.pop,yg=xd.push,zg={};
function Ag(a){function b(a){a===zg?w("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e=wg(zg),f=wg(zg),g=wg(zg);return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){xg(e,a);xg(f,a);xg(g,a)},popHostContext:function(a){f.current===a&&(xg(e,a),xg(f,a))},pushHostContainer:function(a,b){yg(g,b,a);b=d(b);yg(f,a,a);yg(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);d=c(h,a.type,
d);h!==d&&(yg(f,a,a),yg(e,d,a))},resetHostContainer:function(){e.current=zg;g.current=zg}}}var Bg=E.HostComponent,Cg=E.HostText,Dg=E.HostRoot,Eg=J.Deletion,Fg=J.Placement,Gg=de.createFiberFromHostInstanceForDeletion;
function Hg(a){function b(a,b){var c=Gg();c.stateNode=b;c["return"]=a;c.effectTag=Eg;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case Bg:return f(b,a.type,a.pendingProps);case Cg:return g(b,a.pendingProps);default:return!1}}function d(a){for(a=a["return"];null!==a&&a.tag!==Bg&&a.tag!==Dg;)a=a["return"];y=a}var e=a.shouldSetTextContent,f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,
p=a.hydrateInstance,x=a.hydrateTextInstance,S=a.didNotHydrateInstance,D=a.didNotFindHydratableInstance;a=a.didNotFindHydratableTextInstance;if(!(f&&g&&h&&k&&p&&x&&S&&D&&a))return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){w("175")},prepareToHydrateHostTextInstance:function(){w("176")},popHydrationState:function(){return!1}};var y=null,B=null,H=!1;return{enterHydrationState:function(a){B=
k(a.stateNode.containerInfo);y=a;return H=!0},resetHydrationState:function(){B=y=null;H=!1},tryToClaimNextHydratableInstance:function(a){if(H){var d=B;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=Fg;H=!1;y=a;return}b(y,B)}a.stateNode=d;y=a;B=k(d)}else a.effectTag|=Fg,H=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=p(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return x(a.stateNode,a.memoizedProps,a)},
popHydrationState:function(a){if(a!==y)return!1;if(!H)return d(a),H=!0,!1;var c=a.type;if(a.tag!==Bg||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=B;c;)b(a,c),c=h(c);d(a);B=y?h(a.stateNode):null;return!0}}}
var Ig=R.popContextProvider,Jg=xd.reset,Kg=Qa.ReactCurrentOwner,Lg=de.createWorkInProgress,Mg=de.largerPriority,Ng=ig.onCommitRoot,T=Q.NoWork,Og=Q.SynchronousPriority,U=Q.TaskPriority,Pg=Q.HighPriority,Qg=Q.LowPriority,Rg=Q.OffscreenPriority,Sg=Pd.AsyncUpdates,Tg=J.PerformedWork,Ug=J.Placement,Vg=J.Update,Wg=J.PlacementAndUpdate,Xg=J.Deletion,Yg=J.ContentReset,Zg=J.Callback,$g=J.Err,ah=J.Ref,bh=E.HostRoot,ch=E.HostComponent,dh=E.HostPortal,eh=E.ClassComponent,fh=ud.getUpdatePriority,gh=R.resetContext;
function hh(a){function b(){for(;null!==ma&&ma.current.pendingWorkPriority===T;){ma.isScheduled=!1;var a=ma.nextScheduledRoot;ma.nextScheduledRoot=null;if(ma===zb)return zb=ma=null,z=T,null;ma=a}a=ma;for(var b=null,c=T;null!==a;)a.current.pendingWorkPriority!==T&&(c===T||c>a.current.pendingWorkPriority)&&(c=a.current.pendingWorkPriority,b=a),a=a.nextScheduledRoot;null!==b?(z=c,Jg(),gh(),t(),I=Lg(b.current,c),b!==nc&&(oc=0,nc=b)):(z=T,nc=I=null)}function c(c){Hd=!0;na=null;var d=c.stateNode;d.current===
c?w("177"):void 0;z!==Og&&z!==U||oc++;Kg.current=null;if(c.effectTag>Tg)if(null!==c.lastEffect){c.lastEffect.nextEffect=c;var e=c.firstEffect}else e=c;else e=c.firstEffect;Ui();for(u=e;null!==u;){var f=!1,g=void 0;try{for(;null!==u;){var h=u.effectTag;h&Yg&&a.resetTextContent(u.stateNode);if(h&ah){var k=u.alternate;null!==k&&Ph(k)}switch(h&~(Zg|$g|Yg|ah|Tg)){case Ug:q(u);u.effectTag&=~Ug;break;case Wg:q(u);u.effectTag&=~Ug;vf(u.alternate,u);break;case Vg:vf(u.alternate,u);break;case Xg:Id=!0,Mh(u),
Id=!1}u=u.nextEffect}}catch(Jd){f=!0,g=Jd}f&&(null===u?w("178"):void 0,x(u,g),null!==u&&(u=u.nextEffect))}Vi();d.current=c;for(u=e;null!==u;){d=!1;e=void 0;try{for(;null!==u;){var Gd=u.effectTag;Gd&(Vg|Zg)&&Nh(u.alternate,u);Gd&ah&&Oh(u);if(Gd&$g)switch(f=u,g=void 0,null!==P&&(g=P.get(f),P["delete"](f),null==g&&null!==f.alternate&&(f=f.alternate,g=P.get(f),P["delete"](f))),null==g?w("184"):void 0,f.tag){case eh:f.stateNode.componentDidCatch(g.error,{componentStack:g.componentStack});break;case bh:null===
Ja&&(Ja=g.error);break;default:w("157")}var m=u.nextEffect;u.nextEffect=null;u=m}}catch(Jd){d=!0,e=Jd}d&&(null===u?w("178"):void 0,x(u,e),null!==u&&(u=u.nextEffect))}Hd=!1;"function"===typeof Ng&&Ng(c.stateNode);va&&(va.forEach(H),va=null);b()}function d(a){for(;;){var b=Lh(a.alternate,a,z),c=a["return"],d=a.sibling;var e=a;if(!(e.pendingWorkPriority!==T&&e.pendingWorkPriority>z)){for(var f=fh(e),g=e.child;null!==g;)f=Mg(f,g.pendingWorkPriority),g=g.sibling;e.pendingWorkPriority=f}if(null!==b)return b;
null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),a.effectTag>Tg&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{na=a;break}}return null}function e(a){var b=V(a.alternate,a,z);null===b&&(b=d(a));Kg.current=null;return b}function f(a){var b=ld(a.alternate,a,z);null===b&&(b=d(a));Kg.current=null;return b}
function g(a){p(Rg,a)}function h(){if(null!==P&&0<P.size&&z===U)for(;null!==I;){var a=I;I=null!==P&&(P.has(a)||null!==a.alternate&&P.has(a.alternate))?f(I):e(I);if(null===I&&(null===na?w("179"):void 0,O=U,c(na),O=z,null===P||0===P.size||z!==U))break}}function k(a,d){null!==na?(O=U,c(na),h()):null===I&&b();if(!(z===T||z>a)){O=z;a:do{if(z<=U)for(;null!==I&&!(I=e(I),null===I&&(null===na?w("179"):void 0,O=U,c(na),O=z,h(),z===T||z>a||z>U)););else if(null!==d)for(;null!==I&&!Ab;)if(1<d.timeRemaining()){if(I=
e(I),null===I)if(null===na?w("179"):void 0,1<d.timeRemaining()){if(O=U,c(na),O=z,h(),z===T||z>a||z<Pg)break}else Ab=!0}else Ab=!0;switch(z){case Og:case U:if(z<=a)continue a;break a;case Pg:case Qg:case Rg:if(null===d)break a;if(!Ab&&z<=a)continue a;break a;case T:break a;default:w("181")}}while(1)}}function p(a,b){Da?w("182"):void 0;Da=!0;var c=O,d=!1,e=null;try{k(a,b)}catch(Kd){d=!0,e=Kd}for(;d;){if(Ya){Ja=e;break}var h=I;if(null===h)Ya=!0;else{var p=x(h,e);null===p?w("183"):void 0;if(!Ya){try{d=
p;e=a;p=b;for(var q=d;null!==h;){switch(h.tag){case eh:Ig(h);break;case ch:m(h);break;case bh:r(h);break;case dh:r(h)}if(h===q||h.alternate===q)break;h=h["return"]}I=f(d);k(e,p)}catch(Kd){d=!0;e=Kd;continue}break}}}O=c;null!==b&&(Bb=!1);z>U&&!Bb&&($f(g),Bb=!0);a=Ja;Ya=Ab=Da=!1;nc=Ka=P=Ja=null;oc=0;if(null!==a)throw a;}function x(a,b){var c=Kg.current=null,d=!1,e=!1,f=null;if(a.tag===bh)c=a,S(a)&&(Ya=!0);else for(var g=a["return"];null!==g&&null===c;){g.tag===eh?"function"===typeof g.stateNode.componentDidCatch&&
(d=!0,f=Ra(g),c=g,e=!0):g.tag===bh&&(c=g);if(S(g)){if(Id||null!==va&&(va.has(g)||null!==g.alternate&&va.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===Ka&&(Ka=new Set);Ka.add(c);var h="";g=a;do{a:switch(g.tag){case fe:case ge:case he:case ie:var k=g._debugOwner,m=g._debugSource;var p=Ra(g);var q=null;k&&(q=Ra(k));k=m;p="\n    in "+(p||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":q?" (created by "+q+")":"");break a;default:p=""}h+=p;g=g["return"]}while(g);
g=h;a=Ra(a);null===P&&(P=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};P.set(c,b);try{console.error(b.error)}catch(Wi){console.error(Wi)}Hd?(null===va&&(va=new Set),va.add(c)):H(c);return c}null===Ja&&(Ja=b);return null}function S(a){return null!==Ka&&(Ka.has(a)||null!==a.alternate&&Ka.has(a.alternate))}function D(a,b){return y(a,b,!1)}function y(a,b){oc>Xi&&(Ya=!0,w("185"));!Da&&b<=z&&(I=null);for(var c=
!0;null!==a&&c;){c=!1;if(a.pendingWorkPriority===T||a.pendingWorkPriority>b)c=!0,a.pendingWorkPriority=b;null!==a.alternate&&(a.alternate.pendingWorkPriority===T||a.alternate.pendingWorkPriority>b)&&(c=!0,a.alternate.pendingWorkPriority=b);if(null===a["return"])if(a.tag===bh){var d=a.stateNode;b===T||d.isScheduled||(d.isScheduled=!0,zb?zb.nextScheduledRoot=d:ma=d,zb=d);if(!Da)switch(b){case Og:pc?p(Og,null):p(U,null);break;case U:W?void 0:w("186");break;default:Bb||($f(g),Bb=!0)}}else break;a=a["return"]}}
function B(a,b){var c=O;c===T&&(c=!Yi||a.internalContextTag&Sg||b?Qg:Og);return c===Og&&(Da||W)?U:c}function H(a){y(a,U,!0)}var C=Ag(a),Ca=Hg(a),r=C.popHostContainer,m=C.popHostContext,t=C.resetHostContainer,v=Lf(a,C,Ca,D,B),V=v.beginWork,ld=v.beginFailedWork,Lh=eg(a,C,Ca).completeWork;C=vg(a,x);var q=C.commitPlacement,Mh=C.commitDeletion,vf=C.commitWork,Nh=C.commitLifeCycles,Oh=C.commitAttachRef,Ph=C.commitDetachRef,$f=a.scheduleDeferredCallback,Yi=a.useSyncScheduling,Ui=a.prepareForCommit,Vi=a.resetAfterCommit,
O=T,Da=!1,Ab=!1,W=!1,pc=!1,I=null,z=T,u=null,na=null,ma=null,zb=null,Bb=!1,P=null,Ka=null,va=null,Ja=null,Ya=!1,Hd=!1,Id=!1,Xi=1E3,oc=0,nc=null;return{scheduleUpdate:D,getPriorityContext:B,batchedUpdates:function(a,b){var c=W;W=!0;try{return a(b)}finally{W=c,Da||W||p(U,null)}},unbatchedUpdates:function(a){var b=pc,c=W;pc=W;W=!1;try{return a()}finally{W=c,pc=b}},flushSync:function(a){var b=W,c=O;W=!0;O=Og;try{return a()}finally{W=b,O=c,Da?w("187"):void 0,p(U,null)}},deferredUpdates:function(a){var b=
O;O=Qg;try{return a()}finally{O=b}}}}function ih(){w("196")}function jh(a){if(!a)return da;a=Pa.get(a);return"number"===typeof a.tag?ih(a):a._processChildContext(a._context)}jh._injectFiber=function(a){ih=a};var kh=ud.addTopLevelUpdate,lh=R.findCurrentUnmaskedContext,mh=R.isContextProvider,nh=R.processChildContext,oh=E.HostComponent,ph=bb.findCurrentHostFiber,qh=bb.findCurrentHostFiberWithNoPortals;jh._injectFiber(function(a){var b=lh(a);return mh(a)?nh(a,b,!1):b});var rh=F.TEXT_NODE;
function sh(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function th(a,b){var c=sh(a);a=0;for(var d;c;){if(c.nodeType===rh){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=sh(c)}}var uh=null;function vh(){!uh&&l.canUseDOM&&(uh="textContent"in document.documentElement?"textContent":"innerText");return uh}
var wh={getOffsets:function(a){var b=window.getSelection&&window.getSelection();if(!b||0===b.rangeCount)return null;var c=b.anchorNode,d=b.anchorOffset,e=b.focusNode,f=b.focusOffset,g=b.getRangeAt(0);try{g.startContainer.nodeType,g.endContainer.nodeType}catch(k){return null}b=b.anchorNode===b.focusNode&&b.anchorOffset===b.focusOffset?0:g.toString().length;var h=g.cloneRange();h.selectNodeContents(a);h.setEnd(g.startContainer,g.startOffset);a=h.startContainer===h.endContainer&&h.startOffset===h.endOffset?
0:h.toString().length;g=a+b;b=document.createRange();b.setStart(c,d);b.setEnd(e,f);c=b.collapsed;return{start:c?g:a,end:c?a:g}},setOffsets:function(a,b){if(window.getSelection){var c=window.getSelection(),d=a[vh()].length,e=Math.min(b.start,d);b=void 0===b.end?e:Math.min(b.end,d);!c.extend&&e>b&&(d=b,b=e,e=d);d=th(a,e);a=th(a,b);if(d&&a){var f=document.createRange();f.setStart(d.node,d.offset);c.removeAllRanges();e>b?(c.addRange(f),c.extend(a.node,a.offset)):(f.setEnd(a.node,a.offset),c.addRange(f))}}}},
xh=F.ELEMENT_NODE,yh={hasSelectionCapabilities:function(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)},getSelectionInformation:function(){var a=ia();return{focusedElem:a,selectionRange:yh.hasSelectionCapabilities(a)?yh.getSelection(a):null}},restoreSelection:function(a){var b=ia(),c=a.focusedElem;a=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){yh.hasSelectionCapabilities(c)&&yh.setSelection(c,a);b=
[];for(a=c;a=a.parentNode;)a.nodeType===xh&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ha(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}},getSelection:function(a){return("selectionStart"in a?{start:a.selectionStart,end:a.selectionEnd}:wh.getOffsets(a))||{start:0,end:0}},setSelection:function(a,b){var c=b.start,d=b.end;void 0===d&&(d=c);"selectionStart"in a?(a.selectionStart=c,a.selectionEnd=Math.min(d,a.value.length)):wh.setOffsets(a,b)}},zh=yh,
Ah=F.ELEMENT_NODE;function Bh(){w("211")}function Ch(){w("212")}function Dh(a){if(null==a)return null;if(a.nodeType===Ah)return a;var b=Pa.get(a);if(b)return"number"===typeof b.tag?Bh(b):Ch(b);"function"===typeof a.render?w("188"):w("213",Object.keys(a))}Dh._injectFiber=function(a){Bh=a};Dh._injectStack=function(a){Ch=a};var Eh=E.HostComponent;function Fh(a){if(void 0!==a._hostParent)return a._hostParent;if("number"===typeof a.tag){do a=a["return"];while(a&&a.tag!==Eh);if(a)return a}return null}
function Gh(a,b){for(var c=0,d=a;d;d=Fh(d))c++;d=0;for(var e=b;e;e=Fh(e))d++;for(;0<c-d;)a=Fh(a),c--;for(;0<d-c;)b=Fh(b),d--;for(;c--;){if(a===b||a===b.alternate)return a;a=Fh(a);b=Fh(b)}return null}
var Hh={isAncestor:function(a,b){for(;b;){if(a===b||a===b.alternate)return!0;b=Fh(b)}return!1},getLowestCommonAncestor:Gh,getParentInstance:function(a){return Fh(a)},traverseTwoPhase:function(a,b,c){for(var d=[];a;)d.push(a),a=Fh(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)},traverseEnterLeave:function(a,b,c,d,e){for(var f=a&&b?Gh(a,b):null,g=[];a&&a!==f;)g.push(a),a=Fh(a);for(a=[];b&&b!==f;)a.push(b),b=Fh(b);for(b=0;b<g.length;b++)c(g[b],"bubbled",d);for(b=
a.length;0<b--;)c(a[b],"captured",e)}},Ih=Jb.getListener;function Jh(a,b,c){if(b=Ih(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Cb(c._dispatchListeners,b),c._dispatchInstances=Cb(c._dispatchInstances,a)}function Kh(a){a&&a.dispatchConfig.phasedRegistrationNames&&Hh.traverseTwoPhase(a._targetInst,Jh,a)}function Qh(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?Hh.getParentInstance(b):null;Hh.traverseTwoPhase(b,Jh,a)}}
function Rh(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ih(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Cb(c._dispatchListeners,b),c._dispatchInstances=Cb(c._dispatchInstances,a))}function Sh(a){a&&a.dispatchConfig.registrationName&&Rh(a._targetInst,null,a)}
var Th={accumulateTwoPhaseDispatches:function(a){Db(a,Kh)},accumulateTwoPhaseDispatchesSkipTarget:function(a){Db(a,Qh)},accumulateDirectDispatches:function(a){Db(a,Sh)},accumulateEnterLeaveDispatches:function(a,b,c,d){Hh.traverseEnterLeave(c,d,Rh,a,b)}},X={_root:null,_startText:null,_fallbackText:null},Uh={initialize:function(a){X._root=a;X._startText=Uh.getText();return!0},reset:function(){X._root=null;X._startText=null;X._fallbackText=null},getData:function(){if(X._fallbackText)return X._fallbackText;
var a,b=X._startText,c=b.length,d,e=Uh.getText(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);X._fallbackText=e.slice(a,1<d?1-d:void 0);return X._fallbackText},getText:function(){return"value"in X._root?X._root.value:X._root[vh()]}},Vh=Uh,Wh="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Xh={type:null,target:null,currentTarget:ca.thatReturnsNull,eventPhase:null,bubbles:null,
cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function Y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?ca.thatReturnsTrue:ca.thatReturnsFalse;this.isPropagationStopped=ca.thatReturnsFalse;return this}
n(Y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=ca.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=ca.thatReturnsTrue)},persist:function(){this.isPersistent=ca.thatReturnsTrue},isPersistent:ca.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Wh.length;a++)this[Wh[a]]=null}});Y.Interface=Xh;Y.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;n(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=n({},this.Interface,b);a.augmentClass=this.augmentClass;Yh(a)};Yh(Y);function Zh(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function $h(a){a instanceof this?void 0:w("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Yh(a){a.eventPool=[];a.getPooled=Zh;a.release=$h}function ai(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(ai,{data:null});function bi(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(bi,{data:null});var ci=[9,13,27,32],di=l.canUseDOM&&"CompositionEvent"in window,ei=null;l.canUseDOM&&"documentMode"in document&&(ei=document.documentMode);var fi;
if(fi=l.canUseDOM&&"TextEvent"in window&&!ei){var gi=window.opera;fi=!("object"===typeof gi&&"function"===typeof gi.version&&12>=parseInt(gi.version(),10))}
var hi=fi,ii=l.canUseDOM&&(!di||ei&&8<ei&&11>=ei),ji=String.fromCharCode(32),ki={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},li=!1;
function mi(a,b){switch(a){case "topKeyUp":return-1!==ci.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ni(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var oi=!1;function pi(a,b){switch(a){case "topCompositionEnd":return ni(b);case "topKeyPress":if(32!==b.which)return null;li=!0;return ji;case "topTextInput":return a=b.data,a===ji&&li?null:a;default:return null}}
function qi(a,b){if(oi)return"topCompositionEnd"===a||!di&&mi(a,b)?(a=Vh.getData(),Vh.reset(),oi=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return ii?null:b.data;default:return null}}
var ri={eventTypes:ki,extractEvents:function(a,b,c,d){var e;if(di)b:{switch(a){case "topCompositionStart":var f=ki.compositionStart;break b;case "topCompositionEnd":f=ki.compositionEnd;break b;case "topCompositionUpdate":f=ki.compositionUpdate;break b}f=void 0}else oi?mi(a,c)&&(f=ki.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=ki.compositionStart);f?(ii&&(oi||f!==ki.compositionStart?f===ki.compositionEnd&&oi&&(e=Vh.getData()):oi=Vh.initialize(d)),f=ai.getPooled(f,b,c,d),e?f.data=e:(e=ni(c),
null!==e&&(f.data=e)),Th.accumulateTwoPhaseDispatches(f),e=f):e=null;(a=hi?pi(a,c):qi(a,c))?(b=bi.getPooled(ki.beforeInput,b,c,d),b.data=a,Th.accumulateTwoPhaseDispatches(b)):b=null;return[e,b]}},si={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function ti(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!si[a.type]:"textarea"===b?!0:!1}
var ui={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function vi(a,b,c){a=Y.getPooled(ui.change,a,b,c);a.type="change";nb.enqueueStateRestore(c);Th.accumulateTwoPhaseDispatches(a);return a}var wi=null,xi=null;function yi(a){Jb.enqueueEvents(a);Jb.processEventQueue(!1)}
function zi(a){var b=G.getNodeFromInstance(a);if(Bc.updateValueIfChanged(b))return a}function Ai(a,b){if("topChange"===a)return b}var Bi=!1;l.canUseDOM&&(Bi=Lb("input")&&(!document.documentMode||9<document.documentMode));function Ci(){wi&&(wi.detachEvent("onpropertychange",Di),xi=wi=null)}function Di(a){"value"===a.propertyName&&zi(xi)&&(a=vi(xi,a,ub(a)),sb.batchedUpdates(yi,a))}function Ei(a,b,c){"topFocus"===a?(Ci(),wi=b,xi=c,wi.attachEvent("onpropertychange",Di)):"topBlur"===a&&Ci()}
function Fi(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return zi(xi)}function Gi(a,b){if("topClick"===a)return zi(b)}function Hi(a,b){if("topInput"===a||"topChange"===a)return zi(b)}
var Ii={eventTypes:ui,_isInputEventSupported:Bi,extractEvents:function(a,b,c,d){var e=b?G.getNodeFromInstance(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ai;else if(ti(e))if(Bi)g=Hi;else{g=Fi;var h=Ei}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Gi);if(g&&(g=g(a,b)))return vi(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,
e.getAttribute("value")!==a&&e.setAttribute("value",a))}};function Ji(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(Ji,{view:function(a){if(a.view)return a.view;a=ub(a);return a.window===a?a:(a=a.ownerDocument)?a.defaultView||a.parentWindow:window},detail:function(a){return a.detail||0}});var Ki={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Li(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Ki[a])?!!b[a]:!1}function Mi(){return Li}
function Ni(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(Ni,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Mi,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var Oi={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},Pi={eventTypes:Oi,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?G.getClosestInstanceFromNode(b):
null):a=null;if(a===b)return null;var f=null==a?e:G.getNodeFromInstance(a);e=null==b?e:G.getNodeFromInstance(b);var g=Ni.getPooled(Oi.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=Ni.getPooled(Oi.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Th.accumulateEnterLeaveDispatches(g,c,a,b);return[g,c]}},Qi=F.DOCUMENT_NODE,Ri=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Si={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},
dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Ti=null,Zi=null,$i=null,aj=!1,bj=M.isListeningToAllDependencies;
function cj(a,b){if(aj||null==Ti||Ti!==ia())return null;var c=Ti;"selectionStart"in c&&zh.hasSelectionCapabilities(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return $i&&ea($i,c)?null:($i=c,a=Y.getPooled(Si.select,Zi,a,b),a.type="select",a.target=Ti,Th.accumulateTwoPhaseDispatches(a),a)}
var dj={eventTypes:Si,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:d.nodeType===Qi?d:d.ownerDocument;if(!e||!bj("onSelect",e))return null;e=b?G.getNodeFromInstance(b):window;switch(a){case "topFocus":if(ti(e)||"true"===e.contentEditable)Ti=e,Zi=b,$i=null;break;case "topBlur":$i=Zi=Ti=null;break;case "topMouseDown":aj=!0;break;case "topContextMenu":case "topMouseUp":return aj=!1,cj(c,d);case "topSelectionChange":if(Ri)break;case "topKeyDown":case "topKeyUp":return cj(c,d)}return null}};
function ej(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(ej,{animationName:null,elapsedTime:null,pseudoElement:null});function fj(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(fj,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function gj(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(gj,{relatedTarget:null});function hj(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var ij={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},jj={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function kj(a,b,c,d){return Y.call(this,a,b,c,d)}
Ji.augmentClass(kj,{key:function(a){if(a.key){var b=ij[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=hj(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?jj[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Mi,charCode:function(a){return"keypress"===a.type?hj(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?hj(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function lj(a,b,c,d){return Y.call(this,a,b,c,d)}Ni.augmentClass(lj,{dataTransfer:null});function mj(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(mj,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Mi});function nj(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(nj,{propertyName:null,elapsedTime:null,pseudoElement:null});
function oj(a,b,c,d){return Y.call(this,a,b,c,d)}Ni.augmentClass(oj,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var pj={},qj={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};pj[a]=c;qj[b]=c});
var rj={eventTypes:pj,extractEvents:function(a,b,c,d){var e=qj[a];if(!e)return null;switch(a){case "topAbort":case "topCancel":case "topCanPlay":case "topCanPlayThrough":case "topClose":case "topDurationChange":case "topEmptied":case "topEncrypted":case "topEnded":case "topError":case "topInput":case "topInvalid":case "topLoad":case "topLoadedData":case "topLoadedMetadata":case "topLoadStart":case "topPause":case "topPlay":case "topPlaying":case "topProgress":case "topRateChange":case "topReset":case "topSeeked":case "topSeeking":case "topStalled":case "topSubmit":case "topSuspend":case "topTimeUpdate":case "topToggle":case "topVolumeChange":case "topWaiting":var f=Y;
break;case "topKeyPress":if(0===hj(c))return null;case "topKeyDown":case "topKeyUp":f=kj;break;case "topBlur":case "topFocus":f=gj;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":f=Ni;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":f=lj;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":f=
mj;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":f=ej;break;case "topTransitionEnd":f=nj;break;case "topScroll":f=Ji;break;case "topWheel":f=oj;break;case "topCopy":case "topCut":case "topPaste":f=fj}f?void 0:w("86",a);a=f.getPooled(e,b,c,d);Th.accumulateTwoPhaseDispatches(a);return a}};L.setHandleTopLevel(M.handleTopLevel);Jb.injection.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ib.injection.injectComponentTree(G);Jb.injection.injectEventPluginsByName({SimpleEventPlugin:rj,EnterLeaveEventPlugin:Pi,ChangeEventPlugin:Ii,SelectEventPlugin:dj,BeforeInputEventPlugin:ri});
var sj=A.injection.MUST_USE_PROPERTY,Z=A.injection.HAS_BOOLEAN_VALUE,tj=A.injection.HAS_NUMERIC_VALUE,uj=A.injection.HAS_POSITIVE_NUMERIC_VALUE,vj=A.injection.HAS_STRING_BOOLEAN_VALUE,wj={Properties:{allowFullScreen:Z,allowTransparency:vj,async:Z,autoPlay:Z,capture:Z,checked:sj|Z,cols:uj,contentEditable:vj,controls:Z,"default":Z,defer:Z,disabled:Z,download:A.injection.HAS_OVERLOADED_BOOLEAN_VALUE,draggable:vj,formNoValidate:Z,hidden:Z,loop:Z,multiple:sj|Z,muted:sj|Z,noValidate:Z,open:Z,playsInline:Z,
readOnly:Z,required:Z,reversed:Z,rows:uj,rowSpan:tj,scoped:Z,seamless:Z,selected:sj|Z,size:uj,start:tj,span:uj,spellCheck:vj,style:0,itemScope:Z,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:vj},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&
a.ownerDocument.activeElement!==a&&a.setAttribute("value",""+b)}}},xj=A.injection.HAS_STRING_BOOLEAN_VALUE,yj={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},zj={Properties:{autoReverse:xj,externalResourcesRequired:xj,preserveAlpha:xj},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:yj.xlink,xlinkArcrole:yj.xlink,xlinkHref:yj.xlink,xlinkRole:yj.xlink,
xlinkShow:yj.xlink,xlinkTitle:yj.xlink,xlinkType:yj.xlink,xmlBase:yj.xml,xmlLang:yj.xml,xmlSpace:yj.xml}},Aj=/[\-\:]([a-z])/g;function Bj(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Aj,
Bj);zj.Properties[b]=0;zj.DOMAttributeNames[b]=a});A.injection.injectDOMPropertyConfig(wj);A.injection.injectDOMPropertyConfig(zj);
var Cj=ig.injectInternals,Dj=F.ELEMENT_NODE,Ej=F.TEXT_NODE,Fj=F.COMMENT_NODE,Gj=F.DOCUMENT_NODE,Hj=F.DOCUMENT_FRAGMENT_NODE,Ij=A.ROOT_ATTRIBUTE_NAME,Jj=ka.getChildNamespace,Kj=N.createElement,Lj=N.createTextNode,Mj=N.setInitialProperties,Nj=N.diffProperties,Oj=N.updateProperties,Pj=N.diffHydratedProperties,Qj=N.diffHydratedText,Rj=N.warnForDeletedHydratableElement,Sj=N.warnForDeletedHydratableText,Tj=N.warnForInsertedHydratedElement,Uj=N.warnForInsertedHydratedText,Vj=G.precacheFiberNode,Wj=G.updateFiberProps;
nb.injection.injectFiberControlledHostComponent(N);Dh._injectFiber(function(a){return Xj.findHostInstance(a)});var Yj=null,Zj=null;function ak(a){return!(!a||a.nodeType!==Dj&&a.nodeType!==Gj&&a.nodeType!==Hj&&(a.nodeType!==Fj||" react-mount-point-unstable "!==a.nodeValue))}function bk(a){a=a?a.nodeType===Gj?a.documentElement:a.firstChild:null;return!(!a||a.nodeType!==Dj||!a.hasAttribute(Ij))}
var Xj=function(a){var b=a.getPublicInstance;a=hh(a);var c=a.scheduleUpdate,d=a.getPriorityContext;return{createContainer:function(a){var b=ee();a={current:b,containerInfo:a,isScheduled:!1,nextScheduledRoot:null,context:null,pendingContext:null};return b.stateNode=a},updateContainer:function(a,b,g,h){var e=b.current;g=jh(g);null===b.context?b.context=g:b.pendingContext=g;b=h;h=d(e,ed.enableAsyncSubtreeAPI&&null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent);
a={element:a};kh(e,a,void 0===b?null:b,h);c(e,h)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case oh:return b(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:function(a){a=ph(a);return null===a?null:a.stateNode},findHostInstanceWithNoPortals:function(a){a=qh(a);return null===a?null:a.stateNode}}}({getRootHostContext:function(a){if(a.nodeType===
Gj)a=(a=a.documentElement)?a.namespaceURI:Jj(null,"");else{var b=a.nodeType===Fj?a.parentNode:a;a=b.namespaceURI||null;b=b.tagName;a=Jj(a,b)}return a},getChildHostContext:function(a,b){return Jj(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){Yj=M.isEnabled();Zj=zh.getSelectionInformation();M.setEnabled(!1)},resetAfterCommit:function(){zh.restoreSelection(Zj);Zj=null;M.setEnabled(Yj);Yj=null},createInstance:function(a,b,c,d,e){a=Kj(a,b,c,d);Vj(e,a);Wj(a,b);return a},appendInitialChild:function(a,
b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){Mj(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return Nj(a,b,c,d,e)},commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){Wj(a,e);Oj(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&
"string"===typeof b.dangerouslySetInnerHTML.__html},resetTextContent:function(a){a.textContent=""},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=Lj(a,b);Vj(d,a);return a},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){a.nodeType===Fj?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,
b,c){a.nodeType===Fj?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){a.nodeType===Fj?a.parentNode.removeChild(b):a.removeChild(b)},canHydrateInstance:function(a,b){return a.nodeType===Dj&&b===a.nodeName.toLowerCase()},canHydrateTextInstance:function(a,b){return""===b?!1:a.nodeType===Ej},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&a.nodeType!==Dj&&a.nodeType!==Ej;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=
a.firstChild;a&&a.nodeType!==Dj&&a.nodeType!==Ej;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){Vj(f,a);Wj(a,c);return Pj(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){Vj(c,a);return Qj(a,b)},didNotHydrateInstance:function(a,b){1===b.nodeType?Rj(a,b):Sj(a,b)},didNotFindHydratableInstance:function(a,b,c){Tj(a,b,c)},didNotFindHydratableTextInstance:function(a,b){Uj(a,b)},scheduleDeferredCallback:dd.rIC,useSyncScheduling:!0});sb.injection.injectFiberBatchedUpdates(Xj.batchedUpdates);
function ck(a,b,c,d,e){ak(c)?void 0:w("200");var f=c._reactRootContainer;if(f)Xj.updateContainer(b,f,a,e);else{if(!d&&!bk(c))for(d=void 0;d=c.lastChild;)c.removeChild(d);var g=Xj.createContainer(c);f=c._reactRootContainer=g;Xj.unbatchedUpdates(function(){Xj.updateContainer(b,g,a,e)})}return Xj.getPublicRootInstance(f)}function dk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ak(b)?void 0:w("200");return ne.createPortal(a,b,null,c)}
var ek={createPortal:dk,hydrate:function(a,b,c){return ck(null,a,b,!0,c)},render:function(a,b,c){return ck(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null!=a&&Pa.has(a)?void 0:w("38");return ck(a,b,c,!1,d)},unmountComponentAtNode:function(a){ak(a)?void 0:w("40");return a._reactRootContainer?(Xj.unbatchedUpdates(function(){ck(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},findDOMNode:Dh,unstable_createPortal:dk,unstable_batchedUpdates:sb.batchedUpdates,
unstable_deferredUpdates:Xj.deferredUpdates,flushSync:Xj.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Jb,EventPluginRegistry:sa,EventPropagators:Th,ReactControlledComponent:nb,ReactDOMComponentTree:G,ReactDOMEventListener:L}};Cj({findFiberByHostInstance:G.getClosestInstanceFromNode,findHostInstanceByFiber:Xj.findHostInstance,bundleType:0,version:"16.0.0",rendererPackageName:"react-dom"});module.exports=ek;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 React v16.0.0
 react.production.min.js

 Copyright (c) 2013-present, Facebook, Inc.

 This source code is licensed under the MIT license found in the
 LICENSE file in the root directory of this source tree.
*/
var f=__webpack_require__(51),p=__webpack_require__(86);__webpack_require__(8);var r=__webpack_require__(27);
function t(a){for(var b=arguments.length-1,d="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,e=0;e<b;e++)d+="\x26args[]\x3d"+encodeURIComponent(arguments[e+1]);b=Error(d+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var u={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function v(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}v.prototype.isReactComponent={};v.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?t("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};v.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function w(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}function x(){}x.prototype=v.prototype;var y=w.prototype=new x;y.constructor=w;f(y,v.prototype);y.isPureReactComponent=!0;function z(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}var A=z.prototype=new x;A.constructor=z;f(A,v.prototype);A.unstable_isAsyncReactComponent=!0;A.render=function(){return this.props.children};
var B={Component:v,PureComponent:w,AsyncComponent:z},C={current:null},D=Object.prototype.hasOwnProperty,E="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103,F={key:!0,ref:!0,__self:!0,__source:!0};function G(a,b,d,e,c,g,k){return{$$typeof:E,type:a,key:b,ref:d,props:k,_owner:g}}
G.createElement=function(a,b,d){var e,c={},g=null,k=null,m=null,q=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),m=void 0===b.__self?null:b.__self,q=void 0===b.__source?null:b.__source,b)D.call(b,e)&&!F.hasOwnProperty(e)&&(c[e]=b[e]);var l=arguments.length-2;if(1===l)c.children=d;else if(1<l){for(var h=Array(l),n=0;n<l;n++)h[n]=arguments[n+2];c.children=h}if(a&&a.defaultProps)for(e in l=a.defaultProps,l)void 0===c[e]&&(c[e]=l[e]);return G(a,g,k,m,q,C.current,c)};
G.createFactory=function(a){var b=G.createElement.bind(null,a);b.type=a;return b};G.cloneAndReplaceKey=function(a,b){return G(a.type,b,a.ref,a._self,a._source,a._owner,a.props)};
G.cloneElement=function(a,b,d){var e=f({},a.props),c=a.key,g=a.ref,k=a._self,m=a._source,q=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,q=C.current);void 0!==b.key&&(c=""+b.key);if(a.type&&a.type.defaultProps)var l=a.type.defaultProps;for(h in b)D.call(b,h)&&!F.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==l?l[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=d;else if(1<h){l=Array(h);for(var n=0;n<h;n++)l[n]=arguments[n+2];e.children=l}return G(a.type,c,g,k,m,q,e)};
G.isValidElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===E};var H="function"===typeof Symbol&&Symbol.iterator,I="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103;function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var J=/\/+/g,K=[];
function L(a,b,d,e){if(K.length){var c=K.pop();c.result=a;c.keyPrefix=b;c.func=d;c.context=e;c.count=0;return c}return{result:a,keyPrefix:b,func:d,context:e,count:0}}function M(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>K.length&&K.push(a)}
function N(a,b,d,e){var c=typeof a;if("undefined"===c||"boolean"===c)a=null;if(null===a||"string"===c||"number"===c||"object"===c&&a.$$typeof===I)return d(e,a,""===b?"."+O(a,0):b),1;var g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){c=a[k];var m=b+O(c,k);g+=N(c,m,d,e)}else if(m=H&&a[H]||a["@@iterator"],"function"===typeof m)for(a=m.call(a),k=0;!(c=a.next()).done;)c=c.value,m=b+O(c,k++),g+=N(c,m,d,e);else"object"===c&&(d=""+a,t("31","[object Object]"===d?"object with keys {"+
Object.keys(a).join(", ")+"}":d,""));return g}function O(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function P(a,b){a.func.call(a.context,b,a.count++)}function Q(a,b,d){var e=a.result,c=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?R(a,e,d,r.thatReturnsArgument):null!=a&&(G.isValidElement(a)&&(a=G.cloneAndReplaceKey(a,c+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(J,"$\x26/")+"/")+d)),e.push(a))}
function R(a,b,d,e,c){var g="";null!=d&&(g=(""+d).replace(J,"$\x26/")+"/");b=L(b,g,e,c);null==a||N(a,"",Q,b);M(b)}var S={forEach:function(a,b,d){if(null==a)return a;b=L(null,null,b,d);null==a||N(a,"",P,b);M(b)},map:function(a,b,d){if(null==a)return a;var e=[];R(a,e,null,b,d);return e},count:function(a){return null==a?0:N(a,"",r.thatReturnsNull,null)},toArray:function(a){var b=[];R(a,b,null,r.thatReturnsArgument);return b}};
module.exports={Children:{map:S.map,forEach:S.forEach,count:S.count,toArray:S.toArray,only:function(a){G.isValidElement(a)?void 0:t("143");return a}},Component:B.Component,PureComponent:B.PureComponent,unstable_AsyncComponent:B.AsyncComponent,createElement:G.createElement,cloneElement:G.cloneElement,isValidElement:G.isValidElement,createFactory:G.createFactory,version:"16.0.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:C,assign:f}};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(27);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(271);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(272);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(276);
} else {
  module.exports = require('./cjs/react-dom-unstable-native-dependencies.development.js');
}


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 React v16.0.0
 react-dom-unstable-native-dependencies.production.min.js

 Copyright (c) 2013-present, Facebook, Inc.

 This source code is licensed under the MIT license found in the
 LICENSE file in the root directory of this source tree.
*/
__webpack_require__(8);var g=__webpack_require__(51),k=__webpack_require__(27),aa=__webpack_require__(33);
function m(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var p={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?m("197"):void 0;n=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,h,D,l){n.apply(p,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,h,D,l){p.invokeGuardedCallback.apply(this,arguments);if(p.hasCaughtError()){var J=p.clearCaughtError();p._hasRethrowError||(p._hasRethrowError=!0,p._rethrowError=
J)}},rethrowCaughtError:function(){return ba.apply(p,arguments)},hasCaughtError:function(){return p._hasCaughtError},clearCaughtError:function(){if(p._hasCaughtError){var a=p._caughtError;p._caughtError=null;p._hasCaughtError=!1;return a}m("198")}};function n(a,b,c,d,e,f,h,D,l){p._hasCaughtError=!1;p._caughtError=null;var J=Array.prototype.slice.call(arguments,3);try{b.apply(c,J)}catch(ha){p._caughtError=ha,p._hasCaughtError=!0}}
function ba(){if(p._hasRethrowError){var a=p._rethrowError;p._rethrowError=null;p._hasRethrowError=!1;throw a;}}var ca=p,q;function r(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=t.getNodeFromInstance(d);ca.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
var t={isEndish:function(a){return"topMouseUp"===a||"topTouchEnd"===a||"topTouchCancel"===a},isMoveish:function(a){return"topMouseMove"===a||"topTouchMove"===a},isStartish:function(a){return"topMouseDown"===a||"topTouchStart"===a},executeDirectDispatch:function(a){var b=a._dispatchListeners,c=a._dispatchInstances;Array.isArray(b)?m("103"):void 0;a.currentTarget=b?t.getNodeFromInstance(c):null;b=b?b(a):null;a.currentTarget=null;a._dispatchListeners=null;a._dispatchInstances=null;return b},executeDispatchesInOrder:function(a,
b){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)r(a,b,c[e],d[e]);else c&&r(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null},executeDispatchesInOrderStopAtTrue:function(a){a:{var b=a._dispatchListeners;var c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++){if(b[d](a,c[d])){b=c[d];break a}}else if(b&&b(a,c)){b=c;break a}b=null}a._dispatchInstances=null;a._dispatchListeners=
null;return b},hasDispatches:function(a){return!!a._dispatchListeners},getFiberCurrentPropsFromNode:function(a){return q.getFiberCurrentPropsFromNode(a)},getInstanceFromNode:function(a){return q.getInstanceFromNode(a)},getNodeFromInstance:function(a){return q.getNodeFromInstance(a)},injection:{injectComponentTree:function(a){q=a}}},u=t;
function v(a,b){null==b?m("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function w(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}
function x(a,b,c){switch(a){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":return!(!c.disabled||"button"!==b&&"input"!==b&&"select"!==b&&"textarea"!==b);default:return!1}}function y(a){if(void 0!==a._hostParent)return a._hostParent;if("number"===typeof a.tag){do a=a["return"];while(a&&5!==a.tag);if(a)return a}return null}
function z(a,b){for(var c=0,d=a;d;d=y(d))c++;d=0;for(var e=b;e;e=y(e))d++;for(;0<c-d;)a=y(a),c--;for(;0<d-c;)b=y(b),d--;for(;c--;){if(a===b||a===b.alternate)return a;a=y(a);b=y(b)}return null}
var A={isAncestor:function(a,b){for(;b;){if(a===b||a===b.alternate)return!0;b=y(b)}return!1},getLowestCommonAncestor:z,getParentInstance:function(a){return y(a)},traverseTwoPhase:function(a,b,c){for(var d=[];a;)d.push(a),a=y(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)},traverseEnterLeave:function(a,b,c,d,e){for(var f=a&&b?z(a,b):null,h=[];a&&a!==f;)h.push(a),a=y(a);for(a=[];b&&b!==f;)a.push(b),b=y(b);for(b=0;b<h.length;b++)c(h[b],"bubbled",d);for(b=a.length;0<
b--;)c(a[b],"captured",e)}};function B(a,b){if("number"===typeof a.tag){var c=a.stateNode;if(!c)return null;var d=u.getFiberCurrentPropsFromNode(c);if(!d)return null;c=d[b];if(x(b,a.type,d))return null}else{d=a._currentElement;if("string"===typeof d||"number"===typeof d||!a._rootNodeID)return null;a=d.props;c=a[b];if(x(b,d.type,a))return null}c&&"function"!==typeof c?m("231",b,typeof c):void 0;return c}
function C(a,b,c){if(b=B(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=v(c._dispatchListeners,b),c._dispatchInstances=v(c._dispatchInstances,a)}function da(a){a&&a.dispatchConfig.phasedRegistrationNames&&A.traverseTwoPhase(a._targetInst,C,a)}function ea(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?A.getParentInstance(b):null;A.traverseTwoPhase(b,C,a)}}
function E(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=B(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=v(c._dispatchListeners,b),c._dispatchInstances=v(c._dispatchInstances,a))}function fa(a){a&&a.dispatchConfig.registrationName&&E(a._targetInst,null,a)}
var F={accumulateTwoPhaseDispatches:function(a){w(a,da)},accumulateTwoPhaseDispatchesSkipTarget:function(a){w(a,ea)},accumulateDirectDispatches:function(a){w(a,fa)},accumulateEnterLeaveDispatches:function(a,b,c,d){A.traverseEnterLeave(c,d,E,a,b)}},G="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),ia={type:null,target:null,currentTarget:k.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||
Date.now()},defaultPrevented:null,isTrusted:null};function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?k.thatReturnsTrue:k.thatReturnsFalse;this.isPropagationStopped=k.thatReturnsFalse;return this}
g(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=k.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=k.thatReturnsTrue)},persist:function(){this.isPersistent=k.thatReturnsTrue},isPersistent:k.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<G.length;a++)this[G[a]]=null}});H.Interface=ia;H.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;g(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=g({},this.Interface,b);a.augmentClass=this.augmentClass;I(a)};I(H);function ja(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function ka(a){a instanceof this?void 0:m("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function I(a){a.eventPool=[];a.getPooled=ja;a.release=ka}function K(a,b,c,d){return H.call(this,a,b,c,d)}H.augmentClass(K,{touchHistory:function(){return null}});var la=u.isEndish,ma=u.isMoveish,na=u.isStartish,L=[],M={touchBank:L,numberActiveTouches:0,indexOfSingleActiveTouch:-1,mostRecentTimeStamp:0};function N(a){return a.timeStamp||a.timestamp}
function O(a){a=a.identifier;null==a?m("138"):void 0;return a}
function oa(a){var b=O(a),c=L[b];c?(c.touchActive=!0,c.startPageX=a.pageX,c.startPageY=a.pageY,c.startTimeStamp=N(a),c.currentPageX=a.pageX,c.currentPageY=a.pageY,c.currentTimeStamp=N(a),c.previousPageX=a.pageX,c.previousPageY=a.pageY,c.previousTimeStamp=N(a)):(c={touchActive:!0,startPageX:a.pageX,startPageY:a.pageY,startTimeStamp:N(a),currentPageX:a.pageX,currentPageY:a.pageY,currentTimeStamp:N(a),previousPageX:a.pageX,previousPageY:a.pageY,previousTimeStamp:N(a)},L[b]=c);M.mostRecentTimeStamp=N(a)}
function pa(a){var b=L[O(a)];b?(b.touchActive=!0,b.previousPageX=b.currentPageX,b.previousPageY=b.currentPageY,b.previousTimeStamp=b.currentTimeStamp,b.currentPageX=a.pageX,b.currentPageY=a.pageY,b.currentTimeStamp=N(a),M.mostRecentTimeStamp=N(a)):console.error("Cannot record touch move without a touch start.\nTouch Move: %s\n","Touch Bank: %s",P(a),qa())}
function ra(a){var b=L[O(a)];b?(b.touchActive=!1,b.previousPageX=b.currentPageX,b.previousPageY=b.currentPageY,b.previousTimeStamp=b.currentTimeStamp,b.currentPageX=a.pageX,b.currentPageY=a.pageY,b.currentTimeStamp=N(a),M.mostRecentTimeStamp=N(a)):console.error("Cannot record touch end without a touch start.\nTouch End: %s\n","Touch Bank: %s",P(a),qa())}function P(a){return JSON.stringify({identifier:a.identifier,pageX:a.pageX,pageY:a.pageY,timestamp:N(a)})}
function qa(){var a=JSON.stringify(L.slice(0,20));20<L.length&&(a+=" (original size: "+L.length+")");return a}
var Q={recordTouchTrack:function(a,b){if(ma(a))b.changedTouches.forEach(pa);else if(na(a))b.changedTouches.forEach(oa),M.numberActiveTouches=b.touches.length,1===M.numberActiveTouches&&(M.indexOfSingleActiveTouch=b.touches[0].identifier);else if(la(a)&&(b.changedTouches.forEach(ra),M.numberActiveTouches=b.touches.length,1===M.numberActiveTouches))for(a=0;a<L.length;a++)if(b=L[a],null!=b&&b.touchActive){M.indexOfSingleActiveTouch=a;break}},touchHistory:M};
function R(a,b){null==b?m("29"):void 0;return null==a?b:Array.isArray(a)?a.concat(b):Array.isArray(b)?[a].concat(b):[a,b]}var S=u.isStartish,T=u.isMoveish,U=u.isEndish,sa=u.executeDirectDispatch,ta=u.hasDispatches,ua=u.executeDispatchesInOrderStopAtTrue,V=null,W=0,va=0;function X(a,b){var c=V;V=a;if(null!==Y.GlobalResponderHandler)Y.GlobalResponderHandler.onChange(c,a,b)}
var Z={startShouldSetResponder:{phasedRegistrationNames:{bubbled:"onStartShouldSetResponder",captured:"onStartShouldSetResponderCapture"}},scrollShouldSetResponder:{phasedRegistrationNames:{bubbled:"onScrollShouldSetResponder",captured:"onScrollShouldSetResponderCapture"}},selectionChangeShouldSetResponder:{phasedRegistrationNames:{bubbled:"onSelectionChangeShouldSetResponder",captured:"onSelectionChangeShouldSetResponderCapture"}},moveShouldSetResponder:{phasedRegistrationNames:{bubbled:"onMoveShouldSetResponder",
captured:"onMoveShouldSetResponderCapture"}},responderStart:{registrationName:"onResponderStart"},responderMove:{registrationName:"onResponderMove"},responderEnd:{registrationName:"onResponderEnd"},responderRelease:{registrationName:"onResponderRelease"},responderTerminationRequest:{registrationName:"onResponderTerminationRequest"},responderGrant:{registrationName:"onResponderGrant"},responderReject:{registrationName:"onResponderReject"},responderTerminate:{registrationName:"onResponderTerminate"}},
Y={_getResponder:function(){return V},eventTypes:Z,extractEvents:function(a,b,c,d){if(S(a))W+=1;else if(U(a))if(0<=W)--W;else return console.error("Ended a touch event which was not counted in `trackedTouchCount`."),null;Q.recordTouchTrack(a,c);if(b&&("topScroll"===a&&!c.responderIgnoreScroll||0<W&&"topSelectionChange"===a||S(a)||T(a))){var e=S(a)?Z.startShouldSetResponder:T(a)?Z.moveShouldSetResponder:"topSelectionChange"===a?Z.selectionChangeShouldSetResponder:Z.scrollShouldSetResponder,f=V?A.getLowestCommonAncestor(V,
b):b;b=f===V;f=K.getPooled(e,f,c,d);f.touchHistory=Q.touchHistory;b?F.accumulateTwoPhaseDispatchesSkipTarget(f):F.accumulateTwoPhaseDispatches(f);e=ua(f);f.isPersistent()||f.constructor.release(f);if(e&&e!==V)if(b=K.getPooled(Z.responderGrant,e,c,d),b.touchHistory=Q.touchHistory,F.accumulateDirectDispatches(b),f=!0===sa(b),V){var h=K.getPooled(Z.responderTerminationRequest,V,c,d);h.touchHistory=Q.touchHistory;F.accumulateDirectDispatches(h);var D=!ta(h)||sa(h);h.isPersistent()||h.constructor.release(h);
if(D){h=K.getPooled(Z.responderTerminate,V,c,d);h.touchHistory=Q.touchHistory;F.accumulateDirectDispatches(h);var l=R(l,[b,h]);X(e,f)}else e=K.getPooled(Z.responderReject,e,c,d),e.touchHistory=Q.touchHistory,F.accumulateDirectDispatches(e),l=R(l,e)}else l=R(l,b),X(e,f);else l=null}else l=null;e=V&&S(a);b=V&&T(a);f=V&&U(a);if(e=e?Z.responderStart:b?Z.responderMove:f?Z.responderEnd:null)e=K.getPooled(e,V,c,d),e.touchHistory=Q.touchHistory,F.accumulateDirectDispatches(e),l=R(l,e);e=V&&"topTouchCancel"===
a;if(a=V&&!e&&U(a))a:{if((a=c.touches)&&0!==a.length)for(b=0;b<a.length;b++)if(f=a[b].target,null!==f&&void 0!==f&&0!==f&&(f=u.getInstanceFromNode(f),A.isAncestor(V,f))){a=!1;break a}a=!0}if(a=e?Z.responderTerminate:a?Z.responderRelease:null)c=K.getPooled(a,V,c,d),c.touchHistory=Q.touchHistory,F.accumulateDirectDispatches(c),l=R(l,c),X(null);c=Q.touchHistory.numberActiveTouches;if(Y.GlobalInteractionHandler&&c!==va)Y.GlobalInteractionHandler.onChange(c);va=c;return l},GlobalResponderHandler:null,
GlobalInteractionHandler:null,injection:{injectGlobalResponderHandler:function(a){Y.GlobalResponderHandler=a},injectGlobalInteractionHandler:function(a){Y.GlobalInteractionHandler=a}}},wa={injectComponentTree:u.injection.injectComponentTree,ResponderEventPlugin:Y,ResponderTouchHistoryStore:Q};wa.injectComponentTree(aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactDOMComponentTree);module.exports=wa;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _propsToAriaRole=__webpack_require__(88);var _propsToAriaRole2=_interopRequireDefault(_propsToAriaRole);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var roleComponents={article:'article',banner:'header',complementary:'aside',contentinfo:'footer',form:'form',label:'label',link:'a',list:'ul',listitem:'li',main:'main',navigation:'nav',region:'section'};var emptyObject={};var propsToAccessibilityComponent=function propsToAccessibilityComponent(){var props=arguments.length>0&&arguments[0]!==undefined?arguments[0]:emptyObject;var role=(0,_propsToAriaRole2.default)(props);if(role){if(role==='heading'){var level=props['aria-level']||1;return'h'+level;}return roleComponents[role];}};exports.default=propsToAccessibilityComponent;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _isDisabled=__webpack_require__(145);var _isDisabled2=_interopRequireDefault(_isDisabled);var _propsToAriaRole=__webpack_require__(88);var _propsToAriaRole2=_interopRequireDefault(_propsToAriaRole);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var propsToTabIndex=function propsToTabIndex(props){var role=(0,_propsToAriaRole2.default)(props);var focusable=!(0,_isDisabled2.default)(props)&&props.importantForAccessibility!=='no'&&props.importantForAccessibility!=='no-hide-descendants';if(role==='link'){if(props.accessible===false||!focusable){return'-1';}}else if(role==='button'){if(props.accessible!==false&&focusable){return'0';}}else{if(props.accessible===true&&focusable){return'0';}}};exports.default=propsToTabIndex;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _ExecutionEnvironment=__webpack_require__(16);var modality=function modality(){if(!_ExecutionEnvironment.canUseDOM){return;}var styleElement=void 0;var hadKeyboardEvent=false;var keyboardThrottleTimeoutID=0;var proto=window.Element.prototype;var matches=proto.matches||proto.mozMatchesSelector||proto.msMatchesSelector||proto.webkitMatchesSelector;var keyboardModalityWhitelist=['input:not([type])','input[type=text]','input[type=search]','input[type=url]','input[type=tel]','input[type=email]','input[type=password]','input[type=number]','input[type=date]','input[type=month]','input[type=week]','input[type=time]','input[type=datetime]','input[type=datetime-local]','textarea','[role=textbox]'].join(',');var initialize=function initialize(){var id='react-native-modality';styleElement=document.getElementById(id);if(!styleElement){var style='<style id="'+id+'">:focus { outline: none; }</style>';document.head.insertAdjacentHTML('afterbegin',style);styleElement=document.getElementById(id);}};var focusTriggersKeyboardModality=function focusTriggersKeyboardModality(el){if(matches){return matches.call(el,keyboardModalityWhitelist)&&matches.call(el,':not([readonly])');}else{return false;}};var addFocusRing=function addFocusRing(){if(styleElement){styleElement.disabled=true;}};var removeFocusRing=function removeFocusRing(){if(styleElement){styleElement.disabled=false;}};var handleKeyDown=function handleKeyDown(e){hadKeyboardEvent=true;if(keyboardThrottleTimeoutID!==0){clearTimeout(keyboardThrottleTimeoutID);}keyboardThrottleTimeoutID=setTimeout(function(){hadKeyboardEvent=false;keyboardThrottleTimeoutID=0;},100);};var handleFocus=function handleFocus(e){if(hadKeyboardEvent||focusTriggersKeyboardModality(e.target)){addFocusRing();}};var handleBlur=function handleBlur(){if(!hadKeyboardEvent){removeFocusRing();}};if(document.body&&document.body.addEventListener){initialize();document.body.addEventListener('keydown',handleKeyDown,true);document.body.addEventListener('focus',handleFocus,true);document.body.addEventListener('blur',handleBlur,true);}};exports.default=modality;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _createReactDOMStyle=__webpack_require__(281);var _createReactDOMStyle2=_interopRequireDefault(_createReactDOMStyle);var _flattenArray=__webpack_require__(282);var _flattenArray2=_interopRequireDefault(_flattenArray);var _flattenStyle=__webpack_require__(147);var _flattenStyle2=_interopRequireDefault(_flattenStyle);var _I18nManager=__webpack_require__(90);var _I18nManager2=_interopRequireDefault(_I18nManager);var _i18nStyle=__webpack_require__(152);var _i18nStyle2=_interopRequireDefault(_i18nStyle);var _prefixStyles=__webpack_require__(154);var _ReactNativePropRegistry=__webpack_require__(148);var _ReactNativePropRegistry2=_interopRequireDefault(_ReactNativePropRegistry);var _StyleManager=__webpack_require__(301);var _StyleManager2=_interopRequireDefault(_StyleManager);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var emptyObject={};var createCacheKey=function createCacheKey(id){var prefix='rn';return prefix+'-'+id;};var classListToString=function classListToString(list){return list.join(' ').trim();};var StyleRegistry=function(){function StyleRegistry(){_classCallCheck(this,StyleRegistry);this.cache={ltr:{},rtl:{}};this.styleManager=new _StyleManager2.default();}_createClass(StyleRegistry,[{key:'getStyleSheets',value:function getStyleSheets(){return this.styleManager.getStyleSheets();}},{key:'register',value:function register(flatStyle){var id=_ReactNativePropRegistry2.default.register(flatStyle);this._registerById(id);return id;}},{key:'_registerById',value:function _registerById(id){var _this=this;var dir=_I18nManager2.default.isRTL?'rtl':'ltr';if(!this.cache[dir][id]){var style=(0,_flattenStyle2.default)(id);var domStyle=(0,_createReactDOMStyle2.default)((0,_i18nStyle2.default)(style));Object.keys(domStyle).forEach(function(styleProp){var value=domStyle[styleProp];if(value!=null){_this.styleManager.setDeclaration(styleProp,value);}});this.cache[dir][id]=true;}}},{key:'resolve',value:function resolve(reactNativeStyle){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:emptyObject;if(!reactNativeStyle){return emptyObject;}if(typeof reactNativeStyle==='number'){this._registerById(reactNativeStyle);var _key=createCacheKey(reactNativeStyle);return this._resolveStyleIfNeeded(reactNativeStyle,options,_key);}if(!Array.isArray(reactNativeStyle)){return this._resolveStyle(reactNativeStyle,options);}var flatArray=(0,_flattenArray2.default)(reactNativeStyle);var isArrayOfNumbers=true;for(var i=0;i<flatArray.length;i++){var id=flatArray[i];if(typeof id!=='number'){isArrayOfNumbers=false;}else{this._registerById(id);}}var key=isArrayOfNumbers?createCacheKey(flatArray.join('-')):null;return this._resolveStyleIfNeeded(flatArray,options,key);}},{key:'resolveStateful',value:function resolveStateful(rnStyleNext,domStyleProps,options){var _this2=this;var rdomClassList=domStyleProps.classList,rdomStyle=domStyleProps.style;var _rdomClassList$reduce=rdomClassList.reduce(function(styleProps,className){var _styleManager$getDecl=_this2.styleManager.getDeclaration(className),prop=_styleManager$getDecl.prop,value=_styleManager$getDecl.value;if(prop){styleProps.style[prop]=value;}else{styleProps.classList.push(className);}return styleProps;},{classList:[],style:{}}),rnClassList=_rdomClassList$reduce.classList,rnStyle=_rdomClassList$reduce.style;var _resolve=this.resolve([rnStyle,rnStyleNext],options),rdomClassListNext=_resolve.classList,rdomStyleNext=_resolve.style;var style=_extends({},rdomStyle);rdomClassListNext.forEach(function(className){var _styleManager$getDecl2=_this2.styleManager.getDeclaration(className),prop=_styleManager$getDecl2.prop;if(style[prop]){style[prop]='';}});_extends(style,rdomStyleNext);var className=classListToString(rdomClassListNext.concat(rnClassList));return{className:className,style:style};}},{key:'_resolveStyle',value:function _resolveStyle(reactNativeStyle,options){var _this3=this;var flatStyle=(0,_flattenStyle2.default)(reactNativeStyle);var domStyle=(0,_createReactDOMStyle2.default)(options.i18n===false?flatStyle:(0,_i18nStyle2.default)(flatStyle));var props=Object.keys(domStyle).reduce(function(props,styleProp){var value=domStyle[styleProp];if(value!=null){var className=_this3.styleManager.getClassName(styleProp,value);if(className){props.classList.push(className);}else{if(!props.style){props.style={};}props.style[styleProp]=value;}}return props;},{classList:[]});props.className=classListToString(props.classList);if(props.style){props.style=(0,_prefixStyles.prefixInlineStyles)(props.style);}return props;}},{key:'_resolveStyleIfNeeded',value:function _resolveStyleIfNeeded(style,options,key){var dir=_I18nManager2.default.isRTL?'rtl':'ltr';if(key){if(!this.cache[dir][key]){this.cache[dir][key]=this._resolveStyle(style,options);}return this.cache[dir][key];}return this._resolveStyle(style,options);}}]);return StyleRegistry;}();exports.default=StyleRegistry;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _normalizeValue=__webpack_require__(149);var _normalizeValue2=_interopRequireDefault(_normalizeValue);var _processColor=__webpack_require__(151);var _processColor2=_interopRequireDefault(_processColor);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var emptyObject={};var styleShortFormProperties={borderColor:['borderTopColor','borderRightColor','borderBottomColor','borderLeftColor'],borderRadius:['borderTopLeftRadius','borderTopRightRadius','borderBottomRightRadius','borderBottomLeftRadius'],borderStyle:['borderTopStyle','borderRightStyle','borderBottomStyle','borderLeftStyle'],borderWidth:['borderTopWidth','borderRightWidth','borderBottomWidth','borderLeftWidth'],margin:['marginTop','marginRight','marginBottom','marginLeft'],marginHorizontal:['marginRight','marginLeft'],marginVertical:['marginTop','marginBottom'],overflow:['overflowX','overflowY'],padding:['paddingTop','paddingRight','paddingBottom','paddingLeft'],paddingHorizontal:['paddingRight','paddingLeft'],paddingVertical:['paddingTop','paddingBottom'],textDecorationLine:['textDecoration'],writingDirection:['direction']};var colorProps={backgroundColor:true,borderColor:true,borderTopColor:true,borderRightColor:true,borderBottomColor:true,borderLeftColor:true,color:true};var borderWidthProps={borderWidth:true,borderTopWidth:true,borderRightWidth:true,borderBottomWidth:true,borderLeftWidth:true};var systemFontStack='-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, "Helvetica Neue", sans-serif';var alphaSortProps=function alphaSortProps(propsArray){return propsArray.sort(function(a,b){if(a<b){return-1;}if(a>b){return 1;}return 0;});};var defaultOffset={height:0,width:0};var resolveShadow=function resolveShadow(resolvedStyle,style){var _ref=style.shadowOffset||defaultOffset,height=_ref.height,width=_ref.width;var offsetX=(0,_normalizeValue2.default)(null,width);var offsetY=(0,_normalizeValue2.default)(null,height);var blurRadius=(0,_normalizeValue2.default)(null,style.shadowRadius||0);var color=(0,_processColor2.default)(style.shadowColor,style.shadowOpacity);if(color){var boxShadow=offsetX+' '+offsetY+' '+blurRadius+' '+color;resolvedStyle.boxShadow=style.boxShadow?style.boxShadow+', '+boxShadow:boxShadow;}else if(style.boxShadow){resolvedStyle.boxShadow=style.boxShadow;}};var resolveTextShadow=function resolveTextShadow(resolvedStyle,style){var _ref2=style.textShadowOffset||defaultOffset,height=_ref2.height,width=_ref2.width;var offsetX=(0,_normalizeValue2.default)(null,width);var offsetY=(0,_normalizeValue2.default)(null,height);var blurRadius=(0,_normalizeValue2.default)(null,style.textShadowRadius||0);var color=(0,_processColor2.default)(style.textShadowColor);if(color){resolvedStyle.textShadow=offsetX+' '+offsetY+' '+blurRadius+' '+color;}};var mapTransform=function mapTransform(transform){var type=Object.keys(transform)[0];var value=(0,_normalizeValue2.default)(type,transform[type]);return type+'('+value+')';};var convertTransformMatrix=function convertTransformMatrix(transformMatrix){var matrix=transformMatrix.join(',');return'matrix3d('+matrix+')';};var resolveTransform=function resolveTransform(resolvedStyle,style){var transform=style.transform;if(Array.isArray(style.transform)){transform=style.transform.map(mapTransform).join(' ');}else if(style.transformMatrix){transform=convertTransformMatrix(style.transformMatrix);}resolvedStyle.transform=transform;};var createReducer=function createReducer(style,styleProps){var hasResolvedShadow=false;var hasResolvedTextShadow=false;return function(resolvedStyle,prop){var value=(0,_normalizeValue2.default)(prop,style[prop]);if(borderWidthProps[prop]){value=value==null?(0,_normalizeValue2.default)(null,0):value;}if(colorProps[prop]){value=(0,_processColor2.default)(value);}if(value==null){return resolvedStyle;}switch(prop){case'aspectRatio':case'elevation':case'overlayColor':case'resizeMode':case'tintColor':{break;}case'display':{resolvedStyle.display=value;if(style.display==='flex'&&style.flex==null){if(style.flexShrink==null){resolvedStyle.flexShrink='0 !important';}if(style.flexBasis==null){resolvedStyle.flexBasis='auto !important';}}break;}case'flex':{if(value>0){resolvedStyle.flex=value;resolvedStyle.flexGrow=value+' !important';resolvedStyle.flexShrink='1 !important';}else if(value===0){resolvedStyle.flexGrow='0 !important';resolvedStyle.flexShrink='0 !important';resolvedStyle.flexBasis='auto !important';}else if(value===-1){resolvedStyle.flexGrow='0 !important';resolvedStyle.flexShrink='1 !important';resolvedStyle.flexBasis='auto !important';}break;}case'flexGrow':case'flexShrink':case'flexBasis':{if(value!=null){var hasImportant=(''+value).indexOf('!important')>-1;resolvedStyle[prop]=hasImportant?value:value+' !important';}break;}case'fontFamily':{var isSystem=value==='System';resolvedStyle.fontFamily=isSystem?systemFontStack:value;break;}case'shadowColor':case'shadowOffset':case'shadowOpacity':case'shadowRadius':{if(!hasResolvedShadow){resolveShadow(resolvedStyle,style);}hasResolvedShadow=true;break;}case'textAlignVertical':{resolvedStyle.verticalAlign=value==='center'?'middle':value;break;}case'textShadowColor':case'textShadowOffset':case'textShadowRadius':{if(!hasResolvedTextShadow){resolveTextShadow(resolvedStyle,style);}hasResolvedTextShadow=true;break;}case'transform':case'transformMatrix':{resolveTransform(resolvedStyle,style);break;}default:{var longFormProperties=styleShortFormProperties[prop];if(longFormProperties){longFormProperties.forEach(function(longForm,i){if(styleProps.indexOf(longForm)===-1){resolvedStyle[longForm]=value;}});}else{resolvedStyle[prop]=value;}}}return resolvedStyle;};};var createReactDOMStyle=function createReactDOMStyle(style){if(!style){return emptyObject;}var styleProps=Object.keys(style);var sortedStyleProps=alphaSortProps(styleProps);var reducer=createReducer(style,styleProps);var resolvedStyle=sortedStyleProps.reduce(reducer,{});return resolvedStyle;};exports.default=createReactDOMStyle;

/***/ }),
/* 282 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});function flattenArray(array){function flattenDown(array,result){for(var i=0;i<array.length;i++){var value=array[i];if(Array.isArray(value)){flattenDown(value,result);}else if(value!=null&&value!==false){result.push(value);}}return result;}return flattenDown(array,[]);}exports.default=flattenArray;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrefixer;

var _prefixProperty = __webpack_require__(284);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(285);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _addNewValuesOnly = __webpack_require__(286);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(287);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  function prefixAll(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefixAll(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  }

  return prefixAll;
}
module.exports = exports['default'];

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(155);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var requiredPrefixes = prefixProperties[property];
    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
module.exports = exports["default"];

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
module.exports = exports["default"];

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _crossFade=__webpack_require__(289);var _crossFade2=_interopRequireDefault(_crossFade);var _cursor=__webpack_require__(290);var _cursor2=_interopRequireDefault(_cursor);var _filter=__webpack_require__(291);var _filter2=_interopRequireDefault(_filter);var _flex=__webpack_require__(292);var _flex2=_interopRequireDefault(_flex);var _flexboxIE=__webpack_require__(293);var _flexboxIE2=_interopRequireDefault(_flexboxIE);var _flexboxOld=__webpack_require__(294);var _flexboxOld2=_interopRequireDefault(_flexboxOld);var _gradient=__webpack_require__(295);var _gradient2=_interopRequireDefault(_gradient);var _imageSet=__webpack_require__(296);var _imageSet2=_interopRequireDefault(_imageSet);var _position=__webpack_require__(297);var _position2=_interopRequireDefault(_position);var _sizing=__webpack_require__(298);var _sizing2=_interopRequireDefault(_sizing);var _transition=__webpack_require__(299);var _transition2=_interopRequireDefault(_transition);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var w=['Webkit'];var m=['Moz'];var ms=['ms'];var wm=['Webkit','Moz'];var wms=['Webkit','ms'];var wmms=['Webkit','Moz','ms'];exports.default={plugins:[_crossFade2.default,_cursor2.default,_filter2.default,_flex2.default,_flexboxIE2.default,_flexboxOld2.default,_gradient2.default,_imageSet2.default,_position2.default,_sizing2.default,_transition2.default],prefixMap:{animation:w,animationDelay:w,animationDirection:w,animationFillMode:w,animationDuration:w,animationIterationCount:w,animationName:w,animationPlayState:w,animationTimingFunction:w,appearance:wm,userSelect:wmms,textEmphasisPosition:w,textEmphasis:w,textEmphasisStyle:w,textEmphasisColor:w,boxDecorationBreak:w,clipPath:w,maskImage:w,maskMode:w,maskRepeat:w,maskPosition:w,maskClip:w,maskOrigin:w,maskSize:w,maskComposite:w,mask:w,maskBorderSource:w,maskBorderMode:w,maskBorderSlice:w,maskBorderWidth:w,maskBorderOutset:w,maskBorderRepeat:w,maskBorder:w,maskType:w,textDecorationStyle:w,textDecorationSkip:w,textDecorationLine:w,textDecorationColor:w,filter:w,fontFeatureSettings:w,breakAfter:wmms,breakBefore:wmms,breakInside:wmms,columnCount:wm,columnFill:wm,columnGap:wm,columnRule:wm,columnRuleColor:wm,columnRuleStyle:wm,columnRuleWidth:wm,columns:wm,columnSpan:wm,columnWidth:wm,flex:wms,flexBasis:w,flexDirection:wms,flexGrow:w,flexFlow:wms,flexShrink:w,flexWrap:wms,alignContent:w,alignItems:w,alignSelf:w,justifyContent:w,order:w,transform:w,transformOrigin:w,transformOriginX:w,transformOriginY:w,backfaceVisibility:w,perspective:w,perspectiveOrigin:w,transformStyle:w,transformOriginZ:w,backdropFilter:w,fontKerning:w,scrollSnapType:wms,scrollSnapPointsX:wms,scrollSnapPointsY:wms,scrollSnapDestination:wms,scrollSnapCoordinate:wms,shapeImageThreshold:w,shapeImageMargin:w,shapeImageOutside:w,hyphens:wmms,flowInto:wms,flowFrom:wms,regionFragment:wms,textAlignLast:m,tabSize:m,wrapFlow:ms,wrapThrough:ms,wrapMargin:ms,touchAction:ms,gridTemplateColumns:ms,gridTemplateRows:ms,gridTemplateAreas:ms,gridTemplate:ms,gridAutoColumns:ms,gridAutoRows:ms,gridAutoFlow:ms,grid:ms,gridRowStart:ms,gridColumnStart:ms,gridRowEnd:ms,gridRow:ms,gridColumn:ms,gridColumnEnd:ms,gridColumnGap:ms,gridRowGap:ms,gridArea:ms,gridGap:ms,textSizeAdjust:wms,borderImage:w,borderImageOutset:w,borderImageRepeat:w,borderImageSlice:w,borderImageSource:w,borderImageWidth:w,transitionDelay:w,transitionDuration:w,transitionProperty:w,transitionTimingFunction:w}};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;

var _isPrefixedValue = __webpack_require__(52);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#search=cross-fade
var prefixes = ['-webkit-', ''];
function crossFade(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;

var _isPrefixedValue = __webpack_require__(52);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-filter-function
var prefixes = ['-webkit-', ''];
function filter(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports['default'];

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;
var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style) {
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(52);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;

var _isPrefixedValue = __webpack_require__(52);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ['-webkit-', ''];
function imageSet(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}
module.exports = exports['default'];

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(300);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(52);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(155);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports['default'];

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(156);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _ExecutionEnvironment=__webpack_require__(16);var _generateCss2=__webpack_require__(302);var _generateCss3=_interopRequireDefault(_generateCss2);var _hash=__webpack_require__(304);var _hash2=_interopRequireDefault(_hash);var _staticCss=__webpack_require__(305);var _staticCss2=_interopRequireDefault(_staticCss);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var emptyObject={};var STYLE_ELEMENT_ID='react-native-stylesheet';var createClassName=function createClassName(prop,value){var hashed=(0,_hash2.default)(prop+value);return  false?'rn-'+prop+'-'+hashed:'rn-'+hashed;};var createCssRule=function createCssRule(className,prop,value){var css=(0,_generateCss3.default)(_defineProperty({},prop,value));var selector='.'+className;return selector+'{'+css+'}';};var pointerEvents={auto:createClassName('pointerEvents','auto'),boxNone:createClassName('pointerEvents','box-none'),boxOnly:createClassName('pointerEvents','box-only'),none:createClassName('pointerEvents','none')};var pointerEventsCss='.'+pointerEvents.auto+'{pointer-events:auto !important;}\n'+('.'+pointerEvents.boxOnly+'{pointer-events:auto !important;}\n')+('.'+pointerEvents.none+'{pointer-events:none !important;}\n')+('.'+pointerEvents.boxNone+'{pointer-events:none !important;}\n')+('.'+pointerEvents.boxNone+' > *{pointer-events:auto;}\n')+('.'+pointerEvents.boxOnly+' > *{pointer-events:none;}');var StyleManager=function(){function StyleManager(){var _byClassName;_classCallCheck(this,StyleManager);this.cache=null;this.mainSheet=null;var pointerEventsPropName='pointerEvents';this.cache={byClassName:(_byClassName={},_defineProperty(_byClassName,pointerEvents.auto,{prop:pointerEventsPropName,value:'auto'}),_defineProperty(_byClassName,pointerEvents.boxNone,{prop:pointerEventsPropName,value:'box-none'}),_defineProperty(_byClassName,pointerEvents.boxOnly,{prop:pointerEventsPropName,value:'box-only'}),_defineProperty(_byClassName,pointerEvents.none,{prop:pointerEventsPropName,value:'none'}),_byClassName),byProp:{pointerEvents:{auto:pointerEvents.auto,'box-none':pointerEvents.boxNone,'box-only':pointerEvents.boxOnly,none:pointerEvents.none}}};if(_ExecutionEnvironment.canUseDOM){var prerenderedStyleSheet=document.getElementById(STYLE_ELEMENT_ID);if(prerenderedStyleSheet){this.mainSheet=prerenderedStyleSheet;}else{document.head.insertAdjacentHTML('afterbegin',this.getStyleSheetHtml());this.mainSheet=document.getElementById(STYLE_ELEMENT_ID);}}}_createClass(StyleManager,[{key:'getClassName',value:function getClassName(prop,value){var cache=this.cache.byProp;return cache[prop]&&cache[prop].hasOwnProperty(value)&&cache[prop][value];}},{key:'getDeclaration',value:function getDeclaration(className){var cache=this.cache.byClassName;return cache[className]||emptyObject;}},{key:'getStyleSheetHtml',value:function getStyleSheetHtml(){var styleSheets=this.getStyleSheets();return styleSheets.map(function(sheet){return'<style id="'+sheet.id+'">\n'+sheet.textContent+'\n</style>';}).join('\n');}},{key:'getStyleSheets',value:function getStyleSheets(){var _this=this;var cache=this.cache.byProp;var mainSheetTextContext=Object.keys(cache).reduce(function(rules,prop){if(prop!=='pointerEvents'){Object.keys(cache[prop]).forEach(function(value){var className=_this.getClassName(prop,value);var rule=createCssRule(className,prop,value);rules.push(rule);});}return rules;},[]).join('\n');return[{id:'react-native-stylesheet-static',textContent:_staticCss2.default+'\n'+pointerEventsCss},{id:STYLE_ELEMENT_ID,textContent:''+mainSheetTextContext}];}},{key:'setDeclaration',value:function setDeclaration(prop,value){var className=this.getClassName(prop,value);if(!className){className=createClassName(prop,value);this._addToCache(className,prop,value);if(_ExecutionEnvironment.canUseDOM){var sheet=this.mainSheet.sheet;if(this.mainSheet.textContent.indexOf(className)===-1){var rule=createCssRule(className,prop,value);sheet.insertRule(rule,sheet.cssRules.length);}}}return className;}},{key:'_addToCache',value:function _addToCache(className,prop,value){var cache=this.cache;if(!cache.byProp[prop]){cache.byProp[prop]={};}cache.byProp[prop][value]=className;cache.byClassName[className]={prop:prop,value:value};}}]);return StyleManager;}();exports.default=StyleManager;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _hyphenateStyleName=__webpack_require__(156);var _hyphenateStyleName2=_interopRequireDefault(_hyphenateStyleName);var _mapKeyValue=__webpack_require__(303);var _mapKeyValue2=_interopRequireDefault(_mapKeyValue);var _normalizeValue=__webpack_require__(149);var _normalizeValue2=_interopRequireDefault(_normalizeValue);var _prefixStyles=__webpack_require__(154);var _prefixStyles2=_interopRequireDefault(_prefixStyles);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var createDeclarationString=function createDeclarationString(prop,val){var name=(0,_hyphenateStyleName2.default)(prop);var value=(0,_normalizeValue2.default)(prop,val);if(Array.isArray(val)){return val.map(function(v){return name+':'+v;}).join(';');}return name+':'+value;};var generateCss=function generateCss(style){return(0,_mapKeyValue2.default)((0,_prefixStyles2.default)(style),createDeclarationString).sort().join(';');};exports.default=generateCss;

/***/ }),
/* 303 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var hasOwnProperty=Object.prototype.hasOwnProperty;var mapKeyValue=function mapKeyValue(obj,fn){var result=[];for(var key in obj){if(hasOwnProperty.call(obj,key)){var r=fn(key,obj[key]);r&&result.push(r);}}return result;};exports.default=mapKeyValue;

/***/ }),
/* 304 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});function murmurhash2_32_gc(str,seed){var l=str.length,h=seed^l,i=0,k;while(l>=4){k=str.charCodeAt(i)&0xff|(str.charCodeAt(++i)&0xff)<<8|(str.charCodeAt(++i)&0xff)<<16|(str.charCodeAt(++i)&0xff)<<24;k=(k&0xffff)*0x5bd1e995+(((k>>>16)*0x5bd1e995&0xffff)<<16);k^=k>>>24;k=(k&0xffff)*0x5bd1e995+(((k>>>16)*0x5bd1e995&0xffff)<<16);h=(h&0xffff)*0x5bd1e995+(((h>>>16)*0x5bd1e995&0xffff)<<16)^k;l-=4;++i;}switch(l){case 3:h^=(str.charCodeAt(i+2)&0xff)<<16;case 2:h^=(str.charCodeAt(i+1)&0xff)<<8;case 1:h^=str.charCodeAt(i)&0xff;h=(h&0xffff)*0x5bd1e995+(((h>>>16)*0x5bd1e995&0xffff)<<16);}h^=h>>>13;h=(h&0xffff)*0x5bd1e995+(((h>>>16)*0x5bd1e995&0xffff)<<16);h^=h>>>15;return h>>>0;}var hash=function hash(str){return murmurhash2_32_gc(str,1).toString(36);};exports.default=hash;

/***/ }),
/* 305 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});exports.default='html{'+'font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%;'+'-webkit-tap-highlight-color:rgba(0,0,0,0);'+'}\n'+'body{margin:0;}\n'+'button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0;}\n'+'input::-webkit-inner-spin-button,input::-webkit-outer-spin-button,'+'input::-webkit-search-cancel-button,input::-webkit-search-decoration,'+'input::-webkit-search-results-button,input::-webkit-search-results-decoration{display:none;}\n'+'@keyframes rn-ActivityIndicator-animation{'+'0%{-webkit-transform:rotate(0deg);transform:rotate(0deg);}'+'100%{-webkit-transform:rotate(360deg);transform:rotate(360deg);}'+'}\n'+'@keyframes rn-ProgressBar-animation{'+'0%{-webkit-transform:translateX(-100%);transform:translateX(-100%);}'+'100%{-webkit-transform:translateX(400%);transform:translateX(400%);}'+'}';

/***/ }),
/* 306 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var NativeModules={};exports.default=NativeModules;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _animated=__webpack_require__(308);var _animated2=_interopRequireDefault(_animated);var _Image=__webpack_require__(162);var _Image2=_interopRequireDefault(_Image);var _ScrollView=__webpack_require__(66);var _ScrollView2=_interopRequireDefault(_ScrollView);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _Text=__webpack_require__(100);var _Text2=_interopRequireDefault(_Text);var _View=__webpack_require__(11);var _View2=_interopRequireDefault(_View);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}_animated2.default.inject.FlattenStyle(_StyleSheet2.default.flatten);var AnimatedImplementation=_extends({},_animated2.default,{Image:_animated2.default.createAnimatedComponent(_Image2.default),ScrollView:_animated2.default.createAnimatedComponent(_ScrollView2.default),Text:_animated2.default.createAnimatedComponent(_Text2.default),View:_animated2.default.createAnimatedComponent(_View2.default)});exports.default=AnimatedImplementation;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};

var invariant=__webpack_require__(53);

var Animated=__webpack_require__(13);
var AnimatedValue=__webpack_require__(34);
var AnimatedValueXY=__webpack_require__(310);
var AnimatedAddition=__webpack_require__(311);
var AnimatedMultiplication=__webpack_require__(312);
var AnimatedModulo=__webpack_require__(313);
var AnimatedTemplate=__webpack_require__(314);
var AnimatedTracking=__webpack_require__(315);
var isAnimated=__webpack_require__(316);

var Animation=__webpack_require__(55);
var TimingAnimation=__webpack_require__(317);
var DecayAnimation=__webpack_require__(319);
var SpringAnimation=__webpack_require__(320);

































var maybeVectorAnim=function maybeVectorAnim(
value,
config,
anim)
{
if(value instanceof AnimatedValueXY){
var configX=_extends({},config);
var configY=_extends({},config);
for(var key in config){var _config$key=
config[key],x=_config$key.x,y=_config$key.y;
if(x!==undefined&&y!==undefined){
configX[key]=x;
configY[key]=y;
}
}
var aX=anim(value.x,configX);
var aY=anim(value.y,configY);


return parallel([aX,aY],{stopTogether:false});
}
return null;
};

var spring=function spring(
value,
config)
{
return maybeVectorAnim(value,config,spring)||{
start:function start(callback){
var singleValue=value;
var singleConfig=config;
singleValue.stopTracking();
if(config.toValue instanceof Animated){
singleValue.track(new AnimatedTracking(
singleValue,
config.toValue,
SpringAnimation,
singleConfig,
callback));

}else{
singleValue.animate(new SpringAnimation(singleConfig),callback);
}
},

stop:function stop(){
value.stopAnimation();
}};

};

var timing=function timing(
value,
config)
{
return maybeVectorAnim(value,config,timing)||{
start:function start(callback){
var singleValue=value;
var singleConfig=config;
singleValue.stopTracking();
if(config.toValue instanceof Animated){
singleValue.track(new AnimatedTracking(
singleValue,
config.toValue,
TimingAnimation,
singleConfig,
callback));

}else{
singleValue.animate(new TimingAnimation(singleConfig),callback);
}
},

stop:function stop(){
value.stopAnimation();
}};

};

var decay=function decay(
value,
config)
{
return maybeVectorAnim(value,config,decay)||{
start:function start(callback){
var singleValue=value;
var singleConfig=config;
singleValue.stopTracking();
singleValue.animate(new DecayAnimation(singleConfig),callback);
},

stop:function stop(){
value.stopAnimation();
}};

};

var sequence=function sequence(
animations)
{
var current=0;
return{
start:function start(callback){
var onComplete=function onComplete(result){
if(!result.finished){
callback&&callback(result);
return;
}

current++;

if(current===animations.length){
callback&&callback(result);
return;
}

animations[current].start(onComplete);
};

if(animations.length===0){
callback&&callback({finished:true});
}else{
animations[current].start(onComplete);
}
},

stop:function stop(){
if(current<animations.length){
animations[current].stop();
}
}};

};




var parallel=function parallel(
animations,
config)
{
var doneCount=0;

var hasEnded={};
var stopTogether=!(config&&config.stopTogether===false);

var result={
start:function start(callback){
if(doneCount===animations.length){
callback&&callback({finished:true});
return;
}

animations.forEach(function(animation,idx){
var cb=function cb(endResult){
hasEnded[idx]=true;
doneCount++;
if(doneCount===animations.length){
doneCount=0;
callback&&callback(endResult);
return;
}

if(!endResult.finished&&stopTogether){
result.stop();
}
};

if(!animation){
cb({finished:true});
}else{
animation.start(cb);
}
});
},

stop:function stop(){
animations.forEach(function(animation,idx){
!hasEnded[idx]&&animation.stop();
hasEnded[idx]=true;
});
}};


return result;
};

var delay=function delay(time){

return timing(new AnimatedValue(0),{toValue:0,delay:time,duration:0});
};

var stagger=function stagger(
time,
animations)
{
return parallel(animations.map(function(animation,i){
return sequence([
delay(time*i),
animation]);

}));
};




var event=function event(
argMapping,
config)
{
return function(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}
var traverse=function traverse(recMapping,recEvt,key){
if(typeof recEvt==='number'){
invariant(
recMapping instanceof AnimatedValue,
'Bad mapping of type '+typeof recMapping+' for key '+key+
', event value must map to AnimatedValue');

recMapping.setValue(recEvt);
return;
}
invariant(
typeof recMapping==='object',
'Bad mapping of type '+typeof recMapping+' for key '+key);

invariant(
typeof recEvt==='object',
'Bad event of type '+typeof recEvt+' for key '+key);

for(var key in recMapping){
traverse(recMapping[key],recEvt[key],key);
}
};
argMapping.forEach(function(mapping,idx){
traverse(mapping,args[idx],'arg'+idx);
});
if(config&&config.listener){
config.listener.apply(null,args);
}
};
};


























































































module.exports={




Value:AnimatedValue,



ValueXY:AnimatedValueXY,





decay:decay,




timing:timing,




spring:spring,





add:function add(a,b){
return new AnimatedAddition(a,b);
},




multiply:function multiply(a,b){
return new AnimatedMultiplication(a,b);
},





modulo:function modulo(a,modulus){
return new AnimatedModulo(a,modulus);
},





template:function template(strings){for(var _len2=arguments.length,values=Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){values[_key2-1]=arguments[_key2];}
return new AnimatedTemplate(strings,values);
},




delay:delay,





sequence:sequence,





parallel:parallel,




stagger:stagger,

















event:event,





isAnimated:isAnimated,




createAnimatedComponent:__webpack_require__(322),

inject:{
ApplyAnimatedValues:__webpack_require__(161).inject,
InteractionManager:__webpack_require__(157).inject,
FlattenStyle:__webpack_require__(160).inject,
RequestAnimationFrame:__webpack_require__(64).inject,
CancelAnimationFrame:__webpack_require__(65).inject},


__PropsOnlyForTests:__webpack_require__(159)};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";











function SetPolyfill(){
this._cache=[];
}

SetPolyfill.prototype.add=function(e){
if(this._cache.indexOf(e)===-1){
this._cache.push(e);
}
};

SetPolyfill.prototype.forEach=function(cb){
this._cache.forEach(cb);
};

module.exports=SetPolyfill;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var Animated=__webpack_require__(13);
var AnimatedValue=__webpack_require__(34);
var AnimatedWithChildren=__webpack_require__(22);
var invariant=__webpack_require__(53);
var guid=__webpack_require__(91);var









































AnimatedValueXY=function(_AnimatedWithChildren){_inherits(AnimatedValueXY,_AnimatedWithChildren);




function AnimatedValueXY(valueIn){_classCallCheck(this,AnimatedValueXY);var _this=_possibleConstructorReturn(this,(AnimatedValueXY.__proto__||Object.getPrototypeOf(AnimatedValueXY)).call(this));

var value=valueIn||{x:0,y:0};
if(typeof value.x==='number'&&typeof value.y==='number'){
_this.x=new AnimatedValue(value.x);
_this.y=new AnimatedValue(value.y);
}else{
invariant(
value.x instanceof AnimatedValue&&
value.y instanceof AnimatedValue,
'AnimatedValueXY must be initalized with an object of numbers or '+
'AnimatedValues.');

_this.x=value.x;
_this.y=value.y;
}
_this._listeners={};return _this;
}_createClass(AnimatedValueXY,[{key:'setValue',value:function setValue(

value){
this.x.setValue(value.x);
this.y.setValue(value.y);
}},{key:'setOffset',value:function setOffset(

offset){
this.x.setOffset(offset.x);
this.y.setOffset(offset.y);
}},{key:'flattenOffset',value:function flattenOffset()

{
this.x.flattenOffset();
this.y.flattenOffset();
}},{key:'__getValue',value:function __getValue()

{
return{
x:this.x.__getValue(),
y:this.y.__getValue()};

}},{key:'stopAnimation',value:function stopAnimation(

callback){
this.x.stopAnimation();
this.y.stopAnimation();
callback&&callback(this.__getValue());
}},{key:'addListener',value:function addListener(

callback){var _this2=this;
var id=guid();
var jointCallback=function jointCallback(_ref){var number=_ref.value;
callback(_this2.__getValue());
};
this._listeners[id]={
x:this.x.addListener(jointCallback),
y:this.y.addListener(jointCallback)};

return id;
}},{key:'removeListener',value:function removeListener(

id){
this.x.removeListener(this._listeners[id].x);
this.y.removeListener(this._listeners[id].y);
delete this._listeners[id];
}},{key:'getLayout',value:function getLayout()








{
return{
left:this.x,
top:this.y};

}},{key:'getTranslateTransform',value:function getTranslateTransform()










{
return[
{translateX:this.x},
{translateY:this.y}];

}}]);return AnimatedValueXY;}(AnimatedWithChildren);


module.exports=AnimatedValueXY;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var AnimatedWithChildren=__webpack_require__(22);
var Animated=__webpack_require__(13);
var AnimatedValue=__webpack_require__(34);
var Interpolation=__webpack_require__(54);
var AnimatedInterpolation=__webpack_require__(63);var



AnimatedAddition=function(_AnimatedWithChildren){_inherits(AnimatedAddition,_AnimatedWithChildren);






function AnimatedAddition(a,b){_classCallCheck(this,AnimatedAddition);var _this=_possibleConstructorReturn(this,(AnimatedAddition.__proto__||Object.getPrototypeOf(AnimatedAddition)).call(this));

_this._a=typeof a==='number'?new AnimatedValue(a):a;
_this._b=typeof b==='number'?new AnimatedValue(b):b;
_this._listeners={};return _this;
}_createClass(AnimatedAddition,[{key:'__getValue',value:function __getValue()

{
return this._a.__getValue()+this._b.__getValue();
}},{key:'addListener',value:function addListener(

callback){var _this2=this;
if(!this._aListener&&this._a.addListener){
this._aListener=this._a.addListener(function(){
for(var key in _this2._listeners){
_this2._listeners[key]({value:_this2.__getValue()});
}
});
}
if(!this._bListener&&this._b.addListener){
this._bListener=this._b.addListener(function(){
for(var key in _this2._listeners){
_this2._listeners[key]({value:_this2.__getValue()});
}
});
}
var id=guid();
this._listeners[id]=callback;
return id;
}},{key:'removeListener',value:function removeListener(

id){
delete this._listeners[id];
}},{key:'interpolate',value:function interpolate(

config){
return new AnimatedInterpolation(this,Interpolation.create(config));
}},{key:'__attach',value:function __attach()

{
this._a.__addChild(this);
this._b.__addChild(this);
}},{key:'__detach',value:function __detach()

{
this._a.__removeChild(this);
this._b.__removeChild(this);
}}]);return AnimatedAddition;}(AnimatedWithChildren);


module.exports=AnimatedAddition;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var AnimatedWithChildren=__webpack_require__(22);
var Animated=__webpack_require__(13);
var AnimatedValue=__webpack_require__(34);
var AnimatedInterpolation=__webpack_require__(63);
var Interpolation=__webpack_require__(54);var



AnimatedMultiplication=function(_AnimatedWithChildren){_inherits(AnimatedMultiplication,_AnimatedWithChildren);






function AnimatedMultiplication(a,b){_classCallCheck(this,AnimatedMultiplication);var _this=_possibleConstructorReturn(this,(AnimatedMultiplication.__proto__||Object.getPrototypeOf(AnimatedMultiplication)).call(this));

_this._a=typeof a==='number'?new AnimatedValue(a):a;
_this._b=typeof b==='number'?new AnimatedValue(b):b;
_this._listeners={};return _this;
}_createClass(AnimatedMultiplication,[{key:'__getValue',value:function __getValue()

{
return this._a.__getValue()*this._b.__getValue();
}},{key:'addListener',value:function addListener(

callback){var _this2=this;
if(!this._aListener&&this._a.addListener){
this._aListener=this._a.addListener(function(){
for(var key in _this2._listeners){
_this2._listeners[key]({value:_this2.__getValue()});
}
});
}
if(!this._bListener&&this._b.addListener){
this._bListener=this._b.addListener(function(){
for(var key in _this2._listeners){
_this2._listeners[key]({value:_this2.__getValue()});
}
});
}
var id=guid();
this._listeners[id]=callback;
return id;
}},{key:'removeListener',value:function removeListener(

id){
delete this._listeners[id];
}},{key:'interpolate',value:function interpolate(

config){
return new AnimatedInterpolation(this,Interpolation.create(config));
}},{key:'__attach',value:function __attach()

{
this._a.__addChild(this);
this._b.__addChild(this);
}},{key:'__detach',value:function __detach()

{
this._a.__removeChild(this);
this._b.__removeChild(this);
}}]);return AnimatedMultiplication;}(AnimatedWithChildren);


module.exports=AnimatedMultiplication;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var Animated=__webpack_require__(13);
var AnimatedWithChildren=__webpack_require__(22);
var AnimatedInterpolation=__webpack_require__(63);
var Interpolation=__webpack_require__(54);var



AnimatedModulo=function(_AnimatedWithChildren){_inherits(AnimatedModulo,_AnimatedWithChildren);





function AnimatedModulo(a,modulus){_classCallCheck(this,AnimatedModulo);var _this=_possibleConstructorReturn(this,(AnimatedModulo.__proto__||Object.getPrototypeOf(AnimatedModulo)).call(this));

_this._a=a;
_this._modulus=modulus;
_this._listeners={};return _this;
}_createClass(AnimatedModulo,[{key:'__getValue',value:function __getValue()

{
return(this._a.__getValue()%this._modulus+this._modulus)%this._modulus;
}},{key:'addListener',value:function addListener(

callback){var _this2=this;
if(!this._aListener){
this._aListener=this._a.addListener(function(){
for(var key in _this2._listeners){
_this2._listeners[key]({value:_this2.__getValue()});
}
});
}
var id=guid();
this._listeners[id]=callback;
return id;
}},{key:'removeListener',value:function removeListener(

id){
delete this._listeners[id];
}},{key:'interpolate',value:function interpolate(

config){
return new AnimatedInterpolation(this,Interpolation.create(config));
}},{key:'__attach',value:function __attach()

{
this._a.__addChild(this);
}},{key:'__detach',value:function __detach()

{
this._a.__removeChild(this);
}}]);return AnimatedModulo;}(AnimatedWithChildren);


module.exports=AnimatedModulo;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var Animated=__webpack_require__(13);
var AnimatedWithChildren=__webpack_require__(22);var

AnimatedTemplate=function(_AnimatedWithChildren){_inherits(AnimatedTemplate,_AnimatedWithChildren);



function AnimatedTemplate(strings,values){_classCallCheck(this,AnimatedTemplate);var _this=_possibleConstructorReturn(this,(AnimatedTemplate.__proto__||Object.getPrototypeOf(AnimatedTemplate)).call(this));

_this._strings=strings;
_this._values=values;return _this;
}_createClass(AnimatedTemplate,[{key:'__transformValue',value:function __transformValue(

value){
if(value instanceof Animated){
return value.__getValue();
}else{
return value;
}
}},{key:'__getValue',value:function __getValue()

{
var value=this._strings[0];
for(var i=0;i<this._values.length;++i){
value+=this.__transformValue(this._values[i])+this._strings[1+i];
}
return value;
}},{key:'__attach',value:function __attach()

{
for(var i=0;i<this._values.length;++i){
if(this._values[i]instanceof Animated){
this._values[i].__addChild(this);
}
}
}},{key:'__detach',value:function __detach()

{
for(var i=0;i<this._values.length;++i){
if(this._values[i]instanceof Animated){
this._values[i].__removeChild(this);
}
}
}}]);return AnimatedTemplate;}(AnimatedWithChildren);


module.exports=AnimatedTemplate;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var Animated=__webpack_require__(13);
var AnimatedValue=__webpack_require__(34);var



AnimatedTracking=function(_Animated){_inherits(AnimatedTracking,_Animated);






function AnimatedTracking(
value,
parent,
animationClass,
animationConfig,
callback)
{_classCallCheck(this,AnimatedTracking);var _this=_possibleConstructorReturn(this,(AnimatedTracking.__proto__||Object.getPrototypeOf(AnimatedTracking)).call(this));

_this._value=value;
_this._parent=parent;
_this._animationClass=animationClass;
_this._animationConfig=animationConfig;
_this._callback=callback;
_this.__attach();return _this;
}_createClass(AnimatedTracking,[{key:'__getValue',value:function __getValue()

{
return this._parent.__getValue();
}},{key:'__attach',value:function __attach()

{
this._parent.__addChild(this);
}},{key:'__detach',value:function __detach()

{
this._parent.__removeChild(this);
}},{key:'update',value:function update()

{
this._value.animate(new this._animationClass(_extends({},
this._animationConfig,{
toValue:this._animationConfig.toValue.__getValue()})),
this._callback);
}}]);return AnimatedTracking;}(Animated);


module.exports=AnimatedTracking;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";












var Animated=__webpack_require__(13);

function isAnimated(obj){
return obj instanceof Animated;
}

module.exports=isAnimated;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var Animation=__webpack_require__(55);
var AnimatedValue=__webpack_require__(34);
var Easing=__webpack_require__(158);
var RequestAnimationFrame=__webpack_require__(64);
var CancelAnimationFrame=__webpack_require__(65);



var easeInOut=Easing.inOut(Easing.ease);var








TimingAnimation=function(_Animation){_inherits(TimingAnimation,_Animation);










function TimingAnimation(
config)
{_classCallCheck(this,TimingAnimation);var _this=_possibleConstructorReturn(this,(TimingAnimation.__proto__||Object.getPrototypeOf(TimingAnimation)).call(this));

_this._toValue=config.toValue;
_this._easing=config.easing!==undefined?config.easing:easeInOut;
_this._duration=config.duration!==undefined?config.duration:500;
_this._delay=config.delay!==undefined?config.delay:0;
_this.__isInteraction=config.isInteraction!==undefined?config.isInteraction:true;return _this;
}_createClass(TimingAnimation,[{key:'start',value:function start(


fromValue,
onUpdate,
onEnd)
{var _this2=this;
this.__active=true;
this._fromValue=fromValue;
this._onUpdate=onUpdate;
this.__onEnd=onEnd;

var start=function start(){
if(_this2._duration===0){
_this2._onUpdate(_this2._toValue);
_this2.__debouncedOnEnd({finished:true});
}else{
_this2._startTime=Date.now();
_this2._animationFrame=RequestAnimationFrame.current(_this2.onUpdate.bind(_this2));
}
};
if(this._delay){
this._timeout=setTimeout(start,this._delay);
}else{
start();
}
}},{key:'onUpdate',value:function onUpdate()

{
var now=Date.now();
if(now>=this._startTime+this._duration){
if(this._duration===0){
this._onUpdate(this._toValue);
}else{
this._onUpdate(
this._fromValue+this._easing(1)*(this._toValue-this._fromValue));

}
this.__debouncedOnEnd({finished:true});
return;
}

this._onUpdate(
this._fromValue+
this._easing((now-this._startTime)/this._duration)*(
this._toValue-this._fromValue));

if(this.__active){
this._animationFrame=RequestAnimationFrame.current(this.onUpdate.bind(this));
}
}},{key:'stop',value:function stop()

{
this.__active=false;
clearTimeout(this._timeout);
CancelAnimationFrame.current(this._animationFrame);
this.__debouncedOnEnd({finished:false});
}}]);return TimingAnimation;}(Animation);


module.exports=TimingAnimation;

/***/ }),
/* 318 */
/***/ (function(module, exports) {









var NEWTON_ITERATIONS=4;
var NEWTON_MIN_SLOPE=0.001;
var SUBDIVISION_PRECISION=0.0000001;
var SUBDIVISION_MAX_ITERATIONS=10;

var kSplineTableSize=11;
var kSampleStepSize=1.0/(kSplineTableSize-1.0);

var float32ArraySupported=typeof Float32Array==='function';

function A(aA1,aA2){return 1.0-3.0*aA2+3.0*aA1;}
function B(aA1,aA2){return 3.0*aA2-6.0*aA1;}
function C(aA1){return 3.0*aA1;}


function calcBezier(aT,aA1,aA2){return((A(aA1,aA2)*aT+B(aA1,aA2))*aT+C(aA1))*aT;}


function getSlope(aT,aA1,aA2){return 3.0*A(aA1,aA2)*aT*aT+2.0*B(aA1,aA2)*aT+C(aA1);}

function binarySubdivide(aX,aA,aB,mX1,mX2){
var currentX,currentT,i=0;
do{
currentT=aA+(aB-aA)/2.0;
currentX=calcBezier(currentT,mX1,mX2)-aX;
if(currentX>0.0){
aB=currentT;
}else{
aA=currentT;
}
}while(Math.abs(currentX)>SUBDIVISION_PRECISION&&++i<SUBDIVISION_MAX_ITERATIONS);
return currentT;
}

function newtonRaphsonIterate(aX,aGuessT,mX1,mX2){
for(var i=0;i<NEWTON_ITERATIONS;++i){
var currentSlope=getSlope(aGuessT,mX1,mX2);
if(currentSlope===0.0){
return aGuessT;
}
var currentX=calcBezier(aGuessT,mX1,mX2)-aX;
aGuessT-=currentX/currentSlope;
}
return aGuessT;
}

module.exports=function bezier(mX1,mY1,mX2,mY2){
if(!(0<=mX1&&mX1<=1&&0<=mX2&&mX2<=1)){
throw new Error('bezier x values must be in [0, 1] range');
}


var sampleValues=float32ArraySupported?new Float32Array(kSplineTableSize):new Array(kSplineTableSize);
if(mX1!==mY1||mX2!==mY2){
for(var i=0;i<kSplineTableSize;++i){
sampleValues[i]=calcBezier(i*kSampleStepSize,mX1,mX2);
}
}

function getTForX(aX){
var intervalStart=0.0;
var currentSample=1;
var lastSample=kSplineTableSize-1;

for(;currentSample!==lastSample&&sampleValues[currentSample]<=aX;++currentSample){
intervalStart+=kSampleStepSize;
}
--currentSample;


var dist=(aX-sampleValues[currentSample])/(sampleValues[currentSample+1]-sampleValues[currentSample]);
var guessForT=intervalStart+dist*kSampleStepSize;

var initialSlope=getSlope(guessForT,mX1,mX2);
if(initialSlope>=NEWTON_MIN_SLOPE){
return newtonRaphsonIterate(aX,guessForT,mX1,mX2);
}else if(initialSlope===0.0){
return guessForT;
}else{
return binarySubdivide(aX,intervalStart,intervalStart+kSampleStepSize,mX1,mX2);
}
}

return function BezierEasing(x){
if(mX1===mY1&&mX2===mY2){
return x;
}

if(x===0){
return 0;
}
if(x===1){
return 1;
}
return calcBezier(getTForX(x),mY1,mY2);
};
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var Animation=__webpack_require__(55);
var RequestAnimationFrame=__webpack_require__(64);
var CancelAnimationFrame=__webpack_require__(65);var








DecayAnimation=function(_Animation){_inherits(DecayAnimation,_Animation);








function DecayAnimation(
config)
{_classCallCheck(this,DecayAnimation);var _this=_possibleConstructorReturn(this,(DecayAnimation.__proto__||Object.getPrototypeOf(DecayAnimation)).call(this));

_this._deceleration=config.deceleration!==undefined?config.deceleration:0.998;
_this._velocity=config.velocity;
_this.__isInteraction=config.isInteraction!==undefined?config.isInteraction:true;return _this;
}_createClass(DecayAnimation,[{key:'start',value:function start(


fromValue,
onUpdate,
onEnd)
{
this.__active=true;
this._lastValue=fromValue;
this._fromValue=fromValue;
this._onUpdate=onUpdate;
this.__onEnd=onEnd;
this._startTime=Date.now();
this._animationFrame=RequestAnimationFrame.current(this.onUpdate.bind(this));
}},{key:'onUpdate',value:function onUpdate()

{
var now=Date.now();

var value=this._fromValue+
this._velocity/(1-this._deceleration)*(
1-Math.exp(-(1-this._deceleration)*(now-this._startTime)));

this._onUpdate(value);

if(Math.abs(this._lastValue-value)<0.1){
this.__debouncedOnEnd({finished:true});
return;
}

this._lastValue=value;
if(this.__active){
this._animationFrame=RequestAnimationFrame.current(this.onUpdate.bind(this));
}
}},{key:'stop',value:function stop()

{
this.__active=false;
CancelAnimationFrame.current(this._animationFrame);
this.__debouncedOnEnd({finished:false});
}}]);return DecayAnimation;}(Animation);


module.exports=DecayAnimation;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var Animation=__webpack_require__(55);
var AnimatedValue=__webpack_require__(34);
var RequestAnimationFrame=__webpack_require__(64);
var CancelAnimationFrame=__webpack_require__(65);
var invariant=__webpack_require__(53);
var SpringConfig=__webpack_require__(321);















function withDefault(value,defaultValue){
if(value===undefined||value===null){
return defaultValue;
}
return value;
}var

SpringAnimation=function(_Animation){_inherits(SpringAnimation,_Animation);















function SpringAnimation(
config)
{_classCallCheck(this,SpringAnimation);var _this=_possibleConstructorReturn(this,(SpringAnimation.__proto__||Object.getPrototypeOf(SpringAnimation)).call(this));


_this._overshootClamping=withDefault(config.overshootClamping,false);
_this._restDisplacementThreshold=withDefault(config.restDisplacementThreshold,0.001);
_this._restSpeedThreshold=withDefault(config.restSpeedThreshold,0.001);
_this._initialVelocity=config.velocity;
_this._lastVelocity=withDefault(config.velocity,0);
_this._toValue=config.toValue;
_this.__isInteraction=config.isInteraction!==undefined?config.isInteraction:true;

var springConfig;
if(config.bounciness!==undefined||config.speed!==undefined){
invariant(
config.tension===undefined&&config.friction===undefined,
'You can only define bounciness/speed or tension/friction but not both');

springConfig=SpringConfig.fromBouncinessAndSpeed(
withDefault(config.bounciness,8),
withDefault(config.speed,12));

}else{
springConfig=SpringConfig.fromOrigamiTensionAndFriction(
withDefault(config.tension,40),
withDefault(config.friction,7));

}
_this._tension=springConfig.tension;
_this._friction=springConfig.friction;return _this;
}_createClass(SpringAnimation,[{key:'start',value:function start(


fromValue,
onUpdate,
onEnd,
previousAnimation)
{
this.__active=true;
this._startPosition=fromValue;
this._lastPosition=this._startPosition;

this._onUpdate=onUpdate;
this.__onEnd=onEnd;
this._lastTime=Date.now();

if(previousAnimation instanceof SpringAnimation){
var internalState=previousAnimation.getInternalState();
this._lastPosition=internalState.lastPosition;
this._lastVelocity=internalState.lastVelocity;
this._lastTime=internalState.lastTime;
}
if(this._initialVelocity!==undefined&&
this._initialVelocity!==null){
this._lastVelocity=this._initialVelocity;
}
this.onUpdate();
}},{key:'getInternalState',value:function getInternalState()

{
return{
lastPosition:this._lastPosition,
lastVelocity:this._lastVelocity,
lastTime:this._lastTime};

}},{key:'onUpdate',value:function onUpdate()

{
var position=this._lastPosition;
var velocity=this._lastVelocity;

var tempPosition=this._lastPosition;
var tempVelocity=this._lastVelocity;





var MAX_STEPS=64;
var now=Date.now();
if(now>this._lastTime+MAX_STEPS){
now=this._lastTime+MAX_STEPS;
}




var TIMESTEP_MSEC=1;
var numSteps=Math.floor((now-this._lastTime)/TIMESTEP_MSEC);

for(var i=0;i<numSteps;++i){

var step=TIMESTEP_MSEC/1000;



var aVelocity=velocity;
var aAcceleration=this._tension*(this._toValue-tempPosition)-this._friction*tempVelocity;
var tempPosition=position+aVelocity*step/2;
var tempVelocity=velocity+aAcceleration*step/2;

var bVelocity=tempVelocity;
var bAcceleration=this._tension*(this._toValue-tempPosition)-this._friction*tempVelocity;
tempPosition=position+bVelocity*step/2;
tempVelocity=velocity+bAcceleration*step/2;

var cVelocity=tempVelocity;
var cAcceleration=this._tension*(this._toValue-tempPosition)-this._friction*tempVelocity;
tempPosition=position+cVelocity*step/2;
tempVelocity=velocity+cAcceleration*step/2;

var dVelocity=tempVelocity;
var dAcceleration=this._tension*(this._toValue-tempPosition)-this._friction*tempVelocity;
tempPosition=position+cVelocity*step/2;
tempVelocity=velocity+cAcceleration*step/2;

var dxdt=(aVelocity+2*(bVelocity+cVelocity)+dVelocity)/6;
var dvdt=(aAcceleration+2*(bAcceleration+cAcceleration)+dAcceleration)/6;

position+=dxdt*step;
velocity+=dvdt*step;
}

this._lastTime=now;
this._lastPosition=position;
this._lastVelocity=velocity;

this._onUpdate(position);
if(!this.__active){
return;
}


var isOvershooting=false;
if(this._overshootClamping&&this._tension!==0){
if(this._startPosition<this._toValue){
isOvershooting=position>this._toValue;
}else{
isOvershooting=position<this._toValue;
}
}
var isVelocity=Math.abs(velocity)<=this._restSpeedThreshold;
var isDisplacement=true;
if(this._tension!==0){
isDisplacement=Math.abs(this._toValue-position)<=this._restDisplacementThreshold;
}

if(isOvershooting||isVelocity&&isDisplacement){
if(this._tension!==0){

this._onUpdate(this._toValue);
}

this.__debouncedOnEnd({finished:true});
return;
}
this._animationFrame=RequestAnimationFrame.current(this.onUpdate.bind(this));
}},{key:'stop',value:function stop()

{
this.__active=false;
CancelAnimationFrame.current(this._animationFrame);
this.__debouncedOnEnd({finished:false});
}}]);return SpringAnimation;}(Animation);


module.exports=SpringAnimation;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


















function tensionFromOrigamiValue(oValue){
return(oValue-30)*3.62+194;
}

function frictionFromOrigamiValue(oValue){
return(oValue-8)*3+25;
}

function fromOrigamiTensionAndFriction(
tension,
friction)
{
return{
tension:tensionFromOrigamiValue(tension),
friction:frictionFromOrigamiValue(friction)};

}

function fromBouncinessAndSpeed(
bounciness,
speed)
{
function normalize(value,startValue,endValue){
return(value-startValue)/(endValue-startValue);
}

function projectNormal(n,start,end){
return start+n*(end-start);
}

function linearInterpolation(t,start,end){
return t*end+(1-t)*start;
}

function quadraticOutInterpolation(t,start,end){
return linearInterpolation(2*t-t*t,start,end);
}

function b3Friction1(x){
return 0.0007*Math.pow(x,3)-
0.031*Math.pow(x,2)+0.64*x+1.28;
}

function b3Friction2(x){
return 0.000044*Math.pow(x,3)-
0.006*Math.pow(x,2)+0.36*x+2;
}

function b3Friction3(x){
return 0.00000045*Math.pow(x,3)-
0.000332*Math.pow(x,2)+0.1078*x+5.84;
}

function b3Nobounce(tension){
if(tension<=18){
return b3Friction1(tension);
}else if(tension>18&&tension<=44){
return b3Friction2(tension);
}else{
return b3Friction3(tension);
}
}

var b=normalize(bounciness/1.7,0,20);
b=projectNormal(b,0,0.8);
var s=normalize(speed/1.7,0,20);
var bouncyTension=projectNormal(s,0.5,200);
var bouncyFriction=quadraticOutInterpolation(
b,
b3Nobounce(bouncyTension),
0.01);


return{
tension:tensionFromOrigamiValue(bouncyTension),
friction:frictionFromOrigamiValue(bouncyFriction)};

}

module.exports={
fromOrigamiTensionAndFriction:fromOrigamiTensionAndFriction,
fromBouncinessAndSpeed:fromBouncinessAndSpeed};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var React=__webpack_require__(0);
var AnimatedProps=__webpack_require__(159);
var ApplyAnimatedValues=__webpack_require__(161);

function createAnimatedComponent(Component){
var refName='node';var

AnimatedComponent=function(_React$Component){_inherits(AnimatedComponent,_React$Component);function AnimatedComponent(){_classCallCheck(this,AnimatedComponent);return _possibleConstructorReturn(this,(AnimatedComponent.__proto__||Object.getPrototypeOf(AnimatedComponent)).apply(this,arguments));}_createClass(AnimatedComponent,[{key:'componentWillUnmount',value:function componentWillUnmount()


{
this._propsAnimated&&this._propsAnimated.__detach();
}},{key:'setNativeProps',value:function setNativeProps(

props){
var didUpdate=ApplyAnimatedValues.current(this.refs[refName],props,this);
if(didUpdate===false){
this.forceUpdate();
}
}},{key:'componentWillMount',value:function componentWillMount()

{
this.attachProps(this.props);
}},{key:'attachProps',value:function attachProps(

nextProps){var _this2=this;
var oldPropsAnimated=this._propsAnimated;







var callback=function callback(){
var didUpdate=ApplyAnimatedValues.current(_this2.refs[refName],_this2._propsAnimated.__getAnimatedValue(),_this2);
if(didUpdate===false){
_this2.forceUpdate();
}
};

this._propsAnimated=new AnimatedProps(
nextProps,
callback);










oldPropsAnimated&&oldPropsAnimated.__detach();
}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(

nextProps){
this.attachProps(nextProps);
}},{key:'render',value:function render()

{
return(
React.createElement(Component,_extends({},
this._propsAnimated.__getValue(),{
ref:refName})));


}}]);return AnimatedComponent;}(React.Component);

AnimatedComponent.propTypes={
style:function style(props,propName,componentName){
if(!Component.propTypes){
return;
}














}};


return AnimatedComponent;
}

module.exports=createAnimatedComponent;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var Animated=__webpack_require__(13);
var AnimatedWithChildren=__webpack_require__(22);
var AnimatedTransform=__webpack_require__(324);
var FlattenStyle=__webpack_require__(160);var

AnimatedStyle=function(_AnimatedWithChildren){_inherits(AnimatedStyle,_AnimatedWithChildren);


function AnimatedStyle(style){_classCallCheck(this,AnimatedStyle);var _this=_possibleConstructorReturn(this,(AnimatedStyle.__proto__||Object.getPrototypeOf(AnimatedStyle)).call(this));

style=FlattenStyle.current(style)||{};
if(style.transform&&!(style.transform instanceof Animated)){
style=_extends({},
style,{
transform:new AnimatedTransform(style.transform)});

}
_this._style=style;return _this;
}_createClass(AnimatedStyle,[{key:'__getValue',value:function __getValue()

{
var style={};
for(var key in this._style){
var value=this._style[key];
if(value instanceof Animated){
style[key]=value.__getValue();
}else{
style[key]=value;
}
}
return style;
}},{key:'__getAnimatedValue',value:function __getAnimatedValue()

{
var style={};
for(var key in this._style){
var value=this._style[key];
if(value instanceof Animated){
style[key]=value.__getAnimatedValue();
}
}
return style;
}},{key:'__attach',value:function __attach()

{
for(var key in this._style){
var value=this._style[key];
if(value instanceof Animated){
value.__addChild(this);
}
}
}},{key:'__detach',value:function __detach()

{
for(var key in this._style){
var value=this._style[key];
if(value instanceof Animated){
value.__removeChild(this);
}
}
}}]);return AnimatedStyle;}(AnimatedWithChildren);


module.exports=AnimatedStyle;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";










var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var Animated=__webpack_require__(13);
var AnimatedWithChildren=__webpack_require__(22);var

AnimatedTransform=function(_AnimatedWithChildren){_inherits(AnimatedTransform,_AnimatedWithChildren);


function AnimatedTransform(transforms){_classCallCheck(this,AnimatedTransform);var _this=_possibleConstructorReturn(this,(AnimatedTransform.__proto__||Object.getPrototypeOf(AnimatedTransform)).call(this));

_this._transforms=transforms;return _this;
}_createClass(AnimatedTransform,[{key:'__getValue',value:function __getValue()

{
return this._transforms.map(function(transform){
var result={};
for(var key in transform){
var value=transform[key];
if(value instanceof Animated){
result[key]=value.__getValue();
}else{
result[key]=value;
}
}
return result;
});
}},{key:'__getAnimatedValue',value:function __getAnimatedValue()

{
return this._transforms.map(function(transform){
var result={};
for(var key in transform){
var value=transform[key];
if(value instanceof Animated){
result[key]=value.__getAnimatedValue();
}else{

result[key]=value;
}
}
return result;
});
}},{key:'__attach',value:function __attach()

{var _this2=this;
this._transforms.forEach(function(transform){
for(var key in transform){
var value=transform[key];
if(value instanceof Animated){
value.__addChild(_this2);
}
}
});
}},{key:'__detach',value:function __detach()

{var _this3=this;
this._transforms.forEach(function(transform){
for(var key in transform){
var value=transform[key];
if(value instanceof Animated){
value.__removeChild(_this3);
}
}
});
}}]);return AnimatedTransform;}(AnimatedWithChildren);


module.exports=AnimatedTransform;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createDOMProps=__webpack_require__(146);var _createDOMProps2=_interopRequireDefault(_createDOMProps);var _findNodeHandle=__webpack_require__(42);var _findNodeHandle2=_interopRequireDefault(_findNodeHandle);var _i18nStyle=__webpack_require__(152);var _i18nStyle2=_interopRequireDefault(_i18nStyle);var _registry=__webpack_require__(89);var _registry2=_interopRequireDefault(_registry);var _UIManager=__webpack_require__(43);var _UIManager2=_interopRequireDefault(_UIManager);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var hyphenPattern=/-([a-z])/g;var toCamelCase=function toCamelCase(str){return str.replace(hyphenPattern,function(m){return m[1].toUpperCase();});};var NativeMethodsMixin={blur:function blur(){_UIManager2.default.blur((0,_findNodeHandle2.default)(this));},focus:function focus(){_UIManager2.default.focus((0,_findNodeHandle2.default)(this));},measure:function measure(callback){_UIManager2.default.measure((0,_findNodeHandle2.default)(this),callback);},measureInWindow:function measureInWindow(callback){_UIManager2.default.measureInWindow((0,_findNodeHandle2.default)(this),callback);},measureLayout:function measureLayout(relativeToNativeNode,onSuccess,onFail){_UIManager2.default.measureLayout((0,_findNodeHandle2.default)(this),relativeToNativeNode,onFail,onSuccess);},setNativeProps:function setNativeProps(nativeProps){var node=(0,_findNodeHandle2.default)(this);var nodeStyle=node.style;var classList=Array.prototype.slice.call(node.classList);var style={};for(var i=0;i<node.style.length;i+=1){var property=nodeStyle.item(i);if(property){style[toCamelCase(property)]=nodeStyle.getPropertyValue(property);}}var domStyleProps={classList:classList,style:style};var domProps=(0,_createDOMProps2.default)(null,(0,_i18nStyle2.default)(nativeProps),function(style){return _registry2.default.resolveStateful(style,domStyleProps,{i18n:false});});_UIManager2.default.updateView(node,domProps,this);}};exports.default=NativeMethodsMixin;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var nativeRequestAnimationFrame = global.requestAnimationFrame || global.webkitRequestAnimationFrame || global.mozRequestAnimationFrame || global.oRequestAnimationFrame || global.msRequestAnimationFrame;

module.exports = nativeRequestAnimationFrame;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



// setimmediate adds setImmediate to the global. We want to make sure we export
// the actual function.

__webpack_require__(328);
module.exports = global.setImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(329)))

/***/ }),
/* 329 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _dangerousStyleValue=__webpack_require__(331);var _dangerousStyleValue2=_interopRequireDefault(_dangerousStyleValue);var _warnValidStyle=__webpack_require__(332);var _warnValidStyle2=_interopRequireDefault(_warnValidStyle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var setValueForStyles=function setValueForStyles(node,styles,component){var style=node.style;for(var styleName in styles){if(!styles.hasOwnProperty(styleName)){continue;}var isCustomProperty=styleName.indexOf('--')===0;if(false){if(!isCustomProperty){(0,_warnValidStyle2.default)(styleName,styles[styleName],component);}}var styleValue=(0,_dangerousStyleValue2.default)(styleName,styles[styleName],isCustomProperty);if(styleName==='float'){styleName='cssFloat';}if(isCustomProperty){style.setProperty(styleName,styleValue);}else if(styleValue){style[styleName]=styleValue;}else{style[styleName]='';}}};exports.default=setValueForStyles;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _unitlessNumbers=__webpack_require__(150);var _unitlessNumbers2=_interopRequireDefault(_unitlessNumbers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function dangerousStyleValue(name,value,isCustomProperty){var isEmpty=value==null||typeof value==='boolean'||value==='';if(isEmpty){return'';}if(!isCustomProperty&&typeof value==='number'&&value!==0&&!(_unitlessNumbers2.default.hasOwnProperty(name)&&_unitlessNumbers2.default[name])){return value+'px';}return(''+value).trim();}exports.default=dangerousStyleValue;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var emptyFunction=__webpack_require__(27);var warnValidStyle=emptyFunction;if(false){var camelizeStyleName=require('fbjs/lib/camelizeStyleName');var warning=require('fbjs/lib/warning');function getComponentName(instanceOrFiber){if(typeof instanceOrFiber.getName==='function'){var instance=instanceOrFiber;return instance.getName();}if(typeof instanceOrFiber.tag==='number'){var fiber=instanceOrFiber;var type=fiber.type;if(typeof type==='string'){return type;}if(typeof type==='function'){return type.displayName||type.name;}}return null;}var badVendoredStyleNamePattern=/^(?:webkit|moz|o)[A-Z]/;var badStyleValueWithSemicolonPattern=/;\s*$/;var warnedStyleNames={};var warnedStyleValues={};var warnedForNaNValue=false;var warnedForInfinityValue=false;var warnHyphenatedStyleName=function warnHyphenatedStyleName(name,owner){if(warnedStyleNames.hasOwnProperty(name)&&warnedStyleNames[name]){return;}warnedStyleNames[name]=true;warning(false,'Unsupported style property %s. Did you mean %s?%s',name,camelizeStyleName(name),checkRenderMessage(owner));};var warnBadVendoredStyleName=function warnBadVendoredStyleName(name,owner){if(warnedStyleNames.hasOwnProperty(name)&&warnedStyleNames[name]){return;}warnedStyleNames[name]=true;warning(false,'Unsupported vendor-prefixed style property %s. Did you mean %s?%s',name,name.charAt(0).toUpperCase()+name.slice(1),checkRenderMessage(owner));};var warnStyleValueWithSemicolon=function warnStyleValueWithSemicolon(name,value,owner){if(warnedStyleValues.hasOwnProperty(value)&&warnedStyleValues[value]){return;}warnedStyleValues[value]=true;warning(false,"Style property values shouldn't contain a semicolon.%s "+'Try "%s: %s" instead.',checkRenderMessage(owner),name,value.replace(badStyleValueWithSemicolonPattern,''));};var warnStyleValueIsNaN=function warnStyleValueIsNaN(name,value,owner){if(warnedForNaNValue){return;}warnedForNaNValue=true;warning(false,'`NaN` is an invalid value for the `%s` css style property.%s',name,checkRenderMessage(owner));};var warnStyleValueIsInfinity=function warnStyleValueIsInfinity(name,value,owner){if(warnedForInfinityValue){return;}warnedForInfinityValue=true;warning(false,'`Infinity` is an invalid value for the `%s` css style property.%s',name,checkRenderMessage(owner));};var checkRenderMessage=function checkRenderMessage(owner){var ownerName;if(owner!=null){ownerName=getComponentName(owner);}else{}if(ownerName){return'\n\nCheck the render method of `'+ownerName+'`.';}return'';};warnValidStyle=function warnValidStyle(name,value,component){var owner;if(component){}if(name.indexOf('-')>-1){warnHyphenatedStyleName(name,owner);}else if(badVendoredStyleNamePattern.test(name)){warnBadVendoredStyleName(name,owner);}else if(badStyleValueWithSemicolonPattern.test(value)){warnStyleValueWithSemicolon(name,value,owner);}if(typeof value==='number'){if(isNaN(value)){warnStyleValueIsNaN(name,value,owner);}else if(!isFinite(value)){warnStyleValueIsInfinity(name,value,owner);}}};}exports.default=warnValidStyle;

/***/ }),
/* 333 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});exports.registerAsset=registerAsset;exports.getAssetByID=getAssetByID;var assets=[];function registerAsset(asset){return assets.push(asset);}function getAssetByID(assetId){return assets[assetId-1];}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var id=0;var requests={};var ImageLoader={abort:function abort(requestId){var image=requests[''+requestId];if(image){image.onerror=image.onload=image=null;delete requests[''+requestId];}},getSize:function getSize(uri,success,failure){var complete=false;var interval=setInterval(callback,16);var requestId=ImageLoader.load(uri,callback,errorCallback);function callback(){var image=requests[''+requestId];if(image){var naturalHeight=image.naturalHeight,naturalWidth=image.naturalWidth;if(naturalHeight&&naturalWidth){success(naturalWidth,naturalHeight);complete=true;}}if(complete){ImageLoader.abort(requestId);clearInterval(interval);}}function errorCallback(){if(typeof failure==='function'){failure();}ImageLoader.abort(requestId);clearInterval(interval);}},load:function load(uri,onLoad,onError){id+=1;var image=new window.Image();image.onerror=onError;image.onload=onLoad;image.src=uri;requests[''+id]=image;return id;},prefetch:function prefetch(uri){return new Promise(function(resolve,reject){ImageLoader.load(uri,resolve,reject);});}};exports.default=ImageLoader;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _BorderPropTypes=__webpack_require__(165);var _BorderPropTypes2=_interopRequireDefault(_BorderPropTypes);var _ColorPropType=__webpack_require__(14);var _ColorPropType2=_interopRequireDefault(_ColorPropType);var _ImageResizeMode=__webpack_require__(164);var _ImageResizeMode2=_interopRequireDefault(_ImageResizeMode);var _LayoutPropTypes=__webpack_require__(166);var _LayoutPropTypes2=_interopRequireDefault(_LayoutPropTypes);var _ShadowPropTypes=__webpack_require__(167);var _ShadowPropTypes2=_interopRequireDefault(_ShadowPropTypes);var _TransformPropTypes=__webpack_require__(168);var _TransformPropTypes2=_interopRequireDefault(_TransformPropTypes);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ImageStylePropTypes=_extends({},_BorderPropTypes2.default,_LayoutPropTypes2.default,_ShadowPropTypes2.default,_TransformPropTypes2.default,{backgroundColor:_ColorPropType2.default,opacity:_propTypes.number,resizeMode:(0,_propTypes.oneOf)(Object.keys(_ImageResizeMode2.default)),overlayColor:_propTypes.string,tintColor:_ColorPropType2.default,boxShadow:_propTypes.string});exports.default=ImageStylePropTypes;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(27);
var invariant = __webpack_require__(8);
var ReactPropTypesSecret = __webpack_require__(337);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 338 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var dataUriPattern=/^data:/;var ImageUriCache=function(){function ImageUriCache(){_classCallCheck(this,ImageUriCache);}_createClass(ImageUriCache,null,[{key:"has",value:function has(uri){var entries=ImageUriCache._entries;var isDataUri=dataUriPattern.test(uri);return isDataUri||Boolean(entries[uri]);}},{key:"add",value:function add(uri){var entries=ImageUriCache._entries;var lastUsedTimestamp=Date.now();if(entries[uri]){entries[uri].lastUsedTimestamp=lastUsedTimestamp;entries[uri].refCount+=1;}else{entries[uri]={lastUsedTimestamp:lastUsedTimestamp,refCount:1};}}},{key:"remove",value:function remove(uri){var entries=ImageUriCache._entries;if(entries[uri]){entries[uri].refCount-=1;}ImageUriCache._cleanUpIfNeeded();}},{key:"_cleanUpIfNeeded",value:function _cleanUpIfNeeded(){var entries=ImageUriCache._entries;var imageUris=Object.keys(entries);if(imageUris.length+1>ImageUriCache._maximumEntries){var leastRecentlyUsedKey=void 0;var leastRecentlyUsedEntry=void 0;imageUris.forEach(function(uri){var entry=entries[uri];if((!leastRecentlyUsedEntry||entry.lastUsedTimestamp<leastRecentlyUsedEntry.lastUsedTimestamp)&&entry.refCount===0){leastRecentlyUsedKey=uri;leastRecentlyUsedEntry=entry;}});if(leastRecentlyUsedKey){delete entries[leastRecentlyUsedKey];}}}}]);return ImageUriCache;}();ImageUriCache._maximumEntries=256;ImageUriCache._entries={};exports.default=ImageUriCache;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.cancelIdleCallback=undefined;var _ExecutionEnvironment=__webpack_require__(16);var _requestIdleCallback=function _requestIdleCallback(cb){return setTimeout(function(){var start=Date.now();cb({didTimeout:false,timeRemaining:function timeRemaining(){return Math.max(0,50-(Date.now()-start));}});},1);};var _cancelIdleCallback=function _cancelIdleCallback(id){clearTimeout(id);};var isSupported=_ExecutionEnvironment.canUseDOM&&typeof window.requestIdleCallback!=='undefined';var requestIdleCallback=isSupported?window.requestIdleCallback:_requestIdleCallback;var cancelIdleCallback=isSupported?window.cancelIdleCallback:_cancelIdleCallback;exports.default=requestIdleCallback;exports.cancelIdleCallback=cancelIdleCallback;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _propTypes=__webpack_require__(3);var AnimationPropTypes={animationDelay:_propTypes.string,animationDirection:(0,_propTypes.oneOf)(['alternate','alternate-reverse','normal','reverse']),animationDuration:_propTypes.string,animationFillMode:(0,_propTypes.oneOf)(['none','forwards','backwards','both']),animationIterationCount:(0,_propTypes.oneOfType)([_propTypes.number,(0,_propTypes.oneOf)(['infinite'])]),animationName:_propTypes.string,animationPlayState:(0,_propTypes.oneOf)(['paused','running']),animationTimingFunction:_propTypes.string};exports.default=AnimationPropTypes;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(51);

var emptyObject = __webpack_require__(86);
var _invariant = __webpack_require__(8);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _Dimensions=__webpack_require__(67);var _Dimensions2=_interopRequireDefault(_Dimensions);var _findNodeHandle=__webpack_require__(42);var _findNodeHandle2=_interopRequireDefault(_findNodeHandle);var _invariant=__webpack_require__(8);var _invariant2=_interopRequireDefault(_invariant);var _Platform=__webpack_require__(99);var _Platform2=_interopRequireDefault(_Platform);var _TextInputState=__webpack_require__(98);var _TextInputState2=_interopRequireDefault(_TextInputState);var _UIManager=__webpack_require__(43);var _UIManager2=_interopRequireDefault(_UIManager);var _warning=__webpack_require__(68);var _warning2=_interopRequireDefault(_warning);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var emptyObject={};var IS_ANIMATING_TOUCH_START_THRESHOLD_MS=16;var ScrollResponderMixin={scrollResponderMixinGetInitialState:function scrollResponderMixinGetInitialState(){return{isTouching:false,lastMomentumScrollBeginTime:0,lastMomentumScrollEndTime:0,observedScrollSinceBecomingResponder:false,becameResponderWhileAnimating:false};},scrollResponderHandleScrollShouldSetResponder:function scrollResponderHandleScrollShouldSetResponder(){return this.state.isTouching;},scrollResponderHandleStartShouldSetResponder:function scrollResponderHandleStartShouldSetResponder(){return false;},scrollResponderHandleStartShouldSetResponderCapture:function scrollResponderHandleStartShouldSetResponderCapture(e){return this.scrollResponderIsAnimating();},scrollResponderHandleResponderReject:function scrollResponderHandleResponderReject(){(0,_warning2.default)(false,"ScrollView doesn't take rejection well - scrolls anyway");},scrollResponderHandleTerminationRequest:function scrollResponderHandleTerminationRequest(){return!this.state.observedScrollSinceBecomingResponder;},scrollResponderHandleTouchEnd:function scrollResponderHandleTouchEnd(e){var nativeEvent=e.nativeEvent;this.state.isTouching=nativeEvent.touches.length!==0;this.props.onTouchEnd&&this.props.onTouchEnd(e);},scrollResponderHandleResponderRelease:function scrollResponderHandleResponderRelease(e){this.props.onResponderRelease&&this.props.onResponderRelease(e);var currentlyFocusedTextInput=_TextInputState2.default.currentlyFocusedField();if(!this.props.keyboardShouldPersistTaps&&currentlyFocusedTextInput!=null&&e.target!==currentlyFocusedTextInput&&!this.state.observedScrollSinceBecomingResponder&&!this.state.becameResponderWhileAnimating){this.props.onScrollResponderKeyboardDismissed&&this.props.onScrollResponderKeyboardDismissed(e);_TextInputState2.default.blurTextInput(currentlyFocusedTextInput);}},scrollResponderHandleScroll:function scrollResponderHandleScroll(e){this.state.observedScrollSinceBecomingResponder=true;this.props.onScroll&&this.props.onScroll(e);},scrollResponderHandleResponderGrant:function scrollResponderHandleResponderGrant(e){this.state.observedScrollSinceBecomingResponder=false;this.props.onResponderGrant&&this.props.onResponderGrant(e);this.state.becameResponderWhileAnimating=this.scrollResponderIsAnimating();},scrollResponderHandleScrollBeginDrag:function scrollResponderHandleScrollBeginDrag(e){this.props.onScrollBeginDrag&&this.props.onScrollBeginDrag(e);},scrollResponderHandleScrollEndDrag:function scrollResponderHandleScrollEndDrag(e){this.props.onScrollEndDrag&&this.props.onScrollEndDrag(e);},scrollResponderHandleMomentumScrollBegin:function scrollResponderHandleMomentumScrollBegin(e){this.state.lastMomentumScrollBeginTime=Date.now();this.props.onMomentumScrollBegin&&this.props.onMomentumScrollBegin(e);},scrollResponderHandleMomentumScrollEnd:function scrollResponderHandleMomentumScrollEnd(e){this.state.lastMomentumScrollEndTime=Date.now();this.props.onMomentumScrollEnd&&this.props.onMomentumScrollEnd(e);},scrollResponderHandleTouchStart:function scrollResponderHandleTouchStart(e){this.state.isTouching=true;this.props.onTouchStart&&this.props.onTouchStart(e);},scrollResponderHandleTouchMove:function scrollResponderHandleTouchMove(e){this.props.onTouchMove&&this.props.onTouchMove(e);},scrollResponderIsAnimating:function scrollResponderIsAnimating(){var now=Date.now();var timeSinceLastMomentumScrollEnd=now-this.state.lastMomentumScrollEndTime;var isAnimating=timeSinceLastMomentumScrollEnd<IS_ANIMATING_TOUCH_START_THRESHOLD_MS||this.state.lastMomentumScrollEndTime<this.state.lastMomentumScrollBeginTime;return isAnimating;},scrollResponderGetScrollableNode:function scrollResponderGetScrollableNode(){return this.getScrollableNode?this.getScrollableNode():(0,_findNodeHandle2.default)(this);},scrollResponderScrollTo:function scrollResponderScrollTo(x,y,animated){if(typeof x==='number'){console.warn('`scrollResponderScrollTo(x, y, animated)` is deprecated. Use `scrollResponderScrollTo({x: 5, y: 5, animated: true})` instead.');}else{var _ref=x||emptyObject;x=_ref.x;y=_ref.y;animated=_ref.animated;}var node=this.scrollResponderGetScrollableNode();node.scrollLeft=x||0;node.scrollTop=y||0;},scrollResponderScrollWithoutAnimationTo:function scrollResponderScrollWithoutAnimationTo(offsetX,offsetY){console.warn('`scrollResponderScrollWithoutAnimationTo` is deprecated. Use `scrollResponderScrollTo` instead');this.scrollResponderScrollTo({x:offsetX,y:offsetY,animated:false});},scrollResponderZoomTo:function scrollResponderZoomTo(rect,animated){if(_Platform2.default.OS!=='ios'){(0,_invariant2.default)('zoomToRect is not implemented');}},scrollResponderScrollNativeHandleToKeyboard:function scrollResponderScrollNativeHandleToKeyboard(nodeHandle,additionalOffset,preventNegativeScrollOffset){this.additionalScrollOffset=additionalOffset||0;this.preventNegativeScrollOffset=!!preventNegativeScrollOffset;_UIManager2.default.measureLayout(nodeHandle,(0,_findNodeHandle2.default)(this.getInnerViewNode()),this.scrollResponderTextInputFocusError,this.scrollResponderInputMeasureAndScrollToKeyboard);},scrollResponderInputMeasureAndScrollToKeyboard:function scrollResponderInputMeasureAndScrollToKeyboard(left,top,width,height){var keyboardScreenY=_Dimensions2.default.get('window').height;if(this.keyboardWillOpenTo){keyboardScreenY=this.keyboardWillOpenTo.endCoordinates.screenY;}var scrollOffsetY=top-keyboardScreenY+height+this.additionalScrollOffset;if(this.preventNegativeScrollOffset){scrollOffsetY=Math.max(0,scrollOffsetY);}this.scrollResponderScrollTo({x:0,y:scrollOffsetY,animated:true});this.additionalOffset=0;this.preventNegativeScrollOffset=false;},scrollResponderTextInputFocusError:function scrollResponderTextInputFocusError(e){console.error('Error measuring text field: ',e);},componentWillMount:function componentWillMount(){this.keyboardWillOpenTo=null;this.additionalScrollOffset=0;},scrollResponderKeyboardWillShow:function scrollResponderKeyboardWillShow(e){this.keyboardWillOpenTo=e;this.props.onKeyboardWillShow&&this.props.onKeyboardWillShow(e);},scrollResponderKeyboardWillHide:function scrollResponderKeyboardWillHide(e){this.keyboardWillOpenTo=null;this.props.onKeyboardWillHide&&this.props.onKeyboardWillHide(e);},scrollResponderKeyboardDidShow:function scrollResponderKeyboardDidShow(e){if(e){this.keyboardWillOpenTo=e;}this.props.onKeyboardDidShow&&this.props.onKeyboardDidShow(e);},scrollResponderKeyboardDidHide:function scrollResponderKeyboardDidHide(e){this.keyboardWillOpenTo=null;this.props.onKeyboardDidHide&&this.props.onKeyboardDidHide(e);}};var ScrollResponder={Mixin:ScrollResponderMixin};exports.default=ScrollResponder;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='src/components/ScrollView/ScrollViewBase.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _debounce=__webpack_require__(94);var _debounce2=_interopRequireDefault(_debounce);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _View=__webpack_require__(11);var _View2=_interopRequireDefault(_View);var _ViewPropTypes=__webpack_require__(15);var _ViewPropTypes2=_interopRequireDefault(_ViewPropTypes);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var normalizeScrollEvent=function normalizeScrollEvent(e){return{nativeEvent:{contentOffset:{get x(){return e.target.scrollLeft;},get y(){return e.target.scrollTop;}},contentSize:{get height(){return e.target.scrollHeight;},get width(){return e.target.scrollWidth;}},layoutMeasurement:{get height(){return e.target.offsetHeight;},get width(){return e.target.offsetWidth;}}},timeStamp:Date.now()};};var ScrollViewBase=function(_Component){_inherits(ScrollViewBase,_Component);function ScrollViewBase(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ScrollViewBase);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ScrollViewBase.__proto__||Object.getPrototypeOf(ScrollViewBase)).call.apply(_ref,[this].concat(args))),_this),_this._debouncedOnScrollEnd=(0,_debounce2.default)(_this._handleScrollEnd,100),_this._state={isScrolling:false,scrollLastTick:0},_this._createPreventableScrollHandler=function(handler){return function(e){if(_this.props.scrollEnabled){if(handler){handler(e);}}else{e.preventDefault();}};},_this._handleScroll=function(e){e.persist();e.stopPropagation();var scrollEventThrottle=_this.props.scrollEventThrottle;_this._debouncedOnScrollEnd(e);if(_this._state.isScrolling){if(_this._shouldEmitScrollEvent(_this._state.scrollLastTick,scrollEventThrottle)){_this._handleScrollTick(e);}}else{_this._handleScrollStart(e);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ScrollViewBase,[{key:'_handleScrollStart',value:function _handleScrollStart(e){this._state.isScrolling=true;this._state.scrollLastTick=Date.now();}},{key:'_handleScrollTick',value:function _handleScrollTick(e){var onScroll=this.props.onScroll;this._state.scrollLastTick=Date.now();if(onScroll){onScroll(normalizeScrollEvent(e));}}},{key:'_handleScrollEnd',value:function _handleScrollEnd(e){var onScroll=this.props.onScroll;this._state.isScrolling=false;if(onScroll){onScroll(normalizeScrollEvent(e));}}},{key:'_shouldEmitScrollEvent',value:function _shouldEmitScrollEvent(lastTick,eventThrottle){var timeSinceLastTick=Date.now()-lastTick;return eventThrottle>0&&timeSinceLastTick>=eventThrottle;}},{key:'render',value:function render(){var _props=this.props,scrollEnabled=_props.scrollEnabled,style=_props.style,alwaysBounceHorizontal=_props.alwaysBounceHorizontal,alwaysBounceVertical=_props.alwaysBounceVertical,automaticallyAdjustContentInsets=_props.automaticallyAdjustContentInsets,bounces=_props.bounces,bouncesZoom=_props.bouncesZoom,canCancelContentTouches=_props.canCancelContentTouches,centerContent=_props.centerContent,contentInset=_props.contentInset,contentInsetAdjustmentBehavior=_props.contentInsetAdjustmentBehavior,contentOffset=_props.contentOffset,decelerationRate=_props.decelerationRate,directionalLockEnabled=_props.directionalLockEnabled,endFillColor=_props.endFillColor,indicatorStyle=_props.indicatorStyle,keyboardShouldPersistTaps=_props.keyboardShouldPersistTaps,maximumZoomScale=_props.maximumZoomScale,minimumZoomScale=_props.minimumZoomScale,onMomentumScrollBegin=_props.onMomentumScrollBegin,onMomentumScrollEnd=_props.onMomentumScrollEnd,onScrollBeginDrag=_props.onScrollBeginDrag,onScrollEndDrag=_props.onScrollEndDrag,overScrollMode=_props.overScrollMode,pinchGestureEnabled=_props.pinchGestureEnabled,removeClippedSubviews=_props.removeClippedSubviews,scrollEventThrottle=_props.scrollEventThrottle,scrollIndicatorInsets=_props.scrollIndicatorInsets,scrollPerfTag=_props.scrollPerfTag,scrollsToTop=_props.scrollsToTop,showsHorizontalScrollIndicator=_props.showsHorizontalScrollIndicator,showsVerticalScrollIndicator=_props.showsVerticalScrollIndicator,snapToInterval=_props.snapToInterval,snapToAlignment=_props.snapToAlignment,zoomScale=_props.zoomScale,other=_objectWithoutProperties(_props,['scrollEnabled','style','alwaysBounceHorizontal','alwaysBounceVertical','automaticallyAdjustContentInsets','bounces','bouncesZoom','canCancelContentTouches','centerContent','contentInset','contentInsetAdjustmentBehavior','contentOffset','decelerationRate','directionalLockEnabled','endFillColor','indicatorStyle','keyboardShouldPersistTaps','maximumZoomScale','minimumZoomScale','onMomentumScrollBegin','onMomentumScrollEnd','onScrollBeginDrag','onScrollEndDrag','overScrollMode','pinchGestureEnabled','removeClippedSubviews','scrollEventThrottle','scrollIndicatorInsets','scrollPerfTag','scrollsToTop','showsHorizontalScrollIndicator','showsVerticalScrollIndicator','snapToInterval','snapToAlignment','zoomScale']);return _react2.default.createElement(_View2.default,_extends({},other,{onScroll:this._handleScroll,onTouchMove:this._createPreventableScrollHandler(this.props.onTouchMove),onWheel:this._createPreventableScrollHandler(this.props.onWheel),style:[style,!scrollEnabled&&styles.scrollDisabled],__source:{fileName:_jsxFileName,lineNumber:175}}));}}]);return ScrollViewBase;}(_react.Component);ScrollViewBase.defaultProps={scrollEnabled:true,scrollEventThrottle:0};exports.default=ScrollViewBase;ScrollViewBase.propTypes= false?_extends({},_ViewPropTypes2.default,{onMomentumScrollBegin:_propTypes.func,onMomentumScrollEnd:_propTypes.func,onScroll:_propTypes.func,onScrollBeginDrag:_propTypes.func,onScrollEndDrag:_propTypes.func,onTouchMove:_propTypes.func,onWheel:_propTypes.func,removeClippedSubviews:_propTypes.bool,scrollEnabled:_propTypes.bool,scrollEventThrottle:_propTypes.number,showsHorizontalScrollIndicator:_propTypes.bool,showsVerticalScrollIndicator:_propTypes.bool}):{};var styles=_StyleSheet2.default.create({scrollDisabled:{touchAction:'none'}});

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _invariant=__webpack_require__(8);var _invariant2=_interopRequireDefault(_invariant);var _reactDom=__webpack_require__(33);var _renderApplication=__webpack_require__(345);var _renderApplication2=_interopRequireDefault(_renderApplication);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var emptyObject={};var runnables={};var AppRegistry=function(){function AppRegistry(){_classCallCheck(this,AppRegistry);}_createClass(AppRegistry,null,[{key:'getAppKeys',value:function getAppKeys(){return Object.keys(runnables);}},{key:'getApplication',value:function getApplication(appKey,appParameters){(0,_invariant2.default)(runnables[appKey]&&runnables[appKey].getApplication,'Application '+appKey+' has not been registered. '+'This is either due to an import error during initialization or failure to call AppRegistry.registerComponent.');return runnables[appKey].getApplication(appParameters);}},{key:'registerComponent',value:function registerComponent(appKey,getComponentFunc){runnables[appKey]={getApplication:function getApplication(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:emptyObject,initialProps=_ref.initialProps;return(0,_renderApplication.getApplication)(getComponentFunc(),initialProps);},run:function run(_ref2){var _ref2$initialProps=_ref2.initialProps,initialProps=_ref2$initialProps===undefined?emptyObject:_ref2$initialProps,rootTag=_ref2.rootTag;return(0,_renderApplication2.default)(getComponentFunc(),initialProps,rootTag);}};return appKey;}},{key:'registerConfig',value:function registerConfig(config){config.forEach(function(_ref3){var appKey=_ref3.appKey,component=_ref3.component,run=_ref3.run;if(run){AppRegistry.registerRunnable(appKey,run);}else{(0,_invariant2.default)(component,'No component provider passed in');AppRegistry.registerComponent(appKey,component);}});}},{key:'registerRunnable',value:function registerRunnable(appKey,run){runnables[appKey]={run:run};return appKey;}},{key:'runApplication',value:function runApplication(appKey,appParameters){var isDevelopment="production"!=='production';var params=_extends({},appParameters);params.rootTag='#'+params.rootTag.id;console.log('Running application "'+appKey+'" with appParams: '+JSON.stringify(params)+'. '+('development-level warnings are '+(isDevelopment?'ON':'OFF')+', ')+('performance optimizations are '+(isDevelopment?'OFF':'ON')));(0,_invariant2.default)(runnables[appKey]&&runnables[appKey].run,'Application "'+appKey+'" has not been registered. '+'This is either due to an import error during initialization or failure to call AppRegistry.registerComponent.');runnables[appKey].run(appParameters);}},{key:'unmountApplicationComponentAtRootTag',value:function unmountApplicationComponentAtRootTag(rootTag){(0,_reactDom.unmountComponentAtNode)(rootTag);}}]);return AppRegistry;}();exports.default=AppRegistry;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='src/apis/AppRegistry/renderApplication.js';exports.default=renderApplication;exports.getApplication=getApplication;var _invariant=__webpack_require__(8);var _invariant2=_interopRequireDefault(_invariant);var _reactDom=__webpack_require__(33);var _AppContainer=__webpack_require__(346);var _AppContainer2=_interopRequireDefault(_AppContainer);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function renderApplication(RootComponent,initialProps,rootTag){(0,_invariant2.default)(rootTag,'Expect to have a valid rootTag, instead got ',rootTag);(0,_reactDom.render)(_react2.default.createElement(_AppContainer2.default,{rootTag:rootTag,__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement(RootComponent,_extends({},initialProps,{__source:{fileName:_jsxFileName,lineNumber:27}}))),rootTag);}function getApplication(RootComponent,initialProps){var element=_react2.default.createElement(_AppContainer2.default,{rootTag:{},__source:{fileName:_jsxFileName,lineNumber:35}},_react2.default.createElement(RootComponent,_extends({},initialProps,{__source:{fileName:_jsxFileName,lineNumber:36}})));var stylesheets=_StyleSheet2.default.getStyleSheets().map(function(sheet){return _react2.default.createElement('style',{dangerouslySetInnerHTML:{__html:sheet.textContent},id:sheet.id,__source:{fileName:_jsxFileName,lineNumber:41}});});return{element:element,stylesheets:stylesheets};}

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='src/apis/AppRegistry/AppContainer.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _View=__webpack_require__(11);var _View2=_interopRequireDefault(_View);var _propTypes=__webpack_require__(3);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AppContainer=function(_Component){_inherits(AppContainer,_Component);function AppContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AppContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AppContainer.__proto__||Object.getPrototypeOf(AppContainer)).call.apply(_ref,[this].concat(args))),_this),_this.state={mainKey:1},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AppContainer,[{key:'getChildContext',value:function getChildContext(){return{rootTag:this.props.rootTag};}},{key:'render',value:function render(){return _react2.default.createElement(_View2.default,{pointerEvents:'box-none',style:[styles.appContainer,_StyleSheet2.default.absoluteFill],__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_View2.default,{children:this.props.children,key:this.state.mainKey,pointerEvents:'box-none',style:styles.appContainer,__source:{fileName:_jsxFileName,lineNumber:52}}));}}]);return AppContainer;}(_react.Component);AppContainer.childContextTypes={rootTag:_propTypes.any};exports.default=AppContainer;AppContainer.propTypes= false?{children:_propTypes.node,rootTag:_propTypes.any.isRequired}:{};var styles=_StyleSheet2.default.create({appContainer:{flex:1}});

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _ExecutionEnvironment=__webpack_require__(16);var _arrayFindIndex=__webpack_require__(172);var _arrayFindIndex2=_interopRequireDefault(_arrayFindIndex);var _invariant=__webpack_require__(8);var _invariant2=_interopRequireDefault(_invariant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var isPrefixed=_ExecutionEnvironment.canUseDOM&&!document.hasOwnProperty('hidden')&&document.hasOwnProperty('webkitHidden');var EVENT_TYPES=['change'];var VISIBILITY_CHANGE_EVENT=isPrefixed?'webkitvisibilitychange':'visibilitychange';var VISIBILITY_STATE_PROPERTY=isPrefixed?'webkitVisibilityState':'visibilityState';var AppStates={BACKGROUND:'background',ACTIVE:'active'};var listeners=[];var AppState=function(){function AppState(){_classCallCheck(this,AppState);}_createClass(AppState,null,[{key:'addEventListener',value:function addEventListener(type,handler){if(AppState.isAvailable){(0,_invariant2.default)(EVENT_TYPES.indexOf(type)!==-1,'Trying to subscribe to unknown event: "%s"',type);var callback=function callback(){return handler(AppState.currentState);};listeners.push([handler,callback]);document.addEventListener(VISIBILITY_CHANGE_EVENT,callback,false);}}},{key:'removeEventListener',value:function removeEventListener(type,handler){if(AppState.isAvailable){(0,_invariant2.default)(EVENT_TYPES.indexOf(type)!==-1,'Trying to remove listener for unknown event: "%s"',type);var listenerIndex=(0,_arrayFindIndex2.default)(listeners,function(pair){return pair[0]===handler;});(0,_invariant2.default)(listenerIndex!==-1,'Trying to remove AppState listener for unregistered handler');var callback=listeners[listenerIndex][1];document.removeEventListener(VISIBILITY_CHANGE_EVENT,callback,false);listeners.splice(listenerIndex,1);}}},{key:'currentState',get:function get(){if(!AppState.isAvailable){return AppStates.ACTIVE;}switch(document[VISIBILITY_STATE_PROPERTY]){case'hidden':case'prerender':case'unloaded':return AppStates.BACKGROUND;default:return AppStates.ACTIVE;}}}]);return AppState;}();AppState.isAvailable=_ExecutionEnvironment.canUseDOM&&document[VISIBILITY_STATE_PROPERTY];exports.default=AppState;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _deepAssign=__webpack_require__(349);var _deepAssign2=_interopRequireDefault(_deepAssign);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var mergeLocalStorageItem=function mergeLocalStorageItem(key,value){var oldValue=window.localStorage.getItem(key);var oldObject=JSON.parse(oldValue);var newObject=JSON.parse(value);var nextValue=JSON.stringify((0,_deepAssign2.default)({},oldObject,newObject));window.localStorage.setItem(key,nextValue);};var createPromise=function createPromise(getValue,callback){return new Promise(function(resolve,reject){try{var value=getValue();if(callback){callback(null,value);}resolve(value);}catch(err){if(callback){callback(err);}reject(err);}});};var createPromiseAll=function createPromiseAll(promises,callback,processResult){return Promise.all(promises).then(function(result){var value=processResult?processResult(result):null;callback&&callback(null,value);return Promise.resolve(value);},function(errors){callback&&callback(errors);return Promise.reject(errors);});};var AsyncStorage=function(){function AsyncStorage(){_classCallCheck(this,AsyncStorage);}_createClass(AsyncStorage,null,[{key:'clear',value:function clear(callback){return createPromise(function(){window.localStorage.clear();},callback);}},{key:'flushGetRequests',value:function flushGetRequests(){}},{key:'getAllKeys',value:function getAllKeys(callback){return createPromise(function(){var numberOfKeys=window.localStorage.length;var keys=[];for(var i=0;i<numberOfKeys;i+=1){var key=window.localStorage.key(i);keys.push(key);}return keys;},callback);}},{key:'getItem',value:function getItem(key,callback){return createPromise(function(){return window.localStorage.getItem(key);},callback);}},{key:'multiGet',value:function multiGet(keys,callback){var promises=keys.map(function(key){return AsyncStorage.getItem(key);});var processResult=function processResult(result){return result.map(function(value,i){return[keys[i],value];});};return createPromiseAll(promises,callback,processResult);}},{key:'setItem',value:function setItem(key,value,callback){return createPromise(function(){window.localStorage.setItem(key,value);},callback);}},{key:'multiSet',value:function multiSet(keyValuePairs,callback){var promises=keyValuePairs.map(function(item){return AsyncStorage.setItem(item[0],item[1]);});return createPromiseAll(promises,callback);}},{key:'mergeItem',value:function mergeItem(key,value,callback){return createPromise(function(){mergeLocalStorageItem(key,value);},callback);}},{key:'multiMerge',value:function multiMerge(keyValuePairs,callback){var promises=keyValuePairs.map(function(item){return AsyncStorage.mergeItem(item[0],item[1]);});return createPromiseAll(promises,callback);}},{key:'removeItem',value:function removeItem(key,callback){return createPromise(function(){return window.localStorage.removeItem(key);},callback);}},{key:'multiRemove',value:function multiRemove(keys,callback){var promises=keys.map(function(key){return AsyncStorage.removeItem(key);});return createPromiseAll(promises,callback);}}]);return AsyncStorage;}();exports.default=AsyncStorage;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObj = __webpack_require__(350);
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Sources cannot be null or undefined');
	}

	return Object(val);
}

function assignKey(to, from, key) {
	var val = from[key];

	if (val === undefined || val === null) {
		return;
	}

	if (hasOwnProperty.call(to, key)) {
		if (to[key] === undefined || to[key] === null) {
			throw new TypeError('Cannot convert undefined or null to object (' + key + ')');
		}
	}

	if (!hasOwnProperty.call(to, key) || !isObj(val)) {
		to[key] = val;
	} else {
		to[key] = assign(Object(to[key]), from[key]);
	}
}

function assign(to, from) {
	if (to === from) {
		return to;
	}

	from = Object(from);

	for (var key in from) {
		if (hasOwnProperty.call(from, key)) {
			assignKey(to, from, key);
		}
	}

	if (Object.getOwnPropertySymbols) {
		var symbols = Object.getOwnPropertySymbols(from);

		for (var i = 0; i < symbols.length; i++) {
			if (propIsEnumerable.call(from, symbols[i])) {
				assignKey(to, from, symbols[i]);
			}
		}
	}

	return to;
}

module.exports = function deepAssign(target) {
	target = toObject(target);

	for (var s = 1; s < arguments.length; s++) {
		assign(target, arguments[s]);
	}

	return target;
};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (x) {
	var type = typeof x;
	return x !== null && (type === 'object' || type === 'function');
};


/***/ }),
/* 351 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});function emptyFunction(){}var BackHandler={exitApp:emptyFunction,addEventListener:function addEventListener(){return{remove:emptyFunction};},removeEventListener:emptyFunction};exports.default=BackHandler;

/***/ }),
/* 352 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Clipboard=function(){function Clipboard(){_classCallCheck(this,Clipboard);}_createClass(Clipboard,null,[{key:'isAvailable',value:function isAvailable(){return typeof document.queryCommandSupported==='function'&&document.queryCommandSupported('copy');}},{key:'getString',value:function getString(){return Promise.resolve('');}},{key:'setString',value:function setString(text){var success=false;var body=document.body;if(body){var node=document.createElement('span');node.textContent=text;node.style.position='absolute';node.style.opacity='0';body.appendChild(node);var selection=window.getSelection();selection.removeAllRanges();var range=document.createRange();range.selectNodeContents(node);selection.addRange(range);try{document.execCommand('copy');success=true;}catch(e){}selection.removeAllRanges();body.removeChild(node);}return success;}}]);return Clipboard;}();exports.default=Clipboard;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _Easing=__webpack_require__(158);var _Easing2=_interopRequireDefault(_Easing);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_Easing2.default;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _dismissKeyboard=__webpack_require__(169);var _dismissKeyboard2=_interopRequireDefault(_dismissKeyboard);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Keyboard={addListener:function addListener(){return{remove:function remove(){}};},dismiss:function dismiss(){(0,_dismissKeyboard2.default)();},removeAllListeners:function removeAllListeners(){},removeListener:function removeListener(){}};exports.default=Keyboard;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _invariant=__webpack_require__(8);var _invariant2=_interopRequireDefault(_invariant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var InteractionManager={Events:{interactionStart:'interactionStart',interactionComplete:'interactionComplete'},runAfterInteractions:function runAfterInteractions(callback){(0,_invariant2.default)(typeof callback==='function','Must specify a function to schedule.');callback();},createInteractionHandle:function createInteractionHandle(){return 1;},clearInteractionHandle:function clearInteractionHandle(handle){(0,_invariant2.default)(!!handle,'Must provide a handle to clear.');},addListener:function addListener(){}};exports.default=InteractionManager;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _ExecutionEnvironment=__webpack_require__(16);var initialURL=_ExecutionEnvironment.canUseDOM?window.location.href:'';var Linking={addEventListener:function addEventListener(){},removeEventListener:function removeEventListener(){},canOpenURL:function canOpenURL(){return Promise.resolve(true);},getInitialURL:function getInitialURL(){return Promise.resolve(initialURL);},openURL:function openURL(url){try{iframeOpen(url);return Promise.resolve();}catch(e){return Promise.reject(e);}}};var iframeOpen=function iframeOpen(url){var noOpener=url.indexOf('mailto:')!==0;var body=document.body;if(body){var iframe=document.createElement('iframe');iframe.style.display='none';body.appendChild(iframe);var iframeDoc=iframe.contentDocument||iframe.contentWindow.document;var iframeBody=iframeDoc.body;if(iframeBody){var script=iframeDoc.createElement('script');var openerExpression=noOpener?'child.opener = null':'';script.text='\n        window.parent = null; window.top = null; window.frameElement = null;\n        var child = window.open("'+url+'"); '+openerExpression+';\n      ';iframeBody.appendChild(script);}body.removeChild(iframe);}};exports.default=Linking;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[typeof Symbol==='function'?typeof Symbol==='function'?Symbol.iterator:'@@iterator':'@@iterator'](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if((typeof Symbol==='function'?typeof Symbol==='function'?Symbol.iterator:'@@iterator':'@@iterator')in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _ExecutionEnvironment=__webpack_require__(16);var _ExecutionEnvironment2=_interopRequireDefault(_ExecutionEnvironment);var _arrayFindIndex=__webpack_require__(172);var _arrayFindIndex2=_interopRequireDefault(_arrayFindIndex);var _invariant=__webpack_require__(8);var _invariant2=_interopRequireDefault(_invariant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var connection=_ExecutionEnvironment2.default.canUseDOM&&(window.navigator.connection||window.navigator.mozConnection||window.navigator.webkitConnection);var getConnectionInfoObject=function getConnectionInfoObject(){var result={};if(!connection){return result;}for(var prop in connection){if(typeof connection[prop]!=='function'){result[prop]=connection[prop];}}return result;};var eventTypesMap={change:'change',connectionChange:'change'};var eventTypes=Object.keys(eventTypesMap);var connectionListeners=[];var NetInfo={addEventListener:function addEventListener(type,handler){(0,_invariant2.default)(eventTypes.indexOf(type)!==-1,'Trying to subscribe to unknown event: "%s"',type);if(type==='change'){console.warn('Listening to event `change` is deprecated. Use `connectionChange` instead.');}if(!connection){console.error('Network Connection API is not supported. Not listening for connection type changes.');return{remove:function remove(){}};}connection.addEventListener(eventTypesMap[type],handler);return{remove:function remove(){return NetInfo.removeEventListener(eventTypesMap[type],handler);}};},removeEventListener:function removeEventListener(type,handler){(0,_invariant2.default)(eventTypes.indexOf(type)!==-1,'Trying to subscribe to unknown event: "%s"',type);if(type==='change'){console.warn('Listening to event `change` is deprecated. Use `connectionChange` instead.');}if(!connection){return;}connection.removeEventListener(eventTypesMap[type],handler);},fetch:function fetch(){console.warn('`fetch` is deprecated. Use `getConnectionInfo` instead.');return new Promise(function(resolve,reject){try{resolve(connection.type);}catch(err){resolve('unknown');}});},getConnectionInfo:function getConnectionInfo(){return new Promise(function(resolve,reject){resolve(_extends({effectiveType:'unknown',type:'unknown'},getConnectionInfoObject()));});},isConnected:{addEventListener:function addEventListener(type,handler){(0,_invariant2.default)(eventTypes.indexOf(type)!==-1,'Trying to subscribe to unknown event: "%s"',type);if(type==='change'){console.warn('Listening to event `change` is deprecated. Use `connectionChange` instead.');}var onlineCallback=function onlineCallback(){return handler(true);};var offlineCallback=function offlineCallback(){return handler(false);};connectionListeners.push([handler,onlineCallback,offlineCallback]);window.addEventListener('online',onlineCallback,false);window.addEventListener('offline',offlineCallback,false);return{remove:function remove(){return NetInfo.isConnected.removeEventListener(eventTypesMap[type],handler);}};},removeEventListener:function removeEventListener(type,handler){(0,_invariant2.default)(eventTypes.indexOf(type)!==-1,'Trying to subscribe to unknown event: "%s"',type);if(type==='change'){console.warn('Listening to event `change` is deprecated. Use `connectionChange` instead.');}var listenerIndex=(0,_arrayFindIndex2.default)(connectionListeners,function(pair){return pair[0]===handler;});(0,_invariant2.default)(listenerIndex!==-1,'Trying to remove NetInfo connection listener for unregistered handler');var _connectionListeners$=_slicedToArray(connectionListeners[listenerIndex],3),onlineCallback=_connectionListeners$[1],offlineCallback=_connectionListeners$[2];window.removeEventListener('online',onlineCallback,false);window.removeEventListener('offline',offlineCallback,false);connectionListeners.splice(listenerIndex,1);},fetch:function fetch(){console.warn('`fetch` is deprecated. Use `getConnectionInfo` instead.');return NetInfo.isConnected.getConnectionInfo();},getConnectionInfo:function getConnectionInfo(){return new Promise(function(resolve,reject){try{resolve(window.navigator.onLine);}catch(err){resolve(true);}});}}};exports.default=NetInfo;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _TouchHistoryMath=__webpack_require__(359);var _TouchHistoryMath2=_interopRequireDefault(_TouchHistoryMath);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var currentCentroidXOfTouchesChangedAfter=_TouchHistoryMath2.default.currentCentroidXOfTouchesChangedAfter;var currentCentroidYOfTouchesChangedAfter=_TouchHistoryMath2.default.currentCentroidYOfTouchesChangedAfter;var previousCentroidXOfTouchesChangedAfter=_TouchHistoryMath2.default.previousCentroidXOfTouchesChangedAfter;var previousCentroidYOfTouchesChangedAfter=_TouchHistoryMath2.default.previousCentroidYOfTouchesChangedAfter;var currentCentroidX=_TouchHistoryMath2.default.currentCentroidX;var currentCentroidY=_TouchHistoryMath2.default.currentCentroidY;var PanResponder={_initializeGestureState:function _initializeGestureState(gestureState){gestureState.moveX=0;gestureState.moveY=0;gestureState.x0=0;gestureState.y0=0;gestureState.dx=0;gestureState.dy=0;gestureState.vx=0;gestureState.vy=0;gestureState.numberActiveTouches=0;gestureState._accountsForMovesUpTo=0;},_updateGestureStateOnMove:function _updateGestureStateOnMove(gestureState,touchHistory){gestureState.numberActiveTouches=touchHistory.numberActiveTouches;gestureState.moveX=currentCentroidXOfTouchesChangedAfter(touchHistory,gestureState._accountsForMovesUpTo);gestureState.moveY=currentCentroidYOfTouchesChangedAfter(touchHistory,gestureState._accountsForMovesUpTo);var movedAfter=gestureState._accountsForMovesUpTo;var prevX=previousCentroidXOfTouchesChangedAfter(touchHistory,movedAfter);var x=currentCentroidXOfTouchesChangedAfter(touchHistory,movedAfter);var prevY=previousCentroidYOfTouchesChangedAfter(touchHistory,movedAfter);var y=currentCentroidYOfTouchesChangedAfter(touchHistory,movedAfter);var nextDX=gestureState.dx+(x-prevX);var nextDY=gestureState.dy+(y-prevY);var dt=touchHistory.mostRecentTimeStamp-gestureState._accountsForMovesUpTo;gestureState.vx=(nextDX-gestureState.dx)/dt;gestureState.vy=(nextDY-gestureState.dy)/dt;gestureState.dx=nextDX;gestureState.dy=nextDY;gestureState._accountsForMovesUpTo=touchHistory.mostRecentTimeStamp;},create:function create(config){var gestureState={stateID:Math.random()};PanResponder._initializeGestureState(gestureState);var panHandlers={onStartShouldSetResponder:function onStartShouldSetResponder(e){return config.onStartShouldSetPanResponder===undefined?false:config.onStartShouldSetPanResponder(e,gestureState);},onMoveShouldSetResponder:function onMoveShouldSetResponder(e){return config.onMoveShouldSetPanResponder===undefined?false:config.onMoveShouldSetPanResponder(e,gestureState);},onStartShouldSetResponderCapture:function onStartShouldSetResponderCapture(e){if(e.nativeEvent.touches){if(e.nativeEvent.touches.length===1){PanResponder._initializeGestureState(gestureState);}}else if(e.nativeEvent.originalEvent&&e.nativeEvent.originalEvent.type==='mousedown'){PanResponder._initializeGestureState(gestureState);}gestureState.numberActiveTouches=e.touchHistory.numberActiveTouches;return config.onStartShouldSetPanResponderCapture!==undefined?config.onStartShouldSetPanResponderCapture(e,gestureState):false;},onMoveShouldSetResponderCapture:function onMoveShouldSetResponderCapture(e){var touchHistory=e.touchHistory;if(gestureState._accountsForMovesUpTo===touchHistory.mostRecentTimeStamp){return false;}PanResponder._updateGestureStateOnMove(gestureState,touchHistory);return config.onMoveShouldSetPanResponderCapture?config.onMoveShouldSetPanResponderCapture(e,gestureState):false;},onResponderGrant:function onResponderGrant(e){gestureState.x0=currentCentroidX(e.touchHistory);gestureState.y0=currentCentroidY(e.touchHistory);gestureState.dx=0;gestureState.dy=0;config.onPanResponderGrant&&config.onPanResponderGrant(e,gestureState);return config.onShouldBlockNativeResponder===undefined?true:config.onShouldBlockNativeResponder();},onResponderReject:function onResponderReject(e){config.onPanResponderReject&&config.onPanResponderReject(e,gestureState);},onResponderRelease:function onResponderRelease(e){config.onPanResponderRelease&&config.onPanResponderRelease(e,gestureState);PanResponder._initializeGestureState(gestureState);},onResponderStart:function onResponderStart(e){var touchHistory=e.touchHistory;gestureState.numberActiveTouches=touchHistory.numberActiveTouches;config.onPanResponderStart&&config.onPanResponderStart(e,gestureState);},onResponderMove:function onResponderMove(e){var touchHistory=e.touchHistory;if(gestureState._accountsForMovesUpTo===touchHistory.mostRecentTimeStamp){return;}PanResponder._updateGestureStateOnMove(gestureState,touchHistory);config.onPanResponderMove&&config.onPanResponderMove(e,gestureState);},onResponderEnd:function onResponderEnd(e){var touchHistory=e.touchHistory;gestureState.numberActiveTouches=touchHistory.numberActiveTouches;config.onPanResponderEnd&&config.onPanResponderEnd(e,gestureState);},onResponderTerminate:function onResponderTerminate(e){config.onPanResponderTerminate&&config.onPanResponderTerminate(e,gestureState);PanResponder._initializeGestureState(gestureState);},onResponderTerminationRequest:function onResponderTerminationRequest(e){return config.onPanResponderTerminationRequest===undefined?true:config.onPanResponderTerminationRequest(e,gestureState);}};return{panHandlers:panHandlers};}};exports.default=PanResponder;

/***/ }),
/* 359 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var TouchHistoryMath={centroidDimension:function centroidDimension(touchHistory,touchesChangedAfter,isXAxis,ofCurrent){var touchBank=touchHistory.touchBank;var total=0;var count=0;var oneTouchData=touchHistory.numberActiveTouches===1?touchHistory.touchBank[touchHistory.indexOfSingleActiveTouch]:null;if(oneTouchData!==null){if(oneTouchData.touchActive&&oneTouchData.currentTimeStamp>touchesChangedAfter){total+=ofCurrent&&isXAxis?oneTouchData.currentPageX:ofCurrent&&!isXAxis?oneTouchData.currentPageY:!ofCurrent&&isXAxis?oneTouchData.previousPageX:oneTouchData.previousPageY;count=1;}}else{for(var i=0;i<touchBank.length;i++){var touchTrack=touchBank[i];if(touchTrack!==null&&touchTrack!==undefined&&touchTrack.touchActive&&touchTrack.currentTimeStamp>=touchesChangedAfter){var toAdd;if(ofCurrent&&isXAxis){toAdd=touchTrack.currentPageX;}else if(ofCurrent&&!isXAxis){toAdd=touchTrack.currentPageY;}else if(!ofCurrent&&isXAxis){toAdd=touchTrack.previousPageX;}else{toAdd=touchTrack.previousPageY;}total+=toAdd;count++;}}}return count>0?total/count:TouchHistoryMath.noCentroid;},currentCentroidXOfTouchesChangedAfter:function currentCentroidXOfTouchesChangedAfter(touchHistory,touchesChangedAfter){return TouchHistoryMath.centroidDimension(touchHistory,touchesChangedAfter,true,true);},currentCentroidYOfTouchesChangedAfter:function currentCentroidYOfTouchesChangedAfter(touchHistory,touchesChangedAfter){return TouchHistoryMath.centroidDimension(touchHistory,touchesChangedAfter,false,true);},previousCentroidXOfTouchesChangedAfter:function previousCentroidXOfTouchesChangedAfter(touchHistory,touchesChangedAfter){return TouchHistoryMath.centroidDimension(touchHistory,touchesChangedAfter,true,false);},previousCentroidYOfTouchesChangedAfter:function previousCentroidYOfTouchesChangedAfter(touchHistory,touchesChangedAfter){return TouchHistoryMath.centroidDimension(touchHistory,touchesChangedAfter,false,false);},currentCentroidX:function currentCentroidX(touchHistory){return TouchHistoryMath.centroidDimension(touchHistory,0,true,true);},currentCentroidY:function currentCentroidY(touchHistory){return TouchHistoryMath.centroidDimension(touchHistory,0,false,true);},noCentroid:-1};exports.default=TouchHistoryMath;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _Dimensions=__webpack_require__(67);var _Dimensions2=_interopRequireDefault(_Dimensions);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var PixelRatio=function(){function PixelRatio(){_classCallCheck(this,PixelRatio);}_createClass(PixelRatio,null,[{key:'get',value:function get(){return _Dimensions2.default.get('window').scale;}},{key:'getFontScale',value:function getFontScale(){return _Dimensions2.default.get('window').fontScale||PixelRatio.get();}},{key:'getPixelSizeForLayoutSize',value:function getPixelSizeForLayoutSize(layoutSize){return Math.round(layoutSize*PixelRatio.get());}},{key:'roundToNearestPixel',value:function roundToNearestPixel(layoutSize){var ratio=PixelRatio.get();return Math.round(layoutSize*ratio)/ratio;}}]);return PixelRatio;}();exports.default=PixelRatio;

/***/ }),
/* 361 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var _vibrate=function _vibrate(pattern){if('vibrate'in window.navigator){if(typeof pattern==='number'||Array.isArray(pattern)){window.navigator.vibrate(pattern);}else{throw new Error('Vibration pattern should be a number or array');}}};var Vibration={cancel:function cancel(){_vibrate(0);},vibrate:function vibrate(pattern){_vibrate(pattern);}};exports.default=Vibration;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _jsxFileName='src/components/ActivityIndicator/index.js';var _applyNativeMethods=__webpack_require__(18);var _applyNativeMethods2=_interopRequireDefault(_applyNativeMethods);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _View=__webpack_require__(11);var _View2=_interopRequireDefault(_View);var _ViewPropTypes=__webpack_require__(15);var _ViewPropTypes2=_interopRequireDefault(_ViewPropTypes);var _propTypes=__webpack_require__(3);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var createSvgCircle=function createSvgCircle(style){return _react2.default.createElement('circle',{cx:'16',cy:'16',fill:'none',r:'14',strokeWidth:'4',style:style,__source:{fileName:_jsxFileName,lineNumber:21}});};var ActivityIndicator=function(_Component){_inherits(ActivityIndicator,_Component);function ActivityIndicator(){_classCallCheck(this,ActivityIndicator);return _possibleConstructorReturn(this,(ActivityIndicator.__proto__||Object.getPrototypeOf(ActivityIndicator)).apply(this,arguments));}_createClass(ActivityIndicator,[{key:'render',value:function render(){var _props=this.props,animating=_props.animating,color=_props.color,hidesWhenStopped=_props.hidesWhenStopped,size=_props.size,style=_props.style,other=_objectWithoutProperties(_props,['animating','color','hidesWhenStopped','size','style']);var svg=_react2.default.createElement('svg',{height:'100%',viewBox:'0 0 32 32',width:'100%',__source:{fileName:_jsxFileName,lineNumber:46}},createSvgCircle({stroke:color,opacity:0.2}),createSvgCircle({stroke:color,strokeDasharray:80,strokeDashoffset:60}));return _react2.default.createElement(_View2.default,_extends({},other,{accessibilityRole:'progressbar','aria-valuemax':'1','aria-valuemin':'0',style:[styles.container,style],__source:{fileName:_jsxFileName,lineNumber:60}}),_react2.default.createElement(_View2.default,{children:svg,style:[typeof size==='number'?{height:size,width:size}:indicatorSizes[size],styles.animation,!animating&&styles.animationPause,!animating&&hidesWhenStopped&&styles.hidesWhenStopped],__source:{fileName:_jsxFileName,lineNumber:67}}));}}]);return ActivityIndicator;}(_react.Component);ActivityIndicator.displayName='ActivityIndicator';ActivityIndicator.defaultProps={animating:true,color:'#1976D2',hidesWhenStopped:true,size:'small'};ActivityIndicator.propTypes= false?_extends({},_ViewPropTypes2.default,{animating:_propTypes.bool,color:_propTypes.string,hidesWhenStopped:_propTypes.bool,size:(0,_propTypes.oneOfType)([(0,_propTypes.oneOf)(['small','large']),_propTypes.number])}):{};var styles=_StyleSheet2.default.create({container:{alignItems:'center',justifyContent:'center'},hidesWhenStopped:{visibility:'hidden'},animation:{animationDuration:'0.75s',animationName:'rn-ActivityIndicator-animation',animationTimingFunction:'linear',animationIterationCount:'infinite'},animationPause:{animationPlayState:'paused'}});var indicatorSizes=_StyleSheet2.default.create({small:{width:20,height:20},large:{width:36,height:36}});exports.default=(0,_applyNativeMethods2.default)(ActivityIndicator);

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='src/components/Button/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _ColorPropType=__webpack_require__(14);var _ColorPropType2=_interopRequireDefault(_ColorPropType);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _TouchableOpacity=__webpack_require__(173);var _TouchableOpacity2=_interopRequireDefault(_TouchableOpacity);var _Text=__webpack_require__(100);var _Text2=_interopRequireDefault(_Text);var _propTypes=__webpack_require__(3);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Button=function(_Component){_inherits(Button,_Component);function Button(){_classCallCheck(this,Button);return _possibleConstructorReturn(this,(Button.__proto__||Object.getPrototypeOf(Button)).apply(this,arguments));}_createClass(Button,[{key:'render',value:function render(){var _props=this.props,accessibilityLabel=_props.accessibilityLabel,color=_props.color,disabled=_props.disabled,onPress=_props.onPress,testID=_props.testID,title=_props.title;return _react2.default.createElement(_TouchableOpacity2.default,{accessibilityLabel:accessibilityLabel,accessibilityRole:'button',disabled:disabled,onPress:onPress,style:[styles.button,color&&{backgroundColor:color},disabled&&styles.buttonDisabled],testID:testID,__source:{fileName:_jsxFileName,lineNumber:34}},_react2.default.createElement(_Text2.default,{style:[styles.text,disabled&&styles.textDisabled],__source:{fileName:_jsxFileName,lineNumber:46}},title));}}]);return Button;}(_react.Component);Button.propTypes= false?{accessibilityLabel:_propTypes.string,color:_ColorPropType2.default,disabled:_propTypes.bool,onPress:_propTypes.func.isRequired,testID:_propTypes.string,title:_propTypes.string.isRequired}:{};var styles=_StyleSheet2.default.create({button:{backgroundColor:'#2196F3',borderRadius:2},text:{color:'#fff',fontWeight:'500',padding:8,textAlign:'center',textTransform:'uppercase'},buttonDisabled:{backgroundColor:'#dfdfdf'},textDisabled:{color:'#a1a1a1'}});exports.default=Button;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _PooledClass=__webpack_require__(174);var _PooledClass2=_interopRequireDefault(_PooledClass);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var twoArgumentPooler=_PooledClass2.default.twoArgumentPooler;function BoundingDimensions(width,height){this.width=width;this.height=height;}BoundingDimensions.prototype.destructor=function(){this.width=null;this.height=null;};BoundingDimensions.getPooledFromElement=function(element){return BoundingDimensions.getPooled(element.offsetWidth,element.offsetHeight);};_PooledClass2.default.addPoolingTo(BoundingDimensions,twoArgumentPooler);exports.default=BoundingDimensions;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _PooledClass=__webpack_require__(174);var _PooledClass2=_interopRequireDefault(_PooledClass);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var twoArgumentPooler=_PooledClass2.default.twoArgumentPooler;function Position(left,top){this.left=left;this.top=top;}Position.prototype.destructor=function(){this.left=null;this.top=null;};_PooledClass2.default.addPoolingTo(Position,twoArgumentPooler);exports.default=Position;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var TouchEventUtils = {
  /**
   * Utility function for common case of extracting out the primary touch from a
   * touch event.
   * - `touchEnd` events usually do not have the `touches` property.
   *   http://stackoverflow.com/questions/3666929/
   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
   *
   * @param {Event} nativeEvent Native event that may or may not be a touch.
   * @return {TouchesObject?} an object with pageX and pageY or null.
   */
  extractSingleTouch: function extractSingleTouch(nativeEvent) {
    var touches = nativeEvent.touches;
    var changedTouches = nativeEvent.changedTouches;
    var hasTouches = touches && touches.length > 0;
    var hasChangedTouches = changedTouches && changedTouches.length > 0;

    return !hasTouches && hasChangedTouches ? changedTouches[0] : hasTouches ? touches[0] : nativeEvent;
  }
};

module.exports = TouchEventUtils;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _UnimplementedView=__webpack_require__(35);var _UnimplementedView2=_interopRequireDefault(_UnimplementedView);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_UnimplementedView2.default;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='src/components/KeyboardAvoidingView/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _View=__webpack_require__(11);var _View2=_interopRequireDefault(_View);var _ViewPropTypes=__webpack_require__(15);var _ViewPropTypes2=_interopRequireDefault(_ViewPropTypes);var _propTypes=__webpack_require__(3);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var KeyboardAvoidingView=function(_Component){_inherits(KeyboardAvoidingView,_Component);function KeyboardAvoidingView(){var _ref;var _temp,_this,_ret;_classCallCheck(this,KeyboardAvoidingView);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=KeyboardAvoidingView.__proto__||Object.getPrototypeOf(KeyboardAvoidingView)).call.apply(_ref,[this].concat(args))),_this),_this.frame=null,_temp),_possibleConstructorReturn(_this,_ret);}_createClass(KeyboardAvoidingView,[{key:'relativeKeyboardHeight',value:function relativeKeyboardHeight(keyboardFrame){var frame=this.frame;if(!frame||!keyboardFrame){return 0;}var keyboardY=keyboardFrame.screenY-this.props.keyboardVerticalOffset;return Math.max(frame.y+frame.height-keyboardY,0);}},{key:'onKeyboardChange',value:function onKeyboardChange(event){}},{key:'onLayout',value:function onLayout(event){this.frame=event.nativeEvent.layout;}},{key:'render',value:function render(){var _props=this.props,behavior=_props.behavior,contentContainerStyle=_props.contentContainerStyle,keyboardVerticalOffset=_props.keyboardVerticalOffset,rest=_objectWithoutProperties(_props,['behavior','contentContainerStyle','keyboardVerticalOffset']);return _react2.default.createElement(_View2.default,_extends({onLayout:this.onLayout},rest,{__source:{fileName:_jsxFileName,lineNumber:59}}));}}]);return KeyboardAvoidingView;}(_react.Component);KeyboardAvoidingView.defaultProps={keyboardVerticalOffset:0};KeyboardAvoidingView.propTypes= false?_extends({},_ViewPropTypes2.default,{behavior:(0,_propTypes.oneOf)(['height','padding','position']),contentContainerStyle:_ViewPropTypes2.default.style,keyboardVerticalOffset:_propTypes.number.isRequired}):{};exports.default=KeyboardAvoidingView;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='src/components/ListView/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _applyNativeMethods=__webpack_require__(18);var _applyNativeMethods2=_interopRequireDefault(_applyNativeMethods);var _ListViewDataSource=__webpack_require__(175);var _ListViewDataSource2=_interopRequireDefault(_ListViewDataSource);var _ListViewPropTypes=__webpack_require__(370);var _ListViewPropTypes2=_interopRequireDefault(_ListViewPropTypes);var _ScrollView=__webpack_require__(66);var _ScrollView2=_interopRequireDefault(_ScrollView);var _StaticRenderer=__webpack_require__(371);var _StaticRenderer2=_interopRequireDefault(_StaticRenderer);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _isEmpty=__webpack_require__(176);var _isEmpty2=_interopRequireDefault(_isEmpty);var _requestAnimationFrame=__webpack_require__(163);var _requestAnimationFrame2=_interopRequireDefault(_requestAnimationFrame);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DEFAULT_PAGE_SIZE=1;var DEFAULT_INITIAL_ROWS=10;var DEFAULT_SCROLL_RENDER_AHEAD=1000;var DEFAULT_END_REACHED_THRESHOLD=1000;var DEFAULT_SCROLL_CALLBACK_THROTTLE=50;var ListView=function(_Component){_inherits(ListView,_Component);function ListView(props){_classCallCheck(this,ListView);var _this=_possibleConstructorReturn(this,(ListView.__proto__||Object.getPrototypeOf(ListView)).call(this,props));_initialiseProps.call(_this);_this.state={curRenderedRowsCount:_this.props.initialListSize,highlightedRow:{}};_this.onRowHighlighted=function(sectionId,rowId){return _this._onRowHighlighted(sectionId,rowId);};_this.scrollProperties={};return _this;}_createClass(ListView,[{key:'componentWillMount',value:function componentWillMount(){this.scrollProperties={visibleLength:null,contentLength:null,offset:0};this._childFrames=[];this._visibleRows={};this._prevRenderedRowsCount=0;this._sentEndForContentLength=null;}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;(0,_requestAnimationFrame2.default)(function(){_this2._measureAndUpdateScrollProps();});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this3=this;if(this.props.dataSource!==nextProps.dataSource||this.props.initialListSize!==nextProps.initialListSize){this.setState(function(state,props){_this3._prevRenderedRowsCount=0;return{curRenderedRowsCount:Math.min(Math.max(state.curRenderedRowsCount,props.initialListSize),props.enableEmptySections?props.dataSource.getRowAndSectionCount():props.dataSource.getRowCount())};},function(){return _this3._renderMoreRowsIfNeeded();});}}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this4=this;(0,_requestAnimationFrame2.default)(function(){_this4._measureAndUpdateScrollProps();});}},{key:'getScrollResponder',value:function getScrollResponder(){return this._scrollViewRef&&this._scrollViewRef.getScrollResponder();}},{key:'scrollTo',value:function scrollTo(){var _scrollViewRef;return this._scrollViewRef&&(_scrollViewRef=this._scrollViewRef).scrollTo.apply(_scrollViewRef,arguments);}},{key:'setNativeProps',value:function setNativeProps(props){return this._scrollViewRef&&this._scrollViewRef.setNativeProps(props);}},{key:'render',value:function render(){var children=[];var _props=this.props,dataSource=_props.dataSource,enableEmptySections=_props.enableEmptySections,renderFooter=_props.renderFooter,renderHeader=_props.renderHeader,renderScrollComponent=_props.renderScrollComponent,renderSectionHeader=_props.renderSectionHeader,renderSeparator=_props.renderSeparator,initialListSize=_props.initialListSize,onChangeVisibleRows=_props.onChangeVisibleRows,onEndReached=_props.onEndReached,onEndReachedThreshold=_props.onEndReachedThreshold,onKeyboardDidHide=_props.onKeyboardDidHide,onKeyboardDidShow=_props.onKeyboardDidShow,onKeyboardWillHide=_props.onKeyboardWillHide,onKeyboardWillShow=_props.onKeyboardWillShow,pageSize=_props.pageSize,renderRow=_props.renderRow,scrollRenderAheadDistance=_props.scrollRenderAheadDistance,stickyHeaderIndices=_props.stickyHeaderIndices,scrollProps=_objectWithoutProperties(_props,['dataSource','enableEmptySections','renderFooter','renderHeader','renderScrollComponent','renderSectionHeader','renderSeparator','initialListSize','onChangeVisibleRows','onEndReached','onEndReachedThreshold','onKeyboardDidHide','onKeyboardDidShow','onKeyboardWillHide','onKeyboardWillShow','pageSize','renderRow','scrollRenderAheadDistance','stickyHeaderIndices']);var allRowIDs=dataSource.rowIdentities;var rowCount=0;var sectionHeaderIndices=[];var header=renderHeader&&renderHeader();var footer=renderFooter&&renderFooter();var totalIndex=header?1:0;for(var sectionIdx=0;sectionIdx<allRowIDs.length;sectionIdx++){var sectionID=dataSource.sectionIdentities[sectionIdx];var rowIDs=allRowIDs[sectionIdx];if(rowIDs.length===0){if(enableEmptySections===undefined){var warning=__webpack_require__(68);warning(false,'In next release empty section headers will be rendered.'+" In this release you can use 'enableEmptySections' flag to render empty section headers.");continue;}else{var invariant=__webpack_require__(8);invariant(enableEmptySections,"In next release 'enableEmptySections' flag will be deprecated,"+' empty section headers will always be rendered. If empty section headers'+' are not desirable their indices should be excluded from sectionIDs object.'+" In this release 'enableEmptySections' may only have value 'true'"+' to allow empty section headers rendering.');}}if(renderSectionHeader){var shouldUpdateHeader=rowCount>=this._prevRenderedRowsCount&&dataSource.sectionHeaderShouldUpdate(sectionIdx);children.push(_react2.default.createElement(_StaticRenderer2.default,{key:'s_'+sectionID,render:this.renderSectionHeaderFn(dataSource.getSectionHeaderData(sectionIdx),sectionID),shouldUpdate:!!shouldUpdateHeader,__source:{fileName:_jsxFileName,lineNumber:181}}));sectionHeaderIndices.push(totalIndex++);}for(var rowIdx=0;rowIdx<rowIDs.length;rowIdx++){var rowID=rowIDs[rowIdx];var comboID=sectionID+'_'+rowID;var shouldUpdateRow=rowCount>=this._prevRenderedRowsCount&&dataSource.rowShouldUpdate(sectionIdx,rowIdx);var row=_react2.default.createElement(_StaticRenderer2.default,{key:'r_'+comboID,render:this.renderRowFn(dataSource.getRowData(sectionIdx,rowIdx),sectionID,rowID),shouldUpdate:!!shouldUpdateRow,__source:{fileName:_jsxFileName,lineNumber:199}});children.push(row);totalIndex++;if(renderSeparator&&(rowIdx!==rowIDs.length-1||sectionIdx===allRowIDs.length-1)){var adjacentRowHighlighted=this.state.highlightedRow.sectionID===sectionID&&(this.state.highlightedRow.rowID===rowID||this.state.highlightedRow.rowID===rowIDs[rowIdx+1]);var separator=renderSeparator(sectionID,rowID,adjacentRowHighlighted);if(separator){children.push(separator);totalIndex++;}}if(++rowCount===this.state.curRenderedRowsCount){break;}}if(rowCount>=this.state.curRenderedRowsCount){break;}}scrollProps.onScroll=this._onScroll;return _react2.default.cloneElement(renderScrollComponent(scrollProps),{ref:this._setScrollViewRef,onContentSizeChange:this._onContentSizeChange,onLayout:this._onLayout},header,children,footer);}},{key:'_measureAndUpdateScrollProps',value:function _measureAndUpdateScrollProps(){var scrollComponent=this.getScrollResponder();if(!scrollComponent||!scrollComponent.getInnerViewNode){return;}this._updateVisibleRows();}},{key:'_updateVisibleRows',value:function _updateVisibleRows(updatedFrames){var _this5=this;if(!this.props.onChangeVisibleRows){return;}if(updatedFrames){updatedFrames.forEach(function(newFrame){_this5._childFrames[newFrame.index]=_extends({},newFrame);});}var isVertical=!this.props.horizontal;var dataSource=this.props.dataSource;var visibleMin=this.scrollProperties.offset;var visibleMax=visibleMin+this.scrollProperties.visibleLength;var allRowIDs=dataSource.rowIdentities;var header=this.props.renderHeader&&this.props.renderHeader();var totalIndex=header?1:0;var visibilityChanged=false;var changedRows={};for(var sectionIdx=0;sectionIdx<allRowIDs.length;sectionIdx++){var rowIDs=allRowIDs[sectionIdx];if(rowIDs.length===0){continue;}var sectionID=dataSource.sectionIdentities[sectionIdx];if(this.props.renderSectionHeader){totalIndex++;}var visibleSection=this._visibleRows[sectionID];if(!visibleSection){visibleSection={};}for(var rowIdx=0;rowIdx<rowIDs.length;rowIdx++){var rowID=rowIDs[rowIdx];var frame=this._childFrames[totalIndex];totalIndex++;if(this.props.renderSeparator&&(rowIdx!==rowIDs.length-1||sectionIdx===allRowIDs.length-1)){totalIndex++;}if(!frame){break;}var rowVisible=visibleSection[rowID];var min=isVertical?frame.y:frame.x;var max=min+(isVertical?frame.height:frame.width);if(!min&&!max||min===max){break;}if(min>visibleMax||max<visibleMin){if(rowVisible){visibilityChanged=true;delete visibleSection[rowID];if(!changedRows[sectionID]){changedRows[sectionID]={};}changedRows[sectionID][rowID]=false;}}else if(!rowVisible){visibilityChanged=true;visibleSection[rowID]=true;if(!changedRows[sectionID]){changedRows[sectionID]={};}changedRows[sectionID][rowID]=true;}}if(!(0,_isEmpty2.default)(visibleSection)){this._visibleRows[sectionID]=visibleSection;}else if(this._visibleRows[sectionID]){delete this._visibleRows[sectionID];}}visibilityChanged&&this.props.onChangeVisibleRows(this._visibleRows,changedRows);}},{key:'_getDistanceFromEnd',value:function _getDistanceFromEnd(scrollProperties){return scrollProperties.contentLength-scrollProperties.visibleLength-scrollProperties.offset;}},{key:'_maybeCallOnEndReached',value:function _maybeCallOnEndReached(event){if(this.props.onEndReached&&this.scrollProperties.contentLength!==this._sentEndForContentLength&&this._getDistanceFromEnd(this.scrollProperties)<this.props.onEndReachedThreshold&&this.state.curRenderedRowsCount===(this.props.enableEmptySections?this.props.dataSource.getRowAndSectionCount():this.props.dataSource.getRowCount())){this._sentEndForContentLength=this.scrollProperties.contentLength;this.props.onEndReached(event);return true;}return false;}},{key:'_renderMoreRowsIfNeeded',value:function _renderMoreRowsIfNeeded(){if(this.scrollProperties.contentLength===null||this.scrollProperties.visibleLength===null||this.state.curRenderedRowsCount===(this.props.enableEmptySections?this.props.dataSource.getRowAndSectionCount():this.props.dataSource.getRowCount())){this._maybeCallOnEndReached();return;}var distanceFromEnd=this._getDistanceFromEnd(this.scrollProperties);if(distanceFromEnd<this.props.scrollRenderAheadDistance){this._pageInNewRows();}}},{key:'_pageInNewRows',value:function _pageInNewRows(){var _this6=this;this.setState(function(state,props){var rowsToRender=Math.min(state.curRenderedRowsCount+props.pageSize,props.enableEmptySections?props.dataSource.getRowAndSectionCount():props.dataSource.getRowCount());_this6._prevRenderedRowsCount=state.curRenderedRowsCount;return{curRenderedRowsCount:rowsToRender};},function(){_this6._measureAndUpdateScrollProps();_this6._prevRenderedRowsCount=_this6.state.curRenderedRowsCount;});}}]);return ListView;}(_react.Component);ListView.defaultProps={initialListSize:DEFAULT_INITIAL_ROWS,pageSize:DEFAULT_PAGE_SIZE,renderScrollComponent:function renderScrollComponent(props){return _react2.default.createElement(_ScrollView2.default,_extends({},props,{__source:{fileName:_jsxFileName,lineNumber:22}}));},scrollRenderAheadDistance:DEFAULT_SCROLL_RENDER_AHEAD,onEndReachedThreshold:DEFAULT_END_REACHED_THRESHOLD,scrollEventThrottle:DEFAULT_SCROLL_CALLBACK_THROTTLE,removeClippedSubviews:true,stickyHeaderIndices:[]};ListView.DataSource=_ListViewDataSource2.default;var _initialiseProps=function _initialiseProps(){var _this7=this;this._onRowHighlighted=function(sectionId,rowId){_this7.setState({highlightedRow:{sectionId:sectionId,rowId:rowId}});};this.renderSectionHeaderFn=function(data,sectionID){return function(){return _this7.props.renderSectionHeader(data,sectionID);};};this.renderRowFn=function(data,sectionID,rowID){return function(){return _this7.props.renderRow(data,sectionID,rowID,_this7._onRowHighlighted);};};this._onLayout=function(event){var _event$nativeEvent$la=event.nativeEvent.layout,width=_event$nativeEvent$la.width,height=_event$nativeEvent$la.height;var visibleLength=!_this7.props.horizontal?height:width;if(visibleLength!==_this7.scrollProperties.visibleLength){_this7.scrollProperties.visibleLength=visibleLength;_this7._updateVisibleRows();_this7._renderMoreRowsIfNeeded();}_this7.props.onLayout&&_this7.props.onLayout(event);};this._onContentSizeChange=function(width,height){var contentLength=!_this7.props.horizontal?height:width;if(contentLength!==_this7.scrollProperties.contentLength){_this7.scrollProperties.contentLength=contentLength;_this7._updateVisibleRows();_this7._renderMoreRowsIfNeeded();}_this7.props.onContentSizeChange&&_this7.props.onContentSizeChange(width,height);};this._onScroll=function(e){var isVertical=!_this7.props.horizontal;_this7.scrollProperties.visibleLength=e.nativeEvent.layoutMeasurement[isVertical?'height':'width'];_this7.scrollProperties.contentLength=e.nativeEvent.contentSize[isVertical?'height':'width'];_this7.scrollProperties.offset=e.nativeEvent.contentOffset[isVertical?'y':'x'];_this7._updateVisibleRows(e.nativeEvent.updatedChildFrames);if(!_this7._maybeCallOnEndReached(e)){_this7._renderMoreRowsIfNeeded();}if(_this7.props.onEndReached&&_this7._getDistanceFromEnd(_this7.scrollProperties)>_this7.props.onEndReachedThreshold){_this7._sentEndForContentLength=null;}_this7.props.onScroll&&_this7.props.onScroll(e);};this._setScrollViewRef=function(component){_this7._scrollViewRef=component;};};ListView.propTypes= false?_ListViewPropTypes2.default:{};exports.default=(0,_applyNativeMethods2.default)(ListView);

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _ListViewDataSource=__webpack_require__(175);var _ListViewDataSource2=_interopRequireDefault(_ListViewDataSource);var _ScrollView=__webpack_require__(66);var _ScrollView2=_interopRequireDefault(_ScrollView);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_extends({},_ScrollView2.default.propTypes,{dataSource:(0,_propTypes.instanceOf)(_ListViewDataSource2.default).isRequired,renderSeparator:_propTypes.func,renderRow:_propTypes.func.isRequired,initialListSize:_propTypes.number,onEndReached:_propTypes.func,onEndReachedThreshold:_propTypes.number,pageSize:_propTypes.number,renderFooter:_propTypes.func,renderHeader:_propTypes.func,renderSectionHeader:_propTypes.func,renderScrollComponent:_propTypes.func.isRequired,scrollRenderAheadDistance:_propTypes.number,onChangeVisibleRows:_propTypes.func,removeClippedSubviews:_propTypes.bool,stickyHeaderIndices:(0,_propTypes.arrayOf)(_propTypes.number)});

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _propTypes=__webpack_require__(3);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StaticRenderer=function(_Component){_inherits(StaticRenderer,_Component);function StaticRenderer(){_classCallCheck(this,StaticRenderer);return _possibleConstructorReturn(this,(StaticRenderer.__proto__||Object.getPrototypeOf(StaticRenderer)).apply(this,arguments));}_createClass(StaticRenderer,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return nextProps.shouldUpdate;}},{key:'render',value:function render(){return this.props.render();}}]);return StaticRenderer;}(_react.Component);exports.default=StaticRenderer;StaticRenderer.propTypes= false?{render:_propTypes.func.isRequired,shouldUpdate:_propTypes.bool.isRequired}:{};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _UnimplementedView=__webpack_require__(35);var _UnimplementedView2=_interopRequireDefault(_UnimplementedView);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_UnimplementedView2.default;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _UnimplementedView=__webpack_require__(35);var _UnimplementedView2=_interopRequireDefault(_UnimplementedView);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_UnimplementedView2.default;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='src/components/ProgressBar/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _applyNativeMethods=__webpack_require__(18);var _applyNativeMethods2=_interopRequireDefault(_applyNativeMethods);var _ColorPropType=__webpack_require__(14);var _ColorPropType2=_interopRequireDefault(_ColorPropType);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _View=__webpack_require__(11);var _View2=_interopRequireDefault(_View);var _ViewPropTypes=__webpack_require__(15);var _ViewPropTypes2=_interopRequireDefault(_ViewPropTypes);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProgressBar=function(_Component){_inherits(ProgressBar,_Component);function ProgressBar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProgressBar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProgressBar.__proto__||Object.getPrototypeOf(ProgressBar)).call.apply(_ref,[this].concat(args))),_this),_this._setProgressRef=function(element){_this._progressElement=element;},_this._updateProgressWidth=function(){var _this$props=_this.props,indeterminate=_this$props.indeterminate,progress=_this$props.progress;var percentageProgress=indeterminate?50:progress*100;var width=indeterminate?'25%':percentageProgress+'%';if(_this._progressElement){_this._progressElement.setNativeProps({style:{width:width}});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProgressBar,[{key:'componentDidMount',value:function componentDidMount(){this._updateProgressWidth();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this._updateProgressWidth();}},{key:'render',value:function render(){var _props=this.props,color=_props.color,indeterminate=_props.indeterminate,progress=_props.progress,trackColor=_props.trackColor,style=_props.style,other=_objectWithoutProperties(_props,['color','indeterminate','progress','trackColor','style']);var percentageProgress=progress*100;return _react2.default.createElement(_View2.default,_extends({},other,{accessibilityRole:'progressbar','aria-valuemax':'100','aria-valuemin':'0','aria-valuenow':indeterminate?null:percentageProgress,style:[styles.track,style,{backgroundColor:trackColor}],__source:{fileName:_jsxFileName,lineNumber:54}}),_react2.default.createElement(_View2.default,{ref:this._setProgressRef,style:[styles.progress,indeterminate&&styles.animation,{backgroundColor:color}],__source:{fileName:_jsxFileName,lineNumber:62}}));}}]);return ProgressBar;}(_react.Component);ProgressBar.displayName='ProgressBar';ProgressBar.defaultProps={color:'#1976D2',indeterminate:false,progress:0,trackColor:'transparent'};ProgressBar.propTypes= false?_extends({},_ViewPropTypes2.default,{color:_ColorPropType2.default,indeterminate:_propTypes.bool,progress:_propTypes.number,trackColor:_ColorPropType2.default}):{};var styles=_StyleSheet2.default.create({track:{height:5,overflow:'hidden',userSelect:'none',zIndex:0},progress:{height:'100%',zIndex:-1},animation:{animationDuration:'1s',animationName:'rn-ProgressBar-animation',animationTimingFunction:'linear',animationIterationCount:'infinite'}});exports.default=(0,_applyNativeMethods2.default)(ProgressBar);

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='src/components/RefreshControl/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _ColorPropType=__webpack_require__(14);var _ColorPropType2=_interopRequireDefault(_ColorPropType);var _View=__webpack_require__(11);var _View2=_interopRequireDefault(_View);var _ViewPropTypes=__webpack_require__(15);var _ViewPropTypes2=_interopRequireDefault(_ViewPropTypes);var _propTypes=__webpack_require__(3);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RefreshControl=function(_Component){_inherits(RefreshControl,_Component);function RefreshControl(){_classCallCheck(this,RefreshControl);return _possibleConstructorReturn(this,(RefreshControl.__proto__||Object.getPrototypeOf(RefreshControl)).apply(this,arguments));}_createClass(RefreshControl,[{key:'render',value:function render(){var _props=this.props,colors=_props.colors,enabled=_props.enabled,onRefresh=_props.onRefresh,progressBackgroundColor=_props.progressBackgroundColor,progressViewOffset=_props.progressViewOffset,refreshing=_props.refreshing,size=_props.size,tintColor=_props.tintColor,title=_props.title,titleColor=_props.titleColor,rest=_objectWithoutProperties(_props,['colors','enabled','onRefresh','progressBackgroundColor','progressViewOffset','refreshing','size','tintColor','title','titleColor']);return _react2.default.createElement(_View2.default,_extends({},rest,{__source:{fileName:_jsxFileName,lineNumber:51}}));}}]);return RefreshControl;}(_react.Component);RefreshControl.propTypes= false?_extends({},_ViewPropTypes2.default,{colors:(0,_propTypes.arrayOf)(_ColorPropType2.default),enabled:_propTypes.bool,onRefresh:_propTypes.func,progressBackgroundColor:_ColorPropType2.default,progressViewOffset:_propTypes.number,refreshing:_propTypes.bool.isRequired,size:(0,_propTypes.oneOf)([0,1]),tintColor:_ColorPropType2.default,title:_propTypes.string,titleColor:_ColorPropType2.default}):{};exports.default=RefreshControl;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _UnimplementedView=__webpack_require__(35);var _UnimplementedView2=_interopRequireDefault(_UnimplementedView);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_UnimplementedView2.default;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _UnimplementedView=__webpack_require__(35);var _UnimplementedView2=_interopRequireDefault(_UnimplementedView);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_UnimplementedView2.default;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StatusBar=function(_Component){_inherits(StatusBar,_Component);function StatusBar(){_classCallCheck(this,StatusBar);return _possibleConstructorReturn(this,(StatusBar.__proto__||Object.getPrototypeOf(StatusBar)).apply(this,arguments));}_createClass(StatusBar,[{key:'render',value:function render(){return null;}}],[{key:'setBackgroundColor',value:function setBackgroundColor(){}},{key:'setBarStyle',value:function setBarStyle(){}},{key:'setHidden',value:function setHidden(){}},{key:'setNetworkActivityIndicatorVisible',value:function setNetworkActivityIndicatorVisible(){}},{key:'setTranslucent',value:function setTranslucent(){}}]);return StatusBar;}(_react.Component);exports.default=StatusBar;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='src/components/Switch/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _applyNativeMethods=__webpack_require__(18);var _applyNativeMethods2=_interopRequireDefault(_applyNativeMethods);var _ColorPropType=__webpack_require__(14);var _ColorPropType2=_interopRequireDefault(_ColorPropType);var _createElement=__webpack_require__(41);var _createElement2=_interopRequireDefault(_createElement);var _multiplyStyleLengthValue=__webpack_require__(153);var _multiplyStyleLengthValue2=_interopRequireDefault(_multiplyStyleLengthValue);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _UIManager=__webpack_require__(43);var _UIManager2=_interopRequireDefault(_UIManager);var _View=__webpack_require__(11);var _View2=_interopRequireDefault(_View);var _ViewPropTypes=__webpack_require__(15);var _ViewPropTypes2=_interopRequireDefault(_ViewPropTypes);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var emptyObject={};var thumbDefaultBoxShadow='0px 1px 3px rgba(0,0,0,0.5)';var thumbFocusedBoxShadow=thumbDefaultBoxShadow+', 0 0 0 10px rgba(0,0,0,0.1)';var Switch=function(_PureComponent){_inherits(Switch,_PureComponent);function Switch(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Switch);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Switch.__proto__||Object.getPrototypeOf(Switch)).call.apply(_ref,[this].concat(args))),_this),_this._handleChange=function(event){var onValueChange=_this.props.onValueChange;onValueChange&&onValueChange(event.nativeEvent.target.checked);},_this._handleFocusState=function(event){var isFocused=event.nativeEvent.type==='focus';var boxShadow=isFocused?thumbFocusedBoxShadow:thumbDefaultBoxShadow;if(_this._thumbElement){_this._thumbElement.setNativeProps({style:{boxShadow:boxShadow}});}},_this._setCheckboxRef=function(element){_this._checkboxElement=element;},_this._setThumbRef=function(element){_this._thumbElement=element;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Switch,[{key:'blur',value:function blur(){_UIManager2.default.blur(this._checkboxElement);}},{key:'focus',value:function focus(){_UIManager2.default.focus(this._checkboxElement);}},{key:'render',value:function render(){var _props=this.props,activeThumbColor=_props.activeThumbColor,activeTrackColor=_props.activeTrackColor,disabled=_props.disabled,onValueChange=_props.onValueChange,style=_props.style,thumbColor=_props.thumbColor,trackColor=_props.trackColor,value=_props.value,onTintColor=_props.onTintColor,thumbTintColor=_props.thumbTintColor,tintColor=_props.tintColor,other=_objectWithoutProperties(_props,['activeThumbColor','activeTrackColor','disabled','onValueChange','style','thumbColor','trackColor','value','onTintColor','thumbTintColor','tintColor']);var _StyleSheet$flatten=_StyleSheet2.default.flatten(style),styleHeight=_StyleSheet$flatten.height,styleWidth=_StyleSheet$flatten.width;var height=styleHeight||20;var minWidth=(0,_multiplyStyleLengthValue2.default)(height,2);var width=styleWidth>minWidth?styleWidth:minWidth;var trackBorderRadius=(0,_multiplyStyleLengthValue2.default)(height,0.5);var trackCurrentColor=value?onTintColor||activeTrackColor:tintColor||trackColor;var thumbCurrentColor=value?activeThumbColor:thumbTintColor||thumbColor;var thumbHeight=height;var thumbWidth=thumbHeight;var rootStyle=[styles.root,style,{height:height,width:width},disabled&&styles.cursorDefault];var trackStyle=[styles.track,{backgroundColor:trackCurrentColor,borderRadius:trackBorderRadius},disabled&&styles.disabledTrack];var thumbStyle=[styles.thumb,{backgroundColor:thumbCurrentColor,height:thumbHeight,width:thumbWidth},disabled&&styles.disabledThumb];var nativeControl=(0,_createElement2.default)('input',{checked:value,disabled:disabled,onBlur:this._handleFocusState,onChange:this._handleChange,onFocus:this._handleFocusState,ref:this._setCheckboxRef,style:[styles.nativeControl,styles.cursorInherit],type:'checkbox'});return _react2.default.createElement(_View2.default,_extends({},other,{style:rootStyle,__source:{fileName:_jsxFileName,lineNumber:125}}),_react2.default.createElement(_View2.default,{style:trackStyle,__source:{fileName:_jsxFileName,lineNumber:126}}),_react2.default.createElement(_View2.default,{ref:this._setThumbRef,style:[thumbStyle,value&&styles.thumbOn,{marginLeft:value?(0,_multiplyStyleLengthValue2.default)(thumbWidth,-1):0}],__source:{fileName:_jsxFileName,lineNumber:127}}),nativeControl);}}]);return Switch;}(_react.PureComponent);Switch.displayName='Switch';Switch.defaultProps={activeThumbColor:'#009688',activeTrackColor:'#A3D3CF',disabled:false,style:emptyObject,thumbColor:'#FAFAFA',trackColor:'#939393',value:false};Switch.propTypes= false?_extends({},_ViewPropTypes2.default,{activeThumbColor:_ColorPropType2.default,activeTrackColor:_ColorPropType2.default,disabled:_propTypes.bool,onValueChange:_propTypes.func,thumbColor:_ColorPropType2.default,trackColor:_ColorPropType2.default,value:_propTypes.bool,onTintColor:_ColorPropType2.default,thumbTintColor:_ColorPropType2.default,tintColor:_ColorPropType2.default}):{};var styles=_StyleSheet2.default.create({root:{cursor:'pointer',userSelect:'none'},cursorDefault:{cursor:'default'},cursorInherit:{cursor:'inherit'},track:_extends({},_StyleSheet2.default.absoluteFillObject,{height:'70%',margin:'auto',transitionDuration:'0.1s',width:'100%'}),disabledTrack:{backgroundColor:'#D5D5D5'},thumb:{alignSelf:'flex-start',borderRadius:'100%',boxShadow:thumbDefaultBoxShadow,left:'0%',transform:[{translateZ:0}],transitionDuration:'0.1s'},thumbOn:{left:'100%'},disabledThumb:{backgroundColor:'#BDBDBD'},nativeControl:_extends({},_StyleSheet2.default.absoluteFillObject,{height:'100%',margin:0,opacity:0,padding:0,width:'100%'})});exports.default=(0,_applyNativeMethods2.default)(Switch);

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _applyLayout=__webpack_require__(93);var _applyLayout2=_interopRequireDefault(_applyLayout);var _applyNativeMethods=__webpack_require__(18);var _applyNativeMethods2=_interopRequireDefault(_applyNativeMethods);var _ExecutionEnvironment=__webpack_require__(16);var _react=__webpack_require__(0);var _ColorPropType=__webpack_require__(14);var _ColorPropType2=_interopRequireDefault(_ColorPropType);var _createElement=__webpack_require__(41);var _createElement2=_interopRequireDefault(_createElement);var _findNodeHandle=__webpack_require__(42);var _findNodeHandle2=_interopRequireDefault(_findNodeHandle);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _StyleSheetPropType=__webpack_require__(56);var _StyleSheetPropType2=_interopRequireDefault(_StyleSheetPropType);var _TextInputStylePropTypes=__webpack_require__(381);var _TextInputStylePropTypes2=_interopRequireDefault(_TextInputStylePropTypes);var _TextInputState=__webpack_require__(98);var _TextInputState2=_interopRequireDefault(_TextInputState);var _ViewPropTypes=__webpack_require__(15);var _ViewPropTypes2=_interopRequireDefault(_ViewPropTypes);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var isAndroid=_ExecutionEnvironment.canUseDOM&&/Android/i.test(navigator&&navigator.userAgent);var emptyObject={};var normalizeEventHandler=function normalizeEventHandler(handler){return function(e){if(handler){e.nativeEvent.text=e.target.value;return handler(e);}};};var isSelectionStale=function isSelectionStale(node,selection){if(node&&selection){var selectionEnd=node.selectionEnd,selectionStart=node.selectionStart;var start=selection.start,end=selection.end;return start!==selectionStart||end!==selectionEnd;}return false;};var setSelection=function setSelection(node,selection){try{if(isSelectionStale(node,selection)){var start=selection.start,end=selection.end;if(isAndroid){setTimeout(function(){return node.setSelectionRange(start,end||start);},10);}else{node.setSelectionRange(start,end||start);}}}catch(e){}};var TextInput=function(_Component){_inherits(TextInput,_Component);function TextInput(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TextInput);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TextInput.__proto__||Object.getPrototypeOf(TextInput)).call.apply(_ref,[this].concat(args))),_this),_this._handleBlur=function(e){var onBlur=_this.props.onBlur;if(onBlur){onBlur(e);}},_this._handleChange=function(e){var _this$props=_this.props,onChange=_this$props.onChange,onChangeText=_this$props.onChangeText;var text=e.nativeEvent.text;if(onChange){onChange(e);}if(onChangeText){onChangeText(text);}},_this._handleFocus=function(e){var _this$props2=_this.props,clearTextOnFocus=_this$props2.clearTextOnFocus,onFocus=_this$props2.onFocus,selectTextOnFocus=_this$props2.selectTextOnFocus;var node=_this._node;if(onFocus){onFocus(e);}if(clearTextOnFocus){_this.clear();}if(selectTextOnFocus){node&&node.select();}},_this._handleKeyDown=function(e){e.stopPropagation();if(e.which===8||e.which===9||e.which===13&&e.metaKey){_this._handleKeyPress(e);}},_this._handleKeyPress=function(e){var _this$props3=_this.props,blurOnSubmit=_this$props3.blurOnSubmit,multiline=_this$props3.multiline,onKeyPress=_this$props3.onKeyPress,onSubmitEditing=_this$props3.onSubmitEditing;var blurOnSubmitDefault=!multiline;var shouldBlurOnSubmit=blurOnSubmit==null?blurOnSubmitDefault:blurOnSubmit;if(onKeyPress){var keyValue=void 0;switch(e.which){case 8:keyValue='Backspace';break;case 9:keyValue='Tab';break;case 13:keyValue='Enter';break;case 32:keyValue=' ';break;default:{if(e.shiftKey){keyValue=String.fromCharCode(e.which).trim();}else{keyValue=String.fromCharCode(e.which).toLowerCase().trim();}}}if(keyValue){e.nativeEvent={altKey:e.altKey,ctrlKey:e.ctrlKey,key:keyValue,metaKey:e.metaKey,shiftKey:e.shiftKey,target:e.target};onKeyPress(e);}}if(!e.isDefaultPrevented()&&e.which===13&&!e.shiftKey){if((blurOnSubmit||!multiline)&&onSubmitEditing){e.nativeEvent={target:e.target,text:e.target.value};onSubmitEditing(e);}if(shouldBlurOnSubmit){_this.blur();}}},_this._handleSelectionChange=function(e){var _this$props4=_this.props,onSelectionChange=_this$props4.onSelectionChange,_this$props4$selectio=_this$props4.selection,selection=_this$props4$selectio===undefined?emptyObject:_this$props4$selectio;if(onSelectionChange){try{var node=e.target;if(isSelectionStale(node,selection)){var selectionStart=node.selectionStart,selectionEnd=node.selectionEnd;e.nativeEvent.selection={start:selectionStart,end:selectionEnd};onSelectionChange(e);}}catch(e){}}},_this._setNode=function(component){_this._node=(0,_findNodeHandle2.default)(component);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TextInput,[{key:'blur',value:function blur(){_TextInputState2.default.blurTextInput(this._node);}},{key:'clear',value:function clear(){this._node.value='';}},{key:'focus',value:function focus(){_TextInputState2.default.focusTextInput(this._node);}},{key:'isFocused',value:function isFocused(){return _TextInputState2.default.currentlyFocusedField()===this._node;}},{key:'componentDidMount',value:function componentDidMount(){setSelection(this._node,this.props.selection);}},{key:'componentDidUpdate',value:function componentDidUpdate(){setSelection(this._node,this.props.selection);}},{key:'render',value:function render(){var _props=this.props,autoCorrect=_props.autoCorrect,editable=_props.editable,keyboardType=_props.keyboardType,multiline=_props.multiline,numberOfLines=_props.numberOfLines,secureTextEntry=_props.secureTextEntry,style=_props.style,blurOnSubmit=_props.blurOnSubmit,clearTextOnFocus=_props.clearTextOnFocus,onChangeText=_props.onChangeText,onSelectionChange=_props.onSelectionChange,onSubmitEditing=_props.onSubmitEditing,selection=_props.selection,selectTextOnFocus=_props.selectTextOnFocus,caretHidden=_props.caretHidden,clearButtonMode=_props.clearButtonMode,dataDetectorTypes=_props.dataDetectorTypes,disableFullscreenUI=_props.disableFullscreenUI,enablesReturnKeyAutomatically=_props.enablesReturnKeyAutomatically,inlineImageLeft=_props.inlineImageLeft,inlineImagePadding=_props.inlineImagePadding,keyboardAppearance=_props.keyboardAppearance,onContentSizeChange=_props.onContentSizeChange,onEndEditing=_props.onEndEditing,onScroll=_props.onScroll,placeholderTextColor=_props.placeholderTextColor,returnKeyLabel=_props.returnKeyLabel,returnKeyType=_props.returnKeyType,selectionColor=_props.selectionColor,selectionState=_props.selectionState,spellCheck=_props.spellCheck,textBreakStrategy=_props.textBreakStrategy,underlineColorAndroid=_props.underlineColorAndroid,otherProps=_objectWithoutProperties(_props,['autoCorrect','editable','keyboardType','multiline','numberOfLines','secureTextEntry','style','blurOnSubmit','clearTextOnFocus','onChangeText','onSelectionChange','onSubmitEditing','selection','selectTextOnFocus','caretHidden','clearButtonMode','dataDetectorTypes','disableFullscreenUI','enablesReturnKeyAutomatically','inlineImageLeft','inlineImagePadding','keyboardAppearance','onContentSizeChange','onEndEditing','onScroll','placeholderTextColor','returnKeyLabel','returnKeyType','selectionColor','selectionState','spellCheck','textBreakStrategy','underlineColorAndroid']);var type=void 0;switch(keyboardType){case'email-address':type='email';break;case'number-pad':case'numeric':type='number';break;case'phone-pad':type='tel';break;case'search':case'web-search':type='search';break;case'url':type='url';break;default:type='text';}if(secureTextEntry){type='password';}var component=multiline?'textarea':'input';_extends(otherProps,{autoCorrect:autoCorrect?'on':'off',dir:'auto',onBlur:normalizeEventHandler(this._handleBlur),onChange:normalizeEventHandler(this._handleChange),onFocus:normalizeEventHandler(this._handleFocus),onKeyDown:this._handleKeyDown,onKeyPress:this._handleKeyPress,onSelect:normalizeEventHandler(this._handleSelectionChange),readOnly:!editable,ref:this._setNode,style:[styles.initial,style]});if(multiline){otherProps.rows=numberOfLines;}else{otherProps.type=type;}return(0,_createElement2.default)(component,otherProps);}}]);return TextInput;}(_react.Component);TextInput.displayName='TextInput';TextInput.defaultProps={autoCapitalize:'sentences',autoComplete:'on',autoCorrect:true,editable:true,keyboardType:'default',multiline:false,numberOfLines:2,secureTextEntry:false,style:emptyObject};TextInput.State=_TextInputState2.default;TextInput.propTypes= false?_extends({},_ViewPropTypes2.default,{autoCapitalize:(0,_propTypes.oneOf)(['characters','none','sentences','words']),autoComplete:_propTypes.string,autoCorrect:_propTypes.bool,autoFocus:_propTypes.bool,blurOnSubmit:_propTypes.bool,clearTextOnFocus:_propTypes.bool,defaultValue:_propTypes.string,editable:_propTypes.bool,keyboardType:(0,_propTypes.oneOf)(['default','email-address','number-pad','numeric','phone-pad','search','url','web-search']),maxLength:_propTypes.number,multiline:_propTypes.bool,numberOfLines:_propTypes.number,onBlur:_propTypes.func,onChange:_propTypes.func,onChangeText:_propTypes.func,onFocus:_propTypes.func,onKeyPress:_propTypes.func,onSelectionChange:_propTypes.func,onSubmitEditing:_propTypes.func,placeholder:_propTypes.string,secureTextEntry:_propTypes.bool,selectTextOnFocus:_propTypes.bool,selection:(0,_propTypes.shape)({start:_propTypes.number.isRequired,end:_propTypes.number}),style:(0,_StyleSheetPropType2.default)(_TextInputStylePropTypes2.default),value:_propTypes.string,caretHidden:_propTypes.bool,clearButtonMode:_propTypes.string,dataDetectorTypes:_propTypes.string,disableFullscreenUI:_propTypes.bool,enablesReturnKeyAutomatically:_propTypes.bool,keyboardAppearance:_propTypes.string,inlineImageLeft:_propTypes.string,inlineImagePadding:_propTypes.number,onContentSizeChange:_propTypes.func,onEndEditing:_propTypes.func,onScroll:_propTypes.func,placeholderTextColor:_ColorPropType2.default,returnKeyLabel:_propTypes.string,returnKeyType:_propTypes.string,selectionColor:_ColorPropType2.default,selectionState:_propTypes.any,spellCheck:_propTypes.bool,textBreakStrategy:_propTypes.string,underlineColorAndroid:_ColorPropType2.default}):{};var styles=_StyleSheet2.default.create({initial:{appearance:'none',backgroundColor:'transparent',borderColor:'black',borderRadius:0,borderWidth:0,boxSizing:'border-box',color:'inherit',font:'inherit',padding:0,resize:'none'}});exports.default=(0,_applyLayout2.default)((0,_applyNativeMethods2.default)(TextInput));

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _TextStylePropTypes=__webpack_require__(171);var _TextStylePropTypes2=_interopRequireDefault(_TextStylePropTypes);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TextInputStylePropTypes=_extends({},_TextStylePropTypes2.default,{resize:(0,_propTypes.oneOf)(['none','vertical','horizontal','both'])});exports.default=TextInputStylePropTypes;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='src/components/Touchable/TouchableHighlight.js';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _applyNativeMethods=__webpack_require__(18);var _applyNativeMethods2=_interopRequireDefault(_applyNativeMethods);var _ColorPropType=__webpack_require__(14);var _ColorPropType2=_interopRequireDefault(_ColorPropType);var _createReactClass=__webpack_require__(28);var _createReactClass2=_interopRequireDefault(_createReactClass);var _ensureComponentIsNative=__webpack_require__(383);var _ensureComponentIsNative2=_interopRequireDefault(_ensureComponentIsNative);var _ensurePositiveDelayProps=__webpack_require__(101);var _ensurePositiveDelayProps2=_interopRequireDefault(_ensurePositiveDelayProps);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _StyleSheet=__webpack_require__(9);var _StyleSheet2=_interopRequireDefault(_StyleSheet);var _reactTimerMixin=__webpack_require__(103);var _reactTimerMixin2=_interopRequireDefault(_reactTimerMixin);var _Touchable=__webpack_require__(69);var _Touchable2=_interopRequireDefault(_Touchable);var _TouchableWithoutFeedback=__webpack_require__(102);var _TouchableWithoutFeedback2=_interopRequireDefault(_TouchableWithoutFeedback);var _View=__webpack_require__(11);var _View2=_interopRequireDefault(_View);var _ViewPropTypes=__webpack_require__(15);var _ViewPropTypes2=_interopRequireDefault(_ViewPropTypes);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var DEFAULT_PROPS={activeOpacity:0.85,underlayColor:'black'};var PRESS_RETENTION_OFFSET={top:20,left:20,right:20,bottom:30};var TouchableHighlight=(0,_createReactClass2.default)({displayName:'TouchableHighlight',propTypes:_extends({},_TouchableWithoutFeedback2.default.propTypes,{activeOpacity:_propTypes.number,onHideUnderlay:_propTypes.func,onShowUnderlay:_propTypes.func,style:_ViewPropTypes2.default.style,underlayColor:_ColorPropType2.default}),mixins:[_reactTimerMixin2.default,_Touchable2.default.Mixin],getDefaultProps:function getDefaultProps(){return DEFAULT_PROPS;},_computeSyntheticState:function _computeSyntheticState(props){return{activeProps:{style:{opacity:props.activeOpacity}},activeUnderlayProps:{style:{backgroundColor:props.underlayColor}},underlayStyle:[INACTIVE_UNDERLAY_PROPS.style,props.style]};},getInitialState:function getInitialState(){this._isMounted=false;return _extends({},this.touchableGetInitialState(),this._computeSyntheticState(this.props));},componentDidMount:function componentDidMount(){this._isMounted=true;(0,_ensurePositiveDelayProps2.default)(this.props);(0,_ensureComponentIsNative2.default)(this._childRef);},componentWillUnmount:function componentWillUnmount(){this._isMounted=false;},componentDidUpdate:function componentDidUpdate(){(0,_ensureComponentIsNative2.default)(this._childRef);},componentWillReceiveProps:function componentWillReceiveProps(nextProps){(0,_ensurePositiveDelayProps2.default)(nextProps);if(nextProps.activeOpacity!==this.props.activeOpacity||nextProps.underlayColor!==this.props.underlayColor||nextProps.style!==this.props.style){this.setState(this._computeSyntheticState(nextProps));}},touchableHandleActivePressIn:function touchableHandleActivePressIn(e){this.clearTimeout(this._hideTimeout);this._hideTimeout=null;this._showUnderlay();this.props.onPressIn&&this.props.onPressIn(e);},touchableHandleActivePressOut:function touchableHandleActivePressOut(e){if(!this._hideTimeout){this._hideUnderlay();}this.props.onPressOut&&this.props.onPressOut(e);},touchableHandlePress:function touchableHandlePress(e){this.clearTimeout(this._hideTimeout);this._showUnderlay();this._hideTimeout=this.setTimeout(this._hideUnderlay,this.props.delayPressOut||100);this.props.onPress&&this.props.onPress(e);},touchableHandleLongPress:function touchableHandleLongPress(e){this.props.onLongPress&&this.props.onLongPress(e);},touchableGetPressRectOffset:function touchableGetPressRectOffset(){return this.props.pressRetentionOffset||PRESS_RETENTION_OFFSET;},touchableGetHitSlop:function touchableGetHitSlop(){return this.props.hitSlop;},touchableGetHighlightDelayMS:function touchableGetHighlightDelayMS(){return this.props.delayPressIn;},touchableGetLongPressDelayMS:function touchableGetLongPressDelayMS(){return this.props.delayLongPress;},touchableGetPressOutDelayMS:function touchableGetPressOutDelayMS(){return this.props.delayPressOut;},_showUnderlay:function _showUnderlay(){if(!this._isMounted||!this._hasPressHandler()){return;}this._underlayRef.setNativeProps(this.state.activeUnderlayProps);this._childRef.setNativeProps(this.state.activeProps);this.props.onShowUnderlay&&this.props.onShowUnderlay();},_hideUnderlay:function _hideUnderlay(){this.clearTimeout(this._hideTimeout);this._hideTimeout=null;if(this._hasPressHandler()&&this._underlayRef){this._childRef.setNativeProps(INACTIVE_CHILD_PROPS);this._underlayRef.setNativeProps(_extends({},INACTIVE_UNDERLAY_PROPS,{style:this.state.underlayStyle}));this.props.onHideUnderlay&&this.props.onHideUnderlay();}},_hasPressHandler:function _hasPressHandler(){return!!(this.props.onPress||this.props.onPressIn||this.props.onPressOut||this.props.onLongPress);},_setChildRef:function _setChildRef(node){this._childRef=node;},_setUnderlayRef:function _setUnderlayRef(node){this._underlayRef=node;},render:function render(){var _props=this.props,activeOpacity=_props.activeOpacity,onHideUnderlay=_props.onHideUnderlay,onShowUnderlay=_props.onShowUnderlay,underlayColor=_props.underlayColor,delayLongPress=_props.delayLongPress,delayPressIn=_props.delayPressIn,delayPressOut=_props.delayPressOut,onLongPress=_props.onLongPress,onPress=_props.onPress,onPressIn=_props.onPressIn,onPressOut=_props.onPressOut,pressRetentionOffset=_props.pressRetentionOffset,other=_objectWithoutProperties(_props,['activeOpacity','onHideUnderlay','onShowUnderlay','underlayColor','delayLongPress','delayPressIn','delayPressOut','onLongPress','onPress','onPressIn','onPressOut','pressRetentionOffset']);return _react2.default.createElement(_View2.default,_extends({},other,{accessible:this.props.accessible!==false,onKeyDown:this.touchableHandleKeyEvent,onKeyUp:this.touchableHandleKeyEvent,onResponderGrant:this.touchableHandleResponderGrant,onResponderMove:this.touchableHandleResponderMove,onResponderRelease:this.touchableHandleResponderRelease,onResponderTerminate:this.touchableHandleResponderTerminate,onResponderTerminationRequest:this.touchableHandleResponderTerminationRequest,onStartShouldSetResponder:this.touchableHandleStartShouldSetResponder,ref:this._setUnderlayRef,style:[styles.root,!this.props.disabled&&styles.actionable,this.state.underlayStyle],__source:{fileName:_jsxFileName,lineNumber:254}}),_react2.default.cloneElement(_react2.default.Children.only(this.props.children),{ref:this._setChildRef}),_Touchable2.default.renderDebugView({color:'green',hitSlop:this.props.hitSlop}));}});var INACTIVE_CHILD_PROPS={style:_StyleSheet2.default.create({x:{opacity:1.0}}).x};var INACTIVE_UNDERLAY_PROPS={style:_StyleSheet2.default.create({x:{backgroundColor:'transparent'}}).x};var styles=_StyleSheet2.default.create({root:{userSelect:'none'},actionable:{cursor:'pointer',touchAction:'manipulate'}});exports.default=(0,_applyNativeMethods2.default)(TouchableHighlight);

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _invariant=__webpack_require__(8);var _invariant2=_interopRequireDefault(_invariant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ensureComponentIsNative=function ensureComponentIsNative(component){(0,_invariant2.default)(component&&typeof component.setNativeProps==='function','Touchable child must either be native or forward setNativeProps to a native component');};exports.default=ensureComponentIsNative;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _UnimplementedView=__webpack_require__(35);var _UnimplementedView2=_interopRequireDefault(_UnimplementedView);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_UnimplementedView2.default;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _UnimplementedView=__webpack_require__(35);var _UnimplementedView2=_interopRequireDefault(_UnimplementedView);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_UnimplementedView2.default;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createStrictShapeTypeChecker=__webpack_require__(92);var _createStrictShapeTypeChecker2=_interopRequireDefault(_createStrictShapeTypeChecker);var _propTypes=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var PointPropType=(0,_createStrictShapeTypeChecker2.default)({x:_propTypes.number,y:_propTypes.number});exports.default=PointPropType;

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native_web__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native_web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native_web__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__font_css__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__font_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__font_css__);
var ReactNative=__webpack_require__(1);var Modal=__webpack_require__(389);ReactNative.Modal=Modal;__webpack_require__(396);

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Modal
 * 
 */var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_container;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var React=__webpack_require__(0);var PropTypes=__webpack_require__(3);var _require=__webpack_require__(1),Platform=_require.Platform,StyleSheet=_require.StyleSheet,I18nManager=_require.I18nManager,View=_require.View;var ModalComponent=__webpack_require__(390).default;/**
 * The Modal component is a simple way to present content above an enclosing view.
 *
 * _Note: If you need more control over how to present modals over the rest of your app,
 * then consider using a top-level Navigator._
 *
 * ```javascript
 * import React, { Component } from 'react';
 * import { Modal, Text, TouchableHighlight, View } from 'react-native';
 *
 * class ModalExample extends Component {
 *
 *   state = {
 *     modalVisible: false,
 *   }
 *
 *   setModalVisible(visible) {
 *     this.setState({modalVisible: visible});
 *   }
 *
 *   render() {
 *     return (
 *       <View style={{marginTop: 22}}>
 *         <Modal
 *           animationType={"slide"}
 *           transparent={false}
 *           visible={this.state.modalVisible}
 *           onRequestClose={() => {alert("Modal has been closed.")}}
 *           >
 *          <View style={{marginTop: 22}}>
 *           <View>
 *             <Text>Hello World!</Text>
 *
 *             <TouchableHighlight onPress={() => {
 *               this.setModalVisible(!this.state.modalVisible)
 *             }}>
 *               <Text>Hide Modal</Text>
 *             </TouchableHighlight>
 *
 *           </View>
 *          </View>
 *         </Modal>
 *
 *         <TouchableHighlight onPress={() => {
 *           this.setModalVisible(true)
 *         }}>
 *           <Text>Show Modal</Text>
 *         </TouchableHighlight>
 *
 *       </View>
 *     );
 *   }
 * }
 * ```
 */var ANIMATION_IN_TYPES={slide:'slideInUp',face:'fadeIn'};var ANIMATION_OUT_TYPES={slide:'slideOutDown',face:'fadeOut'};var Modal=(_temp=_class=function(_React$Component){_inherits(Modal,_React$Component);function Modal(props){_classCallCheck(this,Modal);var _this=_possibleConstructorReturn(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).call(this,props));Modal._confirmProps(props);return _this;}_createClass(Modal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){Modal._confirmProps(nextProps);}},{key:'render',value:function render(){var _props=this.props,children=_props.children,visible=_props.visible,animationType=_props.animationType,transparent=_props.transparent,onRequestClose=_props.onRequestClose,onShow=_props.onShow,otherProps=_objectWithoutProperties(_props,['children','visible','animationType','transparent','onRequestClose','onShow']);return React.createElement(ModalComponent,Object.assign({visible:visible,animationIn:ANIMATION_IN_TYPES[animationType],animationOut:ANIMATION_OUT_TYPES[animationType],backdropOpacity:transparent?0:1,onModalShow:onShow,onModalHide:onRequestClose},otherProps),React.createElement(View,{style:[styles.container,this.props.style]},children));}}],[{key:'_confirmProps',value:function _confirmProps(props){if(props.presentationStyle&&props.presentationStyle!=='overFullScreen'&&props.transparent){console.warn('Modal with \''+props.presentationStyle+'\' presentation style and \'transparent\' value is not supported.');}}}]);return Modal;}(React.Component),_class.propTypes={/**
     * The `animationType` prop controls how the modal animates.
     *
     * - `slide` slides in from the bottom
     * - `fade` fades into view
     * - `none` appears without an animation
     *
     * Default is set to `none`.
     */animationType:PropTypes.oneOf(['none','slide','fade']),/**
     * The `presentationStyle` prop controls how the modal appears (generally on larger devices such as iPad or plus-sized iPhones).
     * See https://developer.apple.com/reference/uikit/uimodalpresentationstyle for details.
     * @platform ios
     *
     * - `fullScreen` covers the screen completely
     * - `pageSheet` covers portrait-width view centered (only on larger devices)
     * - `formSheet` covers narrow-width view centered (only on larger devices)
     * - `overFullScreen` covers the screen completely, but allows transparency
     *
     * Default is set to `overFullScreen` or `fullScreen` depending on `transparent` property.
     */presentationStyle:PropTypes.oneOf(['fullScreen','pageSheet','formSheet','overFullScreen']),/**
     * The `transparent` prop determines whether your modal will fill the entire view. Setting this to `true` will render the modal over a transparent background.
     */transparent:PropTypes.bool,/**
     * The `hardwareAccelerated` prop controls whether to force hardware acceleration for the underlying window.
     * @platform android
     */hardwareAccelerated:PropTypes.bool,/**
     * The `visible` prop determines whether your modal is visible.
     */visible:PropTypes.bool,/**
     * The `onRequestClose` callback is called when the user taps the hardware back button.
     * @platform android
     */onRequestClose:Platform.OS==='android'?PropTypes.func.isRequired:PropTypes.func,/**
     * The `onShow` prop allows passing a function that will be called once the modal has been shown.
     */onShow:PropTypes.func,/**
     * The `supportedOrientations` prop allows the modal to be rotated to any of the specified orientations.
     * On iOS, the modal is still restricted by what's specified in your app's Info.plist's UISupportedInterfaceOrientations field.
     * When using `presentationStyle` of `pageSheet` or `formSheet`, this property will be ignored by iOS.
     * @platform ios
     */supportedOrientations:PropTypes.arrayOf(PropTypes.oneOf(['portrait','portrait-upside-down','landscape','landscape-left','landscape-right'])),/**
     * The `onOrientationChange` callback is called when the orientation changes while the modal is being displayed.
     * The orientation provided is only 'portrait' or 'landscape'. This callback is also called on initial render, regardless of the current orientation.
     * @platform ios
     */onOrientationChange:PropTypes.func},_class.defaultProps={visible:true,hardwareAccelerated:false},_temp);var side=I18nManager.isRTL?'right':'left';var styles=StyleSheet.create({modal:{position:'absolute'},container:(_container={position:'absolute'},_defineProperty(_container,side,0),_defineProperty(_container,'top',0),_container)});module.exports=Modal;

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Animated", function() { return AnimatedModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SiblingsManager__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalContainer__ = __webpack_require__(395);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Manager", function() { return __WEBPACK_IMPORTED_MODULE_3__SiblingsManager__["a"]; });
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Modal=(_temp=_class=function(_Component){_inherits(Modal,_Component);function Modal(){_classCallCheck(this,Modal);return _possibleConstructorReturn(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).apply(this,arguments));}_createClass(Modal,[{key:'componentWillMount',value:function componentWillMount(){this._modal=new __WEBPACK_IMPORTED_MODULE_3__SiblingsManager__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModalContainer__["b" /* default */],this.props));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this._modal.update(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModalContainer__["b" /* default */],nextProps));}},{key:'componentWillUnmount',value:function componentWillUnmount(){this._modal.destroy();}},{key:'render',value:function render(){return null;}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.displayName='Modal',_class.propTypes=_extends({visible:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool},__WEBPACK_IMPORTED_MODULE_0_react_native__["Animated"].View.propTypes),_class.defaultProps={visible:false},_temp);var AnimatedModal=function(_Modal){_inherits(AnimatedModal,_Modal);function AnimatedModal(){_classCallCheck(this,AnimatedModal);return _possibleConstructorReturn(this,(AnimatedModal.__proto__||Object.getPrototypeOf(AnimatedModal)).apply(this,arguments));}_createClass(AnimatedModal,[{key:'componentWillMount',value:function componentWillMount(){this._modal=new __WEBPACK_IMPORTED_MODULE_3__SiblingsManager__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModalContainer__["a" /* AnimatedModalContainer */],this.props));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this._modal.update(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModalContainer__["a" /* AnimatedModalContainer */],nextProps));}}]);return AnimatedModal;}(Modal);if(!__WEBPACK_IMPORTED_MODULE_0_react_native__["Animated"].Modal){__WEBPACK_IMPORTED_MODULE_0_react_native__["Animated"].Modal=AnimatedModal;}/* harmony default export */ __webpack_exports__["default"] = (Modal);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppRegistryInjection__ = __webpack_require__(392);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var styles=__WEBPACK_IMPORTED_MODULE_1_react_native__["StyleSheet"].create({offStream:{position:'absolute'}});var uid=0;var _default=function(){function _default(element,callback){_classCallCheck(this,_default);this._id=null;Object.defineProperty(this,'_id',{enumerable:false,configurable:false,writable:false,value:uid++});this.update(element,callback);}_createClass(_default,[{key:'_offStreamElement',value:function _offStreamElement(element){return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(element,{style:[element.props.style,styles.offStream]});}},{key:'update',value:function update(element,callback){__WEBPACK_IMPORTED_MODULE_2__AppRegistryInjection__["a" /* default */].emit('siblings.update',this._id,this._offStreamElement(element),callback);}},{key:'destroy',value:function destroy(callback){__WEBPACK_IMPORTED_MODULE_2__AppRegistryInjection__["a" /* default */].emit('siblings.update',this._id,null,callback);}}]);return _default;}();

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_static_container__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_wolfy87_eventemitter__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_wolfy87_eventemitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_wolfy87_eventemitter__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=__WEBPACK_IMPORTED_MODULE_0_react_native__["StyleSheet"].create({container:{flex:1,position:'relative'}});var emitter=__WEBPACK_IMPORTED_MODULE_0_react_native__["AppRegistry"].rootSiblingsEmitter;if(!(emitter instanceof __WEBPACK_IMPORTED_MODULE_3_wolfy87_eventemitter___default.a)){emitter=new __WEBPACK_IMPORTED_MODULE_3_wolfy87_eventemitter___default.a();// inject modals into app entry component
var originRegister=__WEBPACK_IMPORTED_MODULE_0_react_native__["AppRegistry"].registerComponent;__WEBPACK_IMPORTED_MODULE_0_react_native__["AppRegistry"].registerComponent=function(appKey,getAppComponent){var siblings=new Map();var updates=new Set();return originRegister(appKey,function(){var _class,_temp;var OriginAppComponent=getAppComponent();return _temp=_class=function(_Component){_inherits(_class,_Component);function _class(){_classCallCheck(this,_class);return _possibleConstructorReturn(this,(_class.__proto__||Object.getPrototypeOf(_class)).apply(this,arguments));}_createClass(_class,[{key:'componentWillMount',value:function componentWillMount(){this._update=this._update.bind(this);emitter.addListener('siblings.update',this._update);}},{key:'componentWillUnmount',value:function componentWillUnmount(){emitter.removeListener('siblings.update',this._update);siblings.clear();updates.clear();}},{key:'_update',value:function _update(id,element,callback){if(siblings.has(id)&&!element){siblings.delete(id);}else{siblings.set(id,element);}updates.add(id);this.forceUpdate(callback);}},{key:'render',value:function render(){var elements=[];siblings.forEach(function(element,id){elements.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_static_container__["a" /* default */],{key:'root-sibling-'+id,shouldUpdate:updates.has(id)},element));});updates.clear();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_native__["View"],{style:styles.container},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_static_container__["a" /* default */],{shouldUpdate:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(OriginAppComponent,this.props)),elements);}}]);return _class;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.displayName='Root('+appKey+')',_temp;});};__WEBPACK_IMPORTED_MODULE_0_react_native__["AppRegistry"].rootSiblingsEmitter=emitter;}/* harmony default export */ __webpack_exports__["a"] = (emitter);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _default=(_temp=_class=function(_Component){_inherits(_default,_Component);function _default(){_classCallCheck(this,_default);return _possibleConstructorReturn(this,(_default.__proto__||Object.getPrototypeOf(_default)).apply(this,arguments));}_createClass(_default,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return nextProps.shouldUpdate;}},{key:'render',value:function render(){var child=this.props.children;return child===null||child===false?null:__WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(child);}}]);return _default;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={shouldUpdate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired},_temp);

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * EventEmitter v5.2.3 - git.io/ee
 * Unlicense - http://unlicense.org/
 * Oliver Caldwell - http://oli.me.uk/
 * @preserve
 */

;(function (exports) {
    'use strict';

    /**
     * Class for managing events.
     * Can be extended to provide event functionality in other classes.
     *
     * @class EventEmitter Manages event registering and emitting.
     */
    function EventEmitter() {}

    // Shortcuts to improve speed and size
    var proto = EventEmitter.prototype;
    var originalGlobalValue = exports.EventEmitter;

    /**
     * Finds the index of the listener for the event in its storage array.
     *
     * @param {Function[]} listeners Array of listeners to search through.
     * @param {Function} listener Method to look for.
     * @return {Number} Index of the specified listener, -1 if not found
     * @api private
     */
    function indexOfListener(listeners, listener) {
        var i = listeners.length;
        while (i--) {
            if (listeners[i].listener === listener) {
                return i;
            }
        }

        return -1;
    }

    /**
     * Alias a method while keeping the context correct, to allow for overwriting of target method.
     *
     * @param {String} name The name of the target method.
     * @return {Function} The aliased method
     * @api private
     */
    function alias(name) {
        return function aliasClosure() {
            return this[name].apply(this, arguments);
        };
    }

    /**
     * Returns the listener array for the specified event.
     * Will initialise the event object and listener arrays if required.
     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
     * Each property in the object response is an array of listener functions.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Function[]|Object} All listener functions for the event.
     */
    proto.getListeners = function getListeners(evt) {
        var events = this._getEvents();
        var response;
        var key;

        // Return a concatenated array of all matching events if
        // the selector is a regular expression.
        if (evt instanceof RegExp) {
            response = {};
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    response[key] = events[key];
                }
            }
        }
        else {
            response = events[evt] || (events[evt] = []);
        }

        return response;
    };

    /**
     * Takes a list of listener objects and flattens it into a list of listener functions.
     *
     * @param {Object[]} listeners Raw listener objects.
     * @return {Function[]} Just the listener functions.
     */
    proto.flattenListeners = function flattenListeners(listeners) {
        var flatListeners = [];
        var i;

        for (i = 0; i < listeners.length; i += 1) {
            flatListeners.push(listeners[i].listener);
        }

        return flatListeners;
    };

    /**
     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Object} All listener functions for an event in an object.
     */
    proto.getListenersAsObject = function getListenersAsObject(evt) {
        var listeners = this.getListeners(evt);
        var response;

        if (listeners instanceof Array) {
            response = {};
            response[evt] = listeners;
        }

        return response || listeners;
    };

    function isValidListener (listener) {
        if (typeof listener === 'function' || listener instanceof RegExp) {
            return true
        } else if (listener && typeof listener === 'object') {
            return isValidListener(listener.listener)
        } else {
            return false
        }
    }

    /**
     * Adds a listener function to the specified event.
     * The listener will not be added if it is a duplicate.
     * If the listener returns true then it will be removed after it is called.
     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListener = function addListener(evt, listener) {
        if (!isValidListener(listener)) {
            throw new TypeError('listener must be a function');
        }

        var listeners = this.getListenersAsObject(evt);
        var listenerIsWrapped = typeof listener === 'object';
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
                listeners[key].push(listenerIsWrapped ? listener : {
                    listener: listener,
                    once: false
                });
            }
        }

        return this;
    };

    /**
     * Alias of addListener
     */
    proto.on = alias('addListener');

    /**
     * Semi-alias of addListener. It will add a listener that will be
     * automatically removed after its first execution.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addOnceListener = function addOnceListener(evt, listener) {
        return this.addListener(evt, {
            listener: listener,
            once: true
        });
    };

    /**
     * Alias of addOnceListener.
     */
    proto.once = alias('addOnceListener');

    /**
     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
     * You need to tell it what event names should be matched by a regex.
     *
     * @param {String} evt Name of the event to create.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvent = function defineEvent(evt) {
        this.getListeners(evt);
        return this;
    };

    /**
     * Uses defineEvent to define multiple events.
     *
     * @param {String[]} evts An array of event names to define.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvents = function defineEvents(evts) {
        for (var i = 0; i < evts.length; i += 1) {
            this.defineEvent(evts[i]);
        }
        return this;
    };

    /**
     * Removes a listener function from the specified event.
     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to remove the listener from.
     * @param {Function} listener Method to remove from the event.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListener = function removeListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var index;
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                index = indexOfListener(listeners[key], listener);

                if (index !== -1) {
                    listeners[key].splice(index, 1);
                }
            }
        }

        return this;
    };

    /**
     * Alias of removeListener
     */
    proto.off = alias('removeListener');

    /**
     * Adds listeners in bulk using the manipulateListeners method.
     * If you pass an object as the first argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
     * You can also pass it a regular expression to add the array of listeners to all events that match it.
     * Yeah, this function does quite a bit. That's probably a bad thing.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListeners = function addListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(false, evt, listeners);
    };

    /**
     * Removes listeners in bulk using the manipulateListeners method.
     * If you pass an object as the first argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be removed.
     * You can also pass it a regular expression to remove the listeners from all events that match it.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListeners = function removeListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(true, evt, listeners);
    };

    /**
     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
     * The first argument will determine if the listeners are removed (true) or added (false).
     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be added/removed.
     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
     *
     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
        var i;
        var value;
        var single = remove ? this.removeListener : this.addListener;
        var multiple = remove ? this.removeListeners : this.addListeners;

        // If evt is an object then pass each of its properties to this method
        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
            for (i in evt) {
                if (evt.hasOwnProperty(i) && (value = evt[i])) {
                    // Pass the single listener straight through to the singular method
                    if (typeof value === 'function') {
                        single.call(this, i, value);
                    }
                    else {
                        // Otherwise pass back to the multiple function
                        multiple.call(this, i, value);
                    }
                }
            }
        }
        else {
            // So evt must be a string
            // And listeners must be an array of listeners
            // Loop over it and pass each one to the multiple method
            i = listeners.length;
            while (i--) {
                single.call(this, evt, listeners[i]);
            }
        }

        return this;
    };

    /**
     * Removes all listeners from a specified event.
     * If you do not specify an event then all listeners will be removed.
     * That means every event will be emptied.
     * You can also pass a regex to remove all events that match it.
     *
     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeEvent = function removeEvent(evt) {
        var type = typeof evt;
        var events = this._getEvents();
        var key;

        // Remove different things depending on the state of evt
        if (type === 'string') {
            // Remove all listeners for the specified event
            delete events[evt];
        }
        else if (evt instanceof RegExp) {
            // Remove all events matching the regex.
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    delete events[key];
                }
            }
        }
        else {
            // Remove all listeners in all events
            delete this._events;
        }

        return this;
    };

    /**
     * Alias of removeEvent.
     *
     * Added to mirror the node API.
     */
    proto.removeAllListeners = alias('removeEvent');

    /**
     * Emits an event of your choice.
     * When emitted, every listener attached to that event will be executed.
     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
     * So they will not arrive within the array on the other side, they will be separate.
     * You can also pass a regular expression to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {Array} [args] Optional array of arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emitEvent = function emitEvent(evt, args) {
        var listenersMap = this.getListenersAsObject(evt);
        var listeners;
        var listener;
        var i;
        var key;
        var response;

        for (key in listenersMap) {
            if (listenersMap.hasOwnProperty(key)) {
                listeners = listenersMap[key].slice(0);

                for (i = 0; i < listeners.length; i++) {
                    // If the listener returns true then it shall be removed from the event
                    // The function is executed either with a basic call or an apply if there is an args array
                    listener = listeners[i];

                    if (listener.once === true) {
                        this.removeListener(evt, listener.listener);
                    }

                    response = listener.listener.apply(this, args || []);

                    if (response === this._getOnceReturnValue()) {
                        this.removeListener(evt, listener.listener);
                    }
                }
            }
        }

        return this;
    };

    /**
     * Alias of emitEvent
     */
    proto.trigger = alias('emitEvent');

    /**
     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {...*} Optional additional arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emit = function emit(evt) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(evt, args);
    };

    /**
     * Sets the current value to check against when executing listeners. If a
     * listeners return value matches the one set here then it will be removed
     * after execution. This value defaults to true.
     *
     * @param {*} value The new value to check for when executing listeners.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.setOnceReturnValue = function setOnceReturnValue(value) {
        this._onceReturnValue = value;
        return this;
    };

    /**
     * Fetches the current value to check against when executing listeners. If
     * the listeners return value matches this one then it should be removed
     * automatically. It will return true by default.
     *
     * @return {*|Boolean} The current value to check for or the default, true.
     * @api private
     */
    proto._getOnceReturnValue = function _getOnceReturnValue() {
        if (this.hasOwnProperty('_onceReturnValue')) {
            return this._onceReturnValue;
        }
        else {
            return true;
        }
    };

    /**
     * Fetches the events object and creates one if required.
     *
     * @return {Object} The events storage object.
     * @api private
     */
    proto._getEvents = function _getEvents() {
        return this._events || (this._events = {});
    };

    /**
     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
     *
     * @return {Function} Non conflicting EventEmitter class.
     */
    EventEmitter.noConflict = function noConflict() {
        exports.EventEmitter = originalGlobalValue;
        return EventEmitter;
    };

    // Expose the class either via AMD, CommonJS or the global object
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return EventEmitter;
        }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = EventEmitter;
    }
    else {
        exports.EventEmitter = EventEmitter;
    }
}(this || {}));


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimatedModalContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=__WEBPACK_IMPORTED_MODULE_0_react_native__["StyleSheet"].create({defaultModalStyle:{top:0,right:0,bottom:0,left:0,justifyContent:'center',alignItems:'center',backgroundColor:'rgba(0, 0, 0, 0.2)'}});var ModalContainer=(_temp=_class=function(_Component){_inherits(ModalContainer,_Component);function ModalContainer(props){_classCallCheck(this,ModalContainer);var _this=_possibleConstructorReturn(this,(ModalContainer.__proto__||Object.getPrototypeOf(ModalContainer)).call(this,props));_this.state={visible:_this.props.visible};return _this;}_createClass(ModalContainer,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.visible!==this.props.visible){this.setState({visible:nextProps.visible});}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return nextProps.visible||nextProps.visible!==this.props.visible;}},{key:'render',value:function render(){var props=this.props;return this.state.visible?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_native__["View"],Object.assign({},props,{style:[props.style[0]||styles.defaultModalStyle,props.style[1]]})):null;}}]);return ModalContainer;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.displayName='ModalContainer',_class.propTypes=_extends({},__WEBPACK_IMPORTED_MODULE_0_react_native__["Animated"].View.propTypes,{visible:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool}),_class.defaultProps={visible:false},_temp);/* harmony default export */ __webpack_exports__["b"] = (ModalContainer);var AnimatedModalContainer=function(_ModalContainer){_inherits(AnimatedModalContainer,_ModalContainer);function AnimatedModalContainer(){_classCallCheck(this,AnimatedModalContainer);return _possibleConstructorReturn(this,(AnimatedModalContainer.__proto__||Object.getPrototypeOf(AnimatedModalContainer)).apply(this,arguments));}_createClass(AnimatedModalContainer,[{key:'render',value:function render(){var props=this.props;return this.state.visible?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_native__["Animated"].View,Object.assign({},props,{style:[props.style[0]||styles.defaultModalStyle,props.style[1]]})):null;}}]);return AnimatedModalContainer;}(ModalContainer);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_App__ = __webpack_require__(397);
// render(<App />, document.getElementById('root'))
__WEBPACK_IMPORTED_MODULE_2_react_native__["AppRegistry"].registerComponent('NativebaseKitchenSink',function(){return __WEBPACK_IMPORTED_MODULE_3__js_App__["a" /* default */];});__WEBPACK_IMPORTED_MODULE_2_react_native__["AppRegistry"].runApplication('NativebaseKitchenSink',{rootTag:document.getElementById('root')});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_navigation_lib_react_navigation_js__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_navigation_lib_react_navigation_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_navigation_lib_react_navigation_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Drawer__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Header___ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Header_1__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Header_2__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Header_3__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Header_4__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Header_5__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Header_6__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Header_7__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Header_8__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_footer_basicFooter__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_footer_iconFooter__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_footer_iconText__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_footer_badgeFooter__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_button_default__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_button_outline__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_button_rounded__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_button_block__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_button_full__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_button_custom__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_button_transparent__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_button_iconBtn__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_button_disabled__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_card_basic__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_card_card_image__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_card_card_showcase__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_card_card_list__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_card_card_header_and_footer__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_fab_basic__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_fab_multiple__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_form_fixedLabel__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_form_inlineLabel__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_form_floatingLabel__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_form_placeholder__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_form_stacked__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_inputgroup_regular__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_inputgroup_underline__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_inputgroup_rounded__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_inputgroup_iconInput__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_inputgroup_success__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_inputgroup_error__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_inputgroup_disabledInput__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_layout_row__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_layout_column__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_layout_nested__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_layout_customRow__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_layout_customCol__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_listSwipe_basic_list_swipe__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_listSwipe_multi_list_swipe__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_list_basic_list__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_list_list_divider__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_list_list_separator__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_list_list_headers__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_list_list_icon__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_list_list_avatar__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_list_list_thumbnail__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_picker_regularPicker__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_picker_placeholderPicker__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_picker_placeholderPickernote__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_picker_backButtonPicker__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_picker_headerPicker__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_picker_headerStylePicker__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_picker_customHeaderPicker__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_tab_basicTab__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_tab_configTab__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_tab_scrollableTab__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_segment_SegmentHeader__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_actionsheet_regular__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_actionsheet_icon__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_segment_segmentTab__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_deckswiper_simple__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_deckswiper_advanced__ = __webpack_require__(771);
var AppNavigator=Object(__WEBPACK_IMPORTED_MODULE_3_react_navigation_lib_react_navigation_js__["StackNavigator"])({Drawer:{screen:__WEBPACK_IMPORTED_MODULE_4__Drawer__["a" /* default */]},Header1:{screen:__WEBPACK_IMPORTED_MODULE_6__components_Header_1__["a" /* default */]},Header2:{screen:__WEBPACK_IMPORTED_MODULE_7__components_Header_2__["a" /* default */]},Header3:{screen:__WEBPACK_IMPORTED_MODULE_8__components_Header_3__["a" /* default */]},Header4:{screen:__WEBPACK_IMPORTED_MODULE_9__components_Header_4__["a" /* default */]},Header5:{screen:__WEBPACK_IMPORTED_MODULE_10__components_Header_5__["a" /* default */]},Header6:{screen:__WEBPACK_IMPORTED_MODULE_11__components_Header_6__["a" /* default */]},Header7:{screen:__WEBPACK_IMPORTED_MODULE_12__components_Header_7__["a" /* default */]},Header8:{screen:__WEBPACK_IMPORTED_MODULE_13__components_Header_8__["a" /* default */]},BasicFooter:{screen:__WEBPACK_IMPORTED_MODULE_14__components_footer_basicFooter__["a" /* default */]},IconFooter:{screen:__WEBPACK_IMPORTED_MODULE_15__components_footer_iconFooter__["a" /* default */]},IconText:{screen:__WEBPACK_IMPORTED_MODULE_16__components_footer_iconText__["a" /* default */]},BadgeFooter:{screen:__WEBPACK_IMPORTED_MODULE_17__components_footer_badgeFooter__["a" /* default */]},Default:{screen:__WEBPACK_IMPORTED_MODULE_18__components_button_default__["a" /* default */]},Outline:{screen:__WEBPACK_IMPORTED_MODULE_19__components_button_outline__["a" /* default */]},Rounded:{screen:__WEBPACK_IMPORTED_MODULE_20__components_button_rounded__["a" /* default */]},Block:{screen:__WEBPACK_IMPORTED_MODULE_21__components_button_block__["a" /* default */]},Full:{screen:__WEBPACK_IMPORTED_MODULE_22__components_button_full__["a" /* default */]},Custom:{screen:__WEBPACK_IMPORTED_MODULE_23__components_button_custom__["a" /* default */]},Transparent:{screen:__WEBPACK_IMPORTED_MODULE_24__components_button_transparent__["a" /* default */]},IconBtn:{screen:__WEBPACK_IMPORTED_MODULE_25__components_button_iconBtn__["a" /* default */]},Disabled:{screen:__WEBPACK_IMPORTED_MODULE_26__components_button_disabled__["a" /* default */]},BasicCard:{screen:__WEBPACK_IMPORTED_MODULE_27__components_card_basic__["a" /* default */]},NHCardImage:{screen:__WEBPACK_IMPORTED_MODULE_28__components_card_card_image__["a" /* default */]},NHCardShowcase:{screen:__WEBPACK_IMPORTED_MODULE_29__components_card_card_showcase__["a" /* default */]},NHCardList:{screen:__WEBPACK_IMPORTED_MODULE_30__components_card_card_list__["a" /* default */]},NHCardHeaderAndFooter:{screen:__WEBPACK_IMPORTED_MODULE_31__components_card_card_header_and_footer__["a" /* default */]},SimpleDeck:{screen:__WEBPACK_IMPORTED_MODULE_74__components_deckswiper_simple__["a" /* default */]},AdvancedDeck:{screen:__WEBPACK_IMPORTED_MODULE_75__components_deckswiper_advanced__["a" /* default */]},BasicFab:{screen:__WEBPACK_IMPORTED_MODULE_32__components_fab_basic__["a" /* default */]},MultipleFab:{screen:__WEBPACK_IMPORTED_MODULE_33__components_fab_multiple__["a" /* default */]},FixedLabel:{screen:__WEBPACK_IMPORTED_MODULE_34__components_form_fixedLabel__["a" /* default */]},InlineLabel:{screen:__WEBPACK_IMPORTED_MODULE_35__components_form_inlineLabel__["a" /* default */]},FloatingLabel:{screen:__WEBPACK_IMPORTED_MODULE_36__components_form_floatingLabel__["a" /* default */]},PlaceholderLabel:{screen:__WEBPACK_IMPORTED_MODULE_37__components_form_placeholder__["a" /* default */]},StackedLabel:{screen:__WEBPACK_IMPORTED_MODULE_38__components_form_stacked__["a" /* default */]},RegularInput:{screen:__WEBPACK_IMPORTED_MODULE_39__components_inputgroup_regular__["a" /* default */]},UnderlineInput:{screen:__WEBPACK_IMPORTED_MODULE_40__components_inputgroup_underline__["a" /* default */]},RoundedInput:{screen:__WEBPACK_IMPORTED_MODULE_41__components_inputgroup_rounded__["a" /* default */]},IconInput:{screen:__WEBPACK_IMPORTED_MODULE_42__components_inputgroup_iconInput__["a" /* default */]},SuccessInput:{screen:__WEBPACK_IMPORTED_MODULE_43__components_inputgroup_success__["a" /* default */]},ErrorInput:{screen:__WEBPACK_IMPORTED_MODULE_44__components_inputgroup_error__["a" /* default */]},DisabledInput:{screen:__WEBPACK_IMPORTED_MODULE_45__components_inputgroup_disabledInput__["a" /* default */]},RowNB:{screen:__WEBPACK_IMPORTED_MODULE_46__components_layout_row__["a" /* default */]},ColumnNB:{screen:__WEBPACK_IMPORTED_MODULE_47__components_layout_column__["a" /* default */]},NestedGrid:{screen:__WEBPACK_IMPORTED_MODULE_48__components_layout_nested__["a" /* default */]},CustomRow:{screen:__WEBPACK_IMPORTED_MODULE_49__components_layout_customRow__["a" /* default */]},CustomCol:{screen:__WEBPACK_IMPORTED_MODULE_50__components_layout_customCol__["a" /* default */]},NHBasicList:{screen:__WEBPACK_IMPORTED_MODULE_53__components_list_basic_list__["a" /* default */]},NHListDivider:{screen:__WEBPACK_IMPORTED_MODULE_54__components_list_list_divider__["a" /* default */]},NHListSeparator:{screen:__WEBPACK_IMPORTED_MODULE_55__components_list_list_separator__["a" /* default */]},NHListHeader:{screen:__WEBPACK_IMPORTED_MODULE_56__components_list_list_headers__["a" /* default */]},NHListIcon:{screen:__WEBPACK_IMPORTED_MODULE_57__components_list_list_icon__["a" /* default */]},NHListAvatar:{screen:__WEBPACK_IMPORTED_MODULE_58__components_list_list_avatar__["a" /* default */]},NHListThumbnail:{screen:__WEBPACK_IMPORTED_MODULE_59__components_list_list_thumbnail__["a" /* default */]},BasicListSwipe:{screen:__WEBPACK_IMPORTED_MODULE_51__components_listSwipe_basic_list_swipe__["a" /* default */]},MultiListSwipe:{screen:__WEBPACK_IMPORTED_MODULE_52__components_listSwipe_multi_list_swipe__["a" /* default */]},RegularPicker:{screen:__WEBPACK_IMPORTED_MODULE_60__components_picker_regularPicker__["a" /* default */]},PlaceholderPicker:{screen:__WEBPACK_IMPORTED_MODULE_61__components_picker_placeholderPicker__["a" /* default */]},PlaceholderPickerNote:{screen:__WEBPACK_IMPORTED_MODULE_62__components_picker_placeholderPickernote__["a" /* default */]},BackButtonPicker:{screen:__WEBPACK_IMPORTED_MODULE_63__components_picker_backButtonPicker__["a" /* default */]},HeaderPicker:{screen:__WEBPACK_IMPORTED_MODULE_64__components_picker_headerPicker__["a" /* default */]},HeaderStylePicker:{screen:__WEBPACK_IMPORTED_MODULE_65__components_picker_headerStylePicker__["a" /* default */]},CustomHeaderPicker:{screen:__WEBPACK_IMPORTED_MODULE_66__components_picker_customHeaderPicker__["a" /* default */]},BasicTab:{screen:__WEBPACK_IMPORTED_MODULE_67__components_tab_basicTab__["a" /* default */]},ConfigTab:{screen:__WEBPACK_IMPORTED_MODULE_68__components_tab_configTab__["a" /* default */]},ScrollableTab:{screen:__WEBPACK_IMPORTED_MODULE_69__components_tab_scrollableTab__["a" /* default */]},BasicSegment:{screen:__WEBPACK_IMPORTED_MODULE_70__components_segment_SegmentHeader__["a" /* default */]},AdvSegment:{screen:__WEBPACK_IMPORTED_MODULE_73__components_segment_segmentTab__["a" /* default */]},RegularActionSheet:{screen:__WEBPACK_IMPORTED_MODULE_71__components_actionsheet_regular__["a" /* default */]},IconActionSheet:{screen:__WEBPACK_IMPORTED_MODULE_72__components_actionsheet_icon__["a" /* default */]}},{initialRouteName:"Drawer",headerMode:"none"});/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Root"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AppNavigator,null));});

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);var _hoistNonReactStatics=__webpack_require__(399);var _hoistNonReactStatics2=_interopRequireDefault(_hoistNonReactStatics);var _lodash=__webpack_require__(17);var _=_interopRequireWildcard(_lodash);var _normalizeStyle=__webpack_require__(104);var _normalizeStyle2=_interopRequireDefault(_normalizeStyle);var _reactNative=__webpack_require__(1);var _Theme=__webpack_require__(105);var _Theme2=_interopRequireDefault(_Theme);var _resolveComponentStyle=__webpack_require__(403);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var themeCache={};function throwConnectStyleError(errorMessage,componentDisplayName){throw Error(errorMessage+' - when connecting '+componentDisplayName+' component to style.');}function getTheme(context){return context.theme||_Theme2.default.getDefaultTheme();}function isStyleVariant(propertyName){return /^\./.test(propertyName);}function isChildStyle(propertyName){return /(^[^\.].*\.)|^\*$/.test(propertyName);}function getConcreteStyle(style){return _.pickBy(style,function(value,key){return!isStyleVariant(key)&&!isChildStyle(key);});}exports.default=function(componentStyleName){var componentStyle=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var mapPropsToStyleNames=arguments[2];var options=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};function getComponentDisplayName(WrappedComponent){return WrappedComponent.displayName||WrappedComponent.name||"Component";}return function wrapWithStyledComponent(WrappedComponent){var componentDisplayName=getComponentDisplayName(WrappedComponent);if(!_.isPlainObject(componentStyle)){throwConnectStyleError("Component style must be plain object",componentDisplayName);}if(!_.isString(componentStyleName)){throwConnectStyleError("Component Style Name must be string",componentDisplayName);}var StyledComponent=function(_React$Component){_inherits(StyledComponent,_React$Component);function StyledComponent(props,context){_classCallCheck(this,StyledComponent);var _this=_possibleConstructorReturn(this,(StyledComponent.__proto__||Object.getPrototypeOf(StyledComponent)).call(this,props,context));var styleNames=_this.getStyleNames(props);var style=props.style;var finalStyle=_this.getFinalStyle(props,context,style,styleNames);_this.setWrappedInstance=_this.setWrappedInstance.bind(_this);_this.resolveConnectedComponentStyle=_this.resolveConnectedComponentStyle.bind(_this);_this.state={style:finalStyle,addedProps:_this.resolveAddedProps(),styleNames:styleNames};return _this;}_createClass(StyledComponent,[{key:'getFinalStyle',value:function getFinalStyle(props,context,style,styleNames){var resolvedStyle={};if(context.parentPath){resolvedStyle=this.getOrSetStylesInCache(context,props,styleNames,[].concat(_toConsumableArray(context.parentPath),[componentStyleName],_toConsumableArray(styleNames)));}else{resolvedStyle=this.resolveStyle(context,props,styleNames);themeCache[componentStyleName]=resolvedStyle;}var concreteStyle=getConcreteStyle(_.merge({},resolvedStyle));if(_.isArray(style)){return[concreteStyle].concat(_toConsumableArray(style));}if(typeof style=="number"||typeof style=="object"){return[concreteStyle,style];}return concreteStyle;}},{key:'getStyleNames',value:function getStyleNames(props){var styleNamesArr=_.map(props,function(value,key){if(typeof value!=="object"&&value===true){return"."+key;}else{return false;}});_.remove(styleNamesArr,function(value,index){return value===false;});return styleNamesArr;}},{key:'getParentPath',value:function getParentPath(){if(!this.context.parentPath){return[componentStyleName];}else{return[].concat(_toConsumableArray(this.context.parentPath),[componentStyleName],_toConsumableArray(this.getStyleNames(this.props)));}}},{key:'getChildContext',value:function getChildContext(){return{parentPath:this.getParentPath()};}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextContext){var styleNames=this.getStyleNames(nextProps);var style=nextProps.style;if(this.shouldRebuildStyle(nextProps,nextContext,styleNames)){var finalStyle=this.getFinalStyle(nextProps,nextContext,style,styleNames);this.setState({style:finalStyle,styleNames:styleNames});}}},{key:'setNativeProps',value:function setNativeProps(nativeProps){if(this.wrappedInstance.setNativeProps){this.wrappedInstance.setNativeProps(nativeProps);}}},{key:'setWrappedInstance',value:function setWrappedInstance(component){if(component&&component._root){this._root=component._root;}else{this._root=component;}this.wrappedInstance=this._root;}},{key:'hasStyleNameChanged',value:function hasStyleNameChanged(nextProps,styleNames){return mapPropsToStyleNames&&this.props!==nextProps&&!_.isEqual(this.state.styleNames,styleNames);}},{key:'shouldRebuildStyle',value:function shouldRebuildStyle(nextProps,nextContext,styleNames){return nextProps.style!==this.props.style||nextProps.styleName!==this.props.styleName||nextContext.theme!==this.context.theme||!_.isEqual(nextContext.parentPath,this.context.parentPath)||this.hasStyleNameChanged(nextProps,styleNames);}},{key:'resolveStyleNames',value:function resolveStyleNames(props){var styleName=props.styleName;var styleNames=styleName?styleName.split(/\s/g):[];if(!mapPropsToStyleNames){return styleNames;}return _.uniq(mapPropsToStyleNames(styleNames,props));}},{key:'resolveAddedProps',value:function resolveAddedProps(){var addedProps={};if(options.withRef){addedProps.ref="wrappedInstance";}return addedProps;}},{key:'getOrSetStylesInCache',value:function getOrSetStylesInCache(context,props,styleNames,path){if(themeCache&&themeCache[path.join(">")]){return themeCache[path.join(">")];}else{resolvedStyle=this.resolveStyle(context,props,styleNames);if(Object.keys(themeCache).length<10000){themeCache[path.join(">")]=resolvedStyle;}return resolvedStyle;}}},{key:'resolveStyle',value:function resolveStyle(context,props,styleNames){var parentStyle={};var theme=getTheme(context);var themeStyle=theme.createComponentStyle(componentStyleName,componentStyle);if(context.parentPath){parentStyle=themeCache[context.parentPath.join(">")];}else{parentStyle=(0,_resolveComponentStyle.resolveComponentStyle)(componentStyleName,styleNames,themeStyle,parentStyle);}return(0,_resolveComponentStyle.resolveComponentStyle)(componentStyleName,styleNames,themeStyle,parentStyle);}},{key:'resolveConnectedComponentStyle',value:function resolveConnectedComponentStyle(props){var styleNames=this.resolveStyleNames(props);return this.resolveStyle(this.context,props,styleNames).componentStyle;}},{key:'render',value:function render(){var _state=this.state,addedProps=_state.addedProps,style=_state.style;return _react2.default.createElement(WrappedComponent,_extends({},this.props,addedProps,{style:style,ref:this.setWrappedInstance}));}}]);return StyledComponent;}(_react2.default.Component);StyledComponent.contextTypes={theme:_Theme.ThemeShape,parentPath:_propTypes2.default.array};StyledComponent.childContextTypes={parentPath:_propTypes2.default.array};StyledComponent.propTypes={style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array]),styleName:_propTypes2.default.string,virtual:_propTypes2.default.bool};StyledComponent.defaultProps={virtual:options.virtual};StyledComponent.displayName='Styled('+componentDisplayName+')';StyledComponent.WrappedComponent=WrappedComponent;return(0,_hoistNonReactStatics2.default)(StyledComponent,WrappedComponent);};};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var REACT_STATICS={childContextTypes:true,contextTypes:true,defaultProps:true,displayName:true,getDefaultProps:true,mixins:true,propTypes:true,type:true};var KNOWN_STATICS={name:true,length:true,prototype:true,caller:true,arguments:true,arity:true};var isGetOwnPropertySymbolsAvailable=typeof Object.getOwnPropertySymbols==='function';module.exports=function hoistNonReactStatics(targetComponent,sourceComponent,customStatics){if(typeof sourceComponent!=='string'){var keys=Object.getOwnPropertyNames(sourceComponent);if(isGetOwnPropertySymbolsAvailable){keys=keys.concat(Object.getOwnPropertySymbols(sourceComponent));}for(var i=0;i<keys.length;++i){if(!REACT_STATICS[keys[i]]&&!KNOWN_STATICS[keys[i]]&&(!customStatics||!customStatics[keys[i]])){try{targetComponent[keys[i]]=sourceComponent[keys[i]];}catch(error){}}}}return targetComponent;};

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _ShorthandsNormalizerFactory=__webpack_require__(401);var _ShorthandsNormalizerFactory2=_interopRequireDefault(_ShorthandsNormalizerFactory);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var StyleNormalizer=function(){function StyleNormalizer(){_classCallCheck(this,StyleNormalizer);this.normalizers={};this.createNormalizers('margin',[_ShorthandsNormalizerFactory.HORIZONTAL,_ShorthandsNormalizerFactory.VERTICAL,_ShorthandsNormalizerFactory.SIDES]);this.createNormalizers('padding',[_ShorthandsNormalizerFactory.HORIZONTAL,_ShorthandsNormalizerFactory.VERTICAL,_ShorthandsNormalizerFactory.SIDES]);this.createNormalizers('border',[_ShorthandsNormalizerFactory.SIDES],'Width');}_createClass(StyleNormalizer,[{key:'createNormalizers',value:function createNormalizers(prop,shorthands){var _this=this;var suffix=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';shorthands.forEach(function(shorthand){var propName=prop+shorthand.type+suffix;if(_this.normalizerExists(propName)){throw Error('Normalizer for \''+propName+'\' shorthand already exists');}_this.normalizers[propName]=_ShorthandsNormalizerFactory2.default.createNormalizer(prop,shorthand,suffix);});}},{key:'normalizerExists',value:function normalizerExists(normalizerName){return!!this.normalizers[normalizerName];}},{key:'canNormalize',value:function canNormalize(prop){return this.normalizerExists(prop);}},{key:'normalize',value:function normalize(prop,val){return this.normalizers[prop](val);}}]);return StyleNormalizer;}();exports.default=StyleNormalizer;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.BOTTOM_LEFT=exports.TOP_LEFT=exports.BOTTOM_RIGHT=exports.TOP_RIGHT=exports.BOTTOM=exports.TOP=exports.RIGHT=exports.LEFT=exports.VERTICAL=exports.HORIZONTAL=exports.CORNERS=exports.SIDES=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _lodash=__webpack_require__(17);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var createShorthand=function createShorthand(name,type){return{name:name,type:_lodash2.default.isUndefined(type)?name:type};};var SIDES=exports.SIDES=createShorthand('Sides','');var CORNERS=exports.CORNERS=createShorthand('Corners','');var HORIZONTAL=exports.HORIZONTAL=createShorthand('Horizontal');var VERTICAL=exports.VERTICAL=createShorthand('Vertical');var LEFT=exports.LEFT='Left';var RIGHT=exports.RIGHT='Right';var TOP=exports.TOP='Top';var BOTTOM=exports.BOTTOM='Bottom';var TOP_RIGHT=exports.TOP_RIGHT='TopRight';var BOTTOM_RIGHT=exports.BOTTOM_RIGHT='BottomRight';var TOP_LEFT=exports.TOP_LEFT='TopLeft';var BOTTOM_LEFT=exports.BOTTOM_LEFT='BottomLeft';var ShorthandsNormalizerFactory=function(){function ShorthandsNormalizerFactory(){var _createNormalizersMap;_classCallCheck(this,ShorthandsNormalizerFactory);this.createNormalizersMap=(_createNormalizersMap={},_defineProperty(_createNormalizersMap,SIDES.name,this.createAllSidesNormalizer),_defineProperty(_createNormalizersMap,CORNERS.name,this.createAllCornersNormalizer),_defineProperty(_createNormalizersMap,HORIZONTAL.name,this.createHorizontalSidesNormalizer),_defineProperty(_createNormalizersMap,VERTICAL.name,this.createVerticalSidesNormalizer),_createNormalizersMap);}_createClass(ShorthandsNormalizerFactory,[{key:'createAllSidesNormalizer',value:function createAllSidesNormalizer(prop,shorthand){var suffix=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';return function(val){var _ref;return _ref={},_defineProperty(_ref,prop+LEFT+suffix,val),_defineProperty(_ref,prop+RIGHT+suffix,val),_defineProperty(_ref,prop+TOP+suffix,val),_defineProperty(_ref,prop+BOTTOM+suffix,val),_ref;};}},{key:'createAllCornersNormalizer',value:function createAllCornersNormalizer(prop,shorthand){var suffix=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';return function(val){var _ref2;return _ref2={},_defineProperty(_ref2,prop+BOTTOM_LEFT+suffix,val),_defineProperty(_ref2,prop+BOTTOM_RIGHT+suffix,val),_defineProperty(_ref2,prop+TOP_LEFT+suffix,val),_defineProperty(_ref2,prop+TOP_RIGHT+suffix,val),_ref2;};}},{key:'createHorizontalSidesNormalizer',value:function createHorizontalSidesNormalizer(prop){return function(val){var _ref3;return _ref3={},_defineProperty(_ref3,prop+LEFT,val),_defineProperty(_ref3,prop+RIGHT,val),_ref3;};}},{key:'createVerticalSidesNormalizer',value:function createVerticalSidesNormalizer(prop){return function(val){var _ref4;return _ref4={},_defineProperty(_ref4,prop+TOP,val),_defineProperty(_ref4,prop+BOTTOM,val),_ref4;};}},{key:'getNormalizerCreator',value:function getNormalizerCreator(shorthand){return this.createNormalizersMap[shorthand.name];}},{key:'createNormalizer',value:function createNormalizer(prop,shorthand,suffix){var normalizerCreator=this.getNormalizerCreator(shorthand);return normalizerCreator(prop,shorthand,suffix);}}]);return ShorthandsNormalizerFactory;}();exports.default=new ShorthandsNormalizerFactory();

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.default=mergeComponentAndThemeStyles;var _lodash=__webpack_require__(17);var _=_interopRequireWildcard(_lodash);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function mergeComponentAndThemeStyles(componentStyle,themeComponentStyle,themeStyle){var componentThemedStyle=_.merge({},componentStyle,themeComponentStyle);var intersectedRootThemeStyle=_.pick(themeStyle,_.keys(componentThemedStyle));return _.merge({},intersectedRootThemeStyle,componentThemedStyle);}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.resolveComponentStyle=resolveComponentStyle;var _lodash=__webpack_require__(17);var _lodash2=_interopRequireDefault(_lodash);var _customMerge=__webpack_require__(404);var _customMerge2=_interopRequireDefault(_customMerge);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function isStyleVariant(propertyName){return /^\./.test(propertyName);}function isChildStyle(propertyName){return /(^[^\.].*\.)|^\*$/.test(propertyName);}function splitStyle(style){return _lodash2.default.reduce(style,function(result,value,key){var styleSection=result.componentStyle;if(isStyleVariant(key)){styleSection=result.styleVariants;}else if(isChildStyle(key)){styleSection=result.childrenStyle;}styleSection[key]=value;return result;},{componentStyle:{},styleVariants:{},childrenStyle:{}});}function resolveComponentStyle(componentName){var styleNames=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var themeStyle=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var parentStyle=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var themeCache=arguments[4];var mergedStyle=(0,_customMerge2.default)(themeStyle,parentStyle[componentName]);styleNames.forEach(function(sn,index){mergedStyle=(0,_customMerge2.default)(mergedStyle,themeStyle[""+sn]);});styleNames.forEach(function(sn,index){mergedStyle=(0,_customMerge2.default)(mergedStyle,parentStyle[""+componentName+sn]);});var resolvedStyle=(0,_customMerge2.default)(mergedStyle,parentStyle[componentName]);styleNames.forEach(function(sn,index){resolvedStyle=(0,_customMerge2.default)(resolvedStyle,mergedStyle[""+sn]);});styleNames.forEach(function(sn,index){resolvedStyle=(0,_customMerge2.default)(resolvedStyle,parentStyle[""+componentName+sn]);});return resolvedStyle;}

/***/ }),
/* 404 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});exports.default=customMerge;function customMerge(obj1,obj2){var objToReturn={};var property1=void 0,property2=void 0;if(!obj1){return obj2;}else if(!obj2){return obj1;}for(property1 in obj1){for(property2 in obj2){if(property1===property2){if(typeof obj1[property1]!=="object"||typeof obj2[property1]!=="object"||!obj2[property1]||!obj1[property1]){objToReturn[property1]=obj2[property1];}else{objToReturn[property1]=customMerge(obj1[property1],obj2[property1]);}}else{if(objToReturn[property1]===undefined)objToReturn[property1]=obj1[property1];if(objToReturn[property2]===undefined)objToReturn[property2]=obj2[property2];}}}return objToReturn;}

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);var _Theme=__webpack_require__(105);var _Theme2=_interopRequireDefault(_Theme);var _normalizeStyle=__webpack_require__(104);var _normalizeStyle2=_interopRequireDefault(_normalizeStyle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StyleProvider=function(_React$Component){_inherits(StyleProvider,_React$Component);function StyleProvider(props,context){_classCallCheck(this,StyleProvider);var _this=_possibleConstructorReturn(this,(StyleProvider.__proto__||Object.getPrototypeOf(StyleProvider)).call(this,props,context));_this.state={theme:_this.createTheme(props)};return _this;}_createClass(StyleProvider,[{key:'getChildContext',value:function getChildContext(){return{theme:this.state.theme};}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.style!==this.props.style){this.setState({theme:this.createTheme(nextProps)});}}},{key:'createTheme',value:function createTheme(props){return new _Theme2.default(props.style);}},{key:'render',value:function render(){var children=this.props.children;return _react.Children.only(children);}}]);return StyleProvider;}(_react2.default.Component);StyleProvider.propTypes={children:_propTypes2.default.element.isRequired,style:_propTypes2.default.object};StyleProvider.defaultProps={style:{}};StyleProvider.childContextTypes={theme:_Theme.ThemeShape.isRequired};exports.default=StyleProvider;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.createVariations=createVariations;exports.createSharedStyle=createSharedStyle;var _lodash=__webpack_require__(17);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function capitalizeFirstLetter(value){return value.charAt(0).toUpperCase()+value.slice(1);}function createVariations(baseName,nameSuffixes,key,value){return _lodash2.default.reduce(nameSuffixes,function(result,variant){var variantName=variant?baseName+'-'+variant:baseName;var keyName=variant?''+key+capitalizeFirstLetter(variant):key;result[variantName]=_defineProperty({},keyName,value);return result;},{});}function createSharedStyle(componentNames){var sharedStyle=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var customStyles=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};return _lodash2.default.reduce(componentNames,function(result,componentName){result[componentName]=_extends({},sharedStyle,customStyles[componentName]);return result;},{});}

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);var _computeProps=__webpack_require__(106);var _computeProps2=_interopRequireDefault(_computeProps);var _lodash=__webpack_require__(17);var _lodash2=_interopRequireDefault(_lodash);var _Col=__webpack_require__(181);var _Col2=_interopRequireDefault(_Col);var _Row=__webpack_require__(179);var _Row2=_interopRequireDefault(_Row);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GridNB=function(_Component){_inherits(GridNB,_Component);function GridNB(){_classCallCheck(this,GridNB);return _possibleConstructorReturn(this,(GridNB.__proto__||Object.getPrototypeOf(GridNB)).apply(this,arguments));}_createClass(GridNB,[{key:'prepareRootProps',value:function prepareRootProps(){var type={flex:1,flexDirection:this.ifRow()?'column':'row'};var defaultProps={style:type};return(0,_computeProps2.default)(this.props,defaultProps);}},{key:'ifRow',value:function ifRow(){var row=false;_react2.default.Children.forEach(this.props.children,function(child){if(child&&child.type==_Row2.default)row=true;});return row;}},{key:'setNativeProps',value:function setNativeProps(nativeProps){this._root.setNativeProps(nativeProps);}},{key:'render',value:function render(){var _this2=this;if(this.props.onPress){return _react2.default.createElement(_reactNative.TouchableOpacity,{onPress:this.props.onPress},_react2.default.createElement(_reactNative.View,_extends({ref:function ref(component){return _this2._root=component;}},this.props,this.prepareRootProps()),this.props.children));}else{return _react2.default.createElement(_reactNative.View,_extends({ref:function ref(component){return _this2._root=component;}},this.props,this.prepareRootProps()),this.props.children);}}}]);return GridNB;}(_react.Component);exports.default=GridNB;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.default=


setDefaultThemeStyle;var _nativeBaseShoutemTheme=__webpack_require__(5);var _components=__webpack_require__(182);var _components2=_interopRequireDefault(_components);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function setDefaultThemeStyle(){
var theme=(0,_components2.default)();
_nativeBaseShoutemTheme.Theme.setDefaultThemeStyle(theme);
}
//# sourceMappingURL=init.js.map

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var bodyTheme={
flex:1,
alignItems:'center',
alignSelf:'center'};


return bodyTheme;
};
//# sourceMappingURL=Body.js.map

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var colorString = __webpack_require__(411);
var convert = __webpack_require__(414);

var _slice = [].slice;

var skippedModels = [
	// to be honest, I don't really feel like keyword belongs in color convert, but eh.
	'keyword',

	// gray conflicts with some method names, and has its own method defined.
	'gray',

	// shouldn't really be in color-convert either...
	'hex'
];

var hashedModelKeys = {};
Object.keys(convert).forEach(function (model) {
	hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
});

var limiters = {};

function Color(obj, model) {
	if (!(this instanceof Color)) {
		return new Color(obj, model);
	}

	if (model && model in skippedModels) {
		model = null;
	}

	if (model && !(model in convert)) {
		throw new Error('Unknown model: ' + model);
	}

	var i;
	var channels;

	if (!obj) {
		this.model = 'rgb';
		this.color = [0, 0, 0];
		this.valpha = 1;
	} else if (obj instanceof Color) {
		this.model = obj.model;
		this.color = obj.color.slice();
		this.valpha = obj.valpha;
	} else if (typeof obj === 'string') {
		var result = colorString.get(obj);
		if (result === null) {
			throw new Error('Unable to parse color from string: ' + obj);
		}

		this.model = result.model;
		channels = convert[this.model].channels;
		this.color = result.value.slice(0, channels);
		this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
	} else if (obj.length) {
		this.model = model || 'rgb';
		channels = convert[this.model].channels;
		var newArr = _slice.call(obj, 0, channels);
		this.color = zeroArray(newArr, channels);
		this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
	} else if (typeof obj === 'number') {
		// this is always RGB - can be converted later on.
		obj &= 0xFFFFFF;
		this.model = 'rgb';
		this.color = [
			(obj >> 16) & 0xFF,
			(obj >> 8) & 0xFF,
			obj & 0xFF
		];
		this.valpha = 1;
	} else {
		this.valpha = 1;

		var keys = Object.keys(obj);
		if ('alpha' in obj) {
			keys.splice(keys.indexOf('alpha'), 1);
			this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
		}

		var hashedKeys = keys.sort().join('');
		if (!(hashedKeys in hashedModelKeys)) {
			throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
		}

		this.model = hashedModelKeys[hashedKeys];

		var labels = convert[this.model].labels;
		var color = [];
		for (i = 0; i < labels.length; i++) {
			color.push(obj[labels[i]]);
		}

		this.color = zeroArray(color);
	}

	// perform limitations (clamping, etc.)
	if (limiters[this.model]) {
		channels = convert[this.model].channels;
		for (i = 0; i < channels; i++) {
			var limit = limiters[this.model][i];
			if (limit) {
				this.color[i] = limit(this.color[i]);
			}
		}
	}

	this.valpha = Math.max(0, Math.min(1, this.valpha));

	if (Object.freeze) {
		Object.freeze(this);
	}
}

Color.prototype = {
	toString: function () {
		return this.string();
	},

	toJSON: function () {
		return this[this.model]();
	},

	string: function (places) {
		var self = this.model in colorString.to ? this : this.rgb();
		self = self.round(typeof places === 'number' ? places : 1);
		var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
		return colorString.to[self.model](args);
	},

	percentString: function (places) {
		var self = this.rgb().round(typeof places === 'number' ? places : 1);
		var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
		return colorString.to.rgb.percent(args);
	},

	array: function () {
		return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
	},

	object: function () {
		var result = {};
		var channels = convert[this.model].channels;
		var labels = convert[this.model].labels;

		for (var i = 0; i < channels; i++) {
			result[labels[i]] = this.color[i];
		}

		if (this.valpha !== 1) {
			result.alpha = this.valpha;
		}

		return result;
	},

	unitArray: function () {
		var rgb = this.rgb().color;
		rgb[0] /= 255;
		rgb[1] /= 255;
		rgb[2] /= 255;

		if (this.valpha !== 1) {
			rgb.push(this.valpha);
		}

		return rgb;
	},

	unitObject: function () {
		var rgb = this.rgb().object();
		rgb.r /= 255;
		rgb.g /= 255;
		rgb.b /= 255;

		if (this.valpha !== 1) {
			rgb.alpha = this.valpha;
		}

		return rgb;
	},

	round: function (places) {
		places = Math.max(places || 0, 0);
		return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
	},

	alpha: function (val) {
		if (arguments.length) {
			return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
		}

		return this.valpha;
	},

	// rgb
	red: getset('rgb', 0, maxfn(255)),
	green: getset('rgb', 1, maxfn(255)),
	blue: getset('rgb', 2, maxfn(255)),

	hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) { return ((val % 360) + 360) % 360; }), // eslint-disable-line brace-style

	saturationl: getset('hsl', 1, maxfn(100)),
	lightness: getset('hsl', 2, maxfn(100)),

	saturationv: getset('hsv', 1, maxfn(100)),
	value: getset('hsv', 2, maxfn(100)),

	chroma: getset('hcg', 1, maxfn(100)),
	gray: getset('hcg', 2, maxfn(100)),

	white: getset('hwb', 1, maxfn(100)),
	wblack: getset('hwb', 2, maxfn(100)),

	cyan: getset('cmyk', 0, maxfn(100)),
	magenta: getset('cmyk', 1, maxfn(100)),
	yellow: getset('cmyk', 2, maxfn(100)),
	black: getset('cmyk', 3, maxfn(100)),

	x: getset('xyz', 0, maxfn(100)),
	y: getset('xyz', 1, maxfn(100)),
	z: getset('xyz', 2, maxfn(100)),

	l: getset('lab', 0, maxfn(100)),
	a: getset('lab', 1),
	b: getset('lab', 2),

	keyword: function (val) {
		if (arguments.length) {
			return new Color(val);
		}

		return convert[this.model].keyword(this.color);
	},

	hex: function (val) {
		if (arguments.length) {
			return new Color(val);
		}

		return colorString.to.hex(this.rgb().round().color);
	},

	rgbNumber: function () {
		var rgb = this.rgb().color;
		return ((rgb[0] & 0xFF) << 16) | ((rgb[1] & 0xFF) << 8) | (rgb[2] & 0xFF);
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.rgb().color;

		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}

		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();

		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}

		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.rgb().color;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = this.rgb();
		for (var i = 0; i < 3; i++) {
			rgb.color[i] = 255 - rgb.color[i];
		}
		return rgb;
	},

	lighten: function (ratio) {
		var hsl = this.hsl();
		hsl.color[2] += hsl.color[2] * ratio;
		return hsl;
	},

	darken: function (ratio) {
		var hsl = this.hsl();
		hsl.color[2] -= hsl.color[2] * ratio;
		return hsl;
	},

	saturate: function (ratio) {
		var hsl = this.hsl();
		hsl.color[1] += hsl.color[1] * ratio;
		return hsl;
	},

	desaturate: function (ratio) {
		var hsl = this.hsl();
		hsl.color[1] -= hsl.color[1] * ratio;
		return hsl;
	},

	whiten: function (ratio) {
		var hwb = this.hwb();
		hwb.color[1] += hwb.color[1] * ratio;
		return hwb;
	},

	blacken: function (ratio) {
		var hwb = this.hwb();
		hwb.color[2] += hwb.color[2] * ratio;
		return hwb;
	},

	grayscale: function () {
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var rgb = this.rgb().color;
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		return Color.rgb(val, val, val);
	},

	fade: function (ratio) {
		return this.alpha(this.valpha - (this.valpha * ratio));
	},

	opaquer: function (ratio) {
		return this.alpha(this.valpha + (this.valpha * ratio));
	},

	rotate: function (degrees) {
		var hsl = this.hsl();
		var hue = hsl.color[0];
		hue = (hue + degrees) % 360;
		hue = hue < 0 ? 360 + hue : hue;
		hsl.color[0] = hue;
		return hsl;
	},

	mix: function (mixinColor, weight) {
		// ported from sass implementation in C
		// https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		var color1 = this.rgb();
		var color2 = mixinColor.rgb();
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return Color.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue(),
				color1.alpha() * p + color2.alpha() * (1 - p));
	}
};

// model conversion methods and static constructors
Object.keys(convert).forEach(function (model) {
	if (skippedModels.indexOf(model) !== -1) {
		return;
	}

	var channels = convert[model].channels;

	// conversion methods
	Color.prototype[model] = function () {
		if (this.model === model) {
			return new Color(this);
		}

		if (arguments.length) {
			return new Color(arguments, model);
		}

		var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
		return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
	};

	// 'static' construction methods
	Color[model] = function (color) {
		if (typeof color === 'number') {
			color = zeroArray(_slice.call(arguments), channels);
		}
		return new Color(color, model);
	};
});

function roundTo(num, places) {
	return Number(num.toFixed(places));
}

function roundToPlace(places) {
	return function (num) {
		return roundTo(num, places);
	};
}

function getset(model, channel, modifier) {
	model = Array.isArray(model) ? model : [model];

	model.forEach(function (m) {
		(limiters[m] || (limiters[m] = []))[channel] = modifier;
	});

	model = model[0];

	return function (val) {
		var result;

		if (arguments.length) {
			if (modifier) {
				val = modifier(val);
			}

			result = this[model]();
			result.color[channel] = val;
			return result;
		}

		result = this[model]().color[channel];
		if (modifier) {
			result = modifier(result);
		}

		return result;
	};
}

function maxfn(max) {
	return function (v) {
		return Math.max(0, Math.min(max, v));
	};
}

function assertArray(val) {
	return Array.isArray(val) ? val : [val];
}

function zeroArray(arr, length) {
	for (var i = 0; i < length; i++) {
		if (typeof arr[i] !== 'number') {
			arr[i] = 0;
		}
	}

	return arr;
}

module.exports = Color;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var colorNames = __webpack_require__(183);
var swizzle = __webpack_require__(412);

var reverseNames = {};

// create a list of reverse color names
for (var name in colorNames) {
	if (colorNames.hasOwnProperty(name)) {
		reverseNames[colorNames[name]] = name;
	}
}

var cs = module.exports = {
	to: {}
};

cs.get = function (string) {
	var prefix = string.substring(0, 3).toLowerCase();
	var val;
	var model;
	switch (prefix) {
		case 'hsl':
			val = cs.get.hsl(string);
			model = 'hsl';
			break;
		case 'hwb':
			val = cs.get.hwb(string);
			model = 'hwb';
			break;
		default:
			val = cs.get.rgb(string);
			model = 'rgb';
			break;
	}

	if (!val) {
		return null;
	}

	return {model: model, value: val};
};

cs.get.rgb = function (string) {
	if (!string) {
		return null;
	}

	var abbr = /^#([a-f0-9]{3,4})$/i;
	var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
	var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
	var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
	var keyword = /(\D+)/;

	var rgb = [0, 0, 0, 1];
	var match;
	var i;
	var hexAlpha;

	if (match = string.match(hex)) {
		hexAlpha = match[2];
		match = match[1];

		for (i = 0; i < 3; i++) {
			// https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
			var i2 = i * 2;
			rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
		}

		if (hexAlpha) {
			rgb[3] = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
		}
	} else if (match = string.match(abbr)) {
		match = match[1];
		hexAlpha = match[3];

		for (i = 0; i < 3; i++) {
			rgb[i] = parseInt(match[i] + match[i], 16);
		}

		if (hexAlpha) {
			rgb[3] = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
		}
	} else if (match = string.match(rgba)) {
		for (i = 0; i < 3; i++) {
			rgb[i] = parseInt(match[i + 1], 0);
		}

		if (match[4]) {
			rgb[3] = parseFloat(match[4]);
		}
	} else if (match = string.match(per)) {
		for (i = 0; i < 3; i++) {
			rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
		}

		if (match[4]) {
			rgb[3] = parseFloat(match[4]);
		}
	} else if (match = string.match(keyword)) {
		if (match[1] === 'transparent') {
			return [0, 0, 0, 0];
		}

		rgb = colorNames[match[1]];

		if (!rgb) {
			return null;
		}

		rgb[3] = 1;

		return rgb;
	} else {
		return null;
	}

	for (i = 0; i < 3; i++) {
		rgb[i] = clamp(rgb[i], 0, 255);
	}
	rgb[3] = clamp(rgb[3], 0, 1);

	return rgb;
};

cs.get.hsl = function (string) {
	if (!string) {
		return null;
	}

	var hsl = /^hsla?\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
	var match = string.match(hsl);

	if (match) {
		var alpha = parseFloat(match[4]);
		var h = ((parseFloat(match[1]) % 360) + 360) % 360;
		var s = clamp(parseFloat(match[2]), 0, 100);
		var l = clamp(parseFloat(match[3]), 0, 100);
		var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);

		return [h, s, l, a];
	}

	return null;
};

cs.get.hwb = function (string) {
	if (!string) {
		return null;
	}

	var hwb = /^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
	var match = string.match(hwb);

	if (match) {
		var alpha = parseFloat(match[4]);
		var h = ((parseFloat(match[1]) % 360) + 360) % 360;
		var w = clamp(parseFloat(match[2]), 0, 100);
		var b = clamp(parseFloat(match[3]), 0, 100);
		var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
		return [h, w, b, a];
	}

	return null;
};

cs.to.hex = function () {
	var rgba = swizzle(arguments);

	return (
		'#' +
		hexDouble(rgba[0]) +
		hexDouble(rgba[1]) +
		hexDouble(rgba[2]) +
		(rgba[3] < 1
			? (hexDouble(Math.round(rgba[3] * 255)))
			: '')
	);
};

cs.to.rgb = function () {
	var rgba = swizzle(arguments);

	return rgba.length < 4 || rgba[3] === 1
		? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')'
		: 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};

cs.to.rgb.percent = function () {
	var rgba = swizzle(arguments);

	var r = Math.round(rgba[0] / 255 * 100);
	var g = Math.round(rgba[1] / 255 * 100);
	var b = Math.round(rgba[2] / 255 * 100);

	return rgba.length < 4 || rgba[3] === 1
		? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)'
		: 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};

cs.to.hsl = function () {
	var hsla = swizzle(arguments);
	return hsla.length < 4 || hsla[3] === 1
		? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)'
		: 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
};

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
cs.to.hwb = function () {
	var hwba = swizzle(arguments);

	var a = '';
	if (hwba.length >= 4 && hwba[3] !== 1) {
		a = ', ' + hwba[3];
	}

	return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};

cs.to.keyword = function (rgb) {
	return reverseNames[rgb.slice(0, 3)];
};

// helpers
function clamp(num, min, max) {
	return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
	var str = num.toString(16).toUpperCase();
	return (str.length < 2) ? '0' + str : str;
}


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArrayish = __webpack_require__(413);

var concat = Array.prototype.concat;
var slice = Array.prototype.slice;

var swizzle = module.exports = function swizzle(args) {
	var results = [];

	for (var i = 0, len = args.length; i < len; i++) {
		var arg = args[i];

		if (isArrayish(arg)) {
			// http://jsperf.com/javascript-array-concat-vs-push/98
			results = concat.call(results, slice.call(arg));
		} else {
			results.push(arg);
		}
	}

	return results;
};

swizzle.wrap = function (fn) {
	return function () {
		return fn(swizzle(arguments));
	};
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isArrayish(obj) {
	if (!obj || typeof obj === 'string') {
		return false;
	}

	return obj instanceof Array || Array.isArray(obj) ||
		(obj.length >= 0 && (obj.splice instanceof Function ||
			(Object.getOwnPropertyDescriptor(obj, (obj.length - 1)) && obj.constructor.name !== 'String')));
};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(184);
var route = __webpack_require__(415);

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

module.exports = convert;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(184);

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

// https://jsperf.com/object-keys-vs-for-in-with-closure/3
var models = Object.keys(conversions);

function buildGraph() {
	var graph = {};

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

module.exports = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};



/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var leftTheme={
flex:1,
alignSelf:'center',
alignItems:'flex-start'};


return leftTheme;
};
//# sourceMappingURL=Left.js.map

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var rightTheme={
'NativeBase.Button':{
alignSelf:null},

flex:1,
alignSelf:'center',
alignItems:'flex-end'};


return rightTheme;
};
//# sourceMappingURL=Right.js.map

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _reactNative=__webpack_require__(1);

var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var platformStyle=variables.platformStyle;
var platform=variables.platform;

var headerTheme={
".span":{
height:128,
"NativeBase.Left":{
alignSelf:"flex-start"},

"NativeBase.Body":{
alignSelf:"flex-end",
alignItems:"flex-start",
justifyContent:"center",
paddingBottom:26},

"NativeBase.Right":{
alignSelf:"flex-start"}},


".hasSubtitle":{
"NativeBase.Body":{
"NativeBase.Title":{
fontSize:variables.titleFontSize-2,
fontFamily:variables.titleFontfamily,
textAlign:"center"},

"NativeBase.Subtitle":{
fontSize:variables.subTitleFontSize,
fontFamily:variables.titleFontfamily,
color:variables.subtitleColor,
textAlign:"center"}}},



".noShadow":{
elevation:0,
shadowColor:null,
shadowOffset:null,
shadowRadius:null,
shadowOpacity:null},

".hasTabs":{
elevation:0,
shadowColor:null,
shadowOffset:null,
shadowRadius:null,
shadowOpacity:null,
borderBottomWidth:null},

".hasSegment":{
elevation:0,
shadowColor:null,
shadowOffset:null,
shadowRadius:null,
shadowOpacity:null,
borderBottomWidth:null},

"NativeBase.Button":{
justifyContent:"center",
alignSelf:"center",
alignItems:"center",
".transparent":{
"NativeBase.Text":{
color:variables.toolbarBtnColor,
fontWeight:"600"},

"NativeBase.Icon":{
color:variables.toolbarBtnColor},

"NativeBase.IconNB":{
color:variables.toolbarBtnColor},

paddingHorizontal:variables.buttonPadding},

paddingHorizontal:15},

".searchBar":{
"NativeBase.Item":{
"NativeBase.Icon":{
backgroundColor:"transparent",
color:variables.dropdownLinkColor,
fontSize:variables.toolbarSearchIconSize,
alignItems:"center",
marginTop:2,
paddingRight:10,
paddingLeft:10},

"NativeBase.IconNB":{
backgroundColor:"transparent",
color:null,
alignSelf:"center"},

"NativeBase.Input":{
alignSelf:"center",
lineHeight:24,
height:variables.searchBarHeight},

alignSelf:"center",
alignItems:"center",
justifyContent:"flex-start",
flex:1,
height:variables.searchBarHeight,
borderColor:"transparent",
backgroundColor:variables.toolbarInputColor},

"NativeBase.Button":{
".transparent":{
"NativeBase.Text":{
fontWeight:"500"},

paddingHorizontal:null,
paddingLeft:platform==="ios"?10:null},

paddingHorizontal:platform==="ios"?undefined:null,
width:platform==="ios"?undefined:0,
height:platform==="ios"?undefined:0}},


".rounded":{
"NativeBase.Item":{
borderRadius:platform==="ios"&&platformStyle!=="material"?25:3}},


"NativeBase.Left":{
"NativeBase.Button":{
".hasText":{
marginLeft:-10,
height:30,
"NativeBase.Icon":{
color:variables.toolbarBtnColor,
fontSize:variables.iconHeaderSize,
marginTop:2,
marginRight:5,
marginLeft:2},

"NativeBase.Text":{
color:variables.toolbarBtnColor,
fontSize:17,
marginLeft:2,
lineHeight:21},

"NativeBase.IconNB":{
color:variables.toolbarBtnColor,
fontSize:variables.iconHeaderSize,
marginTop:2,
marginRight:5,
marginLeft:2}},


".transparent":{
marginLeft:-3,
"NativeBase.Icon":{
color:variables.toolbarBtnColor,
fontSize:variables.iconHeaderSize,
marginTop:2,
marginRight:2,
marginLeft:2},

"NativeBase.IconNB":{
color:variables.toolbarBtnColor,
fontSize:variables.iconHeaderSize,
marginTop:2,
marginRight:2,
marginLeft:2},

"NativeBase.Text":{
color:variables.toolbarBtnColor,
fontSize:17,
top:platform==="ios"?undefined:-1.5},

backgroundColor:"transparent",
borderColor:null,
elevation:0,
shadowColor:null,
shadowOffset:null,
shadowRadius:null,
shadowOpacity:null},

"NativeBase.Icon":{
color:variables.toolbarBtnColor},

"NativeBase.IconNB":{
color:variables.toolbarBtnColor},

alignSelf:null,
paddingHorizontal:variables.buttonPadding},

flex:platform==="ios"&&platformStyle!=="material"?1:0.5,
alignSelf:"center",
alignItems:"flex-start"},

"NativeBase.Body":{
flex:1,
alignItems:platform==="ios"&&platformStyle!=="material"?"center":"flex-start",
alignSelf:"center",
"NativeBase.Segment":{
borderWidth:0,
alignSelf:"flex-end",
marginRight:platform==="ios"?-40:-55},

"NativeBase.Button":{
alignSelf:"center",
".transparent":{
backgroundColor:"transparent"},

"NativeBase.Icon":{
color:variables.toolbarBtnColor},

"NativeBase.IconNB":{
color:variables.toolbarBtnColor},

"NativeBase.Text":{
color:variables.inverseTextColor,
backgroundColor:"transparent"}}},



"NativeBase.Right":{
"NativeBase.Button":{
".hasText":{
height:30,
"NativeBase.Icon":{
color:variables.toolbarBtnColor,
fontSize:variables.iconHeaderSize-2,
marginTop:2,
marginRight:2,
marginLeft:5},

"NativeBase.Text":{
color:variables.toolbarBtnColor,
fontSize:17,
lineHeight:21},

"NativeBase.IconNB":{
color:variables.toolbarBtnColor,
fontSize:variables.iconHeaderSize-2,
marginTop:2,
marginRight:2,
marginLeft:5}},


".transparent":{
marginRight:-8,
paddingHorizontal:15,
borderRadius:50,
"NativeBase.Icon":{
color:variables.toolbarBtnColor,
fontSize:
platform==="ios"?variables.iconHeaderSize-6:variables.iconHeaderSize-2,
marginTop:2,
marginLeft:2,
marginRight:2},

"NativeBase.IconNB":{
color:variables.toolbarBtnColor,
fontSize:
platform==="ios"?variables.iconHeaderSize-6:variables.iconHeaderSize-2,
marginTop:2,
marginLeft:2,
marginRight:2},

"NativeBase.Text":{
color:variables.toolbarBtnColor,
fontSize:17,
top:platform==="ios"?undefined:-1.5},

backgroundColor:"transparent",
borderColor:null,
elevation:0,
shadowColor:null,
shadowOffset:null,
shadowRadius:null,
shadowOpacity:null},

"NativeBase.Icon":{
color:variables.toolbarBtnColor},

"NativeBase.IconNB":{
color:variables.toolbarBtnColor},

alignSelf:null,
paddingHorizontal:variables.buttonPadding},

flex:1,
alignSelf:"center",
alignItems:"flex-end",
flexDirection:"row",
justifyContent:"flex-end"},

backgroundColor:variables.toolbarDefaultBg,
flexDirection:"row",
paddingHorizontal:10,
justifyContent:"center",
paddingTop:platform==="ios"?variables.isIphoneX?39:15:0,
borderBottomWidth:platform==="ios"?1/_reactNative.PixelRatio.getPixelSizeForLayoutSize(1):0,
borderBottomColor:variables.toolbarDefaultBorder,
height:variables.toolbarHeight,
elevation:3,
shadowColor:platformStyle==="material"?"#000":undefined,
shadowOffset:platformStyle==="material"?{width:0,height:2}:undefined,
shadowOpacity:platformStyle==="material"?0.2:undefined,
shadowRadius:platformStyle==="material"?1.2:undefined,
top:0,
left:0,
right:0};


return headerTheme;
};
//# sourceMappingURL=Header.js.map

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var switchTheme={
marginVertical:-5};


return switchTheme;
};
//# sourceMappingURL=Switch.js.map

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var thumbnailTheme={
'.square':{
borderRadius:0,
'.small':{
width:36,
height:36,
borderRadius:0},

'.large':{
width:80,
height:80,
borderRadius:0}},


'.small':{
width:36,
height:36,
borderRadius:18,
'.square':{
borderRadius:0}},


'.large':{
width:80,
height:80,
borderRadius:40,
'.square':{
borderRadius:0}},


width:56,
height:56,
borderRadius:28};


return thumbnailTheme;
};
//# sourceMappingURL=Thumbnail.js.map

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _reactNative=__webpack_require__(1);

var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var deviceHeight=_reactNative.Dimensions.get("window").height;exports.default=
function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var theme={
flex:1,
height:_reactNative.Platform.OS==="ios"?deviceHeight:deviceHeight-20};


return theme;
};
//# sourceMappingURL=Container.js.map

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var contentTheme={
".padder":{
padding:variables.contentPadding},

flex:1,
backgroundColor:"transparent",
"NativeBase.Segment":{
borderWidth:0,
backgroundColor:"transparent"}};



return contentTheme;
};
//# sourceMappingURL=Content.js.map

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var platformStyle=variables.platformStyle;
var platform=variables.platform;

var buttonTheme={
'.disabled':{
backgroundColor:variables.btnDisabledBg},

'.bordered':{
'.dark':{
'NativeBase.Text':{
color:variables.brandDark},

'NativeBase.Icon':{
color:variables.brandDark},

'NativeBase.IconNB':{
color:variables.brandDark},

backgroundColor:'transparent',
borderColor:variables.brandDark,
borderWidth:variables.borderWidth*2},

'.light':{
'NativeBase.Text':{
color:variables.brandLight},

'NativeBase.Icon':{
color:variables.brandLight},

'NativeBase.IconNB':{
color:variables.brandLight},

backgroundColor:'transparent',
borderColor:variables.brandLight,
borderWidth:variables.borderWidth*2},

'.primary':{
'NativeBase.Text':{
color:variables.btnPrimaryBg},

'NativeBase.Icon':{
color:variables.btnPrimaryBg},

'NativeBase.IconNB':{
color:variables.btnPrimaryBg},

backgroundColor:'transparent',
borderColor:variables.btnPrimaryBg,
borderWidth:variables.borderWidth*2},

'.success':{
'NativeBase.Text':{
color:variables.btnSuccessBg},

'NativeBase.Icon':{
color:variables.btnSuccessBg},

'NativeBase.IconNB':{
color:variables.btnSuccessBg},

backgroundColor:'transparent',
borderColor:variables.btnSuccessBg,
borderWidth:variables.borderWidth*2},

'.info':{
'NativeBase.Text':{
color:variables.btnInfoBg},

'NativeBase.Icon':{
color:variables.btnInfoBg},

'NativeBase.IconNB':{
color:variables.btnInfoBg},

backgroundColor:'transparent',
borderColor:variables.btnInfoBg,
borderWidth:variables.borderWidth*2},

'.warning':{
'NativeBase.Text':{
color:variables.btnWarningBg},

'NativeBase.Icon':{
color:variables.btnWarningBg},

'NativeBase.IconNB':{
color:variables.btnWarningBg},

backgroundColor:'transparent',
borderColor:variables.btnWarningBg,
borderWidth:variables.borderWidth*2},

'.danger':{
'NativeBase.Text':{
color:variables.btnDangerBg},

'NativeBase.Icon':{
color:variables.btnDangerBg},

'NativeBase.IconNB':{
color:variables.btnDangerBg},

backgroundColor:'transparent',
borderColor:variables.btnDangerBg,
borderWidth:variables.borderWidth*2},

'.disabled':{
backgroundColor:null,
borderColor:variables.btnDisabledBg,
borderWidth:variables.borderWidth*2,
'NativeBase.Text':{
color:variables.btnDisabledBg}},


'NativeBase.Text':{
color:variables.btnPrimaryBg},

'NativeBase.Icon':{
color:variables.btnPrimaryBg},

'NativeBase.IconNB':{
color:variables.btnPrimaryBg},

borderWidth:variables.borderWidth*2,
elevation:null,
shadowColor:null,
shadowOffset:null,
shadowOpacity:null,
shadowRadius:null,
backgroundColor:'transparent'},


'.dark':{
'.bordered':{
'NativeBase.Text':{
color:variables.brandDark},

'NativeBase.Icon':{
color:variables.brandDark},

'NativeBase.IconNB':{
color:variables.brandDark}},


backgroundColor:variables.brandDark},

'.light':{
'.transparent':{
'NativeBase.Text':{
color:variables.brandLight},

'NativeBase.Icon':{
color:variables.brandLight},

'NativeBase.IconNB':{
color:variables.brandLight},

backgroundColor:null},

'.bordered':{
'NativeBase.Text':{
color:variables.brandLight},

'NativeBase.Icon':{
color:variables.brandLight},

'NativeBase.IconNB':{
color:variables.brandLight}},


'NativeBase.Text':{
color:variables.brandDark},

'NativeBase.Icon':{
color:variables.brandDark},

'NativeBase.IconNB':{
color:variables.brandDark},

backgroundColor:variables.brandLight},


'.primary':{
'.bordered':{
'NativeBase.Text':{
color:variables.btnPrimaryBg},

'NativeBase.Icon':{
color:variables.btnPrimaryBg},

'NativeBase.IconNB':{
color:variables.btnPrimaryBg}},


backgroundColor:variables.btnPrimaryBg},


'.success':{
'.bordered':{
'NativeBase.Text':{
color:variables.btnSuccessBg},

'NativeBase.Icon':{
color:variables.btnSuccessBg},

'NativeBase.IconNB':{
color:variables.btnSuccessBg}},


backgroundColor:variables.btnSuccessBg},


'.info':{
'.bordered':{
'NativeBase.Text':{
color:variables.btnInfoBg},

'NativeBase.Icon':{
color:variables.btnInfoBg},

'NativeBase.IconNB':{
color:variables.btnInfoBg}},


backgroundColor:variables.btnInfoBg},


'.warning':{
'.bordered':{
'NativeBase.Text':{
color:variables.btnWarningBg},

'NativeBase.Icon':{
color:variables.btnWarningBg},

'NativeBase.IconNB':{
color:variables.btnWarningBg}},


backgroundColor:variables.btnWarningBg},


'.danger':{
'.bordered':{
'NativeBase.Text':{
color:variables.btnDangerBg},

'NativeBase.Icon':{
color:variables.btnDangerBg},

'NativeBase.IconNB':{
color:variables.btnDangerBg}},


backgroundColor:variables.btnDangerBg},


'.block':{
justifyContent:'center',
alignSelf:'stretch'},


'.full':{
justifyContent:'center',
alignSelf:'stretch',
borderRadius:0},


'.rounded':{

borderRadius:variables.borderRadiusLarge},


'.transparent':{
backgroundColor:'transparent',
elevation:0,
shadowColor:null,
shadowOffset:null,
shadowRadius:null,
shadowOpacity:null,

'NativeBase.Text':{
color:variables.btnPrimaryBg},

'NativeBase.Icon':{
color:variables.btnPrimaryBg},

'NativeBase.IconNB':{
color:variables.btnPrimaryBg},

'.dark':{
'NativeBase.Text':{
color:variables.brandDark},

'NativeBase.IconNB':{
color:variables.brandDark},

'NativeBase.Icon':{
color:variables.brandDark},

backgroundColor:null},

'.danger':{
'NativeBase.Text':{
color:variables.btnDangerBg},

'NativeBase.IconNB':{
color:variables.btnDangerBg},

'NativeBase.Icon':{
color:variables.btnDangerBg},

backgroundColor:null},

'.warning':{
'NativeBase.Text':{
color:variables.btnWarningBg},

'NativeBase.IconNB':{
color:variables.btnWarningBg},

'NativeBase.Icon':{
color:variables.btnWarningBg},

backgroundColor:null},

'.info':{
'NativeBase.Text':{
color:variables.btnInfoBg},

'NativeBase.IconNB':{
color:variables.btnInfoBg},

'NativeBase.Icon':{
color:variables.btnInfoBg},

backgroundColor:null},

'.primary':{
'NativeBase.Text':{
color:variables.btnPrimaryBg},

'NativeBase.IconNB':{
color:variables.btnPrimaryBg},

'NativeBase.Icon':{
color:variables.btnPrimaryBg},

backgroundColor:null},

'.success':{
'NativeBase.Text':{
color:variables.btnSuccessBg},

'NativeBase.IconNB':{
color:variables.btnSuccessBg},

'NativeBase.Icon':{
color:variables.btnSuccessBg},

backgroundColor:null},

'.light':{
'NativeBase.Text':{
color:variables.brandLight},

'NativeBase.IconNB':{
color:variables.brandLight},

'NativeBase.Icon':{
color:variables.brandLight},

backgroundColor:null}},



'.small':{
height:30,
'NativeBase.Text':{
fontSize:14}},



'.large':{
height:60,
'NativeBase.Text':{
fontSize:22,
lineHeight:32}},



'.capitalize':{},

'.vertical':{
flexDirection:'column',
height:null},


'NativeBase.Text':{
fontFamily:variables.btnFontFamily,
marginLeft:0,
marginRight:0,
color:variables.inverseTextColor,
fontSize:variables.btnTextSize,
lineHeight:variables.btnLineHeight,
paddingHorizontal:16,
backgroundColor:'transparent'},



'NativeBase.Icon':{
color:variables.inverseTextColor,
fontSize:24,
marginHorizontal:16,
paddingTop:platform==='ios'?2:undefined},

'NativeBase.IconNB':{
color:variables.inverseTextColor,
fontSize:24,
marginHorizontal:16,
paddingTop:platform==='ios'?2:undefined},


'.iconLeft':{
'NativeBase.Text':{
marginLeft:0},

'NativeBase.IconNB':{
marginRight:0,
marginLeft:16},

'NativeBase.Icon':{
marginRight:0,
marginLeft:16}},


'.iconRight':{
'NativeBase.Text':{
marginRight:0},

'NativeBase.IconNB':{
marginLeft:0,
marginRight:16},

'NativeBase.Icon':{
marginLeft:0,
marginRight:16}},


'.picker':{
'NativeBase.Text':{
'.note':{
fontSize:16,
lineHeight:null}}},




paddingVertical:variables.buttonPadding,

backgroundColor:variables.btnPrimaryBg,
borderRadius:variables.borderRadiusBase,
borderColor:variables.btnPrimaryBg,
borderWidth:null,
height:45,
alignSelf:'flex-start',
flexDirection:'row',
elevation:2,
shadowColor:platformStyle==='material'?variables.brandDark:undefined,
shadowOffset:
platformStyle==='material'?{width:0,height:2}:undefined,
shadowOpacity:platformStyle==='material'?0.2:undefined,
shadowRadius:platformStyle==='material'?1.2:undefined,
alignItems:'center',
justifyContent:'space-between'};

return buttonTheme;
};
//# sourceMappingURL=Button.js.map

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _reactNative=__webpack_require__(1);

var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var titleTheme={
fontSize:variables.titleFontSize,
fontFamily:variables.titleFontfamily,
color:variables.titleFontColor,
fontWeight:_reactNative.Platform.OS==="ios"?"600":undefined,
textAlign:"center"};


return titleTheme;
};
//# sourceMappingURL=Title.js.map

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var subtitleTheme={
fontSize:variables.subTitleFontSize,
fontFamily:variables.titleFontfamily,
color:variables.subtitleColor,
textAlign:'center'};


return subtitleTheme;
};
//# sourceMappingURL=Subtitle.js.map

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var inputGroupTheme={
"NativeBase.Icon":{
fontSize:24,
color:variables.sTabBarActiveTextColor,
paddingHorizontal:5},

"NativeBase.IconNB":{
fontSize:24,
color:variables.sTabBarActiveTextColor,
paddingHorizontal:5},

"NativeBase.Input":{
height:variables.inputHeightBase,
color:variables.inputColor,
paddingLeft:5,
paddingRight:5,
flex:1,
fontSize:variables.inputFontSize,
lineHeight:variables.inputLineHeight},

".underline":{
".success":{
borderColor:variables.inputSuccessBorderColor},

".error":{
borderColor:variables.inputErrorBorderColor},

paddingLeft:5,
borderWidth:variables.borderWidth,
borderTopWidth:0,
borderRightWidth:0,
borderLeftWidth:0,
borderColor:variables.inputBorderColor},

".regular":{
".success":{
borderColor:variables.inputSuccessBorderColor},

".error":{
borderColor:variables.inputErrorBorderColor},

paddingLeft:5,
borderWidth:variables.borderWidth,
borderColor:variables.inputBorderColor},

".rounded":{
".success":{
borderColor:variables.inputSuccessBorderColor},

".error":{
borderColor:variables.inputErrorBorderColor},

paddingLeft:5,
borderWidth:variables.borderWidth,
borderRadius:variables.inputGroupRoundedBorderRadius,
borderColor:variables.inputBorderColor},


".success":{
"NativeBase.Icon":{
color:variables.inputSuccessBorderColor},

"NativeBase.IconNB":{
color:variables.inputSuccessBorderColor},

".rounded":{
borderRadius:30,
borderColor:variables.inputSuccessBorderColor},

".regular":{
borderColor:variables.inputSuccessBorderColor},

".underline":{
borderWidth:variables.borderWidth,
borderTopWidth:0,
borderRightWidth:0,
borderLeftWidth:0,
borderColor:variables.inputSuccessBorderColor},

borderColor:variables.inputSuccessBorderColor},


".error":{
"NativeBase.Icon":{
color:variables.inputErrorBorderColor},

"NativeBase.IconNB":{
color:variables.inputErrorBorderColor},

".rounded":{
borderRadius:30,
borderColor:variables.inputErrorBorderColor},

".regular":{
borderColor:variables.inputErrorBorderColor},

".underline":{
borderWidth:variables.borderWidth,
borderTopWidth:0,
borderRightWidth:0,
borderLeftWidth:0,
borderColor:variables.inputErrorBorderColor},

borderColor:variables.inputErrorBorderColor},

".disabled":{
"NativeBase.Icon":{
color:"#384850"},

"NativeBase.IconNB":{
color:"#384850"}},



paddingLeft:5,
borderWidth:variables.borderWidth,
borderTopWidth:0,
borderRightWidth:0,
borderLeftWidth:0,
borderColor:variables.inputBorderColor,
backgroundColor:"transparent",
flexDirection:"row",
alignItems:"center"};


return inputGroupTheme;
};
//# sourceMappingURL=InputGroup.js.map

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var badgeTheme={
".primary":{
backgroundColor:variables.btnPrimaryBg},

".warning":{
backgroundColor:variables.btnWarningBg},

".info":{
backgroundColor:variables.btnInfoBg},

".success":{
backgroundColor:variables.btnSuccessBg},

".danger":{
backgroundColor:variables.btnDangerBg},

"NativeBase.Text":{
color:variables.badgeColor,
fontSize:variables.fontSizeBase,
lineHeight:variables.lineHeight-1,
textAlign:"center",
paddingHorizontal:3},

backgroundColor:variables.badgeBg,
padding:variables.badgePadding,
paddingHorizontal:6,
alignSelf:"flex-start",
borderRadius:13.5,
height:27};

return badgeTheme;
};
//# sourceMappingURL=Badge.js.map

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var checkBoxTheme={
".checked":{
"NativeBase.Icon":{
color:variables.checkboxTickColor},

"NativeBase.IconNB":{
color:variables.checkboxTickColor}},


"NativeBase.Icon":{
color:"transparent",
lineHeight:variables.CheckboxIconSize,
marginTop:variables.CheckboxIconMarginTop,
fontSize:variables.CheckboxFontSize},

"NativeBase.IconNB":{
color:"transparent",
lineHeight:variables.CheckboxIconSize,
marginTop:variables.CheckboxIconMarginTop,
fontSize:variables.CheckboxFontSize},

borderRadius:variables.CheckboxRadius,
overflow:"hidden",
width:variables.checkboxSize,
height:variables.checkboxSize,
borderWidth:variables.CheckboxBorderWidth,
paddingLeft:variables.CheckboxPaddingLeft-1,
paddingBottom:variables.CheckboxPaddingBottom,
left:10};


return checkBoxTheme;
};
//# sourceMappingURL=CheckBox.js.map

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var cardTheme={
".transparent":{
shadowColor:null,
shadowOffset:null,
shadowOpacity:null,
shadowRadius:null,
elevation:null},

marginVertical:5,
marginHorizontal:2,
flex:1,
borderWidth:variables.borderWidth,
borderRadius:2,
borderColor:variables.cardBorderColor,
flexWrap:"wrap",
backgroundColor:variables.cardDefaultBg,
shadowColor:"#000",
shadowOffset:{width:0,height:2},
shadowOpacity:0.1,
shadowRadius:1.5,
elevation:3};


return cardTheme;
};
//# sourceMappingURL=Card.js.map

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _reactNative=__webpack_require__(1);

var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var radioTheme={
".selected":{
"NativeBase.IconNB":{
color:_reactNative.Platform.OS==="ios"?
variables.brandPrimary:
variables.radioSelectedColorAndroid,
lineHeight:_reactNative.Platform.OS==="ios"?25:variables.radioBtnLineHeight,
height:_reactNative.Platform.OS==="ios"?20:undefined}},


"NativeBase.IconNB":{
color:_reactNative.Platform.OS==="ios"?"transparent":undefined,
lineHeight:_reactNative.Platform.OS==="ios"?
undefined:
variables.radioBtnLineHeight,
fontSize:_reactNative.Platform.OS==="ios"?undefined:variables.radioBtnSize}};



return radioTheme;
};
//# sourceMappingURL=Radio.js.map

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var h3Theme={
color:variables.textColor,
fontSize:variables.fontSizeH3,
lineHeight:variables.lineHeightH3};


return h3Theme;
};
//# sourceMappingURL=H3.js.map

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var h2Theme={
color:variables.textColor,
fontSize:variables.fontSizeH2,
lineHeight:variables.lineHeightH2};


return h2Theme;
};
//# sourceMappingURL=H2.js.map

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var h1Theme={
color:variables.textColor,
fontSize:variables.fontSizeH1,
lineHeight:variables.lineHeightH1};


return h1Theme;
};
//# sourceMappingURL=H1.js.map

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var platformStyle=variables.platformStyle;
var platform=variables.platform;

var footerTheme={
"NativeBase.Left":{
"NativeBase.Button":{
".transparent":{
backgroundColor:"transparent",
borderColor:null,
elevation:0,
shadowColor:null,
shadowOffset:null,
shadowRadius:null,
shadowOpacity:null},

"NativeBase.Icon":{
color:variables.topTabBarActiveTextColor},

"NativeBase.IconNB":{
color:variables.topTabBarActiveTextColor},

alignSelf:null},

flex:1,
alignSelf:"center",
alignItems:"flex-start"},

"NativeBase.Body":{
flex:1,
alignItems:"center",
alignSelf:"center",
flexDirection:"row",
"NativeBase.Button":{
alignSelf:"center",
".transparent":{
backgroundColor:"transparent",
borderColor:null,
elevation:0,
shadowColor:null,
shadowOffset:null,
shadowRadius:null,
shadowOpacity:null},

".full":{
height:variables.footerHeight,
paddingBottom:variables.footerPaddingBottom,
flex:1},

"NativeBase.Icon":{
color:variables.topTabBarActiveTextColor},

"NativeBase.IconNB":{
color:variables.topTabBarActiveTextColor}}},



"NativeBase.Right":{
"NativeBase.Button":{
".transparent":{
backgroundColor:"transparent",
borderColor:null,
elevation:0,
shadowColor:null,
shadowOffset:null,
shadowRadius:null,
shadowOpacity:null},

"NativeBase.Icon":{
color:variables.topTabBarActiveTextColor},

"NativeBase.IconNB":{
color:variables.topTabBarActiveTextColor},

alignSelf:null},

flex:1,
alignSelf:"center",
alignItems:"flex-end"},

backgroundColor:variables.footerDefaultBg,
flexDirection:"row",
justifyContent:"center",
borderTopWidth:platform==="ios"&&platformStyle!=="material"?
variables.borderWidth:
undefined,
borderColor:platform==="ios"&&platformStyle!=="material"?
"#cbcbcb":
undefined,
height:variables.footerHeight,
paddingBottom:variables.footerPaddingBottom,
elevation:3,
left:0,
right:0};

return footerTheme;
};
//# sourceMappingURL=Footer.js.map

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _reactNative=__webpack_require__(1);

var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var platform=variables.platform;

var footerTabTheme={
"NativeBase.Button":{
".active":{
"NativeBase.Text":{
color:variables.tabBarActiveTextColor,
fontSize:variables.tabBarTextSize,
lineHeight:16},

"NativeBase.Icon":{
color:variables.tabBarActiveTextColor},

"NativeBase.IconNB":{
color:variables.tabBarActiveTextColor},

backgroundColor:variables.tabActiveBgColor},

flexDirection:null,
backgroundColor:"transparent",
borderColor:null,
elevation:0,
shadowColor:null,
shadowOffset:null,
shadowRadius:null,
shadowOpacity:null,
alignSelf:"center",
flex:1,
height:variables.footerHeight-(variables.isIphoneX?34:0),
justifyContent:"center",
".badge":{
"NativeBase.Badge":{
"NativeBase.Text":{
fontSize:11,
fontWeight:platform==="ios"?"600":undefined,
lineHeight:14},

top:-3,
alignSelf:"center",
left:10,
zIndex:99,
height:18,
padding:1.7,
paddingHorizontal:3},

"NativeBase.Icon":{
marginTop:-18}},


"NativeBase.Icon":{
color:variables.tabBarTextColor},

"NativeBase.IconNB":{
color:variables.tabBarTextColor},

"NativeBase.Text":{
color:variables.tabBarTextColor,
fontSize:variables.tabBarTextSize,
lineHeight:16}},


backgroundColor:_reactNative.Platform.OS==="android"?
variables.tabActiveBgColor:
undefined,
flexDirection:"row",
justifyContent:"space-between",
flex:1,
alignSelf:"stretch"};


return footerTabTheme;
};
//# sourceMappingURL=FooterTab.js.map

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var platform=variables.platform;

var fabTheme={
"NativeBase.Button":{
alignItems:"center",
padding:null,
justifyContent:"center",
"NativeBase.Icon":{
alignSelf:"center",
fontSize:20,
marginLeft:0,
marginRight:0},

"NativeBase.IconNB":{
alignSelf:"center",
fontSize:20,
marginLeft:0,
marginRight:0}}};




return fabTheme;
};
//# sourceMappingURL=Fab.js.map

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _reactNative=__webpack_require__(1);

var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var itemTheme={
'.floatingLabel':{
'NativeBase.Input':{
height:60,
top:8},

'NativeBase.Label':{
top:8},

'NativeBase.Icon':{
top:6}},


'.fixedLabel':{
'NativeBase.Label':{
position:null,
top:null,
left:null,
right:null,
flex:1,
height:null,
width:null,
fontSize:variables.inputFontSize},

'NativeBase.Input':{
flex:2,
fontSize:variables.inputFontSize}},


'.stackedLabel':{
'NativeBase.Label':{
position:null,
top:null,
left:null,
right:null,
paddingTop:5,
alignSelf:'flex-start',
fontSize:variables.inputFontSize-2},

'NativeBase.Icon':{
marginTop:36},

'NativeBase.Input':{
alignSelf:_reactNative.Platform.OS==='ios'?'stretch':'flex-start',
flex:1,
width:_reactNative.Platform.OS==='ios'?null:variables.deviceWidth-25,
fontSize:variables.inputFontSize},

flexDirection:null},

'.inlineLabel':{
'NativeBase.Label':{
position:null,
top:null,
left:null,
right:null,
paddingRight:20,
height:null,
width:null,
fontSize:variables.inputFontSize},

'NativeBase.Input':{
paddingLeft:5,
fontSize:variables.inputFontSize},

flexDirection:'row'},

'NativeBase.Label':{
fontSize:variables.inputFontSize,
color:variables.inputColorPlaceholder,
paddingRight:5},

'NativeBase.Icon':{
fontSize:24,
paddingRight:8},

'NativeBase.IconNB':{
fontSize:24,
paddingRight:8},

'NativeBase.Input':{
'.multiline':{
height:null},

height:variables.inputHeightBase,
color:variables.inputColor,
flex:1,
top:_reactNative.Platform.OS==='ios'?1.5:undefined,
fontSize:variables.inputFontSize,
lineHeight:variables.inputLineHeight},

'.underline':{
'NativeBase.Input':{
paddingLeft:15},

'.success':{
borderColor:variables.inputSuccessBorderColor},

'.error':{
borderColor:variables.inputErrorBorderColor},

borderWidth:variables.borderWidth*2,
borderTopWidth:0,
borderRightWidth:0,
borderLeftWidth:0,
borderColor:variables.inputBorderColor},

'.regular':{
'NativeBase.Input':{
paddingLeft:8},

'NativeBase.Icon':{
paddingLeft:10},

'.success':{
borderColor:variables.inputSuccessBorderColor},

'.error':{
borderColor:variables.inputErrorBorderColor},

borderWidth:variables.borderWidth*2,
borderColor:variables.inputBorderColor},

'.rounded':{
'NativeBase.Input':{
paddingLeft:8},

'NativeBase.Icon':{
paddingLeft:10},

'.success':{
borderColor:variables.inputSuccessBorderColor},

'.error':{
borderColor:variables.inputErrorBorderColor},

borderWidth:variables.borderWidth*2,
borderRadius:30,
borderColor:variables.inputBorderColor},


'.success':{
'NativeBase.Icon':{
color:variables.inputSuccessBorderColor},

'NativeBase.IconNB':{
color:variables.inputSuccessBorderColor},

'.rounded':{
borderRadius:30,
borderColor:variables.inputSuccessBorderColor},

'.regular':{
borderColor:variables.inputSuccessBorderColor},

'.underline':{
borderWidth:variables.borderWidth*2,
borderTopWidth:0,
borderRightWidth:0,
borderLeftWidth:0,
borderColor:variables.inputSuccessBorderColor},

borderColor:variables.inputSuccessBorderColor},


'.error':{
'NativeBase.Icon':{
color:variables.inputErrorBorderColor},

'NativeBase.IconNB':{
color:variables.inputErrorBorderColor},

'.rounded':{
borderRadius:30,
borderColor:variables.inputErrorBorderColor},

'.regular':{
borderColor:variables.inputErrorBorderColor},

'.underline':{
borderWidth:variables.borderWidth*2,
borderTopWidth:0,
borderRightWidth:0,
borderLeftWidth:0,
borderColor:variables.inputErrorBorderColor},

borderColor:variables.inputErrorBorderColor},

'.disabled':{
'NativeBase.Icon':{
color:'#384850'},

'NativeBase.IconNB':{
color:'#384850'}},



borderWidth:variables.borderWidth*2,
borderTopWidth:0,
borderRightWidth:0,
borderLeftWidth:0,
borderColor:variables.inputBorderColor,
backgroundColor:'transparent',
flexDirection:'row',
alignItems:'center',
marginLeft:2};


return itemTheme;
};
//# sourceMappingURL=Item.js.map

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var labelTheme={
".focused":{
width:0},

fontSize:17};


return labelTheme;
};
//# sourceMappingURL=Label.js.map

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var textAreaTheme={
".underline":{
borderBottomWidth:variables.borderWidth,
marginTop:5,
borderColor:variables.inputBorderColor},

".bordered":{
borderWidth:1,
marginTop:5,
borderColor:variables.inputBorderColor},

color:variables.textColor,
paddingLeft:10,
paddingRight:5,
fontSize:15,
textAlignVertical:"top"};


return textAreaTheme;
};
//# sourceMappingURL=Textarea.js.map

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var textTheme={
fontSize:variables.DefaultFontSize-1,
fontFamily:variables.fontFamily,
color:variables.textColor,
".note":{
color:"#a7a7a7",
fontSize:variables.noteFontSize}};



return textTheme;
};
//# sourceMappingURL=Text.js.map

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var platform=variables.platform;

var toastTheme={
".danger":{
backgroundColor:variables.brandDanger},

".warning":{
backgroundColor:variables.brandWarning},

".success":{
backgroundColor:variables.brandSuccess},

backgroundColor:"rgba(0,0,0,0.8)",
borderRadius:platform==="ios"?5:0,
flexDirection:"row",
justifyContent:"space-between",
alignItems:"center",
padding:10,
minHeight:50,
"NativeBase.Text":{
color:"#fff",
flex:1},

"NativeBase.Button":{
backgroundColor:"transparent",
height:30,
elevation:0,
"NativeBase.Text":{
fontSize:14}}};




return toastTheme;
};
//# sourceMappingURL=Toast.js.map

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var tabTheme={
flex:1,
backgroundColor:"#FFF"};


return tabTheme;
};
//# sourceMappingURL=Tab.js.map

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var tabBarTheme={
".tabIcon":{
height:undefined},

".vertical":{
height:60},

"NativeBase.Button":{
".transparent":{
"NativeBase.Text":{
fontSize:variables.tabFontSize,
color:variables.sTabBarActiveTextColor,
fontWeight:"400"},

"NativeBase.IconNB":{
color:variables.sTabBarActiveTextColor}},


"NativeBase.IconNB":{
color:variables.sTabBarActiveTextColor},

"NativeBase.Text":{
fontSize:variables.tabFontSize,
color:variables.sTabBarActiveTextColor,
fontWeight:"400"},

".isTabActive":{
"NativeBase.Text":{
fontWeight:"900"}},


flex:1,
alignSelf:"stretch",
alignItems:"center",
justifyContent:"center",
borderRadius:null,
borderBottomColor:"transparent",
backgroundColor:variables.tabBgColor},

height:45,
flexDirection:"row",
justifyContent:"space-around",
borderWidth:1,
borderTopWidth:0,
borderLeftWidth:0,
borderRightWidth:0,
borderBottomColor:"#ccc",
backgroundColor:variables.tabBgColor};


return tabBarTheme;
};
//# sourceMappingURL=TabBar.js.map

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);
var _reactNative=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var platformStyle=variables.platformStyle;
var platform=variables.platform;

var tabContainerTheme={
elevation:3,
height:50,
flexDirection:"row",
shadowColor:platformStyle==="material"?"#000":undefined,
shadowOffset:platformStyle==="material"?
{width:0,height:2}:
undefined,
shadowOpacity:platformStyle==="material"?0.2:undefined,
shadowRadius:platformStyle==="material"?1.2:undefined,
justifyContent:"space-around",
borderBottomWidth:_reactNative.Platform.OS==="ios"?variables.borderWidth:0,
borderColor:variables.topTabBarBorderColor};


return tabContainerTheme;
};
//# sourceMappingURL=TabContainer.js.map

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var viewTheme={
".padder":{
padding:variables.contentPadding}};



return viewTheme;
};
//# sourceMappingURL=View.js.map

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var platform=variables.platform;

var tabHeadingTheme={
flexDirection:"row",
backgroundColor:variables.tabDefaultBg,
flex:1,
alignItems:"center",
justifyContent:"center",
".scrollable":{
paddingHorizontal:20,
flex:platform==="android"?0:1,
minWidth:platform==="android"?undefined:60},

"NativeBase.Text":{
color:variables.topTabBarTextColor,
marginHorizontal:7},

"NativeBase.Icon":{
color:variables.topTabBarTextColor,
fontSize:platform==="ios"?26:undefined},

".active":{
"NativeBase.Text":{
color:variables.topTabBarActiveTextColor,
fontWeight:"600"},

"NativeBase.Icon":{
color:variables.topTabBarActiveTextColor}}};




return tabHeadingTheme;
};
//# sourceMappingURL=TabHeading.js.map

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var iconTheme={
fontSize:variables.iconFontSize,
color:"#000"};


return iconTheme;
};
//# sourceMappingURL=Icon.js.map

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var inputTheme={
'.multiline':{
height:null},

height:variables.inputHeightBase,
color:variables.inputColor,
paddingLeft:5,
paddingRight:5,
flex:1,
fontSize:variables.inputFontSize,
lineHeight:variables.inputLineHeight};


return inputTheme;
};
//# sourceMappingURL=Input.js.map

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var swipeRowTheme={
"NativeBase.ListItem":{
".list":{
backgroundColor:"#FFF"},

marginLeft:0},

"NativeBase.Left":{
flex:0,
alignSelf:null,
alignItems:null,
"NativeBase.Button":{
flex:1,
alignItems:"center",
justifyContent:"center",
alignSelf:"stretch",
borderRadius:0}},


"NativeBase.Right":{
flex:0,
alignSelf:null,
alignItems:null,
"NativeBase.Button":{
flex:1,
alignItems:"center",
justifyContent:"center",
alignSelf:"stretch",
borderRadius:0}},


"NativeBase.Button":{
flex:1,
height:null,
alignItems:"center",
justifyContent:"center",
alignSelf:"stretch",
borderRadius:0}};



return swipeRowTheme;
};
//# sourceMappingURL=SwipeRow.js.map

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var platform=variables.platform;

var segmentTheme={
height:45,
borderColor:variables.segmentBorderColorMain,
flexDirection:"row",
justifyContent:"center",
backgroundColor:variables.segmentBackgroundColor,
"NativeBase.Button":{
alignSelf:"center",
borderRadius:0,
paddingHorizontal:20,
height:30,
backgroundColor:"transparent",
borderWidth:1,
borderLeftWidth:0,
borderColor:variables.segmentBorderColor,
elevation:0,
".active":{
backgroundColor:variables.segmentActiveBackgroundColor,
"NativeBase.Text":{
color:variables.segmentActiveTextColor}},


".first":{
borderTopLeftRadius:platform==="ios"?5:undefined,
borderBottomLeftRadius:platform==="ios"?5:undefined,
borderLeftWidth:1},

".last":{
borderTopRightRadius:platform==="ios"?5:undefined,
borderBottomRightRadius:platform==="ios"?5:undefined},

"NativeBase.Text":{
color:variables.segmentTextColor,
fontSize:14}}};




return segmentTheme;
};
//# sourceMappingURL=Segment.js.map

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var spinnerTheme={
height:80};


return spinnerTheme;
};
//# sourceMappingURL=Spinner.js.map

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var platform=variables.platform;

var cardItemTheme={
'NativeBase.Left':{
'NativeBase.Body':{
'NativeBase.Text':{
'.note':{
color:variables.listNoteColor,
fontWeight:'400',
marginRight:20}},


flex:1,
marginLeft:10,
alignItems:null},

'NativeBase.Icon':{
fontSize:variables.iconFontSize},

'NativeBase.IconNB':{
fontSize:variables.iconFontSize},

'NativeBase.Text':{
marginLeft:10,
alignSelf:'center'},

'NativeBase.Button':{
'.transparent':{
'NativeBase.Text':{
fontSize:variables.DefaultFontSize-4,
color:variables.sTabBarActiveTextColor},

'NativeBase.Icon':{
fontSize:variables.iconFontSize-10,
color:variables.sTabBarActiveTextColor,
marginHorizontal:null},

'NativeBase.IconNB':{
fontSize:variables.iconFontSize-10,
color:variables.sTabBarActiveTextColor},

paddingVertical:null,
paddingHorizontal:null,
paddingRight:variables.listItemPadding+5}},


flex:1,
flexDirection:'row',
alignItems:'center'},


'.content':{
'NativeBase.Text':{
color:platform==='ios'?'#555':'#222',
fontSize:variables.DefaultFontSize-3}},


'.cardBody':{
padding:-5,
'NativeBase.Text':{
marginTop:5}},


'NativeBase.Body':{
'NativeBase.Text':{
'.note':{
color:variables.listNoteColor,
fontWeight:'200',
marginRight:20}},


'NativeBase.Button':{
'.transparent':{
'NativeBase.Text':{
fontSize:variables.DefaultFontSize-4,
color:variables.sTabBarActiveTextColor},

'NativeBase.Icon':{
fontSize:variables.iconFontSize-10,
color:variables.sTabBarActiveTextColor,
marginHorizontal:null},

'NativeBase.IconNB':{
fontSize:variables.iconFontSize-10,
color:variables.sTabBarActiveTextColor},

paddingVertical:null,
paddingHorizontal:null,
paddingRight:variables.listItemPadding+5,
alignSelf:'stretch'}},


flex:1,
alignSelf:'stretch',
alignItems:'flex-start'},

'NativeBase.Right':{
'NativeBase.Badge':{
alignSelf:null},

'NativeBase.Button':{
'.transparent':{
'NativeBase.Text':{
fontSize:variables.DefaultFontSize-4,
color:variables.sTabBarActiveTextColor},

'NativeBase.Icon':{
fontSize:variables.iconFontSize-10,
color:variables.sTabBarActiveTextColor,
marginHorizontal:null},

'NativeBase.IconNB':{
fontSize:variables.iconFontSize-10,
color:variables.sTabBarActiveTextColor},

paddingVertical:null,
paddingHorizontal:null},

alignSelf:null},

'NativeBase.Icon':{
alignSelf:null,
fontSize:variables.iconFontSize-8,
color:variables.cardBorderColor},

'NativeBase.IconNB':{
alignSelf:null,
fontSize:variables.iconFontSize-8,
color:variables.cardBorderColor},

'NativeBase.Text':{
fontSize:variables.DefaultFontSize-2,
alignSelf:null},

'NativeBase.Thumbnail':{
alignSelf:null},

'NativeBase.Image':{
alignSelf:null},

'NativeBase.Radio':{
alignSelf:null},

'NativeBase.Checkbox':{
alignSelf:null},

'NativeBase.Switch':{
alignSelf:null},

flex:0.8},

'.header':{
'NativeBase.Text':{
fontSize:16,
fontWeight:platform==='ios'?'500':undefined},

'.bordered':{
'NativeBase.Text':{
color:variables.sTabBarActiveTextColor,
fontWeight:platform==='ios'?'500':undefined},

borderBottomWidth:platform==='ios'?variables.borderWidth:null},

borderBottomWidth:null,
paddingVertical:variables.listItemPadding+5},

'.footer':{
'NativeBase.Text':{
fontSize:16,
fontWeight:platform==='ios'?'500':undefined},

'.bordered':{
'NativeBase.Text':{
color:variables.activeTab,
fontWeight:'500'},

borderTopWidth:platform==='ios'?variables.borderWidth:null},

borderBottomWidth:null},

'NativeBase.Text':{
'.note':{
color:variables.listNoteColor,
fontWeight:'200'}},



'NativeBase.Icon':{
width:variables.iconFontSize+5,
fontSize:variables.iconFontSize-2},

'NativeBase.IconNB':{
width:variables.iconFontSize+5,
fontSize:variables.iconFontSize-2},


'.bordered':{
borderBottomWidth:variables.borderWidth,
borderColor:variables.cardBorderColor},

flexDirection:'row',
alignItems:'center',
borderRadius:2,
padding:variables.listItemPadding+5,
paddingVertical:variables.listItemPadding,
backgroundColor:variables.cardDefaultBg};


return cardItemTheme;
};
//# sourceMappingURL=CardItem.js.map

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _reactNative=__webpack_require__(1);

var _Picker=__webpack_require__(454);var _Picker2=_interopRequireDefault(_Picker);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var platform=variables.platform;

var listItemTheme={
"NativeBase.InputGroup":{
"NativeBase.Icon":{
paddingRight:5},

"NativeBase.IconNB":{
paddingRight:5},

"NativeBase.Input":{
paddingHorizontal:5},

flex:1,
borderWidth:null,
margin:-10,
borderBottomColor:"transparent"},

".searchBar":{
"NativeBase.Item":{
"NativeBase.Icon":{
backgroundColor:"transparent",
color:variables.dropdownLinkColor,
fontSize:platform==="ios"?
variables.iconFontSize-10:
variables.iconFontSize-5,
alignItems:"center",
marginTop:2,
paddingRight:8},

"NativeBase.IconNB":{
backgroundColor:"transparent",
color:null,
alignSelf:"center"},

"NativeBase.Input":{
alignSelf:"center"},

alignSelf:"center",
alignItems:"center",
justifyContent:"flex-start",
flex:1,
height:platform==="ios"?30:40,
borderColor:"transparent",
backgroundColor:"#fff",
borderRadius:5},

"NativeBase.Button":{
".transparent":{
"NativeBase.Text":{
fontWeight:"500"},

paddingHorizontal:null,
paddingLeft:platform==="ios"?10:null},

paddingHorizontal:platform==="ios"?undefined:null,
width:platform==="ios"?undefined:0,
height:platform==="ios"?undefined:0},

backgroundColor:variables.toolbarInputColor,
padding:10,
marginLeft:null},

"NativeBase.CheckBox":{
marginLeft:-10,
marginRight:10},

".first":{
".itemHeader":{
paddingTop:variables.listItemPadding+3}},


".itemHeader":{
".first":{
paddingTop:variables.listItemPadding+3},

borderBottomWidth:platform==="ios"?variables.borderWidth:null,
marginLeft:null,
padding:variables.listItemPadding,
paddingLeft:variables.listItemPadding+5,
paddingTop:platform==="ios"?
variables.listItemPadding+25:
undefined,
paddingBottom:platform==="android"?
variables.listItemPadding+20:
undefined,
flexDirection:"row",
borderColor:variables.listBorderColor,
"NativeBase.Text":{
fontSize:14,
color:platform==="ios"?undefined:variables.listNoteColor}},


".itemDivider":{
borderBottomWidth:null,
marginLeft:null,
padding:variables.listItemPadding,
paddingLeft:variables.listItemPadding+5,
backgroundColor:variables.listDividerBg,
flexDirection:"row",
borderColor:variables.listBorderColor},

".selected":{
"NativeBase.Left":{
"NativeBase.Text":{
color:variables.brandPrimary}},


"NativeBase.Text":{
color:variables.brandPrimary}},


"NativeBase.Left":{
"NativeBase.Body":{
"NativeBase.Text":{
".note":{
color:variables.listNoteColor,
fontWeight:"200"},

fontWeight:"600"},

marginLeft:10,
alignItems:null,
alignSelf:null},

"NativeBase.Icon":{
width:variables.iconFontSize-10,
fontSize:variables.iconFontSize-10},

"NativeBase.IconNB":{
width:variables.iconFontSize-10,
fontSize:variables.iconFontSize-10},

"NativeBase.Text":{
marginLeft:10,
alignSelf:"center"},

flexDirection:"row"},

"NativeBase.Body":{
"NativeBase.Text":{
marginHorizontal:variables.listItemPadding,
".note":{
color:variables.listNoteColor,
fontWeight:"200"}},


alignSelf:null,
alignItems:null},

"NativeBase.Right":{
"NativeBase.Badge":{
alignSelf:null},

"NativeBase.PickerNB":{
"NativeBase.Button":{
marginRight:-15,
"NativeBase.Text":{
color:variables.topTabBarActiveTextColor}}},



"NativeBase.Button":{
alignSelf:null,
".transparent":{
"NativeBase.Text":{
color:variables.topTabBarActiveTextColor}}},



"NativeBase.Icon":{
alignSelf:null,
fontSize:variables.iconFontSize-8,
color:"#c9c8cd"},

"NativeBase.IconNB":{
alignSelf:null,
fontSize:variables.iconFontSize-8,
color:"#c9c8cd"},

"NativeBase.Text":{
".note":{
color:variables.listNoteColor,
fontWeight:"200"},

alignSelf:null},

"NativeBase.Thumbnail":{
alignSelf:null},

"NativeBase.Image":{
alignSelf:null},

"NativeBase.Radio":{
alignSelf:null},

"NativeBase.Checkbox":{
alignSelf:null},

"NativeBase.Switch":{
alignSelf:null},

padding:null,
flex:0.28},

"NativeBase.Text":{
".note":{
color:variables.listNoteColor,
fontWeight:"200"},

alignSelf:'center'},


".last":{
marginLeft:-(variables.listItemPadding+5),
paddingLeft:(variables.listItemPadding+5)*2,
top:1},


".avatar":{
"NativeBase.Left":{
flex:0},

"NativeBase.Body":{
"NativeBase.Text":{
marginLeft:null},

flex:1,
paddingVertical:variables.listItemPadding,
borderBottomWidth:variables.borderWidth,
borderColor:variables.listBorderColor,
marginLeft:variables.listItemPadding+5},

"NativeBase.Right":{
"NativeBase.Text":{
".note":{
fontSize:variables.noteFontSize-2}},


flex:0,
paddingRight:variables.listItemPadding+5,
alignSelf:"stretch",
paddingVertical:variables.listItemPadding,
borderBottomWidth:variables.borderWidth,
borderColor:variables.listBorderColor},

borderBottomWidth:null,
paddingVertical:null,
paddingRight:null},


".thumbnail":{
"NativeBase.Left":{
flex:0},

"NativeBase.Body":{
"NativeBase.Text":{
marginLeft:null},

flex:1,
paddingVertical:variables.listItemPadding+5,
borderBottomWidth:variables.borderWidth,
borderColor:variables.listBorderColor,
marginLeft:variables.listItemPadding+5},

"NativeBase.Right":{
"NativeBase.Button":{
".transparent":{
"NativeBase.Text":{
fontSize:variables.listNoteSize,
color:variables.sTabBarActiveTextColor}},


height:null},

flex:0,
justifyContent:"center",
alignSelf:"stretch",
paddingRight:variables.listItemPadding+5,
paddingVertical:variables.listItemPadding+5,
borderBottomWidth:variables.borderWidth,
borderColor:variables.listBorderColor},

borderBottomWidth:null,
paddingVertical:null,
paddingRight:null},


".icon":{
".last":{
"NativeBase.Body":{
borderBottomWidth:null},

"NativeBase.Right":{
borderBottomWidth:null},

borderBottomWidth:variables.borderWidth,
borderColor:variables.listBorderColor},

"NativeBase.Left":{
"NativeBase.Button":{
"NativeBase.IconNB":{
marginHorizontal:null,
fontSize:variables.iconFontSize-5},

"NativeBase.Icon":{
marginHorizontal:null,
fontSize:variables.iconFontSize-8},

alignSelf:"center",
height:29,
width:29,
borderRadius:6,
paddingVertical:null,
paddingHorizontal:null,
alignItems:"center",
justifyContent:"center"},

"NativeBase.Icon":{
width:variables.iconFontSize-5,
fontSize:variables.iconFontSize-2},

"NativeBase.IconNB":{
width:variables.iconFontSize-5,
fontSize:variables.iconFontSize-2},

paddingRight:variables.listItemPadding+5,
flex:0,
height:44,
justifyContent:"center",
alignItems:"center"},

"NativeBase.Body":{
"NativeBase.Text":{
marginLeft:null,
fontSize:17},

flex:1,
height:44,
justifyContent:"center",
borderBottomWidth:1/_reactNative.PixelRatio.getPixelSizeForLayoutSize(1),
borderColor:variables.listBorderColor},

"NativeBase.Right":{
"NativeBase.Text":{
textAlign:"center",
color:"#8F8E95",
fontSize:17},

"NativeBase.IconNB":{
color:"#C8C7CC",
fontSize:variables.iconFontSize-10,
alignSelf:"center",
paddingLeft:10,
paddingTop:3},

"NativeBase.Icon":{
color:"#C8C7CC",
fontSize:variables.iconFontSize-10,
alignSelf:"center",
paddingLeft:10,
paddingTop:3},

"NativeBase.Switch":{
marginRight:_reactNative.Platform.OS==="ios"?undefined:-5,
alignSelf:null},

"NativeBase.PickerNB":_extends({},
(0,_Picker2.default)()),

flexDirection:"row",
alignItems:"center",
flex:0,
alignSelf:"stretch",
height:44,
justifyContent:"flex-end",
borderBottomWidth:1/_reactNative.PixelRatio.getPixelSizeForLayoutSize(1),
borderColor:variables.listBorderColor,
paddingRight:variables.listItemPadding+5},

borderBottomWidth:null,
paddingVertical:null,
paddingRight:null,
height:44,
justifyContent:"center"},

".noBorder":{
borderBottomWidth:null},

alignItems:"center",
flexDirection:"row",
paddingRight:variables.listItemPadding+5,
paddingVertical:variables.listItemPadding+3,
marginLeft:variables.listItemPadding+5,
borderBottomWidth:1/_reactNative.PixelRatio.getPixelSizeForLayoutSize(1),
backgroundColor:variables.listBg,
borderColor:variables.listBorderColor};


return listItemTheme;
};
//# sourceMappingURL=ListItem.js.map

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var pickerTheme={};

return pickerTheme;
};
//# sourceMappingURL=Picker.ios.js.map

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var platform=variables.platform;

var theme={
"NativeBase.Item":{
".fixedLabel":{
"NativeBase.Label":{
paddingLeft:null},

marginLeft:15},

".inlineLabel":{
"NativeBase.Label":{
paddingLeft:null},

marginLeft:15},

".placeholderLabel":{
"NativeBase.Input":{}},

".stackedLabel":{
"NativeBase.Label":{
top:5,
paddingLeft:null},

"NativeBase.Input":{
paddingLeft:null,
marginLeft:null},

"NativeBase.Icon":{
marginTop:36},

marginLeft:15},

".floatingLabel":{
"NativeBase.Input":{
paddingLeft:null,
top:10,
marginLeft:null},

"NativeBase.Label":{
left:0,
top:8},

"NativeBase.Icon":{
top:6},

marginTop:15,
marginLeft:15},

".regular":{
"NativeBase.Label":{
left:0},

marginLeft:0},

".rounded":{
"NativeBase.Label":{
left:0},

marginLeft:0},

".underline":{
"NativeBase.Label":{
left:0,
top:0,
position:"relative"},

"NativeBase.Input":{
left:-15},

marginLeft:15},

".last":{
marginLeft:0,
paddingLeft:15},

"NativeBase.Label":{
paddingRight:5},

marginLeft:15}};



return theme;
};
//# sourceMappingURL=Form.js.map

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var theme={
'.group':{
height:50,
paddingVertical:variables.listItemPadding-8,
paddingTop:variables.listItemPadding+12,
'.bordered':{
height:50,
paddingVertical:variables.listItemPadding-8,
paddingTop:variables.listItemPadding+12}},


'.bordered':{
'.noTopBorder':{
borderTopWidth:0},

'.noBottomBorder':{
borderBottomWidth:0},

height:35,
paddingTop:variables.listItemPadding+2,
paddingBottom:variables.listItemPadding,
borderBottomWidth:variables.borderWidth,
borderTopWidth:variables.borderWidth,
borderColor:variables.listBorderColor},

'NativeBase.Text':{
fontSize:variables.tabBarTextSize-2,
color:'#777'},

'.noTopBorder':{
borderTopWidth:0},

'.noBottomBorder':{
borderBottomWidth:0},

height:38,
backgroundColor:'#F0EFF5',
flex:1,
justifyContent:'center',
paddingLeft:variables.listItemPadding+5};


return theme;
};
//# sourceMappingURL=Separator.js.map

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Drawer/index.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _reactNativeDrawer=__webpack_require__(458);var _reactNativeDrawer2=_interopRequireDefault(_reactNativeDrawer);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Drawer=function(_Component){_inherits(Drawer,_Component);
function Drawer(props){_classCallCheck(this,Drawer);return _possibleConstructorReturn(this,(Drawer.__proto__||Object.getPrototypeOf(Drawer)).call(this,
props));
}_createClass(Drawer,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNativeDrawer2.default,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:10}}));
}}]);return Drawer;}(_react.Component);exports.default=Drawer;


Drawer.defaultProps={
type:"overlay",
tapToClose:true,
openDrawerOffset:0.2,
panCloseMask:0.2,
closedDrawerOffset:0,
styles:{
drawer:{
shadowColor:"#000000",
shadowOpacity:0,
shadowRadius:0,
elevation:5},

mainOverlay:{
opacity:0,
backgroundColor:"rgba(0, 0, 0, 0.8)",
elevation:8}},


tweenHandler:function tweenHandler(ratio){return{
mainOverlay:{opacity:ratio/2}};}};
//# sourceMappingURL=index.js.map

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Drawer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tweener__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tweener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tweener__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var deviceScreen=__WEBPACK_IMPORTED_MODULE_2_react_native__["Dimensions"].get('window');var DOUBLE_TAP_INTERVAL=500;var TAP_DURATION=250;var propsWhomRequireUpdate=['closedDrawerOffset','openDrawerOffset','type','styles'];var Drawer=(_temp2=_class=function(_Component){_inherits(Drawer,_Component);function Drawer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Drawer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Drawer.__proto__||Object.getPrototypeOf(Drawer)).call.apply(_ref,[this].concat(args))),_this),_this._length=0,_this._prevLength=0,_this._offsetOpen=0,_this._offsetClosed=0,_this._open=false,_this._panning=false,_this._tweenPending=false,_this._activeTween=null,_this._lastPress=0,_this._panStartTime=0,_this._syncAfterUpdate=false,_this._interactionHandle=null,_this.state={viewport:deviceScreen},_this.getChildContext=function(){return{drawer:_this};},_this.initialize=function(props){var fullLength=_this.getDeviceLength();_this._offsetClosed=_this.getClosedOffset(props,_this.state.viewport);_this._offsetOpen=_this.getOpenOffset(props,_this.state.viewport);// add function options
_this._prevLength=_this._length;var styles={container:{flex:1,justifyContent:'center',alignItems:'center'}};styles.main=Object.assign({position:'absolute',borderWidth:0},_this.isLeftOrRightSide()?{top:0}:{left:0},_this.props.styles.main);styles.drawer=Object.assign({position:'absolute',borderWidth:0},_this.isLeftOrRightSide()?{top:0}:{left:0},_this.props.styles.drawer);if(props.initializeOpen||props.open){// open
_this._open=true;_this._length=fullLength-_this._offsetOpen;styles.main[_this.props.side]=0;styles.drawer[_this.props.side]=0;if(props.type==='static')styles.main[_this.props.side]=fullLength-_this._offsetOpen;if(props.type==='displace')styles.main[_this.props.side]=fullLength-_this._offsetOpen;}else{// closed
_this._open=false;_this._length=_this._offsetClosed;styles.main[_this.props.side]=_this._offsetClosed;if(props.type==='static')styles.drawer[_this.props.side]=0;if(props.type==='overlay')styles.drawer[_this.props.side]=_this._offsetClosed+_this._offsetOpen-fullLength;if(props.type==='displace')styles.drawer[_this.props.side]=-fullLength+_this._offsetClosed+_this._offsetOpen;}if(_this.main){_this.drawer.setNativeProps({style:{left:styles.drawer.left}});_this.main.setNativeProps({style:{left:styles.main.left}});}else{_this.stylesheet=__WEBPACK_IMPORTED_MODULE_2_react_native__["StyleSheet"].create(styles);_this.responder=__WEBPACK_IMPORTED_MODULE_2_react_native__["PanResponder"].create({onStartShouldSetPanResponder:_this.onStartShouldSetPanResponder,onStartShouldSetPanResponderCapture:_this.onStartShouldSetPanResponderCapture,onMoveShouldSetPanResponder:_this.onMoveShouldSetPanResponder,onMoveShouldSetPanResponderCapture:_this.onMoveShouldSetPanResponderCapture,onPanResponderMove:_this.onPanResponderMove,onPanResponderRelease:_this.onPanResponderRelease,onPanResponderTerminate:_this.onPanResponderTerminate});}_this.resync(null,props);},_this.updatePosition=function(){var mainProps={};var drawerProps={};var ratio=(_this._length-_this._offsetClosed)/(_this.getOpenLength()-_this._offsetClosed);switch(_this.props.type){case'overlay':drawerProps[_this.props.side]=-_this.getDeviceLength()+_this._offsetOpen+_this._length;mainProps[_this.props.side]=_this._offsetClosed;break;case'static':mainProps[_this.props.side]=_this._length;drawerProps[_this.props.side]=0;break;case'displace':mainProps[_this.props.side]=_this._length;drawerProps[_this.props.side]=-_this.getDeviceLength()+_this._length+_this._offsetOpen;break;}var mainOverlayProps=null;var drawerOverlayProps=null;if(_this.props.tweenHandler){var propsFrag=_this.props.tweenHandler(ratio,_this.props.side);mainProps=Object.assign(mainProps,propsFrag.main);drawerProps=Object.assign(drawerProps,propsFrag.drawer);mainOverlayProps=propsFrag.mainOverlay;drawerOverlayProps=propsFrag.drawerOverlay;}if(_this.main&&_this.drawer&&_this.mainOverlay&&_this.drawerOverlay){_this.drawer.setNativeProps({style:drawerProps});_this.main.setNativeProps({style:mainProps});if(mainOverlayProps)_this.mainOverlay.setNativeProps({style:mainOverlayProps});if(drawerOverlayProps)_this.drawerOverlay.setNativeProps({style:drawerOverlayProps});}},_this.onPanResponderTerminate=function(e,gestureState){_this._panning=false;_this.shouldOpenDrawer(_this.getGestureDelta(gestureState))?_this.open():_this.close();},_this.onStartShouldSetPanResponderCapture=function(e,gestureState){if(_this.shouldCaptureGestures())return _this.processShouldSet(e,gestureState);return false;},_this.onStartShouldSetPanResponder=function(e,gestureState){if(!_this.shouldCaptureGestures())return _this.processShouldSet(e,gestureState);return false;},_this.onMoveShouldSetPanResponderCapture=function(e,gestureState){if(_this.shouldCaptureGestures()&&_this.props.negotiatePan)return _this.processMoveShouldSet(e,gestureState);return false;},_this.onMoveShouldSetPanResponder=function(e,gestureState){if(!_this.shouldCaptureGestures()&&_this.props.negotiatePan)return _this.processMoveShouldSet(e,gestureState);return false;},_this.onPanResponderMove=function(e,gestureState){var delta=_this.getGestureDelta(gestureState);if(!_this.props.acceptPan)return false;//Do nothing if we are panning the wrong way
if(_this._open^delta<0^_this.isRightOrBottomSide())return false;delta=_this.isRightOrBottomSide()?delta*-1:delta;var length=_this._prevLength+delta;length=Math.min(length,_this.getOpenLength());length=Math.max(length,_this.getClosedLength());_this._length=length;_this.updatePosition();_this._panning=true;},_this.onPanResponderRelease=function(e,gestureState){var delta=_this.getGestureDelta(gestureState);_this._panning=false;if(Date.now()-_this._panStartTime<TAP_DURATION)_this.processTapGestures();if(Math.abs(delta)<50&&_this._activeTween)return;_this.shouldOpenDrawer(delta)?_this.open():_this.close();_this.updatePosition();_this._prevLength=_this._length;},_this.processShouldSet=function(e,gestureState){var inMask=_this.testPanResponderMask(e,gestureState);if(!inMask)return false;_this._panStartTime=Date.now();if(inMask&&_this.shouldCaptureGestures())return true;if(_this.props.negotiatePan)return false;if(!_this.props.acceptPan)return false;_this.terminateActiveTween();return true;},_this.processMoveShouldSet=function(e,gestureState){var inMask=_this.testPanResponderMask(e,gestureState);if(!inMask)return false;if(!_this.props.acceptPan)return false;if(!_this.props.negotiatePan||_this.props.disabled||!_this.props.acceptPan||_this._panning)return false;var delta=_this.getGestureDelta(gestureState);var deltaOppositeAxis=_this.getGestureDeltaOppositeAxis(gestureState);var swipeToLeftOrTop=delta<0?true:false;var swipeToRightOrBottom=delta>0?true:false;var swipeOppositeAxis=Math.abs(deltaOppositeAxis)>=Math.abs(delta)?true:false;var swipeInCloseDirection=_this.isLeftOrTopSide()?swipeToLeftOrTop:swipeToRightOrBottom;if(swipeOppositeAxis||_this._open&&!swipeInCloseDirection||!_this._open&&swipeInCloseDirection){return false;}_this.terminateActiveTween();return true;},_this.processTapGestures=function(){if(_this._activeTween)return false;// disable tap gestures during tween
if(_this.props.acceptTap||_this.props.tapToClose&&_this._open){_this._open?_this.close():_this.open();return true;}if(_this.props.acceptDoubleTap){var now=new Date().getTime();var timeDelta=now-_this._lastPress;_this._lastPress=now;if(timeDelta<DOUBLE_TAP_INTERVAL){_this._open?_this.close():_this.open();return true;}}return false;},_this.testPanResponderMask=function(e,gestureState){if(_this.props.disabled)return false;// Disable if parent or child drawer exist and are open
// @TODO make cleaner, generalize to work with 3+ drawers, prop to disable/configure
if(_this.context.drawer&&_this.context.drawer._open)return false;if(_this._childDrawer&&_this._childDrawer._open)return false;var pos0=_this.isLeftOrRightSide()?e.nativeEvent.pageX:e.nativeEvent.pageY;var deltaOpen=_this.isLeftOrTopSide()?_this.getDeviceLength()-pos0:pos0;var deltaClose=_this.isLeftOrTopSide()?pos0:_this.getDeviceLength()-pos0;if(_this._open&&deltaOpen>_this.getOpenMask())return false;if(!_this._open&&deltaClose>_this.getClosedMask())return false;return true;},_this.terminateActiveTween=function(){if(_this._activeTween){_this._activeTween.terminate();_this._activeTween=null;}},_this.open=function(type,cb){var start=_this._length;var end=_this.getOpenLength();if(_this._activeTween)return;if(type!=='force'&&start-end===0&&_this._open===true)return;// do nothing if the delta is 0
_this.props.onOpenStart&&_this.props.onOpenStart();_this.setInteractionHandle();_this._activeTween=__WEBPACK_IMPORTED_MODULE_3__tweener___default()({start:_this._length,end:_this.getOpenLength(),duration:_this.props.tweenDuration,easingType:_this.props.tweenEasing,onFrame:function onFrame(tweenValue){_this._length=tweenValue;_this.updatePosition();},onEnd:function onEnd(){_this._activeTween=null;_this._open=true;_this._prevLength=_this._length;_this.adjustForCaptureGestures();_this.props.onOpen();_this.clearInteractionHandle();if(typeof type==='function'){type();// this is actually a callback
}else cb&&cb();}});},_this.close=function(type,cb){var start=_this._length;var end=_this.getClosedLength();if(_this._activeTween)return;if(type!=='force'&&start-end===0&&_this._open===false)return;// do nothing if the delta is 0
_this.props.onCloseStart&&_this.props.onCloseStart();_this.setInteractionHandle();_this._activeTween=__WEBPACK_IMPORTED_MODULE_3__tweener___default()({start:start,end:end,easingType:_this.props.tweenEasing,duration:_this.props.tweenDuration,onFrame:function onFrame(tweenValue){_this._length=tweenValue;_this.updatePosition();},onEnd:function onEnd(){_this._activeTween=null;_this._open=false;_this._prevLength=_this._length;_this.adjustForCaptureGestures();_this.props.onClose();_this.clearInteractionHandle();if(typeof type==='function'){type();// this is actually a callback
}else cb&&cb();}});},_this.toggle=function(){_this._open?_this.close():_this.open();},_this.handleSetViewport=function(e){var viewport=e.nativeEvent.layout;var oldViewport=_this.state.viewport;if(viewport.width===oldViewport.width&&viewport.height===oldViewport.height)return;var didRotationChange=viewport.width!==oldViewport.width;_this.resync(viewport,null,didRotationChange);},_this.resync=function(viewport,props,didRotationChange){if(didRotationChange)_this._syncAfterUpdate=true;viewport=viewport||_this.state.viewport;props=props||_this.props;_this._offsetClosed=_this.getClosedOffset(props,viewport);_this._offsetOpen=_this.getOpenOffset(props,viewport);_this.setState({viewport:viewport});},_this.requiresResync=function(nextProps){for(var i=0;i<propsWhomRequireUpdate.length;i++){var key=propsWhomRequireUpdate[i];if(_this.props[key]!==nextProps[key])return true;}},_this.getDeviceLength=function(){var viewport=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this.state.viewport;return _this.isLeftOrRightSide()?viewport.width:viewport.height;},_this.getOpenLength=function(){return _this.getDeviceLength()-_this._offsetOpen;},_this.getClosedLength=function(){return _this._offsetClosed;},_this.getMainWidth=function(){var viewport=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this.state.viewport;return _this.isLeftOrRightSide()?viewport.width-_this._offsetClosed:viewport.width;},_this.getMainHeight=function(){var viewport=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this.state.viewport;return _this.isTopOrBottomSide()?viewport.height-_this._offsetClosed:viewport.height;},_this.getDrawerWidth=function(){var viewport=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this.state.viewport;return _this.isLeftOrRightSide()?viewport.width-_this._offsetOpen:viewport.width;},_this.getDrawerHeight=function(){var viewport=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this.state.viewport;return _this.isTopOrBottomSide()?viewport.height-_this._offsetOpen:viewport.height;},_this.getOpenMask=function(){var viewport=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this.state.viewport;if(_this.props.panCloseMask&&_this.props.panCloseMask%1===0)return _this.props.panCloseMask;if(_this.props.panCloseMask)return _this.getDeviceLength(viewport)*_this.props.panCloseMask;return Math.max(0.05,_this._offsetOpen);},_this.getClosedMask=function(){if(_this.props.panOpenMask&&_this.props.panOpenMask%1===0)return _this.props.panOpenMask;if(_this.props.panOpenMask)return _this.getDeviceLength()*_this.props.panOpenMask;return Math.max(0.05,_this._offsetClosed);},_this.getOpenOffset=function(props,viewport){if(typeof props.openDrawerOffset==='function')return props.openDrawerOffset(viewport);return props.openDrawerOffset>1||props.openDrawerOffset<0?props.openDrawerOffset:props.openDrawerOffset*_this.getDeviceLength(viewport);},_this.getClosedOffset=function(props,viewport){if(typeof props.closedDrawerOffset==='function')return props.closedDrawerOffset(viewport);return props.closedDrawerOffset>1||props.closedDrawerOffset<0?props.closedDrawerOffset:props.closedDrawerOffset*_this.getDeviceLength(viewport);},_this.getGestureDelta=function(gestureState){return _this.isLeftOrRightSide()?gestureState.dx:gestureState.dy;},_this.getGestureDeltaOppositeAxis=function(gestureState){return _this.isLeftOrRightSide()?gestureState.dy:gestureState.dx;},_this.isLeftOrRightSide=function(){if(__WEBPACK_IMPORTED_MODULE_2_react_native__["I18nManager"].isRTL){return["right","left"].includes(_this.props.side);}else{return["left","right"].includes(_this.props.side);}},_this.isTopOrBottomSide=function(){return["top","bottom"].includes(_this.props.side);},_this.isLeftOrTopSide=function(){var side="left";if(__WEBPACK_IMPORTED_MODULE_2_react_native__["I18nManager"].isRTL){side="right";}return[side,"top"].includes(_this.props.side);},_this.isRightOrBottomSide=function(){var side="right";if(__WEBPACK_IMPORTED_MODULE_2_react_native__["I18nManager"].isRTL){side="left";}return[side,"bottom"].includes(_this.props.side);},_temp),_possibleConstructorReturn(_this,_ret);}/*** CONTEXT ***/_createClass(Drawer,[{key:'_registerChildDrawer',/*** END CONTEXT ***/value:function _registerChildDrawer(drawer){// Store child drawer for gesture disambiguation with multi drawer
// @TODO make cleaner, generalize to work with 3+ drawers, prop to disable/configure
this._childDrawer=drawer;}},{key:'componentWillMount',value:function componentWillMount(){if(this.context.drawer)this.context.drawer._registerChildDrawer(this);if(this.props.openDrawerThreshold&&"production"!=='production')console.error('react-native-drawer: openDrawerThreshold is obsolete. Use panThreshold instead.');if(this.props.panStartCompensation&&"production"!=='production')console.error('react-native-drawer: panStartCompensation is deprecated.');if(this.props.relativeDrag&&"production"!=='production')console.error('react-native-drawer: relativeDrag is deprecated.');this.initialize(this.props);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.requiresResync(nextProps))this.resync(null,nextProps);if(nextProps.open!==null&&this._open!==nextProps.open){this._syncAfterUpdate=true;this._open=nextProps.open;}}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this._syncAfterUpdate){this._syncAfterUpdate=false;this._open?this.open('force'):this.close('force');}}},{key:'shouldOpenDrawer',value:function shouldOpenDrawer(delta){var hasActiveHeading=this._open^delta>0^this.isRightOrBottomSide();if(!hasActiveHeading)return this._open;else return this._open^Math.abs(delta)>this.getDeviceLength()*this.props.panThreshold;}},{key:'shouldCaptureGestures',value:function shouldCaptureGestures(){if(this.props.captureGestures===true)return true;if(this.props.captureGestures==='closed'&&this._open===false)return true;if(this.props.captureGestures==='open'&&this._open===true)return true;return false;}},{key:'adjustForCaptureGestures',value:function adjustForCaptureGestures(){if(!this.props.captureGestures)return;var shouldCapture=this.shouldCaptureGestures();if(this.mainOverlay&&this.drawerOverlay){this.mainOverlay.setNativeProps({pointerEvents:shouldCapture&&this._open?'auto':'none'});this.drawerOverlay.setNativeProps({pointerEvents:shouldCapture&&!this._open?'auto':'none'});}}},{key:'setInteractionHandle',value:function setInteractionHandle(){if(this._interactionHandle)__WEBPACK_IMPORTED_MODULE_2_react_native__["InteractionManager"].clearInteractionHandle(this._interactionHandle);if(this.props.useInteractionManager)this._interactionHandle=__WEBPACK_IMPORTED_MODULE_2_react_native__["InteractionManager"].createInteractionHandle();}},{key:'clearInteractionHandle',value:function clearInteractionHandle(){if(this._interactionHandle)__WEBPACK_IMPORTED_MODULE_2_react_native__["InteractionManager"].clearInteractionHandle(this._interactionHandle);}/*** DYNAMIC GETTERS ***//*** END DYNAMIC GETTERS ***/},{key:'render',value:function render(){var first=this.props.type==='overlay'?this.renderMain():this.renderDrawer();var second=this.props.type==='overlay'?this.renderDrawer():this.renderMain();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["View"],{key:'drawerContainer',onLayout:this.handleSetViewport,style:this.stylesheet.container},first,second);}},{key:'renderMain',value:function renderMain(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["View"],Object.assign({},this.responder.panHandlers,{key:'main',ref:function ref(c){return _this2.main=c;},style:[this.stylesheet.main,{height:this.getMainHeight(),width:this.getMainWidth()}]}),this.props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["View"],{pointerEvents:this._open&&this.shouldCaptureGestures()?'auto':'none',ref:function ref(c){return _this2.mainOverlay=c;},style:[styles.overlay,this.props.styles&&this.props.styles.mainOverlay]}));}},{key:'renderDrawer',value:function renderDrawer(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["View"],Object.assign({},this.responder.panHandlers,{key:'drawer',ref:function ref(c){return _this3.drawer=c;},elevation:this.props.elevation,style:[this.stylesheet.drawer,{height:this.getDrawerHeight(),width:this.getDrawerWidth()}]}),this.props.content,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["View"],{pointerEvents:!this._open&&this.shouldCaptureGestures()?'auto':'none',ref:function ref(c){return _this3.drawerOverlay=c;},style:[styles.overlay,this.props.styles&&this.props.styles.drawerOverlay]}));}}]);return Drawer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.tweenPresets={parallax:function parallax(ratio){var side=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'left';var drawer=_defineProperty({},side,-150*(1-ratio));return{drawer:drawer};}},_class.propTypes={acceptDoubleTap:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,acceptPan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,acceptTap:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,captureGestures:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([true,false,'open','closed']),children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,closedDrawerOffset:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,elevation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,initializeOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,open:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,negotiatePan:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onCloseStart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onOpenStart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,openDrawerOffset:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),panThreshold:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,panCloseMask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,panOpenMask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,side:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left','right','top','bottom']),styles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,tapToClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,tweenDuration:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,tweenEasing:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tweenHandler:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['overlay','static','displace']),useInteractionManager:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,// deprecated
panStartCompensation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,openDrawerThreshold:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any},_class.defaultProps={open:null,initializeOpen:false,type:'displace',closedDrawerOffset:0,openDrawerOffset:0,panThreshold:0.25,// @TODO consider rename to panThreshold
panOpenMask:null,// defaults to closedDrawerOffset
panCloseMask:null,// defaults to openDrawerOffset
tweenHandler:null,tweenDuration:250,tweenEasing:'linear',disabled:false,negotiatePan:false,captureGestures:'open',acceptDoubleTap:false,acceptTap:false,acceptPan:true,tapToClose:false,styles:{},elevation:0,onOpen:function onOpen(){},onClose:function onClose(){},side:'left',useInteractionManager:false},_class.contextTypes={drawer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object},_class.childContextTypes={drawer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object},_temp2);var styles=__WEBPACK_IMPORTED_MODULE_2_react_native__["StyleSheet"].create({overlay:{right:0,left:0,top:0,bottom:0,position:'absolute',backgroundColor:'transparent'}});

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var easingTypes=__webpack_require__(460);module.exports=function(config){return new Tween(config);};function Tween(config){this._rafLoop=this._rafLoop.bind(this);this.terminate=this.terminate.bind(this);this._t0=Date.now();this._config=config;this._rafLoop();}Tween.prototype._rafLoop=function(){if(this._break){return;}var _config=this._config,duration=_config.duration,start=_config.start,end=_config.end,easingType=_config.easingType;var now=Date.now();var elapsed=now-this._t0;if(elapsed>=duration){this._config.onFrame(end);this._config.onEnd();return;}var tweenVal=easingTypes[easingType](elapsed,start,end,duration);this._config.onFrame(tweenVal);requestAnimationFrame(this._rafLoop);};Tween.prototype.terminate=function(){this._break=true;};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// t: current time, b: beginning value, _c: final value, d: total duration
var tweenFunctions = {
  linear: function(t, b, _c, d) {
    var c = _c - b;
    return c * t / d + b;
  },
  easeInQuad: function(t, b, _c, d) {
    var c = _c - b;
    return c * (t /= d) * t + b;
  },
  easeOutQuad: function(t, b, _c, d) {
    var c = _c - b;
    return -c * (t /= d) * (t - 2) + b;
  },
  easeInOutQuad: function(t, b, _c, d) {
    var c = _c - b;
    if ((t /= d / 2) < 1) {
      return c / 2 * t * t + b;
    } else {
      return -c / 2 * ((--t) * (t - 2) - 1) + b;
    }
  },
  easeInCubic: function(t, b, _c, d) {
    var c = _c - b;
    return c * (t /= d) * t * t + b;
  },
  easeOutCubic: function(t, b, _c, d) {
    var c = _c - b;
    return c * ((t = t / d - 1) * t * t + 1) + b;
  },
  easeInOutCubic: function(t, b, _c, d) {
    var c = _c - b;
    if ((t /= d / 2) < 1) {
      return c / 2 * t * t * t + b;
    } else {
      return c / 2 * ((t -= 2) * t * t + 2) + b;
    }
  },
  easeInQuart: function(t, b, _c, d) {
    var c = _c - b;
    return c * (t /= d) * t * t * t + b;
  },
  easeOutQuart: function(t, b, _c, d) {
    var c = _c - b;
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  },
  easeInOutQuart: function(t, b, _c, d) {
    var c = _c - b;
    if ((t /= d / 2) < 1) {
      return c / 2 * t * t * t * t + b;
    } else {
      return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
    }
  },
  easeInQuint: function(t, b, _c, d) {
    var c = _c - b;
    return c * (t /= d) * t * t * t * t + b;
  },
  easeOutQuint: function(t, b, _c, d) {
    var c = _c - b;
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  },
  easeInOutQuint: function(t, b, _c, d) {
    var c = _c - b;
    if ((t /= d / 2) < 1) {
      return c / 2 * t * t * t * t * t + b;
    } else {
      return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    }
  },
  easeInSine: function(t, b, _c, d) {
    var c = _c - b;
    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
  },
  easeOutSine: function(t, b, _c, d) {
    var c = _c - b;
    return c * Math.sin(t / d * (Math.PI / 2)) + b;
  },
  easeInOutSine: function(t, b, _c, d) {
    var c = _c - b;
    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
  },
  easeInExpo: function(t, b, _c, d) {
    var c = _c - b;
    return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
  },
  easeOutExpo: function(t, b, _c, d) {
    var c = _c - b;
    return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
  },
  easeInOutExpo: function(t, b, _c, d) {
    var c = _c - b;
    if (t === 0) {
      return b;
    }
    if (t === d) {
      return b + c;
    }
    if ((t /= d / 2) < 1) {
      return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
    } else {
      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    }
  },
  easeInCirc: function(t, b, _c, d) {
    var c = _c - b;
    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
  },
  easeOutCirc: function(t, b, _c, d) {
    var c = _c - b;
    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
  },
  easeInOutCirc: function(t, b, _c, d) {
    var c = _c - b;
    if ((t /= d / 2) < 1) {
      return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
    } else {
      return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
    }
  },
  easeInElastic: function(t, b, _c, d) {
    var c = _c - b;
    var a, p, s;
    s = 1.70158;
    p = 0;
    a = c;
    if (t === 0) {
      return b;
    } else if ((t /= d) === 1) {
      return b + c;
    }
    if (!p) {
      p = d * 0.3;
    }
    if (a < Math.abs(c)) {
      a = c;
      s = p / 4;
    } else {
      s = p / (2 * Math.PI) * Math.asin(c / a);
    }
    return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
  },
  easeOutElastic: function(t, b, _c, d) {
    var c = _c - b;
    var a, p, s;
    s = 1.70158;
    p = 0;
    a = c;
    if (t === 0) {
      return b;
    } else if ((t /= d) === 1) {
      return b + c;
    }
    if (!p) {
      p = d * 0.3;
    }
    if (a < Math.abs(c)) {
      a = c;
      s = p / 4;
    } else {
      s = p / (2 * Math.PI) * Math.asin(c / a);
    }
    return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
  },
  easeInOutElastic: function(t, b, _c, d) {
    var c = _c - b;
    var a, p, s;
    s = 1.70158;
    p = 0;
    a = c;
    if (t === 0) {
      return b;
    } else if ((t /= d / 2) === 2) {
      return b + c;
    }
    if (!p) {
      p = d * (0.3 * 1.5);
    }
    if (a < Math.abs(c)) {
      a = c;
      s = p / 4;
    } else {
      s = p / (2 * Math.PI) * Math.asin(c / a);
    }
    if (t < 1) {
      return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    } else {
      return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
    }
  },
  easeInBack: function(t, b, _c, d, s) {
    var c = _c - b;
    if (s === void 0) {
      s = 1.70158;
    }
    return c * (t /= d) * t * ((s + 1) * t - s) + b;
  },
  easeOutBack: function(t, b, _c, d, s) {
    var c = _c - b;
    if (s === void 0) {
      s = 1.70158;
    }
    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
  },
  easeInOutBack: function(t, b, _c, d, s) {
    var c = _c - b;
    if (s === void 0) {
      s = 1.70158;
    }
    if ((t /= d / 2) < 1) {
      return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
    } else {
      return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    }
  },
  easeInBounce: function(t, b, _c, d) {
    var c = _c - b;
    var v;
    v = tweenFunctions.easeOutBounce(d - t, 0, c, d);
    return c - v + b;
  },
  easeOutBounce: function(t, b, _c, d) {
    var c = _c - b;
    if ((t /= d) < 1 / 2.75) {
      return c * (7.5625 * t * t) + b;
    } else if (t < 2 / 2.75) {
      return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
    } else if (t < 2.5 / 2.75) {
      return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
    } else {
      return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    }
  },
  easeInOutBounce: function(t, b, _c, d) {
    var c = _c - b;
    var v;
    if (t < d / 2) {
      v = tweenFunctions.easeInBounce(t * 2, 0, c, d);
      return v * 0.5 + b;
    } else {
      v = tweenFunctions.easeOutBounce(t * 2 - d, 0, c, d);
      return v * 0.5 + c * 0.5 + b;
    }
  }
};

module.exports = tweenFunctions;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _reactNative=__webpack_require__(1);

var ViewPropTypes=_reactNative.ViewPropTypes||_reactNative.View.propTypes;exports.default=

ViewPropTypes;
//# sourceMappingURL=viewPropTypes.js.map

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.TabHeading=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/TabHeading.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

TabHeadingNB=function(_Component){_inherits(TabHeadingNB,_Component);function TabHeadingNB(){_classCallCheck(this,TabHeadingNB);return _possibleConstructorReturn(this,(TabHeadingNB.__proto__||Object.getPrototypeOf(TabHeadingNB)).apply(this,arguments));}_createClass(TabHeadingNB,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:10}}));
}}]);return TabHeadingNB;}(_react.Component);


TabHeadingNB.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledTabHeadingNB=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.TabHeading",{},_mapPropsToStyleNames2.default)(TabHeadingNB);exports.
TabHeading=StyledTabHeadingNB;
//# sourceMappingURL=TabHeading.js.map

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.TabContainer=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/TabContainer.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

TabContainer=function(_Component){_inherits(TabContainer,_Component);function TabContainer(){_classCallCheck(this,TabContainer);return _possibleConstructorReturn(this,(TabContainer.__proto__||Object.getPrototypeOf(TabContainer)).apply(this,arguments));}_createClass(TabContainer,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:10}}));
}}]);return TabContainer;}(_react.Component);


TabContainer.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledTabContainer=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.TabContainer",{},_mapPropsToStyleNames2.default)(TabContainer);exports.
TabContainer=StyledTabContainer;
//# sourceMappingURL=TabContainer.js.map

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=createIconButtonComponent;var _isString=__webpack_require__(465);var _isString2=_interopRequireDefault(_isString);var _omit=__webpack_require__(468);var _omit2=_interopRequireDefault(_omit);var _pick=__webpack_require__(124);var _pick2=_interopRequireDefault(_pick);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);var _reactNative=__webpack_require__(75);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=_reactNative.StyleSheet.create({container:{flexDirection:'row',justifyContent:'flex-start',alignItems:'center',padding:8},touchable:{overflow:'hidden'},icon:{marginRight:10},text:{fontWeight:'600',backgroundColor:'transparent'}});var IOS7_BLUE='#007AFF';function createIconButtonComponent(Icon){var _class,_temp;return _temp=_class=function(_Component){_inherits(IconButton,_Component);function IconButton(){_classCallCheck(this,IconButton);return _possibleConstructorReturn(this,(IconButton.__proto__||Object.getPrototypeOf(IconButton)).apply(this,arguments));}_createClass(IconButton,[{key:'render',value:function render(){var _props=this.props,style=_props.style,iconStyle=_props.iconStyle,children=_props.children,restProps=_objectWithoutProperties(_props,['style','iconStyle','children']);var iconProps=(0,_pick2.default)(restProps,Object.keys(_reactNative.Text.propTypes),'style','name','size','color');var touchableProps=(0,_pick2.default)(restProps,Object.keys(_reactNative.TouchableHighlight.propTypes));var props=(0,_omit2.default)(restProps,Object.keys(iconProps),Object.keys(touchableProps),'iconStyle','borderRadius','backgroundColor');iconProps.style=iconStyle?[styles.icon,iconStyle]:styles.icon;var colorStyle=(0,_pick2.default)(this.props,'color');var blockStyle=(0,_pick2.default)(this.props,'backgroundColor','borderRadius');return _react2.default.createElement(_reactNative.TouchableHighlight,_extends({style:[styles.touchable,blockStyle]},touchableProps),_react2.default.createElement(_reactNative.View,_extends({style:[styles.container,blockStyle,style]},props),_react2.default.createElement(Icon,iconProps),(0,_isString2.default)(children)?_react2.default.createElement(_reactNative.Text,{style:[styles.text,colorStyle]},children):children));}}]);return IconButton;}(_react.Component),_class.propTypes={backgroundColor:_propTypes2.default.string,borderRadius:_propTypes2.default.number,color:_propTypes2.default.string,size:_propTypes2.default.number,iconStyle:_propTypes2.default.any,style:_propTypes2.default.any,children:_propTypes2.default.node},_class.defaultProps={backgroundColor:IOS7_BLUE,borderRadius:5,color:'white',size:20},_temp;}

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isArray = __webpack_require__(20),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(45);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 467 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(187),
    baseClone = __webpack_require__(469),
    baseUnset = __webpack_require__(530),
    castPath = __webpack_require__(47),
    copyObject = __webpack_require__(59),
    customOmitClone = __webpack_require__(540),
    flatRest = __webpack_require__(209),
    getAllKeysIn = __webpack_require__(202);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(188),
    arrayEach = __webpack_require__(496),
    assignValue = __webpack_require__(112),
    baseAssign = __webpack_require__(497),
    baseAssignIn = __webpack_require__(506),
    cloneBuffer = __webpack_require__(509),
    copyArray = __webpack_require__(510),
    copySymbols = __webpack_require__(511),
    copySymbolsIn = __webpack_require__(513),
    getAllKeys = __webpack_require__(200),
    getAllKeysIn = __webpack_require__(202),
    getTag = __webpack_require__(203),
    initCloneArray = __webpack_require__(518),
    initCloneByTag = __webpack_require__(519),
    initCloneObject = __webpack_require__(528),
    isArray = __webpack_require__(20),
    isBuffer = __webpack_require__(115),
    isObject = __webpack_require__(46),
    keys = __webpack_require__(113);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 470 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(77);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(77);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(77);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(77);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(76);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 476 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 477 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 478 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(76),
    Map = __webpack_require__(110),
    MapCache = __webpack_require__(111);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(189),
    isMasked = __webpack_require__(481),
    isObject = __webpack_require__(46),
    toSource = __webpack_require__(190);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(482);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(19);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 483 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(485),
    ListCache = __webpack_require__(76),
    Map = __webpack_require__(110);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(486),
    hashDelete = __webpack_require__(487),
    hashGet = __webpack_require__(488),
    hashHas = __webpack_require__(489),
    hashSet = __webpack_require__(490);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(78);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 487 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(78);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(78);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(78);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(79);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 492 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(79);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(79);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(79);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 496 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(59),
    keys = __webpack_require__(113);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 498 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 500 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    isLength = __webpack_require__(117),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 502 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(186);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(118),
    nativeKeys = __webpack_require__(505);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(195);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(59),
    keysIn = __webpack_require__(197);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(46),
    isPrototype = __webpack_require__(118),
    nativeKeysIn = __webpack_require__(508);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 508 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(19);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),
/* 510 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(59),
    getSymbols = __webpack_require__(119);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 512 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(59),
    getSymbolsIn = __webpack_require__(199);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(38),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(38),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(38),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(38),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 518 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(122),
    cloneDataView = __webpack_require__(520),
    cloneMap = __webpack_require__(521),
    cloneRegExp = __webpack_require__(523),
    cloneSet = __webpack_require__(524),
    cloneSymbol = __webpack_require__(526),
    cloneTypedArray = __webpack_require__(527);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(122);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(522),
    arrayReduce = __webpack_require__(205),
    mapToArray = __webpack_require__(206);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 522 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 523 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(525),
    arrayReduce = __webpack_require__(205),
    setToArray = __webpack_require__(207);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 525 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(45);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(122);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(529),
    getPrototype = __webpack_require__(121),
    isPrototype = __webpack_require__(118);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(46);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(47),
    last = __webpack_require__(537),
    parent = __webpack_require__(538),
    toKey = __webpack_require__(80);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(20),
    isSymbol = __webpack_require__(123);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(533);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(534);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(111);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(536);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(45),
    arrayMap = __webpack_require__(187),
    isArray = __webpack_require__(20),
    isSymbol = __webpack_require__(123);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 537 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(208),
    baseSlice = __webpack_require__(539);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 539 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(541);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(36),
    getPrototype = __webpack_require__(121),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(543);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(120),
    isFlattenable = __webpack_require__(544);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(45),
    isArguments = __webpack_require__(114),
    isArray = __webpack_require__(20);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(546);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 546 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(548),
    shortOut = __webpack_require__(551);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(549),
    defineProperty = __webpack_require__(192),
    identity = __webpack_require__(550);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 549 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 550 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 551 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(553),
    hasIn = __webpack_require__(555);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(208),
    baseSet = __webpack_require__(554),
    castPath = __webpack_require__(47);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(112),
    castPath = __webpack_require__(47),
    isIndex = __webpack_require__(116),
    isObject = __webpack_require__(46),
    toKey = __webpack_require__(80);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(556),
    hasPath = __webpack_require__(557);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 556 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(47),
    isArguments = __webpack_require__(114),
    isArray = __webpack_require__(20),
    isIndex = __webpack_require__(116),
    isLength = __webpack_require__(117),
    toKey = __webpack_require__(80);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=createTabBarItemIOSComponent;var _isEqual=__webpack_require__(210);var _isEqual2=_interopRequireDefault(_isEqual);var _pick=__webpack_require__(124);var _pick2=_interopRequireDefault(_pick);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);var _reactNative=__webpack_require__(75);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function createTabBarItemIOSComponent(IconNamePropType,getImageSource){var _class,_temp;return _temp=_class=function(_Component){_inherits(TabBarItemIOS,_Component);function TabBarItemIOS(){_classCallCheck(this,TabBarItemIOS);return _possibleConstructorReturn(this,(TabBarItemIOS.__proto__||Object.getPrototypeOf(TabBarItemIOS)).apply(this,arguments));}_createClass(TabBarItemIOS,[{key:'componentWillMount',value:function componentWillMount(){this.updateIconSources(this.props);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var keys=Object.keys(TabBarItemIOS.propTypes);if(!(0,_isEqual2.default)((0,_pick2.default)(nextProps,keys),(0,_pick2.default)(this.props,keys))){this.updateIconSources(nextProps);}}},{key:'updateIconSources',value:function updateIconSources(props){var _this2=this;if(props.iconName){getImageSource(props.iconName,props.iconSize,props.iconColor).then(function(icon){return _this2.setState({icon:icon});});}if(props.selectedIconName||props.selectedIconColor){var selectedIconName=props.selectedIconName||props.iconName;var selectedIconColor=props.selectedIconColor||props.iconColor;getImageSource(selectedIconName,props.iconSize,selectedIconColor).then(function(selectedIcon){return _this2.setState({selectedIcon:selectedIcon});});}}},{key:'render',value:function render(){return _react2.default.createElement(_reactNative.TabBarIOS.Item,_extends({},this.props,this.state));}}]);return TabBarItemIOS;}(_react.Component),_class.propTypes={iconName:IconNamePropType.isRequired,selectedIconName:IconNamePropType,iconSize:_propTypes2.default.number,iconColor:_propTypes2.default.string,selectedIconColor:_propTypes2.default.string},_class.defaultProps={iconSize:30},_temp;}

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(560),
    isObjectLike = __webpack_require__(37);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(188),
    equalArrays = __webpack_require__(211),
    equalByTag = __webpack_require__(566),
    equalObjects = __webpack_require__(567),
    getTag = __webpack_require__(203),
    isArray = __webpack_require__(20),
    isBuffer = __webpack_require__(115),
    isTypedArray = __webpack_require__(194);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(111),
    setCacheAdd = __webpack_require__(562),
    setCacheHas = __webpack_require__(563);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 562 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 563 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 564 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 565 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(45),
    Uint8Array = __webpack_require__(204),
    eq = __webpack_require__(109),
    equalArrays = __webpack_require__(211),
    mapToArray = __webpack_require__(206),
    setToArray = __webpack_require__(207);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(200);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=createToolbarAndroidComponent;var _isEqual=__webpack_require__(210);var _isEqual2=_interopRequireDefault(_isEqual);var _pick=__webpack_require__(124);var _pick2=_interopRequireDefault(_pick);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);var _reactNative=__webpack_require__(75);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function createToolbarAndroidComponent(IconNamePropType,getImageSource){var _class,_temp;return _temp=_class=function(_Component){_inherits(IconToolbarAndroid,_Component);function IconToolbarAndroid(){_classCallCheck(this,IconToolbarAndroid);return _possibleConstructorReturn(this,(IconToolbarAndroid.__proto__||Object.getPrototypeOf(IconToolbarAndroid)).apply(this,arguments));}_createClass(IconToolbarAndroid,[{key:'componentWillMount',value:function componentWillMount(){this.updateIconSources(this.props);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;var keys=Object.keys(IconToolbarAndroid.propTypes);if(!(0,_isEqual2.default)((0,_pick2.default)(nextProps,keys),(0,_pick2.default)(this.props,keys))){var stateToEvict={};if(!nextProps.logoName){stateToEvict.logo=undefined;}if(!nextProps.navIconName){stateToEvict.navIcon=undefined;}if(!nextProps.overflowIconName){stateToEvict.overflowIcon=undefined;}if(this.state&&Object.keys(stateToEvict).length){this.setState(stateToEvict,function(){return _this2.updateIconSources(nextProps);});}else{this.updateIconSources(nextProps);}}}},{key:'updateIconSources',value:function updateIconSources(props){var _this3=this;var size=props.iconSize;var color=props.iconColor||props.titleColor;if(props.logoName){getImageSource(props.logoName,size,color).then(function(logo){return _this3.setState({logo:logo});});}if(props.navIconName){getImageSource(props.navIconName,size,color).then(function(navIcon){return _this3.setState({navIcon:navIcon});});}if(props.overflowIconName){getImageSource(props.overflowIconName,size,color).then(function(overflowIcon){return _this3.setState({overflowIcon:overflowIcon});});}Promise.all((props.actions||[]).map(function(action){if(action.iconName){return getImageSource(action.iconName,action.iconSize||size,action.iconColor||color).then(function(icon){return _extends({},action,{icon:icon});});}return Promise.resolve(action);})).then(function(actions){return _this3.setState({actions:actions});});}},{key:'render',value:function render(){return _react2.default.createElement(_reactNative.ToolbarAndroid,_extends({},this.props,this.state));}}]);return IconToolbarAndroid;}(_react.Component),_class.propTypes={logoName:IconNamePropType,navIconName:IconNamePropType,overflowIconName:IconNamePropType,actions:_propTypes2.default.arrayOf(_propTypes2.default.shape({title:_propTypes2.default.string.isRequired,iconName:IconNamePropType,iconSize:_propTypes2.default.number,iconColor:_propTypes2.default.string,show:_propTypes2.default.oneOf(['always','ifRoom','never']),showWithText:_propTypes2.default.bool})),iconSize:_propTypes2.default.number,iconColor:_propTypes2.default.string},_class.defaultProps={iconSize:24},_temp;}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports = {"ios-add":61698,"ios-add-circle":61697,"ios-add-circle-outline":61696,"ios-add-outline":61698,"ios-alarm":62408,"ios-alarm-outline":62407,"ios-albums":62410,"ios-albums-outline":62409,"ios-alert":61700,"ios-alert-outline":61699,"ios-american-football":61702,"ios-american-football-outline":61701,"ios-analytics":62414,"ios-analytics-outline":62413,"ios-aperture":61704,"ios-aperture-outline":61703,"ios-apps":61706,"ios-apps-outline":61705,"ios-appstore":61708,"ios-appstore-outline":61707,"ios-archive":61710,"ios-archive-outline":61709,"ios-arrow-back":62415,"ios-arrow-back-outline":62415,"ios-arrow-down":62416,"ios-arrow-down-outline":62416,"ios-arrow-dropdown":61712,"ios-arrow-dropdown-circle":61711,"ios-arrow-dropdown-circle-outline":61711,"ios-arrow-dropdown-outline":61712,"ios-arrow-dropleft":61714,"ios-arrow-dropleft-circle":61713,"ios-arrow-dropleft-circle-outline":61713,"ios-arrow-dropleft-outline":61714,"ios-arrow-dropright":61716,"ios-arrow-dropright-circle":61715,"ios-arrow-dropright-circle-outline":61715,"ios-arrow-dropright-outline":61716,"ios-arrow-dropup":61718,"ios-arrow-dropup-circle":61717,"ios-arrow-dropup-circle-outline":61717,"ios-arrow-dropup-outline":61718,"ios-arrow-forward":62417,"ios-arrow-forward-outline":62417,"ios-arrow-round-back":61719,"ios-arrow-round-back-outline":61719,"ios-arrow-round-down":61720,"ios-arrow-round-down-outline":61720,"ios-arrow-round-forward":61721,"ios-arrow-round-forward-outline":61721,"ios-arrow-round-up":61722,"ios-arrow-round-up-outline":61722,"ios-arrow-up":62424,"ios-arrow-up-outline":62424,"ios-at":62426,"ios-at-outline":62425,"ios-attach":61723,"ios-attach-outline":61723,"ios-backspace":61725,"ios-backspace-outline":61724,"ios-barcode":62428,"ios-barcode-outline":62427,"ios-baseball":62430,"ios-baseball-outline":62429,"ios-basket":61727,"ios-basket-outline":61726,"ios-basketball":62432,"ios-basketball-outline":62431,"ios-battery-charging":61728,"ios-battery-charging-outline":61728,"ios-battery-dead":61729,"ios-battery-dead-outline":61729,"ios-battery-full":61730,"ios-battery-full-outline":61730,"ios-beaker":61732,"ios-beaker-outline":61731,"ios-beer":61734,"ios-beer-outline":61733,"ios-bicycle":61735,"ios-bicycle-outline":61735,"ios-bluetooth":61736,"ios-bluetooth-outline":61736,"ios-boat":61738,"ios-boat-outline":61737,"ios-body":62436,"ios-body-outline":62435,"ios-bonfire":61740,"ios-bonfire-outline":61739,"ios-book":62440,"ios-book-outline":62439,"ios-bookmark":61742,"ios-bookmark-outline":61741,"ios-bookmarks":62442,"ios-bookmarks-outline":62441,"ios-bowtie":61744,"ios-bowtie-outline":61743,"ios-briefcase":62446,"ios-briefcase-outline":62445,"ios-browsers":62448,"ios-browsers-outline":62447,"ios-brush":61746,"ios-brush-outline":61745,"ios-bug":61748,"ios-bug-outline":61747,"ios-build":61750,"ios-build-outline":61749,"ios-bulb":61752,"ios-bulb-outline":61751,"ios-bus":61754,"ios-bus-outline":61753,"ios-cafe":61756,"ios-cafe-outline":61755,"ios-calculator":62450,"ios-calculator-outline":62449,"ios-calendar":62452,"ios-calendar-outline":62451,"ios-call":61758,"ios-call-outline":61757,"ios-camera":62454,"ios-camera-outline":62453,"ios-car":61760,"ios-car-outline":61759,"ios-card":61762,"ios-card-outline":61761,"ios-cart":62456,"ios-cart-outline":62455,"ios-cash":61764,"ios-cash-outline":61763,"ios-chatboxes":62458,"ios-chatboxes-outline":62457,"ios-chatbubbles":61766,"ios-chatbubbles-outline":61765,"ios-checkbox":61768,"ios-checkbox-outline":61767,"ios-checkmark":62463,"ios-checkmark-circle":61770,"ios-checkmark-circle-outline":61769,"ios-checkmark-outline":62463,"ios-clipboard":61772,"ios-clipboard-outline":61771,"ios-clock":62467,"ios-clock-outline":62466,"ios-close":62470,"ios-close-circle":61774,"ios-close-circle-outline":61773,"ios-close-outline":62470,"ios-closed-captioning":61776,"ios-closed-captioning-outline":61775,"ios-cloud":62476,"ios-cloud-circle":61778,"ios-cloud-circle-outline":61777,"ios-cloud-done":61780,"ios-cloud-done-outline":61779,"ios-cloud-download":62472,"ios-cloud-download-outline":62471,"ios-cloud-outline":62473,"ios-cloud-upload":62475,"ios-cloud-upload-outline":62474,"ios-cloudy":62480,"ios-cloudy-night":62478,"ios-cloudy-night-outline":62477,"ios-cloudy-outline":62479,"ios-code":61783,"ios-code-download":61781,"ios-code-download-outline":61781,"ios-code-outline":61783,"ios-code-working":61782,"ios-code-working-outline":61782,"ios-cog":62482,"ios-cog-outline":62481,"ios-color-fill":61785,"ios-color-fill-outline":61784,"ios-color-filter":62484,"ios-color-filter-outline":62483,"ios-color-palette":61787,"ios-color-palette-outline":61786,"ios-color-wand":62486,"ios-color-wand-outline":62485,"ios-compass":61789,"ios-compass-outline":61788,"ios-construct":61791,"ios-construct-outline":61790,"ios-contact":62490,"ios-contact-outline":62489,"ios-contacts":61793,"ios-contacts-outline":61792,"ios-contract":61794,"ios-contract-outline":61794,"ios-contrast":61795,"ios-contrast-outline":61795,"ios-copy":62492,"ios-copy-outline":62491,"ios-create":61797,"ios-create-outline":61796,"ios-crop":62494,"ios-crop-outline":61798,"ios-cube":61800,"ios-cube-outline":61799,"ios-cut":61802,"ios-cut-outline":61801,"ios-desktop":61804,"ios-desktop-outline":61803,"ios-disc":61806,"ios-disc-outline":61805,"ios-document":61808,"ios-document-outline":61807,"ios-done-all":61809,"ios-done-all-outline":61809,"ios-download":62496,"ios-download-outline":62495,"ios-easel":61811,"ios-easel-outline":61810,"ios-egg":61813,"ios-egg-outline":61812,"ios-exit":61815,"ios-exit-outline":61814,"ios-expand":61816,"ios-expand-outline":61816,"ios-eye":62501,"ios-eye-off":61818,"ios-eye-off-outline":61817,"ios-eye-outline":62500,"ios-fastforward":62503,"ios-fastforward-outline":62502,"ios-female":61819,"ios-female-outline":61819,"ios-filing":62505,"ios-filing-outline":62504,"ios-film":62507,"ios-film-outline":62506,"ios-finger-print":61820,"ios-finger-print-outline":61820,"ios-flag":62509,"ios-flag-outline":62508,"ios-flame":62511,"ios-flame-outline":62510,"ios-flash":61822,"ios-flash-outline":61821,"ios-flask":62513,"ios-flask-outline":62512,"ios-flower":62515,"ios-flower-outline":62514,"ios-folder":62517,"ios-folder-open":61824,"ios-folder-open-outline":61823,"ios-folder-outline":62516,"ios-football":62519,"ios-football-outline":62518,"ios-funnel":61826,"ios-funnel-outline":61825,"ios-game-controller-a":62521,"ios-game-controller-a-outline":62520,"ios-game-controller-b":62523,"ios-game-controller-b-outline":62522,"ios-git-branch":61827,"ios-git-branch-outline":61827,"ios-git-commit":61828,"ios-git-commit-outline":61828,"ios-git-compare":61829,"ios-git-compare-outline":61829,"ios-git-merge":61830,"ios-git-merge-outline":61830,"ios-git-network":61831,"ios-git-network-outline":61831,"ios-git-pull-request":61832,"ios-git-pull-request-outline":61832,"ios-glasses":62527,"ios-glasses-outline":62526,"ios-globe":61834,"ios-globe-outline":61833,"ios-grid":61836,"ios-grid-outline":61835,"ios-hammer":61838,"ios-hammer-outline":61837,"ios-hand":61840,"ios-hand-outline":61839,"ios-happy":61842,"ios-happy-outline":61841,"ios-headset":61844,"ios-headset-outline":61843,"ios-heart":62531,"ios-heart-outline":62530,"ios-help":62534,"ios-help-buoy":61846,"ios-help-buoy-outline":61845,"ios-help-circle":61848,"ios-help-circle-outline":61847,"ios-help-outline":62534,"ios-home":62536,"ios-home-outline":62535,"ios-ice-cream":61850,"ios-ice-cream-outline":61849,"ios-image":61852,"ios-image-outline":61851,"ios-images":61854,"ios-images-outline":61853,"ios-infinite":62538,"ios-infinite-outline":62537,"ios-information":62541,"ios-information-circle":61856,"ios-information-circle-outline":61855,"ios-information-outline":62541,"ios-ionic":61857,"ios-ionic-outline":62542,"ios-ionitron":61859,"ios-ionitron-outline":61858,"ios-jet":61861,"ios-jet-outline":61860,"ios-key":61863,"ios-key-outline":61862,"ios-keypad":62544,"ios-keypad-outline":62543,"ios-laptop":61864,"ios-laptop-outline":61864,"ios-leaf":61866,"ios-leaf-outline":61865,"ios-link":61994,"ios-link-outline":61898,"ios-list":62548,"ios-list-box":61868,"ios-list-box-outline":61867,"ios-list-outline":62548,"ios-locate":61870,"ios-locate-outline":61869,"ios-lock":61872,"ios-lock-outline":61871,"ios-log-in":61873,"ios-log-in-outline":61873,"ios-log-out":61874,"ios-log-out-outline":61874,"ios-magnet":61876,"ios-magnet-outline":61875,"ios-mail":61880,"ios-mail-open":61878,"ios-mail-open-outline":61877,"ios-mail-outline":61879,"ios-male":61881,"ios-male-outline":61881,"ios-man":61883,"ios-man-outline":61882,"ios-map":61885,"ios-map-outline":61884,"ios-medal":61887,"ios-medal-outline":61886,"ios-medical":62556,"ios-medical-outline":62555,"ios-medkit":62558,"ios-medkit-outline":62557,"ios-megaphone":61889,"ios-megaphone-outline":61888,"ios-menu":61891,"ios-menu-outline":61890,"ios-mic":62561,"ios-mic-off":62559,"ios-mic-off-outline":61892,"ios-mic-outline":62560,"ios-microphone":61894,"ios-microphone-outline":61893,"ios-moon":62568,"ios-moon-outline":62567,"ios-more":61896,"ios-more-outline":61895,"ios-move":61899,"ios-move-outline":61899,"ios-musical-note":62571,"ios-musical-note-outline":61900,"ios-musical-notes":62572,"ios-musical-notes-outline":61901,"ios-navigate":62574,"ios-navigate-outline":62573,"ios-no-smoking":61903,"ios-no-smoking-outline":61902,"ios-notifications":61907,"ios-notifications-off":61905,"ios-notifications-off-outline":61904,"ios-notifications-outline":61906,"ios-nuclear":61909,"ios-nuclear-outline":61908,"ios-nutrition":62576,"ios-nutrition-outline":62575,"ios-open":61911,"ios-open-outline":61910,"ios-options":61913,"ios-options-outline":61912,"ios-outlet":61915,"ios-outlet-outline":61914,"ios-paper":62578,"ios-paper-outline":62577,"ios-paper-plane":61917,"ios-paper-plane-outline":61916,"ios-partly-sunny":61919,"ios-partly-sunny-outline":61918,"ios-pause":62584,"ios-pause-outline":62583,"ios-paw":62586,"ios-paw-outline":62585,"ios-people":62588,"ios-people-outline":62587,"ios-person":62590,"ios-person-add":61921,"ios-person-add-outline":61920,"ios-person-outline":62589,"ios-phone-landscape":61922,"ios-phone-landscape-outline":61922,"ios-phone-portrait":61923,"ios-phone-portrait-outline":61923,"ios-photos":62594,"ios-photos-outline":62593,"ios-pie":62596,"ios-pie-outline":62595,"ios-pin":61925,"ios-pin-outline":61924,"ios-pint":62598,"ios-pint-outline":62597,"ios-pizza":61927,"ios-pizza-outline":61926,"ios-plane":61929,"ios-plane-outline":61928,"ios-planet":61931,"ios-planet-outline":61930,"ios-play":62600,"ios-play-outline":62599,"ios-podium":61933,"ios-podium-outline":61932,"ios-power":61935,"ios-power-outline":61934,"ios-pricetag":62605,"ios-pricetag-outline":62604,"ios-pricetags":62607,"ios-pricetags-outline":62606,"ios-print":61937,"ios-print-outline":61936,"ios-pulse":62611,"ios-pulse-outline":61938,"ios-qr-scanner":61939,"ios-qr-scanner-outline":61939,"ios-quote":61941,"ios-quote-outline":61940,"ios-radio":61945,"ios-radio-button-off":61942,"ios-radio-button-off-outline":61942,"ios-radio-button-on":61943,"ios-radio-button-on-outline":61943,"ios-radio-outline":61944,"ios-rainy":62613,"ios-rainy-outline":62612,"ios-recording":62615,"ios-recording-outline":62614,"ios-redo":62617,"ios-redo-outline":62616,"ios-refresh":62620,"ios-refresh-circle":61990,"ios-refresh-circle-outline":61988,"ios-refresh-outline":62620,"ios-remove":61948,"ios-remove-circle":61947,"ios-remove-circle-outline":61946,"ios-remove-outline":61948,"ios-reorder":61949,"ios-reorder-outline":61949,"ios-repeat":61950,"ios-repeat-outline":61950,"ios-resize":61951,"ios-resize-outline":61951,"ios-restaurant":61953,"ios-restaurant-outline":61952,"ios-return-left":61954,"ios-return-left-outline":61954,"ios-return-right":61955,"ios-return-right-outline":61955,"ios-reverse-camera":62623,"ios-reverse-camera-outline":62622,"ios-rewind":62625,"ios-rewind-outline":62624,"ios-ribbon":61957,"ios-ribbon-outline":61956,"ios-rose":62627,"ios-rose-outline":62626,"ios-sad":61959,"ios-sad-outline":61958,"ios-school":61961,"ios-school-outline":61960,"ios-search":62629,"ios-search-outline":61962,"ios-send":61964,"ios-send-outline":61963,"ios-settings":62631,"ios-settings-outline":61965,"ios-share":61969,"ios-share-alt":61967,"ios-share-alt-outline":61966,"ios-share-outline":61968,"ios-shirt":61971,"ios-shirt-outline":61970,"ios-shuffle":62633,"ios-shuffle-outline":62633,"ios-skip-backward":61973,"ios-skip-backward-outline":61972,"ios-skip-forward":61975,"ios-skip-forward-outline":61974,"ios-snow":61976,"ios-snow-outline":61996,"ios-speedometer":62640,"ios-speedometer-outline":62639,"ios-square":61978,"ios-square-outline":61977,"ios-star":62643,"ios-star-half":62641,"ios-star-half-outline":62641,"ios-star-outline":62642,"ios-stats":61980,"ios-stats-outline":61979,"ios-stopwatch":62645,"ios-stopwatch-outline":62644,"ios-subway":61982,"ios-subway-outline":61981,"ios-sunny":62647,"ios-sunny-outline":62646,"ios-swap":61983,"ios-swap-outline":61983,"ios-switch":61985,"ios-switch-outline":61984,"ios-sync":61986,"ios-sync-outline":61986,"ios-tablet-landscape":61987,"ios-tablet-landscape-outline":61987,"ios-tablet-portrait":62030,"ios-tablet-portrait-outline":62030,"ios-tennisball":62651,"ios-tennisball-outline":62650,"ios-text":62032,"ios-text-outline":62031,"ios-thermometer":62034,"ios-thermometer-outline":62033,"ios-thumbs-down":62036,"ios-thumbs-down-outline":62035,"ios-thumbs-up":62038,"ios-thumbs-up-outline":62037,"ios-thunderstorm":62653,"ios-thunderstorm-outline":62652,"ios-time":62655,"ios-time-outline":62654,"ios-timer":62657,"ios-timer-outline":62656,"ios-train":62040,"ios-train-outline":62039,"ios-transgender":62041,"ios-transgender-outline":62041,"ios-trash":62661,"ios-trash-outline":62660,"ios-trending-down":62042,"ios-trending-down-outline":62042,"ios-trending-up":62043,"ios-trending-up-outline":62043,"ios-trophy":62045,"ios-trophy-outline":62044,"ios-umbrella":62047,"ios-umbrella-outline":62046,"ios-undo":62663,"ios-undo-outline":62662,"ios-unlock":62049,"ios-unlock-outline":62048,"ios-videocam":62669,"ios-videocam-outline":62668,"ios-volume-down":62050,"ios-volume-down-outline":62050,"ios-volume-mute":62051,"ios-volume-mute-outline":62051,"ios-volume-off":62052,"ios-volume-off-outline":62052,"ios-volume-up":62053,"ios-volume-up-outline":62053,"ios-walk":62054,"ios-walk-outline":62054,"ios-warning":62056,"ios-warning-outline":62055,"ios-watch":62057,"ios-watch-outline":62057,"ios-water":62059,"ios-water-outline":62058,"ios-wifi":62061,"ios-wifi-outline":62060,"ios-wine":62063,"ios-wine-outline":62062,"ios-woman":62065,"ios-woman-outline":62064,"logo-android":61989,"logo-angular":61991,"logo-apple":61993,"logo-bitcoin":61995,"logo-buffer":61997,"logo-chrome":61999,"logo-codepen":62000,"logo-css3":62001,"logo-designernews":62002,"logo-dribbble":62003,"logo-dropbox":62004,"logo-euro":62005,"logo-facebook":62006,"logo-foursquare":62007,"logo-freebsd-devil":62008,"logo-github":62009,"logo-google":62010,"logo-googleplus":62011,"logo-hackernews":62012,"logo-html5":62013,"logo-instagram":62014,"logo-javascript":62015,"logo-linkedin":62016,"logo-markdown":62017,"logo-nodejs":62018,"logo-octocat":62019,"logo-pinterest":62020,"logo-playstation":62021,"logo-python":62022,"logo-reddit":62023,"logo-rss":62024,"logo-sass":62025,"logo-skype":62026,"logo-snapchat":62027,"logo-steam":62028,"logo-tumblr":62029,"logo-tux":62126,"logo-twitch":62127,"logo-twitter":62128,"logo-usd":62129,"logo-vimeo":62148,"logo-whatsapp":62149,"logo-windows":62255,"logo-wordpress":62256,"logo-xbox":62284,"logo-yahoo":62285,"logo-yen":62286,"logo-youtube":62287,"md-add":62067,"md-add-circle":62066,"md-alarm":62068,"md-albums":62069,"md-alert":62070,"md-american-football":62071,"md-analytics":62072,"md-aperture":62073,"md-apps":62074,"md-appstore":62075,"md-archive":62076,"md-arrow-back":62077,"md-arrow-down":62078,"md-arrow-dropdown":62080,"md-arrow-dropdown-circle":62079,"md-arrow-dropleft":62082,"md-arrow-dropleft-circle":62081,"md-arrow-dropright":62084,"md-arrow-dropright-circle":62083,"md-arrow-dropup":62086,"md-arrow-dropup-circle":62085,"md-arrow-forward":62087,"md-arrow-round-back":62088,"md-arrow-round-down":62089,"md-arrow-round-forward":62090,"md-arrow-round-up":62091,"md-arrow-up":62092,"md-at":62093,"md-attach":62094,"md-backspace":62095,"md-barcode":62096,"md-baseball":62097,"md-basket":62098,"md-basketball":62099,"md-battery-charging":62100,"md-battery-dead":62101,"md-battery-full":62102,"md-beaker":62103,"md-beer":62104,"md-bicycle":62105,"md-bluetooth":62106,"md-boat":62107,"md-body":62108,"md-bonfire":62109,"md-book":62110,"md-bookmark":62111,"md-bookmarks":62112,"md-bowtie":62113,"md-briefcase":62114,"md-browsers":62115,"md-brush":62116,"md-bug":62117,"md-build":62118,"md-bulb":62119,"md-bus":62120,"md-cafe":62121,"md-calculator":62122,"md-calendar":62123,"md-call":62124,"md-camera":62125,"md-car":62130,"md-card":62131,"md-cart":62132,"md-cash":62133,"md-chatboxes":62134,"md-chatbubbles":62135,"md-checkbox":62137,"md-checkbox-outline":62136,"md-checkmark":62140,"md-checkmark-circle":62139,"md-checkmark-circle-outline":62138,"md-clipboard":62141,"md-clock":62142,"md-close":62144,"md-close-circle":62143,"md-closed-captioning":62145,"md-cloud":62153,"md-cloud-circle":62146,"md-cloud-done":62147,"md-cloud-download":62150,"md-cloud-outline":62151,"md-cloud-upload":62152,"md-cloudy":62155,"md-cloudy-night":62154,"md-code":62158,"md-code-download":62156,"md-code-working":62157,"md-cog":62159,"md-color-fill":62160,"md-color-filter":62161,"md-color-palette":62162,"md-color-wand":62163,"md-compass":62164,"md-construct":62165,"md-contact":62166,"md-contacts":62167,"md-contract":62168,"md-contrast":62169,"md-copy":62170,"md-create":62171,"md-crop":62172,"md-cube":62173,"md-cut":62174,"md-desktop":62175,"md-disc":62176,"md-document":62177,"md-done-all":62178,"md-download":62179,"md-easel":62180,"md-egg":62181,"md-exit":62182,"md-expand":62183,"md-eye":62185,"md-eye-off":62184,"md-fastforward":62186,"md-female":62187,"md-filing":62188,"md-film":62189,"md-finger-print":62190,"md-flag":62191,"md-flame":62192,"md-flash":62193,"md-flask":62194,"md-flower":62195,"md-folder":62197,"md-folder-open":62196,"md-football":62198,"md-funnel":62199,"md-game-controller-a":62200,"md-game-controller-b":62201,"md-git-branch":62202,"md-git-commit":62203,"md-git-compare":62204,"md-git-merge":62205,"md-git-network":62206,"md-git-pull-request":62207,"md-glasses":62208,"md-globe":62209,"md-grid":62210,"md-hammer":62211,"md-hand":62212,"md-happy":62213,"md-headset":62214,"md-heart":62216,"md-heart-outline":62215,"md-help":62219,"md-help-buoy":62217,"md-help-circle":62218,"md-home":62220,"md-ice-cream":62221,"md-image":62222,"md-images":62223,"md-infinite":62224,"md-information":62226,"md-information-circle":62225,"md-ionic":62227,"md-ionitron":62228,"md-jet":62229,"md-key":62230,"md-keypad":62231,"md-laptop":62232,"md-leaf":62233,"md-link":61998,"md-list":62235,"md-list-box":62234,"md-locate":62236,"md-lock":62237,"md-log-in":62238,"md-log-out":62239,"md-magnet":62240,"md-mail":62242,"md-mail-open":62241,"md-male":62243,"md-man":62244,"md-map":62245,"md-medal":62246,"md-medical":62247,"md-medkit":62248,"md-megaphone":62249,"md-menu":62250,"md-mic":62252,"md-mic-off":62251,"md-microphone":62253,"md-moon":62254,"md-more":61897,"md-move":62257,"md-musical-note":62258,"md-musical-notes":62259,"md-navigate":62260,"md-no-smoking":62261,"md-notifications":62264,"md-notifications-off":62262,"md-notifications-outline":62263,"md-nuclear":62265,"md-nutrition":62266,"md-open":62267,"md-options":62268,"md-outlet":62269,"md-paper":62271,"md-paper-plane":62270,"md-partly-sunny":62272,"md-pause":62273,"md-paw":62274,"md-people":62275,"md-person":62277,"md-person-add":62276,"md-phone-landscape":62278,"md-phone-portrait":62279,"md-photos":62280,"md-pie":62281,"md-pin":62282,"md-pint":62283,"md-pizza":62292,"md-plane":62293,"md-planet":62294,"md-play":62295,"md-podium":62296,"md-power":62297,"md-pricetag":62298,"md-pricetags":62299,"md-print":62300,"md-pulse":62301,"md-qr-scanner":62302,"md-quote":62303,"md-radio":62306,"md-radio-button-off":62304,"md-radio-button-on":62305,"md-rainy":62307,"md-recording":62308,"md-redo":62309,"md-refresh":62310,"md-refresh-circle":61992,"md-remove":62312,"md-remove-circle":62311,"md-reorder":62313,"md-repeat":62314,"md-resize":62315,"md-restaurant":62316,"md-return-left":62317,"md-return-right":62318,"md-reverse-camera":62319,"md-rewind":62320,"md-ribbon":62321,"md-rose":62322,"md-sad":62323,"md-school":62324,"md-search":62325,"md-send":62326,"md-settings":62327,"md-share":62329,"md-share-alt":62328,"md-shirt":62330,"md-shuffle":62331,"md-skip-backward":62332,"md-skip-forward":62333,"md-snow":62334,"md-speedometer":62335,"md-square":62337,"md-square-outline":62336,"md-star":62340,"md-star-half":62338,"md-star-outline":62339,"md-stats":62341,"md-stopwatch":62342,"md-subway":62343,"md-sunny":62344,"md-swap":62345,"md-switch":62346,"md-sync":62347,"md-tablet-landscape":62348,"md-tablet-portrait":62349,"md-tennisball":62350,"md-text":62351,"md-thermometer":62352,"md-thumbs-down":62353,"md-thumbs-up":62354,"md-thunderstorm":62355,"md-time":62356,"md-timer":62357,"md-train":62358,"md-transgender":62359,"md-trash":62360,"md-trending-down":62361,"md-trending-up":62362,"md-trophy":62363,"md-umbrella":62364,"md-undo":62365,"md-unlock":62366,"md-videocam":62367,"md-volume-down":62368,"md-volume-mute":62369,"md-volume-off":62370,"md-volume-up":62371,"md-walk":62372,"md-warning":62373,"md-watch":62374,"md-water":62375,"md-wifi":62376,"md-wine":62377,"md-woman":62378}

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(24);var _createIconSet2=_interopRequireDefault(_createIconSet);var _Entypo=__webpack_require__(571);var _Entypo2=_interopRequireDefault(_Entypo);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_Entypo2.default,'Entypo','Entypo.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports = {"500px":61696,"500px-with-circle":61697,"add-to-list":61698,"add-user":61699,"address":61700,"adjust":61701,"air":61702,"aircraft":61703,"aircraft-landing":61704,"aircraft-take-off":61705,"align-bottom":61706,"align-horizontal-middle":61707,"align-left":61708,"align-right":61709,"align-top":61710,"align-vertical-middle":61711,"app-store":61712,"archive":61713,"area-graph":61714,"arrow-bold-down":61715,"arrow-bold-left":61716,"arrow-bold-right":61717,"arrow-bold-up":61718,"arrow-down":61719,"arrow-left":61720,"arrow-long-down":61721,"arrow-long-left":61722,"arrow-long-right":61723,"arrow-long-up":61724,"arrow-right":61725,"arrow-up":61726,"arrow-with-circle-down":61727,"arrow-with-circle-left":61728,"arrow-with-circle-right":61729,"arrow-with-circle-up":61730,"attachment":61731,"awareness-ribbon":61732,"back":61733,"back-in-time":61734,"baidu":61735,"bar-graph":61736,"basecamp":61737,"battery":61738,"beamed-note":61739,"behance":61740,"bell":61741,"blackboard":61742,"block":61743,"book":61744,"bookmark":61745,"bookmarks":61746,"bowl":61747,"box":61748,"briefcase":61749,"browser":61750,"brush":61751,"bucket":61752,"bug":61753,"cake":61754,"calculator":61755,"calendar":61756,"camera":61757,"ccw":61758,"chat":61759,"check":61760,"chevron-down":61761,"chevron-left":61762,"chevron-right":61763,"chevron-small-down":61764,"chevron-small-left":61765,"chevron-small-right":61766,"chevron-small-up":61767,"chevron-thin-down":61768,"chevron-thin-left":61769,"chevron-thin-right":61770,"chevron-thin-up":61771,"chevron-up":61772,"chevron-with-circle-down":61773,"chevron-with-circle-left":61774,"chevron-with-circle-right":61775,"chevron-with-circle-up":61776,"circle":61777,"circle-with-cross":61778,"circle-with-minus":61779,"circle-with-plus":61780,"circular-graph":61781,"clapperboard":61782,"classic-computer":61783,"clipboard":61784,"clock":61785,"cloud":61786,"code":61787,"cog":61788,"colours":61789,"compass":61790,"controller-fast-backward":61791,"controller-fast-forward":61792,"controller-jump-to-start":61793,"controller-next":61794,"controller-paus":61795,"controller-play":61796,"controller-record":61797,"controller-stop":61798,"controller-volume":61799,"copy":61800,"creative-cloud":61801,"creative-commons":61802,"creative-commons-attribution":61803,"creative-commons-noderivs":61804,"creative-commons-noncommercial-eu":61805,"creative-commons-noncommercial-us":61806,"creative-commons-public-domain":61807,"creative-commons-remix":61808,"creative-commons-share":61809,"creative-commons-sharealike":61810,"credit":61811,"credit-card":61812,"crop":61813,"cross":61814,"cup":61815,"cw":61816,"cycle":61817,"database":61818,"dial-pad":61819,"direction":61820,"document":61821,"document-landscape":61822,"documents":61823,"dot-single":61824,"dots-three-horizontal":61825,"dots-three-vertical":61826,"dots-two-horizontal":61827,"dots-two-vertical":61828,"download":61829,"dribbble":61830,"dribbble-with-circle":61831,"drink":61832,"drive":61833,"drop":61834,"dropbox":61835,"edit":61836,"email":61837,"emoji-flirt":61838,"emoji-happy":61839,"emoji-neutral":61840,"emoji-sad":61841,"erase":61842,"eraser":61843,"evernote":61844,"export":61845,"eye":61846,"eye-with-line":61847,"facebook":61848,"facebook-with-circle":61849,"feather":61850,"fingerprint":61851,"flag":61852,"flash":61853,"flashlight":61854,"flat-brush":61855,"flattr":61856,"flickr":61857,"flickr-with-circle":61858,"flow-branch":61859,"flow-cascade":61860,"flow-line":61861,"flow-parallel":61862,"flow-tree":61863,"flower":61864,"folder":61865,"folder-images":61866,"folder-music":61867,"folder-video":61868,"forward":61869,"foursquare":61870,"funnel":61871,"game-controller":61872,"gauge":61873,"github":61874,"github-with-circle":61875,"globe":61876,"google-":61877,"google--with-circle":61878,"google-drive":61879,"google-hangouts":61880,"google-play":61881,"graduation-cap":61882,"grid":61883,"grooveshark":61884,"hair-cross":61885,"hand":61886,"heart":61887,"heart-outlined":61888,"help":61889,"help-with-circle":61890,"home":61891,"hour-glass":61892,"houzz":61893,"icloud":61894,"image":61895,"image-inverted":61896,"images":61897,"inbox":61898,"infinity":61899,"info":61900,"info-with-circle":61901,"instagram":61902,"instagram-with-circle":61903,"install":61904,"key":61905,"keyboard":61906,"lab-flask":61907,"landline":61908,"language":61909,"laptop":61910,"lastfm":61911,"lastfm-with-circle":61912,"layers":61913,"leaf":61914,"level-down":61915,"level-up":61916,"lifebuoy":61917,"light-bulb":61918,"light-down":61919,"light-up":61920,"line-graph":61921,"link":61922,"linkedin":61923,"linkedin-with-circle":61924,"list":61925,"location":61926,"location-pin":61927,"lock":61928,"lock-open":61929,"log-out":61930,"login":61931,"loop":61932,"magnet":61933,"magnifying-glass":61934,"mail":61935,"mail-with-circle":61936,"man":61937,"map":61938,"mask":61939,"medal":61940,"medium":61941,"medium-with-circle":61942,"megaphone":61943,"menu":61944,"merge":61945,"message":61946,"mic":61947,"minus":61948,"mixi":61949,"mobile":61950,"modern-mic":61951,"moon":61952,"mouse":61953,"mouse-pointer":61954,"music":61955,"network":61956,"new":61957,"new-message":61958,"news":61959,"newsletter":61960,"note":61961,"notification":61962,"notifications-off":61963,"old-mobile":61964,"old-phone":61965,"onedrive":61966,"open-book":61967,"palette":61968,"paper-plane":61969,"paypal":61970,"pencil":61971,"phone":61972,"picasa":61973,"pie-chart":61974,"pin":61975,"pinterest":61976,"pinterest-with-circle":61977,"plus":61978,"popup":61979,"power-plug":61980,"price-ribbon":61981,"price-tag":61982,"print":61983,"progress-empty":61984,"progress-full":61985,"progress-one":61986,"progress-two":61987,"publish":61988,"qq":61989,"qq-with-circle":61990,"quote":61991,"radio":61992,"raft":61993,"raft-with-circle":61994,"rainbow":61995,"rdio":61996,"rdio-with-circle":61997,"remove-user":61998,"renren":61999,"reply":62000,"reply-all":62001,"resize-100-":62002,"resize-full-screen":62003,"retweet":62004,"rocket":62005,"round-brush":62006,"rss":62007,"ruler":62008,"save":62009,"scissors":62010,"scribd":62011,"select-arrows":62012,"share":62013,"share-alternative":62014,"shareable":62015,"shield":62016,"shop":62017,"shopping-bag":62018,"shopping-basket":62019,"shopping-cart":62020,"shuffle":62021,"signal":62022,"sina-weibo":62023,"skype":62024,"skype-with-circle":62025,"slideshare":62026,"smashing":62027,"sound":62028,"sound-mix":62029,"sound-mute":62030,"soundcloud":62031,"sports-club":62032,"spotify":62033,"spotify-with-circle":62034,"spreadsheet":62035,"squared-cross":62036,"squared-minus":62037,"squared-plus":62038,"star":62039,"star-outlined":62040,"stopwatch":62041,"stumbleupon":62042,"stumbleupon-with-circle":62043,"suitcase":62044,"swap":62045,"swarm":62046,"sweden":62047,"switch":62048,"tablet":62049,"tablet-mobile-combo":62050,"tag":62051,"text":62052,"text-document":62053,"text-document-inverted":62054,"thermometer":62055,"thumbs-down":62056,"thumbs-up":62057,"thunder-cloud":62058,"ticket":62059,"time-slot":62060,"tools":62061,"traffic-cone":62062,"trash":62063,"tree":62064,"triangle-down":62065,"triangle-left":62066,"triangle-right":62067,"triangle-up":62068,"tripadvisor":62069,"trophy":62070,"tumblr":62071,"tumblr-with-circle":62072,"tv":62073,"twitter":62074,"twitter-with-circle":62075,"typing":62076,"uninstall":62077,"unread":62078,"untag":62079,"upload":62080,"upload-to-cloud":62081,"user":62082,"users":62083,"v-card":62084,"video":62085,"video-camera":62086,"vimeo":62087,"vimeo-with-circle":62088,"vine":62089,"vine-with-circle":62090,"vinyl":62091,"vk":62092,"vk-alternitive":62093,"vk-with-circle":62094,"voicemail":62095,"wallet":62096,"warning":62097,"water":62098,"windows-store":62099,"xing":62100,"xing-with-circle":62101,"yelp":62102,"youko":62103,"youko-with-circle":62104,"youtube":62105,"youtube-with-circle":62106}

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(24);var _createIconSet2=_interopRequireDefault(_createIconSet);var _FontAwesome=__webpack_require__(573);var _FontAwesome2=_interopRequireDefault(_FontAwesome);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_FontAwesome2.default,'FontAwesome','FontAwesome.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports = {"glass":61440,"music":61441,"search":61442,"envelope-o":61443,"heart":61444,"star":61445,"star-o":61446,"user":61447,"film":61448,"th-large":61449,"th":61450,"th-list":61451,"check":61452,"remove":61453,"close":61453,"times":61453,"search-plus":61454,"search-minus":61456,"power-off":61457,"signal":61458,"gear":61459,"cog":61459,"trash-o":61460,"home":61461,"file-o":61462,"clock-o":61463,"road":61464,"download":61465,"arrow-circle-o-down":61466,"arrow-circle-o-up":61467,"inbox":61468,"play-circle-o":61469,"rotate-right":61470,"repeat":61470,"refresh":61473,"list-alt":61474,"lock":61475,"flag":61476,"headphones":61477,"volume-off":61478,"volume-down":61479,"volume-up":61480,"qrcode":61481,"barcode":61482,"tag":61483,"tags":61484,"book":61485,"bookmark":61486,"print":61487,"camera":61488,"font":61489,"bold":61490,"italic":61491,"text-height":61492,"text-width":61493,"align-left":61494,"align-center":61495,"align-right":61496,"align-justify":61497,"list":61498,"dedent":61499,"outdent":61499,"indent":61500,"video-camera":61501,"photo":61502,"image":61502,"picture-o":61502,"pencil":61504,"map-marker":61505,"adjust":61506,"tint":61507,"edit":61508,"pencil-square-o":61508,"share-square-o":61509,"check-square-o":61510,"arrows":61511,"step-backward":61512,"fast-backward":61513,"backward":61514,"play":61515,"pause":61516,"stop":61517,"forward":61518,"fast-forward":61520,"step-forward":61521,"eject":61522,"chevron-left":61523,"chevron-right":61524,"plus-circle":61525,"minus-circle":61526,"times-circle":61527,"check-circle":61528,"question-circle":61529,"info-circle":61530,"crosshairs":61531,"times-circle-o":61532,"check-circle-o":61533,"ban":61534,"arrow-left":61536,"arrow-right":61537,"arrow-up":61538,"arrow-down":61539,"mail-forward":61540,"share":61540,"expand":61541,"compress":61542,"plus":61543,"minus":61544,"asterisk":61545,"exclamation-circle":61546,"gift":61547,"leaf":61548,"fire":61549,"eye":61550,"eye-slash":61552,"warning":61553,"exclamation-triangle":61553,"plane":61554,"calendar":61555,"random":61556,"comment":61557,"magnet":61558,"chevron-up":61559,"chevron-down":61560,"retweet":61561,"shopping-cart":61562,"folder":61563,"folder-open":61564,"arrows-v":61565,"arrows-h":61566,"bar-chart-o":61568,"bar-chart":61568,"twitter-square":61569,"facebook-square":61570,"camera-retro":61571,"key":61572,"gears":61573,"cogs":61573,"comments":61574,"thumbs-o-up":61575,"thumbs-o-down":61576,"star-half":61577,"heart-o":61578,"sign-out":61579,"linkedin-square":61580,"thumb-tack":61581,"external-link":61582,"sign-in":61584,"trophy":61585,"github-square":61586,"upload":61587,"lemon-o":61588,"phone":61589,"square-o":61590,"bookmark-o":61591,"phone-square":61592,"twitter":61593,"facebook-f":61594,"facebook":61594,"github":61595,"unlock":61596,"credit-card":61597,"feed":61598,"rss":61598,"hdd-o":61600,"bullhorn":61601,"bell":61683,"certificate":61603,"hand-o-right":61604,"hand-o-left":61605,"hand-o-up":61606,"hand-o-down":61607,"arrow-circle-left":61608,"arrow-circle-right":61609,"arrow-circle-up":61610,"arrow-circle-down":61611,"globe":61612,"wrench":61613,"tasks":61614,"filter":61616,"briefcase":61617,"arrows-alt":61618,"group":61632,"users":61632,"chain":61633,"link":61633,"cloud":61634,"flask":61635,"cut":61636,"scissors":61636,"copy":61637,"files-o":61637,"paperclip":61638,"save":61639,"floppy-o":61639,"square":61640,"navicon":61641,"reorder":61641,"bars":61641,"list-ul":61642,"list-ol":61643,"strikethrough":61644,"underline":61645,"table":61646,"magic":61648,"truck":61649,"pinterest":61650,"pinterest-square":61651,"google-plus-square":61652,"google-plus":61653,"money":61654,"caret-down":61655,"caret-up":61656,"caret-left":61657,"caret-right":61658,"columns":61659,"unsorted":61660,"sort":61660,"sort-down":61661,"sort-desc":61661,"sort-up":61662,"sort-asc":61662,"envelope":61664,"linkedin":61665,"rotate-left":61666,"undo":61666,"legal":61667,"gavel":61667,"dashboard":61668,"tachometer":61668,"comment-o":61669,"comments-o":61670,"flash":61671,"bolt":61671,"sitemap":61672,"umbrella":61673,"paste":61674,"clipboard":61674,"lightbulb-o":61675,"exchange":61676,"cloud-download":61677,"cloud-upload":61678,"user-md":61680,"stethoscope":61681,"suitcase":61682,"bell-o":61602,"coffee":61684,"cutlery":61685,"file-text-o":61686,"building-o":61687,"hospital-o":61688,"ambulance":61689,"medkit":61690,"fighter-jet":61691,"beer":61692,"h-square":61693,"plus-square":61694,"angle-double-left":61696,"angle-double-right":61697,"angle-double-up":61698,"angle-double-down":61699,"angle-left":61700,"angle-right":61701,"angle-up":61702,"angle-down":61703,"desktop":61704,"laptop":61705,"tablet":61706,"mobile-phone":61707,"mobile":61707,"circle-o":61708,"quote-left":61709,"quote-right":61710,"spinner":61712,"circle":61713,"mail-reply":61714,"reply":61714,"github-alt":61715,"folder-o":61716,"folder-open-o":61717,"smile-o":61720,"frown-o":61721,"meh-o":61722,"gamepad":61723,"keyboard-o":61724,"flag-o":61725,"flag-checkered":61726,"terminal":61728,"code":61729,"mail-reply-all":61730,"reply-all":61730,"star-half-empty":61731,"star-half-full":61731,"star-half-o":61731,"location-arrow":61732,"crop":61733,"code-fork":61734,"unlink":61735,"chain-broken":61735,"question":61736,"info":61737,"exclamation":61738,"superscript":61739,"subscript":61740,"eraser":61741,"puzzle-piece":61742,"microphone":61744,"microphone-slash":61745,"shield":61746,"calendar-o":61747,"fire-extinguisher":61748,"rocket":61749,"maxcdn":61750,"chevron-circle-left":61751,"chevron-circle-right":61752,"chevron-circle-up":61753,"chevron-circle-down":61754,"html5":61755,"css3":61756,"anchor":61757,"unlock-alt":61758,"bullseye":61760,"ellipsis-h":61761,"ellipsis-v":61762,"rss-square":61763,"play-circle":61764,"ticket":61765,"minus-square":61766,"minus-square-o":61767,"level-up":61768,"level-down":61769,"check-square":61770,"pencil-square":61771,"external-link-square":61772,"share-square":61773,"compass":61774,"toggle-down":61776,"caret-square-o-down":61776,"toggle-up":61777,"caret-square-o-up":61777,"toggle-right":61778,"caret-square-o-right":61778,"euro":61779,"eur":61779,"gbp":61780,"dollar":61781,"usd":61781,"rupee":61782,"inr":61782,"cny":61783,"rmb":61783,"yen":61783,"jpy":61783,"ruble":61784,"rouble":61784,"rub":61784,"won":61785,"krw":61785,"bitcoin":61786,"btc":61786,"file":61787,"file-text":61788,"sort-alpha-asc":61789,"sort-alpha-desc":61790,"sort-amount-asc":61792,"sort-amount-desc":61793,"sort-numeric-asc":61794,"sort-numeric-desc":61795,"thumbs-up":61796,"thumbs-down":61797,"youtube-square":61798,"youtube":61799,"xing":61800,"xing-square":61801,"youtube-play":61802,"dropbox":61803,"stack-overflow":61804,"instagram":61805,"flickr":61806,"adn":61808,"bitbucket":61809,"bitbucket-square":61810,"tumblr":61811,"tumblr-square":61812,"long-arrow-down":61813,"long-arrow-up":61814,"long-arrow-left":61815,"long-arrow-right":61816,"apple":61817,"windows":61818,"android":61819,"linux":61820,"dribbble":61821,"skype":61822,"foursquare":61824,"trello":61825,"female":61826,"male":61827,"gittip":61828,"gratipay":61828,"sun-o":61829,"moon-o":61830,"archive":61831,"bug":61832,"vk":61833,"weibo":61834,"renren":61835,"pagelines":61836,"stack-exchange":61837,"arrow-circle-o-right":61838,"arrow-circle-o-left":61840,"toggle-left":61841,"caret-square-o-left":61841,"dot-circle-o":61842,"wheelchair":61843,"vimeo-square":61844,"turkish-lira":61845,"try":61845,"plus-square-o":61846,"space-shuttle":61847,"slack":61848,"envelope-square":61849,"wordpress":61850,"openid":61851,"institution":61852,"bank":61852,"university":61852,"mortar-board":61853,"graduation-cap":61853,"yahoo":61854,"google":61856,"reddit":61857,"reddit-square":61858,"stumbleupon-circle":61859,"stumbleupon":61860,"delicious":61861,"digg":61862,"pied-piper-pp":61863,"pied-piper-alt":61864,"drupal":61865,"joomla":61866,"language":61867,"fax":61868,"building":61869,"child":61870,"paw":61872,"spoon":61873,"cube":61874,"cubes":61875,"behance":61876,"behance-square":61877,"steam":61878,"steam-square":61879,"recycle":61880,"automobile":61881,"car":61881,"cab":61882,"taxi":61882,"tree":61883,"spotify":61884,"deviantart":61885,"soundcloud":61886,"database":61888,"file-pdf-o":61889,"file-word-o":61890,"file-excel-o":61891,"file-powerpoint-o":61892,"file-photo-o":61893,"file-picture-o":61893,"file-image-o":61893,"file-zip-o":61894,"file-archive-o":61894,"file-sound-o":61895,"file-audio-o":61895,"file-movie-o":61896,"file-video-o":61896,"file-code-o":61897,"vine":61898,"codepen":61899,"jsfiddle":61900,"life-bouy":61901,"life-buoy":61901,"life-saver":61901,"support":61901,"life-ring":61901,"circle-o-notch":61902,"ra":61904,"resistance":61904,"rebel":61904,"ge":61905,"empire":61905,"git-square":61906,"git":61907,"y-combinator-square":61908,"yc-square":61908,"hacker-news":61908,"tencent-weibo":61909,"qq":61910,"wechat":61911,"weixin":61911,"send":61912,"paper-plane":61912,"send-o":61913,"paper-plane-o":61913,"history":61914,"circle-thin":61915,"header":61916,"paragraph":61917,"sliders":61918,"share-alt":61920,"share-alt-square":61921,"bomb":61922,"soccer-ball-o":61923,"futbol-o":61923,"tty":61924,"binoculars":61925,"plug":61926,"slideshare":61927,"twitch":61928,"yelp":61929,"newspaper-o":61930,"wifi":61931,"calculator":61932,"paypal":61933,"google-wallet":61934,"cc-visa":61936,"cc-mastercard":61937,"cc-discover":61938,"cc-amex":61939,"cc-paypal":61940,"cc-stripe":61941,"bell-slash":61942,"bell-slash-o":61943,"trash":61944,"copyright":61945,"at":61946,"eyedropper":61947,"paint-brush":61948,"birthday-cake":61949,"area-chart":61950,"pie-chart":61952,"line-chart":61953,"lastfm":61954,"lastfm-square":61955,"toggle-off":61956,"toggle-on":61957,"bicycle":61958,"bus":61959,"ioxhost":61960,"angellist":61961,"cc":61962,"shekel":61963,"sheqel":61963,"ils":61963,"meanpath":61964,"buysellads":61965,"connectdevelop":61966,"dashcube":61968,"forumbee":61969,"leanpub":61970,"sellsy":61971,"shirtsinbulk":61972,"simplybuilt":61973,"skyatlas":61974,"cart-plus":61975,"cart-arrow-down":61976,"diamond":61977,"ship":61978,"user-secret":61979,"motorcycle":61980,"street-view":61981,"heartbeat":61982,"venus":61985,"mars":61986,"mercury":61987,"intersex":61988,"transgender":61988,"transgender-alt":61989,"venus-double":61990,"mars-double":61991,"venus-mars":61992,"mars-stroke":61993,"mars-stroke-v":61994,"mars-stroke-h":61995,"neuter":61996,"genderless":61997,"facebook-official":62000,"pinterest-p":62001,"whatsapp":62002,"server":62003,"user-plus":62004,"user-times":62005,"hotel":62006,"bed":62006,"viacoin":62007,"train":62008,"subway":62009,"medium":62010,"yc":62011,"y-combinator":62011,"optin-monster":62012,"opencart":62013,"expeditedssl":62014,"battery-4":62016,"battery":62016,"battery-full":62016,"battery-3":62017,"battery-three-quarters":62017,"battery-2":62018,"battery-half":62018,"battery-1":62019,"battery-quarter":62019,"battery-0":62020,"battery-empty":62020,"mouse-pointer":62021,"i-cursor":62022,"object-group":62023,"object-ungroup":62024,"sticky-note":62025,"sticky-note-o":62026,"cc-jcb":62027,"cc-diners-club":62028,"clone":62029,"balance-scale":62030,"hourglass-o":62032,"hourglass-1":62033,"hourglass-start":62033,"hourglass-2":62034,"hourglass-half":62034,"hourglass-3":62035,"hourglass-end":62035,"hourglass":62036,"hand-grab-o":62037,"hand-rock-o":62037,"hand-stop-o":62038,"hand-paper-o":62038,"hand-scissors-o":62039,"hand-lizard-o":62040,"hand-spock-o":62041,"hand-pointer-o":62042,"hand-peace-o":62043,"trademark":62044,"registered":62045,"creative-commons":62046,"gg":62048,"gg-circle":62049,"tripadvisor":62050,"odnoklassniki":62051,"odnoklassniki-square":62052,"get-pocket":62053,"wikipedia-w":62054,"safari":62055,"chrome":62056,"firefox":62057,"opera":62058,"internet-explorer":62059,"tv":62060,"television":62060,"contao":62061,"500px":62062,"amazon":62064,"calendar-plus-o":62065,"calendar-minus-o":62066,"calendar-times-o":62067,"calendar-check-o":62068,"industry":62069,"map-pin":62070,"map-signs":62071,"map-o":62072,"map":62073,"commenting":62074,"commenting-o":62075,"houzz":62076,"vimeo":62077,"black-tie":62078,"fonticons":62080,"reddit-alien":62081,"edge":62082,"credit-card-alt":62083,"codiepie":62084,"modx":62085,"fort-awesome":62086,"usb":62087,"product-hunt":62088,"mixcloud":62089,"scribd":62090,"pause-circle":62091,"pause-circle-o":62092,"stop-circle":62093,"stop-circle-o":62094,"shopping-bag":62096,"shopping-basket":62097,"hashtag":62098,"bluetooth":62099,"bluetooth-b":62100,"percent":62101,"gitlab":62102,"wpbeginner":62103,"wpforms":62104,"envira":62105,"universal-access":62106,"wheelchair-alt":62107,"question-circle-o":62108,"blind":62109,"audio-description":62110,"volume-control-phone":62112,"braille":62113,"assistive-listening-systems":62114,"asl-interpreting":62115,"american-sign-language-interpreting":62115,"deafness":62116,"hard-of-hearing":62116,"deaf":62116,"glide":62117,"glide-g":62118,"signing":62119,"sign-language":62119,"low-vision":62120,"viadeo":62121,"viadeo-square":62122,"snapchat":62123,"snapchat-ghost":62124,"snapchat-square":62125,"pied-piper":62126,"first-order":62128,"yoast":62129,"themeisle":62130,"google-plus-circle":62131,"google-plus-official":62131,"fa":62132,"font-awesome":62132,"handshake-o":62133,"envelope-open":62134,"envelope-open-o":62135,"linode":62136,"address-book":62137,"address-book-o":62138,"vcard":62139,"address-card":62139,"vcard-o":62140,"address-card-o":62140,"user-circle":62141,"user-circle-o":62142,"user-o":62144,"id-badge":62145,"drivers-license":62146,"id-card":62146,"drivers-license-o":62147,"id-card-o":62147,"quora":62148,"free-code-camp":62149,"telegram":62150,"thermometer-4":62151,"thermometer":62151,"thermometer-full":62151,"thermometer-3":62152,"thermometer-three-quarters":62152,"thermometer-2":62153,"thermometer-half":62153,"thermometer-1":62154,"thermometer-quarter":62154,"thermometer-0":62155,"thermometer-empty":62155,"shower":62156,"bathtub":62157,"s15":62157,"bath":62157,"podcast":62158,"window-maximize":62160,"window-minimize":62161,"window-restore":62162,"times-rectangle":62163,"window-close":62163,"times-rectangle-o":62164,"window-close-o":62164,"bandcamp":62165,"grav":62166,"etsy":62167,"imdb":62168,"ravelry":62169,"eercast":62170,"microchip":62171,"snowflake-o":62172,"superpowers":62173,"wpexplorer":62174,"meetup":62176}

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(24);var _createIconSet2=_interopRequireDefault(_createIconSet);var _Foundation=__webpack_require__(575);var _Foundation2=_interopRequireDefault(_Foundation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_Foundation2.default,'fontcustom','Foundation.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports = {"address-book":61696,"alert":61697,"align-center":61698,"align-justify":61699,"align-left":61700,"align-right":61701,"anchor":61702,"annotate":61703,"archive":61704,"arrow-down":61705,"arrow-left":61706,"arrow-right":61707,"arrow-up":61708,"arrows-compress":61709,"arrows-expand":61710,"arrows-in":61711,"arrows-out":61712,"asl":61713,"asterisk":61714,"at-sign":61715,"background-color":61716,"battery-empty":61717,"battery-full":61718,"battery-half":61719,"bitcoin-circle":61720,"bitcoin":61721,"blind":61722,"bluetooth":61723,"bold":61724,"book-bookmark":61725,"book":61726,"bookmark":61727,"braille":61728,"burst-new":61729,"burst-sale":61730,"burst":61731,"calendar":61732,"camera":61733,"check":61734,"checkbox":61735,"clipboard-notes":61736,"clipboard-pencil":61737,"clipboard":61738,"clock":61739,"closed-caption":61740,"cloud":61741,"comment-minus":61742,"comment-quotes":61743,"comment-video":61744,"comment":61745,"comments":61746,"compass":61747,"contrast":61748,"credit-card":61749,"crop":61750,"crown":61751,"css3":61752,"database":61753,"die-five":61754,"die-four":61755,"die-one":61756,"die-six":61757,"die-three":61758,"die-two":61759,"dislike":61760,"dollar-bill":61761,"dollar":61762,"download":61763,"eject":61764,"elevator":61765,"euro":61766,"eye":61767,"fast-forward":61768,"female-symbol":61769,"female":61770,"filter":61771,"first-aid":61772,"flag":61773,"folder-add":61774,"folder-lock":61775,"folder":61776,"foot":61777,"foundation":61778,"graph-bar":61779,"graph-horizontal":61780,"graph-pie":61781,"graph-trend":61782,"guide-dog":61783,"hearing-aid":61784,"heart":61785,"home":61786,"html5":61787,"indent-less":61788,"indent-more":61789,"info":61790,"italic":61791,"key":61792,"laptop":61793,"layout":61794,"lightbulb":61795,"like":61796,"link":61797,"list-bullet":61798,"list-number":61799,"list-thumbnails":61800,"list":61801,"lock":61802,"loop":61803,"magnifying-glass":61804,"mail":61805,"male-female":61806,"male-symbol":61807,"male":61808,"map":61809,"marker":61810,"megaphone":61811,"microphone":61812,"minus-circle":61813,"minus":61814,"mobile-signal":61815,"mobile":61816,"monitor":61817,"mountains":61818,"music":61819,"next":61820,"no-dogs":61821,"no-smoking":61822,"page-add":61823,"page-copy":61824,"page-csv":61825,"page-delete":61826,"page-doc":61827,"page-edit":61828,"page-export-csv":61829,"page-export-doc":61830,"page-export-pdf":61831,"page-export":61832,"page-filled":61833,"page-multiple":61834,"page-pdf":61835,"page-remove":61836,"page-search":61837,"page":61838,"paint-bucket":61839,"paperclip":61840,"pause":61841,"paw":61842,"paypal":61843,"pencil":61844,"photo":61845,"play-circle":61846,"play-video":61847,"play":61848,"plus":61849,"pound":61850,"power":61851,"previous":61852,"price-tag":61853,"pricetag-multiple":61854,"print":61855,"prohibited":61856,"projection-screen":61857,"puzzle":61858,"quote":61859,"record":61860,"refresh":61861,"results-demographics":61862,"results":61863,"rewind-ten":61864,"rewind":61865,"rss":61866,"safety-cone":61867,"save":61868,"share":61869,"sheriff-badge":61870,"shield":61871,"shopping-bag":61872,"shopping-cart":61873,"shuffle":61874,"skull":61875,"social-500px":61876,"social-adobe":61877,"social-amazon":61878,"social-android":61879,"social-apple":61880,"social-behance":61881,"social-bing":61882,"social-blogger":61883,"social-delicious":61884,"social-designer-news":61885,"social-deviant-art":61886,"social-digg":61887,"social-dribbble":61888,"social-drive":61889,"social-dropbox":61890,"social-evernote":61891,"social-facebook":61892,"social-flickr":61893,"social-forrst":61894,"social-foursquare":61895,"social-game-center":61896,"social-github":61897,"social-google-plus":61898,"social-hacker-news":61899,"social-hi5":61900,"social-instagram":61901,"social-joomla":61902,"social-lastfm":61903,"social-linkedin":61904,"social-medium":61905,"social-myspace":61906,"social-orkut":61907,"social-path":61908,"social-picasa":61909,"social-pinterest":61910,"social-rdio":61911,"social-reddit":61912,"social-skillshare":61913,"social-skype":61914,"social-smashing-mag":61915,"social-snapchat":61916,"social-spotify":61917,"social-squidoo":61918,"social-stack-overflow":61919,"social-steam":61920,"social-stumbleupon":61921,"social-treehouse":61922,"social-tumblr":61923,"social-twitter":61924,"social-vimeo":61925,"social-windows":61926,"social-xbox":61927,"social-yahoo":61928,"social-yelp":61929,"social-youtube":61930,"social-zerply":61931,"social-zurb":61932,"sound":61933,"star":61934,"stop":61935,"strikethrough":61936,"subscript":61937,"superscript":61938,"tablet-landscape":61939,"tablet-portrait":61940,"target-two":61941,"target":61942,"telephone-accessible":61943,"telephone":61944,"text-color":61945,"thumbnails":61946,"ticket":61947,"torso-business":61948,"torso-female":61949,"torso":61950,"torsos-all-female":61951,"torsos-all":61952,"torsos-female-male":61953,"torsos-male-female":61954,"torsos":61955,"trash":61956,"trees":61957,"trophy":61958,"underline":61959,"universal-access":61960,"unlink":61961,"unlock":61962,"upload-cloud":61963,"upload":61964,"usb":61965,"video":61966,"volume-none":61967,"volume-strike":61968,"volume":61969,"web":61970,"wheelchair":61971,"widget":61972,"wrench":61973,"x-circle":61974,"x":61975,"yen":61976,"zoom-in":61977,"zoom-out":61978}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(24);var _createIconSet2=_interopRequireDefault(_createIconSet);var _MaterialIcons=__webpack_require__(577);var _MaterialIcons2=_interopRequireDefault(_MaterialIcons);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_MaterialIcons2.default,'Material Icons','MaterialIcons.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = {"3d-rotation":59469,"ac-unit":60219,"access-alarm":57744,"access-alarms":57745,"access-time":57746,"accessibility":59470,"accessible":59668,"account-balance":59471,"account-balance-wallet":59472,"account-box":59473,"account-circle":59475,"adb":58894,"add":57669,"add-a-photo":58425,"add-alarm":57747,"add-alert":57347,"add-box":57670,"add-circle":57671,"add-circle-outline":57672,"add-location":58727,"add-shopping-cart":59476,"add-to-photos":58269,"add-to-queue":57436,"adjust":58270,"airline-seat-flat":58928,"airline-seat-flat-angled":58929,"airline-seat-individual-suite":58930,"airline-seat-legroom-extra":58931,"airline-seat-legroom-normal":58932,"airline-seat-legroom-reduced":58933,"airline-seat-recline-extra":58934,"airline-seat-recline-normal":58935,"airplanemode-active":57749,"airplanemode-inactive":57748,"airplay":57429,"airport-shuttle":60220,"alarm":59477,"alarm-add":59478,"alarm-off":59479,"alarm-on":59480,"album":57369,"all-inclusive":60221,"all-out":59659,"android":59481,"announcement":59482,"apps":58819,"archive":57673,"arrow-back":58820,"arrow-downward":58843,"arrow-drop-down":58821,"arrow-drop-down-circle":58822,"arrow-drop-up":58823,"arrow-forward":58824,"arrow-upward":58840,"art-track":57440,"aspect-ratio":59483,"assessment":59484,"assignment":59485,"assignment-ind":59486,"assignment-late":59487,"assignment-return":59488,"assignment-returned":59489,"assignment-turned-in":59490,"assistant":58271,"assistant-photo":58272,"attach-file":57894,"attach-money":57895,"attachment":58044,"audiotrack":58273,"autorenew":59491,"av-timer":57371,"backspace":57674,"backup":59492,"battery-alert":57756,"battery-charging-full":57763,"battery-full":57764,"battery-std":57765,"battery-unknown":57766,"beach-access":60222,"beenhere":58669,"block":57675,"bluetooth":57767,"bluetooth-audio":58895,"bluetooth-connected":57768,"bluetooth-disabled":57769,"bluetooth-searching":57770,"blur-circular":58274,"blur-linear":58275,"blur-off":58276,"blur-on":58277,"book":59493,"bookmark":59494,"bookmark-border":59495,"border-all":57896,"border-bottom":57897,"border-clear":57898,"border-color":57899,"border-horizontal":57900,"border-inner":57901,"border-left":57902,"border-outer":57903,"border-right":57904,"border-style":57905,"border-top":57906,"border-vertical":57907,"branding-watermark":57451,"brightness-1":58278,"brightness-2":58279,"brightness-3":58280,"brightness-4":58281,"brightness-5":58282,"brightness-6":58283,"brightness-7":58284,"brightness-auto":57771,"brightness-high":57772,"brightness-low":57773,"brightness-medium":57774,"broken-image":58285,"brush":58286,"bubble-chart":59101,"bug-report":59496,"build":59497,"burst-mode":58428,"business":57519,"business-center":60223,"cached":59498,"cake":59369,"call":57520,"call-end":57521,"call-made":57522,"call-merge":57523,"call-missed":57524,"call-missed-outgoing":57572,"call-received":57525,"call-split":57526,"call-to-action":57452,"camera":58287,"camera-alt":58288,"camera-enhance":59644,"camera-front":58289,"camera-rear":58290,"camera-roll":58291,"cancel":58825,"card-giftcard":59638,"card-membership":59639,"card-travel":59640,"casino":60224,"cast":58119,"cast-connected":58120,"center-focus-strong":58292,"center-focus-weak":58293,"change-history":59499,"chat":57527,"chat-bubble":57546,"chat-bubble-outline":57547,"check":58826,"check-box":59444,"check-box-outline-blank":59445,"check-circle":59500,"chevron-left":58827,"chevron-right":58828,"child-care":60225,"child-friendly":60226,"chrome-reader-mode":59501,"class":59502,"clear":57676,"clear-all":57528,"close":58829,"closed-caption":57372,"cloud":58045,"cloud-circle":58046,"cloud-done":58047,"cloud-download":58048,"cloud-off":58049,"cloud-queue":58050,"cloud-upload":58051,"code":59503,"collections":58294,"collections-bookmark":58417,"color-lens":58295,"colorize":58296,"comment":57529,"compare":58297,"compare-arrows":59669,"computer":58122,"confirmation-number":58936,"contact-mail":57552,"contact-phone":57551,"contacts":57530,"content-copy":57677,"content-cut":57678,"content-paste":57679,"control-point":58298,"control-point-duplicate":58299,"copyright":59660,"create":57680,"create-new-folder":58060,"credit-card":59504,"crop":58302,"crop-16-9":58300,"crop-3-2":58301,"crop-5-4":58303,"crop-7-5":58304,"crop-din":58305,"crop-free":58306,"crop-landscape":58307,"crop-original":58308,"crop-portrait":58309,"crop-rotate":58423,"crop-square":58310,"dashboard":59505,"data-usage":57775,"date-range":59670,"dehaze":58311,"delete":59506,"delete-forever":59691,"delete-sweep":57708,"description":59507,"desktop-mac":58123,"desktop-windows":58124,"details":58312,"developer-board":58125,"developer-mode":57776,"device-hub":58165,"devices":57777,"devices-other":58167,"dialer-sip":57531,"dialpad":57532,"directions":58670,"directions-bike":58671,"directions-boat":58674,"directions-bus":58672,"directions-car":58673,"directions-railway":58676,"directions-run":58726,"directions-subway":58675,"directions-transit":58677,"directions-walk":58678,"disc-full":58896,"dns":59509,"do-not-disturb":58898,"do-not-disturb-alt":58897,"do-not-disturb-off":58947,"do-not-disturb-on":58948,"dock":58126,"domain":59374,"done":59510,"done-all":59511,"donut-large":59671,"donut-small":59672,"drafts":57681,"drag-handle":57949,"drive-eta":58899,"dvr":57778,"edit":58313,"edit-location":58728,"eject":59643,"email":57534,"enhanced-encryption":58943,"equalizer":57373,"error":57344,"error-outline":57345,"euro-symbol":59686,"ev-station":58733,"event":59512,"event-available":58900,"event-busy":58901,"event-note":58902,"event-seat":59651,"exit-to-app":59513,"expand-less":58830,"expand-more":58831,"explicit":57374,"explore":59514,"exposure":58314,"exposure-neg-1":58315,"exposure-neg-2":58316,"exposure-plus-1":58317,"exposure-plus-2":58318,"exposure-zero":58319,"extension":59515,"face":59516,"fast-forward":57375,"fast-rewind":57376,"favorite":59517,"favorite-border":59518,"featured-play-list":57453,"featured-video":57454,"feedback":59519,"fiber-dvr":57437,"fiber-manual-record":57441,"fiber-new":57438,"fiber-pin":57450,"fiber-smart-record":57442,"file-download":58052,"file-upload":58054,"filter":58323,"filter-1":58320,"filter-2":58321,"filter-3":58322,"filter-4":58324,"filter-5":58325,"filter-6":58326,"filter-7":58327,"filter-8":58328,"filter-9":58329,"filter-9-plus":58330,"filter-b-and-w":58331,"filter-center-focus":58332,"filter-drama":58333,"filter-frames":58334,"filter-hdr":58335,"filter-list":57682,"filter-none":58336,"filter-tilt-shift":58338,"filter-vintage":58339,"find-in-page":59520,"find-replace":59521,"fingerprint":59661,"first-page":58844,"fitness-center":60227,"flag":57683,"flare":58340,"flash-auto":58341,"flash-off":58342,"flash-on":58343,"flight":58681,"flight-land":59652,"flight-takeoff":59653,"flip":58344,"flip-to-back":59522,"flip-to-front":59523,"folder":58055,"folder-open":58056,"folder-shared":58057,"folder-special":58903,"font-download":57703,"format-align-center":57908,"format-align-justify":57909,"format-align-left":57910,"format-align-right":57911,"format-bold":57912,"format-clear":57913,"format-color-fill":57914,"format-color-reset":57915,"format-color-text":57916,"format-indent-decrease":57917,"format-indent-increase":57918,"format-italic":57919,"format-line-spacing":57920,"format-list-bulleted":57921,"format-list-numbered":57922,"format-paint":57923,"format-quote":57924,"format-shapes":57950,"format-size":57925,"format-strikethrough":57926,"format-textdirection-l-to-r":57927,"format-textdirection-r-to-l":57928,"format-underlined":57929,"forum":57535,"forward":57684,"forward-10":57430,"forward-30":57431,"forward-5":57432,"free-breakfast":60228,"fullscreen":58832,"fullscreen-exit":58833,"functions":57930,"g-translate":59687,"gamepad":58127,"games":57377,"gavel":59662,"gesture":57685,"get-app":59524,"gif":59656,"golf-course":60229,"gps-fixed":57779,"gps-not-fixed":57780,"gps-off":57781,"grade":59525,"gradient":58345,"grain":58346,"graphic-eq":57784,"grid-off":58347,"grid-on":58348,"group":59375,"group-add":59376,"group-work":59526,"hd":57426,"hdr-off":58349,"hdr-on":58350,"hdr-strong":58353,"hdr-weak":58354,"headset":58128,"headset-mic":58129,"healing":58355,"hearing":57379,"help":59527,"help-outline":59645,"high-quality":57380,"highlight":57951,"highlight-off":59528,"history":59529,"home":59530,"hot-tub":60230,"hotel":58682,"hourglass-empty":59531,"hourglass-full":59532,"http":59650,"https":59533,"image":58356,"image-aspect-ratio":58357,"import-contacts":57568,"import-export":57539,"important-devices":59666,"inbox":57686,"indeterminate-check-box":59657,"info":59534,"info-outline":59535,"input":59536,"insert-chart":57931,"insert-comment":57932,"insert-drive-file":57933,"insert-emoticon":57934,"insert-invitation":57935,"insert-link":57936,"insert-photo":57937,"invert-colors":59537,"invert-colors-off":57540,"iso":58358,"keyboard":58130,"keyboard-arrow-down":58131,"keyboard-arrow-left":58132,"keyboard-arrow-right":58133,"keyboard-arrow-up":58134,"keyboard-backspace":58135,"keyboard-capslock":58136,"keyboard-hide":58138,"keyboard-return":58139,"keyboard-tab":58140,"keyboard-voice":58141,"kitchen":60231,"label":59538,"label-outline":59539,"landscape":58359,"language":59540,"laptop":58142,"laptop-chromebook":58143,"laptop-mac":58144,"laptop-windows":58145,"last-page":58845,"launch":59541,"layers":58683,"layers-clear":58684,"leak-add":58360,"leak-remove":58361,"lens":58362,"library-add":57390,"library-books":57391,"library-music":57392,"lightbulb-outline":59663,"line-style":59673,"line-weight":59674,"linear-scale":57952,"link":57687,"linked-camera":58424,"list":59542,"live-help":57542,"live-tv":58937,"local-activity":58687,"local-airport":58685,"local-atm":58686,"local-bar":58688,"local-cafe":58689,"local-car-wash":58690,"local-convenience-store":58691,"local-dining":58710,"local-drink":58692,"local-florist":58693,"local-gas-station":58694,"local-grocery-store":58695,"local-hospital":58696,"local-hotel":58697,"local-laundry-service":58698,"local-library":58699,"local-mall":58700,"local-movies":58701,"local-offer":58702,"local-parking":58703,"local-pharmacy":58704,"local-phone":58705,"local-pizza":58706,"local-play":58707,"local-post-office":58708,"local-printshop":58709,"local-see":58711,"local-shipping":58712,"local-taxi":58713,"location-city":59377,"location-disabled":57782,"location-off":57543,"location-on":57544,"location-searching":57783,"lock":59543,"lock-open":59544,"lock-outline":59545,"looks":58364,"looks-3":58363,"looks-4":58365,"looks-5":58366,"looks-6":58367,"looks-one":58368,"looks-two":58369,"loop":57384,"loupe":58370,"low-priority":57709,"loyalty":59546,"mail":57688,"mail-outline":57569,"map":58715,"markunread":57689,"markunread-mailbox":59547,"memory":58146,"menu":58834,"merge-type":57938,"message":57545,"mic":57385,"mic-none":57386,"mic-off":57387,"mms":58904,"mode-comment":57939,"mode-edit":57940,"monetization-on":57955,"money-off":57948,"monochrome-photos":58371,"mood":59378,"mood-bad":59379,"more":58905,"more-horiz":58835,"more-vert":58836,"motorcycle":59675,"mouse":58147,"move-to-inbox":57704,"movie":57388,"movie-creation":58372,"movie-filter":58426,"multiline-chart":59103,"music-note":58373,"music-video":57443,"my-location":58716,"nature":58374,"nature-people":58375,"navigate-before":58376,"navigate-next":58377,"navigation":58717,"near-me":58729,"network-cell":57785,"network-check":58944,"network-locked":58906,"network-wifi":57786,"new-releases":57393,"next-week":57706,"nfc":57787,"no-encryption":58945,"no-sim":57548,"not-interested":57395,"note":57455,"note-add":59548,"notifications":59380,"notifications-active":59383,"notifications-none":59381,"notifications-off":59382,"notifications-paused":59384,"offline-pin":59658,"ondemand-video":58938,"opacity":59676,"open-in-browser":59549,"open-in-new":59550,"open-with":59551,"pages":59385,"pageview":59552,"palette":58378,"pan-tool":59685,"panorama":58379,"panorama-fish-eye":58380,"panorama-horizontal":58381,"panorama-vertical":58382,"panorama-wide-angle":58383,"party-mode":59386,"pause":57396,"pause-circle-filled":57397,"pause-circle-outline":57398,"payment":59553,"people":59387,"people-outline":59388,"perm-camera-mic":59554,"perm-contact-calendar":59555,"perm-data-setting":59556,"perm-device-information":59557,"perm-identity":59558,"perm-media":59559,"perm-phone-msg":59560,"perm-scan-wifi":59561,"person":59389,"person-add":59390,"person-outline":59391,"person-pin":58714,"person-pin-circle":58730,"personal-video":58939,"pets":59677,"phone":57549,"phone-android":58148,"phone-bluetooth-speaker":58907,"phone-forwarded":58908,"phone-in-talk":58909,"phone-iphone":58149,"phone-locked":58910,"phone-missed":58911,"phone-paused":58912,"phonelink":58150,"phonelink-erase":57563,"phonelink-lock":57564,"phonelink-off":58151,"phonelink-ring":57565,"phonelink-setup":57566,"photo":58384,"photo-album":58385,"photo-camera":58386,"photo-filter":58427,"photo-library":58387,"photo-size-select-actual":58418,"photo-size-select-large":58419,"photo-size-select-small":58420,"picture-as-pdf":58389,"picture-in-picture":59562,"picture-in-picture-alt":59665,"pie-chart":59076,"pie-chart-outlined":59077,"pin-drop":58718,"place":58719,"play-arrow":57399,"play-circle-filled":57400,"play-circle-outline":57401,"play-for-work":59654,"playlist-add":57403,"playlist-add-check":57445,"playlist-play":57439,"plus-one":59392,"poll":59393,"polymer":59563,"pool":60232,"portable-wifi-off":57550,"portrait":58390,"power":58940,"power-input":58166,"power-settings-new":59564,"pregnant-woman":59678,"present-to-all":57567,"print":59565,"priority-high":58949,"public":59403,"publish":57941,"query-builder":59566,"question-answer":59567,"queue":57404,"queue-music":57405,"queue-play-next":57446,"radio":57406,"radio-button-checked":59447,"radio-button-unchecked":59446,"rate-review":58720,"receipt":59568,"recent-actors":57407,"record-voice-over":59679,"redeem":59569,"redo":57690,"refresh":58837,"remove":57691,"remove-circle":57692,"remove-circle-outline":57693,"remove-from-queue":57447,"remove-red-eye":58391,"remove-shopping-cart":59688,"reorder":59646,"repeat":57408,"repeat-one":57409,"replay":57410,"replay-10":57433,"replay-30":57434,"replay-5":57435,"reply":57694,"reply-all":57695,"report":57696,"report-problem":59570,"restaurant":58732,"restaurant-menu":58721,"restore":59571,"restore-page":59689,"ring-volume":57553,"room":59572,"room-service":60233,"rotate-90-degrees-ccw":58392,"rotate-left":58393,"rotate-right":58394,"rounded-corner":59680,"router":58152,"rowing":59681,"rss-feed":57573,"rv-hookup":58946,"satellite":58722,"save":57697,"scanner":58153,"schedule":59573,"school":59404,"screen-lock-landscape":57790,"screen-lock-portrait":57791,"screen-lock-rotation":57792,"screen-rotation":57793,"screen-share":57570,"sd-card":58915,"sd-storage":57794,"search":59574,"security":58154,"select-all":57698,"send":57699,"sentiment-dissatisfied":59409,"sentiment-neutral":59410,"sentiment-satisfied":59411,"sentiment-very-dissatisfied":59412,"sentiment-very-satisfied":59413,"settings":59576,"settings-applications":59577,"settings-backup-restore":59578,"settings-bluetooth":59579,"settings-brightness":59581,"settings-cell":59580,"settings-ethernet":59582,"settings-input-antenna":59583,"settings-input-component":59584,"settings-input-composite":59585,"settings-input-hdmi":59586,"settings-input-svideo":59587,"settings-overscan":59588,"settings-phone":59589,"settings-power":59590,"settings-remote":59591,"settings-system-daydream":57795,"settings-voice":59592,"share":59405,"shop":59593,"shop-two":59594,"shopping-basket":59595,"shopping-cart":59596,"short-text":57953,"show-chart":59105,"shuffle":57411,"signal-cellular-4-bar":57800,"signal-cellular-connected-no-internet-4-bar":57805,"signal-cellular-no-sim":57806,"signal-cellular-null":57807,"signal-cellular-off":57808,"signal-wifi-4-bar":57816,"signal-wifi-4-bar-lock":57817,"signal-wifi-off":57818,"sim-card":58155,"sim-card-alert":58916,"skip-next":57412,"skip-previous":57413,"slideshow":58395,"slow-motion-video":57448,"smartphone":58156,"smoke-free":60234,"smoking-rooms":60235,"sms":58917,"sms-failed":58918,"snooze":57414,"sort":57700,"sort-by-alpha":57427,"spa":60236,"space-bar":57942,"speaker":58157,"speaker-group":58158,"speaker-notes":59597,"speaker-notes-off":59690,"speaker-phone":57554,"spellcheck":59598,"star":59448,"star-border":59450,"star-half":59449,"stars":59600,"stay-current-landscape":57555,"stay-current-portrait":57556,"stay-primary-landscape":57557,"stay-primary-portrait":57558,"stop":57415,"stop-screen-share":57571,"storage":57819,"store":59601,"store-mall-directory":58723,"straighten":58396,"streetview":58734,"strikethrough-s":57943,"style":58397,"subdirectory-arrow-left":58841,"subdirectory-arrow-right":58842,"subject":59602,"subscriptions":57444,"subtitles":57416,"subway":58735,"supervisor-account":59603,"surround-sound":57417,"swap-calls":57559,"swap-horiz":59604,"swap-vert":59605,"swap-vertical-circle":59606,"switch-camera":58398,"switch-video":58399,"sync":58919,"sync-disabled":58920,"sync-problem":58921,"system-update":58922,"system-update-alt":59607,"tab":59608,"tab-unselected":59609,"tablet":58159,"tablet-android":58160,"tablet-mac":58161,"tag-faces":58400,"tap-and-play":58923,"terrain":58724,"text-fields":57954,"text-format":57701,"textsms":57560,"texture":58401,"theaters":59610,"thumb-down":59611,"thumb-up":59612,"thumbs-up-down":59613,"time-to-leave":58924,"timelapse":58402,"timeline":59682,"timer":58405,"timer-10":58403,"timer-3":58404,"timer-off":58406,"title":57956,"toc":59614,"today":59615,"toll":59616,"tonality":58407,"touch-app":59667,"toys":58162,"track-changes":59617,"traffic":58725,"train":58736,"tram":58737,"transfer-within-a-station":58738,"transform":58408,"translate":59618,"trending-down":59619,"trending-flat":59620,"trending-up":59621,"tune":58409,"turned-in":59622,"turned-in-not":59623,"tv":58163,"unarchive":57705,"undo":57702,"unfold-less":58838,"unfold-more":58839,"update":59683,"usb":57824,"verified-user":59624,"vertical-align-bottom":57944,"vertical-align-center":57945,"vertical-align-top":57946,"vibration":58925,"video-call":57456,"video-label":57457,"video-library":57418,"videocam":57419,"videocam-off":57420,"videogame-asset":58168,"view-agenda":59625,"view-array":59626,"view-carousel":59627,"view-column":59628,"view-comfy":58410,"view-compact":58411,"view-day":59629,"view-headline":59630,"view-list":59631,"view-module":59632,"view-quilt":59633,"view-stream":59634,"view-week":59635,"vignette":58421,"visibility":59636,"visibility-off":59637,"voice-chat":58926,"voicemail":57561,"volume-down":57421,"volume-mute":57422,"volume-off":57423,"volume-up":57424,"vpn-key":57562,"vpn-lock":58927,"wallpaper":57788,"warning":57346,"watch":58164,"watch-later":59684,"wb-auto":58412,"wb-cloudy":58413,"wb-incandescent":58414,"wb-iridescent":58422,"wb-sunny":58416,"wc":58941,"web":57425,"web-asset":57449,"weekend":57707,"whatshot":59406,"widgets":57789,"wifi":58942,"wifi-lock":57825,"wifi-tethering":57826,"work":59641,"wrap-text":57947,"youtube-searched-for":59642,"zoom-in":59647,"zoom-out":59648,"zoom-out-map":58731}

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(24);var _createIconSet2=_interopRequireDefault(_createIconSet);var _MaterialCommunityIcons=__webpack_require__(579);var _MaterialCommunityIcons2=_interopRequireDefault(_MaterialCommunityIcons);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_MaterialCommunityIcons2.default,'Material Design Icons','MaterialCommunityIcons.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports = {"access-point":61442,"access-point-network":61443,"account":61444,"account-alert":61445,"account-box":61446,"account-box-outline":61447,"account-card-details":62930,"account-check":61448,"account-circle":61449,"account-convert":61450,"account-edit":63163,"account-key":61451,"account-location":61452,"account-minus":61453,"account-multiple":61454,"account-multiple-minus":62931,"account-multiple-outline":61455,"account-multiple-plus":61456,"account-network":61457,"account-off":61458,"account-outline":61459,"account-plus":61460,"account-remove":61461,"account-search":61462,"account-settings":63024,"account-settings-variant":63025,"account-star":61463,"account-switch":61465,"adjust":61466,"air-conditioner":61467,"airballoon":61468,"airplane":61469,"airplane-landing":62932,"airplane-off":61470,"airplane-takeoff":62933,"airplay":61471,"alarm":61472,"alarm-bell":63373,"alarm-check":61473,"alarm-light":63374,"alarm-multiple":61474,"alarm-off":61475,"alarm-plus":61476,"alarm-snooze":63117,"album":61477,"alert":61478,"alert-box":61479,"alert-circle":61480,"alert-circle-outline":62934,"alert-decagram":63164,"alert-octagon":61481,"alert-octagram":63334,"alert-outline":61482,"all-inclusive":63165,"alpha":61483,"alphabetical":61484,"altimeter":62935,"amazon":61485,"amazon-clouddrive":61486,"ambulance":61487,"amplifier":61488,"anchor":61489,"android":61490,"android-debug-bridge":61491,"android-head":63375,"android-studio":61492,"angular":63153,"angularjs":63166,"animation":62936,"apple":61493,"apple-finder":61494,"apple-ios":61495,"apple-keyboard-caps":63026,"apple-keyboard-command":63027,"apple-keyboard-control":63028,"apple-keyboard-option":63029,"apple-keyboard-shift":63030,"apple-mobileme":61496,"apple-safari":61497,"application":62996,"approval":63376,"apps":61499,"archive":61500,"arrange-bring-forward":61501,"arrange-bring-to-front":61502,"arrange-send-backward":61503,"arrange-send-to-back":61504,"arrow-all":61505,"arrow-bottom-left":61506,"arrow-bottom-right":61507,"arrow-collapse":62997,"arrow-collapse-all":61508,"arrow-collapse-down":63377,"arrow-collapse-left":63378,"arrow-collapse-right":63379,"arrow-collapse-up":63380,"arrow-down":61509,"arrow-down-bold":63277,"arrow-down-bold-box":63278,"arrow-down-bold-box-outline":63279,"arrow-down-bold-circle":61511,"arrow-down-bold-circle-outline":61512,"arrow-down-bold-hexagon-outline":61513,"arrow-down-box":63167,"arrow-down-drop-circle":61514,"arrow-down-drop-circle-outline":61515,"arrow-down-thick":61510,"arrow-expand":62998,"arrow-expand-all":61516,"arrow-expand-down":63381,"arrow-expand-left":63382,"arrow-expand-right":63383,"arrow-expand-up":63384,"arrow-left":61517,"arrow-left-bold":63280,"arrow-left-bold-box":63281,"arrow-left-bold-box-outline":63282,"arrow-left-bold-circle":61519,"arrow-left-bold-circle-outline":61520,"arrow-left-bold-hexagon-outline":61521,"arrow-left-box":63168,"arrow-left-drop-circle":61522,"arrow-left-drop-circle-outline":61523,"arrow-left-thick":61518,"arrow-right":61524,"arrow-right-bold":63283,"arrow-right-bold-box":63284,"arrow-right-bold-box-outline":63285,"arrow-right-bold-circle":61526,"arrow-right-bold-circle-outline":61527,"arrow-right-bold-hexagon-outline":61528,"arrow-right-box":63169,"arrow-right-drop-circle":61529,"arrow-right-drop-circle-outline":61530,"arrow-right-thick":61525,"arrow-top-left":61531,"arrow-top-right":61532,"arrow-up":61533,"arrow-up-bold":63286,"arrow-up-bold-box":63287,"arrow-up-bold-box-outline":63288,"arrow-up-bold-circle":61535,"arrow-up-bold-circle-outline":61536,"arrow-up-bold-hexagon-outline":61537,"arrow-up-box":63170,"arrow-up-drop-circle":61538,"arrow-up-drop-circle-outline":61539,"arrow-up-thick":61534,"assistant":61540,"asterisk":63171,"at":61541,"atom":63335,"attachment":61542,"audiobook":61543,"auto-fix":61544,"auto-upload":61545,"autorenew":61546,"av-timer":61547,"baby":61548,"baby-buggy":63118,"backburger":61549,"backspace":61550,"backup-restore":61551,"bandcamp":63092,"bank":61552,"barcode":61553,"barcode-scan":61554,"barley":61555,"barrel":61556,"basecamp":61557,"basket":61558,"basket-fill":61559,"basket-unfill":61560,"battery":61561,"battery-10":61562,"battery-20":61563,"battery-30":61564,"battery-40":61565,"battery-50":61566,"battery-60":61567,"battery-70":61568,"battery-80":61569,"battery-90":61570,"battery-alert":61571,"battery-charging":61572,"battery-charging-100":61573,"battery-charging-20":61574,"battery-charging-30":61575,"battery-charging-40":61576,"battery-charging-60":61577,"battery-charging-80":61578,"battery-charging-90":61579,"battery-minus":61580,"battery-negative":61581,"battery-outline":61582,"battery-plus":61583,"battery-positive":61584,"battery-unknown":61585,"beach":61586,"beaker":63119,"beats":61591,"beer":61592,"behance":61593,"bell":61594,"bell-off":61595,"bell-outline":61596,"bell-plus":61597,"bell-ring":61598,"bell-ring-outline":61599,"bell-sleep":61600,"beta":61601,"bible":61602,"bike":61603,"bing":61604,"binoculars":61605,"bio":61606,"biohazard":61607,"bitbucket":61608,"black-mesa":61609,"blackberry":61610,"blender":61611,"blinds":61612,"block-helper":61613,"blogger":61614,"bluetooth":61615,"bluetooth-audio":61616,"bluetooth-connect":61617,"bluetooth-off":61618,"bluetooth-settings":61619,"bluetooth-transfer":61620,"blur":61621,"blur-linear":61622,"blur-off":61623,"blur-radial":61624,"bomb":63120,"bomb-off":63172,"bone":61625,"book":61626,"book-minus":62937,"book-multiple":61627,"book-multiple-variant":61628,"book-open":61629,"book-open-page-variant":62938,"book-open-variant":61630,"book-plus":62939,"book-secure":63385,"book-unsecure":63386,"book-variant":61631,"bookmark":61632,"bookmark-check":61633,"bookmark-music":61634,"bookmark-outline":61635,"bookmark-plus":61637,"bookmark-plus-outline":61636,"bookmark-remove":61638,"boombox":62940,"bootstrap":63173,"border-all":61639,"border-bottom":61640,"border-color":61641,"border-horizontal":61642,"border-inside":61643,"border-left":61644,"border-none":61645,"border-outside":61646,"border-right":61647,"border-style":61648,"border-top":61649,"border-vertical":61650,"bow-tie":63095,"bowl":62999,"bowling":61651,"box":61652,"box-cutter":61653,"box-shadow":63031,"bridge":63000,"briefcase":61654,"briefcase-check":61655,"briefcase-download":61656,"briefcase-upload":61657,"brightness-1":61658,"brightness-2":61659,"brightness-3":61660,"brightness-4":61661,"brightness-5":61662,"brightness-6":61663,"brightness-7":61664,"brightness-auto":61665,"broom":61666,"brush":61667,"buffer":63001,"bug":61668,"bulletin-board":61669,"bullhorn":61670,"bullseye":62941,"burst-mode":62942,"bus":61671,"bus-articulated-end":63387,"bus-articulated-front":63388,"bus-double-decker":63389,"bus-school":63390,"bus-side":63391,"cached":61672,"cake":61673,"cake-layered":61674,"cake-variant":61675,"calculator":61676,"calendar":61677,"calendar-blank":61678,"calendar-check":61679,"calendar-clock":61680,"calendar-multiple":61681,"calendar-multiple-check":61682,"calendar-plus":61683,"calendar-question":63121,"calendar-range":63096,"calendar-remove":61684,"calendar-text":61685,"calendar-today":61686,"call-made":61687,"call-merge":61688,"call-missed":61689,"call-received":61690,"call-split":61691,"camcorder":61692,"camcorder-box":61693,"camcorder-box-off":61694,"camcorder-off":61695,"camera":61696,"camera-burst":63122,"camera-enhance":61697,"camera-front":61698,"camera-front-variant":61699,"camera-gopro":63392,"camera-iris":61700,"camera-metering-center":63393,"camera-metering-matrix":63394,"camera-metering-partial":63395,"camera-metering-spot":63396,"camera-off":62943,"camera-party-mode":61701,"camera-rear":61702,"camera-rear-variant":61703,"camera-switch":61704,"camera-timer":61705,"cancel":63289,"candle":62946,"candycane":61706,"cannabis":63397,"car":61707,"car-battery":61708,"car-connected":61709,"car-convertable":63398,"car-estate":63399,"car-hatchback":63400,"car-pickup":63401,"car-side":63402,"car-sports":63403,"car-wash":61710,"caravan":63404,"cards":63032,"cards-outline":63033,"cards-playing-outline":63034,"cards-variant":63174,"carrot":61711,"cart":61712,"cart-off":63083,"cart-outline":61713,"cart-plus":61714,"case-sensitive-alt":61715,"cash":61716,"cash-100":61717,"cash-multiple":61718,"cash-usd":61719,"cast":61720,"cast-connected":61721,"cast-off":63369,"castle":61722,"cat":61723,"cctv":63405,"ceiling-light":63336,"cellphone":61724,"cellphone-android":61725,"cellphone-basic":61726,"cellphone-dock":61727,"cellphone-iphone":61728,"cellphone-link":61729,"cellphone-link-off":61730,"cellphone-settings":61731,"certificate":61732,"chair-school":61733,"chart-arc":61734,"chart-areaspline":61735,"chart-bar":61736,"chart-bar-stacked":63337,"chart-bubble":62947,"chart-donut":63406,"chart-donut-variant":63407,"chart-gantt":63084,"chart-histogram":61737,"chart-line":61738,"chart-line-stacked":63338,"chart-line-variant":63408,"chart-pie":61739,"chart-scatterplot-hexbin":63085,"chart-timeline":63086,"check":61740,"check-all":61741,"check-circle":62944,"check-circle-outline":62945,"checkbox-blank":61742,"checkbox-blank-circle":61743,"checkbox-blank-circle-outline":61744,"checkbox-blank-outline":61745,"checkbox-marked":61746,"checkbox-marked-circle":61747,"checkbox-marked-circle-outline":61748,"checkbox-marked-outline":61749,"checkbox-multiple-blank":61750,"checkbox-multiple-blank-circle":63035,"checkbox-multiple-blank-circle-outline":63036,"checkbox-multiple-blank-outline":61751,"checkbox-multiple-marked":61752,"checkbox-multiple-marked-circle":63037,"checkbox-multiple-marked-circle-outline":63038,"checkbox-multiple-marked-outline":61753,"checkerboard":61754,"chemical-weapon":61755,"chevron-double-down":61756,"chevron-double-left":61757,"chevron-double-right":61758,"chevron-double-up":61759,"chevron-down":61760,"chevron-left":61761,"chevron-right":61762,"chevron-up":61763,"chili-hot":63409,"chili-medium":63410,"chili-mild":63411,"chip":63002,"church":61764,"circle":63332,"circle-outline":63333,"cisco-webex":61765,"city":61766,"clipboard":61767,"clipboard-account":61768,"clipboard-alert":61769,"clipboard-arrow-down":61770,"clipboard-arrow-left":61771,"clipboard-check":61772,"clipboard-flow":63175,"clipboard-outline":61773,"clipboard-plus":63312,"clipboard-text":61774,"clippy":61775,"clock":61776,"clock-alert":62926,"clock-end":61777,"clock-fast":61778,"clock-in":61779,"clock-out":61780,"clock-start":61781,"close":61782,"close-box":61783,"close-box-outline":61784,"close-circle":61785,"close-circle-outline":61786,"close-network":61787,"close-octagon":61788,"close-octagon-outline":61789,"close-outline":63176,"closed-caption":61790,"cloud":61791,"cloud-braces":63412,"cloud-check":61792,"cloud-circle":61793,"cloud-download":61794,"cloud-off-outline":61796,"cloud-outline":61795,"cloud-print":61797,"cloud-print-outline":61798,"cloud-sync":63039,"cloud-tags":63413,"cloud-upload":61799,"code-array":61800,"code-braces":61801,"code-brackets":61802,"code-equal":61803,"code-greater-than":61804,"code-greater-than-or-equal":61805,"code-less-than":61806,"code-less-than-or-equal":61807,"code-not-equal":61808,"code-not-equal-variant":61809,"code-parentheses":61810,"code-string":61811,"code-tags":61812,"code-tags-check":63123,"codepen":61813,"coffee":61814,"coffee-outline":63177,"coffee-to-go":61815,"coin":61816,"coins":63124,"collage":63040,"color-helper":61817,"comment":61818,"comment-account":61819,"comment-account-outline":61820,"comment-alert":61821,"comment-alert-outline":61822,"comment-check":61823,"comment-check-outline":61824,"comment-multiple-outline":61825,"comment-outline":61826,"comment-plus-outline":61827,"comment-processing":61828,"comment-processing-outline":61829,"comment-question-outline":61830,"comment-remove-outline":61831,"comment-text":61832,"comment-text-outline":61833,"compare":61834,"compass":61835,"compass-outline":61836,"console":61837,"console-line":63414,"contact-mail":61838,"contacts":63178,"content-copy":61839,"content-cut":61840,"content-duplicate":61841,"content-paste":61842,"content-save":61843,"content-save-all":61844,"content-save-settings":63003,"contrast":61845,"contrast-box":61846,"contrast-circle":61847,"cookie":61848,"copyright":62950,"corn":63415,"counter":61849,"cow":61850,"creation":61897,"credit-card":61851,"credit-card-multiple":61852,"credit-card-off":62948,"credit-card-plus":63093,"credit-card-scan":61853,"crop":61854,"crop-free":61855,"crop-landscape":61856,"crop-portrait":61857,"crop-rotate":63125,"crop-square":61858,"crosshairs":61859,"crosshairs-gps":61860,"crown":61861,"cube":61862,"cube-outline":61863,"cube-send":61864,"cube-unfolded":61865,"cup":61866,"cup-off":62949,"cup-water":61867,"currency-btc":61868,"currency-chf":63416,"currency-cny":63417,"currency-eth":63418,"currency-eur":61869,"currency-gbp":61870,"currency-inr":61871,"currency-jpy":63419,"currency-krw":63420,"currency-ngn":61872,"currency-rub":61873,"currency-sign":63421,"currency-try":61874,"currency-twd":63422,"currency-usd":61875,"currency-usd-off":63097,"cursor-default":61876,"cursor-default-outline":61877,"cursor-move":61878,"cursor-pointer":61879,"cursor-text":62951,"database":61880,"database-minus":61881,"database-plus":61882,"debug-step-into":61883,"debug-step-out":61884,"debug-step-over":61885,"decagram":63339,"decagram-outline":63340,"decimal-decrease":61886,"decimal-increase":61887,"delete":61888,"delete-circle":63106,"delete-empty":63179,"delete-forever":62952,"delete-sweep":62953,"delete-variant":61889,"delta":61890,"deskphone":61891,"desktop-classic":63423,"desktop-mac":61892,"desktop-tower":61893,"details":61894,"developer-board":63126,"deviantart":61895,"dialpad":63004,"diamond":61896,"dice-1":61898,"dice-2":61899,"dice-3":61900,"dice-4":61901,"dice-5":61902,"dice-6":61903,"dice-d10":63342,"dice-d20":62954,"dice-d4":62955,"dice-d6":62956,"dice-d8":62957,"dice-multiple":63341,"dictionary":63005,"dip-switch":63424,"directions":61904,"directions-fork":63041,"discord":63087,"disk":62958,"disk-alert":61905,"disqus":61906,"disqus-outline":61907,"division":61908,"division-box":61909,"dna":63107,"dns":61910,"do-not-disturb":63127,"do-not-disturb-off":63128,"dolby":63154,"domain":61911,"donkey":63425,"dots-horizontal":61912,"dots-horizontal-circle":63426,"dots-vertical":61913,"dots-vertical-circle":63427,"douban":63129,"download":61914,"download-network":63219,"drag":61915,"drag-horizontal":61916,"drag-vertical":61917,"drawing":61918,"drawing-box":61919,"dribbble":61920,"dribbble-box":61921,"drone":61922,"dropbox":61923,"drupal":61924,"duck":61925,"dumbbell":61926,"ear-hearing":63428,"earth":61927,"earth-box":63180,"earth-box-off":63181,"earth-off":61928,"edge":61929,"eject":61930,"elephant":63429,"elevation-decline":61931,"elevation-rise":61932,"elevator":61933,"email":61934,"email-alert":63182,"email-open":61935,"email-open-outline":62959,"email-outline":61936,"email-secure":61937,"email-variant":62960,"emby":63155,"emoticon":61938,"emoticon-cool":61939,"emoticon-dead":63130,"emoticon-devil":61940,"emoticon-excited":63131,"emoticon-happy":61941,"emoticon-neutral":61942,"emoticon-poop":61943,"emoticon-sad":61944,"emoticon-tongue":61945,"engine":61946,"engine-outline":61947,"equal":61948,"equal-box":61949,"eraser":61950,"eraser-variant":63042,"escalator":61951,"ethernet":61952,"ethernet-cable":61953,"ethernet-cable-off":61954,"etsy":61955,"ev-station":62961,"eventbrite":63430,"evernote":61956,"exclamation":61957,"exit-to-app":61958,"export":61959,"eye":61960,"eye-off":61961,"eye-off-outline":63184,"eye-outline":63183,"eyedropper":61962,"eyedropper-variant":61963,"face":63043,"face-profile":63044,"facebook":61964,"facebook-box":61965,"facebook-messenger":61966,"factory":61967,"fan":61968,"fast-forward":61969,"fast-forward-outline":63185,"fax":61970,"feather":63186,"ferry":61971,"file":61972,"file-account":63290,"file-chart":61973,"file-check":61974,"file-cloud":61975,"file-delimited":61976,"file-document":61977,"file-document-box":61978,"file-excel":61979,"file-excel-box":61980,"file-export":61981,"file-find":61982,"file-hidden":62995,"file-image":61983,"file-import":61984,"file-lock":61985,"file-multiple":61986,"file-music":61987,"file-outline":61988,"file-pdf":61989,"file-pdf-box":61990,"file-plus":63313,"file-powerpoint":61991,"file-powerpoint-box":61992,"file-presentation-box":61993,"file-restore":63088,"file-send":61994,"file-tree":63045,"file-video":61995,"file-word":61996,"file-word-box":61997,"file-xml":61998,"film":61999,"filmstrip":62000,"filmstrip-off":62001,"filter":62002,"filter-outline":62003,"filter-remove":62004,"filter-remove-outline":62005,"filter-variant":62006,"find-replace":63187,"fingerprint":62007,"fire":62008,"firefox":62009,"fish":62010,"flag":62011,"flag-checkered":62012,"flag-outline":62013,"flag-outline-variant":62014,"flag-triangle":62015,"flag-variant":62016,"flash":62017,"flash-auto":62018,"flash-off":62019,"flash-outline":63188,"flash-red-eye":63098,"flashlight":62020,"flashlight-off":62021,"flask":61587,"flask-empty":61588,"flask-empty-outline":61589,"flask-outline":61590,"flattr":62022,"flip-to-back":62023,"flip-to-front":62024,"floppy":62025,"flower":62026,"folder":62027,"folder-account":62028,"folder-download":62029,"folder-google-drive":62030,"folder-image":62031,"folder-lock":62032,"folder-lock-open":62033,"folder-move":62034,"folder-multiple":62035,"folder-multiple-image":62036,"folder-multiple-outline":62037,"folder-open":63343,"folder-outline":62038,"folder-plus":62039,"folder-remove":62040,"folder-star":63132,"folder-upload":62041,"font-awesome":61498,"food":62042,"food-apple":62043,"food-croissant":63431,"food-fork-drink":62962,"food-off":62963,"food-variant":62044,"football":62045,"football-australian":62046,"football-helmet":62047,"forklift":63432,"format-align-bottom":63314,"format-align-center":62048,"format-align-justify":62049,"format-align-left":62050,"format-align-middle":63315,"format-align-right":62051,"format-align-top":63316,"format-annotation-plus":63046,"format-bold":62052,"format-clear":62053,"format-color-fill":62054,"format-color-text":63133,"format-float-center":62055,"format-float-left":62056,"format-float-none":62057,"format-float-right":62058,"format-font":63189,"format-header-1":62059,"format-header-2":62060,"format-header-3":62061,"format-header-4":62062,"format-header-5":62063,"format-header-6":62064,"format-header-decrease":62065,"format-header-equal":62066,"format-header-increase":62067,"format-header-pound":62068,"format-horizontal-align-center":63006,"format-horizontal-align-left":63007,"format-horizontal-align-right":63008,"format-indent-decrease":62069,"format-indent-increase":62070,"format-italic":62071,"format-line-spacing":62072,"format-line-style":62920,"format-line-weight":62921,"format-list-bulleted":62073,"format-list-bulleted-type":62074,"format-list-checks":63317,"format-list-numbers":62075,"format-page-break":63190,"format-paint":62076,"format-paragraph":62077,"format-pilcrow":63191,"format-quote-close":62078,"format-quote-open":63318,"format-rotate-90":63145,"format-section":63134,"format-size":62079,"format-strikethrough":62080,"format-strikethrough-variant":62081,"format-subscript":62082,"format-superscript":62083,"format-text":62084,"format-textdirection-l-to-r":62085,"format-textdirection-r-to-l":62086,"format-title":62964,"format-underline":62087,"format-vertical-align-bottom":63009,"format-vertical-align-center":63010,"format-vertical-align-top":63011,"format-wrap-inline":62088,"format-wrap-square":62089,"format-wrap-tight":62090,"format-wrap-top-bottom":62091,"forum":62092,"forward":62093,"foursquare":62094,"fridge":62095,"fridge-filled":62096,"fridge-filled-bottom":62097,"fridge-filled-top":62098,"fuel":63433,"fullscreen":62099,"fullscreen-exit":62100,"function":62101,"gamepad":62102,"gamepad-variant":62103,"garage":63192,"garage-open":63193,"gas-cylinder":63047,"gas-station":62104,"gate":62105,"gauge":62106,"gavel":62107,"gender-female":62108,"gender-male":62109,"gender-male-female":62110,"gender-transgender":62111,"gesture":63434,"gesture-double-tap":63291,"gesture-swipe-down":63292,"gesture-swipe-left":63293,"gesture-swipe-right":63294,"gesture-swipe-up":63295,"gesture-tap":63296,"gesture-two-double-tap":63297,"gesture-two-tap":63298,"ghost":62112,"gift":62113,"git":62114,"github-box":62115,"github-circle":62116,"github-face":63194,"glass-flute":62117,"glass-mug":62118,"glass-stange":62119,"glass-tulip":62120,"glassdoor":62121,"glasses":62122,"gmail":62123,"gnome":62124,"gondola":63109,"google":62125,"google-analytics":63435,"google-assistant":63436,"google-cardboard":62126,"google-chrome":62127,"google-circles":62128,"google-circles-communities":62129,"google-circles-extended":62130,"google-circles-group":62131,"google-controller":62132,"google-controller-off":62133,"google-drive":62134,"google-earth":62135,"google-glass":62136,"google-keep":63195,"google-maps":62965,"google-nearby":62137,"google-pages":62138,"google-photos":63196,"google-physical-web":62139,"google-play":62140,"google-plus":62141,"google-plus-box":62142,"google-translate":62143,"google-wallet":62144,"gradient":63135,"grease-pencil":63048,"grid":62145,"grid-large":63319,"grid-off":62146,"group":62147,"guitar-acoustic":63344,"guitar-electric":62148,"guitar-pick":62149,"guitar-pick-outline":62150,"hackernews":63012,"hamburger":63108,"hand-pointing-right":62151,"hanger":62152,"hangouts":62153,"harddisk":62154,"headphones":62155,"headphones-box":62156,"headphones-off":63437,"headphones-settings":62157,"headset":62158,"headset-dock":62159,"headset-off":62160,"heart":62161,"heart-box":62162,"heart-box-outline":62163,"heart-broken":62164,"heart-half":63198,"heart-half-full":63197,"heart-half-outline":63199,"heart-off":63320,"heart-outline":62165,"heart-pulse":62966,"help":62166,"help-box":63370,"help-circle":62167,"help-circle-outline":63013,"help-network":63220,"hexagon":62168,"hexagon-multiple":63200,"hexagon-outline":62169,"high-definition":63438,"highway":62967,"history":62170,"hololens":62171,"home":62172,"home-assistant":63439,"home-automation":63440,"home-circle":63441,"home-map-marker":62968,"home-modern":62173,"home-outline":63136,"home-variant":62174,"hook":63201,"hook-off":63202,"hops":62175,"hospital":62176,"hospital-building":62177,"hospital-marker":62178,"hotel":62179,"houzz":62180,"houzz-box":62181,"human":62182,"human-child":62183,"human-female":63049,"human-greeting":63050,"human-handsdown":63051,"human-handsup":63052,"human-male":63053,"human-male-female":62184,"human-pregnant":62927,"humble-bundle":63299,"image":62185,"image-album":62186,"image-area":62187,"image-area-close":62188,"image-broken":62189,"image-broken-variant":62190,"image-filter":62191,"image-filter-black-white":62192,"image-filter-center-focus":62193,"image-filter-center-focus-weak":62194,"image-filter-drama":62195,"image-filter-frames":62196,"image-filter-hdr":62197,"image-filter-none":62198,"image-filter-tilt-shift":62199,"image-filter-vintage":62200,"image-multiple":62201,"import":62202,"inbox":63110,"inbox-arrow-down":62203,"inbox-arrow-up":62417,"incognito":62969,"infinity":63203,"information":62204,"information-outline":62205,"information-variant":63054,"instagram":62206,"instapaper":62207,"internet-explorer":62208,"invert-colors":62209,"itunes":63094,"jeepney":62210,"jira":62211,"jsfiddle":62212,"json":63014,"keg":62213,"kettle":62970,"key":62214,"key-change":62215,"key-minus":62216,"key-plus":62217,"key-remove":62218,"key-variant":62219,"keyboard":62220,"keyboard-backspace":62221,"keyboard-caps":62222,"keyboard-close":62223,"keyboard-off":62224,"keyboard-return":62225,"keyboard-tab":62226,"keyboard-variant":62227,"kickstarter":63300,"kodi":62228,"label":62229,"label-outline":62230,"lambda":63015,"lamp":63156,"lan":62231,"lan-connect":62232,"lan-disconnect":62233,"lan-pending":62234,"language-c":63089,"language-cpp":63090,"language-csharp":62235,"language-css3":62236,"language-go":63442,"language-html5":62237,"language-javascript":62238,"language-php":62239,"language-python":62240,"language-python-text":62241,"language-r":63443,"language-swift":63204,"language-typescript":63205,"laptop":62242,"laptop-chromebook":62243,"laptop-mac":62244,"laptop-off":63206,"laptop-windows":62245,"lastfm":62246,"launch":62247,"lava-lamp":63444,"layers":62248,"layers-off":62249,"lead-pencil":63055,"leaf":62250,"led-off":62251,"led-on":62252,"led-outline":62253,"led-strip":63445,"led-variant-off":62254,"led-variant-on":62255,"led-variant-outline":62256,"library":62257,"library-books":62258,"library-music":62259,"library-plus":62260,"lightbulb":62261,"lightbulb-on":63207,"lightbulb-on-outline":63208,"lightbulb-outline":62262,"link":62263,"link-off":62264,"link-variant":62265,"link-variant-off":62266,"linkedin":62267,"linkedin-box":62268,"linux":62269,"loading":63345,"lock":62270,"lock-open":62271,"lock-open-outline":62272,"lock-outline":62273,"lock-pattern":63209,"lock-plus":62971,"lock-reset":63346,"locker":63446,"locker-multiple":63447,"login":62274,"login-variant":62972,"logout":62275,"logout-variant":62973,"looks":62276,"loop":63210,"loupe":62277,"lumx":62278,"magnet":62279,"magnet-on":62280,"magnify":62281,"magnify-minus":62282,"magnify-minus-outline":63211,"magnify-plus":62283,"magnify-plus-outline":63212,"mail-ru":62284,"mailbox":63213,"map":62285,"map-marker":62286,"map-marker-circle":62287,"map-marker-minus":63056,"map-marker-multiple":62288,"map-marker-off":62289,"map-marker-outline":63448,"map-marker-plus":63057,"map-marker-radius":62290,"margin":62291,"markdown":62292,"marker":63058,"marker-check":62293,"martini":62294,"material-ui":62295,"math-compass":62296,"matrix":63016,"maxcdn":62297,"medical-bag":63214,"medium":62298,"memory":62299,"menu":62300,"menu-down":62301,"menu-down-outline":63157,"menu-left":62302,"menu-right":62303,"menu-up":62304,"menu-up-outline":63158,"message":62305,"message-alert":62306,"message-bulleted":63137,"message-bulleted-off":63138,"message-draw":62307,"message-image":62308,"message-outline":62309,"message-plus":63059,"message-processing":62310,"message-reply":62311,"message-reply-text":62312,"message-settings":63215,"message-settings-variant":63216,"message-text":62313,"message-text-outline":62314,"message-video":62315,"meteor":63017,"metronome":63449,"metronome-tick":63450,"micro-sd":63451,"microphone":62316,"microphone-off":62317,"microphone-outline":62318,"microphone-settings":62319,"microphone-variant":62320,"microphone-variant-off":62321,"microscope":63060,"microsoft":62322,"minecraft":62323,"minus":62324,"minus-box":62325,"minus-box-outline":63217,"minus-circle":62326,"minus-circle-outline":62327,"minus-network":62328,"mixcloud":63018,"mixer":63452,"monitor":62329,"monitor-multiple":62330,"more":62331,"motorbike":62332,"mouse":62333,"mouse-off":62334,"mouse-variant":62335,"mouse-variant-off":62336,"move-resize":63061,"move-resize-variant":63062,"movie":62337,"movie-roll":63453,"multiplication":62338,"multiplication-box":62339,"mushroom":63454,"mushroom-outline":63455,"music":63321,"music-box":62340,"music-box-outline":62341,"music-circle":62342,"music-note":62343,"music-note-bluetooth":62974,"music-note-bluetooth-off":62975,"music-note-eighth":62344,"music-note-half":62345,"music-note-off":62346,"music-note-quarter":62347,"music-note-sixteenth":62348,"music-note-whole":62349,"music-off":63322,"nature":62350,"nature-people":62351,"navigation":62352,"near-me":62925,"needle":62353,"nest-protect":62354,"nest-thermostat":62355,"netflix":63301,"network":63218,"new-box":62356,"newspaper":62357,"nfc":62358,"nfc-tap":62359,"nfc-variant":62360,"ninja":63347,"nintendo-switch":63456,"nodejs":62361,"note":62362,"note-multiple":63159,"note-multiple-outline":63160,"note-outline":62363,"note-plus":62364,"note-plus-outline":62365,"note-text":62366,"notification-clear-all":62367,"npm":63222,"nuke":63139,"null":63457,"numeric":62368,"numeric-0-box":62369,"numeric-0-box-multiple-outline":62370,"numeric-0-box-outline":62371,"numeric-1-box":62372,"numeric-1-box-multiple-outline":62373,"numeric-1-box-outline":62374,"numeric-2-box":62375,"numeric-2-box-multiple-outline":62376,"numeric-2-box-outline":62377,"numeric-3-box":62378,"numeric-3-box-multiple-outline":62379,"numeric-3-box-outline":62380,"numeric-4-box":62381,"numeric-4-box-multiple-outline":62382,"numeric-4-box-outline":62383,"numeric-5-box":62384,"numeric-5-box-multiple-outline":62385,"numeric-5-box-outline":62386,"numeric-6-box":62387,"numeric-6-box-multiple-outline":62388,"numeric-6-box-outline":62389,"numeric-7-box":62390,"numeric-7-box-multiple-outline":62391,"numeric-7-box-outline":62392,"numeric-8-box":62393,"numeric-8-box-multiple-outline":62394,"numeric-8-box-outline":62395,"numeric-9-box":62396,"numeric-9-box-multiple-outline":62397,"numeric-9-box-outline":62398,"numeric-9-plus-box":62399,"numeric-9-plus-box-multiple-outline":62400,"numeric-9-plus-box-outline":62401,"nut":63223,"nutrition":62402,"oar":63099,"octagon":62403,"octagon-outline":62404,"octagram":63224,"octagram-outline":63348,"odnoklassniki":62405,"office":62406,"oil":62407,"oil-temperature":62408,"omega":62409,"onedrive":62410,"onenote":63302,"opacity":62924,"open-in-app":62411,"open-in-new":62412,"openid":62413,"opera":62414,"orbit":61464,"ornament":62415,"ornament-variant":62416,"owl":62418,"package":62419,"package-down":62420,"package-up":62421,"package-variant":62422,"package-variant-closed":62423,"page-first":62976,"page-last":62977,"page-layout-body":63225,"page-layout-footer":63226,"page-layout-header":63227,"page-layout-sidebar-left":63228,"page-layout-sidebar-right":63229,"palette":62424,"palette-advanced":62425,"panda":62426,"pandora":62427,"panorama":62428,"panorama-fisheye":62429,"panorama-horizontal":62430,"panorama-vertical":62431,"panorama-wide-angle":62432,"paper-cut-vertical":62433,"paperclip":62434,"parking":62435,"passport":63458,"pause":62436,"pause-circle":62437,"pause-circle-outline":62438,"pause-octagon":62439,"pause-octagon-outline":62440,"paw":62441,"paw-off":63063,"pen":62442,"pencil":62443,"pencil-box":62444,"pencil-box-outline":62445,"pencil-circle":63230,"pencil-circle-outline":63349,"pencil-lock":62446,"pencil-off":62447,"pentagon":63231,"pentagon-outline":63232,"percent":62448,"periodic-table-co2":63459,"periscope":63303,"pharmacy":62449,"phone":62450,"phone-bluetooth":62451,"phone-classic":62978,"phone-forward":62452,"phone-hangup":62453,"phone-in-talk":62454,"phone-incoming":62455,"phone-locked":62456,"phone-log":62457,"phone-minus":63064,"phone-missed":62458,"phone-outgoing":62459,"phone-paused":62460,"phone-plus":63065,"phone-settings":62461,"phone-voip":62462,"pi":62463,"pi-box":62464,"piano":63100,"pig":62465,"pill":62466,"pillar":63233,"pin":62467,"pin-off":62468,"pine-tree":62469,"pine-tree-box":62470,"pinterest":62471,"pinterest-box":62472,"pipe":63460,"pipe-disconnected":63461,"pistol":63234,"pizza":62473,"plane-shield":63162,"play":62474,"play-box-outline":62475,"play-circle":62476,"play-circle-outline":62477,"play-pause":62478,"play-protected-content":62479,"playlist-check":62919,"playlist-minus":62480,"playlist-play":62481,"playlist-plus":62482,"playlist-remove":62483,"playstation":62484,"plex":63161,"plus":62485,"plus-box":62486,"plus-box-outline":63235,"plus-circle":62487,"plus-circle-multiple-outline":62488,"plus-circle-outline":62489,"plus-network":62490,"plus-one":62491,"plus-outline":63236,"pocket":62492,"pokeball":62493,"polaroid":62494,"poll":62495,"poll-box":62496,"polymer":62497,"pool":62982,"popcorn":62498,"pot":63066,"pot-mix":63067,"pound":62499,"pound-box":62500,"power":62501,"power-plug":63140,"power-plug-off":63141,"power-settings":62502,"power-socket":62503,"power-socket-eu":63462,"power-socket-uk":63463,"power-socket-us":63464,"prescription":63237,"presentation":62504,"presentation-play":62505,"printer":62506,"printer-3d":62507,"printer-alert":62508,"printer-settings":63238,"priority-high":62979,"priority-low":62980,"professional-hexagon":62509,"projector":62510,"projector-screen":62511,"publish":63142,"pulse":62512,"puzzle":62513,"qqchat":62981,"qrcode":62514,"qrcode-scan":62515,"quadcopter":62516,"quality-high":62517,"quicktime":62518,"radar":62519,"radiator":62520,"radio":62521,"radio-handheld":62522,"radio-tower":62523,"radioactive":62524,"radiobox-blank":62525,"radiobox-marked":62526,"raspberrypi":62527,"ray-end":62528,"ray-end-arrow":62529,"ray-start":62530,"ray-start-arrow":62531,"ray-start-end":62532,"ray-vertex":62533,"rdio":62534,"react":63239,"read":62535,"readability":62536,"receipt":62537,"record":62538,"record-rec":62539,"recycle":62540,"reddit":62541,"redo":62542,"redo-variant":62543,"refresh":62544,"regex":62545,"relative-scale":62546,"reload":62547,"remote":62548,"rename-box":62549,"reorder-horizontal":63111,"reorder-vertical":63112,"repeat":62550,"repeat-off":62551,"repeat-once":62552,"replay":62553,"reply":62554,"reply-all":62555,"reproduction":62556,"resize-bottom-right":62557,"responsive":62558,"restart":63240,"restore":63143,"rewind":62559,"rewind-outline":63241,"rhombus":63242,"rhombus-outline":63243,"ribbon":62560,"rice":63465,"ring":63466,"road":62561,"road-variant":62562,"robot":63144,"rocket":62563,"roomba":63244,"rotate-3d":62564,"rotate-left":62565,"rotate-left-variant":62566,"rotate-right":62567,"rotate-right-variant":62568,"rounded-corner":62983,"router-wireless":62569,"routes":62570,"rowing":62984,"rss":62571,"rss-box":62572,"ruler":62573,"run":63245,"run-fast":62574,"sale":62575,"sass":63467,"satellite":62576,"satellite-variant":62577,"saxophone":62985,"scale":62578,"scale-balance":62929,"scale-bathroom":62579,"scanner":63146,"school":62580,"screen-rotation":62581,"screen-rotation-lock":62582,"screwdriver":62583,"script":62584,"sd":62585,"seal":62586,"search-web":63246,"seat-flat":62587,"seat-flat-angled":62588,"seat-individual-suite":62589,"seat-legroom-extra":62590,"seat-legroom-normal":62591,"seat-legroom-reduced":62592,"seat-recline-extra":62593,"seat-recline-normal":62594,"security":62595,"security-home":63113,"security-network":62596,"select":62597,"select-all":62598,"select-inverse":62599,"select-off":62600,"selection":62601,"selection-off":63350,"send":62602,"send-secure":63468,"serial-port":63068,"server":62603,"server-minus":62604,"server-network":62605,"server-network-off":62606,"server-off":62607,"server-plus":62608,"server-remove":62609,"server-security":62610,"set-all":63351,"set-center":63352,"set-center-right":63353,"set-left":63354,"set-left-center":63355,"set-left-right":63356,"set-none":63357,"set-right":63358,"settings":62611,"settings-box":62612,"shape-circle-plus":63069,"shape-plus":62613,"shape-polygon-plus":63070,"shape-rectangle-plus":63071,"shape-square-plus":63072,"share":62614,"share-variant":62615,"shield":62616,"shield-half-full":63359,"shield-outline":62617,"shopping":62618,"shopping-music":62619,"shovel":63247,"shovel-off":63248,"shredder":62620,"shuffle":62621,"shuffle-disabled":62622,"shuffle-variant":62623,"sigma":62624,"sigma-lower":63019,"sign-caution":62625,"sign-direction":63360,"sign-text":63361,"signal":62626,"signal-2g":63249,"signal-3g":63250,"signal-4g":63251,"signal-hspa":63252,"signal-hspa-plus":63253,"signal-off":63362,"signal-variant":62986,"silverware":62627,"silverware-fork":62628,"silverware-spoon":62629,"silverware-variant":62630,"sim":62631,"sim-alert":62632,"sim-off":62633,"sitemap":62634,"skip-backward":62635,"skip-forward":62636,"skip-next":62637,"skip-next-circle":63073,"skip-next-circle-outline":63074,"skip-previous":62638,"skip-previous-circle":63075,"skip-previous-circle-outline":63076,"skull":63115,"skype":62639,"skype-business":62640,"slack":62641,"sleep":62642,"sleep-off":62643,"smoking":62644,"smoking-off":62645,"snapchat":62646,"snowflake":63254,"snowman":62647,"soccer":62648,"sofa":62649,"solid":63116,"sort":62650,"sort-alphabetical":62651,"sort-ascending":62652,"sort-descending":62653,"sort-numeric":62654,"sort-variant":62655,"soundcloud":62656,"source-branch":63020,"source-commit":63255,"source-commit-end":63256,"source-commit-end-local":63257,"source-commit-local":63258,"source-commit-next-local":63259,"source-commit-start":63260,"source-commit-start-next-local":63261,"source-fork":62657,"source-merge":63021,"source-pull":62658,"soy-sauce":63469,"speaker":62659,"speaker-off":62660,"speaker-wireless":63262,"speedometer":62661,"spellcheck":62662,"spotify":62663,"spotlight":62664,"spotlight-beam":62665,"spray":63077,"square":63331,"square-inc":62666,"square-inc-cash":62667,"square-outline":63330,"square-root":63363,"stackexchange":62987,"stackoverflow":62668,"stadium":63263,"stairs":62669,"standard-definition":63470,"star":62670,"star-circle":62671,"star-half":62672,"star-off":62673,"star-outline":62674,"steam":62675,"steering":62676,"step-backward":62677,"step-backward-2":62678,"step-forward":62679,"step-forward-2":62680,"stethoscope":62681,"sticker":62928,"sticker-emoji":63364,"stocking":62682,"stop":62683,"stop-circle":63078,"stop-circle-outline":63079,"store":62684,"store-24-hour":62685,"stove":62686,"subdirectory-arrow-left":62988,"subdirectory-arrow-right":62989,"subway":63147,"subway-variant":62687,"summit":63365,"sunglasses":62688,"surround-sound":62917,"surround-sound-2-0":63471,"surround-sound-3-1":63472,"surround-sound-5-1":63473,"surround-sound-7-1":63474,"svg":63264,"swap-horizontal":62689,"swap-vertical":62690,"swim":62691,"switch":62692,"sword":62693,"sword-cross":63366,"sync":62694,"sync-alert":62695,"sync-off":62696,"tab":62697,"tab-plus":63323,"tab-unselected":62698,"table":62699,"table-column-plus-after":62700,"table-column-plus-before":62701,"table-column-remove":62702,"table-column-width":62703,"table-edit":62704,"table-large":62705,"table-row-height":62706,"table-row-plus-after":62707,"table-row-plus-before":62708,"table-row-remove":62709,"tablet":62710,"tablet-android":62711,"tablet-ipad":62712,"taco":63329,"tag":62713,"tag-faces":62714,"tag-heart":63114,"tag-multiple":62715,"tag-outline":62716,"tag-plus":63265,"tag-remove":63266,"tag-text-outline":62717,"target":62718,"taxi":62719,"teamviewer":62720,"telegram":62721,"television":62722,"television-classic":63475,"television-guide":62723,"temperature-celsius":62724,"temperature-fahrenheit":62725,"temperature-kelvin":62726,"tennis":62727,"tent":62728,"terrain":62729,"test-tube":63080,"text-shadow":63081,"text-to-speech":62730,"text-to-speech-off":62731,"textbox":62990,"textbox-password":63476,"texture":62732,"theater":62733,"theme-light-dark":62734,"thermometer":62735,"thermometer-lines":62736,"thought-bubble":63477,"thought-bubble-outline":63478,"thumb-down":62737,"thumb-down-outline":62738,"thumb-up":62739,"thumb-up-outline":62740,"thumbs-up-down":62741,"ticket":62742,"ticket-account":62743,"ticket-confirmation":62744,"ticket-percent":63267,"tie":62745,"tilde":63268,"timelapse":62746,"timer":62747,"timer-10":62748,"timer-3":62749,"timer-off":62750,"timer-sand":62751,"timer-sand-empty":63148,"timer-sand-full":63371,"timetable":62752,"toggle-switch":62753,"toggle-switch-off":62754,"tooltip":62755,"tooltip-edit":62756,"tooltip-image":62757,"tooltip-outline":62758,"tooltip-outline-plus":62759,"tooltip-text":62760,"tooth":62761,"tor":62762,"tower-beach":63104,"tower-fire":63105,"trackpad":63479,"traffic-light":62763,"train":62764,"tram":62765,"transcribe":62766,"transcribe-close":62767,"transfer":62768,"transit-transfer":63149,"translate":62922,"treasure-chest":63269,"tree":62769,"trello":62770,"trending-down":62771,"trending-neutral":62772,"trending-up":62773,"triangle":62774,"triangle-outline":62775,"trophy":62776,"trophy-award":62777,"trophy-outline":62778,"trophy-variant":62779,"trophy-variant-outline":62780,"truck":62781,"truck-delivery":62782,"truck-fast":63367,"truck-trailer":63270,"tshirt-crew":62783,"tshirt-v":62784,"tumblr":62785,"tumblr-reblog":62786,"tune":63022,"tune-vertical":63082,"twitch":62787,"twitter":62788,"twitter-box":62789,"twitter-circle":62790,"twitter-retweet":62791,"uber":63304,"ubuntu":62792,"ultra-high-definition":63480,"umbraco":62793,"umbrella":62794,"umbrella-outline":62795,"undo":62796,"undo-variant":62797,"unfold-less-horizontal":62798,"unfold-less-vertical":63327,"unfold-more-horizontal":62799,"unfold-more-vertical":63328,"ungroup":62800,"unity":63150,"untappd":62801,"update":63151,"upload":62802,"upload-network":63221,"usb":62803,"van-passenger":63481,"van-utility":63482,"vanish":63483,"vector-arrange-above":62804,"vector-arrange-below":62805,"vector-circle":62806,"vector-circle-variant":62807,"vector-combine":62808,"vector-curve":62809,"vector-difference":62810,"vector-difference-ab":62811,"vector-difference-ba":62812,"vector-intersection":62813,"vector-line":62814,"vector-point":62815,"vector-polygon":62816,"vector-polyline":62817,"vector-radius":63305,"vector-rectangle":62918,"vector-selection":62818,"vector-square":61441,"vector-triangle":62819,"vector-union":62820,"verified":62821,"vibrate":62822,"video":62823,"video-3d":63484,"video-off":62824,"video-switch":62825,"view-agenda":62826,"view-array":62827,"view-carousel":62828,"view-column":62829,"view-dashboard":62830,"view-day":62831,"view-grid":62832,"view-headline":62833,"view-list":62834,"view-module":62835,"view-parallel":63271,"view-quilt":62836,"view-sequential":63272,"view-stream":62837,"view-week":62838,"vimeo":62839,"vine":62840,"violin":62991,"visualstudio":62992,"vk":62841,"vk-box":62842,"vk-circle":62843,"vlc":62844,"voice":62923,"voicemail":62845,"volume-high":62846,"volume-low":62847,"volume-medium":62848,"volume-minus":63325,"volume-mute":63326,"volume-off":62849,"volume-plus":63324,"vpn":62850,"walk":62851,"wall":63485,"wallet":62852,"wallet-giftcard":62853,"wallet-membership":62854,"wallet-travel":62855,"wan":62856,"washing-machine":63273,"watch":62857,"watch-export":62858,"watch-import":62859,"watch-vibrate":63152,"water":62860,"water-off":62861,"water-percent":62862,"water-pump":62863,"watermark":62994,"waves":63372,"weather-cloudy":62864,"weather-fog":62865,"weather-hail":62866,"weather-lightning":62867,"weather-lightning-rainy":63101,"weather-night":62868,"weather-partlycloudy":62869,"weather-pouring":62870,"weather-rainy":62871,"weather-snowy":62872,"weather-snowy-rainy":63102,"weather-sunny":62873,"weather-sunset":62874,"weather-sunset-down":62875,"weather-sunset-up":62876,"weather-windy":62877,"weather-windy-variant":62878,"web":62879,"webcam":62880,"webhook":63023,"webpack":63274,"wechat":62993,"weight":62881,"weight-kilogram":62882,"whatsapp":62883,"wheelchair-accessibility":62884,"white-balance-auto":62885,"white-balance-incandescent":62886,"white-balance-iridescent":62887,"white-balance-sunny":62888,"widgets":63275,"wifi":62889,"wifi-off":62890,"wii":62891,"wiiu":63276,"wikipedia":62892,"window-close":62893,"window-closed":62894,"window-maximize":62895,"window-minimize":62896,"window-open":62897,"window-restore":62898,"windows":62899,"wordpress":62900,"worker":62901,"wrap":62902,"wrench":62903,"wunderlist":62904,"xaml":63091,"xbox":62905,"xbox-controller":62906,"xbox-controller-battery-alert":63306,"xbox-controller-battery-empty":63307,"xbox-controller-battery-full":63308,"xbox-controller-battery-low":63309,"xbox-controller-battery-medium":63310,"xbox-controller-battery-unknown":63311,"xbox-controller-off":62907,"xda":62908,"xing":62909,"xing-box":62910,"xing-circle":62911,"xml":62912,"xmpp":63486,"yammer":63368,"yeast":62913,"yelp":62914,"yin-yang":63103,"youtube-play":62915,"zip-box":62916,"blank":63116}

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(24);var _createIconSet2=_interopRequireDefault(_createIconSet);var _Octicons=__webpack_require__(581);var _Octicons2=_interopRequireDefault(_Octicons);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_Octicons2.default,'Octicons','Octicons.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports = {"alert":61696,"arrow-down":61697,"arrow-left":61698,"arrow-right":61699,"arrow-small-down":61700,"arrow-small-left":61701,"arrow-small-right":61702,"arrow-small-up":61703,"arrow-up":61704,"beaker":61705,"bell":61706,"bold":61707,"book":61708,"bookmark":61709,"briefcase":61710,"broadcast":61711,"browser":61712,"bug":61713,"calendar":61714,"check":61715,"checklist":61716,"chevron-down":61717,"chevron-left":61718,"chevron-right":61719,"chevron-up":61720,"circle-slash":61721,"circuit-board":61722,"clippy":61723,"clock":61724,"cloud-download":61725,"cloud-upload":61726,"code":61727,"comment":61728,"comment-discussion":61729,"credit-card":61730,"dash":61731,"dashboard":61732,"database":61733,"desktop-download":61734,"device-camera":61735,"device-camera-video":61736,"device-desktop":61737,"device-mobile":61738,"diff":61739,"diff-added":61740,"diff-ignored":61741,"diff-modified":61742,"diff-removed":61743,"diff-renamed":61744,"ellipsis":61745,"eye":61746,"file":61747,"file-binary":61748,"file-code":61749,"file-directory":61750,"file-media":61751,"file-pdf":61752,"file-submodule":61753,"file-symlink-directory":61754,"file-symlink-file":61755,"file-text":61756,"file-zip":61757,"flame":61758,"fold":61759,"gear":61760,"gift":61761,"gist":61762,"gist-secret":61763,"git-branch":61764,"git-commit":61765,"git-compare":61766,"git-merge":61767,"git-pull-request":61768,"globe":61769,"grabber":61770,"graph":61771,"heart":61772,"history":61773,"home":61774,"horizontal-rule":61775,"hubot":61776,"inbox":61777,"info":61778,"issue-closed":61779,"issue-opened":61780,"issue-reopened":61781,"italic":61782,"jersey":61783,"kebab-horizontal":61784,"kebab-vertical":61785,"key":61786,"keyboard":61787,"law":61788,"light-bulb":61789,"link":61790,"link-external":61791,"list-ordered":61792,"list-unordered":61793,"location":61794,"lock":61795,"logo-gist":61796,"logo-github":61797,"mail":61798,"mail-read":61799,"mail-reply":61800,"mark-github":61801,"markdown":61802,"megaphone":61803,"mention":61804,"milestone":61805,"mirror":61806,"mortar-board":61807,"mute":61808,"no-newline":61809,"note":61810,"octoface":61811,"organization":61812,"package":61813,"paintcan":61814,"pencil":61815,"person":61816,"pin":61817,"plug":61818,"plus":61819,"plus-small":61820,"primitive-dot":61821,"primitive-square":61822,"project":61823,"pulse":61824,"question":61825,"quote":61826,"radio-tower":61827,"reply":61828,"repo":61829,"repo-clone":61830,"repo-force-push":61831,"repo-forked":61832,"repo-pull":61833,"repo-push":61834,"rocket":61835,"rss":61836,"ruby":61837,"screen-full":61838,"screen-normal":61839,"search":61840,"server":61841,"settings":61842,"shield":61843,"sign-in":61844,"sign-out":61845,"smiley":61846,"squirrel":61847,"star":61848,"stop":61849,"sync":61850,"tag":61851,"tasklist":61852,"telescope":61853,"terminal":61854,"text-size":61855,"three-bars":61856,"thumbsdown":61857,"thumbsup":61858,"tools":61859,"trashcan":61860,"triangle-down":61861,"triangle-left":61862,"triangle-right":61863,"triangle-up":61864,"unfold":61865,"unmute":61866,"unverified":61867,"verified":61868,"versions":61869,"watch":61870,"x":61871,"zap":61872}

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(24);var _createIconSet2=_interopRequireDefault(_createIconSet);var _Zocial=__webpack_require__(583);var _Zocial2=_interopRequireDefault(_Zocial);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_Zocial2.default,'zocial','Zocial.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports = {"acrobat":61696,"amazon":61697,"android":61698,"angellist":61699,"aol":61700,"appnet":61701,"appstore":61702,"bitbucket":61703,"bitcoin":61704,"blogger":61705,"buffer":61706,"cal":61707,"call":61708,"cart":61709,"chrome":61710,"cloudapp":61711,"creativecommons":61712,"delicious":61713,"digg":61714,"disqus":61715,"dribbble":61716,"dropbox":61717,"drupal":61718,"dwolla":61720,"email":61721,"eventasaurus":61722,"eventbrite":61723,"eventful":61724,"evernote":61725,"facebook":61726,"fivehundredpx":61727,"flattr":61728,"flickr":61729,"forrst":61730,"foursquare":61731,"github":61732,"gmail":61733,"google":61734,"googleplay":61735,"googleplus":61736,"gowalla":61737,"grooveshark":61738,"guest":61739,"html5":61740,"ie":61741,"instagram":61742,"instapaper":61743,"intensedebate":61744,"itunes":61745,"klout":61746,"lanyrd":61747,"lastfm":61748,"lego":61749,"linkedin":61750,"lkdto":61751,"logmein":61752,"macstore":61753,"meetup":61754,"myspace":61755,"ninetyninedesigns":61756,"openid":61757,"opentable":61758,"paypal":61759,"persona":61796,"pinboard":61760,"pinterest":61761,"plancast":61762,"plurk":61763,"pocket":61764,"podcast":61765,"posterous":61766,"print":61767,"quora":61768,"reddit":61769,"rss":61770,"scribd":61771,"skype":61772,"smashing":61773,"songkick":61774,"soundcloud":61775,"spotify":61776,"stackoverflow":61777,"statusnet":61778,"steam":61779,"stripe":61780,"stumbleupon":61781,"tumblr":61782,"twitter":61783,"viadeo":61784,"vimeo":61785,"vk":61786,"weibo":61787,"wikipedia":61788,"windows":61789,"wordpress":61790,"xing":61791,"yahoo":61792,"ycombinator":61793,"yelp":61794,"youtube":61795}

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(24);var _createIconSet2=_interopRequireDefault(_createIconSet);var _SimpleLineIcons=__webpack_require__(585);var _SimpleLineIcons2=_interopRequireDefault(_SimpleLineIcons);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_SimpleLineIcons2.default,'simple-line-icons','SimpleLineIcons.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = {"user":57349,"people":57345,"user-female":57344,"user-follow":57346,"user-following":57347,"user-unfollow":57348,"login":57446,"logout":57445,"emotsmile":57377,"phone":58880,"call-end":57416,"call-in":57415,"call-out":57414,"map":57395,"location-pin":57494,"direction":57410,"directions":57409,"compass":57413,"layers":57396,"menu":58881,"list":57447,"options-vertical":58882,"options":58883,"arrow-down":58884,"arrow-left":58885,"arrow-right":58886,"arrow-up":58887,"arrow-up-circle":57464,"arrow-left-circle":57466,"arrow-right-circle":57465,"arrow-down-circle":57467,"check":57472,"clock":57473,"plus":57493,"minus":58901,"close":57474,"event":58905,"exclamation":58903,"organization":58902,"trophy":57350,"screen-smartphone":57360,"screen-desktop":57361,"plane":57362,"notebook":57363,"mustache":57364,"mouse":57365,"magnet":57366,"energy":57376,"disc":57378,"cursor":57454,"cursor-move":57379,"crop":57380,"chemistry":57382,"speedometer":57351,"shield":57358,"screen-tablet":57359,"magic-wand":57367,"hourglass":57368,"graduation":57369,"ghost":57370,"game-controller":57371,"fire":57372,"eyeglass":57373,"envelope-open":57374,"envelope-letter":57375,"bell":57383,"badge":57384,"anchor":57385,"wallet":57386,"vector":57387,"speech":57388,"puzzle":57389,"printer":57390,"present":57391,"playlist":57392,"pin":57393,"picture":57394,"handbag":57397,"globe-alt":57398,"globe":57399,"folder-alt":57401,"folder":57481,"film":57402,"feed":57403,"drop":57406,"drawer":57407,"docs":57408,"doc":57477,"diamond":57411,"cup":57412,"calculator":57417,"bubbles":57418,"briefcase":57419,"book-open":57420,"basket-loaded":57421,"basket":57422,"bag":57423,"action-undo":57424,"action-redo":57425,"wrench":57426,"umbrella":57427,"trash":57428,"tag":57429,"support":57430,"frame":57400,"size-fullscreen":57431,"size-actual":57432,"shuffle":57433,"share-alt":57434,"share":57435,"rocket":57436,"question":57437,"pie-chart":57438,"pencil":57439,"note":57440,"loop":57444,"home":57449,"grid":57450,"graph":57451,"microphone":57443,"music-tone-alt":57441,"music-tone":57442,"earphones-alt":57404,"earphones":57405,"equalizer":57452,"like":57448,"dislike":57453,"control-start":57455,"control-rewind":57456,"control-play":57457,"control-pause":57458,"control-forward":57459,"control-end":57460,"volume-1":57503,"volume-2":57504,"volume-off":57505,"calendar":57461,"bulb":57462,"chart":57463,"ban":57468,"bubble":57469,"camrecorder":57470,"camera":57471,"cloud-download":57475,"cloud-upload":57476,"envelope":57478,"eye":57479,"flag":57480,"heart":57482,"info":57483,"key":57484,"link":57485,"lock":57486,"lock-open":57487,"magnifier":57488,"magnifier-add":57489,"magnifier-remove":57490,"paper-clip":57491,"paper-plane":57492,"power":57495,"refresh":57496,"reload":57497,"settings":57498,"star":57499,"symbol-female":57500,"symbol-male":57501,"target":57502,"credit-card":57381,"paypal":58888,"social-tumblr":57354,"social-twitter":57353,"social-facebook":57355,"social-instagram":58889,"social-linkedin":58890,"social-pinterest":58891,"social-github":58892,"social-google":58893,"social-reddit":58894,"social-skype":58895,"social-dribbble":57357,"social-behance":58896,"social-foursqare":58897,"social-soundcloud":58898,"social-spotify":58899,"social-stumbleupon":58900,"social-youtube":57352,"social-dropbox":57356,"social-vkontakte":58904,"social-steam":58912}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = {"add":{"android":{"default":"md-add","active":"md-add"},"ios":{"default":"ios-add-outline","active":"ios-add"}},"add-circle":{"android":{"default":"md-add-circle","active":"md-add-circle"},"ios":{"default":"ios-add-circle-outline","active":"ios-add-circle"}},"alarm":{"android":{"default":"md-alarm","active":"md-alarm"},"ios":{"default":"ios-alarm-outline","active":"ios-alarm"}},"albums":{"android":{"default":"md-albums","active":"md-albums"},"ios":{"default":"ios-albums-outline","active":"ios-albums"}},"alert":{"android":{"default":"md-alert","active":"md-alert"},"ios":{"default":"ios-alert-outline","active":"ios-alert"}},"american-football":{"android":{"default":"md-american-football","active":"md-american-football"},"ios":{"default":"ios-american-football-outline","active":"ios-american-football"}},"analytics":{"android":{"default":"md-analytics","active":"md-analytics"},"ios":{"default":"ios-analytics-outline","active":"ios-analytics"}},"aperture":{"android":{"default":"md-aperture","active":"md-aperture"},"ios":{"default":"ios-aperture-outline","active":"ios-aperture"}},"apps":{"android":{"default":"md-apps","active":"md-apps"},"ios":{"default":"ios-apps-outline","active":"ios-apps"}},"appstore":{"android":{"default":"md-appstore","active":"md-appstore"},"ios":{"default":"ios-appstore-outline","active":"ios-apps"}},"archive":{"android":{"default":"md-archive","active":"md-archive"},"ios":{"default":"ios-archive-outline","active":"ios-archive"}},"arrow-back":{"android":{"default":"md-arrow-back","active":"md-arrow-back"},"ios":{"default":"ios-arrow-back-outline","active":"ios-arrow-back"}},"arrow-down":{"android":{"default":"md-arrow-down","active":"md-arrow-down"},"ios":{"default":"ios-arrow-down-outline","active":"ios-arrow-down"}},"arrow-dropdown":{"android":{"default":"md-arrow-dropdown","active":"md-arrow-dropdown"},"ios":{"default":"ios-arrow-dropdown-outline","active":"ios-arrow-dropdown"}},"arrow-dropdown-circle":{"android":{"default":"md-arrow-dropdown-circle","active":"md-arrow-dropdown-circle"},"ios":{"default":"ios-arrow-dropdown-circle-outline","active":"ios-arrow-dropdown-circle"}},"arrow-dropleft":{"android":{"default":"md-arrow-dropleft","active":"md-arrow-dropleft"},"ios":{"default":"ios-arrow-dropleft-outline","active":"ios-arrow-dropleft"}},"arrow-dropleft-circle":{"android":{"default":"md-arrow-dropleft-circle","active":"md-arrow-dropleft-circle"},"ios":{"default":"ios-arrow-dropleft-circle-outline","active":"ios-arrow-dropleft-circle"}},"arrow-dropright":{"android":{"default":"md-arrow-dropright","active":"md-arrow-dropright"},"ios":{"default":"ios-arrow-dropright-outline","active":"ios-arrow-dropright"}},"arrow-dropright-circle":{"android":{"default":"md-arrow-dropright-circle","active":"md-arrow-dropright-circle"},"ios":{"default":"ios-arrow-dropright-circle-outline","active":"ios-arrow-dropright-circle"}},"arrow-dropup":{"android":{"default":"md-arrow-dropup","active":"md-arrow-dropup"},"ios":{"default":"ios-arrow-dropup-outline","active":"ios-arrow-dropup"}},"arrow-dropup-circle":{"android":{"default":"md-arrow-dropup-circle","active":"md-arrow-dropup-circle"},"ios":{"default":"ios-arrow-dropup-circle-outline","active":"ios-arrow-dropup-circle"}},"arrow-forward":{"android":{"default":"md-arrow-forward","active":"md-arrow-forward"},"ios":{"default":"ios-arrow-forward-outline","active":"ios-arrow-forward"}},"arrow-round-back":{"android":{"default":"md-arrow-round-back","active":"md-arrow-round-back"},"ios":{"default":"ios-arrow-round-back-outline","active":"ios-arrow-round-back"}},"arrow-round-down":{"android":{"default":"md-arrow-round-down","active":"md-arrow-round-down"},"ios":{"default":"ios-arrow-round-down-outline","active":"ios-arrow-round-down"}},"arrow-round-forward":{"android":{"default":"md-arrow-round-forward","active":"md-arrow-round-forward"},"ios":{"default":"ios-arrow-round-forward-outline","active":"ios-arrow-round-forward"}},"arrow-round-up":{"android":{"default":"md-arrow-round-up","active":"md-arrow-round-up"},"ios":{"default":"ios-arrow-round-up-outline","active":"ios-arrow-round-up"}},"arrow-up":{"android":{"default":"md-arrow-up","active":"md-arrow-up"},"ios":{"default":"ios-arrow-up-outline","active":"ios-arrow-up"}},"at":{"android":{"default":"md-at","active":"md-at"},"ios":{"default":"ios-at-outline","active":"ios-at"}},"attach":{"android":{"default":"md-attach","active":"md-attach"},"ios":{"default":"ios-attach-outline","active":"ios-attach"}},"backspace":{"android":{"default":"md-backspace","active":"md-backspace"},"ios":{"default":"ios-backspace-outline","active":"ios-backspace"}},"barcode":{"android":{"default":"md-barcode","active":"md-barcode"},"ios":{"default":"ios-barcode-outline","active":"ios-barcode"}},"baseball":{"android":{"default":"md-baseball","active":"md-baseball"},"ios":{"default":"ios-baseball-outline","active":"ios-baseball"}},"basket":{"android":{"default":"md-basket","active":"md-basket"},"ios":{"default":"ios-basket-outline","active":"ios-basket"}},"basketball":{"android":{"default":"md-basketball","active":"md-basketball"},"ios":{"default":"ios-basketball-outline","active":"ios-basketball"}},"battery-charging":{"android":{"default":"md-battery-charging","active":"md-battery-charging"},"ios":{"default":"ios-battery-charging-outline","active":"ios-battery-charging"}},"battery-dead":{"android":{"default":"md-battery-dead","active":"md-battery-dead"},"ios":{"default":"ios-battery-dead-outline","active":"ios-battery-dead"}},"battery-full":{"android":{"default":"md-battery-full","active":"md-battery-full"},"ios":{"default":"ios-battery-full-outline","active":"ios-battery-full"}},"beaker":{"android":{"default":"md-beaker","active":"md-beaker"},"ios":{"default":"ios-beaker-outline","active":"ios-beaker"}},"beer":{"android":{"default":"md-beer","active":"md-beer"},"ios":{"default":"ios-beer-outline","active":"ios-beer"}},"bicycle":{"android":{"default":"md-bicycle","active":"md-bicycle"},"ios":{"default":"ios-bicycle-outline","active":"ios-bicycle"}},"bluetooth":{"android":{"default":"md-bluetooth","active":"md-bluetooth"},"ios":{"default":"ios-bluetooth-outline","active":"ios-bluetooth"}},"boat":{"android":{"default":"md-boat","active":"md-boat"},"ios":{"default":"ios-boat-outline","active":"ios-boat"}},"body":{"android":{"default":"md-body","active":"md-body"},"ios":{"default":"ios-body-outline","active":"ios-body"}},"bonfire":{"android":{"default":"md-bonfire","active":"md-bonfire"},"ios":{"default":"ios-bonfire-outline","active":"ios-bonfire"}},"book":{"android":{"default":"md-book","active":"md-book"},"ios":{"default":"ios-book-outline","active":"ios-book"}},"bookmark":{"android":{"default":"md-bookmark","active":"md-bookmark"},"ios":{"default":"ios-bookmark-outline","active":"ios-bookmark"}},"bookmarks":{"android":{"default":"md-bookmarks","active":"md-bookmarks"},"ios":{"default":"ios-bookmarks-outline","active":"ios-bookmarks"}},"bowtie":{"android":{"default":"md-bowtie","active":"md-bowtie"},"ios":{"default":"ios-bowtie-outline","active":"ios-bowtie"}},"briefcase":{"android":{"default":"md-briefcase","active":"md-briefcase"},"ios":{"default":"ios-briefcase-outline","active":"ios-briefcase"}},"browsers":{"android":{"default":"md-browsers","active":"md-browsers"},"ios":{"default":"ios-browsers-outline","active":"ios-browsers"}},"brush":{"android":{"default":"md-brush","active":"md-brush"},"ios":{"default":"ios-brush-outline","active":"ios-brush"}},"bug":{"android":{"default":"md-bug","active":"md-bug"},"ios":{"default":"ios-bug-outline","active":"ios-bug"}},"build":{"android":{"default":"md-build","active":"md-build"},"ios":{"default":"ios-build-outline","active":"ios-build"}},"bulb":{"android":{"default":"md-bulb","active":"md-bulb"},"ios":{"default":"ios-bulb-outline","active":"ios-bulb"}},"bus":{"android":{"default":"md-bus","active":"md-bus"},"ios":{"default":"ios-bus-outline","active":"ios-bus"}},"cafe":{"android":{"default":"md-cafe","active":"md-cafe"},"ios":{"default":"ios-cafe-outline","active":"ios-cafe"}},"calculator":{"android":{"default":"md-calculator","active":"md-calculator"},"ios":{"default":"ios-calculator-outline","active":"ios-calculator"}},"calendar":{"android":{"default":"md-calendar","active":"md-calendar"},"ios":{"default":"ios-calendar-outline","active":"ios-calendar"}},"call":{"android":{"default":"md-call","active":"md-call"},"ios":{"default":"ios-call-outline","active":"ios-call"}},"camera":{"android":{"default":"md-camera","active":"md-camera"},"ios":{"default":"ios-camera-outline","active":"ios-camera"}},"car":{"android":{"default":"md-car","active":"md-car"},"ios":{"default":"ios-car-outline","active":"ios-car"}},"card":{"android":{"default":"md-card","active":"md-card"},"ios":{"default":"ios-card-outline","active":"ios-card"}},"cart":{"android":{"default":"md-cart","active":"md-cart"},"ios":{"default":"ios-cart-outline","active":"ios-cart"}},"cash":{"android":{"default":"md-cash","active":"md-cash"},"ios":{"default":"ios-cash-outline","active":"ios-cash"}},"chatboxes":{"android":{"default":"md-chatboxes","active":"md-chatboxes"},"ios":{"default":"ios-chatboxes-outline","active":"ios-chatboxes"}},"chatbubbles":{"android":{"default":"md-chatbubbles","active":"md-chatbubbles"},"ios":{"default":"ios-chatbubbles-outline","active":"ios-chatbubbles"}},"checkbox":{"android":{"default":"md-checkbox-outline","active":"md-checkbox"},"ios":{"default":"ios-checkbox-outline","active":"ios-checkbox"}},"checkmark":{"android":{"default":"md-checkmark","active":"md-checkmark"},"ios":{"default":"ios-checkmark-outline","active":"ios-checkmark"}},"checkmark-circle":{"android":{"default":"md-checkmark-circle-outline","active":"md-checkmark-circle"},"ios":{"default":"ios-checkmark-circle-outline","active":"ios-checkmark-circle"}},"clipboard":{"android":{"default":"md-clipboard","active":"md-clipboard"},"ios":{"default":"ios-clipboard-outline","active":"ios-clipboard"}},"clock":{"android":{"default":"md-clock","active":"md-clock"},"ios":{"default":"ios-clock-outline","active":"ios-clock"}},"close":{"android":{"default":"md-close","active":"md-close"},"ios":{"default":"ios-close-outline","active":"ios-close"}},"close-circle":{"android":{"default":"md-close-circle","active":"md-close-circle"},"ios":{"default":"ios-close-circle-outline","active":"ios-close-circle"}},"cloud":{"android":{"default":"md-cloud","active":"md-cloud"},"ios":{"default":"ios-cloud-outline","active":"ios-cloud"}},"cloud-circle":{"android":{"default":"md-cloud-circle","active":"md-cloud-circle"},"ios":{"default":"ios-cloud-circle-outline","active":"ios-cloud-circle"}},"cloud-done":{"android":{"default":"md-cloud-done","active":"md-cloud-done"},"ios":{"default":"ios-cloud-done-outline","active":"ios-cloud-done"}},"cloud-download":{"android":{"default":"md-cloud-download","active":"md-cloud-download"},"ios":{"default":"ios-cloud-download-outline","active":"ios-cloud-download"}},"cloud-outline":{"android":{"default":"md-cloud-outline","active":"md-cloud-outline"},"ios":{"default":"ios-cloud-outline-outline","active":"ios-cloud-outline"}},"cloud-upload":{"android":{"default":"md-cloud-upload","active":"md-cloud-upload"},"ios":{"default":"ios-cloud-upload-outline","active":"ios-cloud-upload"}},"cloudy":{"android":{"default":"md-cloudy","active":"md-cloudy"},"ios":{"default":"ios-cloudy-outline","active":"ios-cloudy"}},"cloudy-night":{"android":{"default":"md-cloudy-night","active":"md-cloudy-night"},"ios":{"default":"ios-cloudy-night-outline","active":"ios-cloudy-night"}},"code":{"android":{"default":"md-code","active":"md-code"},"ios":{"default":"ios-code-outline","active":"ios-code"}},"code-download":{"android":{"default":"md-code-download","active":"md-code-download"},"ios":{"default":"ios-code-download-outline","active":"ios-code-download"}},"code-working":{"android":{"default":"md-code-working","active":"md-code-working"},"ios":{"default":"ios-code-working-outline","active":"ios-code-working"}},"cog":{"android":{"default":"md-cog","active":"md-cog"},"ios":{"default":"ios-cog-outline","active":"ios-cog"}},"color-fill":{"android":{"default":"md-color-fill","active":"md-color-fill"},"ios":{"default":"ios-color-fill-outline","active":"ios-color-fill"}},"color-filter":{"android":{"default":"md-color-filter","active":"md-color-filter"},"ios":{"default":"ios-color-filter-outline","active":"ios-color-filter"}},"color-palette":{"android":{"default":"md-color-palette","active":"md-color-palette"},"ios":{"default":"ios-color-palette-outline","active":"ios-color-palette"}},"color-wand":{"android":{"default":"md-color-wand","active":"md-color-wand"},"ios":{"default":"ios-color-wand-outline","active":"ios-color-wand"}},"compass":{"android":{"default":"md-compass","active":"md-compass"},"ios":{"default":"ios-compass-outline","active":"ios-compass"}},"construct":{"android":{"default":"md-construct","active":"md-construct"},"ios":{"default":"ios-construct-outline","active":"ios-construct"}},"contact":{"android":{"default":"md-contact","active":"md-contact"},"ios":{"default":"ios-contact-outline","active":"ios-contact"}},"contacts":{"android":{"default":"md-contacts","active":"md-contacts"},"ios":{"default":"ios-contacts-outline","active":"ios-contacts"}},"contract":{"android":{"default":"md-contract","active":"md-contract"},"ios":{"default":"ios-contract-outline","active":"ios-contract"}},"contrast":{"android":{"default":"md-contrast","active":"md-contrast"},"ios":{"default":"ios-contrast-outline","active":"ios-contrast"}},"copy":{"android":{"default":"md-copy","active":"md-copy"},"ios":{"default":"ios-copy-outline","active":"ios-copy"}},"create":{"android":{"default":"md-create","active":"md-create"},"ios":{"default":"ios-create-outline","active":"ios-create"}},"crop":{"android":{"default":"md-crop","active":"md-crop"},"ios":{"default":"ios-crop-outline","active":"ios-crop"}},"cube":{"android":{"default":"md-cube","active":"md-cube"},"ios":{"default":"ios-cube-outline","active":"ios-cube"}},"cut":{"android":{"default":"md-cut","active":"md-cut"},"ios":{"default":"ios-cut-outline","active":"ios-cut"}},"desktop":{"android":{"default":"md-desktop","active":"md-desktop"},"ios":{"default":"ios-desktop-outline","active":"ios-desktop"}},"disc":{"android":{"default":"md-disc","active":"md-disc"},"ios":{"default":"ios-disc-outline","active":"ios-disc"}},"document":{"android":{"default":"md-document","active":"md-document"},"ios":{"default":"ios-document-outline","active":"ios-document"}},"done-all":{"android":{"default":"md-done-all","active":"md-done-all"},"ios":{"default":"ios-done-all-outline","active":"ios-done-all"}},"download":{"android":{"default":"md-download","active":"md-download"},"ios":{"default":"ios-download-outline","active":"ios-download"}},"easel":{"android":{"default":"md-easel","active":"md-easel"},"ios":{"default":"ios-easel-outline","active":"ios-easel"}},"egg":{"android":{"default":"md-egg","active":"md-egg"},"ios":{"default":"ios-egg-outline","active":"ios-egg"}},"exit":{"android":{"default":"md-exit","active":"md-exit"},"ios":{"default":"ios-exit-outline","active":"ios-exit"}},"expand":{"android":{"default":"md-expand","active":"md-expand"},"ios":{"default":"ios-expand-outline","active":"ios-expand"}},"eye":{"android":{"default":"md-eye","active":"md-eye"},"ios":{"default":"ios-eye-outline","active":"ios-eye"}},"eye-off":{"android":{"default":"md-eye-off","active":"md-eye-off"},"ios":{"default":"ios-eye-off-outline","active":"ios-eye-off"}},"fastforward":{"android":{"default":"md-fastforward","active":"md-fastforward"},"ios":{"default":"ios-fastforward-outline","active":"ios-fastforward"}},"female":{"android":{"default":"md-female","active":"md-female"},"ios":{"default":"ios-female-outline","active":"ios-female"}},"filing":{"android":{"default":"md-filing","active":"md-filing"},"ios":{"default":"ios-filing-outline","active":"ios-filing"}},"film":{"android":{"default":"md-film","active":"md-film"},"ios":{"default":"ios-film-outline","active":"ios-film"}},"finger-print":{"android":{"default":"md-finger-print","active":"md-finger-print"},"ios":{"default":"ios-finger-print-outline","active":"ios-finger-print"}},"flag":{"android":{"default":"md-flag","active":"md-flag"},"ios":{"default":"ios-flag-outline","active":"ios-flag"}},"flame":{"android":{"default":"md-flame","active":"md-flame"},"ios":{"default":"ios-flame-outline","active":"ios-flame"}},"flash":{"android":{"default":"md-flash","active":"md-flash"},"ios":{"default":"ios-flash-outline","active":"ios-flash"}},"flask":{"android":{"default":"md-flask","active":"md-flask"},"ios":{"default":"ios-flask-outline","active":"ios-flask"}},"flower":{"android":{"default":"md-flower","active":"md-flower"},"ios":{"default":"ios-flower-outline","active":"ios-flower"}},"folder":{"android":{"default":"md-folder","active":"md-folder"},"ios":{"default":"ios-folder-outline","active":"ios-folder"}},"folder-open":{"android":{"default":"md-folder-open","active":"md-folder-open"},"ios":{"default":"ios-folder-open-outline","active":"ios-folder-open"}},"football":{"android":{"default":"md-football","active":"md-football"},"ios":{"default":"ios-football-outline","active":"ios-football"}},"funnel":{"android":{"default":"md-funnel","active":"md-funnel"},"ios":{"default":"ios-funnel-outline","active":"ios-funnel"}},"game-controller-a":{"android":{"default":"md-game-controller-a","active":"md-game-controller-a"},"ios":{"default":"ios-game-controller-a-outline","active":"ios-game-controller-a"}},"game-controller-b":{"android":{"default":"md-game-controller-b","active":"md-game-controller-b"},"ios":{"default":"ios-game-controller-b-outline","active":"ios-game-controller-b"}},"git-branch":{"android":{"default":"md-git-branch","active":"md-git-branch"},"ios":{"default":"ios-git-branch-outline","active":"ios-git-branch"}},"git-commit":{"android":{"default":"md-git-commit","active":"md-git-commit"},"ios":{"default":"ios-git-commit-outline","active":"ios-git-commit"}},"git-merge":{"android":{"default":"md-git-merge","active":"md-git-merge"},"ios":{"default":"ios-git-merge-outline","active":"ios-git-merge"}},"git-compare":{"android":{"default":"md-git-compare","active":"md-git-compare"},"ios":{"default":"ios-git-compare-outline","active":"ios-git-compare"}},"git-network":{"android":{"default":"md-git-network","active":"md-git-network"},"ios":{"default":"ios-git-network-outline","active":"ios-git-network"}},"git-pull-request":{"android":{"default":"md-git-pull-request","active":"md-git-pull-request"},"ios":{"default":"ios-git-pull-request-outline","active":"ios-git-pull-request"}},"glasses":{"android":{"default":"md-glasses","active":"md-glasses"},"ios":{"default":"ios-glasses-outline","active":"ios-glasses"}},"globe":{"android":{"default":"md-globe","active":"md-globe"},"ios":{"default":"ios-globe-outline","active":"ios-globe"}},"grid":{"android":{"default":"md-grid","active":"md-grid"},"ios":{"default":"ios-grid-outline","active":"ios-grid"}},"hammer":{"android":{"default":"md-hammer","active":"md-hammer"},"ios":{"default":"ios-hammer-outline","active":"ios-hammer"}},"hand":{"android":{"default":"md-hand","active":"md-hand"},"ios":{"default":"ios-hand-outline","active":"ios-hand"}},"headset":{"android":{"default":"md-headset","active":"md-headset"},"ios":{"default":"ios-headset-outline","active":"ios-headset"}},"heart":{"android":{"default":"md-heart","active":"md-heart"},"ios":{"default":"ios-heart-outline","active":"ios-heart"}},"happy":{"android":{"default":"md-happy-outline","active":"md-happy"},"ios":{"default":"ios-happy-outline","active":"ios-happy"}},"help":{"android":{"default":"md-help","active":"md-help"},"ios":{"default":"ios-help-outline","active":"ios-help"}},"help-buoy":{"android":{"default":"md-help-buoy","active":"md-help-buoy"},"ios":{"default":"ios-help-buoy-outline","active":"ios-help-buoy"}},"help-circle":{"android":{"default":"md-help-circle","active":"md-help-circle"},"ios":{"default":"ios-help-circle-outline","active":"ios-help-circle"}},"home":{"android":{"default":"md-home","active":"md-home"},"ios":{"default":"ios-home-outline","active":"ios-home"}},"ice-cream":{"android":{"default":"md-ice-cream","active":"md-ice-cream"},"ios":{"default":"ios-ice-cream-outline","active":"ios-ice-cream"}},"image":{"android":{"default":"md-image","active":"md-image"},"ios":{"default":"ios-image-outline","active":"ios-image"}},"images":{"android":{"default":"md-images","active":"md-images"},"ios":{"default":"ios-images-outline","active":"ios-images"}},"infinite":{"android":{"default":"md-infinite","active":"md-infinite"},"ios":{"default":"ios-infinite-outline","active":"ios-infinite"}},"information":{"android":{"default":"md-information","active":"md-information"},"ios":{"default":"ios-information-outline","active":"ios-information"}},"information-circle":{"android":{"default":"md-information-circle","active":"md-information-circle"},"ios":{"default":"ios-information-circle-outline","active":"ios-information-circle"}},"ionic":{"android":{"default":"md-ionic","active":"md-ionic"},"ios":{"default":"ios-ionic-outline","active":"ios-ionic"}},"ionitron":{"android":{"default":"md-ionitron","active":"md-ionitron"},"ios":{"default":"ios-ionitron-outline","active":"ios-ionitron"}},"jet":{"android":{"default":"md-jet","active":"md-jet"},"ios":{"default":"ios-jet-outline","active":"ios-jet"}},"key":{"android":{"default":"md-key","active":"md-key"},"ios":{"default":"ios-key-outline","active":"ios-key"}},"keypad":{"android":{"default":"md-keypad","active":"md-keypad"},"ios":{"default":"ios-keypad-outline","active":"ios-keypad"}},"laptop":{"android":{"default":"md-laptop","active":"md-laptop"},"ios":{"default":"ios-laptop-outline","active":"ios-laptop"}},"leaf":{"android":{"default":"md-leaf","active":"md-leaf"},"ios":{"default":"ios-leaf-outline","active":"ios-leaf"}},"link":{"android":{"default":"md-link","active":"md-link"},"ios":{"default":"ios-link-outline","active":"ios-link"}},"list":{"android":{"default":"md-list","active":"md-list"},"ios":{"default":"ios-list-outline","active":"ios-list"}},"list-box":{"android":{"default":"md-list-box","active":"md-list-box"},"ios":{"default":"ios-list-box-outline","active":"ios-list-box"}},"locate":{"android":{"default":"md-locate","active":"md-locate"},"ios":{"default":"ios-locate-outline","active":"ios-locate"}},"lock":{"android":{"default":"md-lock","active":"md-lock"},"ios":{"default":"ios-lock-outline","active":"ios-lock"}},"log-in":{"android":{"default":"md-log-in","active":"md-log-in"},"ios":{"default":"ios-log-in-outline","active":"ios-log-in"}},"log-out":{"android":{"default":"md-log-out","active":"md-log-out"},"ios":{"default":"ios-log-out-outline","active":"ios-log-out"}},"magnet":{"android":{"default":"md-magnet","active":"md-magnet"},"ios":{"default":"ios-magnet-outline","active":"ios-magnet"}},"mail":{"android":{"default":"md-mail","active":"md-mail"},"ios":{"default":"ios-mail-outline","active":"ios-mail"}},"mail-open":{"android":{"default":"md-mail-open","active":"md-mail-open"},"ios":{"default":"ios-mail-open-outline","active":"ios-mail-open"}},"male":{"android":{"default":"md-male","active":"md-male"},"ios":{"default":"ios-male-outline","active":"ios-male"}},"man":{"android":{"default":"md-man","active":"md-man"},"ios":{"default":"ios-man-outline","active":"ios-man"}},"map":{"android":{"default":"md-map","active":"md-map"},"ios":{"default":"ios-map-outline","active":"ios-map"}},"medal":{"android":{"default":"md-medal","active":"md-medal"},"ios":{"default":"ios-medal-outline","active":"ios-medal"}},"medical":{"android":{"default":"md-medical","active":"md-medical"},"ios":{"default":"ios-medical-outline","active":"ios-medical"}},"medkit":{"android":{"default":"md-medkit","active":"md-medkit"},"ios":{"default":"ios-medkit-outline","active":"ios-medkit"}},"megaphone":{"android":{"default":"md-megaphone","active":"md-megaphone"},"ios":{"default":"ios-megaphone-outline","active":"ios-megaphone"}},"menu":{"android":{"default":"md-menu","active":"md-menu"},"ios":{"default":"ios-menu-outline","active":"ios-menu"}},"mic":{"android":{"default":"md-mic","active":"md-mic"},"ios":{"default":"ios-mic-outline","active":"ios-mic"}},"mic-off":{"android":{"default":"md-mic-off","active":"md-mic-off"},"ios":{"default":"ios-mic-off-outline","active":"ios-mic-off"}},"microphone":{"android":{"default":"md-microphone","active":"md-microphone"},"ios":{"default":"ios-microphone-outline","active":"ios-microphone"}},"moon":{"android":{"default":"md-moon","active":"md-moon"},"ios":{"default":"ios-moon-outline","active":"ios-moon"}},"more":{"android":{"default":"md-more","active":"md-more"},"ios":{"default":"ios-more-outline","active":"ios-more"}},"move":{"android":{"default":"md-move","active":"md-move"},"ios":{"default":"ios-move-outline","active":"ios-move"}},"musical-note":{"android":{"default":"md-musical-note","active":"md-musical-note"},"ios":{"default":"ios-musical-note-outline","active":"ios-musical-note"}},"musical-notes":{"android":{"default":"md-musical-notes","active":"md-musical-notes"},"ios":{"default":"ios-musical-notes-outline","active":"ios-musical-notes"}},"navigate":{"android":{"default":"md-navigate","active":"md-navigate"},"ios":{"default":"ios-navigate-outline","active":"ios-navigate"}},"no-smoking":{"android":{"default":"md-no-smoking","active":"md-no-smoking"},"ios":{"default":"ios-no-smoking-outline","active":"ios-no-smoking"}},"notifications":{"android":{"default":"md-notifications-outline","active":"md-notifications"},"ios":{"default":"ios-notifications-outline","active":"ios-notifications"}},"notifications-off":{"android":{"default":"md-notifications-off","active":"md-notifications-off"},"ios":{"default":"ios-notifications-off-outline","active":"ios-notifications-off"}},"nuclear":{"android":{"default":"md-nuclear","active":"md-nuclear"},"ios":{"default":"ios-nuclear-outline","active":"ios-nuclear"}},"nutrition":{"android":{"default":"md-nutrition","active":"md-nutrition"},"ios":{"default":"ios-nutrition-outline","active":"ios-nutrition"}},"open":{"android":{"default":"md-open","active":"md-open"},"ios":{"default":"ios-open-outline","active":"ios-open"}},"options":{"android":{"default":"md-options","active":"md-options"},"ios":{"default":"ios-options-outline","active":"ios-options"}},"outlet":{"android":{"default":"md-outlet","active":"md-outlet"},"ios":{"default":"ios-outlet-outline","active":"ios-outlet"}},"paper":{"android":{"default":"md-paper","active":"md-paper"},"ios":{"default":"ios-paper-outline","active":"ios-paper"}},"paper-plane":{"android":{"default":"md-paper-plane","active":"md-paper-plane"},"ios":{"default":"ios-paper-plane-outline","active":"ios-paper-plane"}},"partly-sunny":{"android":{"default":"md-partly-sunny","active":"md-partly-sunny"},"ios":{"default":"ios-partly-sunny-outline","active":"ios-partly-sunny"}},"pause":{"android":{"default":"md-pause","active":"md-pause"},"ios":{"default":"ios-pause-outline","active":"ios-pause"}},"paw":{"android":{"default":"md-paw","active":"md-paw"},"ios":{"default":"ios-paw-outline","active":"ios-paw"}},"people":{"android":{"default":"md-people","active":"md-people"},"ios":{"default":"ios-people-outline","active":"ios-people"}},"person":{"android":{"default":"md-person","active":"md-person"},"ios":{"default":"ios-person-outline","active":"ios-person"}},"person-add":{"android":{"default":"md-person-add","active":"md-person-add"},"ios":{"default":"ios-person-add-outline","active":"ios-person-add"}},"phone-landscape":{"android":{"default":"md-phone-landscape","active":"md-phone-landscape"},"ios":{"default":"ios-phone-landscape-outline","active":"ios-phone-landscape"}},"phone-portrait":{"android":{"default":"md-phone-portrait","active":"md-phone-portrait"},"ios":{"default":"ios-phone-portrait-outline","active":"ios-phone-portrait"}},"photos":{"android":{"default":"md-photos","active":"md-photos"},"ios":{"default":"ios-photos-outline","active":"ios-photos"}},"pie":{"android":{"default":"md-pie","active":"md-pie"},"ios":{"default":"ios-pie-outline","active":"ios-pie"}},"pin":{"android":{"default":"md-pin","active":"md-pin"},"ios":{"default":"ios-pin-outline","active":"ios-pin"}},"pint":{"android":{"default":"md-pint","active":"md-pint"},"ios":{"default":"ios-pint-outline","active":"ios-pint"}},"pizza":{"android":{"default":"md-pizza","active":"md-pizza"},"ios":{"default":"ios-pizza-outline","active":"ios-pizza"}},"plane":{"android":{"default":"md-plane","active":"md-plane"},"ios":{"default":"ios-plane-outline","active":"ios-plane"}},"planet":{"android":{"default":"md-planet","active":"md-planet"},"ios":{"default":"ios-planet-outline","active":"ios-planet"}},"play":{"android":{"default":"md-play","active":"md-play"},"ios":{"default":"ios-play-outline","active":"ios-play"}},"podium":{"android":{"default":"md-podium","active":"md-podium"},"ios":{"default":"ios-podium-outline","active":"ios-podium"}},"power":{"android":{"default":"md-power","active":"md-power"},"ios":{"default":"ios-power-outline","active":"ios-power"}},"pricetag":{"android":{"default":"md-pricetag","active":"md-pricetag"},"ios":{"default":"ios-pricetag-outline","active":"ios-pricetag"}},"pricetags":{"android":{"default":"md-pricetags","active":"md-pricetags"},"ios":{"default":"ios-pricetags-outline","active":"ios-pricetags"}},"print":{"android":{"default":"md-print","active":"md-print"},"ios":{"default":"ios-print-outline","active":"ios-print"}},"pulse":{"android":{"default":"md-pulse","active":"md-pulse"},"ios":{"default":"ios-pulse-outline","active":"ios-pulse"}},"qr-scanner":{"android":{"default":"md-qr-scanner","active":"md-qr-scanner"},"ios":{"default":"ios-qr-scanner-outline","active":"ios-qr-scanner"}},"quote":{"android":{"default":"md-quote","active":"md-quote"},"ios":{"default":"ios-quote-outline","active":"ios-quote"}},"radio":{"android":{"default":"md-radio","active":"md-radio"},"ios":{"default":"ios-radio-outline","active":"ios-radio"}},"radio-button-off":{"android":{"default":"md-radio-button-off","active":"md-radio-button-off"},"ios":{"default":"ios-radio-button-off-outline","active":"ios-radio-button-off"}},"radio-button-on":{"android":{"default":"md-radio-button-on","active":"md-radio-button-on"},"ios":{"default":"ios-radio-button-on-outline","active":"ios-radio-button-on"}},"rainy":{"android":{"default":"md-rainy","active":"md-rainy"},"ios":{"default":"ios-rainy-outline","active":"ios-rainy"}},"recording":{"android":{"default":"md-recording","active":"md-recording"},"ios":{"default":"ios-recording-outline","active":"ios-recording"}},"redo":{"android":{"default":"md-redo","active":"md-redo"},"ios":{"default":"ios-redo-outline","active":"ios-redo"}},"refresh":{"android":{"default":"md-refresh","active":"md-refresh"},"ios":{"default":"ios-refresh-outline","active":"ios-refresh"}},"remove":{"android":{"default":"md-remove","active":"md-remove"},"ios":{"default":"ios-remove-outline","active":"ios-remove"}},"remove-circle":{"android":{"default":"md-remove-circle","active":"md-remove-circle"},"ios":{"default":"ios-remove-circle-outline","active":"ios-remove-circle"}},"reorder":{"android":{"default":"md-reorder","active":"md-reorder"},"ios":{"default":"ios-reorder-outline","active":"ios-reorder"}},"repeat":{"android":{"default":"md-repeat","active":"md-repeat"},"ios":{"default":"ios-repeat-outline","active":"ios-repeat"}},"resize":{"android":{"default":"md-resize","active":"md-resize"},"ios":{"default":"ios-resize-outline","active":"ios-resize"}},"restaurant":{"android":{"default":"md-restaurant","active":"md-restaurant"},"ios":{"default":"ios-restaurant-outline","active":"ios-restaurant"}},"return-left":{"android":{"default":"md-return-left","active":"md-return-left"},"ios":{"default":"ios-return-left-outline","active":"ios-return-left"}},"return-right":{"android":{"default":"md-return-right","active":"md-return-right"},"ios":{"default":"ios-return-right-outline","active":"ios-return-right"}},"reverse-camera":{"android":{"default":"md-reverse-camera","active":"md-reverse-camera"},"ios":{"default":"ios-reverse-camera-outline","active":"ios-reverse-camera"}},"rewind":{"android":{"default":"md-rewind","active":"md-rewind"},"ios":{"default":"ios-rewind-outline","active":"ios-rewind"}},"ribbon":{"android":{"default":"md-ribbon","active":"md-ribbon"},"ios":{"default":"ios-ribbon-outline","active":"ios-ribbon"}},"rose":{"android":{"default":"md-rose","active":"md-rose"},"ios":{"default":"ios-rose-outline","active":"ios-rose"}},"sad":{"android":{"default":"md-sad","active":"md-sad"},"ios":{"default":"ios-sad-outline","active":"ios-sad"}},"school":{"android":{"default":"md-school","active":"md-school"},"ios":{"default":"ios-school-outline","active":"ios-school"}},"search":{"android":{"default":"md-search","active":"md-search"},"ios":{"default":"ios-search-outline","active":"ios-search"}},"send":{"android":{"default":"md-send","active":"md-send"},"ios":{"default":"ios-send-outline","active":"ios-send"}},"settings":{"android":{"default":"md-settings","active":"md-settings"},"ios":{"default":"ios-settings-outline","active":"ios-settings"}},"share":{"android":{"default":"md-share","active":"md-share"},"ios":{"default":"ios-share-outline","active":"ios-share"}},"share-all":{"android":{"default":"md-share-all","active":"md-share-all"},"ios":{"default":"ios-share-all-outline","active":"ios-share-all"}},"shirt":{"android":{"default":"md-shirt","active":"md-shirt"},"ios":{"default":"ios-shirt-outline","active":"ios-shirt"}},"shuffle":{"android":{"default":"md-shuffle","active":"md-shuffle"},"ios":{"default":"ios-shuffle-outline","active":"ios-shuffle"}},"skip-backward":{"android":{"default":"md-skip-backward","active":"md-skip-backward"},"ios":{"default":"ios-skip-backward-outline","active":"ios-skip-backward"}},"skip-forward":{"android":{"default":"md-skip-forward","active":"md-skip-forward"},"ios":{"default":"ios-skip-forward-outline","active":"ios-skip-forward"}},"snow":{"android":{"default":"md-snow","active":"md-snow"},"ios":{"default":"ios-snow-outline","active":"ios-snow"}},"speedometer":{"android":{"default":"md-speedometer","active":"md-speedometer"},"ios":{"default":"ios-speedometer-outline","active":"ios-speedometer"}},"square":{"android":{"default":"md-square-outline","active":"md-square"},"ios":{"default":"ios-square-outline","active":"ios-square"}},"star":{"android":{"default":"md-star-outline","active":"md-star"},"ios":{"default":"ios-star-outline","active":"ios-star"}},"star-half":{"android":{"default":"md-star-half","active":"md-star-half"},"ios":{"default":"ios-star-half-outline","active":"ios-star-half"}},"stats":{"android":{"default":"md-stats","active":"md-stats"},"ios":{"default":"ios-stats-outline","active":"ios-stats"}},"stopwatch":{"android":{"default":"md-stopwatch","active":"md-stopwatch"},"ios":{"default":"ios-stopwatch-outline","active":"ios-stopwatch"}},"subway":{"android":{"default":"md-subway","active":"md-subway"},"ios":{"default":"ios-subway-outline","active":"ios-subway"}},"sunny":{"android":{"default":"md-sunny","active":"md-sunny"},"ios":{"default":"ios-sunny-outline","active":"ios-sunny"}},"swap":{"android":{"default":"md-swap","active":"md-swap"},"ios":{"default":"ios-swap-outline","active":"ios-swap"}},"switch":{"android":{"default":"md-switch","active":"md-switch"},"ios":{"default":"ios-switch-outline","active":"ios-switch"}},"sync":{"android":{"default":"md-sync","active":"md-sync"},"ios":{"default":"ios-sync-outline","active":"ios-sync"}},"tablet-landscape":{"android":{"default":"md-tablet-landscape","active":"md-tablet-landscape"},"ios":{"default":"ios-tablet-landscape-outline","active":"ios-tablet-landscape"}},"tablet-portrait":{"android":{"default":"md-tablet-portrait","active":"md-tablet-portrait"},"ios":{"default":"ios-tablet-portrait-outline","active":"ios-tablet-portrait"}},"tennisball":{"android":{"default":"md-tennisball","active":"md-tennisball"},"ios":{"default":"ios-tennisball-outline","active":"ios-tennisball"}},"text":{"android":{"default":"md-text","active":"md-text"},"ios":{"default":"ios-text-outline","active":"ios-text"}},"thermometer":{"android":{"default":"md-thermometer","active":"md-thermometer"},"ios":{"default":"ios-thermometer-outline","active":"ios-thermometer"}},"thumbs-down":{"android":{"default":"md-thumbs-down","active":"md-thumbs-down"},"ios":{"default":"ios-thumbs-down-outline","active":"ios-thumbs-down"}},"thumbs-up":{"android":{"default":"md-thumbs-up","active":"md-thumbs-up"},"ios":{"default":"ios-thumbs-up-outline","active":"ios-thumbs-up"}},"thunderstorm":{"android":{"default":"md-thunderstorm","active":"md-thunderstorm"},"ios":{"default":"ios-thunderstorm-outline","active":"ios-thunderstorm"}},"time":{"android":{"default":"md-time","active":"md-time"},"ios":{"default":"ios-time-outline","active":"ios-time"}},"timer":{"android":{"default":"md-timer","active":"md-timer"},"ios":{"default":"ios-timer-outline","active":"ios-timer"}},"train":{"android":{"default":"md-train","active":"md-train"},"ios":{"default":"ios-train-outline","active":"ios-train"}},"transgender":{"android":{"default":"md-transgender","active":"md-transgender"},"ios":{"default":"ios-transgender-outline","active":"ios-transgender"}},"trash":{"android":{"default":"md-trash","active":"md-trash"},"ios":{"default":"ios-trash-outline","active":"ios-trash"}},"trending-down":{"android":{"default":"md-trending-down","active":"md-trending-down"},"ios":{"default":"ios-trending-down-outline","active":"ios-trending-down"}},"trending-up":{"android":{"default":"md-trending-up","active":"md-trending-up"},"ios":{"default":"ios-trending-up-outline","active":"ios-trending-up"}},"trophy":{"android":{"default":"md-trophy","active":"md-trophy"},"ios":{"default":"ios-trophy-outline","active":"ios-trophy"}},"umbrella":{"android":{"default":"md-umbrella","active":"md-umbrella"},"ios":{"default":"ios-umbrella-outline","active":"ios-umbrella"}},"undo":{"android":{"default":"md-undo","active":"md-undo"},"ios":{"default":"ios-undo-outline","active":"ios-undo"}},"unlock":{"android":{"default":"md-unlock","active":"md-unlock"},"ios":{"default":"ios-unlock-outline","active":"ios-unlock"}},"videocam":{"android":{"default":"md-videocam","active":"md-videocam"},"ios":{"default":"ios-videocam-outline","active":"ios-videocam"}},"volume-down":{"android":{"default":"md-volume-down","active":"md-volume-down"},"ios":{"default":"ios-volume-down-outline","active":"ios-volume-down"}},"volume-up":{"android":{"default":"md-volume-up","active":"md-volume-up"},"ios":{"default":"ios-volume-up-outline","active":"ios-volume-up"}},"volume-mute":{"android":{"default":"md-volume-mute","active":"md-volume-mute"},"ios":{"default":"ios-volume-mute-outline","active":"ios-volume-mute"}},"volume-off":{"android":{"default":"md-volume-off","active":"md-volume-off"},"ios":{"default":"ios-volume-off-outline","active":"ios-volume-off"}},"walk":{"android":{"default":"md-walk","active":"md-walk"},"ios":{"default":"ios-walk-outline","active":"ios-walk"}},"warning":{"android":{"default":"md-warning","active":"md-warning"},"ios":{"default":"ios-warning-outline","active":"ios-warning"}},"watch":{"android":{"default":"md-watch","active":"md-watch"},"ios":{"default":"ios-watch-outline","active":"ios-watch"}},"water":{"android":{"default":"md-water","active":"md-water"},"ios":{"default":"ios-water-outline","active":"ios-water"}},"wifi":{"android":{"default":"md-wifi","active":"md-wifi"},"ios":{"default":"ios-wifi-outline","active":"ios-wifi"}},"wine":{"android":{"default":"md-wine","active":"md-wine"},"ios":{"default":"ios-wine-outline","active":"ios-wine"}},"woman":{"android":{"default":"md-woman","active":"md-woman"},"ios":{"default":"ios-woman-outline","active":"ios-woman"}}}

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.InputGroup=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/InputGroup.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);

var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _computeProps=__webpack_require__(23);var _computeProps2=_interopRequireDefault(_computeProps);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

InputGroup=function(_Component){_inherits(InputGroup,_Component);function InputGroup(){_classCallCheck(this,InputGroup);return _possibleConstructorReturn(this,(InputGroup.__proto__||Object.getPrototypeOf(InputGroup)).apply(this,arguments));}_createClass(InputGroup,[{key:"getInitialStyle",value:function getInitialStyle()
{
return{
roundedInputGroup:{
borderWidth:this.props.rounded?1:undefined,
borderRadius:this.props.rounded?_platform2.default.inputGroupRoundedBorderRadius:undefined}};


}},{key:"prepareRootProps",value:function prepareRootProps()

{
var defaultProps={
style:this.getInitialStyle().roundedInputGroup};


return(0,_computeProps2.default)(this.props,defaultProps);
}},{key:"render",value:function render()
{var _this2=this;
return(
_react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.prepareRootProps(),{__source:{fileName:_jsxFileName,lineNumber:30}}),
this.props.children));


}}]);return InputGroup;}(_react.Component);


InputGroup.propTypes=_extends({},_Utils.ViewPropTypes,{

regular:_propTypes2.default.bool,
underline:_propTypes2.default.bool,
rounded:_propTypes2.default.bool,
success:_propTypes2.default.bool,
error:_propTypes2.default.bool,
disabled:_propTypes2.default.bool});


var StyledInputGroup=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.InputGroup",{},_mapPropsToStyleNames2.default)(InputGroup);exports.

InputGroup=StyledInputGroup;
//# sourceMappingURL=InputGroup.js.map

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

NativeBaseComponent=function(_Component){_inherits(NativeBaseComponent,_Component);function NativeBaseComponent(){_classCallCheck(this,NativeBaseComponent);return _possibleConstructorReturn(this,(NativeBaseComponent.__proto__||Object.getPrototypeOf(NativeBaseComponent)).apply(this,arguments));}_createClass(NativeBaseComponent,[{key:"getChildContext",value:function getChildContext()















{
return{
theme:this.props.theme?this.props.theme:this.context.theme};

}},{key:"getContextForegroundColor",value:function getContextForegroundColor()

{
return this.context.foregroundColor;
}}]);return NativeBaseComponent;}(_react.Component);NativeBaseComponent.contextTypes={theme:_propTypes2.default.object,foregroundColor:_propTypes2.default.string};NativeBaseComponent.propTypes={theme:_propTypes2.default.object,foregroundColor:_propTypes2.default.string};NativeBaseComponent.childContextTypes={theme:_propTypes2.default.object,foregroundColor:_propTypes2.default.string};exports.default=NativeBaseComponent;
//# sourceMappingURL=NativeBaseComponent.js.map

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Fab=undefined;var _jsxFileName="src/basic/Fab.js";var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _computeProps=__webpack_require__(23);var _computeProps2=_interopRequireDefault(_computeProps);

var _reactNative=__webpack_require__(1);
var _Icon=__webpack_require__(81);
var _IconNB=__webpack_require__(74);
var _Button=__webpack_require__(58);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);
var _lodash=__webpack_require__(12);var _lodash2=_interopRequireDefault(_lodash);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);
var _nativeBaseShoutemTheme=__webpack_require__(5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _Dimensions$get=

_reactNative.Dimensions.get("window"),height=_Dimensions$get.height,width=_Dimensions$get.width;

var AnimatedFab=_reactNative.Animated.createAnimatedComponent(_Button.Button);var

Fab=function(_Component){_inherits(Fab,_Component);








function Fab(props){_classCallCheck(this,Fab);var _this=_possibleConstructorReturn(this,(Fab.__proto__||Object.getPrototypeOf(Fab)).call(this,
props));
_this.containerHeight=new _reactNative.Animated.Value(56);
_this.containerWidth=new _reactNative.Animated.Value(0);
_this.buttonScale=new _reactNative.Animated.Value(0);
_this.state={
buttons:undefined,
active:false};return _this;

}_createClass(Fab,[{key:"fabTopValue",value:function fabTopValue(

pos){
if(pos==="topLeft"){
return{
top:20,
bottom:undefined,
left:20,
right:undefined};

}else if(pos==="bottomRight"){
return{
top:undefined,
bottom:20,
left:undefined,
right:20};

}else if(pos==="bottomLeft"){
return{
top:undefined,
bottom:20,
left:20,
right:undefined};

}else if(pos==="topRight"){
return{
top:20,
bottom:undefined,
left:undefined,
right:20};

}
}},{key:"fabOtherBtns",value:function fabOtherBtns(

direction,i){
if(direction==="up"){
return{
top:undefined,
bottom:this.props.active===false?_reactNative.Platform.OS==="ios"?50:8:i*50+65,
left:8,
right:0};

}else if(direction==="left"){
return{
top:8,
bottom:0,
left:this.props.active===false?_reactNative.Platform.OS==="ios"?8:8:-(i*50+50),
right:0};

}else if(direction==="down"){
return{
top:this.props.active===false?_reactNative.Platform.OS==="ios"?50:8:i*50+65,
bottom:0,
left:8,
right:0};

}else if(direction==="right"){
return{
top:8,
bottom:0,
left:this.props.active===false?_reactNative.Platform.OS==="ios"?50:8:i*50+65,
right:0};

}
}},{key:"getInitialStyle",value:function getInitialStyle(

iconStyle){
return{
fab:{
height:56,
width:56,
borderRadius:28,
elevation:4,
shadowColor:"#000",
shadowOffset:{width:0,height:2},
shadowOpacity:0.4,
justifyContent:"center",
alignItems:"center",
shadowRadius:2,
position:"absolute",
bottom:0,
backgroundColor:"blue"},

container:{
position:"absolute",
top:this.props.position?this.fabTopValue(this.props.position).top:undefined,
bottom:this.props.position?this.fabTopValue(this.props.position).bottom:20,
right:this.props.position?this.fabTopValue(this.props.position).right:20,
left:this.props.position?this.fabTopValue(this.props.position).left:undefined,
width:56,
height:this.containerHeight,
flexDirection:this.props.direction?
this.props.direction=="left || right"?"row":"column":
"column",
alignItems:"center"},

iconStyle:_extends({
color:"#fff",
fontSize:24,
lineHeight:_reactNative.Platform.OS=="ios"?27:undefined},
iconStyle),

buttonStyle:{
position:"absolute",
height:40,
width:40,
left:7,
borderRadius:20,
transform:this.state.active?[{scale:new _reactNative.Animated.Value(1)}]:[{scale:this.buttonScale}],
marginBottom:10,
backgroundColor:"blue"}};


}},{key:"getContainerStyle",value:function getContainerStyle()

{
return _lodash2.default.merge(this.getInitialStyle().container,this.props.containerStyle);
}},{key:"prepareFabProps",value:function prepareFabProps()

{
var defaultProps={
style:this.getInitialStyle().fab};

var incomingProps=_lodash2.default.clone(this.props);
delete incomingProps.onPress;

return(0,_computeProps2.default)(incomingProps,defaultProps);
}},{key:"getOtherButtonStyle",value:function getOtherButtonStyle(

child,i){
var type={
top:this.props.direction?this.fabOtherBtns(this.props.direction,i).top:undefined,
left:this.props.direction?this.fabOtherBtns(this.props.direction,i).left:8,
right:this.props.direction?this.fabOtherBtns(this.props.direction,i).right:0,
bottom:this.props.direction?
this.fabOtherBtns(this.props.direction,i).bottom:
this.props.active===false?_reactNative.Platform.OS==="ios"?8:8:i*50+65};


return _lodash2.default.merge(this.getInitialStyle().buttonStyle,child.props.style,type);
}},{key:"prepareButtonProps",value:function prepareButtonProps(
child){
var inp=_lodash2.default.clone(child.props);
delete inp.style;

var defaultProps={};

return(0,_computeProps2.default)(inp,defaultProps);
}},{key:"componentDidMount",value:function componentDidMount()

{var _this2=this;
var childrenArray=_react2.default.Children.toArray(this.props.children);
var icon=_lodash2.default.remove(childrenArray,function(item){
if(item.type.displayName==="Styled(Button)"){
return true;
}
});
this.setState({
buttons:icon.length});

this.activeTimer=setTimeout(function(){
_this2.setState({
active:_this2.props.active});

},0);
}},{key:"componentWillUnmount",value:function componentWillUnmount()

{
if(this.activeTimer){
clearTimeout(this.activeTimer);
}
}},{key:"renderFab",value:function renderFab()

{
var childrenArray=_react2.default.Children.toArray(this.props.children);
var icon=_lodash2.default.remove(childrenArray,function(item){
if(item.type.displayName==="Styled(Button)"){
return true;
}
});



return _react2.default.cloneElement(childrenArray[0],{
style:this.getInitialStyle(childrenArray[0].props.style).iconStyle});

}},{key:"renderButtons",value:function renderButtons()

{var _this3=this;
var childrenArray=_react2.default.Children.toArray(this.props.children);






var newChildren=[];

{
childrenArray.slice(1).map(function(child,i){
newChildren.push(
_react2.default.createElement(AnimatedFab,_extends({
style:_this3.getOtherButtonStyle(child,i)},
_this3.prepareButtonProps(child,i),{
fabButton:true,
key:i,__source:{fileName:_jsxFileName,lineNumber:237}}),

child.props.children));


});
}
return newChildren;
}},{key:"upAnimate",value:function upAnimate()
{
if(!this.props.active){
_reactNative.Animated.spring(this.containerHeight,{
toValue:this.state.buttons*51.3+56}).
start();
_reactNative.Animated.spring(this.buttonScale,{
toValue:1}).
start();
}else{
this.setState({
active:false});

_reactNative.Animated.spring(this.containerHeight,{
toValue:56}).
start();
_reactNative.Animated.spring(this.buttonScale,{
toValue:0}).
start();
}
}},{key:"leftAnimate",value:function leftAnimate()

















{
if(!this.props.active){
_reactNative.Animated.spring(this.containerWidth,{
toValue:this.state.buttons*51.3+56}).
start();
_reactNative.Animated.spring(this.buttonScale,{
toValue:1}).
start();
}else{
this.setState({
active:false});

_reactNative.Animated.spring(this.containerHeight,{
toValue:56}).
start();
_reactNative.Animated.spring(this.buttonScale,{
toValue:0}).
start();
}
}},{key:"rightAnimate",value:function rightAnimate()

{
if(!this.props.active){
_reactNative.Animated.spring(this.containerWidth,{
toValue:this.state.buttons*51.3+56}).
start();
_reactNative.Animated.spring(this.buttonScale,{
toValue:1}).
start();
}else{
this.setState({
active:false});

_reactNative.Animated.spring(this.containerHeight,{
toValue:56}).
start();
_reactNative.Animated.spring(this.buttonScale,{
toValue:0}).
start();
}
}},{key:"downAnimate",value:function downAnimate()

{
if(!this.props.active){
_reactNative.Animated.spring(this.containerHeight,{
toValue:56}).
start();
_reactNative.Animated.spring(this.buttonScale,{
toValue:1}).
start();
}else{
this.setState({
active:false});

_reactNative.Animated.spring(this.containerHeight,{
toValue:56}).
start();
_reactNative.Animated.spring(this.buttonScale,{
toValue:0}).
start();
}
}},{key:"_animate",value:function _animate()
{var _props=
this.props,direction=_props.direction,position=_props.position;
if(this.props.direction){
if(this.props.direction==="up"){
this.upAnimate();
}else if(this.props.direction==="left"){
this.leftAnimate();
}else if(this.props.direction==="right"){
this.rightAnimate();
}else if(this.props.direction==="down"){
this.downAnimate();
}
}else{
this.upAnimate();
}
}},{key:"fabOnPress",value:function fabOnPress()

{var _this4=this;
if(this.props.onPress){
this.props.onPress();
this._animate();
this.activeTimer=setTimeout(function(){
_this4.setState({
active:_this4.props.active});

},100);
}
}},{key:"render",value:function render()

{var _this5=this;var
active=this.props.active;

return(
_react2.default.createElement(_reactNative.Animated.View,{style:this.getContainerStyle(),__source:{fileName:_jsxFileName,lineNumber:382}},
this.renderButtons(),
_reactNative.Platform.OS==="ios"||_platform2.default.androidRipple===false||_reactNative.Platform["Version"]<=21?
_react2.default.createElement(_reactNative.TouchableOpacity,_extends({onPress:function onPress(){return _this5.fabOnPress();}},this.prepareFabProps(),{activeOpacity:1,__source:{fileName:_jsxFileName,lineNumber:385}}),
this.renderFab()):


_react2.default.createElement(_reactNative.TouchableNativeFeedback,_extends({
onPress:function onPress(){return _this5.fabOnPress();},
background:
this.props.androidRippleColor?
_reactNative.TouchableNativeFeedback.Ripple(this.props.androidRippleColor):
_reactNative.TouchableNativeFeedback.Ripple(_platform2.default.androidRippleColor)},

this.prepareFabProps(),{__source:{fileName:_jsxFileName,lineNumber:389}}),

_react2.default.createElement(_reactNative.View,{style:[this.getInitialStyle().fab,this.props.style],__source:{fileName:_jsxFileName,lineNumber:398}},this.renderFab()))));




}}]);return Fab;}(_react.Component);

var StyledFab=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Fab",{},_mapPropsToStyleNames2.default)(Fab);exports.
Fab=StyledFab;
//# sourceMappingURL=Fab.js.map

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Badge=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Badge.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Badge=function(_Component){_inherits(Badge,_Component);function Badge(){_classCallCheck(this,Badge);return _possibleConstructorReturn(this,(Badge.__proto__||Object.getPrototypeOf(Badge)).apply(this,arguments));}_createClass(Badge,[{key:"render",value:function render()
{var _this2=this;
return(
_react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:13}}),
this.props.children));


}}]);return Badge;}(_react.Component);


Badge.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledBadge=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Badge",{},_mapPropsToStyleNames2.default)(Badge);exports.

Badge=StyledBadge;
//# sourceMappingURL=Badge.js.map

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.CheckBox=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Checkbox.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Ionicons=__webpack_require__(108);var _Ionicons2=_interopRequireDefault(_Ionicons);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);
var _lodash=__webpack_require__(12);var _lodash2=_interopRequireDefault(_lodash);
var _computeProps=__webpack_require__(23);var _computeProps2=_interopRequireDefault(_computeProps);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

CheckBox=function(_Component){_inherits(CheckBox,_Component);function CheckBox(){_classCallCheck(this,CheckBox);return _possibleConstructorReturn(this,(CheckBox.__proto__||Object.getPrototypeOf(CheckBox)).apply(this,arguments));}_createClass(CheckBox,[{key:"getInitialStyle",value:function getInitialStyle(




variables){
return{
checkStyle:{
borderColor:this.props.color?this.props.color:variables.checkboxBgColor,
backgroundColor:
this.props.checked===true?
this.props.color?this.props.color:variables.checkboxBgColor:
"transparent"}};


}},{key:"prepareRootProps",value:function prepareRootProps(

variables){
var defaultProps={
style:this.getInitialStyle(variables).checkStyle};


return(0,_computeProps2.default)(this.props,defaultProps);
}},{key:"render",value:function render()
{var _this2=this;
var variables=this.context.theme?this.context.theme["@@shoutem.theme/themeStyle"].variables:_platform2.default;
var platformStyle=variables.platformStyle;
var platform=variables.platform;
return(
_react2.default.createElement(_reactNative.TouchableOpacity,_extends({ref:function ref(c){return _this2._root=c;}},this.prepareRootProps(variables),{__source:{fileName:_jsxFileName,lineNumber:40}}),
_react2.default.createElement(_Ionicons2.default,{
style:{
color:this.props.checked===true?variables.checkboxTickColor:"transparent",
fontSize:variables.CheckboxFontSize,
lineHeight:variables.CheckboxIconSize},

name:platform==="ios"&&platformStyle!=="material"?"ios-checkmark-outline":"md-checkmark",__source:{fileName:_jsxFileName,lineNumber:41}})));



}}]);return CheckBox;}(_react.Component);CheckBox.contextTypes={theme:_propTypes2.default.object};


CheckBox.propTypes=_extends({},
_reactNative.TouchableOpacity.propTypes,{
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array]),
checked:_propTypes2.default.bool,
onPress:_propTypes2.default.func});


var StyledCheckBox=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.CheckBox",{},_mapPropsToStyleNames2.default)(CheckBox);exports.

CheckBox=StyledCheckBox;
//# sourceMappingURL=Checkbox.js.map

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Thumbnail=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Thumbnail.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _computeProps=__webpack_require__(23);var _computeProps2=_interopRequireDefault(_computeProps);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Thumbnail=function(_Component){_inherits(Thumbnail,_Component);function Thumbnail(){_classCallCheck(this,Thumbnail);return _possibleConstructorReturn(this,(Thumbnail.__proto__||Object.getPrototypeOf(Thumbnail)).apply(this,arguments));}_createClass(Thumbnail,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.Image,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:10}}));
}}]);return Thumbnail;}(_react.Component);


Thumbnail.propTypes=_extends({},
_reactNative.Image.propTypes,{
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array]),
square:_propTypes2.default.bool,
circular:_propTypes2.default.bool,
size:_propTypes2.default.number});


var StyledThumbnail=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Thumbnail",{},_mapPropsToStyleNames2.default)(Thumbnail);exports.

Thumbnail=StyledThumbnail;
//# sourceMappingURL=Thumbnail.js.map

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Card=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Card.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Card=function(_Component){_inherits(Card,_Component);function Card(){_classCallCheck(this,Card);return _possibleConstructorReturn(this,(Card.__proto__||Object.getPrototypeOf(Card)).apply(this,arguments));}_createClass(Card,[{key:"render",value:function render()
{var _this2=this;
if(this.props.dataArray&&this.props.renderRow){
var ds=new _reactNative.ListView.DataSource({
rowHasChanged:function rowHasChanged(r1,r2){return r1!==r2;}});

var dataSource=ds.cloneWithRows(this.props.dataArray);
return(
_react2.default.createElement(_reactNative.ListView,_extends({},
this.props,{
enableEmptySections:true,
dataSource:dataSource,
renderRow:this.props.renderRow,__source:{fileName:_jsxFileName,lineNumber:17}})));


}
return(
_react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:26}}),
this.props.children));


}}]);return Card;}(_react.Component);


Card.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array]),
dataArray:_propTypes2.default.array,
renderRow:_propTypes2.default.func});


var StyledCard=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Card",{},_mapPropsToStyleNames2.default)(Card);exports.

Card=StyledCard;
//# sourceMappingURL=Card.js.map

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.CardItem=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/CardItem.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

CardItem=function(_Component){_inherits(CardItem,_Component);function CardItem(){_classCallCheck(this,CardItem);return _possibleConstructorReturn(this,(CardItem.__proto__||Object.getPrototypeOf(CardItem)).apply(this,arguments));}_createClass(CardItem,[{key:"render",value:function render()
{var _this2=this;
if(this.props.button){
return(
_react2.default.createElement(_reactNative.TouchableOpacity,_extends({
ref:function ref(c){return _this2._root=c;}},
this.props,{
activeOpacity:this.props.button?0.2:1,__source:{fileName:_jsxFileName,lineNumber:12}}),

this.props.children));


}else{
return(
_react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:22}}),
this.props.children));


}
}}]);return CardItem;}(_react.Component);


CardItem.propTypes=_extends({},
_reactNative.TouchableOpacity.propTypes,{
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array]),
header:_propTypes2.default.bool,
cardBody:_propTypes2.default.bool,
footer:_propTypes2.default.bool,
button:_propTypes2.default.bool});


var StyledCardItem=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.CardItem",{},_mapPropsToStyleNames2.default)(CardItem);exports.

CardItem=StyledCardItem;
//# sourceMappingURL=CardItem.js.map

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.H1=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/H1.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

H1=function(_Component){_inherits(H1,_Component);function H1(){_classCallCheck(this,H1);return _possibleConstructorReturn(this,(H1.__proto__||Object.getPrototypeOf(H1)).apply(this,arguments));}_createClass(H1,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.Text,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:10}}));
}}]);return H1;}(_react.Component);


var childrenType=function childrenType(props,propName,component){
var error=void 0;
var prop=props[propName];
_react2.default.Children.forEach(prop,function(child){
if(typeof child!=="string"){
error=new Error(component+" should have only string");
}
});
return error;
};

H1.propTypes=_extends({},
_reactNative.Text.propTypes,{
children:childrenType,
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledH1=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.H1",{},_mapPropsToStyleNames2.default)(H1);exports.

H1=StyledH1;
//# sourceMappingURL=H1.js.map

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.H2=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/H2.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

H2=function(_Component){_inherits(H2,_Component);function H2(){_classCallCheck(this,H2);return _possibleConstructorReturn(this,(H2.__proto__||Object.getPrototypeOf(H2)).apply(this,arguments));}_createClass(H2,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.Text,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:10}}));
}}]);return H2;}(_react.Component);

var childrenType=function childrenType(props,propName,component){
var error=void 0;
var prop=props[propName];
_react2.default.Children.forEach(prop,function(child){
if(typeof child!=="string"){
error=new Error(component+" should have only string");
}
});
return error;
};

H2.propTypes=_extends({},
_reactNative.Text.propTypes,{
children:childrenType,
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledH2=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.H2",{},_mapPropsToStyleNames2.default)(H2);exports.

H2=StyledH2;
//# sourceMappingURL=H2.js.map

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.H3=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/H3.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

H3=function(_Component){_inherits(H3,_Component);function H3(){_classCallCheck(this,H3);return _possibleConstructorReturn(this,(H3.__proto__||Object.getPrototypeOf(H3)).apply(this,arguments));}_createClass(H3,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.Text,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:10}}));
}}]);return H3;}(_react.Component);


var childrenType=function childrenType(props,propName,component){
var error=void 0;
var prop=props[propName];
_react2.default.Children.forEach(prop,function(child){
if(typeof child!=="string"){
error=new Error(component+" should have only string");
}
});
return error;
};

H3.propTypes=_extends({},
_reactNative.Text.propTypes,{
children:childrenType,
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledH3=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.H3",{},_mapPropsToStyleNames2.default)(H3);exports.

H3=StyledH3;
//# sourceMappingURL=H3.js.map

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Spinner=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Spinner.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Spinner=function(_Component){_inherits(Spinner,_Component);function Spinner(){_classCallCheck(this,Spinner);return _possibleConstructorReturn(this,(Spinner.__proto__||Object.getPrototypeOf(Spinner)).apply(this,arguments));}_createClass(Spinner,[{key:"render",value:function render()



{var _this2=this;
var variables=this.context.theme?this.context.theme["@@shoutem.theme/themeStyle"].variables:_platform2.default;
return(
_react2.default.createElement(_reactNative.ActivityIndicator,_extends({
ref:function ref(c){return _this2._root=c;}},
this.props,{
color:
this.props.color?
this.props.color:
this.props.inverse?variables.inverseSpinnerColor:variables.defaultSpinnerColor,

size:this.props.size?this.props.size:"large",__source:{fileName:_jsxFileName,lineNumber:16}})));


}}]);return Spinner;}(_react.Component);Spinner.contextTypes={theme:_propTypes2.default.object};


Spinner.propTypes=_extends({},
_reactNative.ActivityIndicator.propTypes,{
color:_propTypes2.default.string,
inverse:_propTypes2.default.bool});


var StyledSpinner=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Spinner",{},_mapPropsToStyleNames2.default)(Spinner);exports.

Spinner=StyledSpinner;
//# sourceMappingURL=Spinner.js.map

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Switch=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Switch.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Switch=function(_Component){_inherits(Switch,_Component);function Switch(){_classCallCheck(this,Switch);return _possibleConstructorReturn(this,(Switch.__proto__||Object.getPrototypeOf(Switch)).apply(this,arguments));}_createClass(Switch,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.Switch,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:10}}));
}}]);return Switch;}(_react.Component);


Switch.propTypes=_extends({},
Switch.propTypes);


var StyledSwitch=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Switch",{},_mapPropsToStyleNames2.default)(Switch);exports.

Switch=StyledSwitch;
//# sourceMappingURL=Switch.js.map

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Toast=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Toast.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Toast=function(_Component){_inherits(Toast,_Component);function Toast(){_classCallCheck(this,Toast);return _possibleConstructorReturn(this,(Toast.__proto__||Object.getPrototypeOf(Toast)).apply(this,arguments));}_createClass(Toast,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:10}}));
}}]);return Toast;}(_react.Component);


Toast.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledToast=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Toast",{},_mapPropsToStyleNames2.default)(Toast);exports.
Toast=StyledToast;
//# sourceMappingURL=Toast.js.map

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Root=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Root.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);
var _ToastContainer=__webpack_require__(125);
var _Actionsheet=__webpack_require__(126);
var _Text=__webpack_require__(29);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Root=function(_Component){_inherits(Root,_Component);function Root(){_classCallCheck(this,Root);return _possibleConstructorReturn(this,(Root.__proto__||Object.getPrototypeOf(Root)).apply(this,arguments));}_createClass(Root,[{key:"render",value:function render()
{var _this2=this;
return(
_react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{style:{flex:1},__source:{fileName:_jsxFileName,lineNumber:14}}),
this.props.children,
_react2.default.createElement(_ToastContainer.ToastContainer,{
ref:function ref(c){
if(!_ToastContainer.ToastContainer.toastInstance)_ToastContainer.ToastContainer.toastInstance=c;
},__source:{fileName:_jsxFileName,lineNumber:16}}),

_react2.default.createElement(_Actionsheet.ActionSheetContainer,{
ref:function ref(c){
if(!_Actionsheet.ActionSheetContainer.actionsheetInstance)_Actionsheet.ActionSheetContainer.actionsheetInstance=c;
},__source:{fileName:_jsxFileName,lineNumber:21}})));



}}]);return Root;}(_react.Component);


Root.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledRoot=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Root",{},_mapPropsToStyleNames2.default)(Root);exports.

Root=StyledRoot;
//# sourceMappingURL=Root.js.map

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_KeyboardAwareHOC__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_KeyboardAwareScrollView__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_KeyboardAwareListView__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_KeyboardAwareFlatList__ = __webpack_require__(606);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "listenToKeyboardEvents", function() { return __WEBPACK_IMPORTED_MODULE_0__lib_KeyboardAwareHOC__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "KeyboardAwareListView", function() { return __WEBPACK_IMPORTED_MODULE_2__lib_KeyboardAwareListView__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "KeyboardAwareFlatList", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_KeyboardAwareFlatList__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "KeyboardAwareScrollView", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_KeyboardAwareScrollView__["a"]; });


/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isIphoneX;
/* unused harmony export ifIphoneX */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_native__);
function isIphoneX(){var dimen=__WEBPACK_IMPORTED_MODULE_0_react_native__["Dimensions"].get('window');return __WEBPACK_IMPORTED_MODULE_0_react_native__["Platform"].OS==='ios'&&!__WEBPACK_IMPORTED_MODULE_0_react_native__["Platform"].isPad&&!__WEBPACK_IMPORTED_MODULE_0_react_native__["Platform"].isTVOS&&(dimen.height===812||dimen.width===812);}function ifIphoneX(iphoneXStyle,regularStyle){if(isIphoneX()){return iphoneXStyle;}else{return regularStyle;}}

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KeyboardAwareHOC__ = __webpack_require__(82);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__KeyboardAwareHOC__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react_native__["ScrollView"]));

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KeyboardAwareHOC__ = __webpack_require__(82);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__KeyboardAwareHOC__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react_native__["ListView"]));

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KeyboardAwareHOC__ = __webpack_require__(82);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__KeyboardAwareHOC__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react_native__["FlatList"]));

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Footer=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Footer.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _lodash=__webpack_require__(12);var _lodash2=_interopRequireDefault(_lodash);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);
var _Utils=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Footer=function(_Component){_inherits(Footer,_Component);function Footer(){_classCallCheck(this,Footer);return _possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).apply(this,arguments));}_createClass(Footer,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:11}}));
}}]);return Footer;}(_react.Component);


Footer.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledFooter=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Footer",{},_mapPropsToStyleNames2.default)(Footer);exports.
Footer=StyledFooter;
//# sourceMappingURL=Footer.js.map

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.FooterTab=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/FooterTab.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

FooterTab=function(_Component){_inherits(FooterTab,_Component);function FooterTab(){_classCallCheck(this,FooterTab);return _possibleConstructorReturn(this,(FooterTab.__proto__||Object.getPrototypeOf(FooterTab)).apply(this,arguments));}_createClass(FooterTab,[{key:"render",value:function render()
{var _this2=this;
return(
_react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:12}}),
this.props.children));


}}]);return FooterTab;}(_react.Component);


FooterTab.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledFooterTab=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.FooterTab",{},_mapPropsToStyleNames2.default)(FooterTab);exports.

FooterTab=StyledFooterTab;
//# sourceMappingURL=FooterTab.js.map

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Form=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Form.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Form=function(_Component){_inherits(Form,_Component);function Form(){_classCallCheck(this,Form);return _possibleConstructorReturn(this,(Form.__proto__||Object.getPrototypeOf(Form)).apply(this,arguments));}_createClass(Form,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:11}}));
}}]);return Form;}(_react.Component);


Form.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledForm=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Form",{},_mapPropsToStyleNames2.default)(Form);exports.

Form=StyledForm;
//# sourceMappingURL=Form.js.map

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.PickerNB=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Picker.ios.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _createReactClass=__webpack_require__(28);var _createReactClass2=_interopRequireDefault(_createReactClass);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);
var _lodash=__webpack_require__(12);var _lodash2=_interopRequireDefault(_lodash);
var _Text=__webpack_require__(29);
var _List=__webpack_require__(127);
var _IconNB=__webpack_require__(74);
var _Radio=__webpack_require__(215);
var _Container=__webpack_require__(216);
var _Content=__webpack_require__(217);
var _ListItem=__webpack_require__(73);
var _Button=__webpack_require__(58);
var _Header=__webpack_require__(212);
var _Title=__webpack_require__(214);
var _Left=__webpack_require__(70);
var _Right=__webpack_require__(71);
var _Body=__webpack_require__(72);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _computeProps=__webpack_require__(23);var _computeProps2=_interopRequireDefault(_computeProps);

var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

PickerNB=function(_Component){_inherits(PickerNB,_Component);
function PickerNB(props){_classCallCheck(this,PickerNB);var _this=_possibleConstructorReturn(this,(PickerNB.__proto__||Object.getPrototypeOf(PickerNB)).call(this,
props));
_this.state={
modalVisible:false,
currentLabel:_this.getLabel(props),
dataSource:props.children};return _this;

}_createClass(PickerNB,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(

nextProps){
var currentLabel=this.state.currentLabel;
var nextLabel=this.getLabel(nextProps);
var currentDS=this.state.dataSource;
var nextDS=nextProps.children;

if(currentLabel!==nextLabel){
this.setState({
currentLabel:nextLabel});

}
if(currentDS!==nextDS){
this.setState({
dataSource:nextDS});

}
}},{key:"getInitialStyle",value:function getInitialStyle()

{
return{
picker:{},


pickerItem:{}};

}},{key:"_setModalVisible",value:function _setModalVisible(
visible){
this.setState({modalVisible:visible});
}},{key:"prepareRootProps",value:function prepareRootProps()

{
var defaultProps={
style:this.getInitialStyle().picker,
itemStyle:this.getInitialStyle().pickerItem};


return(0,_computeProps2.default)(this.props,defaultProps);
}},{key:"getLabel",value:function getLabel(

props){
var item=_lodash2.default.find(props.children,function(child){return child.props.value===props.selectedValue;});
return _lodash2.default.get(item,"props.label");
}},{key:"getSelectedItem",value:function getSelectedItem()

{var _this2=this;
return _lodash2.default.find(this.props.children,function(child){return child.props.value===_this2.props.selectedValue;});
}},{key:"renderIcon",value:function renderIcon()

{
return _react2.default.cloneElement(this.props.iosIcon,{
style:{fontSize:22,lineHeight:26,color:"#7a7a7a"}});

}},{key:"renderButton",value:function renderButton()

{var _this3=this;
var onPress=function onPress(){
_this3._setModalVisible(true);
};
var text=this.state.currentLabel?this.state.currentLabel:this.props.placeholder;
if(this.props.renderButton){
return this.props.renderButton({
onPress:onPress,
text:text,
picker:this,
selectedItem:this.getSelectedItem()});

}
return(
_react2.default.createElement(_Button.Button,{style:this.props.style,dark:true,picker:true,transparent:true,onPress:onPress,__source:{fileName:_jsxFileName,lineNumber:103}},
this.state.currentLabel?
_react2.default.createElement(_Text.Text,{style:this.props.textStyle,note:this.props.note,__source:{fileName:_jsxFileName,lineNumber:105}},
this.state.currentLabel):

_react2.default.createElement(_Text.Text,{style:this.props.textStyle,note:this.props.note===false?false:true,__source:{fileName:_jsxFileName,lineNumber:108}},
this.props.placeholder),

this.props.iosIcon===undefined?null:this.renderIcon()));


}},{key:"renderHeader",value:function renderHeader()

{var _this4=this;
return this.props.renderHeader?
this.props.renderHeader(function(){return _this4._setModalVisible(false);}):
_react2.default.createElement(_Header.Header,{style:this.props.headerStyle,__source:{fileName:_jsxFileName,lineNumber:119}},
_react2.default.createElement(_Left.Left,{__source:{fileName:_jsxFileName,lineNumber:120}},
_react2.default.createElement(_Button.Button,{
style:_extends({
shadowOffset:null,
shadowColor:null,
shadowRadius:null,
shadowOpacity:null},
this.props.headerBackButtonStyle),

transparent:true,
onPress:function onPress(){
_this4._setModalVisible(false);
},__source:{fileName:_jsxFileName,lineNumber:121}},

_react2.default.createElement(_Text.Text,{style:this.props.headerBackButtonTextStyle,__source:{fileName:_jsxFileName,lineNumber:134}},
this.props.headerBackButtonText||"Back"))),



_react2.default.createElement(_Body.Body,{__source:{fileName:_jsxFileName,lineNumber:139}},
_react2.default.createElement(_Title.Title,{style:this.props.headerTitleStyle,__source:{fileName:_jsxFileName,lineNumber:140}},
this.props.iosHeader||"Select One")),


_react2.default.createElement(_Right.Right,{__source:{fileName:_jsxFileName,lineNumber:144}}));

}},{key:"render",value:function render()

{var _this5=this;
return(
_react2.default.createElement(_reactNative.View,{ref:function ref(c){return _this5._root=c;},__source:{fileName:_jsxFileName,lineNumber:150}},
this.renderButton(),
_react2.default.createElement(_reactNative.Modal,{
supportedOrientations:this.props.supportedOrientations||null,
animationType:"slide",
transparent:false,
visible:this.state.modalVisible,
onRequestClose:function onRequestClose(){
_this5._setModalVisible(false);
},__source:{fileName:_jsxFileName,lineNumber:152}},

_react2.default.createElement(_Container.Container,{__source:{fileName:_jsxFileName,lineNumber:161}},
this.renderHeader(),
_react2.default.createElement(_Content.Content,{__source:{fileName:_jsxFileName,lineNumber:163}},
_react2.default.createElement(_List.List,{
dataArray:this.state.dataSource,
renderRow:function renderRow(child){return(
_react2.default.createElement(_ListItem.ListItem,{
selected:child.props.value===_this5.props.selectedValue,
button:true,
style:_this5.props.itemStyle,
onPress:function onPress(){
_this5._setModalVisible(false);
_this5.props.onValueChange(child.props.value);
_this5.setState({current:child.props.label});
},__source:{fileName:_jsxFileName,lineNumber:167}},

_react2.default.createElement(_Text.Text,{style:_this5.props.itemTextStyle,__source:{fileName:_jsxFileName,lineNumber:177}},
child.props.label),

_react2.default.createElement(_Right.Right,{__source:{fileName:_jsxFileName,lineNumber:180}},
child.props.value===_this5.props.selectedValue?
_react2.default.createElement(_Radio.Radio,{selected:true,__source:{fileName:_jsxFileName,lineNumber:182}}):
_react2.default.createElement(_Radio.Radio,{selected:false,__source:{fileName:_jsxFileName,lineNumber:183}}))));},__source:{fileName:_jsxFileName,lineNumber:164}}))))));








}}]);return PickerNB;}(_react.Component);


PickerNB.Item=(0,_createReactClass2.default)({displayName:"Item",
render:function render(){
return _react2.default.createElement(_reactNative.Picker.Item,_extends({},this.props(),{__source:{fileName:_jsxFileName,lineNumber:197}}));
}});


PickerNB.propTypes=_extends({},_Utils.ViewPropTypes,{

renderButton:_propTypes2.default.func});


var StyledPickerNB=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.PickerNB",{},_mapPropsToStyleNames2.default)(PickerNB);exports.

PickerNB=StyledPickerNB;
//# sourceMappingURL=Picker.ios.js.map

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Separator=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Separator.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Separator=function(_Component){_inherits(Separator,_Component);function Separator(){_classCallCheck(this,Separator);return _possibleConstructorReturn(this,(Separator.__proto__||Object.getPrototypeOf(Separator)).apply(this,arguments));}_createClass(Separator,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:11}}));
}}]);return Separator;}(_react.Component);


Separator.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledSeparator=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Separator",{},_mapPropsToStyleNames2.default)(Separator);exports.

Separator=StyledSeparator;
//# sourceMappingURL=Separator.js.map

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.DeckSwiper=undefined;var _jsxFileName="src/basic/DeckSwiper.js";var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _clamp=__webpack_require__(218);var _clamp2=_interopRequireDefault(_clamp);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);
var _Utils=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var SWIPE_THRESHOLD=120;var

DeckSwiper=function(_Component){_inherits(DeckSwiper,_Component);
function DeckSwiper(props){_classCallCheck(this,DeckSwiper);var _this=_possibleConstructorReturn(this,(DeckSwiper.__proto__||Object.getPrototypeOf(DeckSwiper)).call(this,
props));
_this.state={
pan:new _reactNative.Animated.ValueXY(),
pan2:new _reactNative.Animated.ValueXY(),
enter:new _reactNative.Animated.Value(0.8),
selectedItem:_this.props.dataSource[0],
selectedItem2:_this.props.dataSource[1],
card1Top:true,
card2Top:false,
fadeAnim:new _reactNative.Animated.Value(0.8),
looping:typeof _this.props.looping==="undefined"?true:_this.props.looping,
disabled:_this.props.dataSource.length===0,
lastCard:_this.props.dataSource.length===1};return _this;

}_createClass(DeckSwiper,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(_ref)

{var dataSource=_ref.dataSource;
if(dataSource.length!==this.props.dataSource.length){
if(dataSource.length<=1){
this.setState(_extends({},
this.state,{
selectedItem:dataSource[0],
selectedItem2:undefined,
disabled:dataSource.length===0,
lastCard:dataSource.length===1}));

return;
}

var visibleIndex=dataSource.indexOf(this.state.selectedItem);
var currentIndex=visibleIndex<0?visibleIndex+1:visibleIndex;
var nextIndex=currentIndex+1===dataSource.length?0:currentIndex+1;

this.setState({
selectedItem:dataSource[currentIndex],
selectedItem2:dataSource[nextIndex]});

}
}},{key:"getInitialStyle",value:function getInitialStyle()

{
return{
topCard:{
position:"absolute",
top:0,
right:0,
left:0}};


}},{key:"findNextIndexes",value:function findNextIndexes(

currentIndex){
var newIdx=currentIndex+1;
var newIdx2=currentIndex+2;

if(newIdx2>this.props.dataSource.length-1&&newIdx===this.props.dataSource.length-1){
return[newIdx,0];
}else if(newIdx>this.props.dataSource.length-1){
return[0,1];
}
return[newIdx,newIdx2];
}},{key:"selectNext",value:function selectNext()

{var _this2=this;
var dataSource=this.props.dataSource;
var currentIndex=dataSource.indexOf(this.state.selectedItem);


if(!this.state.looping){

if(currentIndex===dataSource.length-1){
return this.setState({
disabled:true});

}else if(currentIndex===dataSource.length-2){

return setTimeout(function(){
_this2.setState({
selectedItem:dataSource[currentIndex+1]});

setTimeout(function(){
_this2.setState({
lastCard:true});

},350);
},50);
}
}

var nextIndexes=this.findNextIndexes(currentIndex);
setTimeout(function(){
_this2.setState({
selectedItem:_this2.props.dataSource[nextIndexes[0]]});

setTimeout(function(){
_this2.setState({
selectedItem2:_this2.props.dataSource[nextIndexes[1]]});

},350);
},50);
}},{key:"swipeRight",value:function swipeRight()

{var _this3=this;
if(this.props.onSwiping)this.props.onSwiping("right");
setTimeout(function(){
_reactNative.Animated.timing(_this3.state.fadeAnim,{toValue:1}).start();
_reactNative.Animated.spring(_this3.state.enter,{toValue:1,friction:7}).start();
_this3.selectNext();
_reactNative.Animated.decay(_this3.state.pan,{
velocity:{x:8,y:1},
deceleration:0.98}).
start(_this3._resetState.bind(_this3));
},300);
}},{key:"swipeLeft",value:function swipeLeft()

{var _this4=this;
if(this.props.onSwiping)this.props.onSwiping("left");
setTimeout(function(){
_reactNative.Animated.timing(_this4.state.fadeAnim,{toValue:1}).start();
_reactNative.Animated.spring(_this4.state.enter,{toValue:1,friction:7}).start();
_this4.selectNext();
_reactNative.Animated.decay(_this4.state.pan,{
velocity:{x:-8,y:1},
deceleration:0.98}).
start(_this4._resetState.bind(_this4));
},300);
}},{key:"componentWillMount",value:function componentWillMount()

{var _this5=this;
this._panResponder=_reactNative.PanResponder.create({
onMoveShouldSetResponderCapture:function onMoveShouldSetResponderCapture(){return true;},
onMoveShouldSetPanResponderCapture:function onMoveShouldSetPanResponderCapture(evt,gestureState){return Math.abs(gestureState.dx)>5;},

onPanResponderGrant:function onPanResponderGrant(e,gestureState){
_this5.state.pan.setOffset({
x:_this5.state.pan.x._value,
y:_this5.state.pan.y._value});

_this5.state.pan.setValue({x:0,y:0});
},

onPanResponderMove:function onPanResponderMove(e,gestureState){
if(gestureState.dx>20){
if(_this5.props.onSwiping)_this5.props.onSwiping("right",gestureState.dx);
}else if(gestureState.dx<-20){
if(_this5.props.onSwiping)_this5.props.onSwiping("left",gestureState.dx);
}
var val=Math.abs(gestureState.dx*0.0013);
var opa=Math.abs(gestureState.dx*0.0022);
if(val>0.2){
val=0.2;
}
_reactNative.Animated.timing(_this5.state.fadeAnim,{toValue:0.8+val}).start();
_reactNative.Animated.spring(_this5.state.enter,{
toValue:0.8+val,
friction:7}).
start();
_reactNative.Animated.event([null,{dx:_this5.state.pan.x}])(e,gestureState);
},

onPanResponderRelease:function onPanResponderRelease(e,_ref2){var vx=_ref2.vx,vy=_ref2.vy;
if(_this5.props.onSwiping)_this5.props.onSwiping(null);
var velocity=void 0;

if(vx>=0){
velocity=(0,_clamp2.default)(vx,4.5,10);
}else if(vx<0){
velocity=(0,_clamp2.default)(vx*-1,4.5,10)*-1;
}

if(Math.abs(_this5.state.pan.x._value)>SWIPE_THRESHOLD){
if(velocity>0){
_this5.props.onSwipeRight?_this5.props.onSwipeRight(_this5.state.selectedItem):undefined;
_this5.selectNext();
}else{
_this5.props.onSwipeLeft?_this5.props.onSwipeLeft(_this5.state.selectedItem):undefined;
_this5.selectNext();
}

_reactNative.Animated.decay(_this5.state.pan,{
velocity:{x:velocity,y:vy},
deceleration:0.98}).
start(_this5._resetState.bind(_this5));
}else{
_reactNative.Animated.spring(_this5.state.pan,{
toValue:{x:0,y:0},
friction:4}).
start();
}
}});

}},{key:"_resetState",value:function _resetState()

{
this.state.pan.setValue({x:0,y:0});
this.state.enter.setValue(0.8);
this.state.fadeAnim.setValue(0.8);
this.setState({
card1Top:!this.state.card1Top,
card2Top:!this.state.card2Top});

if(this.props.onSwiping)this.props.onSwiping(null);
}},{key:"getCardStyles",value:function getCardStyles()

{var _state=
this.state,pan=_state.pan,pan2=_state.pan2,enter=_state.enter;var _ref3=

[pan.x,pan.y],translateX=_ref3[0],translateY=_ref3[1];


var rotate=pan.x.interpolate({
inputRange:[-700,0,700],
outputRange:["-10deg","0deg","10deg"]});


var opacity=pan.x.interpolate({
inputRange:[-320,0,320],
outputRange:[0.9,1,0.9]});

var scale=enter;

var animatedCardStyles={
transform:[{translateX:translateX},{translateY:translateY},{rotate:rotate}],
opacity:opacity};

var animatedCardStyles2={transform:[{scale:scale}]};

return[animatedCardStyles,animatedCardStyles2];
}},{key:"render",value:function render()

{
if(this.state.disabled){

return(
_react2.default.createElement(_reactNative.View,{style:{position:"relative",flexDirection:"column"},__source:{fileName:_jsxFileName,lineNumber:247}},

_react2.default.createElement(_reactNative.View,{__source:{fileName:_jsxFileName,lineNumber:249}},
this.props.renderEmpty&&this.props.renderEmpty())));




}else if(this.state.lastCard){

return(
_react2.default.createElement(_reactNative.View,{style:{position:"relative",flexDirection:"column"},__source:{fileName:_jsxFileName,lineNumber:258}},
this.state.selectedItem===undefined?
_react2.default.createElement(_reactNative.View,{__source:{fileName:_jsxFileName,lineNumber:260}}):
_react2.default.createElement(_reactNative.View,{__source:{fileName:_jsxFileName,lineNumber:261}},
_react2.default.createElement(_reactNative.Animated.View,_extends({
style:[
this.getCardStyles()[1],
this.getInitialStyle().topCard,
{opacity:this.state.fadeAnim}]},

this._panResponder.panHandlers,{__source:{fileName:_jsxFileName,lineNumber:262}}),

this.props.renderEmpty&&this.props.renderEmpty()),

_react2.default.createElement(_reactNative.Animated.View,_extends({
style:[this.getCardStyles()[0],this.getInitialStyle().topCard]},
this._panResponder.panHandlers,{__source:{fileName:_jsxFileName,lineNumber:272}}),

this.props.renderItem(this.state.selectedItem)))));




}
return(
_react2.default.createElement(_reactNative.View,{style:{position:"relative",flexDirection:"column"},__source:{fileName:_jsxFileName,lineNumber:283}},
this.state.selectedItem===undefined?
_react2.default.createElement(_reactNative.View,{__source:{fileName:_jsxFileName,lineNumber:285}}):
_react2.default.createElement(_reactNative.View,{__source:{fileName:_jsxFileName,lineNumber:286}},
_react2.default.createElement(_reactNative.Animated.View,_extends({
style:[
this.getCardStyles()[1],
this.getInitialStyle().topCard,
{opacity:this.state.fadeAnim}]},

this._panResponder.panHandlers,{__source:{fileName:_jsxFileName,lineNumber:287}}),

this.props.renderBottom?
this.props.renderBottom(this.state.selectedItem2):
this.props.renderItem(this.state.selectedItem2)),

_react2.default.createElement(_reactNative.Animated.View,_extends({
style:[this.getCardStyles()[0],this.getInitialStyle().topCard]},
this._panResponder.panHandlers,{__source:{fileName:_jsxFileName,lineNumber:299}}),

this.props.renderTop?
this.props.renderTop(this.state.selectedItem):
this.props.renderItem(this.state.selectedItem)))));




}}]);return DeckSwiper;}(_react.Component);


DeckSwiper.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array]),
dataSource:_propTypes2.default.array});


var StyledDeckSwiper=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.DeckSwiper",{},_mapPropsToStyleNames2.default)(DeckSwiper);exports.

DeckSwiper=StyledDeckSwiper;
//# sourceMappingURL=DeckSwiper.js.map

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Item=undefined;var _jsxFileName="src/basic/Item.js";var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Input=__webpack_require__(213);
var _Label=__webpack_require__(219);
var _Icon=__webpack_require__(81);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);
var _computeProps=__webpack_require__(23);var _computeProps2=_interopRequireDefault(_computeProps);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);
var _lodash=__webpack_require__(12);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Item=function(_Component){_inherits(Item,_Component);
function Item(props){_classCallCheck(this,Item);var _this=_possibleConstructorReturn(this,(Item.__proto__||Object.getPrototypeOf(Item)).call(this,
props));
_this.state={
text:"",
topAnim:new _reactNative.Animated.Value(18),
opacAnim:new _reactNative.Animated.Value(1)};return _this;

}_createClass(Item,[{key:"componentDidMount",value:function componentDidMount()
{
if(this.props.floatingLabel){
if(this.inputProps&&this.inputProps.value){
this.setState({isFocused:true});
this.floatUp(-16);
}
if(this.inputProps&&this.inputProps.getRef)this.inputProps.getRef(this._inputRef);
}
}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(
nextProps){var _this2=this;
var childrenArray=_react2.default.Children.toArray(nextProps.children);
var inputProps={};
input=_lodash2.default.remove(childrenArray,function(item){
if(item.type.displayName==="Styled(Input)"){
inputProps=item.props;
_this2.inputProps=item.props;
return item;
}
});
if(this.props.floatingLabel){
if(this.inputProps&&this.inputProps.value){
this.setState({isFocused:true});
this.floatUp(-16);
}
if(this.inputProps&&this.inputProps.getRef)this.inputProps.getRef(this._inputRef);
}
}},{key:"floatBack",value:function floatBack()

{
_reactNative.Animated.timing(this.state.topAnim,{
toValue:18,
duration:150}).
start();
_reactNative.Animated.timing(this.state.opacAnim,{
toValue:1,
duration:150}).
start();
}},{key:"floatUp",value:function floatUp(

e){
_reactNative.Animated.timing(this.state.topAnim,{
toValue:e||-22,
duration:150}).
start();
_reactNative.Animated.timing(this.state.opacAnim,{
toValue:0.7,
duration:150}).
start();
}},{key:"renderLabel",value:function renderLabel(

label,labelProps){
var newLabel=[];
if(this.props.floatingLabel){
if(this.state.isFocused){
newLabel.push(
_react2.default.createElement(_Label.Label,_extends({},
labelProps,{
key:"newFLabel",
float:true,
style:_extends({
fontSize:15,
lineHeight:30},
labelProps.style)})));



this.floatUp();
}else{
newLabel.push(label);
this.floatBack();
}
}else{
newLabel.push(
_react2.default.createElement(_Label.Label,_extends({},
labelProps,{
key:"newLabel"})));


}
return newLabel;
}},{key:"renderChildren",value:function renderChildren()

{var _this3=this;
var newChildren=[];
var childrenArray=_react2.default.Children.toArray(this.props.children);

var label=[];
var labelProps={};
label=_lodash2.default.remove(childrenArray,function(item){
if(item.type===_Label.Label){
labelProps=item.props;
return item;
}
});

var input=[];
var inputProps={};
input=_lodash2.default.remove(childrenArray,function(item){
if(item.type===_Input.Input){
inputProps=item.props;
_this3.inputProps=item.props;
return item;
}
});

var icon=[];
var iconProps={};
icon=_lodash2.default.remove(childrenArray,function(item){
if(item.type===_Icon.Icon){
iconProps=item.props;
return item;
}
});
if(this.props.floatingLabel&&icon.length){
newChildren.push(_react2.default.createElement(_Icon.Icon,_extends({key:"i1"},iconProps,{__source:{fileName:_jsxFileName,lineNumber:137}})));
newChildren.push(
_react2.default.createElement(_reactNative.Animated.View,{
key:"float",
style:{
position:"absolute",
left:this.props.last?22:22,
right:0,
top:this.state.topAnim,
opacity:this.state.opacAnim,
paddingTop:_reactNative.Platform.OS==="ios"?undefined:undefined,
paddingBottom:_reactNative.Platform.OS==="ios"?undefined:12},__source:{fileName:_jsxFileName,lineNumber:139}},


_react2.default.createElement(_Label.Label,_extends({},labelProps,{__source:{fileName:_jsxFileName,lineNumber:151}}),this.renderLabel(label,labelProps))));


newChildren.push(
_react2.default.createElement(_Input.Input,_extends({
key:"l2"},
inputProps,{
onFocus:function onFocus(){
_this3.setState({isFocused:true});
inputProps.onFocus&&inputProps.onFocus();
},
onBlur:function onBlur(){
inputProps.value?
_this3.setState({
isFocused:true}):

!_this3.state.text.length&&_this3.setState({isFocused:false});
inputProps.onBlur&&inputProps.onBlur();
},
onChangeText:function onChangeText(text){
_this3.setState({text:text});
inputProps.onChangeText&&inputProps.onChangeText(text);
},__source:{fileName:_jsxFileName,lineNumber:155}})));


}else if(this.props.floatingLabel){
newChildren.push(
_react2.default.createElement(_reactNative.Animated.View,{
key:"float",
style:{
position:"absolute",
left:this.props.last?15:0,
right:0,
top:this.state.topAnim,
opacity:this.state.opacAnim,
paddingTop:_reactNative.Platform.OS==="ios"?undefined:undefined,
paddingBottom:_reactNative.Platform.OS==="ios"?undefined:12},__source:{fileName:_jsxFileName,lineNumber:178}},


_react2.default.createElement(_Label.Label,_extends({},labelProps,{__source:{fileName:_jsxFileName,lineNumber:190}}),this.renderLabel(label,labelProps))));


newChildren.push(
_react2.default.createElement(_Input.Input,_extends({
ref:function ref(c){return _this3._inputRef=c;},
value:this.state.text,
key:"l2"},
inputProps,{
onFocus:function onFocus(){
_this3.setState({isFocused:true});
inputProps.onFocus&&inputProps.onFocus();
},
onBlur:function onBlur(){
inputProps.value?
_this3.setState({
isFocused:true}):

!_this3.state.text.length&&_this3.setState({isFocused:false});
inputProps.onBlur&&inputProps.onBlur();
},
onChangeText:function onChangeText(text){
_this3.setState({text:text});
inputProps.onChangeText&&inputProps.onChangeText(text);
},__source:{fileName:_jsxFileName,lineNumber:194}})));


}else if(this.props.stackedLabel&&icon.length){
newChildren.push(
_react2.default.createElement(_reactNative.View,{
key:"s",
style:{
flexDirection:"row",
flex:1,
width:_platform2.default.deviceWidth-15},__source:{fileName:_jsxFileName,lineNumber:219}},


_react2.default.createElement(_Icon.Icon,_extends({key:"s1"},iconProps,{__source:{fileName:_jsxFileName,lineNumber:227}})),
_react2.default.createElement(_reactNative.View,{style:{flexDirection:"column"},__source:{fileName:_jsxFileName,lineNumber:228}},
_react2.default.createElement(_Label.Label,_extends({key:"s2"},labelProps,{__source:{fileName:_jsxFileName,lineNumber:229}})),
_react2.default.createElement(_Input.Input,_extends({key:"s3"},inputProps,{style:{width:_platform2.default.deviceWidth-40},__source:{fileName:_jsxFileName,lineNumber:230}})))));



}else{
return this.props.children;
}
return newChildren;
}},{key:"getInitialStyle",value:function getInitialStyle()
{
return{
roundedInputGroup:{
borderWidth:this.props.rounded?_platform2.default.borderWidth*2:undefined,
borderRadius:this.props.rounded?_platform2.default.inputGroupRoundedBorderRadius:undefined}};


}},{key:"prepareRootProps",value:function prepareRootProps()

{
var defaultProps={
style:this.getInitialStyle().roundedInputGroup};


return(0,_computeProps2.default)(this.props,defaultProps);
}},{key:"render",value:function render()
{var _this4=this;
return(
_react2.default.createElement(_reactNative.TouchableOpacity,_extends({ref:function ref(c){return _this4._root=c;}},this.prepareRootProps(),{activeOpacity:1,__source:{fileName:_jsxFileName,lineNumber:257}}),
this.renderChildren()));


}}]);return Item;}(_react.Component);


var childrenType=function childrenType(props,propName,component){
var error=void 0;
var prop=props[propName];
if(!props.children.length){
error=new Error(component+" should have both Label and Input components");
}else if(
props.children[0].type.displayName!=="Styled(Label)"||
props.children[1].type.displayName!=="Styled(Input)")
{
error=new Error(component+" should have Label and Input components only");
}
return error;
};

Item.propTypes=_extends({},
_reactNative.TouchableOpacity.propTypes,{
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array]),
inlineLabel:_propTypes2.default.bool,
floatingLabel:_propTypes2.default.bool,
stackedLabel:_propTypes2.default.bool,
fixedLabel:_propTypes2.default.bool,
success:_propTypes2.default.bool,
error:_propTypes2.default.bool});


var StyledItem=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Item",{},_mapPropsToStyleNames2.default)(Item);exports.

Item=StyledItem;
//# sourceMappingURL=Item.js.map

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Segment=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Segment.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Segment=function(_Component){_inherits(Segment,_Component);function Segment(){_classCallCheck(this,Segment);return _possibleConstructorReturn(this,(Segment.__proto__||Object.getPrototypeOf(Segment)).apply(this,arguments));}_createClass(Segment,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:10}}));
}}]);return Segment;}(_react.Component);


Segment.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledSegment=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Segment",{},_mapPropsToStyleNames2.default)(Segment);exports.
Segment=StyledSegment;
//# sourceMappingURL=Segment.js.map

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Textarea=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Textarea.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _platform=__webpack_require__(4);var _platform2=_interopRequireDefault(_platform);
var _computeProps=__webpack_require__(23);var _computeProps2=_interopRequireDefault(_computeProps);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Textarea=function(_Component){_inherits(Textarea,_Component);function Textarea(){_classCallCheck(this,Textarea);return _possibleConstructorReturn(this,(Textarea.__proto__||Object.getPrototypeOf(Textarea)).apply(this,arguments));}_createClass(Textarea,[{key:"getStyle",value:function getStyle()
{
return{
textarea:{
height:this.props.rowSpan?this.props.rowSpan*25:60}};


}},{key:"prepareRootProps",value:function prepareRootProps()

{
var defaultProps={
style:this.getStyle().textarea};

return(0,_computeProps2.default)(this.props,defaultProps);
}},{key:"render",value:function render()
{var _this2=this;
return(
_react2.default.createElement(_reactNative.TextInput,_extends({
ref:function ref(c){
_this2._textInput=c;
_this2._root=c;
}},
this.prepareRootProps(),{
multiline:true,
placeholderTextColor:
this.props.placeholderTextColor?this.props.placeholderTextColor:_platform2.default.inputColorPlaceholder,

underlineColorAndroid:"rgba(0,0,0,0)",__source:{fileName:_jsxFileName,lineNumber:26}})));


}}]);return Textarea;}(_react.Component);


Textarea.propTypes=_extends({},
_reactNative.TextInput.propTypes,{
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array]),
rowSpan:_propTypes2.default.number,
bordered:_propTypes2.default.bool,
underline:_propTypes2.default.bool});


var StyledTextarea=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Textarea",{},_mapPropsToStyleNames2.default)(Textarea);exports.

Textarea=StyledTextarea;
//# sourceMappingURL=Textarea.js.map

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Tab=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Tab.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _Utils=__webpack_require__(7);

var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Tab=function(_Component){_inherits(Tab,_Component);function Tab(){_classCallCheck(this,Tab);return _possibleConstructorReturn(this,(Tab.__proto__||Object.getPrototypeOf(Tab)).apply(this,arguments));}_createClass(Tab,[{key:"render",value:function render()
{var _this2=this;
return(
_react2.default.createElement(_reactNative.View,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:12}}),
this.props.children));


}}]);return Tab;}(_react.Component);


Tab.propTypes=_extends({},_Utils.ViewPropTypes,{

style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledTab=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Tab",{},_mapPropsToStyleNames2.default)(Tab);exports.

Tab=StyledTab;
//# sourceMappingURL=Tab.js.map

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Tabs/index.js";

var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _createReactClass=__webpack_require__(28);var _createReactClass2=_interopRequireDefault(_createReactClass);










var _Utils=__webpack_require__(7);

var _lodash=__webpack_require__(12);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var React=__webpack_require__(0);var Component=React.Component;var ReactNative=__webpack_require__(1);var Dimensions=ReactNative.Dimensions,View=ReactNative.View,Animated=ReactNative.Animated,ScrollView=ReactNative.ScrollView,StyleSheet=ReactNative.StyleSheet,InteractionManager=ReactNative.InteractionManager,Platform=ReactNative.Platform;var TimerMixin=__webpack_require__(103);

var SceneComponent=__webpack_require__(618);var _require=
__webpack_require__(220),DefaultTabBar=_require.DefaultTabBar;var _require2=
__webpack_require__(222),ScrollableTabBar=_require2.ScrollableTabBar;

var ScrollableTabView=(0,_createReactClass2.default)({displayName:"ScrollableTabView",
mixins:[TimerMixin],
statics:{
DefaultTabBar:DefaultTabBar,
ScrollableTabBar:ScrollableTabBar},


propTypes:{
tabBarPosition:_propTypes2.default.oneOf(["top","bottom","overlayTop","overlayBottom"]),
initialPage:_propTypes2.default.number,
page:_propTypes2.default.number,
onChangeTab:_propTypes2.default.func,
onScroll:_propTypes2.default.func,
renderTabBar:_propTypes2.default.any,
style:_Utils.ViewPropTypes.style,
contentProps:_propTypes2.default.object,
scrollWithoutAnimation:_propTypes2.default.bool,
locked:_propTypes2.default.bool,
prerenderingSiblingsNumber:_propTypes2.default.number},


getDefaultProps:function getDefaultProps(){
return{
tabBarPosition:"top",
initialPage:0,
page:-1,
onChangeTab:function onChangeTab(){},
onScroll:function onScroll(){},
contentProps:{},
scrollWithoutAnimation:false,
locked:false,
prerenderingSiblingsNumber:0};

},

getInitialState:function getInitialState(){
return{
currentPage:this.props.initialPage,
scrollValue:new Animated.Value(this.props.initialPage),
containerWidth:Dimensions.get("window").width,
sceneKeys:this.newSceneKeys({currentPage:this.props.initialPage})};

},

componentDidMount:function componentDidMount(){var _this=this;
var scrollFn=function scrollFn(){
if(_this.scrollView&&Platform.OS==="android"){
var x=_this.props.initialPage*_this.state.containerWidth;
_this.scrollView.scrollTo({x:x,animated:false});
}
};
this.setTimeout(function(){
InteractionManager.runAfterInteractions(scrollFn);
},0);
},

componentWillReceiveProps:function componentWillReceiveProps(props){
if(props.children!==this.props.children){
this.updateSceneKeys({
page:this.state.currentPage,
children:props.children});

}

if(props.page>=0&&props.page!==this.state.currentPage){
this.goToPage(props.page);
}
},

goToPage:function goToPage(pageNumber){
var offset=pageNumber*this.state.containerWidth;
if(this.scrollView){
this.scrollView.scrollTo({
x:offset,
y:0,
animated:!this.props.scrollWithoutAnimation});

}

var currentPage=this.state.currentPage;
this.updateSceneKeys({
page:pageNumber,
callback:this._onChangeTab.bind(this,currentPage,pageNumber)});

},

renderTabBar:function renderTabBar(props){
if(this.props.renderTabBar===false){
return null;
}else if(this.props.renderTabBar){
return React.cloneElement(this.props.renderTabBar(props),props);
}else{
return React.createElement(DefaultTabBar,_extends({},props,{__source:{fileName:_jsxFileName,lineNumber:115}}));
}
},

updateSceneKeys:function updateSceneKeys(_ref){var page=_ref.page,_ref$children=_ref.children,children=_ref$children===undefined?this.props.children:_ref$children,_ref$callback=_ref.callback,callback=_ref$callback===undefined?function(){}:_ref$callback;
var newKeys=this.newSceneKeys({
previousKeys:this.state.sceneKeys,
currentPage:page,
children:children});

this.setState({currentPage:page,sceneKeys:newKeys},callback);
},

newSceneKeys:function newSceneKeys(_ref2){var _this2=this;var _ref2$previousKeys=_ref2.previousKeys,previousKeys=_ref2$previousKeys===undefined?[]:_ref2$previousKeys,_ref2$currentPage=_ref2.currentPage,currentPage=_ref2$currentPage===undefined?0:_ref2$currentPage,_ref2$children=_ref2.children,children=_ref2$children===undefined?this.props.children:_ref2$children;
var newKeys=[];
this._children(children).forEach(function(child,idx){
var key=_this2._makeSceneKey(child,idx);
if(_this2._keyExists(previousKeys,key)||_this2._shouldRenderSceneKey(idx,currentPage)){
newKeys.push(key);
}
});
return newKeys;
},

_shouldRenderSceneKey:function _shouldRenderSceneKey(idx,currentPageKey){
var numOfSibling=this.props.prerenderingSiblingsNumber;
return idx<currentPageKey+numOfSibling+1&&idx>currentPageKey-numOfSibling-1;
},

_keyExists:function _keyExists(sceneKeys,key){
return sceneKeys.find(function(sceneKey){return key===sceneKey;});
},

_makeSceneKey:function _makeSceneKey(child,idx){
return child.props.heading+"_"+idx;
},

renderScrollableContent:function renderScrollableContent(){var _this3=this;
var scenes=this._composeScenes();
return(
React.createElement(ScrollView,_extends({
horizontal:true,
pagingEnabled:true,
automaticallyAdjustContentInsets:false,
contentOffset:{
x:this.props.initialPage*this.state.containerWidth},

ref:function ref(scrollView){
_this3.scrollView=scrollView;
},
onScroll:function onScroll(e){
var offsetX=e.nativeEvent.contentOffset.x;
_this3._updateScrollValue(offsetX/_this3.state.containerWidth);
},
onMomentumScrollBegin:this._onMomentumScrollBeginAndEnd,
onMomentumScrollEnd:this._onMomentumScrollBeginAndEnd,
scrollEventThrottle:16,
scrollsToTop:false,
showsHorizontalScrollIndicator:false,
scrollEnabled:!this.props.locked,
directionalLockEnabled:true,
alwaysBounceVertical:false,
keyboardDismissMode:"on-drag"},
this.props.contentProps,{__source:{fileName:_jsxFileName,lineNumber:155}}),

scenes));


},

_composeScenes:function _composeScenes(){var _this4=this;
return this._children().map(function(child,idx){
var key=_this4._makeSceneKey(child,idx);
return(
React.createElement(SceneComponent,{
key:child.key,
shouldUpdated:_this4._shouldRenderSceneKey(idx,_this4.state.currentPage),
style:{width:_this4.state.containerWidth},__source:{fileName:_jsxFileName,lineNumber:189}},

_this4._keyExists(_this4.state.sceneKeys,key)?
child:

React.createElement(View,{heading:child.props.heading,__source:{fileName:_jsxFileName,lineNumber:197}})));



});
},

_onMomentumScrollBeginAndEnd:function _onMomentumScrollBeginAndEnd(e){
var offsetX=e.nativeEvent.contentOffset.x;
var page=Math.round(offsetX/this.state.containerWidth);
if(this.state.currentPage!==page){
this._updateSelectedPage(page);
}
},

_updateSelectedPage:function _updateSelectedPage(nextPage){
var localNextPage=nextPage;
if(typeof localNextPage==="object"){
localNextPage=nextPage.nativeEvent.position;
}

var currentPage=this.state.currentPage;
this.updateSceneKeys({
page:localNextPage,
callback:this._onChangeTab.bind(this,currentPage,localNextPage)});

},

_onChangeTab:function _onChangeTab(prevPage,currentPage){
this.props.onChangeTab({
i:currentPage,
ref:this._children()[currentPage],
from:prevPage});

},

_updateScrollValue:function _updateScrollValue(value){
this.state.scrollValue.setValue(value);
this.props.onScroll(value);
},

_handleLayout:function _handleLayout(e){var _this5=this;var
width=e.nativeEvent.layout.width;

if(Math.round(width)!==Math.round(this.state.containerWidth)){
this.setState({containerWidth:width});
this.requestAnimationFrame(function(){
_this5.goToPage(_this5.state.currentPage);
});
}
},

_children:function _children(){var children=arguments.length>0&&arguments[0]!==undefined?arguments[0]:this.props.children;
return React.Children.map(children,function(child){return child;});
},

render:function render(){
var overlayTabs=
this.props.tabBarPosition==="overlayTop"||this.props.tabBarPosition==="overlayBottom";
var tabBarProps={
goToPage:this.goToPage,
tabs:this._children().map(function(child){return child.props.heading;}),
tabStyle:this._children().map(function(child){return child.props.tabStyle;}),
activeTabStyle:this._children().map(function(child){return child.props.activeTabStyle;}),
textStyle:this._children().map(function(child){return child.props.textStyle;}),
activeTextStyle:this._children().map(function(child){return child.props.activeTextStyle;}),
tabHeaderStyle:this._children().map(function(child){return(
_lodash2.default.get(child.props.heading.props,"style",undefined));}),

activeTab:this.state.currentPage,
scrollValue:this.state.scrollValue,
containerWidth:this.state.containerWidth};


if(this.props.tabBarBackgroundColor){
tabBarProps.backgroundColor=this.props.tabBarBackgroundColor;
}
if(this.props.tabBarActiveTextColor){
tabBarProps.activeTextColor=this.props.tabBarActiveTextColor;
}
if(this.props.tabBarInactiveTextColor){
tabBarProps.inactiveTextColor=this.props.tabBarInactiveTextColor;
}
if(this.props.tabBarTextStyle){
tabBarProps.textStyle=this.props.tabBarTextStyle;
}
if(this.props.tabBarUnderlineStyle){
tabBarProps.underlineStyle=this.props.tabBarUnderlineStyle;
}
if(this.props.tabContainerStyle){
tabBarProps.tabContainerStyle=this.props.tabContainerStyle;
}
if(overlayTabs){
tabBarProps.style=_defineProperty({
position:"absolute",
left:0,
right:0},
this.props.tabBarPosition==="overlayTop"?"top":"bottom",0);

}

return(
React.createElement(View,{style:[styles.container,this.props.style],onLayout:this._handleLayout,__source:{fileName:_jsxFileName,lineNumber:299}},
this.props.tabBarPosition==="top"&&this.renderTabBar(tabBarProps),
this.renderScrollableContent(),
(this.props.tabBarPosition==="bottom"||overlayTabs)&&this.renderTabBar(tabBarProps)));


}});exports.default=


ScrollableTabView;

var styles=StyleSheet.create({
container:{
flex:1},

scrollableContentAndroid:{
flex:1}});
//# sourceMappingURL=index.js.map

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Tabs/SceneComponent.js";function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var React=__webpack_require__(0);
var ReactNative=__webpack_require__(1);var
Component=React.Component;var
View=ReactNative.View,StyleSheet=ReactNative.StyleSheet;

var StaticContainer=__webpack_require__(619);

var SceneComponent=function SceneComponent(Props){var
shouldUpdated=Props.shouldUpdated,props=_objectWithoutProperties(Props,["shouldUpdated"]);
return(
React.createElement(View,_extends({},props,{__source:{fileName:_jsxFileName,lineNumber:11}}),
React.createElement(StaticContainer,{shouldUpdate:shouldUpdated,__source:{fileName:_jsxFileName,lineNumber:12}},
props.children)));



};

module.exports=SceneComponent;
//# sourceMappingURL=SceneComponent.js.map

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var React=__webpack_require__(0);var

StaticContainer=function(_React$Component){_inherits(StaticContainer,_React$Component);function StaticContainer(){_classCallCheck(this,StaticContainer);return _possibleConstructorReturn(this,(StaticContainer.__proto__||Object.getPrototypeOf(StaticContainer)).apply(this,arguments));}_createClass(StaticContainer,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(
nextProps){
return!!nextProps.shouldUpdate;
}},{key:"render",value:function render()

{
var child=this.props.children;
if(child===null||child===false){
return null;
}
return React.Children.only(child);
}}]);return StaticContainer;}(React.Component);


module.exports=StaticContainer;
//# sourceMappingURL=StaticContainer.js.map

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.Subtitle=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="src/basic/Subtitle.js";var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);
var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);
var _reactNative=__webpack_require__(1);
var _nativeBaseShoutemTheme=__webpack_require__(5);
var _mapPropsToStyleNames=__webpack_require__(6);var _mapPropsToStyleNames2=_interopRequireDefault(_mapPropsToStyleNames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Subtitle=function(_Component){_inherits(Subtitle,_Component);function Subtitle(){_classCallCheck(this,Subtitle);return _possibleConstructorReturn(this,(Subtitle.__proto__||Object.getPrototypeOf(Subtitle)).apply(this,arguments));}_createClass(Subtitle,[{key:"render",value:function render()
{var _this2=this;
return _react2.default.createElement(_reactNative.Text,_extends({ref:function ref(c){return _this2._root=c;}},this.props,{__source:{fileName:_jsxFileName,lineNumber:9}}));
}}]);return Subtitle;}(_react.Component);


Subtitle.propTypes=_extends({},
_reactNative.Text.propTypes,{
style:_propTypes2.default.oneOfType([_propTypes2.default.object,_propTypes2.default.number,_propTypes2.default.array])});


var StyledSubtitle=(0,_nativeBaseShoutemTheme.connectStyle)("NativeBase.Subtitle",{},_mapPropsToStyleNames2.default)(Subtitle);exports.
Subtitle=StyledSubtitle;
//# sourceMappingURL=Subtitle.js.map

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _createNavigationContainer=__webpack_require__(83);var _createNavigationContainer2=_interopRequireDefault(_createNavigationContainer);var _createNavigator=__webpack_require__(84);var _createNavigator2=_interopRequireDefault(_createNavigator);var _CardStackTransitioner=__webpack_require__(225);var _CardStackTransitioner2=_interopRequireDefault(_CardStackTransitioner);var _StackRouter=__webpack_require__(237);var _StackRouter2=_interopRequireDefault(_StackRouter);var _NavigatorTypes=__webpack_require__(130);var _NavigatorTypes2=_interopRequireDefault(_NavigatorTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=function(routeConfigMap){var stackConfig=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var initialRouteName=stackConfig.initialRouteName,initialRouteParams=stackConfig.initialRouteParams,paths=stackConfig.paths,headerMode=stackConfig.headerMode,mode=stackConfig.mode,cardStyle=stackConfig.cardStyle,transitionConfig=stackConfig.transitionConfig,onTransitionStart=stackConfig.onTransitionStart,onTransitionEnd=stackConfig.onTransitionEnd,navigationOptions=stackConfig.navigationOptions;var stackRouterConfig={initialRouteName:initialRouteName,initialRouteParams:initialRouteParams,paths:paths,navigationOptions:navigationOptions};var router=(0,_StackRouter2.default)(routeConfigMap,stackRouterConfig);// Create a navigator with CardStackTransitioner as the view
var navigator=(0,_createNavigator2.default)(router,routeConfigMap,stackConfig,_NavigatorTypes2.default.STACK)(function(props){return _react2.default.createElement(_CardStackTransitioner2.default,_extends({},props,{headerMode:headerMode,mode:mode,cardStyle:cardStyle,transitionConfig:transitionConfig,onTransitionStart:onTransitionStart,onTransitionEnd:onTransitionEnd}));});return(0,_createNavigationContainer2.default)(navigator);};

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=create;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _invariant=__webpack_require__(25);var _invariant2=_interopRequireDefault(_invariant);var _AnimatedValueSubscription=__webpack_require__(623);var _AnimatedValueSubscription2=_interopRequireDefault(_AnimatedValueSubscription);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MIN_POSITION_OFFSET=0.01;/**
 * Create a higher-order component that automatically computes the
 * `pointerEvents` property for a component whenever navigation position
 * changes.
 */function create(Component){var Container=function(_React$Component){_inherits(Container,_React$Component);function Container(props,context){_classCallCheck(this,Container);var _this=_possibleConstructorReturn(this,(Container.__proto__||Object.getPrototypeOf(Container)).call(this,props,context));_this._pointerEvents=_this._computePointerEvents();return _this;}_createClass(Container,[{key:'componentWillMount',value:function componentWillMount(){this._onPositionChange=this._onPositionChange.bind(this);this._onComponentRef=this._onComponentRef.bind(this);}},{key:'componentDidMount',value:function componentDidMount(){this._bindPosition(this.props);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this._positionListener&&this._positionListener.remove();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this._bindPosition(nextProps);}},{key:'render',value:function render(){this._pointerEvents=this._computePointerEvents();return _react2.default.createElement(Component,_extends({},this.props,{pointerEvents:this._pointerEvents,onComponentRef:this._onComponentRef}));}},{key:'_onComponentRef',value:function _onComponentRef(component){this._component=component;if(component){(0,_invariant2.default)(typeof component.setNativeProps==='function','component must implement method `setNativeProps`');}}},{key:'_bindPosition',value:function _bindPosition(props){this._positionListener&&this._positionListener.remove();this._positionListener=new _AnimatedValueSubscription2.default(props.position,this._onPositionChange);}},{key:'_onPositionChange',value:function _onPositionChange(){if(this._component){var pointerEvents=this._computePointerEvents();if(this._pointerEvents!==pointerEvents){this._pointerEvents=pointerEvents;this._component.setNativeProps({pointerEvents:pointerEvents});}}}},{key:'_computePointerEvents',value:function _computePointerEvents(){var _props=this.props,navigation=_props.navigation,position=_props.position,scene=_props.scene;if(scene.isStale||navigation.state.index!==scene.index){// The scene isn't focused.
return scene.index>navigation.state.index?'box-only':'none';}var offset=position.__getAnimatedValue()-navigation.state.index;if(Math.abs(offset)>MIN_POSITION_OFFSET){// The positon is still away from scene's index.
// Scene's children should not receive touches until the position
// is close enough to scene's index.
return'box-only';}return'auto';}}]);return Container;}(_react2.default.Component);return Container;}

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _reactNative=__webpack_require__(1);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var AnimatedValueSubscription=function(){function AnimatedValueSubscription(value,callback){_classCallCheck(this,AnimatedValueSubscription);this._value=value;this._token=value.addListener(callback);}_createClass(AnimatedValueSubscription,[{key:'remove',value:function remove(){this._value.removeListener(this._token);}}]);return AnimatedValueSubscription;}();exports.default=AnimatedValueSubscription;

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAVCAMAAACqsJS4AAAAh1BMVEUAAAAA//8AgP8AgP8AgP8AgP8Ajv8Ai/8AgP8AiP8Ahv8Ahf8AgP8Ae/8Afv8AfP8Aev8Ae/8Ae/8Aev8AfP8Aev8Aev8Ae/8Ae/8Ae/8Ae/8Ae/8Ae/8Ae/8Aev8Ae/8Ae/8Aev8Aev8Aev8Ae/8Aev8Aev8Ae/8Ae/8Ae/8Ae/8Aev8Aev9Eci9zAAAALHRSTlMAAQIEBggJCwwPExccOkFISVFZYmt1f5Odpq62t72+xczT2fDz9Pb3+fv9/m0a/Q0AAAB3SURBVBhXXZDXEsJQCESxl6gxscaWXtTz/9+nYyATL0+cYVh2EbEanA5dL8MzHA1GEWDD8QXee4XpDV47hfkDnqHCIoYmUFgmUPkKXgrFRmGVQb5WkPv3jqm5s99eaXutZr3t8O+eyKzvRWRy7fl0Mjj5nOztXz7Cjg2LWSe7xwAAAABJRU5ErkJggg=="

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _reactNative=__webpack_require__(1);/**
 * Utility that builds the style for the navigation header.
 *
 * +-------------+-------------+-------------+
 * |             |             |             |
 * |    Left     |   Title     |   Right     |
 * |  Component  |  Component  | Component   |
 * |             |             |             |
 * +-------------+-------------+-------------+
 */function forLeft(props){var position=props.position,scene=props.scene;var index=scene.index;return{opacity:position.interpolate({inputRange:[index-1,index-0.5,index,index+0.5,index+1],outputRange:[0,0,1,0,0]})};}function forCenter(props){var position=props.position,scene=props.scene;var index=scene.index;return{opacity:position.interpolate({inputRange:[index-1,index,index+1],outputRange:[0,1,0]}),transform:[{translateX:position.interpolate({inputRange:[index-1,index+1],outputRange:_reactNative.I18nManager.isRTL?[-200,200]:[200,-200]})}]};}function forRight(props){var position=props.position,scene=props.scene;var index=scene.index;return{opacity:position.interpolate({inputRange:[index-1,index,index+1],outputRange:[0,1,0]})};}exports.default={forLeft:forLeft,forCenter:forCenter,forRight:forRight};

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.default=ScenesReducer;var _invariant=__webpack_require__(25);var _invariant2=_interopRequireDefault(_invariant);var _shallowEqual=__webpack_require__(627);var _shallowEqual2=_interopRequireDefault(_shallowEqual);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SCENE_KEY_PREFIX='scene_';/**
 * Helper function to compare route keys (e.g. "9", "11").
 */function compareKey(one,two){var delta=one.length-two.length;if(delta>0){return 1;}if(delta<0){return-1;}return one>two?1:-1;}/**
 * Helper function to sort scenes based on their index and view key.
 */function compareScenes(one,two){if(one.index>two.index){return 1;}if(one.index<two.index){return-1;}return compareKey(one.key,two.key);}/**
 * Whether two routes are the same.
 */function areScenesShallowEqual(one,two){return one.key===two.key&&one.index===two.index&&one.isStale===two.isStale&&one.isActive===two.isActive&&areRoutesShallowEqual(one.route,two.route);}/**
 * Whether two routes are the same.
 */function areRoutesShallowEqual(one,two){if(!one||!two){return one===two;}if(one.key!==two.key){return false;}return(0,_shallowEqual2.default)(one,two);}function ScenesReducer(scenes,nextState,prevState){if(prevState===nextState){return scenes;}var prevScenes=new Map();var freshScenes=new Map();var staleScenes=new Map();// Populate stale scenes from previous scenes marked as stale.
scenes.forEach(function(scene){var key=scene.key;if(scene.isStale){staleScenes.set(key,scene);}prevScenes.set(key,scene);});var nextKeys=new Set();nextState.routes.forEach(function(route,index){var key=SCENE_KEY_PREFIX+route.key;var scene={index:index,isActive:false,isStale:false,key:key,route:route};(0,_invariant2.default)(!nextKeys.has(key),'navigation.state.routes['+index+'].key "'+key+'" conflicts with '+'another route!');nextKeys.add(key);if(staleScenes.has(key)){// A previously `stale` scene is now part of the nextState, so we
// revive it by removing it from the stale scene map.
staleScenes.delete(key);}freshScenes.set(key,scene);});if(prevState){// Look at the previous routes and classify any removed scenes as `stale`.
prevState.routes.forEach(function(route,index){var key=SCENE_KEY_PREFIX+route.key;if(freshScenes.has(key)){return;}staleScenes.set(key,{index:index,isActive:false,isStale:true,key:key,route:route});});}var nextScenes=[];var mergeScene=function mergeScene(nextScene){var key=nextScene.key;var prevScene=prevScenes.has(key)?prevScenes.get(key):null;if(prevScene&&areScenesShallowEqual(prevScene,nextScene)){// Reuse `prevScene` as `scene` so view can avoid unnecessary re-render.
// This assumes that the scene's navigation state is immutable.
nextScenes.push(prevScene);}else{nextScenes.push(nextScene);}};staleScenes.forEach(mergeScene);freshScenes.forEach(mergeScene);nextScenes.sort(compareScenes);var activeScenesCount=0;nextScenes.forEach(function(scene,ii){var isActive=!scene.isStale&&scene.index===nextState.index;if(isActive!==scene.isActive){nextScenes[ii]=_extends({},scene,{isActive:isActive});}if(isActive){activeScenesCount++;}});(0,_invariant2.default)(activeScenesCount===1,'there should always be only one scene active, not %s.',activeScenesCount);if(nextScenes.length!==scenes.length){return nextScenes;}if(nextScenes.some(function(scene,index){return!areScenesShallowEqual(scenes[index],scene);})){return nextScenes;}// scenes haven't changed.
return scenes;}

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 *//*eslint-disable no-self-compare */var _typeof2=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==="undefined"?"undefined":_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==="undefined"?"undefined":_typeof2(obj);};var hasOwnProperty=Object.prototype.hasOwnProperty;/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */function is(x,y){// SameValue algorithm
if(x===y){// Steps 1-5, 7-10
// Steps 6.b-6.e: +0 != -0
// Added the nonzero y check to make Flow happy, but it is redundant
return x!==0||y!==0||1/x===1/y;}else{// Step 6.a: NaN == NaN
return x!==x&&y!==y;}}/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */function shallowEqual(objA,objB){if(is(objA,objB)){return true;}if((typeof objA==='undefined'?'undefined':_typeof(objA))!=='object'||objA===null||(typeof objB==='undefined'?'undefined':_typeof(objB))!=='object'||objB===null){return false;}var keysA=Object.keys(objA);var keysB=Object.keys(objB);if(keysA.length!==keysB.length){return false;}// Test for A's keys different from B.
for(var i=0;i<keysA.length;i++){if(!hasOwnProperty.call(objB,keysA[i])||!is(objA[keysA[i]],objB[keysA[i]])){return false;}}return true;}module.exports=shallowEqual;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(629)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof2=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==="undefined"?"undefined":_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==="undefined"?"undefined":_typeof2(obj);};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var deprecatedKeys=['tabBar'];/**
 * Make sure screen options returned by the `getScreenOption`
 * are valid
 */exports.default=function(screenOptions,route){var keys=Object.keys(screenOptions);var deprecatedKey=keys.find(function(key){return deprecatedKeys.includes(key);});if(typeof screenOptions.title==='function'){throw new Error(['`title` cannot be defined as a function in navigation options for `'+route.routeName+'` screen. \n','Try replacing the following:','{','    title: ({ state }) => state...','}','','with:','({ navigation }) => ({','    title: navigation.state...','})'].join('\n'));}if(deprecatedKey&&typeof screenOptions[deprecatedKey]==='function'){throw new Error(['`'+deprecatedKey+'` cannot be defined as a function in navigation options for `'+route.routeName+'` screen. \n','Try replacing the following:','{','    '+deprecatedKey+': ({ state }) => ({','         key: state...','    })','}','','with:','({ navigation }) => ({','    '+deprecatedKey+'Key: navigation.state...','})'].join('\n'));}if(deprecatedKey&&_typeof(screenOptions[deprecatedKey])==='object'){throw new Error(['Invalid key `'+deprecatedKey+'` defined in navigation options for `'+route.routeName+'` screen.','\n','Try replacing the following navigation options:','{','    '+deprecatedKey+': {'].concat(_toConsumableArray(Object.keys(screenOptions[deprecatedKey]).map(function(key){return'        '+key+': ...,';})),['    },','}','\n','with:','{'],_toConsumableArray(Object.keys(screenOptions[deprecatedKey]).map(function(key){return'    '+(deprecatedKey+key[0].toUpperCase()+key.slice(1))+': ...,';})),['}']).join('\n'));}};

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);var _createNavigator=__webpack_require__(84);var _createNavigator2=_interopRequireDefault(_createNavigator);var _createNavigationContainer=__webpack_require__(83);var _createNavigationContainer2=_interopRequireDefault(_createNavigationContainer);var _TabRouter=__webpack_require__(131);var _TabRouter2=_interopRequireDefault(_TabRouter);var _TabView=__webpack_require__(241);var _TabView2=_interopRequireDefault(_TabView);var _TabBarTop=__webpack_require__(246);var _TabBarTop2=_interopRequireDefault(_TabBarTop);var _TabBarBottom=__webpack_require__(248);var _TabBarBottom2=_interopRequireDefault(_TabBarBottom);var _NavigatorTypes=__webpack_require__(130);var _NavigatorTypes2=_interopRequireDefault(_NavigatorTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var TabNavigator=function TabNavigator(routeConfigs){var config=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};// Use the look native to the platform by default
var mergedConfig=_extends({},TabNavigator.Presets.Default,config);var tabBarComponent=mergedConfig.tabBarComponent,tabBarPosition=mergedConfig.tabBarPosition,tabBarOptions=mergedConfig.tabBarOptions,swipeEnabled=mergedConfig.swipeEnabled,animationEnabled=mergedConfig.animationEnabled,lazy=mergedConfig.lazy,tabsConfig=_objectWithoutProperties(mergedConfig,['tabBarComponent','tabBarPosition','tabBarOptions','swipeEnabled','animationEnabled','lazy']);var router=(0,_TabRouter2.default)(routeConfigs,tabsConfig);var navigator=(0,_createNavigator2.default)(router,routeConfigs,config,_NavigatorTypes2.default.TABS)(function(props){return _react2.default.createElement(_TabView2.default,_extends({},props,{tabBarComponent:tabBarComponent,tabBarPosition:tabBarPosition,tabBarOptions:tabBarOptions,swipeEnabled:swipeEnabled,animationEnabled:animationEnabled,lazy:lazy}));});return(0,_createNavigationContainer2.default)(navigator);};var Presets={iOSBottomTabs:{tabBarComponent:_TabBarBottom2.default,tabBarPosition:'bottom',swipeEnabled:false,animationEnabled:false,lazy:false},AndroidTopTabs:{tabBarComponent:_TabBarTop2.default,tabBarPosition:'top',swipeEnabled:true,animationEnabled:true,lazy:false}};/**
 * Use these to get Android-style top tabs even on iOS or vice versa.
 *
 * Example:
 * ```
 * const HomeScreenTabNavigator = TabNavigator({
 *  Chat: {
 *    screen: ChatScreen,
 *  },
 *  ...
 * }, {
 *  ...TabNavigator.Presets.AndroidTopTabs,
 *  tabBarOptions: {
 *    ...
 *  },
 * });
 *```
 */TabNavigator.Presets={iOSBottomTabs:Presets.iOSBottomTabs,AndroidTopTabs:Presets.AndroidTopTabs,Default:_reactNative.Platform.OS==='ios'?Presets.iOSBottomTabs:Presets.AndroidTopTabs};exports.default=TabNavigator;

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TabViewAnimated; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TabViewPropTypes__ = __webpack_require__(60);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TabViewPager=void 0;switch(__WEBPACK_IMPORTED_MODULE_2_react_native__["Platform"].OS){case'android':TabViewPager=__webpack_require__(243).default;break;case'ios':TabViewPager=__webpack_require__(244).default;break;default:TabViewPager=__webpack_require__(245).default;break;}var TabViewAnimated=(_temp=_class=function(_PureComponent){_inherits(TabViewAnimated,_PureComponent);function TabViewAnimated(props){_classCallCheck(this,TabViewAnimated);var _this=_possibleConstructorReturn(this,(TabViewAnimated.__proto__||Object.getPrototypeOf(TabViewAnimated)).call(this,props));_initialiseProps.call(_this);_this.state={loaded:[_this.props.navigationState.index],layout:_extends({},_this.props.initialLayout,{measured:false}),position:new __WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].Value(_this.props.navigationState.index)};return _this;}_createClass(TabViewAnimated,[{key:'componentDidMount',value:function componentDidMount(){this._mounted=true;this._positionListener=this.state.position.addListener(this._trackPosition);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this._mounted=false;this.state.position.removeListener(this._positionListener);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,navigationState=_props.navigationState,onIndexChange=_props.onIndexChange,onPositionChange=_props.onPositionChange,canJumpToTab=_props.canJumpToTab,lazy=_props.lazy,initialLayout=_props.initialLayout,renderScene=_props.renderScene,renderPager=_props.renderPager,renderHeader=_props.renderHeader,renderFooter=_props.renderFooter,rest=_objectWithoutProperties(_props,['navigationState','onIndexChange','onPositionChange','canJumpToTab','lazy','initialLayout','renderScene','renderPager','renderHeader','renderFooter']);var props=this._buildSceneRendererProps();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["View"],{onLayout:this._handleLayout,loaded:this.state.loaded,style:[styles.container,this.props.style]},renderHeader&&renderHeader(props),renderPager(_extends({},props,rest,{children:navigationState.routes.map(function(route,index){return _this2._renderScene(_extends({},props,{route:route,index:index,focused:index===navigationState.index}));})})),renderFooter&&renderFooter(props));}}]);return TabViewAnimated;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]),_class.propTypes={navigationState:__WEBPACK_IMPORTED_MODULE_3__TabViewPropTypes__["a" /* NavigationStatePropType */].isRequired,onIndexChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onPositionChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,initialLayout:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({height:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired}),canJumpToTab:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,renderPager:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,renderScene:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,renderHeader:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,renderFooter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,lazy:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool},_class.defaultProps={renderPager:function renderPager(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabViewPager,props);},initialLayout:{height:0,width:0}},_initialiseProps=function _initialiseProps(){var _this3=this;this._mounted=false;this._subscriptions={};this._renderScene=function(props){var _props2=_this3.props,renderScene=_props2.renderScene,lazy=_props2.lazy;var navigationState=props.navigationState;var loaded=_this3.state.loaded;if(lazy){if(loaded.includes(navigationState.routes.indexOf(props.route))){return renderScene(props);}return null;}return renderScene(props);};this._handlePositionChange=function(value){var _props3=_this3.props,onChangePosition=_props3.onChangePosition,onPositionChange=_props3.onPositionChange,navigationState=_props3.navigationState,lazy=_props3.lazy;if(onChangePosition){console.warn('`onChangePosition` is deprecated. Use `onPositionChange` instead.');onChangePosition(value);}if(onPositionChange){onPositionChange({value:value});}var loaded=_this3.state.loaded;if(lazy){var next=Math.ceil(value);if(next===navigationState.index){next=Math.floor(value);}if(loaded.includes(next)){return;}_this3.setState({loaded:[].concat(_toConsumableArray(loaded),[next])});}};this._trackPosition=function(e){_this3._handlePositionChange(e.value);_this3._triggerEvent('position',e.value);_this3._lastPosition=e.value;};this._getLastPosition=function(){if(typeof _this3._lastPosition==='number'){return _this3._lastPosition;}else{return _this3.props.navigationState.index;}};this._handleLayout=function(e){var _e$nativeEvent$layout=e.nativeEvent.layout,height=_e$nativeEvent$layout.height,width=_e$nativeEvent$layout.width;if(_this3.state.layout.width===width&&_this3.state.layout.height===height){return;}_this3.setState({layout:{measured:true,height:height,width:width}});};this._buildSceneRendererProps=function(){return{layout:_this3.state.layout,navigationState:_this3.props.navigationState,position:_this3.state.position,jumpToIndex:_this3._jumpToIndex,getLastPosition:_this3._getLastPosition,subscribe:_this3._addSubscription};};this._jumpToIndex=function(index){if(!_this3._mounted){// We are no longer mounted, this is a no-op
return;}var _props4=_this3.props,canJumpToTab=_props4.canJumpToTab,navigationState=_props4.navigationState;if(canJumpToTab&&!canJumpToTab(navigationState.routes[index])){_this3._triggerEvent('reset',navigationState.index);return;}if(index!==navigationState.index){/* $FlowFixMe */if(_this3.props.onRequestChangeTab){console.warn('`onRequestChangeTab` is deprecated. Use `onIndexChange` instead.');/* $FlowFixMe */_this3.props.onRequestChangeTab(index);}_this3.props.onIndexChange(index);}};this._addSubscription=function(event,callback){if(!_this3._subscriptions[event]){_this3._subscriptions[event]=[];}_this3._subscriptions[event].push(callback);return{remove:function remove(){var index=_this3._subscriptions[event].indexOf(callback);if(index>-1){_this3._subscriptions[event].splice(index,1);}}};};this._triggerEvent=function(event,value){if(_this3._subscriptions[event]){_this3._subscriptions[event].forEach(function(fn){return fn(value);});}};},_temp);var styles=__WEBPACK_IMPORTED_MODULE_2_react_native__["StyleSheet"].create({container:{flex:1,overflow:'hidden'}});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TabBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TouchableItem__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TabViewPropTypes__ = __webpack_require__(60);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TabBar=(_temp=_class=function(_PureComponent){_inherits(TabBar,_PureComponent);function TabBar(props){_classCallCheck(this,TabBar);var _this=_possibleConstructorReturn(this,(TabBar.__proto__||Object.getPrototypeOf(TabBar)).call(this,props));_initialiseProps.call(_this);var initialVisibility=0;if(_this.props.scrollEnabled===true){var tabWidth=_this._getTabWidthFromStyle(_this.props.tabStyle);if(_this.props.layout.width||tabWidth){initialVisibility=1;}}else{initialVisibility=1;}_this.state={offset:new __WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].Value(0),visibility:new __WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].Value(initialVisibility),initialOffset:{x:_this._getScrollAmount(_this.props,_this.props.navigationState.index),y:0}};return _this;}_createClass(TabBar,[{key:'componentDidMount',value:function componentDidMount(){this._adjustScroll(this.props.navigationState.index);this._positionListener=this.props.subscribe('position',this._adjustScroll);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.navigationState!==nextProps.navigationState){this._resetScrollOffset(nextProps);}var nextTabWidth=this._getTabWidthFromStyle(nextProps.tabStyle);if(this.props.tabStyle!==nextProps.tabStyle&&nextTabWidth||this.props.layout.width!==nextProps.layout.width&&nextProps.layout.width){this.state.visibility.setValue(1);}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this2=this;if(this.props.scrollEnabled&&(prevProps.layout!==this.props.layout||prevProps.tabStyle!==this.props.tabStyle)){global.requestAnimationFrame(function(){return _this2._adjustScroll(_this2.props.navigationState.index);});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this._positionListener.remove();}},{key:'render',value:function render(){var _this3=this;var _props=this.props,position=_props.position,navigationState=_props.navigationState,scrollEnabled=_props.scrollEnabled;var routes=navigationState.routes,index=navigationState.index;var maxDistance=this._getMaxScrollableDistance(this.props);var finalTabWidth=this._getFinalTabWidth(this.props);var tabBarWidth=finalTabWidth*routes.length;// Prepend '-1', so there are always at least 2 items in inputRange
var inputRange=[-1].concat(_toConsumableArray(routes.map(function(x,i){return i;})));var translateOutputRange=inputRange.map(function(i){return _this3._getScrollAmount(_this3.props,i)*-1;});var translateX=__WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].add(position.interpolate({inputRange:inputRange,outputRange:translateOutputRange}),this.state.offset).interpolate({inputRange:[-maxDistance,0],outputRange:[-maxDistance,0],extrapolate:'clamp'});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].View,{style:[styles.tabBar,this.props.style]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].View,{pointerEvents:'none',style:[styles.indicatorContainer,scrollEnabled?{width:tabBarWidth,transform:[{translateX:translateX}]}:null]},this._renderIndicator(_extends({},this.props,{width:new __WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].Value(finalTabWidth)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["View"],{style:styles.scroll},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["ScrollView"],{horizontal:true,scrollEnabled:scrollEnabled,bounces:false,alwaysBounceHorizontal:false,scrollsToTop:false,showsHorizontalScrollIndicator:false,automaticallyAdjustContentInsets:false,overScrollMode:'never',contentContainerStyle:[styles.tabContent,scrollEnabled?null:styles.container],scrollEventThrottle:16,onScroll:this._handleScroll,onScrollBeginDrag:this._handleBeginDrag,onScrollEndDrag:this._handleEndDrag,onMomentumScrollBegin:this._handleMomentumScrollBegin,onMomentumScrollEnd:this._handleMomentumScrollEnd,contentOffset:this.state.initialOffset,ref:this._setRef},routes.map(function(route,i){var focused=index===i;var outputRange=inputRange.map(function(inputIndex){return inputIndex===i?1:0.7;});var opacity=__WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].multiply(_this3.state.visibility,position.interpolate({inputRange:inputRange,outputRange:outputRange}));var scene={route:route,focused:focused,index:i};var label=_this3._renderLabel(scene);var icon=_this3.props.renderIcon?_this3.props.renderIcon(scene):null;var badge=_this3.props.renderBadge?_this3.props.renderBadge(scene):null;var tabStyle={};tabStyle.opacity=opacity;if(icon){if(label){tabStyle.paddingTop=8;}else{tabStyle.padding=12;}}var passedTabStyle=__WEBPACK_IMPORTED_MODULE_2_react_native__["StyleSheet"].flatten(_this3.props.tabStyle);var isWidthSet=passedTabStyle&&typeof passedTabStyle.width!=='undefined'||scrollEnabled===true;var tabContainerStyle={};if(isWidthSet){tabStyle.width=finalTabWidth;}if(passedTabStyle&&typeof passedTabStyle.flex==='number'){tabContainerStyle.flex=passedTabStyle.flex;}else if(!isWidthSet){tabContainerStyle.flex=1;}var accessibilityLabel=route.accessibilityLabel||route.title;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TouchableItem__["a" /* default */],{borderless:true,key:route.key,testID:route.testID,accessible:route.accessible,accessibilityLabel:accessibilityLabel,accessibilityTraits:'button',pressColor:_this3.props.pressColor,pressOpacity:_this3.props.pressOpacity,delayPressIn:0,onPress:function onPress(){// eslint-disable-line react/jsx-no-bind
var _props2=_this3.props,onTabPress=_props2.onTabPress,jumpToIndex=_props2.jumpToIndex;jumpToIndex(i);if(onTabPress){onTabPress(scene);}},style:tabContainerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["View"],{style:styles.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].View,{style:[styles.tabItem,tabStyle,passedTabStyle,styles.container]},icon,label),badge?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].View,{style:[styles.badge,{opacity:_this3.state.visibility}]},badge):null));}))));}}]);return TabBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]),_class.propTypes=_extends({},__WEBPACK_IMPORTED_MODULE_4__TabViewPropTypes__["b" /* SceneRendererPropType */],{scrollEnabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,pressColor:__WEBPACK_IMPORTED_MODULE_3__TouchableItem__["a" /* default */].propTypes.pressColor,pressOpacity:__WEBPACK_IMPORTED_MODULE_3__TouchableItem__["a" /* default */].propTypes.pressOpacity,getLabelText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,renderIcon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,renderLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,renderIndicator:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onTabPress:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,labelStyle:__WEBPACK_IMPORTED_MODULE_2_react_native__["Text"].propTypes.style,style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any}),_class.defaultProps={getLabelText:function getLabelText(_ref){var route=_ref.route;return route.title?route.title.toUpperCase():null;}},_initialiseProps=function _initialiseProps(){var _this4=this;this._isManualScroll=false;this._isMomentumScroll=false;this._renderLabel=function(scene){if(typeof _this4.props.renderLabel!=='undefined'){return _this4.props.renderLabel(scene);}var label=_this4.props.getLabelText(scene);if(typeof label!=='string'){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["Text"],{style:[styles.tabLabel,_this4.props.labelStyle]},label);};this._renderIndicator=function(props){if(typeof _this4.props.renderIndicator!=='undefined'){return _this4.props.renderIndicator(props);}var width=props.width,position=props.position;var translateX=__WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].multiply(__WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].multiply(position,width),__WEBPACK_IMPORTED_MODULE_2_react_native__["I18nManager"].isRTL?-1:1);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].View,{style:[styles.indicator,{width:width,transform:[{translateX:translateX}]},_this4.props.indicatorStyle]});};this._getTabWidthFromStyle=function(style){if(_this4._tabWidthCache&&_this4._tabWidthCache.style===style){return _this4._tabWidthCache.width;}var passedTabStyle=__WEBPACK_IMPORTED_MODULE_2_react_native__["StyleSheet"].flatten(_this4.props.tabStyle);var cache={style:style,width:passedTabStyle?passedTabStyle.width:null};_this4._tabWidthCache=cache;return cache;};this._getFinalTabWidth=function(props){var layout=props.layout,navigationState=props.navigationState;var tabWidth=_this4._getTabWidthFromStyle(props.tabStyle);if(typeof tabWidth==='number'){return tabWidth;}if(typeof tabWidth==='string'&&tabWidth.endsWith('%')){return layout.width*(parseFloat(tabWidth)/100);}if(props.scrollEnabled){return layout.width/5*2;}return layout.width/navigationState.routes.length;};this._getMaxScrollableDistance=function(props){var layout=props.layout,navigationState=props.navigationState;if(layout.width===0){return 0;}var finalTabWidth=_this4._getFinalTabWidth(props);var tabBarWidth=finalTabWidth*navigationState.routes.length;var maxDistance=tabBarWidth-layout.width;return Math.max(maxDistance,0);};this._normalizeScrollValue=function(props,value){var maxDistance=_this4._getMaxScrollableDistance(props);return Math.max(Math.min(value,maxDistance),0);};this._getScrollAmount=function(props,i){var layout=props.layout;var finalTabWidth=_this4._getFinalTabWidth(props);var centerDistance=finalTabWidth*i+finalTabWidth/2;var scrollAmount=centerDistance-layout.width/2;return _this4._normalizeScrollValue(props,scrollAmount);};this._resetScrollOffset=function(props){if(!props.scrollEnabled||!_this4._scrollView){return;}var scrollAmount=_this4._getScrollAmount(props,props.navigationState.index);_this4._scrollView.scrollTo({x:scrollAmount,animated:true});__WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].timing(_this4.state.offset,{toValue:0,duration:150}).start();};this._adjustScroll=function(index){if(!_this4.props.scrollEnabled||!_this4._scrollView){return;}var scrollAmount=_this4._getScrollAmount(_this4.props,index);_this4._scrollView.scrollTo({x:scrollAmount,animated:false});};this._adjustOffset=function(value){if(!_this4._isManualScroll||!_this4.props.scrollEnabled){return;}var scrollAmount=_this4._getScrollAmount(_this4.props,_this4.props.navigationState.index);var scrollOffset=value-scrollAmount;if(_this4._isMomentumScroll){__WEBPACK_IMPORTED_MODULE_2_react_native__["Animated"].spring(_this4.state.offset,{toValue:-scrollOffset,tension:300,friction:35}).start();}else{_this4.state.offset.setValue(-scrollOffset);}};this._handleScroll=function(e){_this4._adjustOffset(e.nativeEvent.contentOffset.x);};this._handleBeginDrag=function(){// onScrollBeginDrag fires when user touches the ScrollView
_this4._isManualScroll=true;_this4._isMomentumScroll=false;};this._handleEndDrag=function(){// onScrollEndDrag fires when user lifts his finger
// onMomentumScrollBegin fires after touch end
// run the logic in next frame so we get onMomentumScrollBegin first
global.requestAnimationFrame(function(){if(_this4._isMomentumScroll){return;}_this4._isManualScroll=false;});};this._handleMomentumScrollBegin=function(){// onMomentumScrollBegin fires on flick, as well as programmatic scroll
_this4._isMomentumScroll=true;};this._handleMomentumScrollEnd=function(){// onMomentumScrollEnd fires when the scroll finishes
_this4._isMomentumScroll=false;_this4._isManualScroll=false;};this._setRef=function(el){return _this4._scrollView=el;};},_temp);var styles=__WEBPACK_IMPORTED_MODULE_2_react_native__["StyleSheet"].create({container:{flex:1},scroll:{overflow:__WEBPACK_IMPORTED_MODULE_2_react_native__["Platform"].OS==='web'?'auto':'scroll'},tabBar:{backgroundColor:'#2196f3',elevation:4,shadowColor:'black',shadowOpacity:0.1,shadowRadius:__WEBPACK_IMPORTED_MODULE_2_react_native__["StyleSheet"].hairlineWidth,shadowOffset:{height:__WEBPACK_IMPORTED_MODULE_2_react_native__["StyleSheet"].hairlineWidth},// We don't need zIndex on Android, disable it since it's buggy
zIndex:__WEBPACK_IMPORTED_MODULE_2_react_native__["Platform"].OS==='android'?0:1},tabContent:{flexDirection:'row',flexWrap:'nowrap'},tabLabel:{backgroundColor:'transparent',color:'white',margin:8},tabItem:{flexGrow:1,padding:8,alignItems:'center',justifyContent:'center'},badge:{position:'absolute',top:0,right:0},indicatorContainer:{position:'absolute',top:0,left:0,right:0,bottom:0},indicator:{backgroundColor:'#ffeb3b',position:'absolute',left:0,bottom:0,right:0,height:2}});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TouchableItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_native__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LOLLIPOP=21;var TouchableItem=(_temp2=_class=function(_PureComponent){_inherits(TouchableItem,_PureComponent);function TouchableItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TouchableItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TouchableItem.__proto__||Object.getPrototypeOf(TouchableItem)).call.apply(_ref,[this].concat(args))),_this),_this._handlePress=function(){global.requestAnimationFrame(_this.props.onPress);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TouchableItem,[{key:'render',value:function render(){// eslint-disable-next-line react/prop-types
var _props=this.props,style=_props.style,pressOpacity=_props.pressOpacity,pressColor=_props.pressColor,borderless=_props.borderless,rest=_objectWithoutProperties(_props,['style','pressOpacity','pressColor','borderless']);if(__WEBPACK_IMPORTED_MODULE_2_react_native__["Platform"].OS==='android'&&__WEBPACK_IMPORTED_MODULE_2_react_native__["Platform"].Version>=LOLLIPOP){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["TouchableNativeFeedback"],Object.assign({},rest,{onPress:this._handlePress,background:__WEBPACK_IMPORTED_MODULE_2_react_native__["TouchableNativeFeedback"].Ripple(pressColor,borderless)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["View"],{style:style},__WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children)));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native__["TouchableOpacity"],Object.assign({},rest,{onPress:this._handlePress,style:style,activeOpacity:pressOpacity}),this.props.children);}}}]);return TouchableItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]),_class.propTypes={onPress:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,delayPressIn:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,borderless:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,pressColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,pressOpacity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired},_class.defaultProps={pressColor:'rgba(255, 255, 255, .4)'},_temp2);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = SceneMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function SceneMap(scenes){var SceneComponent=function(_PureComponent){_inherits(SceneComponent,_PureComponent);function SceneComponent(){_classCallCheck(this,SceneComponent);return _possibleConstructorReturn(this,(SceneComponent.__proto__||Object.getPrototypeOf(SceneComponent)).apply(this,arguments));}_createClass(SceneComponent,[{key:'render',value:function render(){/* eslint-disable react/prop-types */return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(scenes[this.props.route.key],this.props);}}]);return SceneComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);return function(_ref){var route=_ref.route;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SceneComponent,{key:route.key,route:route});};}

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);var _createNavigator=__webpack_require__(84);var _createNavigator2=_interopRequireDefault(_createNavigator);var _createNavigationContainer=__webpack_require__(83);var _createNavigationContainer2=_interopRequireDefault(_createNavigationContainer);var _TabRouter=__webpack_require__(131);var _TabRouter2=_interopRequireDefault(_TabRouter);var _DrawerScreen=__webpack_require__(637);var _DrawerScreen2=_interopRequireDefault(_DrawerScreen);var _DrawerView=__webpack_require__(249);var _DrawerView2=_interopRequireDefault(_DrawerView);var _DrawerNavigatorItems=__webpack_require__(250);var _DrawerNavigatorItems2=_interopRequireDefault(_DrawerNavigatorItems);var _NavigatorTypes=__webpack_require__(130);var _NavigatorTypes2=_interopRequireDefault(_NavigatorTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var _Dimensions$get=_reactNative.Dimensions.get('window'),height=_Dimensions$get.height,width=_Dimensions$get.width;var DefaultDrawerConfig={/*
   * Default drawer width is screen width - header width
   * https://material.io/guidelines/patterns/navigation-drawer.html
   */drawerWidth:Math.min(height,width)-(_reactNative.Platform.OS==='android'?56:64),contentComponent:_DrawerNavigatorItems2.default,drawerPosition:'left',drawerBackgroundColor:'white',useNativeAnimations:true};var DrawerNavigator=function DrawerNavigator(routeConfigs){var config=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var mergedConfig=_extends({},DefaultDrawerConfig,config);var containerConfig=mergedConfig.containerConfig,drawerWidth=mergedConfig.drawerWidth,drawerLockMode=mergedConfig.drawerLockMode,contentComponent=mergedConfig.contentComponent,contentOptions=mergedConfig.contentOptions,drawerPosition=mergedConfig.drawerPosition,useNativeAnimations=mergedConfig.useNativeAnimations,drawerBackgroundColor=mergedConfig.drawerBackgroundColor,tabsConfig=_objectWithoutProperties(mergedConfig,['containerConfig','drawerWidth','drawerLockMode','contentComponent','contentOptions','drawerPosition','useNativeAnimations','drawerBackgroundColor']);var contentRouter=(0,_TabRouter2.default)(routeConfigs,tabsConfig);var drawerRouter=(0,_TabRouter2.default)({DrawerClose:{screen:(0,_createNavigator2.default)(contentRouter,routeConfigs,config,_NavigatorTypes2.default.DRAWER)(function(props){return _react2.default.createElement(_DrawerScreen2.default,props);})},DrawerOpen:{screen:function screen(){return null;}},DrawerToggle:{screen:function screen(){return null;}}},{initialRouteName:'DrawerClose'});var navigator=(0,_createNavigator2.default)(drawerRouter,routeConfigs,config,_NavigatorTypes2.default.DRAWER)(function(props){return _react2.default.createElement(_DrawerView2.default,_extends({},props,{drawerBackgroundColor:drawerBackgroundColor,drawerLockMode:drawerLockMode,useNativeAnimations:useNativeAnimations,drawerWidth:drawerWidth,contentComponent:contentComponent,contentOptions:contentOptions,drawerPosition:drawerPosition}));});return(0,_createNavigationContainer2.default)(navigator);};exports.default=DrawerNavigator;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _SceneView=__webpack_require__(128);var _SceneView2=_interopRequireDefault(_SceneView);var _withCachedChildNavigation=__webpack_require__(132);var _withCachedChildNavigation2=_interopRequireDefault(_withCachedChildNavigation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Component that renders the child screen of the drawer.
 */var DrawerScreen=function(_PureComponent){_inherits(DrawerScreen,_PureComponent);function DrawerScreen(){_classCallCheck(this,DrawerScreen);return _possibleConstructorReturn(this,(DrawerScreen.__proto__||Object.getPrototypeOf(DrawerScreen)).apply(this,arguments));}_createClass(DrawerScreen,[{key:'render',value:function render(){var _props=this.props,router=_props.router,navigation=_props.navigation,childNavigationProps=_props.childNavigationProps,screenProps=_props.screenProps;var _navigation$state=navigation.state,routes=_navigation$state.routes,index=_navigation$state.index;var childNavigation=childNavigationProps[routes[index].key];var Content=router.getComponentForRouteName(routes[index].routeName);return _react2.default.createElement(_SceneView2.default,{screenProps:screenProps,component:Content,navigation:childNavigation});}}]);return DrawerScreen;}(_react.PureComponent);exports.default=(0,_withCachedChildNavigation2.default)(DrawerScreen);

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _reactNativeDrawerLayout=__webpack_require__(639);var _reactNativeDrawerLayout2=_interopRequireDefault(_reactNativeDrawerLayout);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_reactNativeDrawerLayout2.default;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNativeDismissKeyboard=__webpack_require__(640);var _reactNativeDismissKeyboard2=_interopRequireDefault(_reactNativeDismissKeyboard);var _reactNative=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MIN_SWIPE_DISTANCE=3;var DEVICE_WIDTH=parseFloat(_reactNative.Dimensions.get('window').width);var THRESHOLD=DEVICE_WIDTH/2;var VX_MAX=0.1;var IDLE='Idle';var DRAGGING='Dragging';var SETTLING='Settling';var DrawerLayout=(_temp=_class=function(_Component){_inherits(DrawerLayout,_Component);function DrawerLayout(props,context){_classCallCheck(this,DrawerLayout);var _this=_possibleConstructorReturn(this,(DrawerLayout.__proto__||Object.getPrototypeOf(DrawerLayout)).call(this,props,context));_this._onOverlayClick=function(e){e.stopPropagation();if(!_this._isLockedClosed()&&!_this._isLockedOpen()){_this.closeDrawer();}};_this._emitStateChanged=function(newState){if(_this.props.onDrawerStateChanged){_this.props.onDrawerStateChanged(newState);}};_this.openDrawer=function(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this._emitStateChanged(SETTLING);_reactNative.Animated.spring(_this.state.openValue,_extends({toValue:1,bounciness:0,restSpeedThreshold:0.1,useNativeDriver:_this.props.useNativeAnimations},options)).start(function(){if(_this.props.onDrawerOpen){_this.props.onDrawerOpen();}_this._emitStateChanged(IDLE);});};_this.closeDrawer=function(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this._emitStateChanged(SETTLING);_reactNative.Animated.spring(_this.state.openValue,_extends({toValue:0,bounciness:0,restSpeedThreshold:1,useNativeDriver:_this.props.useNativeAnimations},options)).start(function(){if(_this.props.onDrawerClose){_this.props.onDrawerClose();}_this._emitStateChanged(IDLE);});};_this._handleDrawerOpen=function(){if(_this.props.onDrawerOpen){_this.props.onDrawerOpen();}};_this._handleDrawerClose=function(){if(_this.props.onDrawerClose){_this.props.onDrawerClose();}};_this._shouldSetPanResponder=function(e,_ref){var moveX=_ref.moveX,dx=_ref.dx,dy=_ref.dy;if(!dx||!dy||Math.abs(dx)<MIN_SWIPE_DISTANCE){return false;}if(_this._isLockedClosed()||_this._isLockedOpen()){return false;}if(_this.getDrawerPosition()==='left'){var overlayArea=DEVICE_WIDTH-(DEVICE_WIDTH-_this.props.drawerWidth);if(_this._lastOpenValue===1){if(dx<0&&Math.abs(dx)>Math.abs(dy)*3||moveX>overlayArea){_this._isClosing=true;_this._closingAnchorValue=_this._getOpenValueForX(moveX);return true;}}else{if(moveX<=35&&dx>0){_this._isClosing=false;return true;}return false;}}else{var _overlayArea=DEVICE_WIDTH-_this.props.drawerWidth;if(_this._lastOpenValue===1){if(dx>0&&Math.abs(dx)>Math.abs(dy)*3||moveX<_overlayArea){_this._isClosing=true;_this._closingAnchorValue=_this._getOpenValueForX(moveX);return true;}}else{if(moveX>=DEVICE_WIDTH-35&&dx<0){_this._isClosing=false;return true;}return false;}}};_this._panResponderGrant=function(){_this._emitStateChanged(DRAGGING);};_this._panResponderMove=function(e,_ref2){var moveX=_ref2.moveX;var openValue=_this._getOpenValueForX(moveX);if(_this._isClosing){openValue=1-(_this._closingAnchorValue-openValue);}if(openValue>1){openValue=1;}else if(openValue<0){openValue=0;}_this.state.openValue.setValue(openValue);};_this._panResponderRelease=function(e,_ref3){var moveX=_ref3.moveX,vx=_ref3.vx;var previouslyOpen=_this._isClosing;var isWithinVelocityThreshold=vx<VX_MAX&&vx>-VX_MAX;if(_this.getDrawerPosition()==='left'){if(vx>0&&moveX>THRESHOLD||vx>=VX_MAX||isWithinVelocityThreshold&&previouslyOpen&&moveX>THRESHOLD){_this.openDrawer({velocity:vx});}else if(vx<0&&moveX<THRESHOLD||vx<-VX_MAX||isWithinVelocityThreshold&&!previouslyOpen){_this.closeDrawer({velocity:vx});}else if(previouslyOpen){_this.openDrawer();}else{_this.closeDrawer();}}else{if(vx<0&&moveX<THRESHOLD||vx<=-VX_MAX||isWithinVelocityThreshold&&previouslyOpen&&moveX<THRESHOLD){_this.openDrawer({velocity:-1*vx});}else if(vx>0&&moveX>THRESHOLD||vx>VX_MAX||isWithinVelocityThreshold&&!previouslyOpen){_this.closeDrawer({velocity:-1*vx});}else if(previouslyOpen){_this.openDrawer();}else{_this.closeDrawer();}}};_this._isLockedClosed=function(){return _this.props.drawerLockMode==='locked-closed'&&!_this.state.drawerShown;};_this._isLockedOpen=function(){return _this.props.drawerLockMode==='locked-open'&&_this.state.drawerShown;};_this.state={accessibilityViewIsModal:false,drawerShown:false,openValue:new _reactNative.Animated.Value(0)};return _this;}_createClass(DrawerLayout,[{key:'getDrawerPosition',value:function getDrawerPosition(){var drawerPosition=this.props.drawerPosition;var rtl=_reactNative.I18nManager.isRTL;return rtl?drawerPosition==='left'?'right':'left':drawerPosition;}},{key:'componentWillMount',value:function componentWillMount(){var _this2=this;var openValue=this.state.openValue;openValue.addListener(function(_ref4){var value=_ref4.value;var drawerShown=value>0;var accessibilityViewIsModal=drawerShown;if(drawerShown!==_this2.state.drawerShown){_this2.setState({drawerShown:drawerShown,accessibilityViewIsModal:accessibilityViewIsModal});}if(_this2.props.keyboardDismissMode==='on-drag'){(0,_reactNativeDismissKeyboard2.default)();}_this2._lastOpenValue=value;if(_this2.props.onDrawerSlide){_this2.props.onDrawerSlide({nativeEvent:{offset:value}});}});this._panResponder=_reactNative.PanResponder.create({onMoveShouldSetPanResponder:this._shouldSetPanResponder,onPanResponderGrant:this._panResponderGrant,onPanResponderMove:this._panResponderMove,onPanResponderTerminationRequest:function onPanResponderTerminationRequest(){return false;},onPanResponderRelease:this._panResponderRelease,onPanResponderTerminate:function onPanResponderTerminate(){}});}},{key:'render',value:function render(){var _state=this.state,accessibilityViewIsModal=_state.accessibilityViewIsModal,drawerShown=_state.drawerShown,openValue=_state.openValue;var _props=this.props,drawerBackgroundColor=_props.drawerBackgroundColor,drawerWidth=_props.drawerWidth,drawerPosition=_props.drawerPosition;var dynamicDrawerStyles={backgroundColor:drawerBackgroundColor,width:drawerWidth,left:drawerPosition==='left'?0:null,right:drawerPosition==='right'?0:null};var outputRange=void 0;if(this.getDrawerPosition()==='left'){outputRange=[-drawerWidth,0];}else{outputRange=[drawerWidth,0];}var drawerTranslateX=openValue.interpolate({inputRange:[0,1],outputRange:outputRange,extrapolate:'clamp'});var animatedDrawerStyles={transform:[{translateX:drawerTranslateX}]};var overlayOpacity=openValue.interpolate({inputRange:[0,1],outputRange:[0,0.7],extrapolate:'clamp'});var animatedOverlayStyles={opacity:overlayOpacity};var pointerEvents=drawerShown?'auto':'none';return _react2.default.createElement(_reactNative.View,_extends({style:{flex:1,backgroundColor:'transparent'}},this._panResponder.panHandlers),_react2.default.createElement(_reactNative.Animated.View,{style:styles.main},this.props.children),_react2.default.createElement(_reactNative.TouchableWithoutFeedback,{pointerEvents:pointerEvents,onPress:this._onOverlayClick},_react2.default.createElement(_reactNative.Animated.View,{pointerEvents:pointerEvents,style:[styles.overlay,animatedOverlayStyles]})),_react2.default.createElement(_reactNative.Animated.View,{accessibilityViewIsModal:accessibilityViewIsModal,style:[styles.drawer,dynamicDrawerStyles,animatedDrawerStyles]},this.props.renderNavigationView()));}},{key:'_getOpenValueForX',value:function _getOpenValueForX(x){var drawerWidth=this.props.drawerWidth;if(this.getDrawerPosition()==='left'){return x/drawerWidth;}return(DEVICE_WIDTH-x)/drawerWidth;}}]);return DrawerLayout;}(_react.Component),_class.defaultProps={drawerWidth:0,drawerPosition:'left',useNativeAnimations:false},_class.positions={Left:'left',Right:'right'},_temp);exports.default=DrawerLayout;var styles=_reactNative.StyleSheet.create({drawer:{position:'absolute',top:0,bottom:0,zIndex:1001},main:{flex:1,zIndex:0},overlay:{backgroundColor:'#000',position:'absolute',top:0,left:0,bottom:0,right:0,zIndex:1000}});

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.default = dismissKeyboard;

var _reactNative = __webpack_require__(1);

var TextInputState = _reactNative.TextInput.State;

function dismissKeyboard() {
  TextInputState.blurTextInput(TextInputState.currentlyFocusedField());
}

module.exports = exports.default;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNative=__webpack_require__(1);var _withCachedChildNavigation=__webpack_require__(132);var _withCachedChildNavigation2=_interopRequireDefault(_withCachedChildNavigation);var _NavigationActions=__webpack_require__(39);var _NavigationActions2=_interopRequireDefault(_NavigationActions);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==="undefined"?"undefined":_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==="undefined"?"undefined":_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Component that renders the sidebar screen of the drawer.
 */var DrawerSidebar=function(_PureComponent){_inherits(DrawerSidebar,_PureComponent);function DrawerSidebar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DrawerSidebar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DrawerSidebar.__proto__||Object.getPrototypeOf(DrawerSidebar)).call.apply(_ref,[this].concat(args))),_this),_this._getScreenOptions=function(routeKey){var DrawerScreen=_this.props.router.getComponentForRouteName('DrawerClose');var childNavigation=_this.props.childNavigationProps[routeKey];return DrawerScreen.router.getScreenOptions(childNavigation.state.index!==undefined// if the child screen is a StackRouter then always show the screen options of its first screen (see #1914)
?_extends({},childNavigation,{state:_extends({},childNavigation.state,{index:0})}):childNavigation,_this.props.screenProps);},_this._getLabel=function(_ref2){var focused=_ref2.focused,tintColor=_ref2.tintColor,route=_ref2.route;var _this$_getScreenOptio=_this._getScreenOptions(route.key),drawerLabel=_this$_getScreenOptio.drawerLabel,title=_this$_getScreenOptio.title;if(drawerLabel){return typeof drawerLabel==='function'?drawerLabel({tintColor:tintColor,focused:focused}):drawerLabel;}if(typeof title==='string'){return title;}return route.routeName;},_this._renderIcon=function(_ref3){var focused=_ref3.focused,tintColor=_ref3.tintColor,route=_ref3.route;var _this$_getScreenOptio2=_this._getScreenOptions(route.key),drawerIcon=_this$_getScreenOptio2.drawerIcon;if(drawerIcon){return typeof drawerIcon==='function'?drawerIcon({tintColor:tintColor,focused:focused}):drawerIcon;}return null;},_this._onItemPress=function(_ref4){var route=_ref4.route,focused=_ref4.focused;_this.props.navigation.navigate('DrawerClose');if(!focused){var subAction=void 0;// if the child screen is a StackRouter then always navigate to its first screen (see #1914)
if(route.index!==undefined&&route.index!==0){route=route;subAction=_NavigationActions2.default.navigate({routeName:route.routes[0].routeName});}_this.props.navigation.navigate(route.routeName,undefined,subAction);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DrawerSidebar,[{key:'render',value:function render(){var ContentComponent=this.props.contentComponent;var state=this.props.navigation.state;return _react2.default.createElement(_reactNative.View,{style:[styles.container,this.props.style]},_react2.default.createElement(ContentComponent,_extends({},this.props.contentOptions,{navigation:this.props.navigation,items:state.routes,activeItemKey:state.routes[state.index]&&state.routes[state.index].key,screenProps:this.props.screenProps,getLabel:this._getLabel,renderIcon:this._renderIcon,onItemPress:this._onItemPress,router:this.props.router})));}}]);return DrawerSidebar;}(_react.PureComponent);exports.default=(0,_withCachedChildNavigation2.default)(DrawerSidebar);var styles=_reactNative.StyleSheet.create({container:{flex:1}});

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.default=withNavigation;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(3);var _propTypes2=_interopRequireDefault(_propTypes);var _hoistNonReactStatics=__webpack_require__(233);var _hoistNonReactStatics2=_interopRequireDefault(_hoistNonReactStatics);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function withNavigation(Component){var componentWithNavigation=function componentWithNavigation(props,_ref){var navigation=_ref.navigation;return _react2.default.createElement(Component,_extends({},props,{navigation:navigation}));};componentWithNavigation.displayName='withNavigation('+(Component.displayName||Component.name)+')';componentWithNavigation.contextTypes={navigation:_propTypes2.default.object.isRequired};return(0,_hoistNonReactStatics2.default)(componentWithNavigation,Component);}

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_navigation_lib_react_navigation_js__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_navigation_lib_react_navigation_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_navigation_lib_react_navigation_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home___ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Header___ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_anatomy___ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_footer___ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_badge___ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_button___ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_card___ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_checkbox___ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_deckswiper___ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_fab___ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_form___ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_form_textArea__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_icon___ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_listSwipe___ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_icon_basic__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_icon_state__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_icon_specific__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_inputgroup___ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_layout___ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_list___ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_radio___ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_searchbar___ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_spinner___ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_picker___ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_tab___ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_thumbnail___ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_typography___ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_splashscreen___ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_sidebar__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_segment__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_toast__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_actionsheet__ = __webpack_require__(687);
var DrawerExample=Object(__WEBPACK_IMPORTED_MODULE_1_react_navigation_lib_react_navigation_js__["DrawerNavigator"])({Home:{screen:__WEBPACK_IMPORTED_MODULE_2__components_home___["a" /* default */]},Anatomy:{screen:__WEBPACK_IMPORTED_MODULE_4__components_anatomy___["a" /* default */]},Header:{screen:__WEBPACK_IMPORTED_MODULE_3__components_Header___["a" /* default */]},Footer:{screen:__WEBPACK_IMPORTED_MODULE_5__components_footer___["a" /* default */]},NHBadge:{screen:__WEBPACK_IMPORTED_MODULE_6__components_badge___["a" /* default */]},NHButton:{screen:__WEBPACK_IMPORTED_MODULE_7__components_button___["a" /* default */]},NHCard:{screen:__WEBPACK_IMPORTED_MODULE_8__components_card___["a" /* default */]},NHCheckbox:{screen:__WEBPACK_IMPORTED_MODULE_9__components_checkbox___["a" /* default */]},NHDeckSwiper:{screen:__WEBPACK_IMPORTED_MODULE_10__components_deckswiper___["a" /* default */]},NHFab:{screen:__WEBPACK_IMPORTED_MODULE_11__components_fab___["a" /* default */]},NHForm:{screen:__WEBPACK_IMPORTED_MODULE_12__components_form___["a" /* default */]},TextArea:{screen:__WEBPACK_IMPORTED_MODULE_13__components_form_textArea__["a" /* default */]},NHIcon:{screen:__WEBPACK_IMPORTED_MODULE_14__components_icon___["a" /* default */]},BasicIcon:{screen:__WEBPACK_IMPORTED_MODULE_16__components_icon_basic__["a" /* default */]},IconState:{screen:__WEBPACK_IMPORTED_MODULE_17__components_icon_state__["a" /* default */]},SpecificIcon:{screen:__WEBPACK_IMPORTED_MODULE_18__components_icon_specific__["a" /* default */]},NHInputGroup:{screen:__WEBPACK_IMPORTED_MODULE_19__components_inputgroup___["a" /* default */]},NHLayout:{screen:__WEBPACK_IMPORTED_MODULE_20__components_layout___["a" /* default */]},NHList:{screen:__WEBPACK_IMPORTED_MODULE_21__components_list___["a" /* default */]},ListSwipe:{screen:__WEBPACK_IMPORTED_MODULE_15__components_listSwipe___["a" /* default */]},NHRadio:{screen:__WEBPACK_IMPORTED_MODULE_22__components_radio___["a" /* default */]},NHSearchbar:{screen:__WEBPACK_IMPORTED_MODULE_23__components_searchbar___["a" /* default */]},NHSpinner:{screen:__WEBPACK_IMPORTED_MODULE_24__components_spinner___["a" /* default */]},NHPicker:{screen:__WEBPACK_IMPORTED_MODULE_25__components_picker___["a" /* default */]},NHTab:{screen:__WEBPACK_IMPORTED_MODULE_26__components_tab___["a" /* default */]},NHThumbnail:{screen:__WEBPACK_IMPORTED_MODULE_27__components_thumbnail___["a" /* default */]},NHTypography:{screen:__WEBPACK_IMPORTED_MODULE_28__components_typography___["a" /* default */]},Segment:{screen:__WEBPACK_IMPORTED_MODULE_31__components_segment__["a" /* default */]},Toast:{screen:__WEBPACK_IMPORTED_MODULE_32__components_toast__["a" /* default */]},Actionsheet:{screen:__WEBPACK_IMPORTED_MODULE_33__components_actionsheet__["a" /* default */]}},{initialRouteName:"Home",contentOptions:{activeTintColor:"#e91e63"},contentComponent:function contentComponent(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_sidebar__["a" /* default */],props);}});/* harmony default export */ __webpack_exports__["a"] = (DrawerExample);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(645);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var launchscreenBg=__webpack_require__(646);var launchscreenLogo=__webpack_require__(251);var Home=function(_Component){_inherits(Home,_Component);function Home(){_classCallCheck(this,Home);return _possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).apply(this,arguments));}_createClass(Home,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["StatusBar"],{barStyle:"light-content"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["Image"],{source:launchscreenBg,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].imageContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].logoContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["Image"],{source:launchscreenLogo,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].logo})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{alignItems:"center",marginBottom:50,backgroundColor:"transparent"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["H3"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].text},"App to showcase"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{marginTop:8}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["H3"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].text},"NativeBase components"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{marginTop:8}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{marginBottom:80}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#6FAF98",alignSelf:"center"},onPress:function onPress(){console.log('to DrawerOpen',_this2.props.navigation);_this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Lets Go!")))));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet,Dimensions=React.Dimensions,Platform=React.Platform;var deviceHeight=Dimensions.get("window").height;/* harmony default export */ __webpack_exports__["a"] = ({imageContainer:{flex:1,width:null,height:null},logoContainer:{flex:1,marginTop:deviceHeight/8,marginBottom:30},logo:{position:"absolute",left:Platform.OS==="android"?40:50,top:Platform.OS==="android"?35:60,width:280,height:100},text:{color:"#D8D8D8",bottom:6,marginTop:5}});

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/launchscreen-bg.6dd3150e.png";

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(648);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Anatomy=function(_Component){_inherits(Anatomy,_Component);function Anatomy(){_classCallCheck(this,Anatomy);return _possibleConstructorReturn(this,(Anatomy.__proto__||Object.getPrototypeOf(Anatomy)).apply(this,arguments));}_createClass(Anatomy,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"ios-menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Header")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Content goes here")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Footer"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["FooterTab"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:true,full:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Footer")))));}}]);return Anatomy;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Anatomy);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#fff"}});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(61);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datas=[{route:"BasicFooter",text:"Basic Footer"},{route:"IconFooter",text:"Icon Footer"},{route:"IconText",text:"Icon & Text Footer"},{route:"BadgeFooter",text:"With Badge"}];var NHFooter=function(_Component){_inherits(NHFooter,_Component);function NHFooter(){_classCallCheck(this,NHFooter);return _possibleConstructorReturn(this,(NHFooter.__proto__||Object.getPrototypeOf(NHFooter)).apply(this,arguments));}_createClass(NHFooter,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Footer")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.props.navigation.navigate(data.route);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,data.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward",style:{color:"#999"}})));}})));}}]);return NHFooter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHFooter);

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(651);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NHBadge=function(_Component){_inherits(NHBadge,_Component);function NHBadge(){_classCallCheck(this,NHBadge);return _possibleConstructorReturn(this,(NHBadge.__proto__||Object.getPrototypeOf(NHBadge)).apply(this,arguments));}_createClass(NHBadge,[{key:"render",//eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Badge")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Badge"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Badge"],{primary:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Badge"],{success:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Badge"],{info:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Badge"],{warning:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Badge"],{danger:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Badge"],{primary:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"star",style:{fontSize:15,color:"#fff",lineHeight:20}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Badge"],{style:{backgroundColor:"black"},textStyle:{color:"white"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"1866"))));}}]);return NHBadge;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHBadge);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FFF"},mb:{marginBottom:10}});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datas=[{route:"Default",text:"Default Button"},{route:"Outline",text:"Outline Button"},{route:"Rounded",text:"Rounded Button"},{route:"Block",text:"Block Button"},{route:"Full",text:"Full Button"},{route:"Custom",text:"Custom Size Button"},{route:"Transparent",text:"Transparent Button"},{route:"IconBtn",text:"Icon Button"},{route:"Disabled",text:"Disabled Button"}];var NHButton=function(_Component){_inherits(NHButton,_Component);function NHButton(){_classCallCheck(this,NHButton);return _possibleConstructorReturn(this,(NHButton.__proto__||Object.getPrototypeOf(NHButton)).apply(this,arguments));}_createClass(NHButton,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Buttons")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.props.navigation.navigate(data.route);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,data.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward",style:{color:"#999"}})));}})));}}]);return NHButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHButton);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datas=[{route:"BasicCard",text:"Basic Card"},{route:"NHCardList",text:"Card List"},{route:"NHCardImage",text:"Card Image"},{route:"NHCardShowcase",text:"Card Showcase"},{route:"NHCardHeaderAndFooter",text:"Card Header & Footer"}];var NHCard=function(_Component){_inherits(NHCard,_Component);function NHCard(){_classCallCheck(this,NHCard);return _possibleConstructorReturn(this,(NHCard.__proto__||Object.getPrototypeOf(NHCard)).apply(this,arguments));}_createClass(NHCard,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Card")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.props.navigation.navigate(data.route);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,data.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward",style:{color:"#999"}})));}})));}}]);return NHCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHCard);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(655);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NHCheckbox=function(_Component){_inherits(NHCheckbox,_Component);function NHCheckbox(props){_classCallCheck(this,NHCheckbox);var _this=_possibleConstructorReturn(this,(NHCheckbox.__proto__||Object.getPrototypeOf(NHCheckbox)).call(this,props));_this.state={checkbox1:true,checkbox2:true,checkbox3:true,checkbox4:false};return _this;}_createClass(NHCheckbox,[{key:'toggleSwitch1',value:function toggleSwitch1(){this.setState({checkbox1:!this.state.checkbox1});}},{key:'toggleSwitch2',value:function toggleSwitch2(){this.setState({checkbox2:!this.state.checkbox2});}},{key:'toggleSwitch3',value:function toggleSwitch3(){this.setState({checkbox3:!this.state.checkbox3});}},{key:'toggleSwitch4',value:function toggleSwitch4(){this.setState({checkbox4:!this.state.checkbox4});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate('DrawerOpen');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:'menu'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,'Check Box')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.toggleSwitch1();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CheckBox"],{checked:this.state.checkbox1,onPress:function onPress(){return _this2.toggleSwitch1();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,'Lunch Break'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.toggleSwitch2();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CheckBox"],{color:'red',checked:this.state.checkbox2,onPress:function onPress(){return _this2.toggleSwitch2();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,'Daily Stand Up'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.toggleSwitch3();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CheckBox"],{color:'green',checked:this.state.checkbox3,onPress:function onPress(){return _this2.toggleSwitch3();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,'Finish list Screen'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.toggleSwitch4();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CheckBox"],{color:'#000',checked:this.state.checkbox4,onPress:function onPress(){return _this2.toggleSwitch4();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,'Discussion with Client')))));}}]);return NHCheckbox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHCheckbox);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FFF"}});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(133);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datas=[{route:"SimpleDeck",text:"Simple DeckSwiper"},{route:"AdvancedDeck",text:"Advanced DeckSwiper"}];var NHDeckSwiper=function(_Component){_inherits(NHDeckSwiper,_Component);function NHDeckSwiper(){_classCallCheck(this,NHDeckSwiper);return _possibleConstructorReturn(this,(NHDeckSwiper.__proto__||Object.getPrototypeOf(NHDeckSwiper)).apply(this,arguments));}_createClass(NHDeckSwiper,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Deck Swiper")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.props.navigation.navigate(data.route);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,data.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-forward",style:{color:"#999"}})));}})));}}]);return NHDeckSwiper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHDeckSwiper);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(134);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datas=[{route:"BasicFab",text:"Basic FAB"},{route:"MultipleFab",text:"Multiple FABs"}];var NHFab=function(_Component){_inherits(NHFab,_Component);function NHFab(){_classCallCheck(this,NHFab);return _possibleConstructorReturn(this,(NHFab.__proto__||Object.getPrototypeOf(NHFab)).apply(this,arguments));}_createClass(NHFab,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"FAB")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.props.navigation.navigate(data.route);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,data.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward",style:{color:"#999"}})));}})));}}]);return NHFab;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHFab);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datas=[{route:"FixedLabel",text:"Fixed Label"},{route:"InlineLabel",text:"Inline Label"},{route:"FloatingLabel",text:"Floating Label"},{route:"PlaceholderLabel",text:"Placeholder Label"},{route:"StackedLabel",text:"Stacked Label"},{route:"RegularInput",text:"Regular Textbox"},{route:"UnderlineInput",text:"Underlined Textbox"},{route:"RoundedInput",text:"Rounded Textbox"},{route:"IconInput",text:"Icon Textbox"},{route:"SuccessInput",text:"Success Input Textbox"},{route:"ErrorInput",text:"Error Input Textbox"},{route:"DisabledInput",text:"Disabled Textbox"}];var NHForm=function(_Component){_inherits(NHForm,_Component);function NHForm(){_classCallCheck(this,NHForm);return _possibleConstructorReturn(this,(NHForm.__proto__||Object.getPrototypeOf(NHForm)).apply(this,arguments));}_createClass(NHForm,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Form & Inputs")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.props.navigation.navigate(data.route);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,data.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward",style:{color:"#999"}})));}})));}}]);return NHForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHForm);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextArea=function(_Component){_inherits(TextArea,_Component);function TextArea(){_classCallCheck(this,TextArea);return _possibleConstructorReturn(this,(TextArea.__proto__||Object.getPrototypeOf(TextArea)).apply(this,arguments));}_createClass(TextArea,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["IconNB"],{name:"ios-arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"TextArea")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Textarea"],{rowSpan:5,bordered:true,placeholder:"Textarea"})));}}]);return TextArea;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TextArea);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NHIcon=function(_Component){_inherits(NHIcon,_Component);function NHIcon(){_classCallCheck(this,NHIcon);return _possibleConstructorReturn(this,(NHIcon.__proto__||Object.getPrototypeOf(NHIcon)).apply(this,arguments));}_createClass(NHIcon,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Icons")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Grid"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-apple",style:{color:"#999"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-apple")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"pizza",style:{color:"#ffc125"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"pizza")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"person",style:{color:"#387ef5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"person")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"beer",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"beer")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"bicycle",style:{color:"#663399"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"bicycle"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"navigate",style:{color:"#32db64"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"navigate")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"cloud-circle",style:{color:"#27a"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"cloud-circle")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"pie",style:{color:"#fac125"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"pie")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"bookmarks",style:{color:"blue"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"bookmarks")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"pulse",style:{color:"green"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"pulse"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"camera",style:{color:"#aaa"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"camera")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"mic-off",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"mic-off")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"film",style:{color:"brown"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"film")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"flame",style:{color:"orange"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"flame")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"paper",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"paper"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"paper-plane",style:{color:"#387ef5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"paper-plane")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"cart",style:{color:"red"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"cart")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"flask",style:{color:"blue"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"flask")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"paw",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"paw")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"rose",style:{color:"pink"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"rose"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"pint",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"pint")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"shuffle",style:{color:"green"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"shuffle")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"keypad",style:{color:"#387ef5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"keypad")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"eye",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"eye")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"glasses",style:{color:"#aaa"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"glasses"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"microphone",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"microphone")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"color-filter",style:{color:"purple"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"color-filter")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"alarm",style:{color:"green"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"alarm")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"medkit",style:{color:"red"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"medkit")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"ionic",style:{color:"blue"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"ionic"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"refresh",style:{color:"blue"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"refresh")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"star-half",style:{color:"gold"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"star-half")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"train",style:{color:"#E14343"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"train")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"wine",style:{color:"brown"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"wine")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"partly-sunny",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"partly-sunny"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"nutrition",style:{color:"red"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"nutrition")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"grid",style:{color:"blue"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"grid")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"settings",style:{color:"#555"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"settings")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"chatbubbles",style:{color:"#27a"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"chatbubbles")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"speedometer",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"speedometer"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"chatboxes",style:{color:"green"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"chatboxes")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"cog",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"cog")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"baseball",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"baseball")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"bulb",style:{color:"gold"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"bulb")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"calculator",style:{color:"#889"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"calculator"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"rainy",style:{color:"blue"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"rainy")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"videocam",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"videocam")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"play",style:{color:"#f53d3d"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"play")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"disc",style:{color:"#c76"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"disc")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"body",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"body"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"lock",style:{color:"blue"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"lock")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"key",style:{color:"gold"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"key")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"flag",style:{color:"green"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"flag")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"skip-forward",style:{color:"#999"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"skip-forward")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-github",style:{color:"brown"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-github"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"barcode",style:{color:"#387ef5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"barcode")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-tux",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-tux")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"copy",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"copy")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"stopwatch",style:{color:"#1df"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"stopwatch")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"medical",style:{color:"red"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"medical"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"archive",style:{color:"brown"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"archive")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"bookmark",style:{color:"green"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"bookmark")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"clipboard",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"clipboard")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"happy",style:{color:"#ffc125"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"happy")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"share",style:{color:"#387ef5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"share"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"bluetooth",style:{color:"#387ef5"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"bluetooth")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"search",style:{color:"#777"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"search")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"wifi",style:{color:"blue"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"wifi")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"hand",style:{color:"#EBAB7F"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"hand")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"trash",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"trash"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"images",style:{color:"red"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"images")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"attach",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"attach")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-facebook",style:{color:"#46639E"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-facebook")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-googleplus",style:{color:"#DC4A38"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-googleplus")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-twitter",style:{color:"#1DA1F2"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-twitter"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-github",style:{color:"red"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-github")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-whatsapp",style:{color:"#000"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-whatsapp")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-wordpress",style:{color:"#46639E"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-wordpress")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-youtube",style:{color:"#DC4A38"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-youtube")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"mail",style:{color:"#1DA1F2"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"mail"))))));}}]);return NHIcon;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHIcon);

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(135);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datas=[{route:'BasicListSwipe',text:'Single SwipeRow'},{route:'MultiListSwipe',text:'Multiple List Swipe'}];var ListSwipe=function(_Component){_inherits(ListSwipe,_Component);function ListSwipe(){_classCallCheck(this,ListSwipe);return _possibleConstructorReturn(this,(ListSwipe.__proto__||Object.getPrototypeOf(ListSwipe)).apply(this,arguments));}_createClass(ListSwipe,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate('DrawerOpen');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:'menu'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,'List Swipe')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{scrollEnabled:false,contentContainerStyle:{flex:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.props.navigation.navigate(data.route);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,data.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:'arrow-forward'})));}})));}}]);return ListSwipe;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ListSwipe);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Basic=function(_Component){_inherits(Basic,_Component);function Basic(){_classCallCheck(this,Basic);return _possibleConstructorReturn(this,(Basic.__proto__||Object.getPrototypeOf(Basic)).apply(this,arguments));}_createClass(Basic,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.replaceAt("icon");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Basic")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].iconContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"logo-apple",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"pizza",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"person",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"beer",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"bicycle",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"navigate",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"cloud-circle",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"pie",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"bookmarks",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"pulse",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"camera",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"mic-off",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"film",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"flame",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"paper",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"paper-plane",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"speedometer",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"cart",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"flask",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"cloudy-night",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"partly-sunny",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"paw",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"rose",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"pint",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"shuffle",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"game-controller-a",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"glasses",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"microphone",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"keypad",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"color-filter",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"eye",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"mic-off",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"alarm",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"medkit",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"ionic",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"star-half",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"refresh",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"train",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"musical-notes",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"wine",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"nutrition",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"thunderstorm",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"grid",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"settings",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"chatbubbles",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"chatboxes",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"cog",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"baseball",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"bulb",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"calculator",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"rainy",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"videocam",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"play",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"disc",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"body",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"lock",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"skip-backward",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"key",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"flag",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"skip-forward",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"barcode",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"logo-tux",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"copy",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"stopwatch",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"medical",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"archive",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"bookmark",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"clipboard",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"happy",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"share",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"bluetooth",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"search",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"wifi",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"hand",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"trash",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"images",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"attach",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"logo-facebook",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"logo-googleplus",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"logo-twitter",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"logo-github",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"logo-whatsapp",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"logo-wordpress",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"logo-youtube",style:{width:45,height:45,justifyContent:"center"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"mail",style:{width:45,height:45,justifyContent:"center"}}))));}}]);return Basic;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Basic);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var State=function(_Component){_inherits(State,_Component);function State(){_classCallCheck(this,State);return _possibleConstructorReturn(this,(State.__proto__||Object.getPrototypeOf(State)).apply(this,arguments));}_createClass(State,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.replaceAt("icon");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Icons")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Grid"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-apple"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-apple")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"pizza"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"pizza")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"person"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"person")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"beer"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"beer")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"bicycle"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"bicycle"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"navigate"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"navigate")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"cloud-circle"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"cloud-circle")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"pie"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"pie")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"bookmarks"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"bookmarks")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"pulse"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"pulse"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"camera"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"camera")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"mic-off"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"mic-off")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"film"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"film")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"flame"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"flame")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"paper"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"paper"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"paper-plane"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"paper-plane")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"cart"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"cart")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"flask"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"flask")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"paw"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"paw")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"rose"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"rose"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"pint"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"pint")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"shuffle"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"shuffle")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"keypad"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"keypad")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"eye"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"eye")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"glasses"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"glasses"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"microphone"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"microphone")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"color-filter"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"color-filter")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"alarm"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"alarm")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"medkit"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"medkit")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"ionic"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"ionic"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"refresh"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"refresh")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"star-half"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"star-half")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"train"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"train")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"wine"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"wine")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"partly-sunny"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"partly-sunny"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"nutrition"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"nutrition")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"grid"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"grid")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"settings"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"settings")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"chatbubbles"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"chatbubbles")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"speedometer"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"speedometer"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"chatboxes"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"chatboxes")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"cog"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"cog")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"baseball"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"baseball")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"bulb"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"bulb")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"calculator"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"calculator"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"rainy"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"rainy")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"videocam"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"videocam")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"play"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"play")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"disc"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"disc")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"body"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"body"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"lock"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"lock")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"key"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"key")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"flag"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"flag")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"skip-forward"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"skip-forward")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-github"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-github"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"barcode"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"barcode")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-tux"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-tux")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"copy"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"copy")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"stopwatch"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"stopwatch")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"medical"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"medical"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"archive"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"archive")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"bookmark"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"bookmark")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"clipboard"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"clipboard")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"happy"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"happy")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"share"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"share"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"bluetooth"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"bluetooth")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"search"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"search")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"wifi"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"wifi")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"hand"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"hand")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"trash"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"trash"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"images"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"images")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"attach"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"attach")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-facebook"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-facebook")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-googleplus"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-googleplus")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-twitter"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-twitter"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-github"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-github")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-whatsapp"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-whatsapp")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-wordpress"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-wordpress")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"logo-youtube"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"logo-youtube")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"mail"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].iconText},"mail"))))));}}]);return State;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (State);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Specific=function(_Component){_inherits(Specific,_Component);function Specific(){_classCallCheck(this,Specific);return _possibleConstructorReturn(this,(Specific.__proto__||Object.getPrototypeOf(Specific)).apply(this,arguments));}_createClass(Specific,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.replaceAt("icon");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Platform")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Grid"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{ios:"ios-person",android:"md-person"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"person")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{ios:"ios-apps-outline",android:"md-apps"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"person")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{ios:"ios-menu",android:"md-menu"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"person")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{ios:"ios-paper",android:"md-paper"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"person")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Col"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].col},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{ios:"ios-cart-outline",android:"md-cart"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"person"))))));}}]);return Specific;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Specific);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datas=[{route:"RegularInput",text:"Regular Textbox"},{route:"UnderlineInput",text:"Underlined Textbox"},{route:"RoundedInput",text:"Rounded Textbox"},{route:"IconInput",text:"Icon Textbox"},{route:"SuccessInput",text:"Success Input Textbox"},{route:"ErrorInput",text:"Error Input Textbox"},{route:"DisabledInput",text:"Disabled Textbox"}];var NHInputGroup=function(_Component){_inherits(NHInputGroup,_Component);function NHInputGroup(){_classCallCheck(this,NHInputGroup);return _possibleConstructorReturn(this,(NHInputGroup.__proto__||Object.getPrototypeOf(NHInputGroup)).apply(this,arguments));}_createClass(NHInputGroup,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["IconNB"],{name:"ios-menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Inputs")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.props.navigation.navigate(data.route);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,data.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward",style:{color:"#999"}})));}})));}}]);return NHInputGroup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHInputGroup);

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datas=[{route:"RowNB",text:"Row Grid"},{route:"ColumnNB",text:"Column Grid"},{route:"NestedGrid",text:"Nested Grid"},{route:"CustomRow",text:"Custom Row Size Grid"},{route:"CustomCol",text:"Custom Column Size Grid"}];var NHLayout=function(_Component){_inherits(NHLayout,_Component);function NHLayout(){_classCallCheck(this,NHLayout);return _possibleConstructorReturn(this,(NHLayout.__proto__||Object.getPrototypeOf(NHLayout)).apply(this,arguments));}_createClass(NHLayout,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:{backgroundColor:"#FBFAFA"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Layout")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.props.navigation.navigate(data.route);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,data.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward",style:{color:"#999"}})));}})));}}]);return NHLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHLayout);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datas=[{route:'NHBasicList',text:'Basic List'},{route:'NHListDivider',text:'List Divider'},{route:'NHListHeader',text:'List Header'},{route:'NHListIcon',text:'List Icon'},{route:'NHListAvatar',text:'List Avatar'},{route:'NHListThumbnail',text:'List Thumbnail'},,{route:'NHListSeparator',text:'List Separator'}];var NHList=function(_Component){_inherits(NHList,_Component);function NHList(){_classCallCheck(this,NHList);return _possibleConstructorReturn(this,(NHList.__proto__||Object.getPrototypeOf(NHList)).apply(this,arguments));}_createClass(NHList,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate('DrawerOpen');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:'menu'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,'List')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.props.navigation.navigate(data.route);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,data.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:'arrow-forward'})));}})));}}]);return NHList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHList);

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(669);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NHRadio=function(_Component){_inherits(NHRadio,_Component);function NHRadio(props){_classCallCheck(this,NHRadio);var _this=_possibleConstructorReturn(this,(NHRadio.__proto__||Object.getPrototypeOf(NHRadio)).call(this,props));_this.state={radio1:false,radio2:false,radio3:false,radio4:true};return _this;}_createClass(NHRadio,[{key:"toggleRadio1",value:function toggleRadio1(){this.setState({radio1:true,radio2:false,radio3:false,radio4:false});}},{key:"toggleRadio2",value:function toggleRadio2(){this.setState({radio1:false,radio2:true,radio3:false,radio4:false});}},{key:"toggleRadio3",value:function toggleRadio3(){this.setState({radio1:false,radio2:false,radio3:true,radio4:false});}},{key:"toggleRadio4",value:function toggleRadio4(){this.setState({radio1:false,radio2:false,radio3:false,radio4:true});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Radio")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{selected:this.state.radio1,onPress:function onPress(){return _this2.toggleRadio1();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Lunch Break"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Radio"],{selected:this.state.radio1,onPress:function onPress(){return _this2.toggleRadio1();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{selected:this.state.radio2,onPress:function onPress(){return _this2.toggleRadio2();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Daily Stand Up"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Radio"],{selected:this.state.radio2,onPress:function onPress(){return _this2.toggleRadio2();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{selected:this.state.radio3,onPress:function onPress(){return _this2.toggleRadio3();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Finish List Screen"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Radio"],{selected:this.state.radio3,onPress:function onPress(){return _this2.toggleRadio3();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{selected:this.state.radio4,onPress:function onPress(){return _this2.toggleRadio4();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Discussion with Client"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Radio"],{selected:this.state.radio4,onPress:function onPress(){return _this2.toggleRadio4();}})))));}}]);return NHRadio;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHRadio);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FFF"}});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(671);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NHSearchbar=function(_Component){_inherits(NHSearchbar,_Component);function NHSearchbar(){_classCallCheck(this,NHSearchbar);return _possibleConstructorReturn(this,(NHSearchbar.__proto__||Object.getPrototypeOf(NHSearchbar)).apply(this,arguments));}_createClass(NHSearchbar,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],{searchBar:true,rounded:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"search"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],{placeholder:"Search"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"people"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Search"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{block:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Back"))));}}]);return NHSearchbar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHSearchbar);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FFF"}});

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(673);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NHSpinner=function(_Component){_inherits(NHSpinner,_Component);function NHSpinner(){_classCallCheck(this,NHSpinner);return _possibleConstructorReturn(this,(NHSpinner.__proto__||Object.getPrototypeOf(NHSpinner)).apply(this,arguments));}_createClass(NHSpinner,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Spinner")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Spinner"],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Spinner"],{color:"red"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Spinner"],{color:"green"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Spinner"],{color:"blue"})));}}]);return NHSpinner;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHSpinner);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FBFAFA"}});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datas=[{route:"RegularPicker",text:"Regular"},{route:"PlaceholderPicker",text:"Placeholder"},{route:"PlaceholderPickerNote",text:"Placeholder (without note)"},{route:"BackButtonPicker",text:"Custom Back Button"},{route:"HeaderPicker",text:"Custom Header Text"},{route:"HeaderStylePicker",text:"Custom Header Style"},{route:"CustomHeaderPicker",text:"Custom Header"}];var NHPicker=function(_Component){_inherits(NHPicker,_Component);function NHPicker(){_classCallCheck(this,NHPicker);return _possibleConstructorReturn(this,(NHPicker.__proto__||Object.getPrototypeOf(NHPicker)).apply(this,arguments));}_createClass(NHPicker,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Picker")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.props.navigation.navigate(data.route);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,data.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-forward",style:{color:"#999"}})));}})));}}]);return NHPicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHPicker);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(50);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datas=[{route:"BasicTab",text:"Basic Tabs"},{route:"ConfigTab",text:"Advanced Tabs"},{route:"ScrollableTab",text:"Scrollable Tabs"}];var NHTab=function(_Component){_inherits(NHTab,_Component);function NHTab(props){_classCallCheck(this,NHTab);var _this=_possibleConstructorReturn(this,(NHTab.__proto__||Object.getPrototypeOf(NHTab)).call(this,props));_this.state={tab1:false,tab2:false,tab3:true};return _this;}_createClass(NHTab,[{key:"toggleTab1",value:function toggleTab1(){this.setState({tab1:true,tab2:false,tab3:false});}},{key:"toggleTab2",value:function toggleTab2(){this.setState({tab1:false,tab2:true,tab3:false});}},{key:"toggleTab3",value:function toggleTab3(){this.setState({tab1:false,tab2:false,tab3:true});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],{noShadow:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Tabs")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.props.navigation.navigate(data.route);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,data.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward",style:{color:"#999"}})));}})));}}]);return NHTab;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHTab);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(677);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var imgOne=__webpack_require__(136);var imgTwo=__webpack_require__(137);var logo=__webpack_require__(253);var cover=__webpack_require__(678);var NHThumbnail=function(_Component){_inherits(NHThumbnail,_Component);function NHThumbnail(){_classCallCheck(this,NHThumbnail);return _possibleConstructorReturn(this,(NHThumbnail.__proto__||Object.getPrototypeOf(NHThumbnail)).apply(this,arguments));}_createClass(NHThumbnail,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Thumbnail")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["View"],{style:{flex:1,alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb10},"Square Thumbnail"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Thumbnail"],{square:true,small:true,source:logo,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb10}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Thumbnail"],{square:true,source:logo,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb10}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Thumbnail"],{square:true,large:true,source:logo,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb35}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb10},"Circular Thumbnail"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Thumbnail"],{small:true,source:cover,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb10}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Thumbnail"],{source:cover,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb10}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Thumbnail"],{large:true,source:cover}))));}}]);return NHThumbnail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHThumbnail);

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FFF"},mb10:{marginBottom:10},mb35:{marginBottom:35}});

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/web-cover1.a47417bc.jpg";

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(680);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NHTypography=function(_Component){_inherits(NHTypography,_Component);function NHTypography(){_classCallCheck(this,NHTypography);return _possibleConstructorReturn(this,(NHTypography.__proto__||Object.getPrototypeOf(NHTypography)).apply(this,arguments));}_createClass(NHTypography,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Typography")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["H1"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb10},"Header One"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["H2"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb10},"Header Two"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["H3"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb10},"Header Three"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Default")));}}]);return NHTypography;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHTypography);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#FFF"},mb10:{marginBottom:10}});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var splashscreen=__webpack_require__(253);var SplashPage=function(_Component){_inherits(SplashPage,_Component);function SplashPage(){_classCallCheck(this,SplashPage);return _possibleConstructorReturn(this,(SplashPage.__proto__||Object.getPrototypeOf(SplashPage)).apply(this,arguments));}_createClass(SplashPage,[{key:"render",value:function render(){// eslint-disable-line class-methods-use-this
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["Image"],{source:splashscreen,style:{flex:1,height:null,width:null}});}}]);return SplashPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__(683);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var drawerCover=__webpack_require__(138);var drawerImage=__webpack_require__(251);var datas=[{name:"Anatomy",route:"Anatomy",icon:"phone-portrait",bg:"#C5F442"},{name:"Actionsheet",route:"Actionsheet",icon:"easel",bg:"#C5F442"},{name:"Header",route:"Header",icon:"phone-portrait",bg:"#477EEA",types:"8"},{name:"Footer",route:"Footer",icon:"phone-portrait",bg:"#DA4437",types:"4"},{name:"Badge",route:"NHBadge",icon:"notifications",bg:"#4DCAE0"},{name:"Button",route:"NHButton",icon:"radio-button-off",bg:"#1EBC7C",types:"9"},{name:"Card",route:"NHCard",icon:"keypad",bg:"#B89EF5",types:"5"},{name:"Check Box",route:"NHCheckbox",icon:"checkmark-circle",bg:"#EB6B23"},{name:"Deck Swiper",route:"NHDeckSwiper",icon:"swap",bg:"#3591FA",types:"2"},{name:"Fab",route:"NHFab",icon:"help-buoy",bg:"#EF6092",types:"2"},{name:"Form & Inputs",route:"NHForm",icon:"call",bg:"#EFB406",types:"12"},{name:"Icon",route:"NHIcon",icon:"information-circle",bg:"#EF6092"},{name:"Layout",route:"NHLayout",icon:"grid",bg:"#9F897C",types:"5"},{name:"List",route:"NHList",icon:"lock",bg:"#5DCEE2",types:"7"},{name:"ListSwipe",route:"ListSwipe",icon:"swap",bg:"#C5F442",types:"2"},{name:"Picker",route:"NHPicker",icon:"arrow-dropdown",bg:"#F50C75"},{name:"Radio",route:"NHRadio",icon:"radio-button-on",bg:"#6FEA90"},{name:"SearchBar",route:"NHSearchbar",icon:"search",bg:"#29783B"},{name:"Segment",route:"Segment",icon:"menu",bg:"#0A2C6B",types:"2"},{name:"Spinner",route:"NHSpinner",icon:"navigate",bg:"#BE6F50"},{name:"Tabs",route:"NHTab",icon:"home",bg:"#AB6AED",types:"3"},{name:"Thumbnail",route:"NHThumbnail",icon:"image",bg:"#cc0000",types:"2"},{name:"Toast",route:"Toast",icon:"albums",bg:"#C5F442"},{name:"Typography",route:"NHTypography",icon:"paper",bg:"#48525D"}];var SideBar=function(_Component){_inherits(SideBar,_Component);function SideBar(props){_classCallCheck(this,SideBar);var _this=_possibleConstructorReturn(this,(SideBar.__proto__||Object.getPrototypeOf(SideBar)).call(this,props));_this.state={shadowOffsetWidth:1,shadowRadius:4};return _this;}_createClass(SideBar,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],{bounces:false,style:{flex:1,backgroundColor:"#fff",top:-1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["Image"],{source:drawerCover,style:__WEBPACK_IMPORTED_MODULE_3__style__["a" /* default */].drawerCover},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["Image"],{square:true,style:__WEBPACK_IMPORTED_MODULE_3__style__["a" /* default */].drawerImage,source:drawerImage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["ListItem"],{button:true,noBorder:true,onPress:function onPress(){return _this2.props.navigation.navigate(data.route);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:data.icon,style:{color:"#777",fontSize:26,width:30}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],{style:__WEBPACK_IMPORTED_MODULE_3__style__["a" /* default */].text},data.name)),data.types&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],{style:{flex:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Badge"],{style:{borderRadius:3,height:25,width:72,backgroundColor:data.bg}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],{style:__WEBPACK_IMPORTED_MODULE_3__style__["a" /* default */].badgeText},data.types+" Types"))));}})));}}]);return SideBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SideBar);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet,Platform=React.Platform,Dimensions=React.Dimensions;var deviceHeight=Dimensions.get("window").height;var deviceWidth=Dimensions.get("window").width;/* harmony default export */ __webpack_exports__["a"] = ({sidebar:{flex:1,backgroundColor:"#fff"},drawerCover:{alignSelf:"stretch",// resizeMode: 'cover',
height:deviceHeight/3.5,width:null,position:"relative",marginBottom:10},drawerImage:{position:"absolute",// left: (Platform.OS === 'android') ? 30 : 40,
left:Platform.OS==="android"?deviceWidth/10:deviceWidth/9,// top: (Platform.OS === 'android') ? 45 : 55,
top:Platform.OS==="android"?deviceHeight/13:deviceHeight/12,width:210,height:75,resizeMode:"cover"},listItemContainer:{flexDirection:"row",justifyContent:"flex-start",alignItems:"center"},iconContainer:{width:37,height:37,borderRadius:18,marginRight:12,paddingTop:Platform.OS==="android"?7:5},sidebarIcon:{fontSize:21,color:"#fff",lineHeight:Platform.OS==="android"?21:25,backgroundColor:"transparent",alignSelf:"center"},text:{fontWeight:Platform.OS==="ios"?"500":"400",fontSize:16,marginLeft:20},badgeText:{fontSize:Platform.OS==="ios"?13:11,fontWeight:"400",textAlign:"center",marginTop:Platform.OS==="android"?-3:undefined}});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(139);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datas=[{route:"BasicSegment",text:"Segments inside Header"},{route:"AdvSegment",text:"Segments outside Header "}];var NBSegment=function(_Component){_inherits(NBSegment,_Component);function NBSegment(){_classCallCheck(this,NBSegment);return _possibleConstructorReturn(this,(NBSegment.__proto__||Object.getPrototypeOf(NBSegment)).apply(this,arguments));}_createClass(NBSegment,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Segments")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{button:true,onPress:function onPress(){return _this2.props.navigation.navigate(data.route);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,data.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward",style:{color:"#999"}})));}})));}}]);return NBSegment;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NBSegment);

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(686);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ToastNB=function(_Component){_inherits(ToastNB,_Component);function ToastNB(props){_classCallCheck(this,ToastNB);var _this=_possibleConstructorReturn(this,(ToastNB.__proto__||Object.getPrototypeOf(ToastNB)).call(this,props));_this.state={showToast:false};return _this;}_createClass(ToastNB,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"ios-menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Toast")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{onPress:function onPress(){return __WEBPACK_IMPORTED_MODULE_1_native_base__["Toast"].show({text:"Wrong password!",buttonText:"Okay"});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Toast"))));}}]);return ToastNB;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ToastNB);

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var React=__webpack_require__(1);var StyleSheet=React.StyleSheet;/* harmony default export */ __webpack_exports__["a"] = ({container:{backgroundColor:"#fff"}});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionSheetNB; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BUTTONS=["Option 0","Option 1","Option 2","Delete","Cancel"];var DESTRUCTIVE_INDEX=3;var CANCEL_INDEX=4;var ActionSheetNB=function(_Component){_inherits(ActionSheetNB,_Component);function ActionSheetNB(props){_classCallCheck(this,ActionSheetNB);var _this=_possibleConstructorReturn(this,(ActionSheetNB.__proto__||Object.getPrototypeOf(ActionSheetNB)).call(this,props));_this.state={};return _this;}_createClass(ActionSheetNB,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.navigate("DrawerOpen");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"ios-menu"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"ActionSheet")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{onPress:function onPress(){return __WEBPACK_IMPORTED_MODULE_1_native_base__["ActionSheet"].show({options:BUTTONS,cancelButtonIndex:CANCEL_INDEX,destructiveButtonIndex:DESTRUCTIVE_INDEX,title:"Options"},function(buttonIndex){_this2.setState({clicked:BUTTONS[buttonIndex]});});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Actionsheet"))));}}]);return ActionSheetNB;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header1=function(_Component){_inherits(Header1,_Component);function Header1(){_classCallCheck(this,Header1);return _possibleConstructorReturn(this,(Header1.__proto__||Object.getPrototypeOf(Header1)).apply(this,arguments));}_createClass(Header1,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Header")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Back"))));}}]);return Header1;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Header1);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header2=function(_Component){_inherits(Header2,_Component);function Header2(){_classCallCheck(this,Header2);return _possibleConstructorReturn(this,(Header2.__proto__||Object.getPrototypeOf(Header2)).apply(this,arguments));}_createClass(Header2,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Header")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"menu"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Header with Icon Buttons")));}}]);return Header2;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Header2);

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header3=function(_Component){_inherits(Header3,_Component);function Header3(){_classCallCheck(this,Header3);return _possibleConstructorReturn(this,(Header3.__proto__||Object.getPrototypeOf(Header3)).apply(this,arguments));}_createClass(Header3,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Back"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Header")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Cancel")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Header with Text Buttons")));}}]);return Header3;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Header3);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header4=function(_Component){_inherits(Header4,_Component);function Header4(){_classCallCheck(this,Header4);return _possibleConstructorReturn(this,(Header4.__proto__||Object.getPrototypeOf(Header4)).apply(this,arguments));}_createClass(Header4,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Header")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Cancel")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Header with Icon Button & Text Buttons")));}}]);return Header4;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Header4);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header5=function(_Component){_inherits(Header5,_Component);function Header5(){_classCallCheck(this,Header5);return _possibleConstructorReturn(this,(Header5.__proto__||Object.getPrototypeOf(Header5)).apply(this,arguments));}_createClass(Header5,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Back"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Header")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Cancel")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Header with Icon & Text Button")));}}]);return Header5;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Header5);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header6=function(_Component){_inherits(Header6,_Component);function Header6(){_classCallCheck(this,Header6);return _possibleConstructorReturn(this,(Header6.__proto__||Object.getPrototypeOf(Header6)).apply(this,arguments));}_createClass(Header6,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Header")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"search"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"heart"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"more"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Header with multiple Icon Buttons")));}}]);return Header6;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Header6);

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header7=function(_Component){_inherits(Header7,_Component);function Header7(){_classCallCheck(this,Header7);return _possibleConstructorReturn(this,(Header7.__proto__||Object.getPrototypeOf(Header7)).apply(this,arguments));}_createClass(Header7,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],{hasSubtitle:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Title"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Subtitle"],null,"Subtitle")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Header with Title & Subtitle")));}}]);return Header7;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Header7);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header8=function(_Component){_inherits(Header8,_Component);function Header8(){_classCallCheck(this,Header8);return _possibleConstructorReturn(this,(Header8.__proto__||Object.getPrototypeOf(Header8)).apply(this,arguments));}_createClass(Header8,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],{style:{backgroundColor:"#dc4239"},androidStatusBarColor:"#dc2015",iosBarStyle:"light-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back",style:{color:"#FFF"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],{style:{color:"#FFF"}},"Custom Header")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Header with Custom background color")));}}]);return Header8;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Header8);

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(61);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Basic=function(_Component){_inherits(Basic,_Component);function Basic(props){_classCallCheck(this,Basic);var _this=_possibleConstructorReturn(this,(Basic.__proto__||Object.getPrototypeOf(Basic)).call(this,props));_this.state={tab1:false,tab2:false,tab3:true,tab4:false};return _this;}_createClass(Basic,[{key:"toggleTab1",value:function toggleTab1(){this.setState({tab1:true,tab2:false,tab3:false,tab4:false});}},{key:"toggleTab2",value:function toggleTab2(){this.setState({tab1:false,tab2:true,tab3:false,tab4:false});}},{key:"toggleTab3",value:function toggleTab3(){this.setState({tab1:false,tab2:false,tab3:true,tab4:false});}},{key:"toggleTab4",value:function toggleTab4(){this.setState({tab1:false,tab2:false,tab3:false,tab4:true});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Footer")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Footer"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["FooterTab"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.tab1,onPress:function onPress(){return _this2.toggleTab1();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Apps")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.tab2,onPress:function onPress(){return _this2.toggleTab2();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Camera")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.tab3,onPress:function onPress(){return _this2.toggleTab3();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Navigate")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.tab4,onPress:function onPress(){return _this2.toggleTab4();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Contact")))));}}]);return Basic;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Basic);

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(61);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IconFooter=function(_Component){_inherits(IconFooter,_Component);function IconFooter(props){_classCallCheck(this,IconFooter);var _this=_possibleConstructorReturn(this,(IconFooter.__proto__||Object.getPrototypeOf(IconFooter)).call(this,props));_this.state={tab1:false,tab2:false,tab3:true,tab4:false};return _this;}_createClass(IconFooter,[{key:"toggleTab1",value:function toggleTab1(){this.setState({tab1:true,tab2:false,tab3:false,tab4:false});}},{key:"toggleTab2",value:function toggleTab2(){this.setState({tab1:false,tab2:true,tab3:false,tab4:false});}},{key:"toggleTab3",value:function toggleTab3(){this.setState({tab1:false,tab2:false,tab3:true,tab4:false});}},{key:"toggleTab4",value:function toggleTab4(){this.setState({tab1:false,tab2:false,tab3:false,tab4:true});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Footer")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Footer"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["FooterTab"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.tab1,onPress:function onPress(){return _this2.toggleTab1();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:this.state.tab1,name:"apps"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.tab2,onPress:function onPress(){return _this2.toggleTab2();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:this.state.tab2,name:"camera"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.tab3,onPress:function onPress(){return _this2.toggleTab3();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:this.state.tab3,name:"compass"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.tab4,onPress:function onPress(){return _this2.toggleTab4();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:this.state.tab4,name:"contact"})))));}}]);return IconFooter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IconFooter);

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(61);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IconText=function(_Component){_inherits(IconText,_Component);function IconText(props){_classCallCheck(this,IconText);var _this=_possibleConstructorReturn(this,(IconText.__proto__||Object.getPrototypeOf(IconText)).call(this,props));_this.state={tab1:false,tab2:false,tab3:true,tab4:false};return _this;}_createClass(IconText,[{key:"toggleTab1",value:function toggleTab1(){this.setState({tab1:true,tab2:false,tab3:false,tab4:false});}},{key:"toggleTab2",value:function toggleTab2(){this.setState({tab1:false,tab2:true,tab3:false,tab4:false});}},{key:"toggleTab3",value:function toggleTab3(){this.setState({tab1:false,tab2:false,tab3:true,tab4:false});}},{key:"toggleTab4",value:function toggleTab4(){this.setState({tab1:false,tab2:false,tab3:false,tab4:true});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Footer")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Footer"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["FooterTab"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.tab1,onPress:function onPress(){return _this2.toggleTab1();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:this.state.tab1,name:"apps"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Apps")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.tab2,onPress:function onPress(){return _this2.toggleTab2();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:this.state.tab2,name:"camera"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Camera")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.tab3,onPress:function onPress(){return _this2.toggleTab3();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:this.state.tab3,name:"compass"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Compass")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.tab4,onPress:function onPress(){return _this2.toggleTab4();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:this.state.tab4,name:"contact"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Contact")))));}}]);return IconText;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IconText);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(61);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BadgeFooter=function(_Component){_inherits(BadgeFooter,_Component);function BadgeFooter(props){_classCallCheck(this,BadgeFooter);var _this=_possibleConstructorReturn(this,(BadgeFooter.__proto__||Object.getPrototypeOf(BadgeFooter)).call(this,props));_this.state={tab1:false,tab2:false,tab3:true,tab4:false};return _this;}_createClass(BadgeFooter,[{key:"toggleTab1",value:function toggleTab1(){this.setState({tab1:true,tab2:false,tab3:false,tab4:false});}},{key:"toggleTab2",value:function toggleTab2(){this.setState({tab1:false,tab2:true,tab3:false,tab4:false});}},{key:"toggleTab3",value:function toggleTab3(){this.setState({tab1:false,tab2:false,tab3:true,tab4:false});}},{key:"toggleTab4",value:function toggleTab4(){this.setState({tab1:false,tab2:false,tab3:false,tab4:true});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Footer")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Footer"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["FooterTab"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.tab1,onPress:function onPress(){return _this2.toggleTab1();},vertical:true,badge:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Badge"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:this.state.tab1,name:"apps"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Apps")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.tab2,onPress:function onPress(){return _this2.toggleTab2();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:this.state.tab2,name:"camera"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Camera")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.tab3,onPress:function onPress(){return _this2.toggleTab3();},vertical:true,badge:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Badge"],{style:{backgroundColor:"green"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"51")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:this.state.tab3,name:"compass"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Compass")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.tab4,onPress:function onPress(){return _this2.toggleTab4();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:this.state.tab4,name:"contact"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Contact")))));}}]);return BadgeFooter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BadgeFooter);

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Default=function(_Component){_inherits(Default,_Component);function Default(){_classCallCheck(this,Default);return _possibleConstructorReturn(this,(Default.__proto__||Object.getPrototypeOf(Default)).apply(this,arguments));}_createClass(Default,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Default")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true,style:{backgroundColor:"#fff",padding:20}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{light:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Light")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{info:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Info")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{primary:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Primary")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{success:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Success")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{warning:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Warning")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{danger:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Danger")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{dark:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Dark"))));}}]);return Default;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Default);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Outline=function(_Component){_inherits(Outline,_Component);function Outline(){_classCallCheck(this,Outline);return _possibleConstructorReturn(this,(Outline.__proto__||Object.getPrototypeOf(Outline)).apply(this,arguments));}_createClass(Outline,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Outline")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true,style:{backgroundColor:"#fff",padding:20}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{bordered:true,light:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Light")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{bordered:true,info:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Info")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{bordered:true,primary:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Primary")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{bordered:true,success:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Success")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{bordered:true,warning:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Warning")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{bordered:true,danger:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Danger")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{bordered:true,dark:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Dark"))));}}]);return Outline;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Outline);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Rounded=function(_Component){_inherits(Rounded,_Component);function Rounded(){_classCallCheck(this,Rounded);return _possibleConstructorReturn(this,(Rounded.__proto__||Object.getPrototypeOf(Rounded)).apply(this,arguments));}_createClass(Rounded,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Rounded")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true,style:{backgroundColor:"#FFF",padding:20}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{rounded:true,light:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Light")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{rounded:true,info:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Info")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{rounded:true,primary:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Primary")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{rounded:true,success:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Success")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{rounded:true,warning:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Warning")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{rounded:true,danger:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Danger")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{rounded:true,dark:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Dark"))));}}]);return Rounded;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Rounded);

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Block=function(_Component){_inherits(Block,_Component);function Block(){_classCallCheck(this,Block);return _possibleConstructorReturn(this,(Block.__proto__||Object.getPrototypeOf(Block)).apply(this,arguments));}_createClass(Block,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Block")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true,style:{backgroundColor:"#FFF",padding:20}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{block:true,light:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Light")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{block:true,info:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Info")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{block:true,primary:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Primary")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{block:true,success:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Success")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{block:true,warning:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Warning")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{block:true,danger:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Danger")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{block:true,dark:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Dark"))));}}]);return Block;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Block);

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Full=function(_Component){_inherits(Full,_Component);function Full(){_classCallCheck(this,Full);return _possibleConstructorReturn(this,(Full.__proto__||Object.getPrototypeOf(Full)).apply(this,arguments));}_createClass(Full,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Full")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{style:{backgroundColor:"#fff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{full:true,light:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mt15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Light")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{full:true,info:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mt15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Info")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{full:true,primary:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mt15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Primary")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{full:true,success:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mt15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Success")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{full:true,warning:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mt15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Warning")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{full:true,danger:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mt15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Danger")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{full:true,dark:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mt15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Dark"))));}}]);return Full;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Full);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Custom=function(_Component){_inherits(Custom,_Component);function Custom(){_classCallCheck(this,Custom);return _possibleConstructorReturn(this,(Custom.__proto__||Object.getPrototypeOf(Custom)).apply(this,arguments));}_createClass(Custom,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Custom Size")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true,style:{padding:20}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{small:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Default Small")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{success:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Success Default")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{large:true,dark:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Dark Large"))));}}]);return Custom;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Custom);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Transparent=function(_Component){_inherits(Transparent,_Component);function Transparent(){_classCallCheck(this,Transparent);return _possibleConstructorReturn(this,(Transparent.__proto__||Object.getPrototypeOf(Transparent)).apply(this,arguments));}_createClass(Transparent,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Transparent")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true,style:{backgroundColor:"#fff",padding:20}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,light:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Light")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,info:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Info")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Primary")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,success:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Success")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,warning:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Warning")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,danger:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Danger")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,dark:true,style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Dark"))));}}]);return Transparent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Transparent);

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IconBtn=function(_Component){_inherits(IconBtn,_Component);function IconBtn(){_classCallCheck(this,IconBtn);return _possibleConstructorReturn(this,(IconBtn.__proto__||Object.getPrototypeOf(IconBtn)).apply(this,arguments));}_createClass(IconBtn,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Icon Buttons")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],{padder:true,style:{padding:20}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{flexDirection:"row",justifyContent:"space-between"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{iconLeft:true,light:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"arrow-back"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Back")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{light:true,iconRight:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Next"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"arrow-forward"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{light:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"arrow-down"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{light:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"arrow-up"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{flexDirection:"row"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{iconLeft:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"home"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Home")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{iconLeft:true,bordered:true,style:{marginBottom:20,marginLeft:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"briefcase"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Work"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{flexDirection:"row"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{iconLeft:true,success:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"people"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"People")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{iconLeft:true,success:true,bordered:true,style:{marginBottom:20,marginLeft:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"paw"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Animals"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{flexDirection:"row"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{iconLeft:true,danger:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"close"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Trash")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{danger:true,bordered:true,style:{marginBottom:20,marginLeft:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"trash"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{danger:true,transparent:true,style:{marginBottom:20,marginLeft:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"trash"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{flexDirection:"row"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{iconLeft:true,warning:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"warning"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Dont")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{warning:true,bordered:true,style:{marginBottom:20,marginLeft:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"warning"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{flexDirection:"row"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{iconLeft:true,info:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"alert"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Help")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{info:true,style:{marginBottom:20,marginLeft:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"alert"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{flexDirection:"row"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{iconLeft:true,dark:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"cog"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Settings")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{dark:true,transparent:true,style:{marginBottom:20,marginLeft:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"cog"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{iconLeft:true,transparent:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"beer"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Pub"))));}}]);return IconBtn;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IconBtn);

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Disabled=function(_Component){_inherits(Disabled,_Component);function Disabled(){_classCallCheck(this,Disabled);return _possibleConstructorReturn(this,(Disabled.__proto__||Object.getPrototypeOf(Disabled)).apply(this,arguments));}_createClass(Disabled,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Disabled")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{paddingHorizontal:20,paddingTop:20}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{disabled:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Default")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{disabled:true,bordered:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Outline")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{disabled:true,rounded:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Rounded")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{disabled:true,large:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Custom")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{disabled:true,iconRight:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Icon Button"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"home"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{disabled:true,block:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Block"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{disabled:true,full:true,style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Full"))));}}]);return Disabled;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Disabled);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Basic=function(_Component){_inherits(Basic,_Component);function Basic(){_classCallCheck(this,Basic);return _possibleConstructorReturn(this,(Basic.__proto__||Object.getPrototypeOf(Basic)).apply(this,arguments));}_createClass(Basic,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Basic Card")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Card"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"This is just a basic card with some text to boot."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Like it? Keep Scrolling..."))))));}}]);return Basic;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Basic);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var logo=__webpack_require__(254);var cardImage=__webpack_require__(138);var NHCardImage=function(_Component){_inherits(NHCardImage,_Component);function NHCardImage(){_classCallCheck(this,NHCardImage);return _possibleConstructorReturn(this,(NHCardImage.__proto__||Object.getPrototypeOf(NHCardImage)).apply(this,arguments));}_createClass(NHCardImage,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Card Image")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Card"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Thumbnail"],{source:logo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"NativeBase"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],{note:true},"GeekyAnts")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["CardItem"],{cardBody:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["Image"],{style:{resizeMode:"cover",width:null,height:200,flex:1},source:cardImage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["CardItem"],{style:{paddingVertical:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{iconLeft:true,transparent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"thumbs-up"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"4923 Likes"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{iconLeft:true,transparent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"chatbubbles"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"89 Comments"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"11h ago"))))));}}]);return NHCardImage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHCardImage);

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var deviceWidth=__WEBPACK_IMPORTED_MODULE_1_react_native__["Dimensions"].get("window").width;var logo=__webpack_require__(254);var cardImage=__webpack_require__(138);var NHCardShowcase=function(_Component){_inherits(NHCardShowcase,_Component);function NHCardShowcase(){_classCallCheck(this,NHCardShowcase);return _possibleConstructorReturn(this,(NHCardShowcase.__proto__||Object.getPrototypeOf(NHCardShowcase)).apply(this,arguments));}_createClass(NHCardShowcase,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Card Showcase")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Card"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].mb},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["CardItem"],{bordered:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Thumbnail"],{source:logo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"NativeBase"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],{note:true},"April 15, 2016")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["Image"],{style:{alignSelf:"center",height:150,resizeMode:"cover",width:deviceWidth/1.18,marginVertical:5},source:cardImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"NativeBase is a free and source framework that enable developers to build high-quality mobile apps using React Native with a fusion of ES6. NativeBase builds a layer on top of React Native that provides you with basic set of components for mobile application development."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["CardItem"],{style:{paddingVertical:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"logo-github"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"4,923 stars")))))));}}]);return NHCardShowcase;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHCardShowcase);

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NHCardList=function(_Component){_inherits(NHCardList,_Component);function NHCardList(){_classCallCheck(this,NHCardList);return _possibleConstructorReturn(this,(NHCardList.__proto__||Object.getPrototypeOf(NHCardList)).apply(this,arguments));}_createClass(NHCardList,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Card List")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Card"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],{header:true,bordered:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Social Applications")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"logo-googleplus",style:{color:"#DD5044"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Google Plus"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"logo-facebook",style:{color:"#3B579D"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"facebook"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"logo-twitter",style:{color:"#55ACEE"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Twitter"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"logo-reddit",style:{color:"#FF4500"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Reddit"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"logo-linkedin",style:{color:"#007BB6"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"LinkedIn"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"logo-youtube",style:{color:"#D62727"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"YouTube"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward"}))))));}}]);return NHCardList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHCardList);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NHCardHeaderAndFooter=function(_Component){_inherits(NHCardHeaderAndFooter,_Component);function NHCardHeaderAndFooter(){_classCallCheck(this,NHCardHeaderAndFooter);return _possibleConstructorReturn(this,(NHCardHeaderAndFooter.__proto__||Object.getPrototypeOf(NHCardHeaderAndFooter)).apply(this,arguments));}_createClass(NHCardHeaderAndFooter,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Header & Footer Card")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Card"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].mb},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],{header:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"NativeBase")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"NativeBase is a free and open source framework that enable developers to build high-quality mobile apps using React Native with a fusion of ES6."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"NativeBase builds a layer on top of React Native that provides you with basic set of components for mobile application development."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Get on the mobile fast track with NativeBase, the fastest-growing platform and tool set for mobile platform development."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],{footer:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"GeekyAnts")))));}}]);return NHCardHeaderAndFooter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHCardHeaderAndFooter);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(134);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BasicFab=function(_Component){_inherits(BasicFab,_Component);function BasicFab(props){_classCallCheck(this,BasicFab);var _this=_possibleConstructorReturn(this,(BasicFab.__proto__||Object.getPrototypeOf(BasicFab)).call(this,props));_this.state={active:false};return _this;}_createClass(BasicFab,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Single FAB")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{flex:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Fab"],{active:this.state.active,direction:"up",containerStyle:{},style:{backgroundColor:"#5067FF"},position:"bottomRight",onPress:function onPress(){return _this2.setState({active:!_this2.state.active});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"md-share"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#34A34F"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"logo-whatsapp"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#3B5998"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"logo-facebook"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{disabled:true,style:{backgroundColor:"#DD5144"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"ios-mail"})))));}}]);return BasicFab;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BasicFab);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(134);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MultipleFab=function(_Component){_inherits(MultipleFab,_Component);function MultipleFab(props){_classCallCheck(this,MultipleFab);var _this=_possibleConstructorReturn(this,(MultipleFab.__proto__||Object.getPrototypeOf(MultipleFab)).call(this,props));_this.state={active:false,active1:false,active2:false,active3:false};return _this;}_createClass(MultipleFab,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Multiple FABs")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{flex:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Fab"],{active:this.state.active,direction:"up",containerStyle:{},style:{backgroundColor:"#5067FF"},position:"bottomRight",onPress:function onPress(){return _this2.setState({active:!_this2.state.active});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"md-share"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#34A34F"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"logo-whatsapp"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#3B5998"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"logo-facebook"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{disabled:true,style:{backgroundColor:"#DD5144"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"ios-mail"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Fab"],{active:this.state.active1,direction:"left",containerStyle:{},style:{backgroundColor:"#5067FF"},position:"topRight",onPress:function onPress(){return _this2.setState({active1:!_this2.state.active1});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"md-share"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#34A34F"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"logo-whatsapp"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#3B5998"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"logo-facebook"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{disabled:true,style:{backgroundColor:"#DD5144"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"ios-mail"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Fab"],{active:this.state.active2,direction:"down",containerStyle:{},style:{backgroundColor:"#5067FF"},position:"topLeft",onPress:function onPress(){return _this2.setState({active2:!_this2.state.active2});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"md-share"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#34A34F"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"logo-whatsapp"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#3B5998"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"logo-facebook"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{disabled:true,style:{backgroundColor:"#DD5144"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"ios-mail"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Fab"],{active:this.state.active3,direction:"right",containerStyle:{},style:{backgroundColor:"#5067FF"},position:"bottomLeft",onPress:function onPress(){return _this2.setState({active3:!_this2.state.active3});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"md-share"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#34A34F"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"logo-whatsapp"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#3B5998"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"logo-facebook"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{disabled:true,style:{backgroundColor:"#DD5144"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"ios-mail"})))));}}]);return MultipleFab;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MultipleFab);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FixedLabel=function(_Component){_inherits(FixedLabel,_Component);function FixedLabel(){_classCallCheck(this,FixedLabel);return _possibleConstructorReturn(this,(FixedLabel.__proto__||Object.getPrototypeOf(FixedLabel)).apply(this,arguments));}_createClass(FixedLabel,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Fixed Label")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Form"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],{fixedLabel:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Label"],null,"Username"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],{fixedLabel:true,last:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Label"],null,"Password"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{block:true,style:{margin:15,marginTop:50}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Sign In"))));}}]);return FixedLabel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FixedLabel);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InlineLabel=function(_Component){_inherits(InlineLabel,_Component);function InlineLabel(){_classCallCheck(this,InlineLabel);return _possibleConstructorReturn(this,(InlineLabel.__proto__||Object.getPrototypeOf(InlineLabel)).apply(this,arguments));}_createClass(InlineLabel,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Inline Label")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Form"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],{inlineLabel:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Label"],null,"Username"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],{inlineLabel:true,last:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Label"],null,"Password"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{block:true,style:{margin:15,marginTop:50}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Sign In"))));}}]);return InlineLabel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (InlineLabel);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FloatingLabel=function(_Component){_inherits(FloatingLabel,_Component);function FloatingLabel(){_classCallCheck(this,FloatingLabel);return _possibleConstructorReturn(this,(FloatingLabel.__proto__||Object.getPrototypeOf(FloatingLabel)).apply(this,arguments));}_createClass(FloatingLabel,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Floating Label")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Form"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],{floatingLabel:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Label"],null,"Username"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],{floatingLabel:true,last:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Label"],null,"Password"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{block:true,style:{margin:15,marginTop:50}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Sign In"))));}}]);return FloatingLabel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FloatingLabel);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Placeholder=function(_Component){_inherits(Placeholder,_Component);function Placeholder(){_classCallCheck(this,Placeholder);return _possibleConstructorReturn(this,(Placeholder.__proto__||Object.getPrototypeOf(Placeholder)).apply(this,arguments));}_createClass(Placeholder,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Placeholder Label")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Form"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],{placeholder:"Username"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],{last:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],{placeholder:"Password"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{block:true,style:{margin:15,marginTop:50}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Sign In"))));}}]);return Placeholder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Placeholder);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Stacked=function(_Component){_inherits(Stacked,_Component);function Stacked(){_classCallCheck(this,Stacked);return _possibleConstructorReturn(this,(Stacked.__proto__||Object.getPrototypeOf(Stacked)).apply(this,arguments));}_createClass(Stacked,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Stacked Label")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Form"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],{stackedLabel:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Label"],null,"Username"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],{stackedLabel:true,last:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Label"],null,"Password"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{block:true,style:{margin:15,marginTop:50}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Sign In"))));}}]);return Stacked;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Stacked);

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Regular=function(_Component){_inherits(Regular,_Component);function Regular(){_classCallCheck(this,Regular);return _possibleConstructorReturn(this,(Regular.__proto__||Object.getPrototypeOf(Regular)).apply(this,arguments));}_createClass(Regular,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Regular")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],{regular:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],{placeholder:"Regular Textbox"}))));}}]);return Regular;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Regular);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Underline=function(_Component){_inherits(Underline,_Component);function Underline(){_classCallCheck(this,Underline);return _possibleConstructorReturn(this,(Underline.__proto__||Object.getPrototypeOf(Underline)).apply(this,arguments));}_createClass(Underline,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Underline")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Form"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],{placeholder:"Underline Textbox"})))));}}]);return Underline;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Underline);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Rounded=function(_Component){_inherits(Rounded,_Component);function Rounded(){_classCallCheck(this,Rounded);return _possibleConstructorReturn(this,(Rounded.__proto__||Object.getPrototypeOf(Rounded)).apply(this,arguments));}_createClass(Rounded,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Rounded")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],{rounded:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],{placeholder:"Rounded Textbox"}))));}}]);return Rounded;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Rounded);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IconInput=function(_Component){_inherits(IconInput,_Component);function IconInput(){_classCallCheck(this,IconInput);return _possibleConstructorReturn(this,(IconInput.__proto__||Object.getPrototypeOf(IconInput)).apply(this,arguments));}_createClass(IconInput,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Icon Input")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"home"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],{placeholder:"Icon Textbox"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],{placeholder:"Icon Alignment in Textbox"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:"swap"}))));}}]);return IconInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IconInput);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Success=function(_Component){_inherits(Success,_Component);function Success(){_classCallCheck(this,Success);return _possibleConstructorReturn(this,(Success.__proto__||Object.getPrototypeOf(Success)).apply(this,arguments));}_createClass(Success,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Success Input")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],{success:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],{placeholder:"Textbox with Success Input"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["IconNB"],{name:"ios-checkmark-circle"}))));}}]);return Success;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Success);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Error=function(_Component){_inherits(Error,_Component);function Error(){_classCallCheck(this,Error);return _possibleConstructorReturn(this,(Error.__proto__||Object.getPrototypeOf(Error)).apply(this,arguments));}_createClass(Error,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Error Input")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],{error:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],{placeholder:"Textbox with Error Input"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["IconNB"],{name:"ios-close-circle"}))));}}]);return Error;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Error);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Disabled=function(_Component){_inherits(Disabled,_Component);function Disabled(){_classCallCheck(this,Disabled);return _possibleConstructorReturn(this,(Disabled.__proto__||Object.getPrototypeOf(Disabled)).apply(this,arguments));}_createClass(Disabled,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Disabled Input")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Item"],{disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Input"],{disabled:true,placeholder:"Disabled Textbox"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["IconNB"],{name:"ios-information-circle"}))));}}]);return Disabled;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Disabled);

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RowNB=function(_Component){_inherits(RowNB,_Component);function RowNB(){_classCallCheck(this,RowNB);return _possibleConstructorReturn(this,(RowNB.__proto__||Object.getPrototypeOf(RowNB)).apply(this,arguments));}_createClass(RowNB,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Row Grid")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Grid"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Row"],{style:{backgroundColor:"#635DB7"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Row"],{style:{backgroundColor:"#00CE9F"}})));}}]);return RowNB;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RowNB);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ColumnNB=function(_Component){_inherits(ColumnNB,_Component);function ColumnNB(){_classCallCheck(this,ColumnNB);return _possibleConstructorReturn(this,(ColumnNB.__proto__||Object.getPrototypeOf(ColumnNB)).apply(this,arguments));}_createClass(ColumnNB,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Column Grid")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Grid"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Col"],{style:{backgroundColor:"#635DB7"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Col"],{style:{backgroundColor:"#00CE9F"}})));}}]);return ColumnNB;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ColumnNB);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NestedGrid=function(_Component){_inherits(NestedGrid,_Component);function NestedGrid(){_classCallCheck(this,NestedGrid);return _possibleConstructorReturn(this,(NestedGrid.__proto__||Object.getPrototypeOf(NestedGrid)).apply(this,arguments));}_createClass(NestedGrid,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Nested Grid")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Grid"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Col"],{style:{backgroundColor:"#DD9E2C"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Col"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Row"],{style:{backgroundColor:"#00CE9F"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Row"],{style:{backgroundColor:"#635DB7"}}))));}}]);return NestedGrid;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NestedGrid);

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CustomRow=function(_Component){_inherits(CustomRow,_Component);function CustomRow(){_classCallCheck(this,CustomRow);return _possibleConstructorReturn(this,(CustomRow.__proto__||Object.getPrototypeOf(CustomRow)).apply(this,arguments));}_createClass(CustomRow,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Custom Row")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Grid"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Row"],{size:1,style:{backgroundColor:"#635DB7"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Row"],{size:2,style:{backgroundColor:"#00CE9F"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Row"],{size:4,style:{backgroundColor:"#DD9E2C"}})));}}]);return CustomRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CustomRow);

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CustomCol=function(_Component){_inherits(CustomCol,_Component);function CustomCol(){_classCallCheck(this,CustomCol);return _possibleConstructorReturn(this,(CustomCol.__proto__||Object.getPrototypeOf(CustomCol)).apply(this,arguments));}_createClass(CustomCol,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Custom Col")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Grid"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Col"],{size:1,style:{backgroundColor:"#00CE9F"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Col"],{size:2,style:{backgroundColor:"#635DB7"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_native_easy_grid__["Col"],{size:4,style:{backgroundColor:"#DD9E2C"}})));}}]);return CustomCol;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CustomCol);

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(135);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BasicListSwipe=function(_Component){_inherits(BasicListSwipe,_Component);function BasicListSwipe(){_classCallCheck(this,BasicListSwipe);return _possibleConstructorReturn(this,(BasicListSwipe.__proto__||Object.getPrototypeOf(BasicListSwipe)).apply(this,arguments));}_createClass(BasicListSwipe,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:'arrow-back'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],{style:{flex:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,'Single SwipeRow')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{scrollEnabled:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["SwipeRow"],{leftOpenValue:75,rightOpenValue:-75,left:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{success:true,onPress:function onPress(){return alert('Add');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:'add',style:{color:'#FFF'}})),right:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{danger:true,onPress:function onPress(){return alert('Trash');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{active:true,name:'trash'})),body:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["View"],{style:{paddingLeft:20}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,'Some Body Text'))})));}}]);return BasicListSwipe;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BasicListSwipe);

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(135);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datas=["Simon Mignolet","Nathaniel Clyne","Dejan Lovren","Mama Sakho","Alberto Moreno","Emre Can","Joe Allen","Phil Coutinho"];var MultiListSwipe=function(_Component){_inherits(MultiListSwipe,_Component);function MultiListSwipe(props){_classCallCheck(this,MultiListSwipe);var _this=_possibleConstructorReturn(this,(MultiListSwipe.__proto__||Object.getPrototypeOf(MultiListSwipe)).call(this,props));_this.ds=new __WEBPACK_IMPORTED_MODULE_1_react_native__["ListView"].DataSource({rowHasChanged:function rowHasChanged(r1,r2){return r1!==r2;}});_this.state={basic:true,listViewData:datas};return _this;}_createClass(MultiListSwipe,[{key:"deleteRow",value:function deleteRow(secId,rowId,rowMap){rowMap[""+secId+rowId].props.closeRow();var newData=[].concat(_toConsumableArray(this.state.listViewData));newData.splice(rowId,1);this.setState({listViewData:newData});}},{key:"render",value:function render(){var _this2=this;var ds=new __WEBPACK_IMPORTED_MODULE_1_react_native__["ListView"].DataSource({rowHasChanged:function rowHasChanged(r1,r2){return r1!==r2;}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],{style:{flex:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Multiple List Swipe")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["List"],{dataSource:this.ds.cloneWithRows(this.state.listViewData),renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["ListItem"],{style:{paddingLeft:20}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,data));},renderLeftHiddenRow:function renderLeftHiddenRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{full:true,onPress:function onPress(){return alert(data);},style:{backgroundColor:"#CCC",flex:1,alignItems:"center",justifyContent:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"information-circle"}));},renderRightHiddenRow:function renderRightHiddenRow(data,secId,rowId,rowMap){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{full:true,danger:true,onPress:function onPress(_){return _this2.deleteRow(secId,rowId,rowMap);},style:{flex:1,alignItems:"center",justifyContent:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"trash"}));},leftOpenValue:75,rightOpenValue:-75})));}}]);return MultiListSwipe;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MultiListSwipe);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var datas=["Simon Mignolet","Nathaniel Clyne","Dejan Lovren","Mama Sakho","Alberto Moreno","Emre Can","Joe Allen","Phil Coutinho"];var NHBasicList=function(_Component){_inherits(NHBasicList,_Component);function NHBasicList(){_classCallCheck(this,NHBasicList);return _possibleConstructorReturn(this,(NHBasicList.__proto__||Object.getPrototypeOf(NHBasicList)).apply(this,arguments));}_createClass(NHBasicList,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Basic List")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,data),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-forward"})));}})));}}]);return NHBasicList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHBasicList);

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NHListDivider=function(_Component){_inherits(NHListDivider,_Component);function NHListDivider(){_classCallCheck(this,NHListDivider);return _possibleConstructorReturn(this,(NHListDivider.__proto__||Object.getPrototypeOf(NHListDivider)).apply(this,arguments));}_createClass(NHListDivider,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"List Divider")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{itemDivider:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"A")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Aaron Bennet")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Ali Connors")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Allen Lee")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Andy Hertzfeld")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{last:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Angana Ghosh")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{itemDivider:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Bradley Horowitz")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Brian Swetland")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{last:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Brittany Kelso")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{itemDivider:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Caroline Aaron")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Cendre Urbino")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{last:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Claire Barclay"))));}}]);return NHListDivider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHListDivider);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NHListSeparator=function(_Component){_inherits(NHListSeparator,_Component);function NHListSeparator(){_classCallCheck(this,NHListSeparator);return _possibleConstructorReturn(this,(NHListSeparator.__proto__||Object.getPrototypeOf(NHListSeparator)).apply(this,arguments));}_createClass(NHListSeparator,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:'arrow-back'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,'List Separator')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Separator"],{bordered:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,'MIDFIELD')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,'Caroline Aaron')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,'Urbino Cendre')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{last:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,'Lee Allen'))));}}]);return NHListSeparator;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHListSeparator);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NHListHeader=function(_Component){_inherits(NHListHeader,_Component);function NHListHeader(){_classCallCheck(this,NHListHeader);return _possibleConstructorReturn(this,(NHListHeader.__proto__||Object.getPrototypeOf(NHListHeader)).apply(this,arguments));}_createClass(NHListHeader,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"List Header")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{itemHeader:true,first:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"COMEDY")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Hangover")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Horrible Bosses")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Wedding Crashers")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{last:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Cop Out")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{itemHeader:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"HORROR")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"The Evil Dead")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Residential Evil")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{last:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Conjuring")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{itemHeader:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"ACTION")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Terminator Genesis")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Fast And Furious")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{last:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Top Gun"))));}}]);return NHListHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHListHeader);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Item=__WEBPACK_IMPORTED_MODULE_2_native_base__["Picker"].Item;var NHListIcon=function(_Component){_inherits(NHListIcon,_Component);function NHListIcon(props){_classCallCheck(this,NHListIcon);var _this=_possibleConstructorReturn(this,(NHListIcon.__proto__||Object.getPrototypeOf(NHListIcon)).call(this,props));_this.state={selectedItem:undefined,selected1:"key1",results:{items:[]}};return _this;}_createClass(NHListIcon,[{key:"onValueChange",value:function onValueChange(value){this.setState({selected1:value});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"List Icon")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Separator"],{bordered:true,noTopBorder:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["ListItem"],{icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#FF9501"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"plane"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Airplane Mode")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Switch"],{value:false,onTintColor:"#50B948"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["ListItem"],{icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#007AFF"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"wifi"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Wi-Fi")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"GeekyAnts"),__WEBPACK_IMPORTED_MODULE_1_react_native__["Platform"].OS==="ios"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"arrow-forward"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["ListItem"],{icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#007AFF"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"bluetooth"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Bluetooth")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"On"),__WEBPACK_IMPORTED_MODULE_1_react_native__["Platform"].OS==="ios"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"arrow-forward"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["ListItem"],{icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#4CDA64"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"phone-portrait"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Mobile Data")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Radio"],{selected:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["ListItem"],{icon:true,last:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#4CDA64"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"link"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Personal Hotspot")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Off"),__WEBPACK_IMPORTED_MODULE_1_react_native__["Platform"].OS==="ios"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"arrow-forward"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Separator"],{bordered:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["ListItem"],{icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#FD3C2D"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"notifications"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Notifications")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_1_react_native__["Platform"].OS==="ios"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"arrow-forward"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["ListItem"],{icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#8F8E93"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"switch"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Control Center")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_1_react_native__["Platform"].OS==="ios"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"arrow-forward"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["ListItem"],{icon:true,last:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#5855D6"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"moon"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Do Not Disturb")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Yes"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Separator"],{bordered:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["ListItem"],{icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#4CDA64"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-dropdown"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Pick SIM")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Picker"],{note:true,iosHeader:"Select one",mode:"dropdown",selectedValue:this.state.selected1,onValueChange:this.onValueChange.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"TATA",value:"key0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"AIRTEL",value:"key1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["ListItem"],{icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#8F8E93"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"cog"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Software Update")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Badge"],{style:{backgroundColor:"#FD3C2D"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["ListItem"],{last:true,icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{style:{backgroundColor:"#007AFF"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"hand"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Privacy")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_1_react_native__["Platform"].OS==="ios"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{active:true,name:"arrow-forward"})))));}}]);return NHListIcon;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHListIcon);

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var pratik=__webpack_require__(741);var sanket=__webpack_require__(742);var megha=__webpack_require__(743);var atul=__webpack_require__(744);var saurabh=__webpack_require__(745);var varun=__webpack_require__(746);var datas=[{img:pratik,text:"Kumar Pratik",note:"Its time to build a difference . .",time:"3:43 pm"},{img:sanket,text:"Kumar Sanket",note:"One needs courage to be happy and smiling all time . . ",time:"1:12 pm"},{img:megha,text:"Megha",note:"Live a life style that matchs your vision",time:"10:03 am"},{img:atul,text:"Atul Ranjan",note:"Failure is temporary, giving up makes it permanent",time:"5:47 am"},{img:saurabh,text:"Saurabh Sahu",note:"The biggest risk is a missed opportunity !!",time:"11:11 pm"},{img:varun,text:"Varun Sahu",note:"Wish I had a Time machine . .",time:"8:54 pm"}];var NHListAvatar=function(_Component){_inherits(NHListAvatar,_Component);function NHListAvatar(){_classCallCheck(this,NHListAvatar);return _possibleConstructorReturn(this,(NHListAvatar.__proto__||Object.getPrototypeOf(NHListAvatar)).apply(this,arguments));}_createClass(NHListAvatar,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"List Avatar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{avatar:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Thumbnail"],{small:true,source:data.img})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,data.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,note:true},data.note)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{note:true},data.time)));}})));}}]);return NHListAvatar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHListAvatar);

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pratik.afc24956.png";

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sanket.2ea71896.png";

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/megha.a72acb16.png";

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/atul.5c706cd1.png";

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/saurabh.8a70256f.png";

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/varun.0319a3dc.png";

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var sankhadeep=__webpack_require__(748);var supriya=__webpack_require__(749);var himanshu=__webpack_require__(750);var shweta=__webpack_require__(751);var shruti=__webpack_require__(752);var shivraj=__webpack_require__(753);var datas=[{img:sankhadeep,text:"Sankhadeep",note:"Its time to build a difference . ."},{img:supriya,text:"Supriya",note:"One needs courage to be happy and smiling all time . . "},{img:himanshu,text:"Himanshu",note:"Live a life style that matchs your vision"},{img:shweta,text:"Shweta",note:"Failure is temporary, giving up makes it permanent"},{img:shruti,text:"Shruti",note:"The biggest risk is a missed opportunity !!"},{img:shivraj,text:"Shivraj",note:"Time changes everything . ."}];var NHListThumbnail=function(_Component){_inherits(NHListThumbnail,_Component);function NHListThumbnail(){_classCallCheck(this,NHListThumbnail);return _possibleConstructorReturn(this,(NHListThumbnail.__proto__||Object.getPrototypeOf(NHListThumbnail)).apply(this,arguments));}_createClass(NHListThumbnail,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"List Thumbnail")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["List"],{dataArray:datas,renderRow:function renderRow(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ListItem"],{thumbnail:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Thumbnail"],{square:true,size:55,source:data.img})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,data.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],{numberOfLines:1,note:true},data.note)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"View"))));}})));}}]);return NHListThumbnail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NHListThumbnail);

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sankhadeep.fcd0c6c4.png";

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/supriya.5a341458.png";

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/himanshu.679fe301.png";

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shweta.62f8459f.png";

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shruti.fa497278.png";

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shivraj.de268288.jpg";

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Item=__WEBPACK_IMPORTED_MODULE_2_native_base__["Picker"].Item;var RegularPicker=function(_Component){_inherits(RegularPicker,_Component);function RegularPicker(props){_classCallCheck(this,RegularPicker);var _this=_possibleConstructorReturn(this,(RegularPicker.__proto__||Object.getPrototypeOf(RegularPicker)).call(this,props));_this.state={selected1:"key1"};return _this;}_createClass(RegularPicker,[{key:"onValueChange",value:function onValueChange(value){this.setState({selected1:value});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],{style:{flex:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Regular")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Form"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Picker"],{iosHeader:"Select one",mode:"dropdown",style:{width:__WEBPACK_IMPORTED_MODULE_1_react_native__["Platform"].OS==="ios"?undefined:200},selectedValue:this.state.selected1,onValueChange:this.onValueChange.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Wallet",value:"key0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"ATM Card",value:"key1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Debit Card",value:"key2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Credit Card",value:"key3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Net Banking",value:"key4"})))));}}]);return RegularPicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RegularPicker);

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Item=__WEBPACK_IMPORTED_MODULE_2_native_base__["Picker"].Item;var RegularPicker=function(_Component){_inherits(RegularPicker,_Component);function RegularPicker(props){_classCallCheck(this,RegularPicker);var _this=_possibleConstructorReturn(this,(RegularPicker.__proto__||Object.getPrototypeOf(RegularPicker)).call(this,props));_this.state={selected2:undefined};return _this;}_createClass(RegularPicker,[{key:"onValueChange2",value:function onValueChange2(value){this.setState({selected2:value});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],{style:{flex:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Placeholder Picker")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Form"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Picker"],{mode:"dropdown",style:{width:__WEBPACK_IMPORTED_MODULE_1_react_native__["Platform"].OS==="ios"?undefined:120},placeholder:"Select One",selectedValue:this.state.selected2,onValueChange:this.onValueChange2.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Wallet",value:"key0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"ATM Card",value:"key1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Debit Card",value:"key2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Credit Card",value:"key3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Net Banking",value:"key4"})))));}}]);return RegularPicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RegularPicker);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Item=__WEBPACK_IMPORTED_MODULE_2_native_base__["Picker"].Item;var RegularPicker=function(_Component){_inherits(RegularPicker,_Component);function RegularPicker(props){_classCallCheck(this,RegularPicker);var _this=_possibleConstructorReturn(this,(RegularPicker.__proto__||Object.getPrototypeOf(RegularPicker)).call(this,props));_this.state={selected2:undefined};return _this;}_createClass(RegularPicker,[{key:"onValueChange2",value:function onValueChange2(value){this.setState({selected2:value});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],{style:{flex:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Placeholder picker w/o Note")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Form"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Picker"],{mode:"dropdown",style:{width:__WEBPACK_IMPORTED_MODULE_1_react_native__["Platform"].OS==="ios"?undefined:120},placeholder:"Select One",note:false,selectedValue:this.state.selected2,onValueChange:this.onValueChange2.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Wallet",value:"key0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"ATM Card",value:"key1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Debit Card",value:"key2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Credit Card",value:"key3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Net Banking",value:"key4"})))));}}]);return RegularPicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RegularPicker);

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Item=__WEBPACK_IMPORTED_MODULE_2_native_base__["Picker"].Item;var RegularPicker=function(_Component){_inherits(RegularPicker,_Component);function RegularPicker(props){_classCallCheck(this,RegularPicker);var _this=_possibleConstructorReturn(this,(RegularPicker.__proto__||Object.getPrototypeOf(RegularPicker)).call(this,props));_this.state={selected3:"key3"};return _this;}_createClass(RegularPicker,[{key:"onValueChange3",value:function onValueChange3(value){this.setState({selected3:value});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],{style:{flex:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Custom back button")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Form"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Picker"],{mode:"dropdown",headerBackButtonText:"Baaack!",style:{width:__WEBPACK_IMPORTED_MODULE_1_react_native__["Platform"].OS==="ios"?undefined:120},selectedValue:this.state.selected3,onValueChange:this.onValueChange3.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Wallet",value:"key0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"ATM Card",value:"key1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Debit Card",value:"key2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Credit Card",value:"key3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Net Banking",value:"key4"})))));}}]);return RegularPicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RegularPicker);

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Item=__WEBPACK_IMPORTED_MODULE_2_native_base__["Picker"].Item;var RegularPicker=function(_Component){_inherits(RegularPicker,_Component);function RegularPicker(props){_classCallCheck(this,RegularPicker);var _this=_possibleConstructorReturn(this,(RegularPicker.__proto__||Object.getPrototypeOf(RegularPicker)).call(this,props));_this.state={selected4:"key4"};return _this;}_createClass(RegularPicker,[{key:"onValueChange4",value:function onValueChange4(value){this.setState({selected4:value});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],{style:{flex:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Custom Title")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Form"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Picker"],{mode:"dropdown",iosHeader:"Your Header",style:{width:__WEBPACK_IMPORTED_MODULE_1_react_native__["Platform"].OS==="ios"?undefined:120},selectedValue:this.state.selected4,onValueChange:this.onValueChange4.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Wallet",value:"key0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"ATM Card",value:"key1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Debit Card",value:"key2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Credit Card",value:"key3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Net Banking",value:"key4"})))));}}]);return RegularPicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RegularPicker);

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Item=__WEBPACK_IMPORTED_MODULE_2_native_base__["Picker"].Item;var RegularPicker=function(_Component){_inherits(RegularPicker,_Component);function RegularPicker(props){_classCallCheck(this,RegularPicker);var _this=_possibleConstructorReturn(this,(RegularPicker.__proto__||Object.getPrototypeOf(RegularPicker)).call(this,props));_this.state={selected5:"key2"};return _this;}_createClass(RegularPicker,[{key:"onValueChange5",value:function onValueChange5(value){this.setState({selected5:value});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],{style:{flex:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Custom Header Style")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Form"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Picker"],{mode:"dropdown",headerStyle:{backgroundColor:"#b95dd3"},headerBackButtonTextStyle:{color:"#fff"},headerTitleStyle:{color:"#fff"},style:{width:__WEBPACK_IMPORTED_MODULE_1_react_native__["Platform"].OS==="ios"?undefined:120},selectedValue:this.state.selected5,onValueChange:this.onValueChange5.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Wallet",value:"key0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"ATM Card",value:"key1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Debit Card",value:"key2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Credit Card",value:"key3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Net Banking",value:"key4"})))));}}]);return RegularPicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RegularPicker);

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Item=__WEBPACK_IMPORTED_MODULE_2_native_base__["Picker"].Item;var RegularPicker=function(_Component){_inherits(RegularPicker,_Component);function RegularPicker(props){_classCallCheck(this,RegularPicker);var _this=_possibleConstructorReturn(this,(RegularPicker.__proto__||Object.getPrototypeOf(RegularPicker)).call(this,props));_this.state={selected1:"key1"};return _this;}_createClass(RegularPicker,[{key:"onValueChange",value:function onValueChange(value){this.setState({selected1:value});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],{style:{flex:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Custom Header")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Content"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Form"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Picker"],{renderHeader:function renderHeader(backAction){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],{style:{backgroundColor:"#f44242"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:backAction},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back",style:{color:"#fff"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],{style:{flex:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],{style:{color:"#fff"}},"Your Header")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null));},mode:"dropdown",style:{width:__WEBPACK_IMPORTED_MODULE_1_react_native__["Platform"].OS==="ios"?undefined:200},selectedValue:this.state.selected1,onValueChange:this.onValueChange.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Wallet",value:"key0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"ATM Card",value:"key1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Debit Card",value:"key2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Credit Card",value:"key3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{label:"Net Banking",value:"key4"})))));}}]);return RegularPicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RegularPicker);

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tabOne__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabTwo__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tabThree__ = __webpack_require__(142);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BasicTab=function(_Component){_inherits(BasicTab,_Component);function BasicTab(){_classCallCheck(this,BasicTab);return _possibleConstructorReturn(this,(BasicTab.__proto__||Object.getPrototypeOf(BasicTab)).apply(this,arguments));}_createClass(BasicTab,[{key:'render',// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],{hasTabs:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:'arrow-back'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,' Basic Tabs')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Tabs"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Tab"],{heading:'Tab1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__tabOne__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Tab"],{heading:'Tab2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__tabTwo__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Tab"],{heading:'Tab3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__tabThree__["a" /* default */],null))));}}]);return BasicTab;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BasicTab);

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tabOne__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabTwo__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tabThree__ = __webpack_require__(142);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConfigTab=function(_Component){_inherits(ConfigTab,_Component);function ConfigTab(){_classCallCheck(this,ConfigTab);return _possibleConstructorReturn(this,(ConfigTab.__proto__||Object.getPrototypeOf(ConfigTab)).apply(this,arguments));}_createClass(ConfigTab,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],{hasTabs:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],{style:{flex:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null," Advanced Tabs")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Tabs"],{style:{elevation:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Tab"],{heading:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["TabHeading"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"camera"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Camera"))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__tabOne__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Tab"],{heading:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["TabHeading"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"No Icon"))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__tabTwo__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Tab"],{heading:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["TabHeading"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"apps"}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__tabThree__["a" /* default */],null))));}}]);return ConfigTab;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ConfigTab);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tabOne__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabTwo__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tabThree__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tabFour__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tabFive__ = __webpack_require__(765);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BasicTab=function(_Component){_inherits(BasicTab,_Component);function BasicTab(){_classCallCheck(this,BasicTab);return _possibleConstructorReturn(this,(BasicTab.__proto__||Object.getPrototypeOf(BasicTab)).apply(this,arguments));}_createClass(BasicTab,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],{hasTabs:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null," Scrollable Tabs")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Tabs"],{renderTabBar:function renderTabBar(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["ScrollableTab"],null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Tab"],{heading:"Tab1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__tabOne__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Tab"],{heading:"Tab2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__tabTwo__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Tab"],{heading:"Tab3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__tabThree__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Tab"],{heading:"Tab4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__tabFour__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Tab"],{heading:"Tab5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__tabFive__["a" /* default */],null))));}}]);return BasicTab;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BasicTab);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabFour; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(50);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TabFour=function(_Component){_inherits(TabFour,_Component);function TabFour(){_classCallCheck(this,TabFour);return _possibleConstructorReturn(this,(TabFour.__proto__||Object.getPrototypeOf(TabFour)).apply(this,arguments));}_createClass(TabFour,[{key:"render",// eslint-disable-line
value:function render(){// eslint-disable-line
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true,style:{marginTop:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Card"],{style:{flex:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Customize and build beautiful apps with complex interfaces using NativeBase as the building block.")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Card"],{style:{flex:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"NativeBase lets you experience the awesomeness of React Native without the pain.")))));}}]);return TabFour;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabFour; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(50);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TabFour=function(_Component){_inherits(TabFour,_Component);function TabFour(){_classCallCheck(this,TabFour);return _possibleConstructorReturn(this,(TabFour.__proto__||Object.getPrototypeOf(TabFour)).apply(this,arguments));}_createClass(TabFour,[{key:"render",// eslint-disable-line
value:function render(){// eslint-disable-line
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true,style:{marginTop:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Card"],{style:{flex:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"NativeBase's stack of components is built using native UI components so there are no compromises with the UX.")))));}}]);return TabFour;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(139);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SegmentNB=function(_Component){_inherits(SegmentNB,_Component);function SegmentNB(props){_classCallCheck(this,SegmentNB);var _this=_possibleConstructorReturn(this,(SegmentNB.__proto__||Object.getPrototypeOf(SegmentNB)).call(this,props));_this.state={seg:2};return _this;}_createClass(SegmentNB,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],{hasTabs:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Segment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{first:true,active:this.state.seg===1?true:false,onPress:function onPress(){return _this2.setState({seg:1});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Puppies")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{last:true,active:this.state.seg===2?true:false,onPress:function onPress(){return _this2.setState({seg:2});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Cubs")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"search"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},this.state.seg===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Puppies Selected"),this.state.seg===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Cubs Selected")));}}]);return SegmentNB;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SegmentNB);

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionSheetNB; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BUTTONS=["Option 0","Option 1","Option 2","Delete","Cancel"];var DESTRUCTIVE_INDEX=3;var CANCEL_INDEX=4;var ActionSheetNB=function(_Component){_inherits(ActionSheetNB,_Component);function ActionSheetNB(props){_classCallCheck(this,ActionSheetNB);var _this=_possibleConstructorReturn(this,(ActionSheetNB.__proto__||Object.getPrototypeOf(ActionSheetNB)).call(this,props));_this.state={};return _this;}_createClass(ActionSheetNB,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"ActionSheet")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{onPress:function onPress(){return __WEBPACK_IMPORTED_MODULE_1_native_base__["ActionSheet"].show({options:BUTTONS,cancelButtonIndex:CANCEL_INDEX,destructiveButtonIndex:DESTRUCTIVE_INDEX,title:"Options"},function(buttonIndex){_this2.setState({clicked:BUTTONS[buttonIndex]});});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Actionsheet"))));}}]);return ActionSheetNB;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionSheetNB; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BUTTONS=[{text:"Option 0",icon:"american-football",iconColor:"#2c8ef4"},{text:"Option 1",icon:"analytics",iconColor:"#f42ced"},{text:"Option 2",icon:"aperture",iconColor:"#ea943b"},{text:"Delete",icon:"trash",iconColor:"#fa213b"},{text:"Cancel",icon:"close",iconColor:"#25de5b"}];var DESTRUCTIVE_INDEX=3;var CANCEL_INDEX=4;var ActionSheetNB=function(_Component){_inherits(ActionSheetNB,_Component);function ActionSheetNB(props){_classCallCheck(this,ActionSheetNB);var _this=_possibleConstructorReturn(this,(ActionSheetNB.__proto__||Object.getPrototypeOf(ActionSheetNB)).call(this,props));_this.state={};return _this;}_createClass(ActionSheetNB,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Icon ActionSheet")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{onPress:function onPress(){return __WEBPACK_IMPORTED_MODULE_1_native_base__["ActionSheet"].show({options:BUTTONS,cancelButtonIndex:CANCEL_INDEX,destructiveButtonIndex:DESTRUCTIVE_INDEX,title:"Options"},function(buttonIndex){_this2.setState({clicked:BUTTONS[buttonIndex]});});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Actionsheet"))));}}]);return ActionSheetNB;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(139);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SegmentNB=function(_Component){_inherits(SegmentNB,_Component);function SegmentNB(props){_classCallCheck(this,SegmentNB);var _this=_possibleConstructorReturn(this,(SegmentNB.__proto__||Object.getPrototypeOf(SegmentNB)).call(this,props));_this.state={seg:2};return _this;}_createClass(SegmentNB,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Header"],{hasTabs:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Title"],null,"Segments")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Right"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{transparent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Icon"],{name:"search"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Segment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{first:true,active:this.state.seg===1?true:false,onPress:function onPress(){return _this2.setState({seg:1});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Puppies")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{active:this.state.seg===2?true:false,onPress:function onPress(){return _this2.setState({seg:2});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Kittens")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Button"],{last:true,active:this.state.seg===3?true:false,onPress:function onPress(){return _this2.setState({seg:3});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Cubs"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Content"],{padder:true},this.state.seg===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Puppies Selected"),this.state.seg===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Kittens Selected"),this.state.seg===3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_native_base__["Text"],null,"Cubs Selected")));}}]);return SegmentNB;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SegmentNB);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(133);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var cardOne=__webpack_require__(136);var cardTwo=__webpack_require__(137);var cardThree=__webpack_require__(255);var cardFour=__webpack_require__(256);var cards=[{text:"Card One",name:"One",image:cardOne},{text:"Card Two",name:"Two",image:cardTwo},{text:"Card Three",name:"Three",image:cardThree},{text:"Card Four",name:"Four",image:cardFour}];var SimpleDeck=function(_Component){_inherits(SimpleDeck,_Component);function SimpleDeck(){_classCallCheck(this,SimpleDeck);return _possibleConstructorReturn(this,(SimpleDeck.__proto__||Object.getPrototypeOf(SimpleDeck)).apply(this,arguments));}_createClass(SimpleDeck,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Simple Deck Swiper")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{flex:1,padding:12}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["DeckSwiper"],{dataSource:cards,looping:false,renderEmpty:function renderEmpty(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Over"));},renderItem:function renderItem(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Card"],{style:{elevation:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Thumbnail"],{source:item.image}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,item.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],{note:true},"NativeBase")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["CardItem"],{cardBody:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["Image"],{style:{resizeMode:"cover",width:null,flex:1,height:300},source:item.image})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"ios-heart",style:{color:"#ED4A6A"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,item.name)));}})));}}]);return SimpleDeck;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SimpleDeck);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_native_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_native_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(133);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var cardOne=__webpack_require__(136);var cardTwo=__webpack_require__(137);var cardThree=__webpack_require__(255);var cardFour=__webpack_require__(256);var cards=[{text:"Card One",name:"One",image:cardOne},{text:"Card Two",name:"Two",image:cardTwo},{text:"Card Three",name:"Three",image:cardThree},{text:"Card Four",name:"Four",image:cardFour}];var AdvancedDeck=function(_Component){_inherits(AdvancedDeck,_Component);function AdvancedDeck(){_classCallCheck(this,AdvancedDeck);return _possibleConstructorReturn(this,(AdvancedDeck.__proto__||Object.getPrototypeOf(AdvancedDeck)).apply(this,arguments));}_createClass(AdvancedDeck,[{key:"render",// eslint-disable-line
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Container"],{style:__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Header"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{transparent:true,onPress:function onPress(){return _this2.props.navigation.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Title"],null,"Advanced Deck Swiper")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Right"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{flex:1,padding:12}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["DeckSwiper"],{ref:function ref(mr){return _this2._deckSwiper=mr;},dataSource:cards,looping:false,renderEmpty:function renderEmpty(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{alignSelf:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Over"));},renderItem:function renderItem(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Card"],{style:{elevation:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Left"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Thumbnail"],{source:item.image}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Body"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,item.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],{note:true},"NativeBase")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["CardItem"],{cardBody:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["Image"],{style:{resizeMode:"cover",width:null,flex:1,height:300},source:item.image})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["CardItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["IconNB"],{name:"ios-heart",style:{color:"#ED4A6A"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,item.name)));}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_native__["View"],{style:{flexDirection:"row",flex:1,position:"absolute",bottom:50,left:0,right:0,justifyContent:'space-between',padding:15}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{iconLeft:true,onPress:function onPress(){return _this2._deckSwiper._root.swipeLeft();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-back"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Swipe Left")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Button"],{iconRight:true,onPress:function onPress(){return _this2._deckSwiper._root.swipeRight();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Text"],null,"Swipe Right"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_native_base__["Icon"],{name:"arrow-forward"}))));}}]);return AdvancedDeck;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AdvancedDeck);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.17a4a7cd.js